const GroupedMenuData = [
{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "502957",
              "name": "Andhra Gunpowder",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "andhra-gunpowder-malleshwaram-malleshwaram",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "bs9qgsy25pn07pzn6xx1",
              "locality": "Shivananda Circle",
              "areaName": "Seshadripuram",
              "costForTwo": "35000",
              "costForTwoMessage": "₹350 for two",
              "cuisines": [
                "Andhra",
                "Biryani"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "502957",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4900
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4900,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (4.1 kms) | Additional delivery fee will apply"
              },
              "parentId": "10496",
              "avgRatingString": "4.4",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "502957",
                "deliveryTime": 29,
                "minDeliveryTime": 29,
                "maxDeliveryTime": 29,
                "lastMileTravel": 4.2,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_IT_IS_LONG_DISTANCE",
                "zoneId": 49,
                "slaString": "29 MINS",
                "lastMileTravelString": "4.1 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 01:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹449",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹449 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "andhra-gunpowder-malleshwaram-malleshwaram",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "No :- 5 Old No :- 28, 2nd Floor ,  Hare Krishna Road , Opp To Desai Hospital , Shivananda Circle ,Kumara Park East, Seshadripuram Bengaluru, Karnataka :- 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Andhra,Biryani"
                }
              ],
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹449",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹449 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 314,
                  "maxValue": 449,
                  "priority": 1,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 490,
                  "maxValue": 700,
                  "priority": 2,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 20
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 20% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 20% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/502957"
              },
              "expectationNotifiers": [
                {
                  "text": "Far (4.1 kms) | Additional delivery fee will apply",
                  "icon": {
                    "imageId": "v1648208530/surgecreatives/info"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>Far (4.1 kms)</b> | Additional delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.98681,77.579384"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "01a93cc6-a605-41a8-a48c-dd3369d9569c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹449",
                      "offerType": "offers",
                      "restId": "502957",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "ff0137ce-e763-4b61-8c63-5e66f66fed38"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹700",
                      "offerType": "offers",
                      "restId": "502957",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "502957",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "502957",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "502957",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93655509",
                              "name": "Butter Paneer Biryani Family Pack (serves 3-4)",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Paneer Tikka cooked in a silky makhani gravy layered on Dum biryani rice. Served with raita and salan.",
                              "imageId": "xdn3ovilifxvzoyexlaw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 89900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395429",
                              "name": "Hyderabadi Chicken Dum Biryani Family Pack (serves 3-4)",
                              "category": "Biryani Family Pack (Save upto Rs 150/-)",
                              "description": "Serves 4 | Slow-cooked long grained rice layered in chicken masala, caramelised onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                              "imageId": "jkfyqgzhvmddguwgsaee",
                              "inStock": 1,
                              "price": 98900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 4"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395352",
                              "name": "Paneer Makhni Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Paneer Tikka cooked in silky makhani gravy tops a Veg Dum biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                              "imageId": "kbox9yaeq8gwcabncefl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731942",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808788",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93230244",
                              "name": "Hyderabadi Paneer Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Paneer cooked in a rich masala and added to a veg Dum Biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                              "imageId": "tpw4aky5jxzxj7qfklg5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52732004",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808743",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395404",
                              "name": "Egg Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Masala eggs top a bowl of dum rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1185, Protein(g): 33, Carbohydrate(g): 115, Fat (g):66\"",
                              "imageId": "dnuw70nclzxujjcjfunl",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731979",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808734",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395353",
                              "name": "Hyderabadi Chicken Dum Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Slow-cooked long grained rice layered in chicken masala, caramelized onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                              "imageId": "janhgjevj4xnyyg5htnv",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731944",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808715",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101219474",
                              "name": "Boneless Kebab Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Deep fried spicy chicken kebab tops a bowl of Dum Hyderabadi biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1106, Protein(g): 35, Carbohydrate(g): 113, Fat (g):57\"",
                              "imageId": "70ab23fb7177ba9abe0fe8fe2feaa5c6",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395402",
                              "name": "Chicken Tikka Masala Biryani",
                              "category": "Hyderabadi Biryanis",
                              "description": "Serves 1 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                              "imageId": "unbgenhukd68zfybeial",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731977",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808746",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395362",
                              "name": "Andhra Style Chicken Biryani",
                              "category": "Andhra Biryani",
                              "description": "Serves 1 | Marinated chicken cooked with onion, chilli, and garlic added to a Dum with rice. Served with raita and salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1640, Protein(g): 87, Carbohydrate(g): 128, Fat (g):86\"",
                              "imageId": "wt4yfrfw2ugwv0pmf6ar",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731956",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53854910",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395379",
                              "name": "Paneer Makhni Bagara Biryani",
                              "category": "Bagara Biryani",
                              "description": "Serves 1 | Paneer tikka cooked in a silky makhani gravy, tops a bowl of Bagara rice. Served with raita and  salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1077, Protein(g): 28, Carbohydrate(g): 112, Fat (g):58\"",
                              "imageId": "tp48oduaveu90hfwyvyk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731968",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808814",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395405",
                              "name": "Egg Bagara Biryani",
                              "category": "Bagara Biryani",
                              "description": "Serves 1 | Masala eggs tops a  bowl of special Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1075, Protein(g): 34, Carbohydrate(g): 112, Fat (g):55\"",
                              "imageId": "kuzhvpwr5okwqx99venb",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731980",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808769",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395380",
                              "name": "Boneless Chicken Bagara Biryani",
                              "category": "Bagara Biryani",
                              "description": "Serves 1 | Cashew based masala chicken (boneless) tops bagara rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1037, Protein(g): 45, Carbohydrate(g): 110, Fat (g):47\"",
                              "imageId": "wrdzdkvthzjjnyz6i2ov",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731971",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808709",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395407",
                              "name": "Chicken Tikka Masala Bagara Biryani",
                              "category": "Bagara Biryani",
                              "description": "Serves 1 | Smoky Chicken Tikka cooked in a tomato masala tops a bowl of Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1005, Protein(g): 45, Carbohydrate(g): 110, Fat (g):43\"",
                              "imageId": "jmumtongbbuhw4uwvb7d",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731981",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53808754",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714189",
                              "name": "Bhai Chicken Biryani",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style biryani cooked in Dum style with Long Grain Basmati rice and flavor-packed Chicken served with Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1688, Protein(g): 90, Carbohydrate(g): 127, Fat (g):91\"",
                              "imageId": "yghmyl3sno4inq6r02ne",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223416",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714190",
                              "name": "Bhai Biryani - Khushka with Egg",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style Kushka (Non-Veg) cooked in Dum style with Long Grain Basmati rice and served with Raita.",
                              "imageId": "a7nrsjbl9dcexqfqxztz",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223417",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714193",
                              "name": "Bhai Chicken Biryani and Chicken Kebab Combo",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Bhai Chicken Biryani(Serves 1) + Fried Chicken Kebab.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1988, Protein(g): 102, Carbohydrate(g): 135, Fat (g):116\"",
                              "imageId": "coorechharrm7ix46doy",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395377",
                              "name": "Fried Chicken Kebab(Boneless)",
                              "category": "Starters",
                              "description": "Serves 1 | Marinated chicken is coated in spicy masala and fried to perfection.\n\n\"Allergens : -\nNutritional information : Kcal(g):647, Protein(g): 25, Carbohydrate(g): 17, Fat (g):53\"",
                              "imageId": "ytcezodswsdrejtgicwj",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "95 ratings",
                                  "ratingCountV2": "95"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125755796",
                              "name": "Andhra Pepper Chicken",
                              "category": "Starters",
                              "description": "Serves 1 | Tender marinated chicken cooked in aromatic dark pepper masala, served with a coriander garnish.\n\n\"Allergens : -\nNutritional information : Kcal(g):307, Protein(g): 42, Carbohydrate(g): 10, Fat (g):11\"",
                              "imageId": "maw5aalu74mqjkrdc51x",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395387",
                              "name": "Ghee Gulab Jamun (2 Pcs)",
                              "category": "Desserts.",
                              "description": "Serves 1 | Khoya rich dumplings are deep fried and then given a soaking in sugar syrup.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):426, Protein(g): 4, Carbohydrate(g): 41, Fat (g):27\"",
                              "imageId": "i6wqvnqigzfkkbgxkvxp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395390",
                              "name": "Sweet Lassi",
                              "category": "Beverages",
                              "description": "Serves 1 | Classic Lassi - Chilled.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):223, Protein(g): 24, Carbohydrate(g): 22, Fat (g):5\"",
                              "imageId": "gplhj8dthmmsvb4pybe9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Biryani Family Pack (Save upto Rs 150/-)",
                      "categories": [
                        {
                          "title": "Hyderabadi Biryani Family Pack",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93655509",
                                  "name": "Butter Paneer Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Paneer Tikka cooked in a silky makhani gravy layered on Dum biryani rice. Served with raita and salan.",
                                  "imageId": "xdn3ovilifxvzoyexlaw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395429",
                                  "name": "Hyderabadi Chicken Dum Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Slow-cooked long grained rice layered in chicken masala, caramelised onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                                  "imageId": "jkfyqgzhvmddguwgsaee",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395432",
                                  "name": "Chicken Tikka Masala Biryani Family Pack (serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 4 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                                  "imageId": "foos9ap0iuljzjtbxku4",
                                  "inStock": 1,
                                  "price": 98000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93230245",
                                  "name": "Guntur Chicken Biryani Family Pack (Serves 3-4)",
                                  "category": "Biryani Family Pack (Save upto Rs 150/-)",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Dum Hyderabadi biryani rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information ( For serve 1) : Kcal(g):1000, Protein(g): 29, Carbohydrate(g): 108, Fat (g):50\"",
                                  "imageId": "gwrm4csbtdc9p3ttbay6",
                                  "inStock": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Super Saver Meals",
                      "categories": [
                        {
                          "title": "Super Saver Meals for 2",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228876",
                                  "name": "Andhra Chicken Sambar Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Andhra Chicken Curry (380g) + Sambar (380g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Fried Chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):3126, Protein(g): 111, Carbohydrate(g): 365, Fat (g):135\"",
                                  "imageId": "gu0hkottesgizfzwthxl",
                                  "inStock": 1,
                                  "price": 52900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97228880",
                                  "name": "Guntur Chicken Meal (For 2)",
                                  "category": "Super Saver Meals",
                                  "description": "Serves 1 | A perfect combo for 2 people includes plain Rice (2) + Guntur Chicken (180g) + Vegetable Sambar (380g) + Rasam (180g) + Curd (180g) served with Ghee, Gunpowder, Papad, and Fried Chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):2133, Protein(g): 54, Carbohydrate(g): 354, Fat (g):56\"",
                                  "imageId": "ew0qb3xztppzuuuarhs8",
                                  "inStock": 1,
                                  "price": 54900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Hyderabadi Biryanis",
                      "categories": [
                        {
                          "title": "Veg Hyderabadi Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395351",
                                  "name": "Veg Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Layers of aromatic Rice and Vegetables cooked with our biryani masala in a dum. Served with Mirchi ka Salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1087, Protein(g): 29, Carbohydrate(g): 133, Fat (g):49\"",
                                  "imageId": "3f4a79ca260ae1572fec5891b1397e3d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "127223419",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395352",
                                  "name": "Paneer Makhni Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Paneer Tikka cooked in silky makhani gravy tops a Veg Dum biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                                  "imageId": "kbox9yaeq8gwcabncefl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731942",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808788",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "93230244",
                                  "name": "Hyderabadi Paneer Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Paneer cooked in a rich masala and added to a veg Dum Biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1054, Protein(g): 27, Carbohydrate(g): 114, Fat (g):54\"",
                                  "imageId": "tpw4aky5jxzxj7qfklg5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732004",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808743",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Hyderabadi Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395404",
                                  "name": "Egg Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Masala eggs top a bowl of dum rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1185, Protein(g): 33, Carbohydrate(g): 115, Fat (g):66\"",
                                  "imageId": "dnuw70nclzxujjcjfunl",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731979",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808734",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395353",
                                  "name": "Hyderabadi Chicken Dum Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Slow-cooked long grained rice layered in chicken masala, caramelized onions is finished in charcoal dum. Served with Mirchi ka salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1713, Protein(g): 88, Carbohydrate(g): 113, Fat (g):101\"",
                                  "imageId": "janhgjevj4xnyyg5htnv",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731944",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808715",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "78 ratings",
                                      "ratingCountV2": "78"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101219474",
                                  "name": "Boneless Kebab Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Deep fried spicy chicken kebab tops a bowl of Dum Hyderabadi biryani rice. Served with Salan and Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1106, Protein(g): 35, Carbohydrate(g): 113, Fat (g):57\"",
                                  "imageId": "70ab23fb7177ba9abe0fe8fe2feaa5c6",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395350",
                                  "name": "Guntur Chicken Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Dum Hyderabadi biryani rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1000, Protein(g): 29, Carbohydrate(g): 108, Fat (g):50\"",
                                  "imageId": "gwtusq0zmzwzbqzfwfhc",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731938",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808720",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395402",
                                  "name": "Chicken Tikka Masala Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Smoky boneless chicken tikka finished in a tomato masala and topped on dum biryani rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1115, Protein(g): 44, Carbohydrate(g): 113, Fat (g):54\"",
                                  "imageId": "unbgenhukd68zfybeial",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731977",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808746",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.5",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395383",
                                  "name": "Butter Chicken Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Smoky Chicken Tikka, cooked in a silky makhani gravy, added to dum biryani rice. Served with raita, salan and salad.",
                                  "imageId": "ivysnthcsu2limy4ycxd",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128249060",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128249061",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395354",
                                  "name": "Chicken Keema Biryani",
                                  "category": "Hyderabadi Biryanis",
                                  "description": "Serves 1 | Chicken keema in a creamy Hyderabadi masala layered on Dum biryani rice. Served with Mirchi ka Salan and creamy raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1154, Protein(g): 41, Carbohydrate(g): 114, Fat (g):59\"",
                                  "imageId": "lcrdgsbrsfbzslqd3i9i",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731946",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808680",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Andhra Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395362",
                              "name": "Andhra Style Chicken Biryani",
                              "category": "Andhra Biryani",
                              "description": "Serves 1 | Marinated chicken cooked with onion, chilli, and garlic added to a Dum with rice. Served with raita and salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1640, Protein(g): 87, Carbohydrate(g): 128, Fat (g):86\"",
                              "imageId": "wt4yfrfw2ugwv0pmf6ar",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "52731956",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "53854910",
                                  "groupName": "Sides",
                                  "choices": [
                                    {
                                      "id": "43298966",
                                      "name": "Extra Raita",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Bagara Biryani",
                      "categories": [
                        {
                          "title": "Veg Bagara Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395379",
                                  "name": "Paneer Makhni Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Paneer tikka cooked in a silky makhani gravy, tops a bowl of Bagara rice. Served with raita and  salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1077, Protein(g): 28, Carbohydrate(g): 112, Fat (g):58\"",
                                  "imageId": "tp48oduaveu90hfwyvyk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731968",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808814",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Bagara Biryani",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395405",
                                  "name": "Egg Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Masala eggs tops a  bowl of special Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1075, Protein(g): 34, Carbohydrate(g): 112, Fat (g):55\"",
                                  "imageId": "kuzhvpwr5okwqx99venb",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731980",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808769",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395380",
                                  "name": "Boneless Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Cashew based masala chicken (boneless) tops bagara rice.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1037, Protein(g): 45, Carbohydrate(g): 110, Fat (g):47\"",
                                  "imageId": "wrdzdkvthzjjnyz6i2ov",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731971",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808709",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395407",
                                  "name": "Chicken Tikka Masala Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Smoky Chicken Tikka cooked in a tomato masala tops a bowl of Bagara rice. Served with Mirchi ka Salan and mixed raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1005, Protein(g): 45, Carbohydrate(g): 110, Fat (g):43\"",
                                  "imageId": "jmumtongbbuhw4uwvb7d",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52731981",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808754",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91767129",
                                  "name": "Guntur Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Sizzling hot Guntur Chicken tops a bowl of Bagara Rice. Served with Raita and Salan.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):890, Protein(g): 30, Carbohydrate(g): 106, Fat (g):39\"",
                                  "imageId": "eofffmwpytxf1kjlqwgu",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "52732008",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "53808777",
                                      "groupName": "Sides",
                                      "choices": [
                                        {
                                          "id": "43298966",
                                          "name": "Extra Raita",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127261513",
                                  "name": "Pepper Chicken Bagara Biryani",
                                  "category": "Bagara Biryani",
                                  "description": "Serves 1 | Experience marinated chicken cooked in aromatic dark pepper masala served on a bowl of aromatic bagara rice.",
                                  "inStock": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "127223421",
                                      "groupName": "Biryani Add Ons",
                                      "choices": [
                                        {
                                          "id": "44096237",
                                          "name": "Chicken Kebab (Full)",
                                          "price": 24000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096238",
                                          "name": "Chicken Kebab (Half)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096241",
                                          "name": "Sweet Lassi",
                                          "price": 5900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096242",
                                          "name": "Dry Fruit Lassi",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "43298990",
                                          "name": "Fresh Curd (200 ml)",
                                          "price": 4100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44691057",
                                          "name": "Rabdi",
                                          "price": 4900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "44096240",
                                          "name": "Ghee Gulab Jamun (2pcs)",
                                          "price": 5000,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Andhra Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395419",
                              "name": "Brinjal Curry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Andhra Style Brinjal Curry, Steamed Rice, Potato Fry, Papad and Fried Chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):882, Protein(g): 15, Carbohydrate(g): 118, Fat (g):39\"",
                              "imageId": "vswzgkrxqi8rrunhfkpq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99744483",
                              "name": "Sambar Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Sambar, Steamed Rice, Potato Fry, Papad and Fried Chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):844, Protein(g): 18, Carbohydrate(g): 127, Fat (g):29\"",
                              "imageId": "h5prmmrimublerlo8g6z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115989221",
                              "name": "Curd And Poriyal Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Try our in creamy Curd and Rice paired with vegetable poriyal stir-fry. A light and refreshing all-inclusive Tamil-style meal served with avakai pickle, papad, fried crispy chilli, deep-fried crispy aloo and poriyal of the day.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):867, Protein(g): 47, Carbohydrate(g): 127, Fat (g):19\"",
                              "imageId": "71015f621fcd581b4bcc6ebd7777d419",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129820368",
                              "name": "Rasam and Poriyal Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Savour our tangy, peppery rasam mixed with white rice in a satisfying bowl served with a side of poriyal. A South Indian comfort food classic, now conveniently served together and accompanied by papad and fried chilli. Our Rasam and Poriyal Rice Bowl brings together two greats for a delightful, nostalgic meal.",
                              "imageId": "acb9ecfc24c24c935a0c512df1e496c0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395461",
                              "name": "Andhra Gun Powder Khichdi",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Freshly Ground Kandi Podi (Gunpowder) is added to our khichdi Mix. This is a fun Andhra take. Served with Ghee, Aloo Chokha, Pickle, Papad and Curd.\n\n\"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "5207769d61042eff6348c8bb3a15f20e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104608637",
                              "name": "Egg Curry Rice Bowl (Andhra Style)",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Boiled Eggs stewed in an Andhra-style onion tomato mix served with rice in an all-inclusive bowl.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1036, Protein(g): 26, Carbohydrate(g): 118, Fat (g):51\"",
                              "imageId": "rslioqyxekef1ypqo0ky",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395410",
                              "name": "Andhra Chicken Curry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Andhra Style Chicken Curry, Steamed Rice, Boiled Egg, Papad and Fried Chilli.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1236, Protein(g): 51, Carbohydrate(g): 112, Fat (g):65\"",
                              "imageId": "ylefe7hr3c2ku4hingbg",
                              "inStock": 1,
                              "price": 29800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194585",
                              "name": "Rasam Rice and Bangalore Kebab Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Experience rasam poured over rice, paired with succulent Bangalore Chicken Kebab. The meal is balanced with cool Curd and served alongside crispy papad, potato vepudu and curd chilli.",
                              "imageId": "da6d3b63a31976ded51bfffc0b26666a",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131194586",
                              "name": "Sambar Rice and Bangalore Kebab Fry Rice Bowl",
                              "category": "Andhra Bowls",
                              "description": "Serves 1 | Indulge in the wholesome goodness of sambar rice, paired with Bangalore Chicken Kebab, curd, served with crunchy papad, potato vepudu and a spicy curd chilli.",
                              "imageId": "14512fe9b4b10d8b629a1b51eefb4f44",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Basmati Bhai Biryani - Tamil Edition",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714189",
                              "name": "Bhai Chicken Biryani",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style biryani cooked in Dum style with Long Grain Basmati rice and flavor-packed Chicken served with Raita.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1688, Protein(g): 90, Carbohydrate(g): 127, Fat (g):91\"",
                              "imageId": "yghmyl3sno4inq6r02ne",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223416",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714190",
                              "name": "Bhai Biryani - Khushka with Egg",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Tamil Muslim Style Kushka (Non-Veg) cooked in Dum style with Long Grain Basmati rice and served with Raita.",
                              "imageId": "a7nrsjbl9dcexqfqxztz",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223417",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714193",
                              "name": "Bhai Chicken Biryani and Chicken Kebab Combo",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Bhai Chicken Biryani(Serves 1) + Fried Chicken Kebab.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1988, Protein(g): 102, Carbohydrate(g): 135, Fat (g):116\"",
                              "imageId": "coorechharrm7ix46doy",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114714194",
                              "name": "Bhai Biryani - Khushka with Egg and Chicken Kebab Combo",
                              "category": "Basmati Bhai Biryani - Tamil Edition",
                              "description": "Serves 1 | Bhai Biryani - Khushka (Non-Veg) (Serves 1) + Fried Chicken Kebab.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):1294, Protein(g): 41, Carbohydrate(g): 135, Fat (g):66\"",
                              "imageId": "81e581c53ad3d7c76cc97af114e116e3",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127223418",
                                  "groupName": "Biryani Add Ons",
                                  "choices": [
                                    {
                                      "id": "44096237",
                                      "name": "Chicken Kebab (Full)",
                                      "price": 24000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096238",
                                      "name": "Chicken Kebab (Half)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096241",
                                      "name": "Sweet Lassi",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096242",
                                      "name": "Dry Fruit Lassi",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "43298990",
                                      "name": "Fresh Curd (200 ml)",
                                      "price": 4100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44691057",
                                      "name": "Rabdi",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44096240",
                                      "name": "Ghee Gulab Jamun (2pcs)",
                                      "price": 5000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Starters",
                      "categories": [
                        {
                          "title": "Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395400",
                                  "name": "Paneer Pakoda",
                                  "category": "Starters",
                                  "description": "Serves 1 | Soft Dairy fresh Paneer coated in a special batter and deep fried to golden brown.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):663, Protein(g): 17, Carbohydrate(g): 22, Fat (g):57\"",
                                  "imageId": "jdpkkbqkdzzthiuuckqz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395377",
                                  "name": "Fried Chicken Kebab(Boneless)",
                                  "category": "Starters",
                                  "description": "Serves 1 | Marinated chicken is coated in spicy masala and fried to perfection.\n\n\"Allergens : -\nNutritional information : Kcal(g):647, Protein(g): 25, Carbohydrate(g): 17, Fat (g):53\"",
                                  "imageId": "ytcezodswsdrejtgicwj",
                                  "inStock": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "95 ratings",
                                      "ratingCountV2": "95"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125755796",
                                  "name": "Andhra Pepper Chicken",
                                  "category": "Starters",
                                  "description": "Serves 1 | Tender marinated chicken cooked in aromatic dark pepper masala, served with a coriander garnish.\n\n\"Allergens : -\nNutritional information : Kcal(g):307, Protein(g): 42, Carbohydrate(g): 10, Fat (g):11\"",
                                  "imageId": "maw5aalu74mqjkrdc51x",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals Add Ons",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395458",
                              "name": "Vegetable Sambar (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Lentil-based vegetables, cooked with in-house masala and tamarind(Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):349, Protein(g): 8, Carbohydrate(g): 26, Fat (g):24\"",
                              "imageId": "k05pdjuqjh4azbyy8ddk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "73 ratings",
                                  "ratingCountV2": "73"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395456",
                              "name": "Rasam (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Functional Food using tamarind juice as a base, with the addition of turmeric, tomato, chilli pepper, pepper, garlic, cumin, curry leaves, mustard, coriander, asafoetida, sea salt, and water.\n\n\"Allergens : -\nNutritional information : Kcal(g):128, Protein(g): 4, Carbohydrate(g): 15, Fat (g):6\"",
                              "imageId": "oabyrcankntimjumfksh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "148 ratings",
                                  "ratingCountV2": "148"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104608635",
                              "name": "Andhra Egg Curry (350 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Boiled eggs stewed in an Andhra-style tomato onion gravy (350 ml).\n\n\"Allergens : Egg\nNutritional information : Kcal(g):575, Protein(g): 21, Carbohydrate(g): 16, Fat (g):47\"",
                              "imageId": "cqgf6b0kr0ht5zptspgh",
                              "inStock": 1,
                              "price": 16500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395454",
                              "name": "Guntur Chicken Dry (400 gms)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Juicy chicken cooked in spicy masala (Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):143, Protein(g): 7, Carbohydrate(g): 4, Fat (g):11\"",
                              "imageId": "sgbkjpwknnnuxkcupywy",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395452",
                              "name": "Andhra Chicken Curry (400 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Marinated chicken is made with a freshly ground tamarind masala (Serves 2).\n\n\"Allergens : -\nNutritional information : Kcal(g):1128, Protein(g): 58, Carbohydrate(g): 19, Fat (g):91\"",
                              "imageId": "kmp3tquxjhq1ivyv7bss",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93770585",
                              "name": "Plain Rice (Gunpowder, Ghee, Papad & Crispy Fried Curd Chilli )",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Served with Ghee, Gunpowder, Papad & Fried Chilli (Serves 1).\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):780, Protein(g): 14, Carbohydrate(g): 133, Fat (g):21\"",
                              "imageId": "vd1qcbt7dwyettvwyymj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "190 ratings",
                                  "ratingCountV2": "190"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395460",
                              "name": "Fresh Curd (200 ml)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | Creamy fresh curd (200 Ml).\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):145, Protein(g): 20, Carbohydrate(g): 8, Fat (g):4\"",
                              "imageId": "zkaygnxsap6b9dbg01zz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395463",
                              "name": "Extra Papad",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | \"Allergens : -\nNutritional information : Kcal(g):68, Protein(g): 2, Carbohydrate(g): 6, Fat (g):4\"",
                              "imageId": "diglkpki32lznvw1vi1z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "132 ratings",
                                  "ratingCountV2": "132"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395409",
                              "name": "Gunpowder (Kandi Podi) (200 gms)",
                              "category": "Meals Add Ons",
                              "description": "Serves 1 | \"Allergens : -\nNutritional information : Kcal(g):492, Protein(g): 16, Carbohydrate(g): 47, Fat (g):27\"",
                              "imageId": "7e6b4346b5067bbd186723ffebab42d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117417563",
                              "name": "Payasam (200gm)",
                              "category": "Desserts.",
                              "description": "Serves 1 | Payasam Of The Day.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):406, Protein(g): 9, Carbohydrate(g): 72, Fat (g):9\"",
                              "imageId": "d3af1638b216b7dd27020a1d64a5adee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395387",
                              "name": "Ghee Gulab Jamun (2 Pcs)",
                              "category": "Desserts.",
                              "description": "Serves 1 | Khoya rich dumplings are deep fried and then given a soaking in sugar syrup.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):426, Protein(g): 4, Carbohydrate(g): 41, Fat (g):27\"",
                              "imageId": "i6wqvnqigzfkkbgxkvxp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88395464",
                              "name": "Ghee Gulab Jamun - 4 Pcs",
                              "category": "Desserts.",
                              "description": "Serves 1 | Khoya rich dumplings are deep fried and then given a soaking in sugar syrup.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):853, Protein(g): 8, Carbohydrate(g): 81, Fat (g):55\"",
                              "imageId": "nwr4e3l5gdqh1lkffoyw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Healthy Beverages.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130874351",
                              "name": "Masala Shikanji",
                              "category": "Healthy Beverages.",
                              "description": "Serves 1 | The perfect thirst quencher, get our tangy nimbu pani mixed with cooling spices (250ml)",
                              "imageId": "95b0b1343e6fd975912b78a40c895c12",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Beverages",
                      "categories": [
                        {
                          "title": "Healthy Lassi",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395390",
                                  "name": "Sweet Lassi",
                                  "category": "Beverages",
                                  "description": "Serves 1 | Classic Lassi - Chilled.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):223, Protein(g): 24, Carbohydrate(g): 22, Fat (g):5\"",
                                  "imageId": "gplhj8dthmmsvb4pybe9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395392",
                                  "name": "Dry Fruit Lassi",
                                  "category": "Beverages",
                                  "description": "Serves 1 | Classic Lassi, blended with Dry Fruit.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):287, Protein(g): 25, Carbohydrate(g): 29, Fat (g):8\"",
                                  "imageId": "bhs9ipdh7qebylefiuyj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88395393",
                                  "name": "Mango Lassi",
                                  "category": "Beverages",
                                  "description": "Serves 1 | Classic lassi churned with mango pulp.\n\n\"Allergens : Dairy\nNutritional information : Kcal(g):195, Protein(g): 14, Carbohydrate(g): 29, Fat (g):3\"",
                                  "imageId": "kp2fejjkf13mbmzxqqyr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Soft Drinks",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127923660",
                                  "name": "Pepsi Pet Bottle-475 mL",
                                  "category": "Beverages",
                                  "description": "Serves 1",
                                  "imageId": "5644a8e1c048e48f29892797742ec511",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221331001736"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Andhra Gunpowder",
                      "area": "Seshadripuram",
                      "completeAddress": "No :- 5 Old No :- 28, 2nd Floor ,  Hare Krishna Road , Opp To Desai Hospital , Shivananda Circle ,Kumara Park East, Seshadripuram Bengaluru, Karnataka :- 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "cd1abaa1-8b18-49d1-8283-5fe44f9cd151",
  "sid": "bf66fa30-678a-4b4b-9495-5ac941815cfe",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "uKn4qd4Qvb0n-I57qhyR89dXT5u1ArlL9pfUvJYE"
},


{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "281469",
              "name": "Lavonne",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "lavonne-central-bangalore-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "emlehbuwgsmryxhwzhvq",
              "locality": "St. Marks Road",
              "areaName": "St. Marks Road",
              "costForTwo": "75000",
              "costForTwoMessage": "₹750 for two",
              "cuisines": [
                "Bakery",
                "Desserts"
              ],
              "avgRating": 4.6,
              "feeDetails": {
                "restaurantId": "281469",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3900
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3900,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.6 kms | ₹39 Delivery fee will apply"
              },
              "parentId": "10530",
              "avgRatingString": "4.6",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "281469",
                "deliveryTime": 22,
                "minDeliveryTime": 22,
                "maxDeliveryTime": 22,
                "lastMileTravel": 0.6,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "22 MINS",
                "lastMileTravelString": "0.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-05 22:40:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹100 | Use RUPAY100 Above ₹129",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "lavonne-central-bangalore-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Samrah Plaza, 4/2, Ground Floor St. Mark, s Road, Bengaluru, Karnataka 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Bakery,Desserts"
                }
              ],
              "logo": "v1642740559/G%20header%20logos/Lavonne.png",
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹100 | Use RUPAY100 Above ₹129",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/281469"
              },
              "expectationNotifiers": [
                {
                  "text": "0.6 kms | ₹39 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>0.6 kms</b> | ₹39 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "restaurantCategory": "RESTAURANT_CATEGORY_GOURMET",
              "backgroundImage": "v1641894907/gourmet%20menu%20header/Lavonne.png",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "brandHeaderText": "Home of iconic European delicacies...",
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.96945780,77.6004788"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 4,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "281469",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "281469",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "281469",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "281469",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Christmas",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106946826",
                              "name": "Dundee Cake (500g)",
                              "category": "Christmas",
                              "description": "Creaming method type of pound cake. Orignally from scotland. Topped with almonds. ",
                              "imageId": "334512b6a71bfb2f93740bf78d5d62d9",
                              "inStock": 1,
                              "price": 120000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "106946823",
                              "name": "Assorted Cookies",
                              "category": "Christmas",
                              "imageId": "dbcda000672322af5e75cb56622e6eef",
                              "inStock": 1,
                              "price": 45000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129276453",
                              "name": "Truffles",
                              "category": "Christmas",
                              "description": "Box of lime and coconut(2), chocolate cherry(1) and coffee(2). ",
                              "imageId": "97bc180ef407d3c7f423d88335c5c2ae",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 65000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bakery",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461515",
                              "name": "Butter Croissant",
                              "category": "Bakery",
                              "description": "Buttery flaky viennoiserie baked to golden crisp perfection. ",
                              "imageId": "ibopjotvtdd9urynmpio",
                              "inStock": 1,
                              "price": 21000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "108 ratings",
                                  "ratingCountV2": "108"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461518",
                              "name": "Pain Au Chocolat",
                              "category": "Bakery",
                              "description": "Fresh baked croissant inserted with dark couverture chocolate batons. ",
                              "imageId": "ugrj9pseotjva2jtgrne",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68788149",
                              "name": "Almond Croissant",
                              "category": "Bakery",
                              "description": "Rich and buttery croissant filled with a sweet frangipan and topped with toasted almond flakes. ",
                              "imageId": "megyy5cmso4ufk3b7dsn",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "258 ratings",
                                  "ratingCountV2": "258"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461512",
                              "name": "Caramelised Milk Chocolate Croissant",
                              "category": "Bakery",
                              "description": "Freshly baked croissant with luscious dulce filling and dipped into gourmand milk chocolate and almonds. ",
                              "imageId": "a4598aaad629918959ee32061ff10116",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "123 ratings",
                                  "ratingCountV2": "123"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461513",
                              "name": "Cinnamon Roll",
                              "category": "Bakery",
                              "description": "Classic sweet sticky roll made using croissant dough and mildly spiced with cinnamon. ",
                              "imageId": "qpwwvowznonmafzckzhl",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461502",
                              "name": "Golden Milk & Lemon Coconut Beignets",
                              "category": "Bakery",
                              "description": "Soft and delectable golden milk berliner stuffed with lemon coconut chantilly",
                              "imageId": "8c2eadf6bab7b629cde71234beb916d9",
                              "inStock": 1,
                              "price": 21000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461478",
                              "name": "Coffee & Milk Berliner",
                              "category": "Bakery",
                              "description": "Berliner stuffed with coffee milk chocolate cream and glazed with dark chocolate gourmand. ",
                              "imageId": "4150ecc8c3903384cbd66ea8c567b186",
                              "inStock": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "97 ratings",
                                  "ratingCountV2": "97"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461539",
                              "name": "Banana Tea Cake",
                              "category": "Bakery",
                              "description": "Soft and moist tea cake made with the magical combination of bananas and walnuts. ",
                              "imageId": "k5vubzkka0jzb5lo7kxc",
                              "inStock": 1,
                              "price": 25000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461504",
                              "name": "Tellicherry Pepper Chicken Puff",
                              "category": "Bakery",
                              "description": "Freshly baked puff pastry with curried chicken mince filling and topped off with curry leaf powder. ",
                              "imageId": "wwe0vvnehlzt2ae3drmf",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461507",
                              "name": "Barbecue Feta Danish",
                              "category": "Bakery",
                              "description": "Layered croissant dough filled with barbeque tomatoes and caramelised onion and topped with fresh feta. ",
                              "imageId": "wwi36zncydqtmm5dmmqf",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88529219",
                              "name": "Chicken Balchao Frankfurter Danish",
                              "category": "Bakery",
                              "description": "Baked croissant dough, topped with tangy balchao paste, grilled chicken frankfurter and garnished with fried onions and leek. ",
                              "imageId": "pb1j9xpxcb3zaf2u8at7",
                              "inStock": 1,
                              "price": 23000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461490",
                              "name": "Jalapeno & Cheddar Fondue Berliner",
                              "category": "Bakery",
                              "description": "Delectable berliner stuffed with melted cheddar cheese fondue and pickled jalapenos, topped off with fried onions",
                              "imageId": "i5dtn8dpfi8f8act7qrz",
                              "inStock": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461517",
                              "name": "Kerala Onion, Ham & Cheddar Croissant",
                              "category": "Bakery",
                              "description": "Croissant stuffed with ham & cheese and topped off with crispy kerala onion and cheese. ",
                              "imageId": "c729b42c7a876265cfbb6d8be94f573e",
                              "inStock": 1,
                              "price": 23000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123734804",
                              "name": "Multigrain Guava Perad Croissant",
                              "category": "Bakery",
                              "description": "Multigrain croissant cube filled with guava, cream cheese and topped with guava perad. ",
                              "imageId": "6f3568648ebf4b6a0fe7fe1351c03747",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123734805",
                              "name": "Coconut & Pineapple Danish",
                              "category": "Bakery",
                              "description": "Danish filled with coconut cream and pineapple marmalade and topped of with fresh pineapple. ",
                              "imageId": "d31b2d19ff4ec8df08aa4f4b5792361d",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123734807",
                              "name": "Pain Suisse",
                              "category": "Bakery",
                              "description": "A swiss delicacy of laminated dough filled with custard, crumble, and glazed with nannari syrup. ",
                              "imageId": "41ac3176ccee46c51506d1200c5e356a",
                              "inStock": 1,
                              "price": 23000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461535",
                              "name": "Sourdough Bread Plain",
                              "category": "Breads",
                              "description": "Slow fermented and artisanal crafted, crusty and flavourful bread. ",
                              "imageId": "218d7f53e3b244bf9a10d6ec69be695b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461545",
                              "name": "Sourdough Bread Turmeric Walnut And Flax Seeds",
                              "category": "Breads",
                              "description": "Slow fermented and artisanal crafted, crusty bread with flavours of turmeric, walnuts and flaxseed. ",
                              "imageId": "e4m5qqo212jhmwxhcz3f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461521",
                              "name": "Baguette",
                              "category": "Breads",
                              "description": "Freshly baked french bread that is soft and porous on the inside while hard and crusty on the outside. ",
                              "imageId": "mhxrmbl8u1iayeko1cac",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461473",
                              "name": "Multigrain Sandwich Jr",
                              "category": "Breads",
                              "description": "Made with the goodness of whole wheat and a whole lot of multigrain, it is still rich, buttery and flaky. ",
                              "imageId": "kjv7an8rzlyypmce0lpv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88526279",
                              "name": "Babka",
                              "category": "Breads",
                              "description": "A rich sweet braided bread, with flavours of almond and chocolate paste",
                              "imageId": "7f79ecdd13980992066ecc1b381df168",
                              "inStock": 1,
                              "price": 25000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461468",
                              "name": "Milk Bread Jr",
                              "category": "Breads",
                              "description": "Freshly baked and uncut loaf perfect for your everyday sandwich. ",
                              "imageId": "997c5ce1c83e256a2f235ec02beeeb9f",
                              "inStock": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461525",
                              "name": "Milk Bread",
                              "category": "Breads",
                              "description": "Freshly baked and uncut loaf perfect for your everyday sandwich. ",
                              "imageId": "cieovvwlz03uvtodhfc1",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastry",
                      "categories": [
                        {
                          "title": "Pastry Products",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "76953788",
                                  "name": "Tiramisu (280gms)",
                                  "category": "Pastry",
                                  "description": "Most elegant italian dessert, blending in the bold flavours of espresso, rich cocoa and gorgeous mascarpone all layered between the lightest savoiardi sponge. ",
                                  "imageId": "o1cpvdvgt7tjeavcjv5z",
                                  "inStock": 1,
                                  "price": 70000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "74 ratings",
                                      "ratingCountV2": "74"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461505",
                                  "name": "Brownie",
                                  "category": "Pastry",
                                  "description": "Dense and fudgy chocolate brownie squares, topped with a sprinkle of sea salt to balance off the rich flavours. ",
                                  "imageId": "ig4sr6ex8cggol1owk4x",
                                  "inStock": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "33 ratings",
                                      "ratingCountV2": "33"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461590",
                                  "name": "Chocolate Cup Cake (4 Pcs)",
                                  "category": "Pastry",
                                  "description": "Rich and delicate chocolate cupcake, swirled with lip smacking chocolate ganache and topped off with shaved chocolate",
                                  "imageId": "roljohrjzvxslm8666an",
                                  "inStock": 1,
                                  "price": 50000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461602",
                                  "name": "7 Seven Chocolate Mousse Cake (270gms)",
                                  "category": "Pastry",
                                  "description": "Rich and velvety chocolate mousse cake with chocolate crumble and dark chocolate ganache",
                                  "imageId": "uj3txl16293oniliqboc",
                                  "inStock": 1,
                                  "price": 50000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461557",
                                  "name": "Signature Chocolate Cake",
                                  "category": "Pastry",
                                  "description": "Lavonne?s classic signature chocolate cake with layers of chocolate sponge and chocolate cream enclosed in a decadent chocolate mousse",
                                  "imageId": "72a6e93720856c07698c019b3fe04b5b",
                                  "inStock": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "49 ratings",
                                      "ratingCountV2": "49"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100110100",
                                  "name": "Carrot Cake",
                                  "category": "Pastry",
                                  "description": "Carrot cake baked with a crunchy buttery crumble topped with hazelnut praline and caramelised white chocolate cheese cremeux and orange gel",
                                  "imageId": "9e676b124d7f771385ee6f340c973dfb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "27 ratings",
                                      "ratingCountV2": "27"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100110106",
                                  "name": "Classic Pineapple",
                                  "category": "Pastry",
                                  "description": "Vanilla cake with pineapple confit , coconut mousse topped with lime vanilla namelaka",
                                  "imageId": "f9f1b5fa390b81085be629a8cc49dd43",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734792",
                                  "name": "Raspberry Lamington",
                                  "category": "Pastry",
                                  "description": "Light lemon spongecake soaked in raspberry syrup,with desiccated coconut namelaka and a raspberry confit. ",
                                  "imageId": "2d5a55c417f3966eb976b15307b44b4a",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734793",
                                  "name": "Inspiration Opera",
                                  "category": "Pastry",
                                  "description": "Coffee-soaked jocnode sponge,coffee buttercream,dark chocolate ganache and mousse,topped with mascarpone namelaka. ",
                                  "imageId": "42f95fc22ce2001ac3779077fd753e48",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734794",
                                  "name": "Strawberry Rice Pudding",
                                  "category": "Pastry",
                                  "description": "Rice coconut pudding with strawberry compote & mascarpone lime mousse in a ruby chocolate coating with strawberry gel. ",
                                  "imageId": "20b2f37dc324894081e3cdb6dba042e7",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734795",
                                  "name": "Chocolate Caramel Profiterole",
                                  "category": "Pastry",
                                  "description": "Caramel-filled profitrole,vanilla namelaka,soft caramel ganache,hazelnut chocolate streusel cake and dark chocolate coating. ",
                                  "imageId": "08df51a6f6fe0ab21d6d135d94d58e3d",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734796",
                                  "name": "Fruit & Nut",
                                  "category": "Pastry",
                                  "description": "Nutty chocolate cake with mixed berry compote and chocolate mousse,dipped in crunchy gourmand glaze. ",
                                  "imageId": "e47e937d189c7e5320e0596eec3ed6d2",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734797",
                                  "name": "Blueberry & Lemon Mascarpone Tarte",
                                  "category": "Pastry",
                                  "description": "Lemon blueberry sponge with mascarpone mousse, blueberry confit, lime namelaka and blueberries. ",
                                  "imageId": "a8221e45e5f3ece242d1a1ed5429c567",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734798",
                                  "name": "Vegan Pecan Chocolate Brownie",
                                  "category": "Pastry",
                                  "description": "70% dark chocolate brownie, topped with chocolate whipped ganache, pacan cream and pecan praline. ",
                                  "imageId": "0f8b858a4ed57243aeafd51e9d6963fd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734799",
                                  "name": "Pistachio & Saffron Apricot Cheesecake",
                                  "category": "Pastry",
                                  "description": "Brie set cheesecake with pistachio cremeux, topped with pistachio whipped ganache and apricot confit. ",
                                  "imageId": "ffd77f719adadd5bfea40fc5e6816083",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.3",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734800",
                                  "name": "Hazelnut Caramel Basque",
                                  "category": "Pastry",
                                  "description": "Basque cheesecake topped with creamy soft caramel chantilly and hazelnut praline, studded with caramelized hazelnut. ",
                                  "imageId": "f5112ddb3066408a84a4db41de0940d9",
                                  "inStock": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734801",
                                  "name": "Chocolate Muffin",
                                  "category": "Pastry",
                                  "description": "Moist and indulgent, a loaded double chocolate chip muffin. ",
                                  "imageId": "77158a3cae28f077fe503f538f186b32",
                                  "inStock": 1,
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734802",
                                  "name": "Blueberry & Lime Coconut Muffin",
                                  "category": "Pastry",
                                  "description": "Lemon coconut muffin filled with a blueberry compote. ",
                                  "imageId": "2e8d184f4180026038df3360afcd1c13",
                                  "inStock": 1,
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Bowl",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461569",
                              "name": "Granola Powerbowl",
                              "category": "Bowl",
                              "description": "Granola with yoghurt, fresh cut fruit and a drizzle of honey",
                              "imageId": "ryzunwj2wvpfartopqfx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69394640",
                              "name": "Seasonal Smoothie Bowl",
                              "category": "Bowl",
                              "description": "Rich fruit smoothie dish topped with cut fruits, granola and honey",
                              "imageId": "ddzt1kyxe2dm0yqdozrb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "91 ratings",
                                  "ratingCountV2": "91"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Croissanwich",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461580",
                              "name": "Bacon Egg And Cheese Croissanwich",
                              "category": "Croissanwich",
                              "description": "Savoury and sweet toppings on two sourdough toasts or filled inside a sliced croissant",
                              "imageId": "rott01jidoph2pfd3c15",
                              "inStock": 1,
                              "price": 42000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "71604043",
                              "name": "Creamy Chicken Salad Croissanwich",
                              "category": "Croissanwich",
                              "description": "Savoury and sweet toppings on two sourdough toasts or filled inside a sliced croissant",
                              "imageId": "dlds741xtwkkvfzpbk2p",
                              "inStock": 1,
                              "price": 36000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69394646",
                              "name": "Creamy Egg Salad Croissanwich",
                              "category": "Croissanwich",
                              "description": "Savoury and sweet toppings on two sourdough toasts or filled inside a sliced croissant",
                              "imageId": "cbtyd1uxp9ym6d8y3xhh",
                              "inStock": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461565",
                              "name": "Pesto Grilled English Vegetable Croissanwich",
                              "category": "Croissanwich",
                              "description": "Savoury and sweet toppings on two sourdough toasts or filled inside a sliced croissant",
                              "imageId": "t1ersvxu6gvnr2ktfeeh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Salad",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461574",
                              "name": "Bruleed Figs And Roast Beets",
                              "category": "Salad",
                              "description": "With fresh buffalo mozzarella basil and arugula",
                              "imageId": "sezlhghkkt046mp3uapx",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943372",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448447",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448448",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461572",
                              "name": "Grilled English Vegetable Salad With Crumbled Feta",
                              "category": "Salad",
                              "imageId": "gy5iwrdymwakj1ml47sd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943373",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448449",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448450",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461576",
                              "name": "Seasonal Cold Fruit Salad With Fresh Herbs And Candied Walnuts",
                              "category": "Salad",
                              "imageId": "bp2vzyzrcfytjwlvfh0q",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943374",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448451",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448452",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461578",
                              "name": "Slice Tenderloin Salad With Arugula In Orange Mustard Vinaigrette",
                              "category": "Salad",
                              "imageId": "qxnlbl7fv5ajbroefcsb",
                              "inStock": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943375",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448453",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448454",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461582",
                              "name": "Grilled Chicken With Charred Pineapple Salad",
                              "category": "Salad",
                              "imageId": "bwf7jit1n21ykbr8tyvm",
                              "inStock": 1,
                              "price": 42000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943376",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448455",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448456",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461593",
                              "name": "Hearty Cobb Salad With Chicken, Boiled Eggs And Bacon",
                              "category": "Salad",
                              "imageId": "o7mwc1pibpyh4uz81hvx",
                              "inStock": 1,
                              "price": 44000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120943377",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "104448457",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104448458",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461603",
                              "name": "Bbq Pulled Pork With Sliced Green Apples Burger",
                              "category": "Burgers",
                              "imageId": "ac7n0qrj0m9dagn8uai3",
                              "inStock": 1,
                              "price": 51000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461604",
                              "name": "Grilled Buff Tenderloin Bulgogi Burger",
                              "category": "Burgers",
                              "description": "With caramelized onions and gochujang paste. ",
                              "imageId": "xoietaygo3jagq8gmtv8",
                              "inStock": 1,
                              "price": 53000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461599",
                              "name": "Fried Spicy Chicken With Coleslaw Burger",
                              "category": "Burgers",
                              "imageId": "exdtfbbtpztun4gaswdl",
                              "inStock": 1,
                              "price": 48000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461605",
                              "name": "Double Buff Patty Cheese Burger With Bacon And Fried Egg",
                              "category": "Burgers",
                              "imageId": "yi6c3wrnfedfvqg7hjwg",
                              "inStock": 1,
                              "price": 58000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461598",
                              "name": "Crispy Wasabi Prawn Po Boy Burger",
                              "category": "Burgers",
                              "imageId": "wa93ofmidg75oxtuvhmn",
                              "inStock": 1,
                              "price": 48000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461600",
                              "name": "Single Patty Cheese Burger With Bacon And Fried Egg",
                              "category": "Burgers",
                              "imageId": "imykucbeyihjg0omjezc",
                              "inStock": 1,
                              "price": 48000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sandwiches",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461575",
                              "name": "Grilled Chicken With Fresh Tomatoes And Mozzarella Sandwich",
                              "category": "Sandwiches",
                              "imageId": "m82ptwj8dxprgllhb5st",
                              "inStock": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461581",
                              "name": "Crispy Bacon, Egg And Cheese With Mustard Mayo Sandwich",
                              "category": "Sandwiches",
                              "imageId": "ufcv9c5j4z1vsahxeyxc",
                              "inStock": 1,
                              "price": 42000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461568",
                              "name": "English Vegetables Sandwich",
                              "category": "Sandwiches",
                              "description": "With sun dried tomatoes, mozarella and pesto mayo. ",
                              "imageId": "r1cwbfkkqtpz9uipnlwb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pasta",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461588",
                              "name": "Basil Pesto Spaghetti With Grilled Vegetables And Bacconcini",
                              "category": "Pasta",
                              "imageId": "zzmi5lh3nbkiuqh8hgv7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 44000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445836",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401419",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401420",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401421",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461589",
                              "name": "Browned Butter And Sage Fettuccine",
                              "category": "Pasta",
                              "description": "With sliced shitake mushrooms and parmesan breadcrumbs. ",
                              "imageId": "zqnhjvtd5o2duuo08o6d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 44000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445837",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401422",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401423",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401424",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461583",
                              "name": "Penne Alfredo With Grilled Vegetables And Bocconcini",
                              "category": "Pasta",
                              "imageId": "yrkqadxiz8efw7umxrtw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 42000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445838",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401425",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401426",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401427",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461595",
                              "name": "Penne In Browned Bechamel",
                              "category": "Pasta",
                              "description": "With shitake and button mushrooms and sun dried tomatoes",
                              "imageId": "oct4wqvwxzuz0jkiopku",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 46000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445839",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401428",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401429",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401430",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461579",
                              "name": "Penne With Roast Eggplant",
                              "category": "Pasta",
                              "description": "With roast eggplant, bell peppers, olives, sun dried tomatoes and parmesan breadcrumbs",
                              "imageId": "r1jbxhgoistmo9ermosw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445840",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401431",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401432",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401433",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54836940",
                              "name": "Spaghetti Alla Puttanesca",
                              "category": "Pasta",
                              "imageId": "nz4qcweuuo8smasbiosj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445841",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401434",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401435",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401436",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461597",
                              "name": "Bacon And Shrimps Fettuccine With Wilted Greens In Creamy Bechamel",
                              "category": "Pasta",
                              "imageId": "hmpyyfzg7selpgnity1a",
                              "inStock": 1,
                              "price": 48000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445842",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401437",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401438",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401439",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "97461573",
                              "name": "Spaghetti Aglio E Olio",
                              "category": "Pasta",
                              "imageId": "xul44cjqha0kiykasamr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "88445843",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "76401440",
                                      "name": "Crispy Bacon",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401441",
                                      "name": "Grilled Chicken",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "76401442",
                                      "name": "Grilled Veg",
                                      "price": 12000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Beverage",
                      "categories": [
                        {
                          "title": "Coffee",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836953",
                                  "name": "Americano",
                                  "category": "Beverage",
                                  "description": "Rich aromatic coffee brewed along with hot water. ",
                                  "imageId": "hovrpzv7rfrhzgpsaydv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461508",
                                  "name": "Cafe Latte",
                                  "category": "Beverage",
                                  "description": "Freshly brewed espresso balanced with steamed milk and a thin layer of foam. ",
                                  "imageId": "anamt4saylfpcunswryw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461537",
                                  "name": "Cafe Mocha",
                                  "category": "Beverage",
                                  "description": "A warm infusion of couverture dark chocolate and coffee. ",
                                  "imageId": "mao54nqiejj7ypyqotky",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836951",
                                  "name": "Cappuccino",
                                  "category": "Beverage",
                                  "description": "Freshly brewed espresso with an equal amount of steamed milk topped with foam. ",
                                  "imageId": "tsbkkzhqmeudnmudikox",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "69 ratings",
                                      "ratingCountV2": "69"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836950",
                                  "name": "Cold Coffee",
                                  "category": "Beverage",
                                  "description": "The original iced milk-coffee blended to perfection and served cold. ",
                                  "imageId": "lwc4gijmjrrrzo0m9elg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "147 ratings",
                                      "ratingCountV2": "147"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461514",
                                  "name": "Cortado",
                                  "category": "Beverage",
                                  "description": "Freshly brewed espresso with a generous helping of warm milk",
                                  "imageId": "d45cfdfe93b50e974d1ae3613a3a3953",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461484",
                                  "name": "Espresso Doppio",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836948",
                                  "name": "Filter Coffee",
                                  "category": "Beverage",
                                  "description": "A rich and aromatic variation of the traditional south indian styled coffee. ",
                                  "imageId": "ighmzpsxbhyqlnyawxvf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461516",
                                  "name": "Flat White",
                                  "category": "Beverage",
                                  "description": "An espresso dominant beverage topped with velvety foam. ",
                                  "imageId": "wvqmo1xgmso6tuzkvzox",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461472",
                                  "name": "Iced Americano",
                                  "category": "Beverage",
                                  "description": "The refreshing goodness of an americano served ice cold. ",
                                  "imageId": "skk6wye7ff7p37pclh6z",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836902",
                                  "name": "Iced Latte",
                                  "category": "Beverage",
                                  "description": "Freshly brewed coffee blended and balanced with cold milk and foam. ",
                                  "imageId": "jxs7dc9bzm4qkp4kkyzw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836903",
                                  "name": "Iced Mocha",
                                  "category": "Beverage",
                                  "description": "The perfect balance of dark chocolate and coffee, served cold. ",
                                  "imageId": "eqi1ng8io8mxina7zn4s",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461493",
                                  "name": "Macchiato",
                                  "category": "Beverage",
                                  "description": "Freshly brewed espresso with a sparing amount of foamed milk. ",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461464",
                                  "name": "Espresso",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Coffees",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71604036",
                                  "name": "Cold Brew Classic",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Dairy Delights",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461533",
                                  "name": "Banana Caramel Thickshake",
                                  "category": "Beverage",
                                  "description": "A smooth blend of fresh bananas along with caramel sauce, ice cream and cold milk, served over ice. ",
                                  "imageId": "q13iokuxm99eswfb01rv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734785",
                                  "name": "Belgian Hot Chocolate With Marshmallows Classic",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123734786",
                                  "name": "Belgian Cold Chocolate",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Refreshers",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836913",
                                  "name": "Orange Juice",
                                  "category": "Beverage",
                                  "description": "Slow and fresh pressed orange juice, with no added sugar. ",
                                  "imageId": "i82fm7do0sneag0nlpqx",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "85 ratings",
                                      "ratingCountV2": "85"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120994384",
                                  "name": "Ginger Kombucha",
                                  "category": "Beverage",
                                  "imageId": "ae2cd0991161ae2b09a32813367da2aa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120994385",
                                  "name": "Peach Kombucha",
                                  "category": "Beverage",
                                  "imageId": "eb2f8e285f81f3e3b2477feae704955c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120994386",
                                  "name": "Earlgrey Lavender Kombucha",
                                  "category": "Beverage",
                                  "imageId": "6faa48a27480c3b32f8b1b53a4a8ddc3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Smoothies",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836904",
                                  "name": "Blueberry Smoothie",
                                  "category": "Beverage",
                                  "description": "A smooth blend of yoghurt, blueberry puree, ice-cream and milk",
                                  "imageId": "ddcp8hubcz84i9bdjgwp",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461540",
                                  "name": "Mixed Berry Smoothie",
                                  "category": "Beverage",
                                  "description": "A smooth blend of yohurt, blueberry and strawberry puree, ice cream and milk",
                                  "imageId": "yfpsydyotuvhrqryrkbn",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97461546",
                                  "name": "Strawberry Smoothie",
                                  "category": "Beverage",
                                  "description": "A smooth blend of yoghurt, strawberry puree, ice-cream and milk",
                                  "imageId": "g5tlddy67uphx6rvfkzo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54836905",
                                  "name": "Banana Peanut Butter Smoothie",
                                  "category": "Beverage",
                                  "description": "A smooth blend of yoghurt, fresh bananas, peanut butter, ice-cream and milk. ",
                                  "imageId": "eclgggjfzgffajktfwlp",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Tea",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88083645",
                                  "name": "Peach Iced Tea",
                                  "category": "Beverage",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11219333001098"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Lavonne",
                      "area": "St. Marks Road",
                      "completeAddress": "Samrah Plaza, 4/2, Ground Floor St. Mark, s Road, Bengaluru, Karnataka 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "9ed481c5-70ed-4e46-85af-3f75628fab4d",
  "sid": "bf94875c-5ee2-4f13-8a0c-f0021a68060d",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "LdGSoa8g6Qs9-uTSu6sgvCIHZe0tVrdZX1VOCx2A"
},
// 20240105232519
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=5938&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "5938",
              "name": "Burger King",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "burger-king-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "e33e1d3ba7d6b2bb0d45e1001b731fcf",
              "locality": "Tasker Town",
              "areaName": "Shivaji Nagar",
              "costForTwo": "35000",
              "costForTwoMessage": "₹350 for two",
              "cuisines": [
                "Burgers",
                "American"
              ],
              "avgRating": 4.2,
              "feeDetails": {
                "restaurantId": "5938",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "2.7 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "166",
              "avgRatingString": "4.2",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "5938",
                "deliveryTime": 34,
                "minDeliveryTime": 34,
                "maxDeliveryTime": 34,
                "lastMileTravel": 2.7,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "34 MINS",
                "lastMileTravelString": "2.7 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 02:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 129",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 129",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 129",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "burger-king-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Unit no 111/4, and 8/2, Asha Gallary, Opposite to west side , Commercial Street, Bangalore-  5600001"
                },
                {
                  "title": "Cuisines",
                  "message": "Burgers,American"
                }
              ],
              "logo": "rng/md/carousel/production/pkcgpsd4df6i5ud3eyuk",
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 129",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 129",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 129",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ]
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 34,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 129
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/5938"
              },
              "expectationNotifiers": [
                {
                  "text": "2.7 kms | ₹38 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>2.7 kms</b> | ₹38 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "itemNudges": {
                "SILD": {
                  "priority": 34,
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD"
                }
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.982855,77.606721",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹129",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "d2085d10-3f82-48ab-ae0a-d1e19963c31c"
                      ],
                      "expiryTime": "1970-01-01T04:33:41Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "5938",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C",
                      "showExpiryTimer": true
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "5938",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "5938",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "5938",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "5938",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714908",
                              "name": "Crispy Veg Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "7798d7bed74c81bc0e5ffc677a7d2eef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16000,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714905",
                              "name": "Crispy Veg Double Patty Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "2b8b717cfc1d7aac9c1c9d16594735f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714901",
                              "name": "Crispy Chicken Double Patty Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "d065d5e9870ed98fb74d6b58c6e4f455",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114906540",
                              "name": "Premium Family Feast for 4 - Chicken",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | Chicken Whopper + Fiery Chicken + Crispy Chicken + Chicken Crunchy Taco + 2 Med Fries + 1 Dip + Peri Peri Sachet + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "50cc6eae0029c5022a3a49dc01cec410",
                              "inStock": 1,
                              "price": 98200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 98200,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114906542",
                              "name": "Classic Family Feast for 4 - Veg",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | 2 Crispy Veg + BK Veggie + Veg Crunchy Taco + 2 Med Fries + 2 Dips + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "3ff9747682a64122fd4b4a6e0601130c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 73100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 73100,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62373980",
                              "name": "Veg Whopper",
                              "category": "Whopper",
                              "description": "Our signature Whopper with 7 layers between the buns. Extra crunchy veg patty, fresh onions, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with new premium buns. Swaad Aisa, India Jaisa.",
                              "imageId": "f10379c6bd1edbbb7ee38da07c78058f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121491734",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491735",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491739",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491742",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491747",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491748",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "426 ratings",
                                  "ratingCountV2": "426"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62373970",
                              "name": "Chicken Whopper",
                              "category": "Whopper",
                              "description": "Our signature Whopper with 7 layers between the buns. Flame-Grilled chicken patty, fresh onions, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with new premium glazed buns. Swaad Aisa, India Jaisa.",
                              "imageId": "595b9676902e5e37c7990e80c020188e",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741093",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741094",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741095",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741096",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741097",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741098",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1052 ratings",
                                  "ratingCountV2": "1052"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112372941",
                              "name": "Crispy Veg Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Veg Patty, Fresh Onion And Our Signature Sauce",
                              "imageId": "eqaon8guufklmil7ayhr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492318",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492322",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492325",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492330",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492334",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492337",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7000,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1879 ratings",
                                  "ratingCountV2": "1879"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999447",
                              "name": "Crispy Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Patty, Onion And Classic Mayo Sauce",
                              "imageId": "mqr237klqgnu0w2pzd94",
                              "inStock": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733481",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733482",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733483",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733484",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733485",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733486",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "2485 ratings",
                                  "ratingCountV2": "2485"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62052423",
                              "name": "Crispy Chicken Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Double Patty, Onion And Classic Mayo Sauce",
                              "imageId": "vfagr7gcirgouhiewq66",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733493",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733494",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733495",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733496",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733497",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733498",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "630 ratings",
                                  "ratingCountV2": "630"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112372940",
                              "name": "Crispy Veg Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Veg Double Patty, Fresh Onion And Our Signature Sauce",
                              "imageId": "phm3t2g7v0lpczvtu6g7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493262",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493264",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493267",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493270",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493271",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493273",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "418 ratings",
                                  "ratingCountV2": "418"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830381",
                              "name": "Hot 'N' Cheezy Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy.",
                              "imageId": "zv7fx1ed433greh6tpvn",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493644",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493647",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493650",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493653",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493656",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516201",
                              "name": "Fiery Chicken Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Spicy Fried Chicken, loads of sauces in soft square masala buns. It's hot and happening.",
                              "imageId": "ppxmlepv15e3qexhhq9v",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "122972521",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972522",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972523",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972524",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972525",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1086 ratings",
                                  "ratingCountV2": "1086"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62097686",
                              "name": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                              "category": "Burger Doubles.",
                              "description": "Two Crispy Veg Double Patty",
                              "imageId": "n3xekdsgny6jdboxy4xw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493728",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493731",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493733",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493736",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493740",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19800,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "373 ratings",
                                  "ratingCountV2": "373"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70207935",
                              "name": "Veg Makhani Burst + Whopper Jr Veg",
                              "category": "Burger Doubles.",
                              "description": "Veg Makhani Burst + Lite Whopper Jr Veg",
                              "imageId": "vrs4vlu7go8nr7q4mcwb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493745",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493747",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493749",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493751",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493752",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107798358",
                              "name": "4 Crispy Veg + 2 Medium Fries",
                              "category": "Friends & Family Combo (Save upto 20%)",
                              "imageId": "bd23501ff2292a42b77a8cdcce803a4b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 40000,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999465",
                              "name": "Medium Fries",
                              "category": "Sides",
                              "description": "The Perfect Crispy Partner",
                              "imageId": "uttwq3j7gos3thsaposd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "284 ratings",
                                  "ratingCountV2": "284"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999464",
                              "name": "King Fries",
                              "category": "Sides",
                              "description": "The Perfect Crispy Partner",
                              "imageId": "uttwq3j7gos3thsaposd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494890",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "108770033",
                                  "groupName": "Add Peri Peri Spice Mix",
                                  "choices": [
                                    {
                                      "id": "98845145",
                                      "name": "Peri Peri Spice Mix",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13000,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "540 ratings",
                                  "ratingCountV2": "540"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "75333592",
                              "name": "King Peri Peri Fries",
                              "category": "Sides",
                              "description": "Crispy Fries With Peri Peri Spice. Hot Indeed",
                              "imageId": "mgipyyoulmma7rjwofoj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494921",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "90 ratings",
                                  "ratingCountV2": "90"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516211",
                              "name": "Chocolate Thick Shake",
                              "category": "Beverages",
                              "description": "Our Signature Chocolate Thick Shake",
                              "imageId": "iixakii4wvkq3dgmpsvc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "242 ratings",
                                  "ratingCountV2": "242"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rs 129 Deal Of The Day",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842396",
                              "name": "2 Med Fries.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "The perfect crispy partner.",
                              "imageId": "vhhodglyalty92qtkobl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114480028",
                              "name": "BK Veggie Burger + Veg Taco.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "3003251dd361d4c0adf74bbbc9126be5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842400",
                              "name": "Veg Makhani Burst Burger+ Medium Peri Peri Fries.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Veg Makhani Burst Burger+ Medium Peri Peri Fries",
                              "imageId": "sn8nuhvffvflrb9pf5e1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "53 ratings",
                                  "ratingCountV2": "53"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842395",
                              "name": "Whopper Jr Veg+ Crispy Veg.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our signature veg whopper in a smaller size + Crispy veg patty  burger",
                              "imageId": "mdf9cluo0plx8xtwbkhi",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842393",
                              "name": "1Crispy Veg Double Patty + 1Med Fries.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Double up the crispy veg patty burger in our best selling burger with fries on the side",
                              "imageId": "slf6cyeqaixjqih3tm9j",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115625002",
                              "name": "BK Veggie Burger + Crispy Veg Burger.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "fa43c54f7dc66a9dac383948c30b3e33",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "117 ratings",
                                  "ratingCountV2": "117"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842389",
                              "name": "Crispy Chicken + Med Fries.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Crispy Chicken patty burger with fries on the side.",
                              "imageId": "tx9dno3ojm5efz9ldwnm",
                              "inStock": 1,
                              "price": 20500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "133 ratings",
                                  "ratingCountV2": "133"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840016",
                              "name": "Crispy Chicken + Crunchy Chicken Taco.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "635a3067995d10a6fc5d6a78a1b8c993",
                              "inStock": 1,
                              "price": 20000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842412",
                              "name": "Whopper Jr Chicken with Cheese Burger.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "3508a3fc00f82f05e64be380e04597b0",
                              "inStock": 1,
                              "price": 19400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842387",
                              "name": "Double Crispy Veg + Double Crispy Veg.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "crispy veg patty burger, our best seller! !",
                              "imageId": "n3xekdsgny6jdboxy4xw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "76 ratings",
                                  "ratingCountV2": "76"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842410",
                              "name": "Crispy Veg Double Patty Burger+Veg Crunchy Taco.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "f01c87024184fe09bf908c5c1ab9a2c9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842397",
                              "name": "Mango Shake.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our signature mango thick shake.",
                              "imageId": "e5fk28ospzzsy5a7m7hc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842398",
                              "name": "Chocolate Shake.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our signature chocolate thick shake.",
                              "imageId": "iixakii4wvkq3dgmpsvc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842409",
                              "name": "Crispy Veg Burger+Med Fries.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "00b61e58b68eff61bf2f75a64625022f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111646152",
                              "name": "Crispy Chicken + Medium Soft Drink (Cola).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "71fca05b9224f31315d54c66c95f5e58",
                              "inStock": 1,
                              "price": 18500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840017",
                              "name": "Crispy Chicken + Chicken Nuggets (4Pcs).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "6481474be0224c91bc1128e0846ed821",
                              "inStock": 1,
                              "price": 18500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840018",
                              "name": "Crispy Chicken with Cheese Burger + Fries (Reg).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "ac05fa2401fa65ee95cbddbba7ed3d25",
                              "inStock": 1,
                              "price": 18500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842392",
                              "name": "Crispy Chicken + Crispy Chicken.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Crispy Chicken patty burger, our best seller. Enjoy Twice.",
                              "imageId": "kqxbihqpeimd5cxpinfn",
                              "inStock": 1,
                              "price": 18000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "249 ratings",
                                  "ratingCountV2": "249"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129661106",
                              "name": "Chicken Whopper Jr Double Patty.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "76cc60a03e91a4b91abaef5b4b849d98",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840019",
                              "name": "Crunchy Chicken Taco + Fries (Reg).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "a1a7645222677ed037cba000d960aa62",
                              "inStock": 1,
                              "price": 18000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85586709",
                              "name": "BK Chicken Double Patty Burger.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our tribute to classic American taste. BK chicken double patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce",
                              "imageId": "1bc2965d3cb5b7c360e45d4a3cd0e962",
                              "inStock": 1,
                              "price": 17900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842413",
                              "name": "Whopper Jr Veg with Cheese Burger.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "6fbac1a74fc40652e9b8d88d944d74a2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 17400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128146754",
                              "name": "Crunchy Chicken Nuggets (Six Pcs).",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection. Served with easy cheesy dip",
                              "imageId": "755dcb8db93f0494e977ade72c18e1b1",
                              "inStock": 1,
                              "price": 16900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111646149",
                              "name": "Crispy Veg + Medium Soft Drink (Cola).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "4de0352ff4142c8606b951301eba86b5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840020",
                              "name": "Crispy Veg with Cheese Burger + Fries (Reg).",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "03d60f1d5333ac3a4364c6e085a19d92",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16500,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840021",
                              "name": "BK Chicken Burger with Cheese.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our tribute to classic American taste. BK chicken patty, garden fresh crispy lettuce, juicy tomato (seasonal), Cheese slice & our signature sauce.",
                              "imageId": "2b6add43b72a5138881bf10da05bc87d",
                              "inStock": 1,
                              "price": 16400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842391",
                              "name": "Crispy Veg + Crispy Chicken.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our best sellers - crispy veg patty burger and crispy chicken patty burger.",
                              "imageId": "vdvl37f0zttykfxrcweh",
                              "inStock": 1,
                              "price": 16000,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113086587",
                              "name": "BK Veggie Double Patty Burger.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our tribute to classic American taste. BK veg Double patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce.",
                              "imageId": "5f4fd933f8375608699694728bf226c3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842406",
                              "name": "Veggie Strips - 5Pcs + Chocolate Mousse Cup.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Veggie Strips - 5Pcs + Chocolate Mousse cup",
                              "imageId": "pexbywbbp16gclzzfcog",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15800,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840022",
                              "name": "Bk Veggie Burger with Cheese.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Our tribute to classic American taste. BK veg patty with cheese slice, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce.",
                              "imageId": "1673e2d5251f3caba2b9842ddccdbf5a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15400,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110842399",
                              "name": "Boneless Wings Regular.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "qlpzsgwyrjwzd3g43iol",
                              "inStock": 1,
                              "price": 14900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "142 ratings",
                                  "ratingCountV2": "142"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129661107",
                              "name": "Veg Whopper Jr Double Patty.",
                              "category": "Rs 129 Deal Of The Day",
                              "imageId": "c32f81063609d3cac4da1a6f3678993a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128096151",
                              "name": "Chicken Wings Fried - Four Pieces.",
                              "category": "Rs 129 Deal Of The Day",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "f93c364a342fd080c66f4c06657fc820",
                              "inStock": 1,
                              "price": 14900,
                              "finalPrice": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "itemNudgeType": "FinalPrice",
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Deal Of The Day @169",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109257365",
                              "name": "2 Veg Crunchy Taco + Med Fries,",
                              "category": "Deal Of The Day @169",
                              "description": "2 Veg Crunchy Taco + Med Fries",
                              "imageId": "9ad5bac8ed97c1fd6588bf6509e0eab5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840023",
                              "name": "2 BK Veggie Burgers,",
                              "category": "Deal Of The Day @169",
                              "imageId": "6bede647c9f56199b7cdbf1a4fcd3393",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109257366",
                              "name": "1 Crunchy Chicken Taco + Medium Peri Peri Fries,",
                              "category": "Deal Of The Day @169",
                              "imageId": "nbuchsmkgeitoxuachdh",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105416733",
                              "name": "2 King Fries,",
                              "category": "Deal Of The Day @169",
                              "description": "MRP. 218 | Save Rs. 49,  The perfect crispy partner.",
                              "imageId": "vhhodglyalty92qtkobl",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105416736",
                              "name": "Chocolate Thick Shake + Crispy Veg Burger,",
                              "category": "Deal Of The Day @169",
                              "description": "MRP. 204 | Save Rs. 35, Chocolate Thick Shake + Crispy Veg Burger",
                              "imageId": "hzqhwhrvkp0zsxyftp1w",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840024",
                              "name": "Fries (M) + BK Veggie Burger,",
                              "category": "Deal Of The Day @169",
                              "imageId": "dde5e0084070495088f4bf70d0cb5e6a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840025",
                              "name": "Veg Whopper Jr + Crunchy Veg Taco,",
                              "category": "Deal Of The Day @169",
                              "imageId": "8ab6f15b8b847c39a36b8ef06553b2fe",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840026",
                              "name": "Crispy Chicken Burger + BK Chicken Burger,",
                              "category": "Deal Of The Day @169",
                              "imageId": "d659b16e71390a54587f2ba35579da8c",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840027",
                              "name": "Chicken Whopper Jr + Fries (Reg),",
                              "category": "Deal Of The Day @169",
                              "imageId": "00ad94e029bfbbb09be399610ca0fcea",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840028",
                              "name": "BK Chicken with Cheese + Fries (Reg),",
                              "category": "Deal Of The Day @169",
                              "imageId": "010537978ab608f74f5becb8bc2e60b9",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840029",
                              "name": "BK Veggie with Cheese + Fries (Reg),",
                              "category": "Deal Of The Day @169",
                              "imageId": "21145d72ef2e7de8ffba8daa9ed76445",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840030",
                              "name": "Veg Whopper Jr + Fries (Reg),",
                              "category": "Deal Of The Day @169",
                              "imageId": "33bdd1bfcf02b28871e6d068dedeb1a7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840031",
                              "name": "Chicken Makhani Burst Burger + Crunchy Chicken Taco,",
                              "category": "Deal Of The Day @169",
                              "imageId": "3d5327ae24d5f10196d4492b16bbb152",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127284420",
                              "name": "Fiery Chicken Burger,",
                              "category": "Deal Of The Day @169",
                              "description": "Spicy Fried Chicken, loads of sauces in soft square masala buns. It's hot and happening.",
                              "imageId": "ppxmlepv15e3qexhhq9v",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1086 ratings",
                                  "ratingCountV2": "1086"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105416720",
                              "name": "Chicken Tandoori Burger,",
                              "category": "Deal Of The Day @169",
                              "description": "Flame Grilled Tandoori Chicken, veg khurchan, soft square masala buns. It's Tandoorilicious.",
                              "imageId": "x7zs6wy8jpqbambap3us",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101165267",
                              "name": "Hot 'N' Cheezy Burger,",
                              "category": "Deal Of The Day @169",
                              "description": "Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy.",
                              "imageId": "zv7fx1ed433greh6tpvn",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128749616",
                              "name": "Paneer Royale Burger,",
                              "category": "Deal Of The Day @169",
                              "description": "Thick Paneer Patty, loads of sauces in soft square masala buns. It's Royally Paneer.",
                              "imageId": "gq6qbyomdgkuql8aevd1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128840032",
                              "name": "2 Crunchy Chicken Taco,",
                              "category": "Deal Of The Day @169",
                              "imageId": "735f9f360d5dc7126e7fad4f7d229173",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burger+Fries (Save upto 15%)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176730",
                              "name": "Fiery Chicken Wrap+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "d64be3882de6ee5b366224e7e2d84a94",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176732",
                              "name": "Paneer Royale Wrap+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "80fb9bbb88ef15d0f83d5e7074b46778",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176733",
                              "name": "Hot 'N' Cheezy Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "4bdeb1eb40c046c5f5098ce7cafc2a9c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176735",
                              "name": "Fiery Chicken Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "c7c28337a2b39fe428fcd969ed1e271c",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176737",
                              "name": "Paneer Royale Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "f8e91c5dad053aea85cf4d198c08f86c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176738",
                              "name": "Chicken Tandoori+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "60b5c3624684312e3354d63c8dda18fd",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176740",
                              "name": "Whopper Jr Chicken+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "108667f3a9e53070132abb9d302e0f62",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176742",
                              "name": "BK Chicken Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "46414d264421dd57ed7bb5c4a95eff15",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176743",
                              "name": "Whopper Jr Veg+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "17fc1ae2afff5f7b6d3d11070e39f494",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176745",
                              "name": "Veg Whopper+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "ae4ef25dff5f24a06b073b8a46b132fd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176747",
                              "name": "Chicken Whopper+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "a460e5959f4b2f6c034ed172ef633f59",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176748",
                              "name": "BK Veggie Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "45016bc31e171e3d7c397bd39dcfc989",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176749",
                              "name": "Crispy Chicken Double Patty Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "aa9dd4f3bd0d48a168917864c26f67aa",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176750",
                              "name": "Chicken Makhani Burst Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "868abb84b158daf7e5143466cfadadbc",
                              "inStock": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176751",
                              "name": "Crispy Veg Double Patty Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "87cd18453000bd26de16c7be43d7753b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176752",
                              "name": "Crispy Chicken Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "f0b75f36f2c232f617ceb6eca7de7baf",
                              "inStock": 1,
                              "price": 17000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 17000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176753",
                              "name": "Veg Makhani Burst Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "178430ebf68aa04de113e0528fcb5b8a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129176754",
                              "name": "Crispy Veg Burger+Fries(Reg)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "77018891777fcc313f2111b2dfad0a47",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714908",
                              "name": "Crispy Veg Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "7798d7bed74c81bc0e5ffc677a7d2eef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714911",
                              "name": "Veg Crunchy Taco+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "88171677adbbb5f960501fca28514955",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714903",
                              "name": "Crispy Chicken Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "53601f4ac59713a4ee2f87de0ddc7cd7",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714905",
                              "name": "Crispy Veg Double Patty Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "2b8b717cfc1d7aac9c1c9d16594735f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714915",
                              "name": "Crunchy Chicken Taco+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "2c42dae7ad0c577c5c99e0ba5e64ade1",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714913",
                              "name": "BK Veggie Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "4b6ff71f1ac7fcbba197092e1a178fd3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714901",
                              "name": "Crispy Chicken Double Patty Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "d065d5e9870ed98fb74d6b58c6e4f455",
                              "inStock": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714925",
                              "name": "BK Chicken Burger+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "cf38652e9fa53e607a08b3f1e177d593",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714923",
                              "name": "Whopper Jr Veg+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "9059c61098a54b2fe504515db2cf9bf6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714920",
                              "name": "Veg Whopper+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "5ad019a668375abf0c54589e13113c55",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714927",
                              "name": "Paneer Royale Wrap+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "a7070fe1bdf0ea1f798e0c00b18802ce",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120714919",
                              "name": "Chicken Whopper+Fries(M)",
                              "category": "Burger+Fries (Save upto 15%)",
                              "imageId": "784506abfb738f0c89bb17242280b730",
                              "inStock": 1,
                              "price": 28900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 28900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cricket Mania Combos ( Save Rs 122)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121702125",
                              "name": "Super Over Combo - Veg",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Whopper Jr Veg + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "f35ceb73777f02ae2beed92cd174991e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 59600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 59600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121622130",
                              "name": "Super Over Combo - Chicken",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Whopper Jr Chicken + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "28ec9e7f61902f5dd1be6a091d3c12f6",
                              "inStock": 1,
                              "price": 63600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 63600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121622131",
                              "name": "Game Changer Combo - Veg",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Veg Whopper + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "774235fbe1e90fc68eecfbfa407d6df5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 65600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 65600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121622132",
                              "name": "Game Changer Combo - Chicken",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Chicken Whopper + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "2f9a2cff987f815824e31dcebb759a0b",
                              "inStock": 1,
                              "price": 69600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 69600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121622133",
                              "name": "The Hattrick Combo - Veg",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Boss Veg Whopper + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "a5f84821cbd615f1763e0dbdf88b720c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 73600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 73600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121622134",
                              "name": "The Hattrick Combo - Chicken",
                              "category": "Cricket Mania Combos ( Save Rs 122)",
                              "description": "Save Rs. 122 | 2 Boss Chicken Whopper + 2 Med Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "01fb7e9c0586bd1b867db7ffa7e323ea",
                              "inStock": 1,
                              "price": 77600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 77600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Family Feast for 4 ( Save upto 37%)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115192358",
                              "name": "Premium Family Feast for 4 - Veg",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | Veg Whopper + Paneer Royale + Crispy Veg + BK Veggie + 2 Med Fries + 1 Dip + Peri Peri Sachet + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "a9b60d491d38b5a193285d4f5d779d79",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 95300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 95300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114906540",
                              "name": "Premium Family Feast for 4 - Chicken",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | Chicken Whopper + Fiery Chicken + Crispy Chicken + Chicken Crunchy Taco + 2 Med Fries + 1 Dip + Peri Peri Sachet + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "50cc6eae0029c5022a3a49dc01cec410",
                              "inStock": 1,
                              "price": 98200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 98200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114906542",
                              "name": "Classic Family Feast for 4 - Veg",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | 2 Crispy Veg + BK Veggie + Veg Crunchy Taco + 2 Med Fries + 2 Dips + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "3ff9747682a64122fd4b4a6e0601130c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 73100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 73100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114906541",
                              "name": "Classic Family Feast for 4 - Chicken",
                              "category": "Family Feast for 4 ( Save upto 37%)",
                              "description": "Save Rs. 200 | 2 Crispy Chicken + BK Chicken + Chicken Crunchy Taco + 2 Med Fries + 2 Dips + Medium Soft Drink (Cola) + Chocolate Thick Shake",
                              "imageId": "abf2088a65b3dfcd30d66d2cfd99e138",
                              "inStock": 1,
                              "price": 82800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 82800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Super Saver Combos (Save upto Rs 90)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93229599",
                              "name": "2 Chicken Tandoori Burger + 1 Med Fries",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 533. Save Rs 95! With this Limited Time Offer",
                              "imageId": "dpceu2bvm3dcrgsdba7f",
                              "inStock": 1,
                              "price": 41800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98446855",
                              "name": "Whopper Duo - Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 772. Save Rs 90 | 2 Veg Whopper + 1 King Fries + 1 Chocolate Shake + 1 Medium Soft Drink (Cola)",
                              "imageId": "7727ff37bf9563f969427289b882db42",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 68200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 68200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830376",
                              "name": "2 Fiery Chicken Burger + 1 Med Fries",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 533. Save Rs 95! With this Limited Time Offer",
                              "imageId": "hyvhcr4g1efoo71itzk5",
                              "inStock": 1,
                              "price": 41800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128515757",
                              "name": "Whopper Duo - Non Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 812. Save Rs 90 | 2 Chicken Whopper + 1 King Fries  + 1 Chocolate Shake  + 1 Medium Soft Drink (Cola)",
                              "imageId": "10f057afcd6eb887139d17c4589c3904",
                              "inStock": 1,
                              "price": 72200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 72200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830374",
                              "name": "Paneer Royale Burger + Hot 'N' Cheezy Burger + 1 Med Fries",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 533. Save Rs 95! With this Limited Time Offer",
                              "imageId": "onssgrtxft7udr5ds7qy",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119452753",
                              "name": "Cheezy Duo - Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 718. Save Rs 90 | 2 Hot'N'Cheezy + 1 King Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "d42d1a0b7fac4000c38688855cef9266",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 62800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 62800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830375",
                              "name": "2 Hot 'N' Cheezy Burger + 1 Med Fries",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 533. Save Rs 95! With this Limited Time Offer",
                              "imageId": "pqm4ofmptidnqw9e6pmy",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119452755",
                              "name": "Fiery Duo - Non Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 718. Save Rs 90 | 2 FieryChicken + 1 King Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "34535700757b596f4ae80502e7ec9884",
                              "inStock": 1,
                              "price": 62800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 62800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830378",
                              "name": "2 Paneer Royale Burger + 1 Med Fries",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 533. Save Rs 95! With this Limited Time Offer",
                              "imageId": "zftsnjnvvbmbshojb5zk",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98446862",
                              "name": "Binging Duo - Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 706. Save Rs 90 | 2Crispy Veg Double Patty+1King Fries+2Chocolate Shake",
                              "imageId": "9bce3075b3fb801e41039b325f7bc1bd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 61600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 61600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98446863",
                              "name": "Binging Duo - Non  Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 766. Save Rs 90 | 2Crispy Chicken Double Patty+1King Fries+2Chocolate Shake",
                              "imageId": "2feb7d4684459eae42ee8c094d46036d",
                              "inStock": 1,
                              "price": 69600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 69600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119452754",
                              "name": "Indulgent Duo - Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 718. Save Rs 90 | 2 Paneer Royale + 1 King Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "8012d8109750604d89914f48fb118570",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 62800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 62800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119452752",
                              "name": "Indulgent Duo - Non Veg",
                              "category": "Super Saver Combos (Save upto Rs 90)",
                              "description": "MRP 718. Save Rs 90 | 2 Chicken Tandoor Grill + 1 King Fries + 2 Medium Soft Drink (Cola)",
                              "imageId": "f9da4f4bdb8e577ae5e3733daea532d2",
                              "inStock": 1,
                              "price": 62800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 62800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Whopper",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516186",
                              "name": "Mutton Whopper",
                              "category": "Whopper",
                              "description": "Our signature Whopper with 7 layers between the buns. Flame-Grilled mutton patty, fresh onions, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with new glazed buns. Swaad Aisa, India Jaisa.",
                              "imageId": "01b7cb04a2f54faa47b9dd52ad8432b9",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741087",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741088",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741089",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741090",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741091",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741092",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 31900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "329 ratings",
                                  "ratingCountV2": "329"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62373980",
                              "name": "Veg Whopper",
                              "category": "Whopper",
                              "description": "Our signature Whopper with 7 layers between the buns. Extra crunchy veg patty, fresh onions, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with new premium buns. Swaad Aisa, India Jaisa.",
                              "imageId": "f10379c6bd1edbbb7ee38da07c78058f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121491734",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491735",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491739",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491742",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491747",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121491748",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "426 ratings",
                                  "ratingCountV2": "426"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62373970",
                              "name": "Chicken Whopper",
                              "category": "Whopper",
                              "description": "Our signature Whopper with 7 layers between the buns. Flame-Grilled chicken patty, fresh onions, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with new premium glazed buns. Swaad Aisa, India Jaisa.",
                              "imageId": "595b9676902e5e37c7990e80c020188e",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741093",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741094",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741095",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741096",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741097",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741098",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1052 ratings",
                                  "ratingCountV2": "1052"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94736919",
                              "name": "Boss Whopper Mutton",
                              "category": "Whopper",
                              "description": "The biggest Whopper ever, Boss Whopper, with Premium buns, flame grilled mutton patty, cheese, crunchy chips, 'loads of veggies & sauces. Big on flavours, big on bite.",
                              "imageId": "40ab573c44eada77c739509fdc03807f",
                              "inStock": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741099",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741100",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741101",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741102",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741103",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741104",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 35900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "41927810",
                              "name": "Mutton Whopper Double Patty",
                              "category": "Whopper",
                              "description": "Two Much Mutton As Delicious Flame-Grilled Patties, Farm-Fresh Veggies And Mayo Is What Makes This Mutton Double Whopper A Feast For The Beast",
                              "imageId": "2b7e9081f78e16ff787fe1f5b74a79fe",
                              "inStock": 1,
                              "price": 38900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741105",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741106",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741107",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741108",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741109",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741110",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 38900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "71131117",
                              "name": "Chicken Whopper with Cheese",
                              "category": "Whopper",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns. Flame Grilled Chicken Patty With Cheese Slice, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
                              "imageId": "2120ea6ddc4bb465ef401d75d34b50f9",
                              "inStock": 1,
                              "price": 22400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741111",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741112",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741113",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741114",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741115",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741116",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 22400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94736925",
                              "name": "Boss Whopper Chicken",
                              "category": "Whopper",
                              "description": "The biggest Whopper ever, Boss Whopper, with Premium buns, flame grilled chicken patty, cheese, crunchy chips, loads of veggies & sauces. Big on flavours, big on bite.",
                              "imageId": "2ece2c5f21d615e1bb12163a495bbcbc",
                              "inStock": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741117",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741118",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741119",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741120",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741121",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741122",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 23900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63484119",
                              "name": "Chicken Whopper Double Patty",
                              "category": "Whopper",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns. Flame Grilled Chicken Double Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
                              "imageId": "896b0d8059a658a8330ed6499923c432",
                              "inStock": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741123",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741124",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741125",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741126",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741127",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741128",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "162 ratings",
                                  "ratingCountV2": "162"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "71131109",
                              "name": "Veg Whopper with Cheese",
                              "category": "Whopper",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns. Extra Crunchy Veg Patty With Cheese Slice, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
                              "imageId": "5b62c9147712a4744c398f9761bd665b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492001",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492007",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492014",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492021",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492028",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492034",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60383808",
                              "name": "Boss Whopper Veg",
                              "category": "Whopper",
                              "description": "The biggest Whopper ever, Boss Whopper, with Premium buns, extra crunchy veg patty, cheese, crunchy chips, loads of veggies & sauces. Big on flavours, big on bite.",
                              "imageId": "3417cc55a5b19f08596978c8696e262b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492292",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492294",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492295",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492296",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492298",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492300",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63484121",
                              "name": "Veg Whopper Double Patty",
                              "category": "Whopper",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns. Extra Crunchy Veg Double Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces With Xxl Buns. It’S Not A Burger, It’S A Whopper",
                              "imageId": "957c088b2c68ba2bd57fe1cd03730f82",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492303",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492305",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492306",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492307",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492309",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492312",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers & Wraps",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109404545",
                              "name": "Paneer Royale Wrap",
                              "category": "Burgers & Wraps",
                              "description": "Loaded wrap with thick paneer patty, lots of veggies and sauces",
                              "imageId": "ac57be9fa688f3c2ac5833cd97bb3343",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121680927",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680928",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680929",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680930",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680931",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112372941",
                              "name": "Crispy Veg Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Veg Patty, Fresh Onion And Our Signature Sauce",
                              "imageId": "eqaon8guufklmil7ayhr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492318",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492322",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492325",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492330",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492334",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492337",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7000,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "1879 ratings",
                                  "ratingCountV2": "1879"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117498065",
                              "name": "Chicken Makhani Burst Burger",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy Rich Makhani Flavour With Crispy Chicken Patty Topped With Fresh Onion",
                              "imageId": "ajxjn6rht9vc8aplkvbw",
                              "inStock": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492342",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492345",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492348",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492351",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492352",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492353",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109404546",
                              "name": "Fiery Chicken Wrap",
                              "category": "Burgers & Wraps",
                              "description": "Loaded wrap with spicy fried chicken, lots of veggies and sauces",
                              "imageId": "6308facd353cf1a0a3d3a255e8a783ab",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121680932",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680933",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680935",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680936",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121680937",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102670540",
                              "name": "Crispy Chicken with Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Patty, Cheese Slice, Onion And Classic Mayo Sauce",
                              "imageId": "ieec9d9wdbunnpe98vun",
                              "inStock": 1,
                              "price": 12400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733475",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733476",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733477",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733478",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733479",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733480",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 12400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "357 ratings",
                                  "ratingCountV2": "357"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117498064",
                              "name": "Veg Makhani Burst Burger",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy Rich Makhani Flavour With Mix Veg Patty Topped Up With Fresh Onion",
                              "imageId": "rnljd0ea2zwgfbhkzwwh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492704",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492705",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492706",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492707",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492709",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492710",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999447",
                              "name": "Crispy Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Patty, Onion And Classic Mayo Sauce",
                              "imageId": "mqr237klqgnu0w2pzd94",
                              "inStock": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733481",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733482",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733483",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733484",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733485",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733486",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "2485 ratings",
                                  "ratingCountV2": "2485"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118525856",
                              "name": "Crispy Veg with Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger Withcrispy Veg Patty, Cheese Slice, Fresh Onion And Our Signature Sauce",
                              "imageId": "whfmakrbktn8fqqtcixu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492724",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492727",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492729",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492731",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492735",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492737",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "255 ratings",
                                  "ratingCountV2": "255"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102670541",
                              "name": "Crispy Chicken Double Patty with Cheese",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Double Patty, Cheese Slice, Onion And Classic Mayo Sauce.",
                              "imageId": "okvymi5tdwyu0io6gr3b",
                              "inStock": 1,
                              "price": 16400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733487",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733488",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733489",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733490",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733491",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733492",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68961487",
                              "name": "Crunchy Chicken Taco",
                              "category": "Burgers & Wraps",
                              "description": "Crunchy Shell with chicken patty, crunchy veggies and spicy sauce",
                              "imageId": "kzekifdu0vakjkebcxml",
                              "inStock": 1,
                              "price": 11000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121492761",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492766",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492770",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492773",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121492778",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 11000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "219 ratings",
                                  "ratingCountV2": "219"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62373989",
                              "name": "Whopper Jr Chicken",
                              "category": "Burgers & Wraps",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns In A Convenient Size. Flame Grilled Chicken Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces",
                              "imageId": "imehwx5nybd2mvbdspag",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741129",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741130",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741131",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741132",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741133",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741134",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "145 ratings",
                                  "ratingCountV2": "145"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62052423",
                              "name": "Crispy Chicken Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Chicken Double Patty, Onion And Classic Mayo Sauce",
                              "imageId": "vfagr7gcirgouhiewq66",
                              "inStock": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733493",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733494",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733495",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733496",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733497",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733498",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "630 ratings",
                                  "ratingCountV2": "630"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999443",
                              "name": "BK Veggie Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Tribute To Classic American Taste. Bk Veg Patty, Garden Fresh Crispy Lettuce, Juicy Tomato(seasonal) & Our Signature Sauce",
                              "imageId": "ylt69e6eeeltgwnf8jla",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493224",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62374005",
                              "name": "BK Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our tribute to classic American taste. The new BK Chicken now has 50%* More Chicken. Enjoy this burger in a Crunchy Chicken patty, garden fresh crispy lettuce, juicy tomato(seasonal) & our signature sauce.",
                              "imageId": "232c7e1b2b74dfc2851556a255e148a2",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493235",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493240",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493243",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493249",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493252",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493255",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112372940",
                              "name": "Crispy Veg Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Veg Double Patty, Fresh Onion And Our Signature Sauce",
                              "imageId": "phm3t2g7v0lpczvtu6g7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493262",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493264",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493267",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493270",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493271",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493273",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "418 ratings",
                                  "ratingCountV2": "418"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112372942",
                              "name": "Crispy Veg Double Patty with Cheese",
                              "category": "Burgers & Wraps",
                              "description": "Our Best-Selling Burger With Crispy Veg Double Patty, Cheese Slice, Fresh Onion And Our Signature Sauce",
                              "imageId": "ndp3akjkdainthdpugjp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493279",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493281",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493284",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493286",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493287",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493288",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 12400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999445",
                              "name": "BK-Veggie Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Our tribute to classic American taste. BK veg double patty, garden fresh crispy lettuce, juicy tomato (seasonal) & our signature sauce",
                              "imageId": "iajmq3xmw6cg13easydh",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493289",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493290",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493291",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493293",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999446",
                              "name": "Whopper Jr Veg",
                              "category": "Burgers & Wraps",
                              "description": "Our Signature Whopper With 7 Layers Between The Buns In A Convenient Size. Extra Crunchy Veg Patty, Fresh Onion, Crispy Lettuce, Juicy Tomatoes(seasonal), Tangy Gherkins, Creamy And Smoky Sauces",
                              "imageId": "y9paueit9iwqcdwv62kf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493295",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493297",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493299",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493301",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493303",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493305",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Kings Premium Burgers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830381",
                              "name": "Hot 'N' Cheezy Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy.",
                              "imageId": "zv7fx1ed433greh6tpvn",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493644",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493647",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493650",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493653",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493656",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830388",
                              "name": "Paneer Royale Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Thick Paneer Patty, loads of sauces in soft square masala buns. It's Royally Paneer.",
                              "imageId": "gq6qbyomdgkuql8aevd1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493663",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493665",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493669",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493674",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493678",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516201",
                              "name": "Fiery Chicken Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Spicy Fried Chicken, loads of sauces in soft square masala buns. It's hot and happening.",
                              "imageId": "ppxmlepv15e3qexhhq9v",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "122972521",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972522",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972523",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972524",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972525",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1086 ratings",
                                  "ratingCountV2": "1086"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93229600",
                              "name": "Chicken Tandoori Burger",
                              "category": "Kings Premium Burgers",
                              "description": "Desiness Alert! Flame grilled Tandoori Chicken, mint sauce with fresh onions.",
                              "imageId": "x7zs6wy8jpqbambap3us",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741135",
                                  "groupName": "SAY CHEESE!",
                                  "choices": [
                                    {
                                      "id": "104880820",
                                      "name": "Double Cheese Slice",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880821",
                                      "name": "Single Cheese Slice",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741136",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741137",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741138",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741139",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burger Doubles.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62097686",
                              "name": "Crispy Veg Double Patty + Crispy Veg Double Patty",
                              "category": "Burger Doubles.",
                              "description": "Two Crispy Veg Double Patty",
                              "imageId": "n3xekdsgny6jdboxy4xw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493728",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493731",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493733",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493736",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493740",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 19800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "373 ratings",
                                  "ratingCountV2": "373"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70207935",
                              "name": "Veg Makhani Burst + Whopper Jr Veg",
                              "category": "Burger Doubles.",
                              "description": "Veg Makhani Burst + Lite Whopper Jr Veg",
                              "imageId": "vrs4vlu7go8nr7q4mcwb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121493745",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493747",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493749",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493751",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121493752",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "55206372",
                              "name": "Chicken Whopper + Chicken Whopper",
                              "category": "Burger Doubles.",
                              "imageId": "83fbae6d81b544b68562cffd4b380482",
                              "inStock": 1,
                              "price": 39800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741140",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741141",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741142",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741143",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741144",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 39800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "187 ratings",
                                  "ratingCountV2": "187"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516170",
                              "name": "2 Crispy Veg",
                              "category": "Burger Doubles.",
                              "imageId": "5cab04c856cc023e482522be309fc5b1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "248 ratings",
                                  "ratingCountV2": "248"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62381724",
                              "name": "BK Veggie Burger + BK Veggie Burger",
                              "category": "Burger Doubles.",
                              "description": "BK Veggie Burger and BK Veggie Burger",
                              "imageId": "bxzazdbhgsttmnoqdhdu",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 27800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "50 ratings",
                                  "ratingCountV2": "50"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62097685",
                              "name": "Crispy Chicken Double Patty + Crispy Chicken Double Patty",
                              "category": "Burger Doubles.",
                              "description": "Two Crispy Chicken Double Patty",
                              "imageId": "rbsdsxa1esuwgdh3bsh0",
                              "inStock": 1,
                              "price": 27800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733499",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733500",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733501",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733502",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733503",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 27800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "405 ratings",
                                  "ratingCountV2": "405"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70207949",
                              "name": "Chicken Makhani Burst + Whopper Jr Chicken",
                              "category": "Burger Doubles.",
                              "description": "Chicken Makhani Burst + Lite Whopper Jr Chicken",
                              "imageId": "gavlmj9y7wo9fubryx19",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741145",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741146",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741147",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741148",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741149",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62381704",
                              "name": "BK Chicken Burger + BK Chicken Burger",
                              "category": "Burger Doubles.",
                              "description": "Two BK Chicken Burger",
                              "imageId": "686e605a3fb8a6ebbd93751a25182bb2",
                              "inStock": 1,
                              "price": 29800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 29800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "94 ratings",
                                  "ratingCountV2": "94"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62786391",
                              "name": "Veg Whopper + Veg Whopper",
                              "category": "Burger Doubles.",
                              "description": "Two Veg Whopper",
                              "imageId": "667922098ad03c21e2176c3f52b432c0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494062",
                                  "groupName": "Make it a combo!!",
                                  "choices": [
                                    {
                                      "id": "104880822",
                                      "name": "King Fries + Medium Pepsi (23% off)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880823",
                                      "name": "Medium Fries + Medium Pepsi Black (23% OFF)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880824",
                                      "name": "Medium Fries + Medium Fountain Pepsi(23% Off)",
                                      "price": 14900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168696",
                                      "name": "Medium Fries + Chocolate Thick Shake (34% off)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880825",
                                      "name": "Med Fries + Med Pepsi + Choco Lava (25% Off)",
                                      "price": 21900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494067",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494071",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494074",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494078",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Friends & Family Combo (Save upto 20%)",
                      "categories": [
                        {
                          "title": "Buddy Box",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107798360",
                                  "name": "6 Crispy Chicken",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "617d4dcdb3319a8469bfc0665309523d",
                                  "inStock": 1,
                                  "price": 49500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 49500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107798359",
                                  "name": "4 Crispy Chicken + 2 Medium Fries",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "4 Crispy Chicken + 2 Medium Fries",
                                  "imageId": "ff09695b642a74ef985f9acc71a59b5b",
                                  "inStock": 1,
                                  "price": 48000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 48000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107798358",
                                  "name": "4 Crispy Veg + 2 Medium Fries",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "bd23501ff2292a42b77a8cdcce803a4b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 40000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107798357",
                                  "name": "6 Crispy Veg",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "deb01939e3eded4c4a633e2085b16139",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 35000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Snack Attack",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "80325638",
                                  "name": "Veggie Strips(5Pcs) + 1 Dip",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Veggie Strips(5Pcs)+1Easy Cheesy Dip",
                                  "imageId": "uxohy5swq99mzwihgqbz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7281,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121494167",
                                      "groupName": "Choose your Dips",
                                      "choices": [
                                        {
                                          "id": "104880836",
                                          "name": "Fiery Hell Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880837",
                                          "name": "Easy Cheesy Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880838",
                                          "name": "Herby Garlic",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 7281,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "80325633",
                                  "name": "Boneless Chicken Wings(4pcs)+1Herby Garlic Dip",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Boneless Chicken Wings (4pcs) with 1 Herby Garlic Dip",
                                  "imageId": "fnhs2dhyb1jkpoqd4veh",
                                  "inStock": 1,
                                  "price": 17281,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121494170",
                                      "groupName": "Choose your Dips",
                                      "choices": [
                                        {
                                          "id": "104880836",
                                          "name": "Fiery Hell Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880837",
                                          "name": "Easy Cheesy Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880838",
                                          "name": "Herby Garlic",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 17281,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105240930",
                                  "name": "Fire Me Up",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "MRP: 318 |  Save 15%, Fiery Chicken Burger + 1 King Fries",
                                  "imageId": "h3abpmfvnui7auc6lcdt",
                                  "inStock": 1,
                                  "price": 27000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 27000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "94473258",
                                  "name": "Boneless Chicken Wings(7Pcs)+1Herby Garlic Dip",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "fnhs2dhyb1jkpoqd4veh",
                                  "inStock": 1,
                                  "price": 27281,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121494171",
                                      "groupName": "Choose your Dips",
                                      "choices": [
                                        {
                                          "id": "104880836",
                                          "name": "Fiery Hell Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880837",
                                          "name": "Easy Cheesy Dip",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "104880838",
                                          "name": "Herby Garlic",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 27281,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105240923",
                                  "name": "Chicken Lovers",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "MRP: 449 |  Save 15%, Crispy Chicken Double Patty + Fiery Chicken + Med Fries + Fiery Hell Dip",
                                  "imageId": "sg4awappvjyvcbcbdrkc",
                                  "inStock": 1,
                                  "price": 38200,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 38200,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105240928",
                                  "name": "Cheezy Bite",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "MRP: 318 |  Save 15%, Hot 'N' Cheezy Burger+1King Fries",
                                  "imageId": "m5wgy2mjxgzla05jqdsi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "64774999",
                                  "name": "2 Crispy Veg Double Patty + 1King Fries + 1Veggie strips",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "nijanydurnusuwckrzim",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 38700,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "98 ratings",
                                      "ratingCountV2": "98"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105240938",
                                  "name": "Cheezy Twins",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "MRP: 398 |  Save 15%, Hot 'N' Cheezy Burger + Hot 'N' Cheezy Burger",
                                  "imageId": "npimka56foklar6xs6fp",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 33800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 33800,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105240941",
                                  "name": "Fiery Twins",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "MRP: 398 |  Save 15%, Fiery Chicken Burger+Fiery Chicken Burger",
                                  "imageId": "muqfnlrqyivs7vwq1xvo",
                                  "inStock": 1,
                                  "price": 33800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 33800,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101289080",
                                  "name": "1 Jr Veg Whopper +1 Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs. 49 | 1 Jr. Veg Whopper +1 Chocolate Thick Shake",
                                  "imageId": "guewpefkkopaurmjxwlf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101289081",
                                  "name": "1 Jr Chicken Whopper+1 Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 49 | 1 Jr. Chicken Whopper+1 Chocolate Thick Shake",
                                  "imageId": "rt1iucvp8tpwnoi3tiv7",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "King Deals (Save Rs 99)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086568",
                                  "name": "Crispy Veg + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | Crispy Veg + Med Fries + Chocolate Thick Shake",
                                  "imageId": "307556c7b9964434829feda7e363e0c9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086569",
                                  "name": "Crispy Chicken + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | Crispy Chicken + Med Fries + Chocolate Thick Shake",
                                  "imageId": "50894d7b5b546fdb9a41175d83b63f73",
                                  "inStock": 1,
                                  "price": 30400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086570",
                                  "name": "BK Veggie + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | BK Veggie + Med Fries + Chocolate Thick Shake",
                                  "imageId": "1c448fd8d9ab3e3ff00450bb28285bd4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 34400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086571",
                                  "name": "BK Chicken + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "0e6440657bea935877dda551cb1b5b13",
                                  "inStock": 1,
                                  "price": 35400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 35400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086572",
                                  "name": "Veg Whopper + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "imageId": "b2cd95b4763d9b96ae18a621445d009d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 38400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086574",
                                  "name": "Chicken Whopper + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | Chicken Whopper + Med Fries + Chocolate Thick Shake",
                                  "imageId": "43b28f43b086924f3aa115ef5ff95825",
                                  "inStock": 1,
                                  "price": 40400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 40400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086579",
                                  "name": "Paneer Royale + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | Paneer Royale + Med Fries + Chocolate Thick Shake",
                                  "imageId": "8baef885118770aedda5b938fc4b28ae",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 40400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "113086582",
                                  "name": "Fiery Chicken + Med Fries + Chocolate Thick Shake",
                                  "category": "Friends & Family Combo (Save upto 20%)",
                                  "description": "Save Rs 99 | Fiery Chicken + Med Fries + Chocolate Thick Shake",
                                  "imageId": "58ad0a8171f8bfee39b9ddab134f453b",
                                  "inStock": 1,
                                  "price": 40400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 40400,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meal Combos(Save Rs. 45)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33542666",
                              "name": "Crispy Veg Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our best-selling burger with crispy veg patty, fresh onion and our signature sauce. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "deyyaxafzufypp1xtpij",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494220",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494223",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494224",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494227",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "485 ratings",
                                  "ratingCountV2": "485"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "27440518",
                              "name": "Crispy Chicken Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our best-selling burger with crispy chicken patty, onion and classic mayo sauce. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "kc81hwtkyuoaj7ecrhv2",
                              "inStock": 1,
                              "price": 26700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "126733504",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733505",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733506",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126733507",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "481 ratings",
                                  "ratingCountV2": "481"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62381763",
                              "name": "Whopper Jr Veg Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our signature Whopper with 7 layers between the buns in a convenient size. Extra crunchy veg Patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "ctrtjnt4kbua0aptyelj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494651",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494657",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494662",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494667",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 26800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62381751",
                              "name": "Whopper Jr Chicken Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our signature Whopper with 7 layers between the buns in a convenient size. Flame Grilled chicken Patty, fresh onion, crispy lettuce, juicy tomatoes, tangy gherkins, creamy and smoky sauces. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "lagxcnkkbyl9wh4owhyq",
                              "inStock": 1,
                              "price": 28800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741150",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741151",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741152",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741153",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 28800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108364625",
                              "name": "Veg Whopper Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our signature Whopper with 7 layers between the buns. Extra crunchy veg Patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with xxl buns. It’s Not A Burger, it’s a Whopper. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "64258e1b7c4bcd5166776d4bf97fa097",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494439",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494441",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494444",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494450",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 32800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "62381730",
                              "name": "Chicken Whopper Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Our signature Whopper with 7 layers between the buns. Flame Grilled chicken Patty, fresh onion, crispy lettuce, juicy tomatoes (seasonal), tangy gherkins, creamy and smoky sauces with xxl buns. It’s Not A Burger, it’s a Whopper. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "d29037b088e5d16af2c37a29cf4c0a11",
                              "inStock": 1,
                              "price": 35800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741154",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741155",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741156",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741157",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "180 ratings",
                                  "ratingCountV2": "180"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830540",
                              "name": "Hot 'N' Cheezy Burger Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Chilli Cheese patty, spicy sauce, soft square masala buns. It's cheezy & spicy. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "rviwuzgjzwfnncsah6ht",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494477",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494480",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494482",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494484",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830564",
                              "name": "Fiery Chicken Burger Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Spicy Fried Chicken, loads of sauces in soft square masala buns. It's hot and happening. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "itfyqnfpxdpfqakoairw",
                              "inStock": 1,
                              "price": 36800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "122972526",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972527",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972528",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122972529",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 36800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89830558",
                              "name": "Paneer Royale Burger Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Thick Paneer Patty, loads of sauces in soft square masala buns. It's Royally Paneer. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "jrvhuujbgioijvapv5sv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494493",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494495",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494497",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121494499",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 35800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93229605",
                              "name": "Chicken Tandoori Burger Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Desiness Alert! Flame grilled Tandoori Chicken, mint sauce with fresh onions. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "hzva8r58mrp8pu4p7ixc",
                              "inStock": 1,
                              "price": 34800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741158",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741159",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741160",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741161",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 34800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53136906",
                              "name": "Mutton Whopper - Combo",
                              "category": "Meal Combos(Save Rs. 45)",
                              "description": "Save Rs 45 | Spicy, Saucy & Desi Masala Whopper for a limited time. Comes with Fries (M) + Medium Soft Drink (Cola)",
                              "imageId": "f4daaf285fadb071c20105171948787c",
                              "inStock": 1,
                              "price": 44800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125741162",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "104880826",
                                      "name": "King Fries",
                                      "price": 13000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880827",
                                      "name": "King Peri Peri Fries",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880828",
                                      "name": "Medium Fries",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880829",
                                      "name": "Medium Peri Peri Fries",
                                      "price": 14400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880830",
                                      "name": "Cheesy Fries",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880831",
                                      "name": "Boneless Wings (4 Pcs)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741163",
                                  "groupName": "Choose Your Beverages!!",
                                  "choices": [
                                    {
                                      "id": "106168697",
                                      "name": "Chocolate Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168698",
                                      "name": "Berry Blast Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880832",
                                      "name": "Medium Pepsi",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880833",
                                      "name": "Medium Pepsi Black",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106168699",
                                      "name": "Mango Thick Shake",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741164",
                                  "groupName": "Add Dessert",
                                  "choices": [
                                    {
                                      "id": "104880834",
                                      "name": "Choco Lava Cake",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880835",
                                      "name": "Chocolate Mousse Cup",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125741165",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "87 ratings",
                                  "ratingCountV2": "87"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999462",
                              "name": "Fiery Hell Dip",
                              "category": "Sides",
                              "description": "Chef's Special Spicy Sauce",
                              "imageId": "nsqnarjlxmzioj5zotty",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 2381,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127472682",
                              "name": "Crunchy Chicken Nuggets (Four Pcs)",
                              "category": "Sides",
                              "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection",
                              "imageId": "bc9b17fa358d5638113f40bea4b16e50",
                              "inStock": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113086593",
                              "name": "Herby Garlic Dip",
                              "category": "Sides",
                              "description": "Chef's Special Garlic Sauce With Herbs",
                              "imageId": "pocqti14flqmqyqghelf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 2381,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127472683",
                              "name": "Crunchy Chicken Nuggets (Six Pcs)",
                              "category": "Sides",
                              "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection. Served with easy cheesy dip",
                              "imageId": "755dcb8db93f0494e977ade72c18e1b1",
                              "inStock": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113086604",
                              "name": "Easy Cheesy Dip",
                              "category": "Sides",
                              "description": "Cheese & Jalapeno Sauce",
                              "imageId": "cfxufomgselawz85bhbo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 2381,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127472684",
                              "name": "Crunchy Chicken Nuggets (Nine Pcs)",
                              "category": "Sides",
                              "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection. Served with easy cheesy dip & fiery hell dip",
                              "imageId": "8c17756e3eb0c4012f4e87df509d341e",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102872026",
                              "name": "Hashbrown",
                              "category": "Sides",
                              "description": "What Every Potato Wants To Be",
                              "imageId": "hslhhbg0ix0ptxl1egez",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114457137",
                              "name": "Peri Peri Spice Mix",
                              "category": "Sides",
                              "imageId": "1200974eb60f9c4489cad469e5485498",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 2857,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127472685",
                              "name": "Crunchy Chicken Nuggets (Eighteen Pcs)",
                              "category": "Sides",
                              "description": "Tender Juicy Crunchy Chicken Nuggets fried to golden brown perfection. Served with easy cheesy dip, fiery dip and herby garlic dip",
                              "imageId": "d93d857760613a190809343f344b2400",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 31900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101197903",
                              "name": "Veggie Strips(5 Pcs)",
                              "category": "Sides",
                              "description": "Vegetarian's Favourite Finger Food",
                              "imageId": "jez2tqz2d0euumrrpvbn",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494825",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "108769990",
                                  "groupName": "Add Peri Peri Spice Mix",
                                  "choices": [
                                    {
                                      "id": "98845145",
                                      "name": "Peri Peri Spice Mix",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 5900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "376 ratings",
                                  "ratingCountV2": "376"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999465",
                              "name": "Medium Fries",
                              "category": "Sides",
                              "description": "The Perfect Crispy Partner",
                              "imageId": "uttwq3j7gos3thsaposd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "284 ratings",
                                  "ratingCountV2": "284"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101999464",
                              "name": "King Fries",
                              "category": "Sides",
                              "description": "The Perfect Crispy Partner",
                              "imageId": "uttwq3j7gos3thsaposd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494890",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "108770033",
                                  "groupName": "Add Peri Peri Spice Mix",
                                  "choices": [
                                    {
                                      "id": "98845145",
                                      "name": "Peri Peri Spice Mix",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "540 ratings",
                                  "ratingCountV2": "540"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116431012",
                              "name": "Medium Peri Peri Fries",
                              "category": "Sides",
                              "description": "Crispy Fries With Peri Peri Spice. Hot Indeed",
                              "imageId": "mgipyyoulmma7rjwofoj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494898",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "102 ratings",
                                  "ratingCountV2": "102"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "43114262",
                              "name": "Cheesy Fries",
                              "category": "Sides",
                              "description": "Crispy French Fries, Loads Of Cheese, Yum!",
                              "imageId": "bs5oedbj1ihduwvbuj8z",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494906",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "108770060",
                                  "groupName": "Add Peri Peri Spice Mix",
                                  "choices": [
                                    {
                                      "id": "98845145",
                                      "name": "Peri Peri Spice Mix",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "481 ratings",
                                  "ratingCountV2": "481"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120197050",
                              "name": "Creamy Italian Fries",
                              "category": "Sides",
                              "description": "The Lip-Smacking Duo Of Creamy Classic Mayo And Tangy Tomato Herb Mayo Make These Fries Very Hard To Resist!",
                              "imageId": "b3hgwlbtnnuovkb4rvcv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494913",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "108770072",
                                  "groupName": "Add Peri Peri Spice Mix",
                                  "choices": [
                                    {
                                      "id": "98845145",
                                      "name": "Peri Peri Spice Mix",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "267 ratings",
                                  "ratingCountV2": "267"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "75333592",
                              "name": "King Peri Peri Fries",
                              "category": "Sides",
                              "description": "Crispy Fries With Peri Peri Spice. Hot Indeed",
                              "imageId": "mgipyyoulmma7rjwofoj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121494921",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "90 ratings",
                                  "ratingCountV2": "90"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51882912",
                              "name": "Peri Peri Fries",
                              "category": "Sides",
                              "description": "Crispy fries with peri peri spice. Hot indeed.",
                              "imageId": "mgipyyoulmma7rjwofoj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34211337",
                                    "name": "Customized",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 144,
                                        "default": 1,
                                        "id": "105758577",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "King",
                                        "price": 159,
                                        "id": "105758578",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34211337",
                                        "variationId": "105758577"
                                      }
                                    ],
                                    "price": 14400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880836"
                                      },
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880837"
                                      },
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880838"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34211337",
                                        "variationId": "105758578"
                                      }
                                    ],
                                    "price": 15900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880836"
                                      },
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880837"
                                      },
                                      {
                                        "groupId": "121959599",
                                        "addonId": "104880838"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "121959599",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "114 ratings",
                                  "ratingCountV2": "114"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111131482",
                              "name": "Medium Soft Drink (Ice Tea)",
                              "category": "Beverages",
                              "imageId": "04a04ee85ec1512de3f0df739627142b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78572855",
                              "name": "Medium Soft Drink (Cola)",
                              "category": "Beverages",
                              "imageId": "jjsk5itomwsjmfz3sd3b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "61 ratings",
                                  "ratingCountV2": "61"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111131480",
                              "name": "Medium Soft Drink (Orange)",
                              "category": "Beverages",
                              "imageId": "39e3ce914464c6eac8e601ec3f4dded4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111131483",
                              "name": "Medium Soft Drink (Clear)",
                              "category": "Beverages",
                              "imageId": "09b99545c6879dfb5cbae7525544026e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516211",
                              "name": "Chocolate Thick Shake",
                              "category": "Beverages",
                              "description": "Our Signature Chocolate Thick Shake",
                              "imageId": "iixakii4wvkq3dgmpsvc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "242 ratings",
                                  "ratingCountV2": "242"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516213",
                              "name": "Mango Thick Shake",
                              "category": "Beverages",
                              "description": "Our Signature Mango Thick Shake",
                              "imageId": "e5fk28ospzzsy5a7m7hc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "117 ratings",
                                  "ratingCountV2": "117"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "71901398",
                              "name": "Berry Blast Thick Shake",
                              "category": "Beverages",
                              "description": "Rich Creamy Black Currant Thick shake",
                              "imageId": "yzkpob5ifvenc79yqjvs",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109811228",
                              "name": "Medium Soft Drink (Diet Cola)",
                              "category": "Beverages",
                              "imageId": "f8320b1b518af3ccb404687e2e185e58",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "90679737",
                              "name": "Chocolate Mousse Cup",
                              "category": "Desserts",
                              "description": "Airy and creamy chocolate mousse topped with chocolate ganache and choco chips",
                              "imageId": "hxpyxm2e2dasvebpzkoz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chicken Wings.",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24516188",
                              "name": "Chicken Wings Fried - Two Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "7a496db5a30393917cec1df6771a91d2",
                              "inStock": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "233 ratings",
                                  "ratingCountV2": "233"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60205071",
                              "name": "Chicken Wings Grilled - Two Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "ef86d1a5d50bdf3192cc0cf709c84991",
                              "inStock": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 7900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66543792",
                              "name": "Boneless Wings Regular",
                              "category": "Chicken Wings.",
                              "description": "4pcs Boneless Chicken Bites",
                              "imageId": "qlpzsgwyrjwzd3g43iol",
                              "inStock": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121495023",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "142 ratings",
                                  "ratingCountV2": "142"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125960345",
                              "name": "Chicken Wings Grilled - Four Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "22d40a7801e67202024cd3c9999e513d",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "309 ratings",
                                  "ratingCountV2": "309"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128217005",
                              "name": "Chicken Wings Fried - Four Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "f93c364a342fd080c66f4c06657fc820",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66543791",
                              "name": "Boneless Wings Large",
                              "category": "Chicken Wings.",
                              "description": "7pcs Boneless Chicken Bites",
                              "imageId": "qefyb4gxjhh0i9iz6ozu",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121495041",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "104880836",
                                      "name": "Fiery Hell Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880837",
                                      "name": "Easy Cheesy Dip",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104880838",
                                      "name": "Herby Garlic",
                                      "price": 2381,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 26900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60205051",
                              "name": "Chicken Wings Grilled - Ten Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "9603ca602ecd7203296ff560deaf6c3a",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "61113854",
                              "name": "Chicken Wings - Five Pcs Fried + Five Pcs Grilled",
                              "category": "Chicken Wings.",
                              "description": "Combination of juicy fried and grilled chicken wings.",
                              "imageId": "xkl6yq42u3xabampktne",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60205037",
                              "name": "Chicken Wings Fried - Ten Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "2de7322bfb3f37e134127d6b189ff9fb",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60205025",
                              "name": "Chicken Wings Fried - Fifteen Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "2de7322bfb3f37e134127d6b189ff9fb",
                              "inStock": 1,
                              "price": 52900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 52900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60205027",
                              "name": "Chicken Wings Grilled - Fifteen Pieces",
                              "category": "Chicken Wings.",
                              "description": "Juicy chicken wings cooked to perfection.",
                              "imageId": "9603ca602ecd7203296ff560deaf6c3a",
                              "inStock": 1,
                              "price": 52900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 52900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220333001288"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Burger King",
                      "area": "Shivaji Nagar",
                      "completeAddress": "Unit no 111/4, and 8/2, Asha Gallary, Opposite to west side , Commercial Street, Bangalore-  5600001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "lHuc9DzBnGpS-DH6yWaD3KNBoGuCw2PBC5_6a2ic"
},
// 20240105232607
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=347868&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "347868",
              "name": "KFC",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "kfc-cunningham-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "f01666ac73626461d7455d9c24005cd4",
              "locality": "Cunnigham road",
              "areaName": "Vasanth Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Burgers",
                "Biryani"
              ],
              "avgRating": 4,
              "feeDetails": {
                "restaurantId": "347868",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 5300
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 5300,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "3 kms | ₹53 Delivery fee will apply"
              },
              "parentId": "547",
              "avgRatingString": "4.0",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "347868",
                "deliveryTime": 27,
                "minDeliveryTime": 27,
                "maxDeliveryTime": 27,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "27 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 03:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "40% off",
                "shortDescriptionList": [
                  {
                    "meta": "40% off | Use SWIGGYIT",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "kfc-cunningham-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "19/3, BMS Pladium, SRT Road,Formerly Cunningham Road,Vasanth Nagar. Bangalore-560052."
                },
                {
                  "title": "Cuisines",
                  "message": "Burgers,Biryani"
                }
              ],
              "logo": "marketing-dashboard/carousel/jieoyuprsn64ubnthg0f",
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "40% off",
                "shortDescriptionList": [
                  {
                    "meta": "40% off | Use SWIGGYIT",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "40% off up to ₹80 on select items | Use code SWIGGYIT",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/347868"
              },
              "expectationNotifiers": [
                {
                  "text": "3 kms | ₹53 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>3 kms</b> | ₹53 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_4",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.986689443208903,77.5953188127101",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "40% OFF UPTO ₹80",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "e35131d2-1321-47c0-9315-ccaa64b0b78d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYIT",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "347868",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "347868",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "347868",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "347868",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "347868",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "40% OFF"
                        }
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1641589",
                          "creativeId": "TopPicks/CCWMeal",
                          "title": "Chicken Chizza & Wings Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "127998209",
                              "name": "Chicken Chizza & Wings Meal",
                              "category": "CHICKEN CHIZZA",
                              "description": "All-chicken-no-crust Chizza, 2 Pc Hot Wings and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                              "imageId": "120374790af673aae76c5a5d883d45ad",
                              "inStock": 1,
                              "price": 45905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596723",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1681248",
                          "creativeId": "TopPicks/USavBucket",
                          "title": "Ultimate Savings Chicken Bucket",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "99453590",
                              "name": "Ultimate Savings Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Savings of 35% on signature bucket of 4pc Hot & crispy chicken, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml [serves 2-3 ]",
                              "imageId": "edbffde0880bbe400d26c5e152a6f088",
                              "inStock": 1,
                              "price": 69905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130680464",
                                  "groupName": "Choose your sides",
                                  "choices": [
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680463",
                                  "groupName": "Choose Your Snack",
                                  "choices": [
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680462",
                                  "groupName": "Choose your beverages",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680461",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1643407",
                          "creativeId": "TopPicks/CChizza",
                          "title": "Chicken Chizza",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "108268652",
                              "name": "Chicken Chizza",
                              "category": "CHICKEN CHIZZA",
                              "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                              "imageId": "5108c304c25e2360d28588a461e1f210",
                              "inStock": 1,
                              "price": 31905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596756",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1644308",
                          "creativeId": "TopPicks/ZPBCMeal",
                          "title": "Zinger Pro Burger & Chicken Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "122153737",
                              "name": "Zinger Pro Burger & Chicken Meal",
                              "category": "BURGERS",
                              "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                              "imageId": "6bafd5f307841d1025401757c7be3521",
                              "inStock": 1,
                              "price": 39905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596459",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1645219",
                          "creativeId": "TopPicks/AOCBucket",
                          "title": "All in One Chicken Bucket",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "117826163",
                              "name": "All in One Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Save 24% with variety bucket of 1 Leg Pc, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml [Serves 2-3]",
                              "imageId": "31f899d11feb6a4bc6b3af7815e0f06f",
                              "inStock": 1,
                              "price": 54857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595633",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595646",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595656",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595670",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1647127",
                          "creativeId": "TopPicks/CBBMeal",
                          "title": "Chicken Burger Buddy Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "66007356",
                              "name": "Chicken Burger Buddy Meal",
                              "category": "BURGERS",
                              "description": "Save Rs. 40 & Share 2 Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                              "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                              "inStock": 1,
                              "price": 52857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596356",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "CHICKEN CHIZZA",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108268652",
                              "name": "Chicken Chizza",
                              "category": "CHICKEN CHIZZA",
                              "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                              "imageId": "5108c304c25e2360d28588a461e1f210",
                              "inStock": 1,
                              "price": 31905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596756",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127998210",
                              "name": "Chicken Chizza & Dessert Meal",
                              "category": "CHICKEN CHIZZA",
                              "description": "All-chicken-no-crust Chizza, Choco Lava Cake and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                              "imageId": "e4d425ed2f059e4e12c8b905f3bc7d99",
                              "inStock": 1,
                              "price": 46857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596742",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111580525",
                              "name": "Chicken Chizza & Pepsi Combo",
                              "category": "CHICKEN CHIZZA",
                              "description": "1 Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml [Serves 1]",
                              "imageId": "aa3caff35ff99fab3dadcd1121a962ce",
                              "inStock": 1,
                              "price": 37619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108268646",
                              "name": "Duo Chicken Chizza",
                              "category": "CHICKEN CHIZZA",
                              "description": "2 Crunchy all-chicken-no-crust Chizza topped with cheese, spicy sauce, veggies & herbs [Serves 2-3]",
                              "imageId": "fd28a1625bb03867ebb65d14a741bba5",
                              "inStock": 1,
                              "price": 62857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130680536",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127998209",
                              "name": "Chicken Chizza & Wings Meal",
                              "category": "CHICKEN CHIZZA",
                              "description": "All-chicken-no-crust Chizza, 2 Pc Hot Wings and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                              "imageId": "120374790af673aae76c5a5d883d45ad",
                              "inStock": 1,
                              "price": 45905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596723",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "RICE BOWLZ",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530114",
                              "name": "Plain Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "New Plain Rice Bowlz",
                              "imageId": "38c021b7322ea7451ad6668b1e0706be",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530113",
                              "name": "Popcorn Chicken Rice Bowlz & Wings Meal",
                              "category": "RICE BOWLZ",
                              "description": "Deal Savings of Rs. 118 on 2 units of Popcorn Chicken Rice Bowlz and 8 Pc Hot Wings [Serves 3-4]",
                              "imageId": "8239f998f8dd9b79b00ed459ff995ca0",
                              "inStock": 1,
                              "price": 69905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530112",
                              "name": "Veg Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Aromatic Veg rice bowl mixed with spicy gravy [serves 1]",
                              "imageId": "b55628a57b4ae927013617605d4db6e6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530111",
                              "name": "Popcorn Chicken Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Aromatic Poprcorn Chicken rice bowl mixed with spicy gravy [serves 1]",
                              "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                              "inStock": 1,
                              "price": 22952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530110",
                              "name": "Smoky Red Chicken Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Aromatic Smoky Red Chicken rice bowl mixed with spicy gravy [serves 1]",
                              "imageId": "3e243b6fbc280b8891643b1d3b7836f6",
                              "inStock": 1,
                              "price": 22952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530109",
                              "name": "Classic Chicken Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 1]",
                              "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                              "inStock": 1,
                              "price": 22952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129530106",
                              "name": "Duo Popcorn Chicken Rice Bowlz",
                              "category": "RICE BOWLZ",
                              "description": "Save Rs. 30 on aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 2]",
                              "imageId": "30eb3662da29c0e469299b2149aa4600",
                              "inStock": 1,
                              "price": 42857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "FESTIVE PARTY BUCKETS/COMBOS (UPTO 35% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130582886",
                              "name": "Bucket List Meal",
                              "category": "FESTIVE PARTY BUCKETS/COMBOS (UPTO 35% OFF)",
                              "description": "Complete Bucket list with flat Rs. 125 off on 4 Pc Peri Peri Strips, 4 Pc Chicken Leg Piece and a Pepsi PET 475ml [Serves 2]",
                              "imageId": "39686cc350991fb7b34b09bcd64b1c53",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130582885",
                              "name": "Chicken Hamper Bucket",
                              "category": "FESTIVE PARTY BUCKETS/COMBOS (UPTO 35% OFF)",
                              "description": "Rs. 129 off on special Hamper Bucket of 6 Pc Chicken Leg Piece & 6 Pc Peri Peri Chicken Strips [Serves 2]",
                              "imageId": "b373c620d5ae0903c18e9a72c255c06e",
                              "inStock": 1,
                              "price": 79900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130582884",
                              "name": "Jingle Bite Bonanza",
                              "category": "FESTIVE PARTY BUCKETS/COMBOS (UPTO 35% OFF)",
                              "description": "Bonanza savings of Rs 68 on 2 Chicken Zinger Burgers and a Medium Popcorn [Serves 2]",
                              "imageId": "82faa270cbd556b330bb075ad9e86d61",
                              "inStock": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130582883",
                              "name": "Rock & Roll Meal",
                              "category": "FESTIVE PARTY BUCKETS/COMBOS (UPTO 35% OFF)",
                              "description": "Rocking savings Rs. 75 on 2 Classic chicken Roll, 4 Pc Hot Wings and a Pepsi PET 475ml [Serves 1-2]",
                              "imageId": "792218de28cce63f5c76688f84e4d58a",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "KFC BLACK FRIDAY",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101517116",
                              "name": "Chicken Super Snacker Combo",
                              "category": "KFC BLACK FRIDAY",
                              "description": "Best of snacks meal with a Medium Chicken Popcorn, 4 strips, 1 dip & a chilled Pepsi Black [serves 1-2]",
                              "imageId": "xpfkrnzizg80fvytwemn",
                              "inStock": 1,
                              "price": 49333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129343810",
                              "name": "Chicken Wings Combo",
                              "category": "KFC BLACK FRIDAY",
                              "description": "Save Rs. 59 & Enjoy 2pc Hot & Crispy Chicken, 4 chicken wings , 2 dips & a chilled Pepsi Black [serves 1-2]",
                              "imageId": "myzsatoxkzx6lhdgqd1q",
                              "inStock": 1,
                              "price": 46667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129343804",
                              "name": "Chicken Zinger Burger Meal",
                              "category": "KFC BLACK FRIDAY",
                              "description": "Favorite combo of Classic Chicken Zinger Burger, Medium French Fries & a chilled Pepsi Black",
                              "imageId": "ovzvp5tvgxnz9kfoec1m",
                              "inStock": 1,
                              "price": 35524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596613",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101517113",
                              "name": "Chicken Strips Solo Combo",
                              "category": "KFC BLACK FRIDAY",
                              "description": "Go solo with 1 pc Hot & Crispy Chicken, 3 strips, Medium Fries & a chilled Pepsi Black [serves 1]",
                              "imageId": "s62nu52qoowyguynx1ya",
                              "inStock": 1,
                              "price": 45048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129343825",
                              "name": "Solo Chicken Black Combo",
                              "category": "KFC BLACK FRIDAY",
                              "description": "Enjoy solo combo of 1 Hot & Crispy chicken, 2 chicken Hot Wings & a chilled Pepsi Black [Serves 1]",
                              "imageId": "jbwljbqe10jqtq4pbli2",
                              "inStock": 1,
                              "price": 26190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BURGERS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122153760",
                              "name": "Spicy Zinger Burger and Popcorn Meal",
                              "category": "BURGERS",
                              "description": "New Spicy Zinger Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                              "imageId": "6cce1149da3fbc6f78f0857a1863332a",
                              "inStock": 1,
                              "price": 43900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596561",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596563",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596568",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596571",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596574",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122153758",
                              "name": "Zinger Pro Burger & Popcorn Meal",
                              "category": "BURGERS",
                              "description": "New Zinger Pro premium Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                              "imageId": "9b153dffd3829fb695a66e4fd7182b6c",
                              "inStock": 1,
                              "price": 45905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596526",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596532",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596536",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596541",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596544",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122153743",
                              "name": "Spicy Zinger Burger and Chicken Meal",
                              "category": "BURGERS",
                              "description": "New Spicy Zinger Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                              "imageId": "97d830dff091ac86dd037033d9560b01",
                              "inStock": 1,
                              "price": 37900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596502",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596506",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596508",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596510",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122153740",
                              "name": "Zinger Pro Burger",
                              "category": "BURGERS",
                              "description": "Premium burger with crunchy chicken, Mexican Habanero sauce, cheese, tomato & onion",
                              "imageId": "36901b422d759c19c2799c10eeb416c8",
                              "inStock": 1,
                              "price": 23905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596470",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596473",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596479",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596482",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596486",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122153737",
                              "name": "Zinger Pro Burger & Chicken Meal",
                              "category": "BURGERS",
                              "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                              "imageId": "6bafd5f307841d1025401757c7be3521",
                              "inStock": 1,
                              "price": 39905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596459",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007356",
                              "name": "Chicken Burger Buddy Meal",
                              "category": "BURGERS",
                              "description": "Save Rs. 40 & Share 2 Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                              "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                              "inStock": 1,
                              "price": 52857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596356",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007366",
                              "name": "Mixed Chicken Zinger Burger Doubles",
                              "category": "BURGERS",
                              "description": "Save Rs.41 on Best-seller combo of classic chicken Zinger & Tandoori zinger burgers",
                              "imageId": "dd434d7cd80de42b3d04cb979aeacb46",
                              "inStock": 1,
                              "price": 36857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596296",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "174 ratings",
                                  "ratingCountV2": "174"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122227628",
                              "name": "Spicy Zinger Burger",
                              "category": "BURGERS",
                              "description": "Spicy Bun & Spicy chilli sauce with Zinger Fillet, Lettuce, Onion and Tomatoes",
                              "imageId": "e3c645c8b5caa9c1b6374d88709e9e05",
                              "inStock": 1,
                              "price": 21905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596243",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596251",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596256",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596261",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596265",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007364",
                              "name": "Chicken Zinger Burger - Classic",
                              "category": "BURGERS",
                              "description": "Signature chicken burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
                              "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                              "inStock": 1,
                              "price": 19905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596206",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596210",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596214",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596218",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596221",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "587 ratings",
                                  "ratingCountV2": "587"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007354",
                              "name": "Veg Zinger Burger",
                              "category": "BURGERS",
                              "description": "Signature veg burger with crispy patties, veggies & a tangy sauce",
                              "imageId": "a403a55dc5b74cc6acfcfa755f30c165",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596184",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "92 ratings",
                                  "ratingCountV2": "92"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007368",
                              "name": "Chicken Zinger Burger - Tandoori",
                              "category": "BURGERS",
                              "description": "Chicken zinger with a delicious tandoori sauce",
                              "imageId": "af3699168db40a2dbadc372d87338e97",
                              "inStock": 1,
                              "price": 20857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596166",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "256 ratings",
                                  "ratingCountV2": "256"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007385",
                              "name": "2 X Chicken Krisper Burgers",
                              "category": "BURGERS",
                              "description": "2 delicious chicken value burgers - at a deal price",
                              "imageId": "ufzxglygurm6dowpbc2t",
                              "inStock": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596122",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596128",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596136",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596144",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596151",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "239 ratings",
                                  "ratingCountV2": "239"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007376",
                              "name": "2 X Veg Krisper Burgers",
                              "category": "BURGERS",
                              "description": "2 delicious veg value burgers - at a deal price",
                              "imageId": "cvqb24o2vlkd967jzzas",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596094",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596098",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596101",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596102",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113592392",
                              "name": "Peri Peri 10 Pc Chicken Strips & 2 Dips",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                              "description": "Save 24% with the indulging 10 Piece Peri Peri Boneless Strips and 2 Dips [Serves 2-3]",
                              "imageId": "a0feef07b2a9d72ba02f4a7d53e46948",
                              "inStock": 1,
                              "price": 49905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596044",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596053",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596062",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130596072",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124523869",
                              "name": "Peri Peri Chicken 5 Leg Piece & 2 Dips",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                              "description": "Save Rs 120 on 5 Spicy Peri Peri Leg Pieces, paired with 2 delicous dips (20gm each) [serves 2]",
                              "imageId": "561e47ac42b2e426ec03e46d7d09b01b",
                              "inStock": 1,
                              "price": 51905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124523868",
                              "name": "Peri Peri 10 Leg Pc & 4 Dips",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                              "description": "Save Rs. 334 on 10 Spicy Peri Peri Leg Pieces & 4 Dips (20gm each) [serves 3-4]",
                              "imageId": "ye1imbdqn5efc7vheuah",
                              "inStock": 1,
                              "price": 94857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99453569",
                              "name": "Peri Peri Chicken Strips - 6 Pc",
                              "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                              "description": "Save 16% with on savouring 6 Spicy Peri Peri chicken boneless strips [serves 2]",
                              "imageId": "qsmfyjef2hbu05emuu2c",
                              "inStock": 1,
                              "price": 29905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130596024",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67885074",
                              "name": "Chicken Krisper Burger Combo",
                              "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                              "description": "Save Rs. 57 on Deal combo of 2 chicken value burgers, 2 pc Hot & Crispy, 2 dips (20gm each) & a chilled Pepsi PET 475 ml [Serves 1-2]",
                              "imageId": "m038pslx2jfyqgdmlgch",
                              "inStock": 1,
                              "price": 53905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595927",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214690",
                              "name": "Chicken Mingles Bucket Meal",
                              "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                              "description": "Save Rs. 63 on this crowd favorite combo of 4 Hot Wings, 2 Chicken Peri Peri Boneless Strips, a Reg Popcorn, medium fries & a chilled Pepsi PET 475ml [serves 2 ]",
                              "imageId": "kt0vzw4bzztarxnl0wcl",
                              "inStock": 1,
                              "price": 49905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595867",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595874",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595878",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595884",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214592",
                              "name": "Chicken & French Fries Bucket",
                              "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                              "description": "Crowd-favorite combo of 2pc Hot & Crispy Chicken with Medium French Fries",
                              "imageId": "pasdg6owucvi23hcp9eb",
                              "inStock": 1,
                              "price": 29905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595805",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595813",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595820",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595826",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595834",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214590",
                              "name": "Chicken Popcorn & French Fries Bucket",
                              "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                              "description": "Large Chicken Popcorn with Med French Fries - at a deal price",
                              "imageId": "raq6sxtwfb9fvbd6bakq",
                              "inStock": 1,
                              "price": 31905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595743",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595753",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595765",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595775",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66007374",
                              "name": "2 X Veg Krispers Burger Meal",
                              "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                              "description": "Save Rs. 49 with 2 veg value burgers, crispy Medium French Fries & 2 delicious Dips at a deal price! [Serves 1-2]",
                              "imageId": "xdzkcjjgypmjcwhikqae",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595709",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595719",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117826163",
                              "name": "All in One Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Save 24% with variety bucket of 1 Leg Pc, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml [Serves 2-3]",
                              "imageId": "31f899d11feb6a4bc6b3af7815e0f06f",
                              "inStock": 1,
                              "price": 54857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595633",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595646",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595656",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595670",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99453590",
                              "name": "Ultimate Savings Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Savings of 35% on signature bucket of 4pc Hot & crispy chicken, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml [serves 2-3 ]",
                              "imageId": "edbffde0880bbe400d26c5e152a6f088",
                              "inStock": 1,
                              "price": 69905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130680464",
                                  "groupName": "Choose your sides",
                                  "choices": [
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680463",
                                  "groupName": "Choose Your Snack",
                                  "choices": [
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680462",
                                  "groupName": "Choose your beverages",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130680461",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67885079",
                              "name": "Stay Home Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Save 24% & enjoy 4pc Hot & Crispy Chicken, 4 Hot Wings, 6 chicken peri peri boneless strips & 2 delicious dips (20gm each) [serves 3]",
                              "imageId": "nku1xlhmmifu1hxoiugt",
                              "inStock": 1,
                              "price": 79905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214702",
                              "name": "Big 12 - Chicken Bucket",
                              "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                              "description": "Save 26% on 6pc Hot & Crispy Chicken, 6 Hot Wings & 2 dips (20gm each) [serves 2- 3]",
                              "imageId": "yqxxwbdxoaconjcyb7ka",
                              "inStock": 1,
                              "price": 74857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595593",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "CHICKEN ROLLS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955758",
                              "name": "Double Chicken Roll Meal for 2",
                              "category": "CHICKEN ROLLS",
                              "description": "Save Rs. 23 with 2 KFC Double Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [2 units of Double Chicken Roll, Serves 2]",
                              "imageId": "xo2cpzgjtlbdsv3sdzsy",
                              "inStock": 1,
                              "price": 54857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955760",
                              "name": "Classic Chicken Roll Meal for 2",
                              "category": "CHICKEN ROLLS",
                              "description": "2 units of The classic KFC Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [2 units of Classic Chicken Roll, Serves 2]",
                              "imageId": "txepnr2oyy73hfpzxkow",
                              "inStock": 1,
                              "price": 47905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955774",
                              "name": "Double Chicken Roll Meal for 1",
                              "category": "CHICKEN ROLLS",
                              "description": "Save Rs. 24 with a Double Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [1 unit of Double Chicken Roll, Serves 1]",
                              "imageId": "ecbrc7z6vrcrb5d3tfb7",
                              "inStock": 1,
                              "price": 37905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955778",
                              "name": "Classic Chicken Roll Meal for 1",
                              "category": "CHICKEN ROLLS",
                              "description": "Save Rs. 14 on a classic KFC Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [1 unit of Classic Chicken Roll, Serves 1]",
                              "imageId": "lwl1wny7an69glqeu2kt",
                              "inStock": 1,
                              "price": 33905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955754",
                              "name": "2 Double Chicken Rolls",
                              "category": "CHICKEN ROLLS",
                              "description": "2 Double Chicken Roll with double chicken strip filling, layerful parantha onions and two spicy sauce [2 units of Double Chicken Roll, Serves 1-2]",
                              "imageId": "b881c8de97cefa72c822926e43a38d32",
                              "inStock": 1,
                              "price": 32857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595429",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595440",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595445",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595452",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595458",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955756",
                              "name": "2 Classic Chicken Rolls",
                              "category": "CHICKEN ROLLS",
                              "description": "Save Rs. 10 on 2 Street Syle Roll with Layerful parantha, single chicken strip, onions and two spicy sauce [2 units of Classic Chicken Roll, Serves 1-2]",
                              "imageId": "9c67bdcd5218f5b53a858f4665ad0dab",
                              "inStock": 1,
                              "price": 22857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595361",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595366",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595371",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595379",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595388",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955781",
                              "name": "Double Chicken Roll & Pepsi Combo",
                              "category": "CHICKEN ROLLS",
                              "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce & Pepsi PET 475ml [1 unit of Double Chicken Roll, Serves 1]",
                              "imageId": "92f117d2f5163260c533bdb6b03c1ddc",
                              "inStock": 1,
                              "price": 22571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595275",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595279",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595286",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595300",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595313",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955785",
                              "name": "Classic Chicken Roll & Pepsi Combo",
                              "category": "CHICKEN ROLLS",
                              "description": "Street Syle Roll with Layerful parantha, single chicken strip, onions and two spicy sauce & Pepsi PET 475ml [1 units of Classic Chicken Roll, Serves 1]",
                              "imageId": "b97f4414c5b8c2cd098f3f3ca2e9604f",
                              "inStock": 1,
                              "price": 17619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594560",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594565",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594572",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594576",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594583",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955763",
                              "name": "Double Chicken Roll",
                              "category": "CHICKEN ROLLS",
                              "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce [1 unit of Double Chicken Roll, Serves 1]",
                              "imageId": "ebcda29a62123bbf8bb8a33bbe2ab847",
                              "inStock": 1,
                              "price": 16857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594597",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594602",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594608",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594613",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594617",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "VALUE SNACKERS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118353923",
                              "name": "Chicken Longer Burger & 2 Strips Combo",
                              "category": "VALUE SNACKERS",
                              "description": "Longgg burger with crunchy chicken, onions & a punchy sauce , served with 2 peri peri chicken strips",
                              "imageId": "e344aa3aac91a825e9d0d0e3f60eda4b",
                              "inStock": 1,
                              "price": 21905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595210",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595219",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853410",
                                      "name": "Hot & Crispy Chicken - 1 pc",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595227",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595235",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595242",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121921679",
                              "name": "2 X Veg Longer Burger",
                              "category": "VALUE SNACKERS",
                              "description": "The really long burger with Veg Patty, Onion, Lettuce and two sauces",
                              "imageId": "866ef0fcc37944827cf419f6d9783d97",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595172",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113955767",
                              "name": "Classic Chicken Roll",
                              "category": "VALUE SNACKERS",
                              "description": "Street style roll with single chicken strip, onions and two spicy sauce [1 unit of Roll]",
                              "imageId": "ebd8e706049e4fd5ca79ecf708f8ecba",
                              "inStock": 1,
                              "price": 11905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123961481",
                              "name": "2 X Veg Roll",
                              "category": "VALUE SNACKERS",
                              "description": "Try the amazing Veg Roll [2 units of Veg Roll]",
                              "imageId": "f6db48f08a27a8bf10ce1ad5567da0e6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123961482",
                              "name": "Veg Roll Meal",
                              "category": "VALUE SNACKERS",
                              "description": "Deal meal of 2 Veg Rolls, Large Fries and a Pepsi PET 475ml [Serves 1-2]",
                              "imageId": "9d83b7f6273d12556797ab595460dd15",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "HOT & CRISPY CHICKEN, WINGS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214657",
                              "name": "Hot & Crispy Chicken - 8 pcs",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Save Rs. 182 & get 8pc signature Hot & crispy chicken [serves 3-4]",
                              "imageId": "uspplszjphtrwqn1alef",
                              "inStock": 1,
                              "price": 76857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595086",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214666",
                              "name": "Hot & Crispy Chicken - 6 pcs",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Flat 10% off on 6pc signature Hot & crispy chicken [serves 2-3]",
                              "imageId": "ygv0a2rzffhnfgbfajz4",
                              "inStock": 1,
                              "price": 62857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595037",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595045",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595050",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595059",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595063",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214587",
                              "name": "Hot & Crispy Chicken - 4 pcs",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Save Rs. 34 on 4 pc of signature Hot & Crispy Chicken at a deal price",
                              "imageId": "m7q813n17jh4nrhtt7ss",
                              "inStock": 1,
                              "price": 42857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130595024",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "121 ratings",
                                  "ratingCountV2": "121"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214571",
                              "name": "Hot & Crispy Chicken- 2 pcs",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Signature Hot & crispy chicken",
                              "imageId": "n8ictcqllyfu5ojx3oci",
                              "inStock": 1,
                              "price": 22952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594983",
                                  "groupName": "Choose your Sides",
                                  "choices": [
                                    {
                                      "id": "110853449",
                                      "name": "Chicken Popcorn - Large",
                                      "price": 24857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594987",
                                  "groupName": "Choose your Snacks",
                                  "choices": [
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594992",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853443",
                                      "name": "Pepsi Black Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853447",
                                      "name": "7UP Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853434",
                                      "name": "Mirinda Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130594996",
                                  "groupName": "Choose your Dips",
                                  "choices": [
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130595001",
                                  "groupName": "Choose your Desserts",
                                  "choices": [
                                    {
                                      "id": "110853441",
                                      "name": "Coffee Mousse Cake",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853415",
                                      "name": "Chocolate Mud Pie",
                                      "price": 12857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "220 ratings",
                                  "ratingCountV2": "220"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214561",
                              "name": "Hot Chicken Wings - 4 pcs",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Seasoned, signature KFC chicken wings",
                              "imageId": "ubpofq5tlhdgwh2lzo8d",
                              "inStock": 1,
                              "price": 17905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594964",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "387 ratings",
                                  "ratingCountV2": "387"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214559",
                              "name": "Hot & Crispy Chicken - 1 pc",
                              "category": "HOT & CRISPY CHICKEN, WINGS",
                              "description": "Signature Hot & crispy chicken",
                              "imageId": "scl1wyh0yg3saadaakbk",
                              "inStock": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594946",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853436",
                                      "name": "Chicken Popcorn - Medium",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853429",
                                      "name": "Chicken Popcorn - Regular",
                                      "price": 11524,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "101 ratings",
                                  "ratingCountV2": "101"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "BONELESS CHICKEN POPCORN",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214580",
                              "name": "Chicken Popcorn - Large",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Signature bite-sized boneless chicken, with special spices",
                              "imageId": "xwunbsyx5mjosb47pgpi",
                              "inStock": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594934",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "320 ratings",
                                  "ratingCountV2": "320"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214576",
                              "name": "Chicken Popcorn - Medium",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Signature bite-sized boneless chicken, with special spices",
                              "imageId": "vq4hhfaphd4fam2kieqq",
                              "inStock": 1,
                              "price": 16857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594920",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853409",
                                      "name": "Pepsi PET 475ml",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853451",
                                      "name": "Pack of 2 Dips",
                                      "price": 5714,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853426",
                                      "name": "French Fries - Large",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853423",
                                      "name": "Hot Chicken Wings - 4 pcs",
                                      "price": 17905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853452",
                                      "name": "Classic Chicken Roll",
                                      "price": 11905,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "247 ratings",
                                  "ratingCountV2": "247"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214574",
                              "name": "Chicken Popcorn - Regular",
                              "category": "BONELESS CHICKEN POPCORN",
                              "description": "Signature bite-sized boneless chicken, with special spices",
                              "imageId": "xzzsjnmakrosu2i5qatn",
                              "inStock": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130594901",
                                  "groupName": "This goes well with",
                                  "choices": [
                                    {
                                      "id": "110853421",
                                      "name": "Chocolate Lava Cake",
                                      "price": 10857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853411",
                                      "name": "Pepsi Can 300 ml",
                                      "price": 5710,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853454",
                                      "name": "Tandoori Masala Dip",
                                      "price": 2857,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853438",
                                      "name": "French Fries - Medium",
                                      "price": 9905,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853428",
                                      "name": "Hot & Crispy Chicken- 2 pcs",
                                      "price": 22952,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110853418",
                                      "name": "Double Chicken Roll",
                                      "price": 16857,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "198 ratings",
                                  "ratingCountV2": "198"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "SIDES AND DIPS",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125145406",
                              "name": "Chicken Leg Piece - 1 pc",
                              "category": "SIDES AND DIPS",
                              "description": "Crispy Chicken Leg Piece",
                              "imageId": "pss6auktmzkk1iaclhj2",
                              "inStock": 1,
                              "price": 12500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "99453546",
                              "name": "Peri Peri Chicken Strips - 3 pc",
                              "category": "SIDES AND DIPS",
                              "description": "3 Pieces Spicy Peri Peri chicken boneless strips",
                              "inStock": 1,
                              "price": 17905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214549",
                              "name": "2 pc Veg Patty",
                              "category": "SIDES AND DIPS",
                              "description": "Delicious, crispy, veg add-on",
                              "imageId": "v9thnyukkkv47ifzmxfa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214538",
                              "name": "French Fries - Large",
                              "category": "SIDES AND DIPS",
                              "description": "Jazz up your meal with crispy french fries",
                              "imageId": "r93ljtqjnlpn2xr24dln",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214536",
                              "name": "French Fries - Medium",
                              "category": "SIDES AND DIPS",
                              "description": "Jazz up your meal with crispy french fries",
                              "imageId": "n4ry9mep4uisjri10uqp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "168 ratings",
                                  "ratingCountV2": "168"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214543",
                              "name": "Pack of 4 Dips",
                              "category": "SIDES AND DIPS",
                              "description": "Adding dips is always a good idea! (Save Rs. 5)",
                              "imageId": "gvtc5ybblsammx3nemfo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214540",
                              "name": "Pack of 2 Dips",
                              "category": "SIDES AND DIPS",
                              "description": "Adding dips is always a good idea!",
                              "imageId": "yblqo1sys6x3sdszulqq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "40% OFF",
                                  "subTitle": "USE SWIGGYIT",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214546",
                              "name": "Tandoori Masala Dip",
                              "category": "SIDES AND DIPS",
                              "description": "Special tandoori flavor dip to add a twist to your meal",
                              "imageId": "icpcqoet1ssvzkvd4g3m",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95812036",
                              "name": "Nashville Hot Pepper Sauce Bottle",
                              "category": "SIDES AND DIPS",
                              "description": "Nashville in a bottle! Our signature hot, peppery sauce which pairs well with all things KFC.",
                              "imageId": "vjpd4gm5eowrmer0hhqm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95812035",
                              "name": "Dynamite Spicy Mayo Sauce Bottle",
                              "category": "SIDES AND DIPS",
                              "description": "Spicy, punchy mayo?bottled up just for you & your favorite KFC! Our signature launch.",
                              "imageId": "yjplgscd126mummkpfm6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "DESSERTS & BEVERAGES",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100871762",
                              "name": "Chocolate Lava Cake",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "New Soft Chocolate cake with a gooey center- perfect chocolaty end to every meal",
                              "imageId": "thb7rrdooctsnknsnatz",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69509461",
                              "name": "Chocolate Mud Pie",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Chocolate lovers unite! Say hello to our delicious, new, creamy chocolate & cake dessert- a must try!",
                              "imageId": "fhtrvjerl7l2ck1crwhp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69509462",
                              "name": "Coffee Mousse Cake",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Coffee, chocolate, cake?what's not to love? Enjoy our delicious, new dessert for those coffee-licious temptations!",
                              "imageId": "cb0kmlqdl0kjiri0qii9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65214534",
                              "name": "Pepsi PET 475ml",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                              "imageId": "ibrkax41b0rltgjvb0k1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "141 ratings",
                                  "ratingCountV2": "141"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115060810",
                              "name": "Pepsi Can 300 ml",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                              "imageId": "zzsh8emh9fz3v2puiijd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5710,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115060807",
                              "name": "7UP Can 300 ml",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "7UP is the ultimate Super-Duper Refresher. Every sip of this crisp lemon flavour refreshes you to the core.",
                              "imageId": "qn00mdssgatf9yjauq8o",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5710,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115060805",
                              "name": "Pepsi Black Can 300 ml",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Enjoy Pepsi Black to make your food rise up to max levels of awesome with Zero sugar and Zero guilt!",
                              "imageId": "rop9dooensk8zq97ssqj",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5710,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115060801",
                              "name": "Mirinda Can 300 ml",
                              "category": "DESSERTS & BEVERAGES",
                              "description": "Great orange taste and sparking bubbles encourage you to be carefree, spontaneous and playful!",
                              "imageId": "zcwmo9x7sbvhehuz59td",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5710,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220333002024"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "KFC",
                      "area": "Vasanth Nagar",
                      "completeAddress": "19/3, BMS Pladium, SRT Road,Formerly Cunningham Road,Vasanth Nagar. Bangalore-560052."
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "bTxzVQZOSumB-vaKei5OtyC-o-woYMfqa5P2GVg4"
},
// 20240105233237
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=43836&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "43836",
              "name": "McDonald's",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "mcdonalds-kasturba-road-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "bb7ae131544c7d37e10fc5faf76f09d6",
              "locality": "MG Road",
              "areaName": "Ashok Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Burgers",
                "Beverages"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "43836",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.6 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "630",
              "avgRatingString": "4.3",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "43836",
                "deliveryTime": 27,
                "minDeliveryTime": 27,
                "maxDeliveryTime": 27,
                "lastMileTravel": 0.7,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "27 MINS",
                "lastMileTravelString": "0.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 02:45:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "20% off",
                "shortDescriptionList": [
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "mcdonalds-kasturba-road-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Burgers,Beverages"
                }
              ],
              "logo": "ygzpacvdpquemhj77imr",
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "20% off",
                "shortDescriptionList": [
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 700,
                  "maxValue": 1000,
                  "priority": -60,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 10
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 10% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 10% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/43836"
              },
              "expectationNotifiers": [
                {
                  "text": "0.6 kms | ₹38 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>0.6 kms</b> | ₹38 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.97565719,77.59843376",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹50",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "7ab56c10-98dd-4b79-9398-08e412019ed9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 10% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "7a2991e1-0069-473e-ac1e-5730ddf6fb8b"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹1000",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "20% OFF"
                        }
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1411146",
                          "creativeId": "TopPicks/5pMcSpFChicBu",
                          "title": "5 pcs McSpicy Fried Chicken Bucket",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "119984440",
                              "name": "5 pcs McSpicy Fried Chicken Bucket",
                              "category": "Fried Chicken & Wings",
                              "description": "Share your love for chicken with the Friendship box: 5 pcs McSpicy Fried chicken",
                              "imageId": "5ceceaea3e7052d91c7d87ddd2b65804",
                              "inStock": 1,
                              "price": 42476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1411347",
                          "creativeId": "TopPicks/McSChzCM",
                          "title": "McSaver Cheesy Italian Chicken Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "126294849",
                              "name": "McSaver Cheesy Italian Chicken Meal",
                              "category": "Meals",
                              "description": "Indulge in a cheesy experience with our Cheesy Italian Chicken Burger Meal. Enjoy Cheesy Italian Chicken Burger+ Fries(M)+ Coke (M)",
                              "imageId": "9a868c42f75143f0620d751f89c5b6ee",
                              "inStock": 1,
                              "price": 32762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278644",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278645",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301830",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1411518",
                          "creativeId": "TopPicks/2McChBuFr2C",
                          "title": "2 McChicken Burger + Fries (L) + 2 Coke",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "118027863",
                              "name": "2 McChicken Burger + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McChicken Burger + Fries (L) + 2 Coke",
                              "imageId": "e33dc60f9e7af336efeea5b9fd59a24f",
                              "inStock": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278744",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1411635",
                          "creativeId": "TopPicks/McSMcSpCM",
                          "title": "McSaver McSpicy Chicken Meal",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "58150212",
                              "name": "McSaver McSpicy Chicken Meal",
                              "category": "Meals",
                              "description": "Scrumptiously filling McSpicy Chicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "9b586c092f1c790228ac2198cf111bfd",
                              "inStock": 1,
                              "price": 36476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278639",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278640",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301789",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1411656",
                          "creativeId": "TopPicks/McVB2FriMcAl",
                          "title": "McVeggie Burger + 2 Fries (M) + McAloo Tikki+ Veg Pizza McPuff",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "117965859",
                              "name": "McVeggie Burger + 2 Fries (M) + McAloo Tikki+ Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                              "imageId": "2bb4b3cae53b1a6739aaf769ce2b3364",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Party Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "52431077",
                              "name": "2 McAloo Tikki + 2 Fries (L)",
                              "category": "Party Combo",
                              "description": "Stay home, stay safe and share a combo- 2 McAloo Tikki Burgers + 2 Fries (L)",
                              "imageId": "ea7ba594c7d77cb752de9a730fbcb3bf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149161",
                              "name": "6 Pc Nuggets + McChicken + Coke",
                              "category": "Party Combo",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with 6 Pc Nuggets and Coke.",
                              "imageId": "934194567f9c231dc46dccf2d4e6d415",
                              "inStock": 1,
                              "price": 32953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301749",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301753",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "142 ratings",
                                  "ratingCountV2": "142"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107203",
                              "name": "McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                              "category": "Party Combo",
                              "description": "Flat 15% Off on McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                              "imageId": "630a62321ae747b1c3a60a550387c84b",
                              "inStock": 1,
                              "price": 37524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713361",
                              "name": "Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                              "category": "Party Combo",
                              "description": "Flat 15% Off on Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                              "imageId": "a6fae39f2d1210d4746ffb3b5cc474f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965851",
                              "name": "2 McChicken Burger\t + 2 Fries (M)\t + Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McChicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "b57153898abed2127d7217c2ee3e9e4b",
                              "inStock": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965852",
                              "name": "2 McSpicy Chicken Burger  + 2 Fries (M)  + Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McSpicy Chicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "e62aea3ba1cd5585a76004f59cd991e5",
                              "inStock": 1,
                              "price": 49048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965853",
                              "name": "2 McVeggie Burger\t + 2 Fries (M)\t \t+ Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McVeggie Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "1ff73fc5aa656a10da5801469da3327a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965857",
                              "name": "McSpicy Fried Chicken - 2 Pc + 2 Fries (M)\t \t+ McSpicy Chicken Burger",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Fried Chicken - 2 Pc + 2 Fries (M) + McSpicy Chicken Burger",
                              "imageId": "311067fe96ac784c00f029acf458afaf",
                              "inStock": 1,
                              "price": 43905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965858",
                              "name": "McSpicy Paneer Burger + 2 Fries M + McAloo Tikki + Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger  + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                              "imageId": "0ea8a2fddbbc17bc6239a9104963a3e8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965859",
                              "name": "McVeggie Burger + 2 Fries (M) + McAloo Tikki+ Veg Pizza McPuff",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                              "imageId": "2bb4b3cae53b1a6739aaf769ce2b3364",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027863",
                              "name": "2 McChicken Burger + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McChicken Burger + Fries (L) + 2 Coke",
                              "imageId": "e33dc60f9e7af336efeea5b9fd59a24f",
                              "inStock": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278744",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027865",
                              "name": "2 McSpicy Chicken Burger + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McSpicy Chicken Burger + Fries (L) + 2 Coke",
                              "imageId": "98afaf26d81b15bec74cc356fe60cc13",
                              "inStock": 1,
                              "price": 48953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278732",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027868",
                              "name": "2 McVeggie Burger + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McVeggie Burger + Fries (L) + 2 Coke",
                              "imageId": "09b3cb6130cfae15d486223c313fb6c6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301803",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027870",
                              "name": "McSpicy Paneer Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "imageId": "642ae100416c13ce1c4c2d61c44026a1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301781",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027875",
                              "name": "McVeggie Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "imageId": "d2381b84780fb273c2e7b868410a22cc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33715,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301420",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193870",
                              "name": "2 Chicken Maharaja Mac + 2 Coke + Fries (L) + McFlurry Oreo (M)",
                              "category": "Party Combo",
                              "description": "Enjoy 2 of the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalapeno, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce. Served with Coke, Large Fries and a medium McFlurry Oreo",
                              "imageId": "65c9c9b82c4d1f77a05dc4d89c9ead1d",
                              "inStock": 1,
                              "price": 59334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301675",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284323",
                              "name": "2 Corn and Cheese Burger + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 Corn and Cheese Burger + Fries (L)  + 2 Coke",
                              "imageId": "847b562672e71c2352d92b797c0b0a4e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301444",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284324",
                              "name": "2 Grilled Chicken and Cheese Burger + Fries (L) \t+ 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 Grilled Chicken and Cheese Burger + Fries (L)  + 2 Coke",
                              "imageId": "1166a8baa3066342affb829ef0c428dd",
                              "inStock": 1,
                              "price": 46953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278669",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284325",
                              "name": "2 McCheese Burger Chicken + Fries (L)  + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McCheese Burger Chicken (with New Italian Herb Bun) + Fries (L)  + 2 Coke",
                              "imageId": "349b4231339017baacc1295fddc25d3a",
                              "inStock": 1,
                              "price": 64858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301433",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284326",
                              "name": "2 McCheese Burger Veg + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 McCheese Burger Veg (with New Italian Herb Bun) + Fries (L)  + 2 Coke",
                              "imageId": "00437a0cd5b8108edac144a768947f4d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 61905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301625",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294821",
                              "name": "2 Cheesy Italian Chicken + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 Cheesy Italian Chicken  + Fries (L) + 2 Coke",
                              "imageId": "26babffe86dd4dbbbdee5066b2533471",
                              "inStock": 1,
                              "price": 52858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301844",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294826",
                              "name": "2 Cheesy Italian Veg + Fries (L) + 2 Coke",
                              "category": "Party Combo",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - 2 Cheesy Italian Veg  + Fries (L)  + 2 Coke",
                              "imageId": "1b95a56794338bde12bd74fff695eba9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301475",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127403057",
                              "name": "Chicken Nuggets Bucket – 27 Pc",
                              "category": "Party Combo",
                              "description": "Enjoy a winning combination of 25 pc Chicken Nuggets along with Piri Piri Mix, Tangy Pepper Dip and Sweet Chilli Dip.",
                              "imageId": "d37fa65a71c8885b463e5b2d6455bc24",
                              "inStock": 1,
                              "price": 57048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127403058",
                              "name": "Fries Bucket",
                              "category": "Party Combo",
                              "description": "Indulge in the ultimate matchday snack with our Fries Bucket! A jumbo serving of fries along with Piri Piri Mix, Tangy Pepper Dip and Sweet Chilli Dip.",
                              "imageId": "22fa7889d5fa91c14f52a1ecc09770c3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Jain Friendly",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965854",
                              "name": "Jain Meal - McCheese Burger Veg",
                              "category": "Jain Friendly",
                              "description": "Enjoy a combo of the Jain friendly, McCheese Burger Veg(now with New Italian herb bun), Classic corn, Cheesy Dip, McFlurry Oreo (Small) with a beverage of your choice in a delivery friendly, resuable bottle.",
                              "imageId": "ed9f453426748ddc136bb7eaf6113d46",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278662",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125370267",
                              "name": "McCheese Burger Veg",
                              "category": "Jain Friendly",
                              "description": "The Delicious McCheese Burger Veg (now with New Italian herb bun), is a burger with sinfully oozing cheesy veg patty , roasted chipotle sauce, Jalapenos & Lettuce.",
                              "imageId": "72c73e65ff60eeea758b7aa93093f08b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125370276",
                              "name": "Classic Cheesy Dip-",
                              "category": "Jain Friendly",
                              "description": "A delicious cheesy dip, now Jain Friendly, goes well with your favourite burgers and sides.",
                              "imageId": "3387bf47379d00478c9a95d481305708",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fried Chicken & Wings",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "52364329",
                              "name": "McSpicy Fried Chicken - 1 PC",
                              "category": "Fried Chicken & Wings",
                              "description": "Try the new McSpicy Fried chicken that is juicy, crunchy and spicy to the last bite!",
                              "imageId": "18cdeabc815b748622911259c3b7df1d",
                              "inStock": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713376",
                              "name": "2 PC Mcspicy Fried chicken",
                              "category": "Fried Chicken & Wings",
                              "description": "Two pieces of the new McSpicy Fried chicken that are juicy, crunchy and spicy to the last bite!",
                              "imageId": "fcbc9e5bc45ebf0fde9ac2da44032035",
                              "inStock": 1,
                              "price": 22762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713380",
                              "name": "5 pc of McSpicy Fried chicken Bucket + 2 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 5 pc of McSpicy Fried chicken + 2 Coke - perfect sharing meal for a party!",
                              "imageId": "54bafa953686424e5af0f9a0a20ef1c9",
                              "inStock": 1,
                              "price": 53334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301527",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119984440",
                              "name": "5 pcs McSpicy Fried Chicken Bucket",
                              "category": "Fried Chicken & Wings",
                              "description": "Share your love for chicken with the Friendship box: 5 pcs McSpicy Fried chicken",
                              "imageId": "5ceceaea3e7052d91c7d87ddd2b65804",
                              "inStock": 1,
                              "price": 42476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972272",
                              "name": "4 pcs McSpicy Fried chicken Bucket + 1 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Share your love for chicken with the Duet box: 4 pcs McSpicy Fried chicken + 1 coke",
                              "imageId": "77ce9851cf897e3d82779977a4848c08",
                              "inStock": 1,
                              "price": 47619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301477",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972273",
                              "name": "McSpicy Fried Chicken 10 Pc Bucket + 2 Fries (L) + 4 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy McSpicy Fried Chicken 10 Pc + 2 Fries (L) + 4 Coke - perfect sharing meal for a party",
                              "imageId": "225d73dc44b15869fe737798a154fba7",
                              "inStock": 1,
                              "price": 123906,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301578",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972274",
                              "name": "3 pc of McSpicy Fried chicken Bucket + 2 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 3 pc of McSpicy Fried chicken + 2 Coke - perfect sharing meal for a catchup!",
                              "imageId": "e8523cbe88496b99f299c8eb7b137059",
                              "inStock": 1,
                              "price": 38001,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301596",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128073128",
                              "name": "McSpicy Fried Chicken 2 Pc + McSpicy Chicken Wings- 4 Pc + 2 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy McSpicy Fried Chicken 2 Pc + McSpicy Chicken Wings- 4 Pc + 2 Coke - perfect sharing meal for your catchup",
                              "imageId": "955ba09d332205cbd6607e86f0986fe4",
                              "inStock": 1,
                              "price": 41905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301487",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers & Wraps",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102328224",
                              "name": "McCheese Burger Veg-",
                              "category": "Burgers & Wraps",
                              "description": "The Delicious McCheese Burger Veg (now with New Italian herb bun), is a burger with sinfully oozing cheesy veg patty , roasted chipotle sauce, Jalapenos & Lettuce.",
                              "imageId": "72c73e65ff60eeea758b7aa93093f08b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57683215",
                              "name": "Veg Maharaja Mac",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy the tallest burgers innovated by us. Created with perfectly fried corn and cheese patty paired along with fresh ingredients like jalape??o, onion, slice of cheese & crunchy lettuce dressed with cocktail sauce.",
                              "imageId": "7a248018e36c112eb3fb0b877b4b06f2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "212 ratings",
                                  "ratingCountV2": "212"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150140",
                              "name": "McAloo Tikki Burger",
                              "category": "Burgers & Wraps",
                              "description": "The World's favourite Indian burger! Crunchy potato and peas patty with delicious Tom Mayo & crunchy onions",
                              "imageId": "b13811eeee71e578bc6ca89eca0ec87f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "723 ratings",
                                  "ratingCountV2": "723"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150150",
                              "name": "McVeggie Burger",
                              "category": "Burgers & Wraps",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns.",
                              "imageId": "a25f25f74a6a6068e55fcbced1580084",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "755 ratings",
                                  "ratingCountV2": "755"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150153",
                              "name": "McSpicy Paneer Burger",
                              "category": "Burgers & Wraps",
                              "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more.",
                              "imageId": "ad20daa26b978ebff5d08572cb6cca7f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "515 ratings",
                                  "ratingCountV2": "515"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150167",
                              "name": "McSpicy Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more.",
                              "imageId": "12b045b7fd1d82b15ebde45b778e22b8",
                              "inStock": 1,
                              "price": 20857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1008 ratings",
                                  "ratingCountV2": "1008"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150206",
                              "name": "McChicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite.",
                              "imageId": "51352086abd3efaaef530188aec16631",
                              "inStock": 1,
                              "price": 14095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "924 ratings",
                                  "ratingCountV2": "924"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150207",
                              "name": "Big Spicy Paneer Wrap",
                              "category": "Burgers & Wraps",
                              "description": "Rich & filling cottage cheese patty coated in spicy crispy batter, topped with tom mayo sauce wrapped with lettuce, onions, tomatoes & cheese",
                              "imageId": "4ec1d2575e44cbb24d345eb14a9ac9bd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "204 ratings",
                                  "ratingCountV2": "204"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150213",
                              "name": "Grilled Chicken & Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "Earlier known as American Cheese Supreme Chicken, this is a burger with grilled chicken patty covered with a slice of cheese, a dollop of spicy habanero sauce, jalapenos and shredded onions",
                              "imageId": "3730f0236ea8c484d5fb8a3918085f81",
                              "inStock": 1,
                              "price": 16857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "162 ratings",
                                  "ratingCountV2": "162"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150224",
                              "name": "Chicken Kebab Burger",
                              "category": "Burgers & Wraps",
                              "description": "A flavourful chicken kebab patty combined with tangy rassam sauce and shredded onions, laid on a perfectly grilled butter naan",
                              "imageId": "f8287bf0bd1f1dacc6504b799dc84029",
                              "inStock": 1,
                              "price": 11238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "193 ratings",
                                  "ratingCountV2": "193"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150227",
                              "name": "Corn & Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "Earlier known as American Cheese Supreme Veg, this is a burger with crispy corn & cheese patty, covered with a slice of cheese, creamy cocktail sauce, jalapenos and shredded onions",
                              "imageId": "28d4d94291cf9d70f5f559d1dfa46252",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "153 ratings",
                                  "ratingCountV2": "153"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150228",
                              "name": "Big Spicy Chicken Wrap",
                              "category": "Burgers & Wraps",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter, topped with a creamy sauce, wrapped with lettuce, onions, tomatoes & seasoning and cheese. A BIG indulgence.",
                              "imageId": "737764ba52f5827e75486b71c9f74330",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "320 ratings",
                                  "ratingCountV2": "320"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150234",
                              "name": "Mexican McAloo Tikki Burger",
                              "category": "Burgers & Wraps",
                              "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce",
                              "imageId": "167aeccf27bab14940fa646c8328b1b4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "477 ratings",
                                  "ratingCountV2": "477"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553380",
                              "name": "Masala McEgg Burger",
                              "category": "Burgers & Wraps",
                              "description": "Steamed egg patty loaded with crunchy onion, habanero sauce sandwiched between toasted buns.",
                              "imageId": "265c57f68b1a52f1cc4b63acf082d611",
                              "inStock": 1,
                              "price": 6952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576214",
                              "name": "McCheese Burger Chicken",
                              "category": "Burgers & Wraps",
                              "description": "The Delicious McCheese Burger Chicken (now with New Italian herb bun), is a burger with sinfully oozing cheesy veg patty and Flame grilled Chicken patty, roasted chipotle sauce, shredded onion,Jalapenos & Lettuce.",
                              "imageId": "ddb3fa173ee67c823c290b31de2b627f",
                              "inStock": 1,
                              "price": 28095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576221",
                              "name": "McSpicy Premium Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "A spicy Chicken patty, shredded Lettuce topped with Jalapenos and Cheese slice, Spicy Habanero sauce & Cheese sauce layered between toasted Whole Wheat Buns.",
                              "imageId": "5d71415c768b5ff868684a6818bf7242",
                              "inStock": 1,
                              "price": 26000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576226",
                              "name": "McSpicy Premium Veg Burger",
                              "category": "Burgers & Wraps",
                              "description": "A spicy Paneer patty, shredded Lettuce topped with Jalapenos and Cheese slice, Spicy Cocktail sauce & Cheese sauce layered between toasted Whole Wheat Buns.",
                              "imageId": "82609174cf229436f977e6f73f964e6d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713347",
                              "name": "Chicken Maharaja Mac",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalape??o, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce.",
                              "imageId": "aaaecb696882cdb7ebaad35464b26d94",
                              "inStock": 1,
                              "price": 25429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "291 ratings",
                                  "ratingCountV2": "291"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294831",
                              "name": "Cheesy Italian Chicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Indulge in a cheesy experience with our Cheesy Italian Chicken Burger. Flame Grilled Chicken Patty encased in a perfectly toasted Focaccia Bun, paired with Tomato Slices, Flavoured Cheese Slice and Tomato Cheese Sauce.",
                              "imageId": "b88c5f5a1a6c9a009c2c4ce9e6df8104",
                              "inStock": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294832",
                              "name": "Cheesy Italian Veg Burger",
                              "category": "Burgers & Wraps",
                              "description": "Indulge in a cheesy experience with our Cheesy Italian Veg Burger. Corn n Cheese Patty encased in a perfectly toasted Focaccia Bun, paired with Tomato Slices, Flavoured Cheese Slice and Tomato Cheese Sauce.",
                              "imageId": "c71d4735ce5f3d571ae01648409abd50",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121242175",
                              "name": "McSaver Piri Piri McSpicy Paneer Burger Meal",
                              "category": "Meals",
                              "description": "The iconic McSpicy burger meal but now with a Piri Piri Twist! Enjoy a delicious, filling meal of Piri Piri McSpicy Paneer Burger (No onion and No garlic) ! Spicy paneer patty, Piri Piri creamy sauce and crunchy lettuce come together on sesame buns+ Coke +Fries (M) with this meal.",
                              "imageId": "c03151591a3d7d79d1da063e984eec03",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278641",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150212",
                              "name": "McSaver McSpicy Chicken Meal",
                              "category": "Meals",
                              "description": "Scrumptiously filling McSpicy Chicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "9b586c092f1c790228ac2198cf111bfd",
                              "inStock": 1,
                              "price": 36476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278639",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278640",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301789",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "382 ratings",
                                  "ratingCountV2": "382"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150217",
                              "name": "McSaver Chicken Kebab Burger Meal",
                              "category": "Meals",
                              "description": "Relish on a juicy Chicken Kebab Burger + Fries (M) + Drink of your Choice on this meal. Order now to experience a customizable, delicious meal.",
                              "imageId": "b22592af2edd8c7046fcc74d10a66ace",
                              "inStock": 1,
                              "price": 26381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278688",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278689",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301566",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150229",
                              "name": "McSaver Veg Maharaja Mac Meal",
                              "category": "Meals",
                              "description": "Enjoy a double decker Veg Maharaja Mac+ Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "6180c6720b3e29c715f1cb497cf8cdb2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278646",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278647",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301427",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150233",
                              "name": "McSaver Big Spicy Chicken Wrap Meal",
                              "category": "Meals",
                              "description": "Treat yourself with a Big Spicy Chicken Wrap + Fries (M) + Drink of your choice.",
                              "imageId": "33b121efe5444bc8e05bd9db8f92297e",
                              "inStock": 1,
                              "price": 40476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278658",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278659",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301836",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "125 ratings",
                                  "ratingCountV2": "125"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150235",
                              "name": "McSaver McVeggie Meal",
                              "category": "Meals",
                              "description": "Enjoy a combo of McVeggie + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal. Save Rs.50 on this Meal.",
                              "imageId": "7c6d604e19903a0f0a9f2b0f3adf8e4d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278637",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278638",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301776",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "178 ratings",
                                  "ratingCountV2": "178"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150236",
                              "name": "McSaver Chicken Maharaja Mac Meal",
                              "category": "Meals",
                              "description": "Enjoy a double decker Chicken Maharaja Mac + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "cb8b1b3aabcfc5b0a5bcb3b2376fe024",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278664",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278665",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301491",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "224 ratings",
                                  "ratingCountV2": "224"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150237",
                              "name": "McSaver Big Spicy Paneer Wrap Meal",
                              "category": "Meals",
                              "description": "Treat yourself to a Big Spicy Paneer Wrap + Fries (M) + Drink of your Choice Order now to experience a customizable, delicious meal",
                              "imageId": "e15ef5d9e92af31163b508b71554c902",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278642",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278643",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301797",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150241",
                              "name": "McSaver McSpicy Paneer Meal",
                              "category": "Meals",
                              "description": "Enjoy a crispy McSpicy Paneer Burger + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal. Save Rs.50 on this Meal.",
                              "imageId": "07b51f7717dceffee5bbcdfe006129e1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278709",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278711",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301458",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "151 ratings",
                                  "ratingCountV2": "151"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150242",
                              "name": "McSaver McChicken Meal",
                              "category": "Meals",
                              "description": "Your favorite McChicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "de305cbe78c2ce5241a3c575c1fd49fe",
                              "inStock": 1,
                              "price": 30476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301638",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278692",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301643",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "202 ratings",
                                  "ratingCountV2": "202"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60385945",
                              "name": "McSaver Chicken McNuggets 9 Pcs Meal",
                              "category": "Meals",
                              "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                              "imageId": "4c56f086e500afe6b2025f9c46846e12",
                              "inStock": 1,
                              "price": 38001,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278650",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278651",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60386057",
                              "name": "McSaver Chicken McNuggets 6 Pcs Meal",
                              "category": "Meals",
                              "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                              "imageId": "6e7f9411ed67fe8d8873734af1e8d4e9",
                              "inStock": 1,
                              "price": 34858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278698",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278699",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60740886",
                              "name": "McSaver Mexican McAloo Tikki Meal",
                              "category": "Meals",
                              "description": "Enjoy a combo of Mexican McAloo Tikki + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "0140c49c7274cdb6af08053af1e6cc20",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278652",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278654",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301600",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.9",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553370",
                              "name": "McSaver Masala McEgg Meal",
                              "category": "Meals",
                              "description": "Enjoy a combo of Masala McEgg + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "4f474c833930fa31d08ad2feed3414d8",
                              "inStock": 1,
                              "price": 22667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278735",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278737",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301612",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576224",
                              "name": "McSaver McSpicy Premium Chicken Meal",
                              "category": "Meals",
                              "description": "A deliciously filling meal of McSpicy Premium Chicken Burger + Fries (M) + Drink of your choice",
                              "imageId": "2b5160beab7e8e724691a337806f91a1",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278670",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278671",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301521",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576228",
                              "name": "McSaver McSpicy Premium Veg Meal",
                              "category": "Meals",
                              "description": "A deliciously filling meal of McSpicy Premium Veg Burger + Fries (M) + Drink of your choice",
                              "imageId": "187f757d74110fce6fe220884f16db6b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278678",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278681",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301825",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100815471",
                              "name": "McSaver McCheese Burger Chicken Meal",
                              "category": "Meals",
                              "description": "Enjoy a deliciously filling meal of McCheese Chicken Burger (now with New Italian Herb Bun) + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                              "imageId": "af76d5949ca8799a5b17efae3ba35080",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278672",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278674",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301700",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713511",
                              "name": "McSaver McCheese Burger Veg Meal",
                              "category": "Meals",
                              "description": "Enjoy a deliciously filling meal of McCheese Veg Burger (now with New Italian Herb Bun) + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                              "imageId": "11068ba505d6c435d4789c5aa6b3146b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278752",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278755",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301484",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128753",
                              "name": "McSaver Corn & Cheese Burger Meal",
                              "category": "Meals",
                              "description": "Enjoy a combo of Corn & Cheese Burger + Fries (M) + Coke on this meal. Order now to experience a customizable, delicious meal.",
                              "imageId": "22b35abf6e86af245205741bfcadc4e6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278705",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278707",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301470",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "43 ratings",
                                  "ratingCountV2": "43"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128756",
                              "name": "McSaver Grilled Chicken & Cheese Burger Meal",
                              "category": "Meals",
                              "description": "Enjoy a combo of Grilled Chicken & Cheese Burger + Fries (M) + Coke on this meal. Order now to experience a customizable, delicious meal.",
                              "imageId": "f8cce046c346f5a88af05de353dbac6a",
                              "inStock": 1,
                              "price": 32000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278648",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278649",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301720",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128759",
                              "name": "McSaver McAloo Tikki Meal",
                              "category": "Meals",
                              "description": "Enjoy a delicious meal of McAloo Tikki Burger + Fries (M) + Beverage of your choice in a new, delivery friendly, reusable bottle.",
                              "imageId": "b03a3ad7212fca0da40e90eed372ced9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301724",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278722",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301726",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193894",
                              "name": "McSaver Mcspicy Fried Chicken Meal.",
                              "category": "Meals",
                              "description": "Enjoy the new McSpicy Fried chicken + Fries (M) + Drink of your choice",
                              "imageId": "2bc1f7542c53c75ee548e5bdd5061742",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106302970",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294849",
                              "name": "McSaver Cheesy Italian Chicken Meal",
                              "category": "Meals",
                              "description": "Indulge in a cheesy experience with our Cheesy Italian Chicken Burger Meal. Enjoy Cheesy Italian Chicken Burger+ Fries(M)+ Coke (M)",
                              "imageId": "9a868c42f75143f0620d751f89c5b6ee",
                              "inStock": 1,
                              "price": 32762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278644",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278645",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301830",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294853",
                              "name": "McSaver Cheesy Italian Veg Meal",
                              "category": "Meals",
                              "description": "Indulge in a cheesy experience with our Cheesy Italian Veg Burger Meal. Enjoy Cheesy Italian Veg Burger+ Fries(M)+ Coke (M)",
                              "imageId": "3d5631f06b12f0e112175aa5da1128c3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278655",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278656",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo Small",
                                      "price": 9100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044251",
                                      "name": "KitKat McFlurry with Brownie (Reg)",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301453",
                                  "groupName": "Choose an option for Fries (M)",
                                  "choices": [
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheesy Fries",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047291",
                                      "name": "Fries (L)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047290",
                                      "name": "Cheesy Veg Nuggets – 9 pcs ",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Coffee & Beverages (Hot and Cold)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68302584",
                              "name": "Coke",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect companion to your burger, fries and everything nice.",
                              "imageId": "a1afed29afd8a2433b25cc47b83d01da",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68962005",
                              "name": "Coke zero can",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect diet companion to your burger, fries and everything nice. Regular serving size, 300 Ml.",
                              "imageId": "8d6a37c4fc69bceb66b6a66690097190",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "52 ratings",
                                  "ratingCountV2": "52"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69017952",
                              "name": "Vedica Zen Water Bottle",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Quench your thirst with the Vedica Zen Water Bottle",
                              "imageId": "6da8fa6b64c806e89058c87c0a85e759",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69678412",
                              "name": "Fanta",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Add a zest of refreshing orange to your meal.",
                              "imageId": "7d662c96bc13c4ac33cea70c691f7f28",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479525",
                              "name": "Mixed Fruit Beverage",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Made with puree, pulp & juice from 6 delicious fruits",
                              "imageId": "8e455d39bbbd8e4107b2099da51f3933",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83840289",
                              "name": "Sprite",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect companion to your burger, fries and everything nice.",
                              "imageId": "46e03daf797857bfbce9f9fbb539a6aa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620458",
                              "name": "American Mud Pie",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A classic American Mud Pie gets a makeover; wonderfully creamy and rich with Chocolate, this shake is more delicious than it sounds! Now in a ne, convenient and delivery friendly packaging",
                              "imageId": "d05081a8a351a3b137bf4db4d003a73c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620501",
                              "name": "Green Apple Chiller",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A perfect blend of aromatic teas, infused with green apple flavour .Now in a new, convenient and delivery friendly packaging",
                              "imageId": "54243043b1b31fa715f38e6998a63e93",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620507",
                              "name": "Mango Smoothie",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A delicious mix of mangoes, soft serve mix and blended ice .Now in a new, convenient and delivery friendly packaging",
                              "imageId": "fcc7bdd67c518672de72c0eb9d7221dd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620515",
                              "name": "McCafe-Chocolate Frappe",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing sweet treat made from chocolate sauce and Oreo cookie pieces which is blended with ice and garnished with whipped cream. Now in a new, convenient and delivery friendly packaging",
                              "imageId": "58e19527263a4bf3bbbac4befb924120",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620573",
                              "name": "Mixed Berry Smoothie",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A delectable mix of mixed berries, blended together with our creamy soft serve. Now in a new, convenient and delivery friendly packaging",
                              "imageId": "ecf495ca2b581c194ace5c8e6fb30288",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713377",
                              "name": "English Breakfast",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Relax. It's your time to enjoy a long, slow sip of delicious and delectable english breakfast tea",
                              "imageId": "6333ac2ebe823a20cad586c0cd397b16",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713379",
                              "name": "Flat White",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Our signature McCaf?? espresso made with 100% Arabica beans, blended with steamed and slightly frothed 100% real milk.",
                              "imageId": "562cb96c1de1c6f650daab676cf8dc8a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713394",
                              "name": "Hot Chocolate (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Sinful chocolate whisked with silky steamed milk and topped with an even sweeter touch of chocolate.",
                              "imageId": "491e836e6a114d9e3d4e5d8400de8bf5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713395",
                              "name": "Hot Chocolate (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Sinful chocolate whisked with silky steamed milk and topped with an even sweeter touch of chocolate.",
                              "imageId": "3abea0944c4f74ac47cb177ba109fb6d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713404",
                              "name": "Latte (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Treat yourself with the smooth and sophisticated Latte, made with our signature McCaf?? espresso and topped with 100% real milk, steamed and frothed.",
                              "imageId": "cee1ec0e10e25018572adcaf3a3c9e8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713407",
                              "name": "Latte (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Treat yourself with the smooth and sophisticated Latte, made with our signature McCaf?? espresso and topped with 100% real milk, steamed and frothed.",
                              "imageId": "166e91251135561dddae7c2cb026c45a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713421",
                              "name": "McCafe Americano (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Our Americano is bold and robust, made with our signature McCaf?? espresso combined with hot water, for coffee aficionados who prefer a bolder cup.",
                              "imageId": "7af6ca2978ba398b418547ed0386a931",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713424",
                              "name": "McCafe Americano (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Our Americano is bold and robust, made with our signature McCaf?? espresso combined with hot water, for coffee aficionados who prefer a bolder cup.",
                              "imageId": "7af6ca2978ba398b418547ed0386a931",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713427",
                              "name": "McCafe-Ice Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An irrestible combination of our signature espresso and soft serve, which is to die for! Now in a new, convenient and delivery friendly packaging",
                              "imageId": "06cb5429b883a108cc5be508fb2780b0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713429",
                              "name": "Mccafe Iced Americano",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Feel refreshed with the blend of perfect espresso shot mixed with ice.",
                              "imageId": "7d89db9d67c537d666d838ddc1e0c44f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713603",
                              "name": "Mocha (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing combination of well-ground coffee beans and white steamed milk, topped off with dark froth.",
                              "imageId": "04a137420bf3febf861c4beed86d5702",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713604",
                              "name": "Mocha (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing combination of well-ground coffee beans and white steamed milk, topped off with dark froth.",
                              "imageId": "71df07eb87d96824e2122f3412c8f743",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713605",
                              "name": "Moroccan Mint Green Tea",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Freshly brewed refreshing tea with hint of Moroccon Mint flavour.",
                              "imageId": "2699c7c2130b4f50a09af3e294966b2e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713618",
                              "name": "Strawberry Green Tea (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Freshly brewed refreshing tea with flavoured with fruity Strawberries.",
                              "imageId": "167dc0134bc1f4e8d7cb8e5c2a9dde5d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923947",
                              "name": "Cappuccino (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshingly warm shot of espresso made with 100% Arabica beans, topped with milk that is steamed to a thick, perfect froth. A classic favourite.",
                              "imageId": "e0587fa071e5ce08b8363e32efc82852",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923948",
                              "name": "Cappuccino (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshingly warm shot of espresso made with 100% Arabica beans, topped with milk that is steamed to a thick, perfect froth. A classic favourite.",
                              "imageId": "0a969eb81b4986afcc6cc3d27d8ad894",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972288",
                              "name": "Chocolate Shake",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The classic sinful chocolate shake, a treat for anytime you need one. Now in new, convenient and delivery friendly packaging",
                              "imageId": "c3c58eb3c803c38b4adb885c64970488",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972289",
                              "name": "Lemon Chiller",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A perfect blend of aromatic teas, infused with lemon flavour.Now in a new, convenient and delivery friendly packaging",
                              "imageId": "2b12986f8bbbaa37552bb6d110132e71",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972290",
                              "name": "McCafe-Classic Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An irrestible blend of our signature espresso and soft serve with whipped cream on top, a timeless combination! Now in a new, convenient and delivery friendly packaging. Now in a new, convenient and delivery friendly packaging",
                              "imageId": "5f9bdb36689a11cadb601a27b6fdef2d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972291",
                              "name": "McCafe-Mocha Frappe",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing coffee beverage, blended with rich mocha sauce and our signature soft serve. Now in a new, convenient, delivery frinedly packaging",
                              "imageId": "063e9cd747c621978ab4fddbb6d0a5ee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972292",
                              "name": "Strawberry Chiller",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A perfect blend of aromatic teas, infused with strawberry flavour . Now in a new, convenient and delivery friendly packaging",
                              "imageId": "4bb2d1b9a24a904bc7bba3d3a74a27c4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972293",
                              "name": "Strawberry Shake",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An all time favourite treat bringing together the perfect blend of creamy vanilla soft serve and strawberry flavor.Now in new, convenient and delivery friendly packaging",
                              "imageId": "fe5357fbb4086f1f8b47566d46a947dc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294835",
                              "name": "Hazelnut Cappuccino Regular",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A strong Cappuccino with a flavour of Hazelnut, a flavour made in heaven to delight your senses",
                              "imageId": "e7dd94f44cb02535d183f2f0ae8ba049",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294843",
                              "name": "Hazelnut Cappuccino Small",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A strong Cappuccino with a flavour of Hazelnut, a flavour made in heaven to delight your senses ",
                              "imageId": "e7dd94f44cb02535d183f2f0ae8ba049",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294844",
                              "name": "Hazelnut Cold Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Enjoy the indulgent flavour of Hazelnut with our popular cold coffee ",
                              "imageId": "60c41d4fad7304e3526ae1db751a00a2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294846",
                              "name": "Hazelnut Hot Chocolate Regular",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Chocolaty indulgence of hot chocolate doubled with our Hazelnut flavour",
                              "imageId": "39cc8a9dba0ed5a4e15164d3477e4e16",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294847",
                              "name": "Hazelnut Hot Chocolate Small",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Chocolaty indulgence of hot chocolate doubled with our Hazelnut flavour",
                              "imageId": "39cc8a9dba0ed5a4e15164d3477e4e16",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299739",
                              "name": "Chocolate Shake with GEMS",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A classic sinful chocolate shake to treat yourself to whenever you want to! Now with the colourful twist of a GEMS toppings",
                              "imageId": "35de600327e12cf877edf3619e830a87",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299742",
                              "name": "Strawberry Shake with GEMS",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A classic strawberry shake to treat yourself to whenever you want to! Now with the colourful twist of a GEMS toppings",
                              "imageId": "83be162574d52e962a0419aeb82fb1fe",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fries & Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150151",
                              "name": "Piri Piri Spice Mix",
                              "category": "Fries & Sides",
                              "description": "The perfect, taste bud tingling partner for our World Famous Fries. Shake Shake, and dive in!",
                              "imageId": "df3edfc74f610edff535324cc53a362a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "1629 ratings",
                                  "ratingCountV2": "1629"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150175",
                              "name": "Veg Pizza McPuff",
                              "category": "Fries & Sides",
                              "description": "Crispy brown crust with a generous filling of rich tomato sauce, mixed with carrots, bell peppers, beans, onions and mozzarella. Served HOT.",
                              "imageId": "abe4b8cdf0f1bbfd1b9a7a05be3413e8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "699 ratings",
                                  "ratingCountV2": "699"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329668",
                              "name": "Fries (R)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
                              "imageId": "5a18fbbff67076c9a4457a6b220a55d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "649 ratings",
                                  "ratingCountV2": "649"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329669",
                              "name": "Fries (M)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
                              "imageId": "8a61e7fd97c454ea14d0750859fcebb8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "625 ratings",
                                  "ratingCountV2": "625"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329670",
                              "name": "Fries (L)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy golden, fried to perfection and lightly salted. Also known as happiness.",
                              "imageId": "a4b3002d0ea35bde5e5983f40e4ebfb4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1100 ratings",
                                  "ratingCountV2": "1100"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67458864",
                              "name": "Tomato Ketchup Sachet",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "7db5533db29a4e9d2cc033f35c5572bc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 95,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68261451",
                              "name": "Chicken McNuggets - 9 Pcs",
                              "category": "Fries & Sides",
                              "description": "9 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                              "inStock": 1,
                              "price": 20858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301663",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "185 ratings",
                                  "ratingCountV2": "185"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68261457",
                              "name": "Chicken McNuggets - 6 Pcs",
                              "category": "Fries & Sides",
                              "description": "6 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                              "inStock": 1,
                              "price": 17715,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301766",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "200 ratings",
                                  "ratingCountV2": "200"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69669709",
                              "name": "Chilli Sauce Sachet",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "f708dfc29c9624d8aef6e6ec30bde1c9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334813",
                              "name": "Cheesy Veg Nuggets - 2 Pc",
                              "category": "Fries & Sides",
                              "description": "Try the new delicious 2 piece pack of Cheesy Veg Nuggets, oozing with cheese seasoned to perfection. Best enjoyed with Satvik ketchup/NONG ketchup",
                              "imageId": "dafdc300b81d5c54dd70eff5d82c8e1a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334814",
                              "name": "Cheesy Veg Nuggets - 4 Pc",
                              "category": "Fries & Sides",
                              "description": "Try the new delicious 4 piece pack of Cheesy Veg Nuggets, oozing with cheese seasoned to perfection. Best enjoyed with Satvik ketchup/NONG ketchup",
                              "imageId": "33717c7f353f04e15aa151f8ed795a44",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334815",
                              "name": "Cheesy Veg Nuggets 4 Pc + Piri Piri Spice Mix",
                              "category": "Fries & Sides",
                              "description": "Relish this delicious combo of 4 Pieces of Cheesy Veg Nuggets, paired with Piri Piri Seasoning, to give you the perfect balance of Cheese and Spice",
                              "imageId": "d76ab4412ec936d7164e379f058326d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334816",
                              "name": "Cheesy Veg Nuggets - 9 Pc",
                              "category": "Fries & Sides",
                              "description": "Try the new delicious 9 piece pack of Cheesy Veg Nuggets, oozing with cheese seasoned to perfection. Best enjoyed with Satvik ketchup/NONG ketchup",
                              "imageId": "7457489c0366a8b28e14843931561ef1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334817",
                              "name": "Cheesy Veg Nuggets 9 Pc + Piri Piri Spice Mix",
                              "category": "Fries & Sides",
                              "description": "Relish this delicious combo of 9 Pieces of Cheesy Veg Nuggets, paired with Piri Piri Seasoning, to give you the perfect balance of Cheese and Spice",
                              "imageId": "e62e39815d3bc9a772942697d0c5d059",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620491",
                              "name": "Classic Corn Cup",
                              "category": "Fries & Sides",
                              "description": "A delicious side of golden sweet kernels of corn in a cup",
                              "imageId": "9d67eae020425c4413acaf5af2a29dce",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620498",
                              "name": "Fries (M) + Piri Piri Mix",
                              "category": "Fries & Sides",
                              "description": "Flat 15% Off on Fries (M) + Piri Piri Mix",
                              "imageId": "2835b7daf6a76ac5687bf4e4054bbfb8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620564",
                              "name": "Classic Cheesy Fries",
                              "category": "Fries & Sides",
                              "description": "The world famous, crispy golden Fries, served with delicious cheese sauce with a hint of spice",
                              "imageId": "f13f7c1db7b7fda89c86e84e98dc1d29",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116486555",
                              "name": "Chicken McNuggets - 20 Pcs",
                              "category": "Fries & Sides",
                              "description": "20 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                              "inStock": 1,
                              "price": 38001,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301727",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193873",
                              "name": "Barbeque Sauce",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "ba0a188d45aecc3d4d187f340ea9df54",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193882",
                              "name": "Chicken McNuggets 4 PC",
                              "category": "Fries & Sides",
                              "description": "4 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                              "inStock": 1,
                              "price": 9619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193915",
                              "name": "Mustard Sauce",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "6c3aeffdbd544ea3ceae1e4b8ce3fc43",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294834",
                              "name": "Festive Dip Box",
                              "category": "Fries & Sides",
                              "description": "Get some of everything with the dip box that let's you try both new flavours to mix and match",
                              "imageId": "f62556f43d8b95c59e0365650533b6a0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294856",
                              "name": "Salsa Cheesy Fries",
                              "category": "Fries & Sides",
                              "description": "The world famous, crispy, golden Fries, served with rich cheese sauce and a tangy twist of salsa",
                              "imageId": "319bffa6b4a2045961e09585cd5988a0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294857",
                              "name": "Sweet Chilli Dip",
                              "category": "Fries & Sides",
                              "description": "Your new favourite dip is here! Try the spicy chilly balanced with the acidic lime to accompany your burger and sides.",
                              "imageId": "2b8702a9fc15fd520de1264c3a310dad",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294858",
                              "name": "Tangy Pepper Dip",
                              "category": "Fries & Sides",
                              "description": "Enjoy that perfect pour with the new tangy pepper dip with Indian spicy pepper and notes of curry leaves. For the festive period only!",
                              "imageId": "d99ab924545a3a977a431bbae52eaa20",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68302588",
                              "name": "Mcflurry Oreo Small",
                              "category": "Desserts",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Perfect for one.",
                              "imageId": "a28369e386195be4071d9cf5078a438d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "152 ratings",
                                  "ratingCountV2": "152"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713467",
                              "name": "McFlurry Oreo Medium",
                              "category": "Desserts",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Share it, if you can.",
                              "imageId": "f966500ed8b913a16cfdb25aab9244e4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "228 ratings",
                                  "ratingCountV2": "228"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713610",
                              "name": "Soft Serve Hot Fudge (M)",
                              "category": "Desserts",
                              "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. Always grab an extra spoon.",
                              "imageId": "9c8958145495e8f2cf70470195f7834a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "134 ratings",
                                  "ratingCountV2": "134"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713616",
                              "name": "Soft Serve Strawberry (M)",
                              "category": "Desserts",
                              "description": "The cool vanilla soft serve ice cream with twirls of strawberry syrup.",
                              "imageId": "d7bd22aa47cffdcdde2d5b6223fde06e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.2",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923952",
                              "name": "Oreo Sundae Medium",
                              "category": "Desserts",
                              "description": "Enjoy the classic McFlurry Oreo goodness with a drizzle of hot fudge sauce with the Oreo Sundae!",
                              "imageId": "3696da86802f534ba9ca68bd8be717ab",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193874",
                              "name": "Black Forest McFlurry Medium",
                              "category": "Desserts",
                              "description": "A sweet treat to suit your every mood",
                              "imageId": "f513cc8c35cadd098835fb5b23c03561",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193876",
                              "name": "Blueberry Cheese Cake",
                              "category": "Desserts",
                              "description": "A sweet treat to suit your every mood",
                              "imageId": "f3c4415f38ed3982e25c9cd4665840fc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193878",
                              "name": "Brownie Hot Fudge (M)",
                              "category": "Desserts",
                              "description": "Luscious chocolate brownie and hot-chocolate fudge to sweeten your day",
                              "imageId": "6e00a57c6d8ceff6812a765c80e9ce74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193885",
                              "name": "Chocolate Express Cake",
                              "category": "Desserts",
                              "description": "This rich, velvety chocolate cake is topped with chocolate shavings and is perfect for all chocolate lovers out there. Soft, moist, and packed with flavor, it's the perfect dessert to treat yourself with after a long day.",
                              "imageId": "b424bcb7466a0a04ff8d7fe3270641b6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972287",
                              "name": "Chocolate Chip Muffin",
                              "category": "Desserts",
                              "description": "Soft, fluffy, and bursting with chocolate chips with muffin is loaded with chocolate!",
                              "imageId": "6c748c0b21f4a99593d1040021500430",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972294",
                              "name": "Vanilla Chocolate Muffin",
                              "category": "Desserts",
                              "description": "Sweet, soft, and fluffy vanilla flavoured chocolate chip muffins are perfect accompaniment with hot coffee!",
                              "imageId": "56ecb9e43f657ee8f239cc22f7831b83",
                              "inStock": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299738",
                              "name": "1+1 Gems Flurry",
                              "category": "Desserts",
                              "description": "What's better than one McFlurry with GEMS? Two of them!",
                              "imageId": "6412c75cb514458b438242c80fb3e273",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299740",
                              "name": "McFlurry with GEMS Medium",
                              "category": "Desserts",
                              "description": "Bring out the fun-loving child in you with the colourful and creamy McFlurry with GEMS. The cooling McFlurry with bursts of colourful pellets and chocolate make for the perfect end to your meal!",
                              "imageId": "6ccaf3ac7c6b41bee93435e3b7e41de2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299741",
                              "name": "McFlurry with GEMS Regular",
                              "category": "Desserts",
                              "description": "Bring out the fun-loving child in you with the colourful and creamy McFlurry with GEMS. The cooling McFlurry with bursts of colourful pellets and chocolate make for the perfect end to your meal!",
                              "imageId": "a499053bafd96f375c0071e8306a8d42",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130299743",
                              "name": "Sundae with GEMS Medium",
                              "category": "Desserts",
                              "description": "Playful goodness in a cup! With the new Sundae with GEMS, enjoy a classic Sundae topped with a pop of colour",
                              "imageId": "fb1c42bcbcc0e7ad3ebaf546b681f44a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Happy Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150136",
                              "name": "McChicken Happy Meal",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of McChicken Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "2b7356d14d1c9dc38d20ab8a30247834",
                              "inStock": 1,
                              "price": 32953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278666",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278667",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150137",
                              "name": "McVeggie Happy Meal",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of McVeggie Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "ca05cb0597101eb8357cda385b92b584",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278701",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278702",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150141",
                              "name": "McAloo Tikki Happy Meal",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of McAloo Tikki Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "98b4674a979d6faf528f05e65e6799f2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278740",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278742",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479522",
                              "name": "Birthday Party Package - McChicken",
                              "category": "Happy Meals",
                              "description": "5 McChicken Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                              "imageId": "31da1776bf9e74beea809aadc61cf1da",
                              "inStock": 1,
                              "price": 221144,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278717",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278719",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479523",
                              "name": "Birthday Party Package - McVeggie",
                              "category": "Happy Meals",
                              "description": "5 McVeggie Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                              "imageId": "567411605ac9c72680aa742e17fb83d5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 221144,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278724",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278726",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479524",
                              "name": "McEgg Happy Meal",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of McEgg Burger  + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "7a328a58de3b5e209116682223e5d94d",
                              "inStock": 1,
                              "price": 23905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278696",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278697",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294828",
                              "name": "2 Pc Chicken Nuggets HM",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of  2 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                              "imageId": "78924991d845b01f4413bafd169fb8bc",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278746",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278747",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294829",
                              "name": "4 Pc Chicken Nuggets HM",
                              "category": "Happy Meals",
                              "description": "Enjoy a combo of  4 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                              "imageId": "d85f06a7806ccad6994a3a4badf90135",
                              "inStock": 1,
                              "price": 26762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278660",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278661",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044264",
                                      "name": "Chocolate Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Cappuccino (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Splash",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McSaver Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33933608",
                              "name": "Pizza Mc Puff + McSpicy Chicken",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Veg Pizza McPuff",
                              "imageId": "fb4b9d4775505e82d05d6734ef3e2491",
                              "inStock": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50287486",
                              "name": "McChicken + McSpicy Chicken Burger",
                              "category": "McSaver Combos",
                              "description": "The ultimate chicken combo made just for you. Get the top selling McChicken with the McSpicy Chicken Burger.",
                              "imageId": "006d51070b0ab9c839a293b87412541c",
                              "inStock": 1,
                              "price": 29143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50287497",
                              "name": "McVeggie + McAloo Tikki Burger",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns makes our iconic McVeggie. Make it a combo with our top selling McAloo Tikki Burger.",
                              "imageId": "1f4d583548597d41086df0c723560da7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149158",
                              "name": "McChicken + Fries (M)",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Medium Fries.",
                              "imageId": "f2db3e452c63d643cc735371537e49c7",
                              "inStock": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "376 ratings",
                                  "ratingCountV2": "376"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149159",
                              "name": "McVeggie + Fries (M)",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Medium Fries.",
                              "imageId": "d14cc495747a172686ebe43e675bc941",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "226 ratings",
                                  "ratingCountV2": "226"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149162",
                              "name": "McAloo Tikki + Veg Pizza McPuff + Coke",
                              "category": "McSaver Combos",
                              "description": "The ultimate veg combo made just for you. Get the top selling McAloo Tikki served with Veg Pizza McPuff and Coke.",
                              "imageId": "9f0269a2d28f4918a3b07f63a487f26d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16096,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278634",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "143 ratings",
                                  "ratingCountV2": "143"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65035612",
                              "name": "2 Coke",
                              "category": "McSaver Combos",
                              "description": "The perfect companion to your burger, fries and everything nice. Double it up with this combo.",
                              "imageId": "2d7540e92ac04c0c0823e9f4f029e2dd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343167",
                              "name": "McAloo Tikki + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "Aloo Tikki+ Fries (R)",
                              "imageId": "bd66dd17e8ed566e747662403b791e63",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343174",
                              "name": "Mexican McAloo Tikki Burger + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Regular Fries.",
                              "imageId": "7274d82212a758e597550e8c246fb2f7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343175",
                              "name": "McChicken Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Veg Pizza McPuff.",
                              "imageId": "9a66b8ef66d780b9f83a0fc7cd434ded",
                              "inStock": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343176",
                              "name": "McChicken Burger + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with regular Fries.",
                              "imageId": "fee8ad670ba06e0f2b3f6fd8305adcbc",
                              "inStock": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343179",
                              "name": "McVeggie Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Veg Pizza McPuff.",
                              "imageId": "8cb2f75ca6a51061c69280daf1b63bec",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.3",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343180",
                              "name": "McVeggie Burger + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Regular fries.",
                              "imageId": "52a347eab543d461b1a15b609779b8c2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.4",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834979",
                              "name": "Mexican McAloo Tikki Burger + Fries (L)",
                              "category": "McSaver Combos",
                              "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Large Fries.",
                              "imageId": "f4be6e877d2567a0b585d4b16e53871e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834988",
                              "name": "McChicken Burger + Fries (L)",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Large Fries.",
                              "imageId": "a4148348225f693c23b73eda06934fac",
                              "inStock": 1,
                              "price": 22762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834991",
                              "name": "McVeggie Burger + Fries (L)",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Large fries.",
                              "imageId": "f16eeec3e5d19f8627971620ed2da6f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553330",
                              "name": "McSaver Chicken Nuggets (4 Pc)",
                              "category": "McSaver Combos",
                              "description": "McSaver Chicken Nuggets (4 Pc) + coke",
                              "imageId": "7bf83367ed61708817caefbc79a3c9eb",
                              "inStock": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301818",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553337",
                              "name": "McSaver McAloo Tikki",
                              "category": "McSaver Combos",
                              "description": "Enjoy a delicious combo of McAloo Tikki Burger and Beverage of your choice in a new, delivery friendly, reusable bottle.",
                              "imageId": "ab4c47366f0e51ac0071f705b0f2d93e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278728",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553340",
                              "name": "McSaver Chicken Kebab Burger",
                              "category": "McSaver Combos",
                              "description": "McSaver Chicken Kebab Burger + coke",
                              "imageId": "a752e2e5c57a5c0428c3bdcc66813971",
                              "inStock": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120205747",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553348",
                              "name": "McSaver Masala McEgg",
                              "category": "McSaver Combos",
                              "description": "McSaver Masala McEgg + Coke",
                              "imageId": "8f0cbf7d50d3f8dad87b971fb11f8d6c",
                              "inStock": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "112258284",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541945",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 6700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541944",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541947",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 6700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541950",
                                      "name": "Berry Cooler @ 99",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541946",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 6700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541949",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541948",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 6700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553352",
                              "name": "McSaver Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "McSaver Pizza McPuff + Coke",
                              "imageId": "45fa406e76418771de26c37e8863fbb3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301604",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553360",
                              "name": "McSaver Small Fries",
                              "category": "McSaver Combos",
                              "description": "McSaver Small Fries + Coke",
                              "imageId": "70771ada9c14923d9535e84d1d2fc2e0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "112258409",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553364",
                              "name": "McSaver Mexican McAloo Tikki",
                              "category": "McSaver Combos",
                              "description": "McSaver Mexican McAloo Tikki  + Coke",
                              "imageId": "5897849bed9b0298559968c3e5f4af81",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "112258363",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "100541900",
                                      "name": "Berry Cooler @ 99",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541895",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541897",
                                      "name": "Green Apple Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541896",
                                      "name": "Cappuccino (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541899",
                                      "name": "Lemon Chiller @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541898",
                                      "name": "Iced Coffee (S) @ 129",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87366535",
                              "name": "2 Fries (R)",
                              "category": "McSaver Combos",
                              "description": "World Famous Fries, crispy golden, fried to perfection and lightly salted. Double the goodness with this combo.",
                              "imageId": "4a170da5ecae92e11410a8fbb44c8476",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87366548",
                              "name": "2 McVeggie Burger",
                              "category": "McSaver Combos",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns makes our iconic McVeggie. Double it up with this combo!",
                              "imageId": "8860bbebd978965031c6fe9a508bcd21",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107198",
                              "name": "Grilled Chicken & Cheese Burger + Coke",
                              "category": "McSaver Combos",
                              "description": "Flat 15% Off on Grilled Chicken & Cheese Burger + Coke",
                              "imageId": "f0249c4990ec08a8ae254852217e3bf7",
                              "inStock": 1,
                              "price": 21619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "99475401",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107201",
                              "name": "McAloo Tikki + Veg Pizza McPuff + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "Flat 15% Off on McAloo Tikki + Veg Pizza McPuff + Fries (R)",
                              "imageId": "dcf114f75ce0203b6de114b1295868ea",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107204",
                              "name": "McVeggie Burger + Fries (M) + Piri Piri Mix",
                              "category": "McSaver Combos",
                              "description": "Flat 15% Off on McVeggie Burger + Fries (M) + Piri Piri Mix",
                              "imageId": "0205cbd8b77f841e19e25ce727993d51",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107205",
                              "name": "McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                              "category": "McSaver Combos",
                              "description": "Flat 15% Off on McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                              "imageId": "58be9ff9147470f125ed042c484959b3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334826",
                              "name": "Chicken McNuggets 6 Pc + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos",
                              "description": "The best Non veg sides combo curated for you! Get 6 pc Chicken McNuggets + Fries M. Top it up with Piri Piri mix.",
                              "imageId": "8cba0938b4401e5c8cb2ccf3741b93c4",
                              "inStock": 1,
                              "price": 24762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106302965",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334831",
                              "name": "McAloo Tikki Burger + Veg Pizza McPuff + Piri Piri Spice Mix",
                              "category": "McSaver Combos",
                              "description": "Get India's favourite burger - McAloo Tikki along with Veg Pizza McPuff and spice it up with a Piri Piri Mix",
                              "imageId": "46bcb1e486cbe6dcdb0487b063af58a6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039799",
                              "name": "Grilled Chicken & Cheese Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "A delicious Grilled Chicken & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                              "imageId": "b9f02abd64c74307339cbd3421e7f853",
                              "inStock": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039800",
                              "name": "Corn & Cheese Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "A delicious Corn & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                              "imageId": "f847f39d3b81367ecd2aa14bd2dca94d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039801",
                              "name": "Corn & Cheese Burger + Fries (R)",
                              "category": "McSaver Combos",
                              "description": "A delicious Corn & Cheese Burger + a side of crispy, golden, world famous fries ??",
                              "imageId": "495bcb831b35c29883707b9458fd55b0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039804",
                              "name": "Corn & Cheese Burger + Coke",
                              "category": "McSaver Combos",
                              "description": "Flat 15% Off on Corn & Cheese Burger + Coke",
                              "imageId": "7194232b8ff13f5a78c4572f981bd621",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22572,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "99475348",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614787",
                                      "name": "Latte (S)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487430",
                                      "name": "McCafe-Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614794",
                                      "name": "Strawberry Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614793",
                                      "name": "Hot Chocolate (S)",
                                      "price": 8300,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487421",
                                      "name": "Cappuccino (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614795",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487422",
                                      "name": "Green Apple Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614792",
                                      "name": "Lemon Chiller",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614791",
                                      "name": "McCafe-Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487427",
                                      "name": "Mocha (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Chocolate Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487428",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Cappuccino (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "American Mudpie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541777",
                                      "name": "Mango Smoothie",
                                      "price": 5600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614789",
                                      "name": "Masala Pop Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487423",
                                      "name": "Chilli Guava Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487425",
                                      "name": "Masala Pop Coke",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487424",
                                      "name": "Chilli Guava Sprite",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713315",
                              "name": "2 Cappuccino",
                              "category": "McSaver Combos",
                              "description": "2 Cappuccino (S) @ 198",
                              "imageId": "67008b9d2ebb7ce75e225442749a3777",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713329",
                              "name": "2 McFlurry Oreo (S)",
                              "category": "McSaver Combos",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Make it double with this combo!",
                              "imageId": "65f3574f53112e9d263dfa924b1f8fed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713331",
                              "name": "2 Soft Serve Hot Fudge (M)",
                              "category": "McSaver Combos",
                              "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. So good you won't be able to stop at one!",
                              "imageId": "f1238db9da73d8ec7a999792f35865d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713348",
                              "name": "Chocolate Shake + Fries (M)",
                              "category": "McSaver Combos",
                              "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Chocolate Shake.",
                              "imageId": "46781c13d587e5f951ac1bbb39e57154",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713620",
                              "name": "Strawberry Shake + Fries (M)",
                              "category": "McSaver Combos",
                              "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Strawberry Shake.",
                              "imageId": "74603316fc90ea3cd2b193ab491fbf53",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128694",
                              "name": "2 Iced Coffee",
                              "category": "McSaver Combos",
                              "description": "2 Iced Coffee @ 200",
                              "imageId": "67e07d25a37641db63cd12134b091864",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119629964",
                              "name": "Cheesy Veg Nuggets 9 pc + Fries (M)",
                              "category": "McSaver Combos",
                              "description": "The best Veg sides combo curated for you! Get 9 Pc Cheesy Veg Nuggets + Fries M. Top it up with Piri Piri Mix.",
                              "imageId": "a85ff9e14a45d5e3f9359732872a5629",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923944",
                              "name": "Corn and Cheese Burger \t+ Coke + Fries (M) \t+ Veg Pizza McPuff",
                              "category": "McSaver Combos",
                              "description": "Treat yourself today with these exclusive Coke combos. Huge discounts on your favourite meals. Get a Corn and Cheese Burger + Coke + Fries (M) + Veg Pizza McPuff today!",
                              "imageId": "8d4a82d50f6e79d95fcc324b161374f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193892",
                              "name": "McSpicy Chicken + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                              "imageId": "e10982204687e18ee6541684365039b8",
                              "inStock": 1,
                              "price": 26476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193893",
                              "name": "McSpicy Chicken + Mexican Cheesy Fries",
                              "category": "McSaver Combos",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheesy Fries.",
                              "imageId": "40259e78ad0e89966755805a7c1ad800",
                              "inStock": 1,
                              "price": 25048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193910",
                              "name": "McSpicy Paneer + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos",
                              "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                              "imageId": "87ce9779f986dcb21ab1fcfe794938d1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193912",
                              "name": "McSpicy Paneer + Mexican Cheesy Fries",
                              "category": "McSaver Combos",
                              "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheesy Fries.",
                              "imageId": "fcc2fb1635f8e14c69b57126014f0bd5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972286",
                              "name": "Black Forest Mcflurry (M) BOGO",
                              "category": "McSaver Combos",
                              "description": "Get 2 Black Forest McFlurry for the price of one!",
                              "imageId": "972a2b3aca8059ba25a04875ec091885",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McBreakfast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33428071",
                              "name": "Sausage & Egg McMuffin 2 pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between the two slices of fresh English muffins + Coffee (R)",
                              "imageId": "55f41cd2962cd5162adf657a949fab80",
                              "price": 26953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301509",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33428076",
                              "name": "Sausage McMuffin 2 pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between the two slices of fresh English muffins + Coffee (R)",
                              "imageId": "c57b5327ffeb8d44f90982ef13811c78",
                              "price": 25333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301573",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150161",
                              "name": "Hashbrown",
                              "category": "McBreakfast",
                              "description": "Freshly fried golden brown potatoes that melt in your mouth.",
                              "imageId": "534f18e69e28bb060a85d30e03a102e4",
                              "isVeg": 1,
                              "price": 5333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "227 ratings",
                                  "ratingCountV2": "227"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693022",
                              "name": "Double Cheese McMuffin",
                              "category": "McBreakfast",
                              "description": "Make your mornings Cheesy with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns",
                              "imageId": "8bcca26adae8fa3e5593e1c8405dcac9",
                              "isVeg": 1,
                              "price": 10095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693023",
                              "name": "Double Cheese McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Try the delcious combo of Double Cheese McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                              "imageId": "3a91832849055b8770ec4ef2bd27fd03",
                              "isVeg": 1,
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278254",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693024",
                              "name": "Egg & Cheese McMuffin",
                              "category": "McBreakfast",
                              "description": "Fluffy soft egg topped with Cheese served between English muffins",
                              "imageId": "39bb3c273b440ee352b738fa1f00c842",
                              "price": 10095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693025",
                              "name": "Egg & Cheese McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Fluffy soft egg topped with cheese served between English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "6e3ebff1d0678c7678e4fd2401f799ae",
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278327",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693026",
                              "name": "McSaver Double Cheese McMuffin Meal",
                              "category": "McBreakfast",
                              "description": "Make your mornings Cheesy with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                              "imageId": "4a32aa8cabd4caa4f6dc361b1fe0331c",
                              "isVeg": 1,
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693027",
                              "name": "McSaver Egg & Cheese McMuffin Meal",
                              "category": "McBreakfast",
                              "description": "Start your day with a combo of Egg & Cheese McMuffin and a Cappuccino (S)",
                              "imageId": "a00928a1fbaa5a3a49a58953295987db",
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693028",
                              "name": "McSaver Spicy Egg McMuffin Meal",
                              "category": "McBreakfast",
                              "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                              "imageId": "ae7bc83b4549021a4579323516bab7ad",
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693029",
                              "name": "Sausage & Egg McMuffin",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. A wholesome breakfast!",
                              "imageId": "63f426865644cf79af5163230a901d80",
                              "price": 15429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693030",
                              "name": "Sausage McMuffin",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. A wholesome breakfast!",
                              "imageId": "83bcbf3a3eab08d09e332aa2d7acca69",
                              "price": 13238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693031",
                              "name": "Sausage McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "acee1d07c362312c3bc4332013450e88",
                              "price": 27429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278354",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693032",
                              "name": "Sausage with Egg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "853df93396ec14836751239af41c0f84",
                              "price": 29619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278281",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693033",
                              "name": "Spicy Egg McMuffin",
                              "category": "McBreakfast",
                              "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns.",
                              "imageId": "798e2b493a04283cea3f7c388d6ef6ea",
                              "price": 10762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693034",
                              "name": "Spicy Egg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Try the delcious combo of Spicy Egg McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                              "imageId": "38d8784662196a231858925936c84847",
                              "price": 25333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301587",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693035",
                              "name": "Veg McMuffin",
                              "category": "McBreakfast",
                              "description": "Grilled Spinach & Corn patty and slice of processed Cheddar cheese nestled between a toasty English Muffin.",
                              "imageId": "36d8d4789793db20bcfe3359ec814b8e",
                              "isVeg": 1,
                              "price": 11810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693036",
                              "name": "Veg McMuffin 2 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Start your day with a combo of Veg McMuffin and a Coffee (S)",
                              "imageId": "0d64bf0e5a9308ab143f28e49e190902",
                              "isVeg": 1,
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301667",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693037",
                              "name": "Veg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Grilled Spinach & Corn patty and slice of processed cheddar cheese nestled between a toasty English Muffin served with Hashbrowns and a Coffee of your choice",
                              "imageId": "76aeecdcdea1eea92c575db5b1111223",
                              "isVeg": 1,
                              "price": 26476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278202",
                                  "groupName": "Choose an option for Cappuccino (S)",
                                  "choices": [
                                    {
                                      "id": "110044157",
                                      "name": "Cappuccino (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "20% OFF",
                                  "subTitle": "USE TRYNEW",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11214333001617"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "McDonald's",
                      "area": "Ashok Nagar",
                      "completeAddress": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "igyKAlOatZlE-7uKh-xcHvbugAbBNda25gGNc_po"
},
// 20240105233311
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=23847&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "23847",
              "name": "Domino's Pizza",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "dominos-pizza-rex-theater-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "fjqcvqfgqlw6h0atques",
              "locality": "Rest House Road",
              "areaName": "Brigade Road",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Pizzas",
                "Italian"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "23847",
                "icon": "dominos_cod_xc6inc"
              },
              "parentId": "2456",
              "avgRatingString": "4.3",
              "totalRatingsString": "5K+ ratings",
              "sla": {
                "restaurantId": "23847",
                "serviceability": "NON_SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 10:57 am, tomorrow",
                "nextOpenTime": "2024-01-06 10:57:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹150 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹999",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹299 | Use code WELCOMEDOM150",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹999 | Use code FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "dominos-pizza-rex-theater-central-bangalore",
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "First Floor,Corp. No. 30 (Old No. 16 Later 23)Opp. Guzzlers Inn, Rest House Road, Nr Brigade Road,Bangalore - 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Pizzas,Italian"
                }
              ],
              "logo": "dominos_logo_zohi7f",
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹150 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹999",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹299 | Use code WELCOMEDOM150",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off on orders above ₹999 | Use code FLAT100",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 209,
                  "maxValue": 299,
                  "priority": 1,
                  "couponCode": "WELCOMEDOM150",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 150
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹150 | Code WELCOMEDOM150",
                  "unlockedMessage": "WELCOMEDOM150 Coupon Unlocked! Use it to save ₹150",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 699,
                  "maxValue": 999,
                  "priority": 2,
                  "couponCode": "FLAT100",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 100
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹100 | Code FLAT100",
                  "unlockedMessage": "FLAT100 Coupon Unlocked! Use it to save ₹100",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/23847"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Does not deliver to your location",
              "orderabilityCommunication": {
                "title": {
                  "text": "Wish you were"
                },
                "subTitle": {
                  "text": "CLOSER!"
                },
                "message": {
                  "text": "This location is outside the outlet's delivery area",
                  "textColour": "negative"
                },
                "customIcon": {
                  "bgGradientColorStart": "#F64C41",
                  "bgGradientColorEnd": "#E53554"
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.973637,77.60710300000005",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "d5b9f442-6118-4aa2-b93e-a8fc7c95ff96"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE WELCOMEDOM150",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "23847",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "cf4dba12-f926-448d-8c33-3d1c2f96d393"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT100",
                      "description": "ABOVE ₹999",
                      "offerType": "offers",
                      "restId": "23847",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "23847",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "23847",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "23847",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "New Launches",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105212439",
                              "name": "Primavera Gourmet-Pizza",
                              "category": "New Launches",
                              "description": "Gourmet veggie delight with bocconcini, zucchini, bell peppers, and mushrooms.",
                              "imageId": "0f33dad543169282a0f4b70c69749ad3",
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154214",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99454473",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154216",
                                          "variationId": "99454478"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154216",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 549,
                                        "default": 1,
                                        "id": "99454478",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 849,
                                        "id": "99454480",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154214",
                                        "variationId": "99454473"
                                      },
                                      {
                                        "groupId": "32154216",
                                        "variationId": "99454478"
                                      }
                                    ],
                                    "price": 54900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154214",
                                        "variationId": "99454473"
                                      },
                                      {
                                        "groupId": "32154216",
                                        "variationId": "99454480"
                                      }
                                    ],
                                    "price": 84900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 54900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105212440",
                              "name": "Al Fungi Gourmet-Pizza",
                              "category": "New Launches",
                              "description": "Gourmet mushroom pizza on a cheesy Mozzarella base with jalapenos & cherry tomatoes.",
                              "imageId": "d7b0e23a28996d920bdc24a0510771f4",
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153746",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99452182",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153748",
                                          "variationId": "99452191"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153748",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 549,
                                        "default": 1,
                                        "id": "99452191",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 849,
                                        "id": "99452193",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153746",
                                        "variationId": "99452182"
                                      },
                                      {
                                        "groupId": "32153748",
                                        "variationId": "99452191"
                                      }
                                    ],
                                    "price": 54900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153746",
                                        "variationId": "99452182"
                                      },
                                      {
                                        "groupId": "32153748",
                                        "variationId": "99452193"
                                      }
                                    ],
                                    "price": 84900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 54900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105212442",
                              "name": "Chicken Pepperoni Gourmet-Pizza",
                              "category": "New Launches",
                              "description": "The classic Italian gourmet pizza with bocconcini cheese and chicken pepperoni.",
                              "imageId": "b29ac48b8ba1d1bbd236cdea0acb109c",
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155148",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99459133",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155149",
                                          "variationId": "99459134"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155149",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 699,
                                        "default": 1,
                                        "id": "99459134",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 999,
                                        "id": "99459135",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155148",
                                        "variationId": "99459133"
                                      },
                                      {
                                        "groupId": "32155149",
                                        "variationId": "99459134"
                                      }
                                    ],
                                    "price": 69900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155148",
                                        "variationId": "99459133"
                                      },
                                      {
                                        "groupId": "32155149",
                                        "variationId": "99459135"
                                      }
                                    ],
                                    "price": 99900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 69900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105212444",
                              "name": "Smoked Chicken Gourmet-Pizza",
                              "category": "New Launches",
                              "description": "Gourmet non-veg delight with bocconcini, juicy chicken, olives, bellpeppers & basil pesto.",
                              "imageId": "84dc36067d05b1e10518c8bd39e64013",
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155164",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99459190",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155166",
                                          "variationId": "99459193"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155166",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 699,
                                        "default": 1,
                                        "id": "99459193",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 999,
                                        "id": "99459197",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155164",
                                        "variationId": "99459190"
                                      },
                                      {
                                        "groupId": "32155166",
                                        "variationId": "99459193"
                                      }
                                    ],
                                    "price": 69900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155164",
                                        "variationId": "99459190"
                                      },
                                      {
                                        "groupId": "32155166",
                                        "variationId": "99459197"
                                      }
                                    ],
                                    "price": 99900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 69900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105212445",
                              "name": "Quattro Formaggi Gourmet-Pizza",
                              "category": "New Launches",
                              "description": "Gourmet cheesy delight with bocconcini, mozzarella, cheddar and ghost pepper cheese.",
                              "imageId": "29360562265b645145b66999a8f940d6",
                              "isVeg": 1,
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154200",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99454407",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154202",
                                          "variationId": "99454414"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154202",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 549,
                                        "default": 1,
                                        "id": "99454414",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 849,
                                        "id": "99454418",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154200",
                                        "variationId": "99454407"
                                      },
                                      {
                                        "groupId": "32154202",
                                        "variationId": "99454414"
                                      }
                                    ],
                                    "price": 54900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154200",
                                        "variationId": "99454407"
                                      },
                                      {
                                        "groupId": "32154202",
                                        "variationId": "99454418"
                                      }
                                    ],
                                    "price": 84900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 54900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117102351",
                              "name": "Blazing Onion & Paprika",
                              "category": "New Launches",
                              "description": "Hot & spicy pizza with onion & red paprika toppings and a new spicy peri peri sauce on a Domino's cheesy base.",
                              "imageId": "257508279a8ed217b14b01bee97ba9a1",
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153477",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99450676",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153479",
                                          "variationId": "99450691"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99450678",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153479",
                                          "variationId": "99450697"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99450680",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153479",
                                          "variationId": "99450700"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99450683",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153479",
                                          "variationId": "99450707"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153479",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 179,
                                        "id": "99450686",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 549,
                                        "id": "99450689",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 329,
                                        "default": 1,
                                        "id": "99450691",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99450694",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 379,
                                        "id": "99450697",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 428,
                                        "id": "99450700",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 254,
                                        "id": "99450703",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99450705",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 379,
                                        "id": "99450707",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450676"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450686"
                                      }
                                    ],
                                    "price": 17900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450676"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450689"
                                      }
                                    ],
                                    "price": 54900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450676"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450691"
                                      }
                                    ],
                                    "price": 32900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450678"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450694"
                                      }
                                    ],
                                    "price": 20900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450678"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450697"
                                      }
                                    ],
                                    "price": 37900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450680"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450700"
                                      }
                                    ],
                                    "price": 42800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450680"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450703"
                                      }
                                    ],
                                    "price": 25400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450683"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450705"
                                      }
                                    ],
                                    "price": 20900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153477",
                                        "variationId": "99450683"
                                      },
                                      {
                                        "groupId": "32153479",
                                        "variationId": "99450707"
                                      }
                                    ],
                                    "price": 37900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117102352",
                              "name": "Fiery Jalapeno & Paprika",
                              "category": "New Launches",
                              "description": "Spiciest veg pizza with jalapeno & red paprika toppings and a new spicy peri peri sauce.",
                              "imageId": "285d47a0c466347ba3d199a33ea37831",
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153487",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99450736",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153490",
                                          "variationId": "99450745"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99450740",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153490",
                                          "variationId": "99450751"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99450742",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153490",
                                          "variationId": "99450753"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99450743",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153490",
                                          "variationId": "99450761"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153490",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Large",
                                        "price": 549,
                                        "id": "99450744",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 329,
                                        "default": 1,
                                        "id": "99450745",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 179,
                                        "id": "99450747",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99450749",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 379,
                                        "id": "99450751",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 428,
                                        "id": "99450753",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 254,
                                        "id": "99450755",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99450757",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 379,
                                        "id": "99450761",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450736"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450744"
                                      }
                                    ],
                                    "price": 54900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450736"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450745"
                                      }
                                    ],
                                    "price": 32900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450736"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450747"
                                      }
                                    ],
                                    "price": 17900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450740"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450749"
                                      }
                                    ],
                                    "price": 20900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450740"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450751"
                                      }
                                    ],
                                    "price": 37900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450742"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450753"
                                      }
                                    ],
                                    "price": 42800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450742"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450755"
                                      }
                                    ],
                                    "price": 25400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450743"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450757"
                                      }
                                    ],
                                    "price": 20900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153487",
                                        "variationId": "99450743"
                                      },
                                      {
                                        "groupId": "32153490",
                                        "variationId": "99450761"
                                      }
                                    ],
                                    "price": 37900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 32900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117102353",
                              "name": "Fiery Sausage & Paprika",
                              "category": "New Launches",
                              "description": "Spiciest non veg pizza with spicy & herby chicken sausage and red paprika toppings on a new spicy peri peri sauce base.",
                              "imageId": "53d9867672e903481a40006fb9fd1dd6",
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153503",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99450826",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153504",
                                          "variationId": "99450835"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99450828",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153504",
                                          "variationId": "99450837"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99450830",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153504",
                                          "variationId": "99450838"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99450832",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153504",
                                          "variationId": "99450844"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153504",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99450833",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 669,
                                        "id": "99450834",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "default": 1,
                                        "id": "99450835",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 279,
                                        "id": "99450836",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 499,
                                        "id": "99450837",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 548,
                                        "id": "99450838",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 324,
                                        "id": "99450840",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 279,
                                        "id": "99450842",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 499,
                                        "id": "99450844",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450826"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450833"
                                      }
                                    ],
                                    "price": 24900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450826"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450834"
                                      }
                                    ],
                                    "price": 66900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450826"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450835"
                                      }
                                    ],
                                    "price": 44900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450828"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450836"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450828"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450837"
                                      }
                                    ],
                                    "price": 49900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450830"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450838"
                                      }
                                    ],
                                    "price": 54800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450830"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450840"
                                      }
                                    ],
                                    "price": 32400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450832"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450842"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153503",
                                        "variationId": "99450832"
                                      },
                                      {
                                        "groupId": "32153504",
                                        "variationId": "99450844"
                                      }
                                    ],
                                    "price": 49900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117102354",
                              "name": "Blazing Chicken & Paprika",
                              "category": "New Launches",
                              "description": "Hot & spicy chicken pizza with a combination of chicken keema & red paprika toppings and a new spicy peri peri sauce.",
                              "imageId": "79fb72c49aec9dc8c5b422a3a3753693",
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153497",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99450792",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153498",
                                          "variationId": "99450804"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99450794",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153498",
                                          "variationId": "99450806"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99450796",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153498",
                                          "variationId": "99450807"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99450798",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153498",
                                          "variationId": "99450810"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153498",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99450800",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 669,
                                        "id": "99450802",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "default": 1,
                                        "id": "99450804",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 279,
                                        "id": "99450805",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 499,
                                        "id": "99450806",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 548,
                                        "id": "99450807",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 324,
                                        "id": "99450808",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 279,
                                        "id": "99450809",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 499,
                                        "id": "99450810",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450792"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450800"
                                      }
                                    ],
                                    "price": 24900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450792"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450802"
                                      }
                                    ],
                                    "price": 66900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450792"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450804"
                                      }
                                    ],
                                    "price": 44900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450794"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450805"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450794"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450806"
                                      }
                                    ],
                                    "price": 49900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450796"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450807"
                                      }
                                    ],
                                    "price": 54800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450796"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450808"
                                      }
                                    ],
                                    "price": 32400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450798"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450809"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153497",
                                        "variationId": "99450798"
                                      },
                                      {
                                        "groupId": "32153498",
                                        "variationId": "99450810"
                                      }
                                    ],
                                    "price": 49900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Party Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113677416",
                              "name": "Party for 2 (Non-Veg) @Rs. 85 off",
                              "category": "Party Combo",
                              "description": "Regular Pepper BBQ Chicken + Regular Chicken Sausage + Garlic Bread + Pepsi",
                              "imageId": "b2b07382e9a1c33796829dcfab95428c",
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113677419",
                              "name": "Dominator Party for 4 (Non-Veg) @Rs. 300 off",
                              "category": "Party Combo",
                              "description": "Medium Non Veg Supreme + Medium Chicken Dominator + Garlic Bread + 2 Pepsi",
                              "imageId": "2ac327c07a5ac7a1455171586b893850",
                              "price": 115900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113677424",
                              "name": "Party for 2 (Veg) @Rs. 75 off",
                              "category": "Party Combo",
                              "description": "Regular Margherita +Regular  Farmhouse + Garlic Bread + Pepsi",
                              "imageId": "69a16e7d310b785ab043441281e6f973",
                              "isVeg": 1,
                              "price": 46900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113677426",
                              "name": "Extravaganza Party for 2 (Veg) @Rs. 110 off",
                              "category": "Party Combo",
                              "description": "Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Garlic Bread + Pepsi",
                              "imageId": "e7d6d932c362d6c172c4f502aa17072d",
                              "isVeg": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113677427",
                              "name": "Special Party for 4 (Veg) @Rs. 180 off",
                              "category": "Party Combo",
                              "description": "Medium Peppy Paneer + Medium Farmhouse + Garlic Bread + 2 Pepsi",
                              "imageId": "31c36b0f76effabbde5a3ad6c2fcad4a",
                              "isVeg": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119164801",
                              "name": "Special Party for 2 (Non-Veg) @Rs. 115 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Pepper BBQ Chicken + Regular Chicken Dominator with Garlic Bread & Pepsi",
                              "imageId": "882841f991c215d5a0699da366ccc768",
                              "price": 67900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119164802",
                              "name": "Dominator Party for 2 (Non-Veg) @Rs. 140 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Non Veg Supreme + Regular Chicken Dominator with Garlic Bread & Pepsi",
                              "imageId": "6019078c15eb870a338a326876250638",
                              "price": 76900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119164803",
                              "name": "Party for 4 (Veg) @Rs. 130 off",
                              "category": "Party Combo",
                              "description": "Meal for 4: Medium Margherita + Medium Farmhouse with Garlic Bread & 2 Pepsi",
                              "imageId": "faf4ef937df8355ffce5dd37b972a8a2",
                              "isVeg": 1,
                              "price": 82900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119164804",
                              "name": "Pizza Party for 4 (Veg) @Rs. 180 Off",
                              "category": "Party Combo",
                              "description": "Meal for 4: Regular Veg Extravaganza + Regular Indi Tandoori Paneer + Regular Farmhouse + Regular Veggie Paradise",
                              "imageId": "0cd4398343d013e2feeeb691be0a1f6b",
                              "isVeg": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125890359",
                              "name": "Special Party for 2 (Veg) @Rs. 105 off",
                              "category": "Party Combo",
                              "description": "Regular Farmhouse + Regular Peppy Paneer + Garlic Bread + Pepsi",
                              "imageId": "18ff34273573710b73a2e59e93f981c8",
                              "isVeg": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131414811",
                              "name": "Match Day Veg Combo @Rs. 110 off",
                              "category": "Party Combo",
                              "description": "Meal for 2: Regular Veg Extravaganza + Regular Indi Tandoori Paneer with Chocolava Cake & Pepsi",
                              "imageId": "980e6b393c0abe57c0e0a37dbd79bdda",
                              "isVeg": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854988",
                              "name": "Margherita Pizza",
                              "category": "Veg Pizza",
                              "description": "Classic delight with 100% real mozzarella cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "39e8f7a1cb3398d997ce415cc86210db",
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153620",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99451477",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153624",
                                          "variationId": "99451508"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99451483",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153624",
                                          "variationId": "99451515"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99451487",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153624",
                                          "variationId": "99451517"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99451491",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153624",
                                          "variationId": "99451526"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99451495",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153624",
                                          "variationId": "99451528"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153624",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 109,
                                        "id": "99451501",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 479,
                                        "id": "99451505",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 259,
                                        "default": 1,
                                        "id": "99451508",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 139,
                                        "id": "99451511",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 309,
                                        "id": "99451515",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 358,
                                        "id": "99451517",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 184,
                                        "id": "99451521",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 139,
                                        "id": "99451524",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 309,
                                        "id": "99451526",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 109,
                                        "id": "99451528",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451477"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451501"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451477"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451505"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451477"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451508"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451483"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451511"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451483"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451515"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451487"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451517"
                                      }
                                    ],
                                    "price": 35800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451487"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451521"
                                      }
                                    ],
                                    "price": 18400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451491"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451524"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451491"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451526"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153620",
                                        "variationId": "99451495"
                                      },
                                      {
                                        "groupId": "32153624",
                                        "variationId": "99451528"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819910",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110819910",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "401 ratings",
                                  "ratingCountV2": "401"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854996",
                              "name": "Double Cheese Margherita Pizza",
                              "category": "Veg Pizza",
                              "description": "A classic delight loaded with extra 100% real mozzarella cheese",
                              "imageId": "eb10d3bbeea43e9150307a8ebb32b220",
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154225",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99454520",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154226",
                                          "variationId": "99454531"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99454521",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154226",
                                          "variationId": "99454536"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99454522",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154226",
                                          "variationId": "99454539"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99454523",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154226",
                                          "variationId": "99454548"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99454524",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154226",
                                          "variationId": "99454550"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154226",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99454525",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 639,
                                        "id": "99454528",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "default": 1,
                                        "id": "99454531",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99454534",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99454536",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 498,
                                        "id": "99454539",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 294,
                                        "id": "99454542",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99454545",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99454548",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99454550",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454520"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454525"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454520"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454528"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454520"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454531"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454521"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454534"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454521"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454536"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454522"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454539"
                                      }
                                    ],
                                    "price": 49800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454522"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454542"
                                      }
                                    ],
                                    "price": 29400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454523"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454545"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454523"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454548"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154225",
                                        "variationId": "99454524"
                                      },
                                      {
                                        "groupId": "32154226",
                                        "variationId": "99454550"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820074",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820074",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "179 ratings",
                                  "ratingCountV2": "179"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855009",
                              "name": "Fresh Veggie Pizza",
                              "category": "Veg Pizza",
                              "description": "Delectable combination of onion & capsicum, a veggie lovers pick",
                              "imageId": "4f3395d60363f951a7f9e2debbc352f2",
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154988",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99458344",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154989",
                                          "variationId": "99458351"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99458345",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154989",
                                          "variationId": "99458355"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99458346",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154989",
                                          "variationId": "99458358"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99458347",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154989",
                                          "variationId": "99458365"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99458348",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154989",
                                          "variationId": "99458374"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154989",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458349",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 639,
                                        "id": "99458350",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "default": 1,
                                        "id": "99458351",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99458352",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99458355",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 498,
                                        "id": "99458358",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 294,
                                        "id": "99458359",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99458360",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99458365",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458374",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458344"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458349"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458344"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458350"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458344"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458351"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458345"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458352"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458345"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458355"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458346"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458358"
                                      }
                                    ],
                                    "price": 49800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458346"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458359"
                                      }
                                    ],
                                    "price": 29400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458347"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458360"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458347"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458365"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154988",
                                        "variationId": "99458348"
                                      },
                                      {
                                        "groupId": "32154989",
                                        "variationId": "99458374"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820269",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820269",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855015",
                              "name": "Farmhouse Pizza",
                              "category": "Veg Pizza",
                              "description": "Delightful combination of onion, capsicum, tomato & grilled mushroom. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "f7ef8df0fed856ee03c983f156fbb68d",
                              "isVeg": 1,
                              "price": 47900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153671",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99451727",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153674",
                                          "variationId": "99451758"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99451732",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153674",
                                          "variationId": "99451764"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99451736",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153674",
                                          "variationId": "99451768"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99451741",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153674",
                                          "variationId": "99451777"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99451744",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153674",
                                          "variationId": "99451781"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153674",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99451750",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 719,
                                        "id": "99451755",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 479,
                                        "default": 1,
                                        "id": "99451758",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99451761",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99451764",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 578,
                                        "id": "99451768",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 344,
                                        "id": "99451770",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99451774",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99451777",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99451781",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451727"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451750"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451727"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451755"
                                      }
                                    ],
                                    "price": 71900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451727"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451758"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451732"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451761"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451732"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451764"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451736"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451768"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451736"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451770"
                                      }
                                    ],
                                    "price": 34400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451741"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451774"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451741"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451777"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153671",
                                        "variationId": "99451744"
                                      },
                                      {
                                        "groupId": "32153674",
                                        "variationId": "99451781"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819923",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110819923",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 47900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "203 ratings",
                                  "ratingCountV2": "203"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855021",
                              "name": "Peppy Paneer Pizza",
                              "category": "Veg Pizza",
                              "description": "Flavorful trio of juicy paneer, crisp capsicum with spicy red paprika",
                              "imageId": "81fbe5f6e8576cc7bdae699c3900197c",
                              "isVeg": 1,
                              "price": 47900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154261",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99454647",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154269",
                                          "variationId": "99454682"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99454649",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154269",
                                          "variationId": "99454690"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99454651",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154269",
                                          "variationId": "99454697"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99454656",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154269",
                                          "variationId": "99454704"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99454663",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154269",
                                          "variationId": "99454708"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154269",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99454674",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 719,
                                        "id": "99454679",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 479,
                                        "default": 1,
                                        "id": "99454682",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99454686",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99454690",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 344,
                                        "id": "99454693",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 578,
                                        "id": "99454697",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99454700",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99454704",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99454708",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454647"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454674"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454647"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454679"
                                      }
                                    ],
                                    "price": 71900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454647"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454682"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454649"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454686"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454649"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454690"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454651"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454693"
                                      }
                                    ],
                                    "price": 34400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454651"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454697"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454656"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454700"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454656"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454704"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154261",
                                        "variationId": "99454663"
                                      },
                                      {
                                        "groupId": "32154269",
                                        "variationId": "99454708"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820081",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820081",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 47900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "134 ratings",
                                  "ratingCountV2": "134"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855027",
                              "name": "Mexican Green Wave Pizza",
                              "category": "Veg Pizza",
                              "description": "Mexican herbs sprinkled on onion, capsicum, tomato & jalapeno",
                              "imageId": "d8c9b9418213d3d7f813808d91a98fbc",
                              "isVeg": 1,
                              "price": 47900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154308",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99454867",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154316",
                                          "variationId": "99454909"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99454871",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154316",
                                          "variationId": "99454915"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99454875",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154316",
                                          "variationId": "99454929"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99454880",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154316",
                                          "variationId": "99454951"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99454886",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154316",
                                          "variationId": "99454959"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154316",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99454897",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 719,
                                        "id": "99454902",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 479,
                                        "default": 1,
                                        "id": "99454909",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99454915",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99454922",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 578,
                                        "id": "99454929",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 344,
                                        "id": "99454936",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99454943",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99454951",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99454959",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454867"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454897"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454867"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454902"
                                      }
                                    ],
                                    "price": 71900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454867"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454909"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454871"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454915"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454871"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454922"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454875"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454929"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454875"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454936"
                                      }
                                    ],
                                    "price": 34400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454880"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454943"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454880"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454951"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154308",
                                        "variationId": "99454886"
                                      },
                                      {
                                        "groupId": "32154316",
                                        "variationId": "99454959"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820093",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820093",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 47900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "97 ratings",
                                  "ratingCountV2": "97"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855033",
                              "name": "Veggie Paradise Pizza",
                              "category": "Veg Pizza",
                              "description": "The awesome foursome! Golden corn, black olives, capsicum, red paprika",
                              "imageId": "d256f07dc0da10e511f6442ee0886131",
                              "isVeg": 1,
                              "price": 47900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154361",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99455094",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154363",
                                          "variationId": "99455123"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99455099",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154363",
                                          "variationId": "99455129"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99455103",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154363",
                                          "variationId": "99455130"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99455108",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154363",
                                          "variationId": "99455137"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99455113",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154363",
                                          "variationId": "99455141"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154363",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99455119",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 719,
                                        "id": "99455122",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 479,
                                        "default": 1,
                                        "id": "99455123",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99455126",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99455129",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 578,
                                        "id": "99455130",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 344,
                                        "id": "99455132",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 299,
                                        "id": "99455134",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 529,
                                        "id": "99455137",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 269,
                                        "id": "99455141",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455094"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455119"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455094"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455122"
                                      }
                                    ],
                                    "price": 71900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455094"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455123"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455099"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455126"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455099"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455129"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455103"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455130"
                                      }
                                    ],
                                    "price": 57800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455103"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455132"
                                      }
                                    ],
                                    "price": 34400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455108"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455134"
                                      }
                                    ],
                                    "price": 29900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455108"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455137"
                                      }
                                    ],
                                    "price": 52900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154361",
                                        "variationId": "99455113"
                                      },
                                      {
                                        "groupId": "32154363",
                                        "variationId": "99455141"
                                      }
                                    ],
                                    "price": 26900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820102",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820102",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 47900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17855050",
                              "name": "Veg Extravaganza Pizza",
                              "category": "Veg Pizza",
                              "description": "Black olives, capsicum, onion, grilled mushroom, corn, tomato, jalapeno & extra cheese. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "b337ca46e24a31366f59f64d3ad923f5",
                              "isVeg": 1,
                              "price": 57900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153694",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99451842",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153699",
                                          "variationId": "99451881"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99451850",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153699",
                                          "variationId": "99451900"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99451856",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153699",
                                          "variationId": "99451905"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99451863",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153699",
                                          "variationId": "99451918"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99451870",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153699",
                                          "variationId": "99451922"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153699",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Medium",
                                        "price": 579,
                                        "default": 1,
                                        "id": "99451881",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99451884",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 839,
                                        "id": "99451891",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99451894",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99451900",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 678,
                                        "id": "99451905",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 394,
                                        "id": "99451908",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99451914",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99451918",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99451922",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451842"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451881"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451842"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451884"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451842"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451891"
                                      }
                                    ],
                                    "price": 83900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451850"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451894"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451850"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451900"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451856"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451905"
                                      }
                                    ],
                                    "price": 67800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451856"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451908"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451863"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451914"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451863"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451918"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153694",
                                        "variationId": "99451870"
                                      },
                                      {
                                        "groupId": "32153699",
                                        "variationId": "99451922"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819930",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110819930",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 57900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "192 ratings",
                                  "ratingCountV2": "192"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42320708",
                              "name": "Indi Tandoori Paneer Pizza",
                              "category": "Veg Pizza",
                              "description": "It is hot. It is spicy. It is oh-so-Indian. Tandoori paneer with capsicum, red paprika & mint mayo. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "3f7b4790495d3ad00cc5de3c40edb8d3",
                              "isVeg": 1,
                              "price": 57900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153722",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99452032",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153725",
                                          "variationId": "99452071"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99452036",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153725",
                                          "variationId": "99452080"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99452041",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153725",
                                          "variationId": "99452084"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99452048",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153725",
                                          "variationId": "99452091"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99452055",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153725",
                                          "variationId": "99452093"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153725",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99452061",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 839,
                                        "id": "99452066",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 579,
                                        "default": 1,
                                        "id": "99452071",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99452076",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99452080",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 678,
                                        "id": "99452084",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 394,
                                        "id": "99452087",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99452089",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99452091",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99452093",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452032"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452061"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452032"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452066"
                                      }
                                    ],
                                    "price": 83900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452032"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452071"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452036"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452076"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452036"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452080"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452041"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452084"
                                      }
                                    ],
                                    "price": 67800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452041"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452087"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452048"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452089"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452048"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452091"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153722",
                                        "variationId": "99452055"
                                      },
                                      {
                                        "groupId": "32153725",
                                        "variationId": "99452093"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819941",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110819941",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 57900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "58 ratings",
                                  "ratingCountV2": "58"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "46230005",
                              "name": "Achari Do Pyaza Pizza",
                              "category": "Veg Pizza",
                              "description": "Tangy & spicy achari flavours on a super cheesy onion pizza- as desi as it gets!",
                              "imageId": "c47f616328092869ed0def9f53df2767",
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155053",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99458656",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155062",
                                          "variationId": "99458690"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99458658",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155062",
                                          "variationId": "99458698"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99458661",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155062",
                                          "variationId": "99458702"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99458665",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155062",
                                          "variationId": "99458714"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99458673",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155062",
                                          "variationId": "99458717"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155062",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 189,
                                        "id": "99458680",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 579,
                                        "id": "99458685",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 349,
                                        "default": 1,
                                        "id": "99458690",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458695",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "id": "99458698",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 448,
                                        "id": "99458702",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 264,
                                        "id": "99458706",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458710",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "id": "99458714",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 189,
                                        "id": "99458717",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458656"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458680"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458656"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458685"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458656"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458690"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458658"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458695"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458658"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458698"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458661"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458702"
                                      }
                                    ],
                                    "price": 44800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458661"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458706"
                                      }
                                    ],
                                    "price": 26400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458665"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458710"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458665"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458714"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155053",
                                        "variationId": "99458673"
                                      },
                                      {
                                        "groupId": "32155062",
                                        "variationId": "99458717"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820289",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820289",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 34900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "75124549",
                              "name": "The 4 Cheese Pizza",
                              "category": "Veg Pizza",
                              "description": "Cheese Overloaded pizza with 4 different varieties of cheese and 4 times the cheese of a normal pizza, including a spicy hit of Ghost Pepper flavoured Cheese",
                              "imageId": "eb5d446692bda65257a1c5d3fbd6d79f",
                              "isVeg": 1,
                              "price": 63900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32153644",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99451594",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153647",
                                          "variationId": "99451612"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99451597",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153647",
                                          "variationId": "99451619"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99451599",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153647",
                                          "variationId": "99451626"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99451602",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32153647",
                                          "variationId": "99451629"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32153647",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99451605",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 959,
                                        "id": "99451609",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 639,
                                        "default": 1,
                                        "id": "99451612",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 379,
                                        "id": "99451617",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 689,
                                        "id": "99451619",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 379,
                                        "id": "99451623",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 689,
                                        "id": "99451626",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99451629",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451594"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451605"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451594"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451609"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451594"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451612"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451597"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451617"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451597"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451619"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451599"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451623"
                                      }
                                    ],
                                    "price": 37900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451599"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451626"
                                      }
                                    ],
                                    "price": 68900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32153644",
                                        "variationId": "99451602"
                                      },
                                      {
                                        "groupId": "32153647",
                                        "variationId": "99451629"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110819916",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110819916",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 63900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91331896",
                              "name": "Corn n Cheese Paratha Pizza",
                              "category": "Veg Pizza",
                              "description": "A crazy fusion like never before. A delicious fusion of corn stuffed paratha and cheesy pizza.",
                              "imageId": "bc38205c7acfe96175b160571f5d6a21",
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32154189",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "default": 1,
                                        "id": "99454366",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32154190",
                                          "variationId": "99454367"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32154190",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 189,
                                        "default": 1,
                                        "id": "99454367",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32154189",
                                        "variationId": "99454366"
                                      },
                                      {
                                        "groupId": "32154190",
                                        "variationId": "99454367"
                                      }
                                    ],
                                    "price": 18900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109956259",
                              "name": "Cheese n Corn Pizza",
                              "category": "Veg Pizza",
                              "description": "A delectable combination of sweet & juicy golden corn",
                              "imageId": "8245b4fd8d77f1c594c220a228ebeb97",
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155024",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99458511",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155027",
                                          "variationId": "99458543"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99458514",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155027",
                                          "variationId": "99458551"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99458518",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155027",
                                          "variationId": "99458554"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99458522",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155027",
                                          "variationId": "99458570"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99458531",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155027",
                                          "variationId": "99458575"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155027",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458534",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 639,
                                        "id": "99458538",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 399,
                                        "default": 1,
                                        "id": "99458543",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99458547",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99458551",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 498,
                                        "id": "99458554",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 294,
                                        "id": "99458557",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 249,
                                        "id": "99458564",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 449,
                                        "id": "99458570",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 219,
                                        "id": "99458575",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458511"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458534"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458511"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458538"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458511"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458543"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458514"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458547"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458514"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458551"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458518"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458554"
                                      }
                                    ],
                                    "price": 49800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458518"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458557"
                                      }
                                    ],
                                    "price": 29400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458522"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458564"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458522"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458570"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155024",
                                        "variationId": "99458531"
                                      },
                                      {
                                        "groupId": "32155027",
                                        "variationId": "99458575"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820282",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820282",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 39900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non-Veg Pizza",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854951",
                              "name": "Chicken Golden Delight Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Double pepper barbecue chicken, golden corn and extra cheese, true delight",
                              "imageId": "62f3e2a1a523da9f291734686a75825b",
                              "price": 57900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156699",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99467717",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156702",
                                          "variationId": "99467735"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99467720",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156702",
                                          "variationId": "99467737"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99467722",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156702",
                                          "variationId": "99467742"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99467724",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156702",
                                          "variationId": "99467752"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99467727",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156702",
                                          "variationId": "99467755"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156702",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99467730",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 859,
                                        "id": "99467733",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 579,
                                        "default": 1,
                                        "id": "99467735",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99467737",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99467739",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 678,
                                        "id": "99467742",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 394,
                                        "id": "99467746",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99467749",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99467752",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99467755",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467717"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467730"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467717"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467733"
                                      }
                                    ],
                                    "price": 85900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467717"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467735"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467720"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467737"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467720"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467739"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467722"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467742"
                                      }
                                    ],
                                    "price": 67800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467722"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467746"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467724"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467749"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467724"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467752"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156699",
                                        "variationId": "99467727"
                                      },
                                      {
                                        "groupId": "32156702",
                                        "variationId": "99467755"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820832",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820832",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 57900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854956",
                              "name": "Chicken Fiesta Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Grilled chicken rashers, peri-peri chicken, onion & capsicum, a complete fiesta",
                              "imageId": "db57310aee78264b1db8505abe9f81f7",
                              "price": 57900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156053",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99464311",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156058",
                                          "variationId": "99464330"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99464315",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156058",
                                          "variationId": "99464336"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99464317",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156058",
                                          "variationId": "99464340"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99464319",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156058",
                                          "variationId": "99464346"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99464321",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156058",
                                          "variationId": "99464349"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156058",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99464324",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 859,
                                        "id": "99464327",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 579,
                                        "default": 1,
                                        "id": "99464330",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99464333",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99464336",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 394,
                                        "id": "99464337",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 678,
                                        "id": "99464340",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 349,
                                        "id": "99464343",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 629,
                                        "id": "99464346",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 319,
                                        "id": "99464349",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464311"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464324"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464311"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464327"
                                      }
                                    ],
                                    "price": 85900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464311"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464330"
                                      }
                                    ],
                                    "price": 57900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464315"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464333"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464315"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464336"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464317"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464337"
                                      }
                                    ],
                                    "price": 39400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464317"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464340"
                                      }
                                    ],
                                    "price": 67800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464319"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464343"
                                      }
                                    ],
                                    "price": 34900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464319"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464346"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156053",
                                        "variationId": "99464321"
                                      },
                                      {
                                        "groupId": "32156058",
                                        "variationId": "99464349"
                                      }
                                    ],
                                    "price": 31900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820631",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820631",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 57900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25931895",
                              "name": "Chicken Pepperoni Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "A classic American taste! Relish the delectable flavor of Chicken Pepperoni, topped with extra cheese",
                              "imageId": "1c5f2d5151e17a13d4d6e3cae89dfc63",
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156740",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99467979",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156741",
                                          "variationId": "99467994"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99467982",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156741",
                                          "variationId": "99467997"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99467983",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156741",
                                          "variationId": "99467999"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99467986",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156741",
                                          "variationId": "99468004"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99467988",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156741",
                                          "variationId": "99468005"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156741",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99467990",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 959,
                                        "id": "99467992",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 619,
                                        "default": 1,
                                        "id": "99467994",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99467996",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99467997",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 718,
                                        "id": "99467999",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 444,
                                        "id": "99468001",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99468003",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99468004",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99468005",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467979"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467990"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467979"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467992"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467979"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467994"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467982"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467996"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467982"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467997"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467983"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99467999"
                                      }
                                    ],
                                    "price": 71800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467983"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99468001"
                                      }
                                    ],
                                    "price": 44400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467986"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99468003"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467986"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99468004"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156740",
                                        "variationId": "99467988"
                                      },
                                      {
                                        "groupId": "32156741",
                                        "variationId": "99468005"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820846",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820846",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "66 ratings",
                                  "ratingCountV2": "66"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25931896",
                              "name": "Chicken Dominator Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Loaded with double pepper barbecue chicken, peri-peri chicken, chicken tikka & grilled chicken rashers. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "961822219e2fcbe797bb532c84bbcf14",
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155906",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99463414",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155913",
                                          "variationId": "99463480"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99463425",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155913",
                                          "variationId": "99463497"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99463434",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155913",
                                          "variationId": "99463506"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99463442",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155913",
                                          "variationId": "99463524"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99463451",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155913",
                                          "variationId": "99463531"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155913",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99463462",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 959,
                                        "id": "99463471",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 619,
                                        "default": 1,
                                        "id": "99463480",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99463489",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99463497",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 718,
                                        "id": "99463506",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 444,
                                        "id": "99463513",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99463519",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99463524",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99463531",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463414"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463462"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463414"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463471"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463414"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463480"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463425"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463489"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463425"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463497"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463434"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463506"
                                      }
                                    ],
                                    "price": 71800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463434"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463513"
                                      }
                                    ],
                                    "price": 44400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463442"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463519"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463442"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463524"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155906",
                                        "variationId": "99463451"
                                      },
                                      {
                                        "groupId": "32155913",
                                        "variationId": "99463531"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820583",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820583",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "42320707",
                              "name": "Indi Chicken Tikka Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "The wholesome flavour of tandoori masala with Chicken tikka, onion, red paprika & mint mayo",
                              "imageId": "90baa57b161d5dad43c3db433b8b8e25",
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156745",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99468020",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156746",
                                          "variationId": "99468033"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99468021",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156746",
                                          "variationId": "99468036"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99468024",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156746",
                                          "variationId": "99468039"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99468025",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156746",
                                          "variationId": "99468047"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99468028",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156746",
                                          "variationId": "99468049"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156746",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99468030",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 959,
                                        "id": "99468032",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 619,
                                        "default": 1,
                                        "id": "99468033",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99468035",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99468036",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 718,
                                        "id": "99468039",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 444,
                                        "id": "99468042",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99468044",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99468047",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99468049",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468020"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468030"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468020"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468032"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468020"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468033"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468021"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468035"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468021"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468036"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468024"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468039"
                                      }
                                    ],
                                    "price": 71800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468024"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468042"
                                      }
                                    ],
                                    "price": 44400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468025"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468044"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468025"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468047"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156745",
                                        "variationId": "99468028"
                                      },
                                      {
                                        "groupId": "32156746",
                                        "variationId": "99468049"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820849",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820849",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53167531",
                              "name": "Chicken Sausage Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "American classic! Spicy, herbed chicken sausage on pizza",
                              "imageId": "8c42f29cf116cadcac1577414bd9a21a",
                              "price": 38900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156026",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99464134",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156032",
                                          "variationId": "99464175"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99464139",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156032",
                                          "variationId": "99464183"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99464144",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156032",
                                          "variationId": "99464187"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99464149",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156032",
                                          "variationId": "99464194"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99464155",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156032",
                                          "variationId": "99464196"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156032",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99464165",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 629,
                                        "id": "99464170",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 389,
                                        "default": 1,
                                        "id": "99464175",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 239,
                                        "id": "99464179",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 439,
                                        "id": "99464183",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 488,
                                        "id": "99464187",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 284,
                                        "id": "99464190",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 239,
                                        "id": "99464192",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 439,
                                        "id": "99464194",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 209,
                                        "id": "99464196",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464134"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464165"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464134"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464170"
                                      }
                                    ],
                                    "price": 62900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464134"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464175"
                                      }
                                    ],
                                    "price": 38900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464139"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464179"
                                      }
                                    ],
                                    "price": 23900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464139"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464183"
                                      }
                                    ],
                                    "price": 43900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464144"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464187"
                                      }
                                    ],
                                    "price": 48800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464144"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464190"
                                      }
                                    ],
                                    "price": 28400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464149"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464192"
                                      }
                                    ],
                                    "price": 23900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464149"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464194"
                                      }
                                    ],
                                    "price": 43900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156026",
                                        "variationId": "99464155"
                                      },
                                      {
                                        "groupId": "32156032",
                                        "variationId": "99464196"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820622",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820622",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 38900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82815440",
                              "name": "Spiced Double Chicken",
                              "category": "Non-Veg Pizza",
                              "description": "Delightful combination of our spicy duo- Pepper Barbecue Chicken and Peri Peri Chicken for Chicken Lovers.",
                              "imageId": "452758e698a5988c079289db39f64121",
                              "price": 55900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155995",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99463989",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155996",
                                          "variationId": "99464000"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99463991",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155996",
                                          "variationId": "99464006"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99463993",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155996",
                                          "variationId": "99464011"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99463995",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155996",
                                          "variationId": "99464025"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99463996",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155996",
                                          "variationId": "99464030"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155996",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 309,
                                        "id": "99463997",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 829,
                                        "id": "99463998",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 559,
                                        "default": 1,
                                        "id": "99464000",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 339,
                                        "id": "99464002",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 609,
                                        "id": "99464006",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 658,
                                        "id": "99464011",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 384,
                                        "id": "99464016",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 339,
                                        "id": "99464020",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 609,
                                        "id": "99464025",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 309,
                                        "id": "99464030",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463989"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99463997"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463989"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99463998"
                                      }
                                    ],
                                    "price": 82900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463989"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464000"
                                      }
                                    ],
                                    "price": 55900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463991"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464002"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463991"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464006"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463993"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464011"
                                      }
                                    ],
                                    "price": 65800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463993"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464016"
                                      }
                                    ],
                                    "price": 38400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463995"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464020"
                                      }
                                    ],
                                    "price": 33900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463995"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464025"
                                      }
                                    ],
                                    "price": 60900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155995",
                                        "variationId": "99463996"
                                      },
                                      {
                                        "groupId": "32155996",
                                        "variationId": "99464030"
                                      }
                                    ],
                                    "price": 30900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820613",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820613",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 55900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82815465",
                              "name": "The 5 Chicken Feast Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Loaded with 5 different Chicken toppings - grilled Chicken Rashers, Chicken Meatballs, Chicken Tikka, herby Chicken Sausage and flavorful Chicken Keema",
                              "imageId": "92056e4c5422b00c66c620f015d6fed0",
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155967",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99463783",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155969",
                                          "variationId": "99463804"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99463785",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155969",
                                          "variationId": "99463809"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99463788",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155969",
                                          "variationId": "99463812"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99463792",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155969",
                                          "variationId": "99463819"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99463795",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155969",
                                          "variationId": "99463821"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155969",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99463799",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 1029,
                                        "id": "99463802",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 699,
                                        "default": 1,
                                        "id": "99463804",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 429,
                                        "id": "99463807",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 749,
                                        "id": "99463809",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 798,
                                        "id": "99463812",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 474,
                                        "id": "99463815",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 429,
                                        "id": "99463818",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 749,
                                        "id": "99463819",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99463821",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463783"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463799"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463783"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463802"
                                      }
                                    ],
                                    "price": 102900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463783"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463804"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463785"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463807"
                                      }
                                    ],
                                    "price": 42900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463785"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463809"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463788"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463812"
                                      }
                                    ],
                                    "price": 79800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463788"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463815"
                                      }
                                    ],
                                    "price": 47400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463792"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463818"
                                      }
                                    ],
                                    "price": 42900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463792"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463819"
                                      }
                                    ],
                                    "price": 74900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155967",
                                        "variationId": "99463795"
                                      },
                                      {
                                        "groupId": "32155969",
                                        "variationId": "99463821"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820602",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820602",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 69900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91331898",
                              "name": "Chicken Keema Paratha Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Flavourful & meaty chicken keema paratha and goodness of cheesy pizza coming together in an epic crossover!",
                              "imageId": "6067034a9808a1736edf7bbe9c878df2",
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155945",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "default": 1,
                                        "id": "99463658",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155949",
                                          "variationId": "99463666"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155949",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 259,
                                        "default": 1,
                                        "id": "99463666",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155945",
                                        "variationId": "99463658"
                                      },
                                      {
                                        "groupId": "32155949",
                                        "variationId": "99463666"
                                      }
                                    ],
                                    "price": 25900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 25900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91866133",
                              "name": "Non Veg Supreme Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Supreme combination of black olives, onion, capsicum, grilled mushroom, pepper barbecue chicken, peri-peri chicken & grilled chicken rashers",
                              "imageId": "ede2338303b3edde0d19389256353319",
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32156719",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99467856",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156722",
                                          "variationId": "99467878"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99467858",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156722",
                                          "variationId": "99467885"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99467861",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156722",
                                          "variationId": "99467890"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99467864",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156722",
                                          "variationId": "99467899"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99467867",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32156722",
                                          "variationId": "99467902"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32156722",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99467871",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 959,
                                        "id": "99467875",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 619,
                                        "default": 1,
                                        "id": "99467878",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99467881",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99467885",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 718,
                                        "id": "99467890",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 444,
                                        "id": "99467894",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 399,
                                        "id": "99467897",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 669,
                                        "id": "99467899",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 369,
                                        "id": "99467902",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467856"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467871"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467856"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467875"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467856"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467878"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467858"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467881"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467858"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467885"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467861"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467890"
                                      }
                                    ],
                                    "price": 71800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467861"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467894"
                                      }
                                    ],
                                    "price": 44400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467864"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467897"
                                      }
                                    ],
                                    "price": 39900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467864"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467899"
                                      }
                                    ],
                                    "price": 66900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32156719",
                                        "variationId": "99467867"
                                      },
                                      {
                                        "groupId": "32156722",
                                        "variationId": "99467902"
                                      }
                                    ],
                                    "price": 36900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820841",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820841",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91866619",
                              "name": "Pepper Barbecue Chicken Pizza",
                              "category": "Non-Veg Pizza",
                              "description": "Pepper barbecue chicken for that extra zing. Available in Cheese Burst, Wheat Thin Crust and Pan Crust options.",
                              "imageId": "ecc5cbac9986d029ab0ed179667a6625",
                              "price": 46900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32155883",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "New Hand Tossed",
                                        "default": 1,
                                        "id": "99463287",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155886",
                                          "variationId": "99463323"
                                        }
                                      },
                                      {
                                        "name": "100% Wheat Thin Crust",
                                        "id": "99463292",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155886",
                                          "variationId": "99463330"
                                        }
                                      },
                                      {
                                        "name": "Cheese Burst",
                                        "id": "99463298",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155886",
                                          "variationId": "99463332"
                                        }
                                      },
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99463304",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155886",
                                          "variationId": "99463334"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "99463308",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32155886",
                                          "variationId": "99463336"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32155886",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 259,
                                        "id": "99463315",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large",
                                        "price": 699,
                                        "id": "99463319",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 469,
                                        "default": 1,
                                        "id": "99463323",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 289,
                                        "id": "99463327",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 519,
                                        "id": "99463330",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 568,
                                        "id": "99463332",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 334,
                                        "id": "99463333",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Medium",
                                        "price": 519,
                                        "id": "99463334",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 289,
                                        "id": "99463335",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 259,
                                        "id": "99463336",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463287"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463315"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463287"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463319"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988205"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988225"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988245"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988213"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988248"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988216"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988232"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988239"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988247"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988234"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988207"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988228"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988215"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988204"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988244"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988223"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463287"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463323"
                                      }
                                    ],
                                    "price": 46900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463292"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463327"
                                      }
                                    ],
                                    "price": 28900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463292"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463330"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463298"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463332"
                                      }
                                    ],
                                    "price": 56800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463298"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463333"
                                      }
                                    ],
                                    "price": 33400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463304"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463334"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988236"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988210"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988230"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988226"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988220"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988208"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988214"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988217"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988219"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988211"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988231"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988206"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988238"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988237"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988221"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988240"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463304"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463335"
                                      }
                                    ],
                                    "price": 28900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32155883",
                                        "variationId": "99463308"
                                      },
                                      {
                                        "groupId": "32155886",
                                        "variationId": "99463336"
                                      }
                                    ],
                                    "price": 25900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988218"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988241"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988202"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988201"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988212"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988227"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988224"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988246"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988235"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988222"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988209"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988229"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988242"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988203"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988243"
                                      },
                                      {
                                        "groupId": "110820572",
                                        "addonId": "99988233"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "110820572",
                                  "groupName": "Topping",
                                  "choices": [
                                    {
                                      "id": "99988233",
                                      "name": "Onion",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988211",
                                      "name": "Chicken Sausage",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988210",
                                      "name": "Fresh Tomato",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988232",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988235",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988213",
                                      "name": "Red Pepper",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988234",
                                      "name": "Chicken Sausage",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988212",
                                      "name": "Jalapeno",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988215",
                                      "name": "Extra Cheese",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988237",
                                      "name": "Grilled Mushrooms",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988214",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988236",
                                      "name": "Crisp Capsicum",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988217",
                                      "name": "Peri - Peri Chicken",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988239",
                                      "name": "Peri - Peri Chicken",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988216",
                                      "name": "Black Olive",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988238",
                                      "name": "Extra Cheese",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988231",
                                      "name": "Chicken Tikka",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988230",
                                      "name": "Paneer",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988208",
                                      "name": "Black Olive",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988229",
                                      "name": "Chicken Pepperoni",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988207",
                                      "name": "Chicken Tikka",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988209",
                                      "name": "Chicken Tikka",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988222",
                                      "name": "Chicken Sausage",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988244",
                                      "name": "Chicken Keema",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988243",
                                      "name": "Grilled Mushrooms",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988221",
                                      "name": "Chicken Keema",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988202",
                                      "name": "Paneer",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988224",
                                      "name": "Pepper Barbecue Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988246",
                                      "name": "Peri - Peri Chicken",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988223",
                                      "name": "Onion",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988245",
                                      "name": "Paneer",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988201",
                                      "name": "Red Pepper",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988226",
                                      "name": "Red Pepper",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988248",
                                      "name": "Jalapeno",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988204",
                                      "name": "Grilled Mushrooms",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988247",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988203",
                                      "name": "Chicken Keema",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988225",
                                      "name": "Fresh Tomato",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988228",
                                      "name": "Chicken Pepperoni",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988206",
                                      "name": "Chicken Pepperoni",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988205",
                                      "name": "Crisp Capsicum",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988227",
                                      "name": "Black Olive",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988240",
                                      "name": "Onion",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988220",
                                      "name": "Jalapeno",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988242",
                                      "name": "Extra Cheese",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988241",
                                      "name": "Fresh Tomato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988219",
                                      "name": "Grilled Chicken Rasher",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99988218",
                                      "name": "Crisp Capsicum",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": -1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "23665431",
                              "name": "Pepsi 475ml",
                              "category": "Beverages",
                              "description": "Sparkling and Refreshing Beverage",
                              "imageId": "961fc39de595aa6bbd083dedfd2a29fc",
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "410 ratings",
                                  "ratingCountV2": "410"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "27974446",
                              "name": "Mirinda 475ml",
                              "category": "Beverages",
                              "description": "Delicious Orange Flavoured beverage",
                              "imageId": "a134422f5474d1000b23eb5ef9b04994",
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "48682628",
                              "name": "Pepsi Black Can 300ml",
                              "category": "Beverages",
                              "description": "Maximum Taste Zero Calories",
                              "imageId": "129f78ee910b893f06a0236407d878e7",
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51298146",
                              "name": "7Up 475ml",
                              "category": "Beverages",
                              "description": "Refreshing clear drink with a natural lemon flavor",
                              "imageId": "88b64ebc06c52b7e3d27f9a6f9966a14",
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "61312797",
                              "name": "Bailley One (500ml)",
                              "category": "Beverages",
                              "description": "Packaged Drinking Water",
                              "imageId": "19e42d1585317ec92adec8d32583c1d2",
                              "isVeg": 1,
                              "price": 1904,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69192515",
                              "name": "Lipton Ice Tea ( 350 ml)",
                              "category": "Beverages",
                              "description": "Refreshment Sahi, Gas Nahi",
                              "imageId": "e05a7a09fdebafceb9a8ccadad985e14",
                              "isVeg": 1,
                              "price": 5714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104949400",
                              "name": "Nagpur Orange",
                              "category": "Beverages",
                              "description": "Enjoy Oranges from Nagpur with the goodness of Fiber",
                              "imageId": "8ef8d9d174ce6e0777833d9116225b5d",
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854799",
                              "name": "Garlic Breadsticks",
                              "category": "Sides",
                              "description": "Baked to perfection. Your perfect pizza partner! Tastes best with dip",
                              "imageId": "62ade166fb91bf7618f3b6a625b2713c",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "620 ratings",
                                  "ratingCountV2": "620"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854805",
                              "name": "Chicken Parcel",
                              "category": "Sides",
                              "description": "Snacky bites! Pizza rolls with chicken sausage & creamy harissa sauce",
                              "imageId": "b42b881bac9c6766d5fbabfe918c761d",
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "154 ratings",
                                  "ratingCountV2": "154"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854811",
                              "name": "Veg Parcel",
                              "category": "Sides",
                              "description": "Snacky bites! Pizza rolls with paneer & creamy harissa sauce",
                              "imageId": "7923baa0f7dedaa6e8cbf979ac6f16f7",
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "171 ratings",
                                  "ratingCountV2": "171"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854821",
                              "name": "Classic Stuffed Garlic Bread",
                              "category": "Sides",
                              "description": "Freshly baked garlic bread with cheese, juicy corn & tangy jalapeno",
                              "imageId": "304902609647bdedb4c0f5a40025ebed",
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "283 ratings",
                                  "ratingCountV2": "283"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854871",
                              "name": "Cheesy Dip",
                              "category": "Sides",
                              "description": "An all-time favorite with your Garlic Breadsticks & Stuffed Garlic Bread for a Cheesy indulgence",
                              "imageId": "3c85785337901b0b676914ab72cc9135",
                              "isVeg": 1,
                              "price": 2857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "391 ratings",
                                  "ratingCountV2": "391"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854879",
                              "name": "Taco Mexicana Non Veg",
                              "category": "Sides",
                              "description": "Truly irresistible! Crispy taco with non-veg patty & creamy harissa sauce",
                              "imageId": "7011a6e2289ffd700f1e6ac27f8304ee",
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "95 ratings",
                                  "ratingCountV2": "95"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854883",
                              "name": "Taco Mexicana Veg",
                              "category": "Sides",
                              "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                              "imageId": "389bde81686bc78ea92aeb9b74fe9d64",
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854912",
                              "name": "Burger Pizza - Classic Veg",
                              "category": "Sides",
                              "description": "Oven-baked buns with cheese, tomato & capsicum in creamy mayo",
                              "imageId": "14904112f8c4194ab603544352b120e4",
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.3",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854920",
                              "name": "Burger Pizza - Premium Veg",
                              "category": "Sides",
                              "description": "Oven-baked buns with cheese, paneer, tomato, capsicum & red paprika in creamy mayo",
                              "imageId": "14904112f8c4194ab603544352b120e4",
                              "isVeg": 1,
                              "price": 15500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854928",
                              "name": "Burger Pizza - Classic Non Veg",
                              "category": "Sides",
                              "description": "Oven-baked buns with cheese, peri-peri chicken, tomato & capsicum in creamy mayo",
                              "imageId": "ec21b004023760f2951b358d3753bef7",
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51298103",
                              "name": "Roasted Chicken Wings Peri-Peri",
                              "category": "Sides",
                              "description": "Crisp, roasted chicken wings in classic hot sauce and peri-peri flavour",
                              "imageId": "4559eee3316a4b7fda5a3452433b799d",
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51298133",
                              "name": "Tomato Ketchup",
                              "category": "Sides",
                              "description": "Goodness of Tomato Ketchup in mini sachets",
                              "imageId": "0241c5ce2d67e0233755935ca760be33",
                              "isVeg": 1,
                              "price": 95,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91962058",
                              "name": "Chicken Meatballs Peri-Peri Sauce",
                              "category": "Sides",
                              "description": "Tender, Juicy, Melt in Mouth Chicken Meatballs in Peri Peri Sauce",
                              "imageId": "3c2d2237477e93f0cb5fead8f6683402",
                              "price": 15500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93082934",
                              "name": "Taco Mexicana Veg (Single)",
                              "category": "Sides",
                              "description": "Truly irresistible! Crispy taco with veg patty & creamy harissa sauce",
                              "imageId": "21e88c202d967fb956e8efb1b86652aa",
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101910869",
                              "name": "Basil Pesto Dip",
                              "category": "Sides",
                              "description": "Your perfect pizza partner!  Savour your pizza slices with this new rich, herby & salty dip with the goodness of basil leaves & nuts that will surely give you a new flavor dimension!",
                              "imageId": "e285e11aacab2ae112f8aa3d732f2563",
                              "isVeg": 1,
                              "price": 4667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101910870",
                              "name": "Harissa Dip",
                              "category": "Sides",
                              "description": "A spicy & peppery pizza dip which can help you add the right amount of spiciness to your favorite pizza slices.",
                              "imageId": "40a13291ebccb53c09ac408cbc027835",
                              "isVeg": 1,
                              "price": 4667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115310546",
                              "name": "Garlic Breadsticks + Pepsi",
                              "category": "Sides",
                              "description": "Enjoy the all time favourite Garlic Breadsticks with Pepsi (475 ml)",
                              "imageId": "695720e0363a5c4dbc8e9ab4d8ba1ab9",
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117821613",
                              "name": "Choco Lava Cake + Pepsi",
                              "category": "Sides",
                              "description": "Get the indulgent Choco Lava Cake & a Pepsi (475 ml) for just INR 149",
                              "imageId": "abe89720b2f173a8a89e4bd0c5ae0edc",
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pizza Mania",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91866671",
                              "name": "Golden Corn",
                              "category": "Pizza Mania",
                              "description": "Sweet & juicy golden corn for that lipsmacking taste",
                              "imageId": "56dc734475307dc8f0923a8bbec1f843",
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157410",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99471547",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157412",
                                          "variationId": "99471555"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99471551",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157412",
                                          "variationId": "99471558"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157412",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 119,
                                        "id": "99471555",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 89,
                                        "default": 1,
                                        "id": "99471558",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157410",
                                        "variationId": "99471547"
                                      },
                                      {
                                        "groupId": "32157412",
                                        "variationId": "99471555"
                                      }
                                    ],
                                    "price": 11900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157410",
                                        "variationId": "99471551"
                                      },
                                      {
                                        "groupId": "32157412",
                                        "variationId": "99471558"
                                      }
                                    ],
                                    "price": 8900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91866684",
                              "name": "Onion",
                              "category": "Pizza Mania",
                              "description": "Crunchy onion on a cheesy base. The pizza mania classic",
                              "imageId": "650a7f92dec8430a1c6068901fbc5594",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36189989",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "default": 1,
                                        "id": "112479470",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36189990",
                                          "variationId": "112479472"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "id": "112479471",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36189990",
                                          "variationId": "112479473"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36189990",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 99,
                                        "default": 1,
                                        "id": "112479472",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 69,
                                        "id": "112479473",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36189989",
                                        "variationId": "112479470"
                                      },
                                      {
                                        "groupId": "36189990",
                                        "variationId": "112479472"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36189989",
                                        "variationId": "112479471"
                                      },
                                      {
                                        "groupId": "36189990",
                                        "variationId": "112479473"
                                      }
                                    ],
                                    "price": 6900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91962009",
                              "name": "Pepper Barbecue Chicken",
                              "category": "Pizza Mania",
                              "description": "Pepper barbecue chicken for that extra zing",
                              "imageId": "137c5560addb0476b44eb1d056b51f42",
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157331",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99471044",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157336",
                                          "variationId": "99471063"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99471055",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157336",
                                          "variationId": "99471071"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157336",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 149,
                                        "id": "99471063",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 119,
                                        "default": 1,
                                        "id": "99471071",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157331",
                                        "variationId": "99471044"
                                      },
                                      {
                                        "groupId": "32157336",
                                        "variationId": "99471063"
                                      }
                                    ],
                                    "price": 14900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157331",
                                        "variationId": "99471055"
                                      },
                                      {
                                        "groupId": "32157336",
                                        "variationId": "99471071"
                                      }
                                    ],
                                    "price": 11900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 11900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "101 ratings",
                                  "ratingCountV2": "101"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91962011",
                              "name": "Chicken Sausage",
                              "category": "Pizza Mania",
                              "description": "American classic! Spicy, herbed chicken sausage on pizza",
                              "imageId": "f8a4041b1319ed5fb519f1bde6dc4848",
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157390",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99471401",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157392",
                                          "variationId": "99471421"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99471408",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157392",
                                          "variationId": "99471427"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157392",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 139,
                                        "id": "99471421",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 109,
                                        "default": 1,
                                        "id": "99471427",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157390",
                                        "variationId": "99471401"
                                      },
                                      {
                                        "groupId": "32157392",
                                        "variationId": "99471421"
                                      }
                                    ],
                                    "price": 13900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157390",
                                        "variationId": "99471408"
                                      },
                                      {
                                        "groupId": "32157392",
                                        "variationId": "99471427"
                                      }
                                    ],
                                    "price": 10900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110397990",
                              "name": "Chicken Keema & Onion with Desi Makhani Sauce",
                              "category": "Pizza Mania",
                              "description": "Authentic Indian Flavor of Makhani Sauce loaded with meaty Chicken Keema and crunchy Onion.",
                              "imageId": "3ca131ee9a3a93d30cbd7c90381d1c47",
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157183",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99470349",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157184",
                                          "variationId": "99470351"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99470350",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157184",
                                          "variationId": "99470353"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157184",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 184,
                                        "id": "99470351",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 139,
                                        "default": 1,
                                        "id": "99470353",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157183",
                                        "variationId": "99470349"
                                      },
                                      {
                                        "groupId": "32157184",
                                        "variationId": "99470351"
                                      }
                                    ],
                                    "price": 18400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157183",
                                        "variationId": "99470350"
                                      },
                                      {
                                        "groupId": "32157184",
                                        "variationId": "99470353"
                                      }
                                    ],
                                    "price": 13900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110397991",
                              "name": "Paneer, Onion & Capsicum with Desi Makhani Sauce",
                              "category": "Pizza Mania",
                              "description": "Authentic Indian Flavor of Makhani Sauce loaded with juicy Paneer, crisp Capsicum and crunchy Onion.",
                              "imageId": "ad3169aff34ea7a2f1d4b9a4adab1f72",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157219",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99470472",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157220",
                                          "variationId": "99470474"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99470473",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157220",
                                          "variationId": "99470475"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157220",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 174,
                                        "id": "99470474",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 129,
                                        "default": 1,
                                        "id": "99470475",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157219",
                                        "variationId": "99470472"
                                      },
                                      {
                                        "groupId": "32157220",
                                        "variationId": "99470474"
                                      }
                                    ],
                                    "price": 17400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157219",
                                        "variationId": "99470473"
                                      },
                                      {
                                        "groupId": "32157220",
                                        "variationId": "99470475"
                                      }
                                    ],
                                    "price": 12900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 12900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110397992",
                              "name": "Paneer & Capsicum with Videshi Hot Sauce",
                              "category": "Pizza Mania",
                              "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with juicy Paneer and crisp Capsicum.",
                              "imageId": "1188181858845deaccd534746fa1ea02",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157245",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99470558",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157246",
                                          "variationId": "99470562"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99470560",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157246",
                                          "variationId": "99470565"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157246",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 154,
                                        "id": "99470562",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 109,
                                        "default": 1,
                                        "id": "99470565",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157245",
                                        "variationId": "99470558"
                                      },
                                      {
                                        "groupId": "32157246",
                                        "variationId": "99470562"
                                      }
                                    ],
                                    "price": 15400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157245",
                                        "variationId": "99470560"
                                      },
                                      {
                                        "groupId": "32157246",
                                        "variationId": "99470565"
                                      }
                                    ],
                                    "price": 10900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110397993",
                              "name": "Capsicum & Red Paprika with Videshi Hot Sauce",
                              "category": "Pizza Mania",
                              "description": "Internationally inspired Hot sauce to cater your spice cravings loaded with crisp Capsicum and spicy Red Paprika.",
                              "imageId": "6770291bd906215f8633a58e0ab1f7e2",
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32157267",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "99470668",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157268",
                                          "variationId": "99470670"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "99470669",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "32157268",
                                          "variationId": "99470672"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "32157268",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 134,
                                        "id": "99470670",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 89,
                                        "default": 1,
                                        "id": "99470672",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157267",
                                        "variationId": "99470668"
                                      },
                                      {
                                        "groupId": "32157268",
                                        "variationId": "99470670"
                                      }
                                    ],
                                    "price": 13400
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32157267",
                                        "variationId": "99470669"
                                      },
                                      {
                                        "groupId": "32157268",
                                        "variationId": "99470672"
                                      }
                                    ],
                                    "price": 8900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110505137",
                              "name": "Classic",
                              "category": "Pizza Mania",
                              "description": "A classic pizza topped with sprinkle of basil and parsley herbs",
                              "imageId": "49b0b344ebe9310bf3e9be7fc4ed1271",
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36189991",
                                    "name": "Crust",
                                    "variations": [
                                      {
                                        "name": "Fresh Pan Pizza",
                                        "id": "112479474",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36189992",
                                          "variationId": "112479476"
                                        }
                                      },
                                      {
                                        "name": "Classic Hand Tossed",
                                        "default": 1,
                                        "id": "112479475",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1,
                                        "dependantVariation": {
                                          "groupId": "36189992",
                                          "variationId": "112479477"
                                        }
                                      }
                                    ]
                                  },
                                  {
                                    "groupId": "36189992",
                                    "name": "Size",
                                    "variations": [
                                      {
                                        "name": "Regular",
                                        "price": 79,
                                        "id": "112479476",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Regular",
                                        "price": 49,
                                        "default": 1,
                                        "id": "112479477",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36189991",
                                        "variationId": "112479474"
                                      },
                                      {
                                        "groupId": "36189992",
                                        "variationId": "112479476"
                                      }
                                    ],
                                    "price": 7900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36189991",
                                        "variationId": "112479475"
                                      },
                                      {
                                        "groupId": "36189992",
                                        "variationId": "112479477"
                                      }
                                    ],
                                    "price": 4900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Meals & Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297422",
                              "name": "Party Combo: Farmhouse & Veg Extravaganza",
                              "category": "Meals & Combos",
                              "description": "Regular Farmhouse + Regular Veg Extravaganza + Garlic Bread + Pepsi",
                              "imageId": "f8dd5e9d4bf6507c236bda226d60e39a",
                              "isVeg": 1,
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297431",
                              "name": "Party Combo: Veg Paradise & Farmhouse",
                              "category": "Meals & Combos",
                              "description": "Regular Veg Paradise + Regular Farmhouse + Garlic Bread + Pepsi",
                              "imageId": "4da8c18c8588f35cdac9325d1c9a875f",
                              "isVeg": 1,
                              "price": 58900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297452",
                              "name": "Party Combo: Pepper BBQ Chicken & Spiced Double Chicken",
                              "category": "Meals & Combos",
                              "description": "Regular Pepper BBQ Chicken + Regular Spiced Double Chicken + Garlic Bread + Pepsi",
                              "imageId": "20c82e66b0f499407b7d35fc6cba93f0",
                              "price": 61900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297478",
                              "name": "Party Combo: Margherita & Peppy Paneer",
                              "category": "Meals & Combos",
                              "description": "Medium Margherita + Medium Peppy Paneer + Garlic Bread + 2 Pepsi",
                              "imageId": "47cf42341da7987fcc4e50661659ec44",
                              "isVeg": 1,
                              "price": 78900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297490",
                              "name": "Party Combo: Veg Extravaganza & Indi Tandoori Paneer",
                              "category": "Meals & Combos",
                              "description": "Medium Veg Extravaganza + Medium Indi Tandoori Paneer + Garlic Bread + 2 Pepsi",
                              "imageId": "94b6e9cd1a115634f6b2cffdcb8db4c8",
                              "isVeg": 1,
                              "price": 111900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107297508",
                              "name": "Party Combo: Veg Cheesy Pizza",
                              "category": "Meals & Combos",
                              "description": "Regular Fresh Veggie + Regular Peppy Paneer + Regular Corn n Cheese + Regular Farmhouse",
                              "imageId": "7baf27441fb363aeefbb97272d526915",
                              "isVeg": 1,
                              "price": 79900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321703",
                              "name": "Garlic Breadsticks + Cheesy Dip",
                              "category": "Meals & Combos",
                              "description": "Enjoy the all-time favorite Garlic Breadsticks with the indulgent Cheesy Dip",
                              "imageId": "ebfb530d3547df8579c1d17e76244907",
                              "isVeg": 1,
                              "price": 13700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321704",
                              "name": "Spicy Veg Combo @ Rs. 75 Off",
                              "category": "Meals & Combos",
                              "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + GB + Pepsi",
                              "imageId": "5d28f2ed4aa1d609fd871df365fc0b45",
                              "isVeg": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321705",
                              "name": "Spicy Non Veg Combo @ Rs. 95 Off",
                              "category": "Meals & Combos",
                              "description": "Reg Blazing ChK & Paprika + Reg Fiery Sausage & Paprika + GB + Pepsi",
                              "imageId": "cbc3a8009769158466174b572af8b027",
                              "price": 56900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321706",
                              "name": "Hot and Sweet Veg Combo @ Rs. 75 Off",
                              "category": "Meals & Combos",
                              "description": "Reg Blazing On & Paprika + Reg Fiery Jalapeno & Paprika + CLC + Pepsi",
                              "imageId": "7e4c952cb7d8bbf372688722f59983e6",
                              "isVeg": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321707",
                              "name": "Hot and Sweet Non Veg Combo @ Rs. 95 Off",
                              "category": "Meals & Combos",
                              "description": "Reg Blazing ChK & Paprika + Reg Fiery Sausage & Paprika + CLC + Pepsi",
                              "imageId": "84208b36da15c84aa9efb63c3939d4f3",
                              "price": 56900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321708",
                              "name": "Spicy Veg Party Combo @ Rs. 140 off",
                              "category": "Meals & Combos",
                              "description": "Med Blazing On & Paprika + Med Fiery Jalapeno & Paprika + 2GB + 2 Pepsi",
                              "imageId": "58c364b63bddf27d5d5069b6969db028",
                              "isVeg": 1,
                              "price": 84900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121321709",
                              "name": "Spicy Non Veg Party Combo @ Rs. 180 off",
                              "category": "Meals & Combos",
                              "description": "Med Blazing ChK & Paprika + Med Fiery Sausage & Paprika + 2GB + 2 Pepsi",
                              "imageId": "0657dd96f9a7bb9bcc83f56238919440",
                              "price": 104900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17854897",
                              "name": "Butterscotch Mousse Cake",
                              "category": "Dessert",
                              "description": "Sweet temptation! Butterscotch flavored mousse",
                              "imageId": "d9acfb1d2bed96ea87049d1b44b8a625",
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51298113",
                              "name": "Choco Lava Cake",
                              "category": "Dessert",
                              "description": "Chocolate lovers delight! Indulgent, gooey molten lava inside chocolate cake",
                              "imageId": "499ebd7bb7b311f4c724ab7ad91a5592",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58852790",
                              "name": "Red Velvet Lava Cake",
                              "category": "Dessert",
                              "description": "A truly indulgent experience with sweet and rich red velvet cake on a creamy cheese flavoured base to give a burst of flavour in every bite!",
                              "imageId": "1017c18326008549a510c409a559ee5c",
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11219333002272"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Domino's Pizza",
                      "area": "Brigade Road",
                      "completeAddress": "First Floor,Corp. No. 30 (Old No. 16 Later 23)Opp. Guzzlers Inn, Rest House Road, Nr Brigade Road,Bangalore - 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "wJDooiQYGX9s-XshGMg-rwpk24G01_TBpFe3yPBA"
},
// 20240105233350
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=396748&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "396748",
              "name": "The Good Bowl",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "the-good-bowl1-residency-road-shantinagar",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "6e04be27387483a7c00444f8e8241108",
              "locality": "Residency Road",
              "areaName": "Shantinagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Biryani",
                "Pastas"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "396748",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "2.5 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "7918",
              "avgRatingString": "4.4",
              "totalRatingsString": "100+ ratings",
              "sla": {
                "restaurantId": "396748",
                "deliveryTime": 23,
                "minDeliveryTime": 23,
                "maxDeliveryTime": 23,
                "lastMileTravel": 2.5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 33,
                "slaString": "23 MINS",
                "lastMileTravelString": "2.5 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-05 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹110 on select items | Use code SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "the-good-bowl1-residency-road-shantinagar",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "KMK Towers, 1st floor, WEST PORTION, 142 K H ROAD, above Tata Motors, Shanthinagar, Bangalore South, bangalore, 560027"
                },
                {
                  "title": "Cuisines",
                  "message": "Biryani,Pastas"
                }
              ],
              "logo": "rng/md/carousel/production/hfpxtvd1qvabww2jtinp",
              "totalRatings": 100,
              "aggregatedDiscountInfoV2": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹110 on select items | Use code SPECIALS",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 700,
                  "maxValue": 1000,
                  "priority": 33,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 15
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 15% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 15% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/396748"
              },
              "expectationNotifiers": [
                {
                  "text": "2.5 kms | ₹38 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>2.5 kms</b> | ₹38 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.961774,77.594236",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "60% OFF UPTO ₹110",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "49ae01b9-5edb-4b1d-a605-4f53540423c6"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SPECIALS",
                      "description": "ON SELECT ITEMS",
                      "offerType": "offers",
                      "restId": "396748",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 15% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "2bd0cbae-ef7c-484e-b533-b62c2b302bdb"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹1000",
                      "offerType": "offers",
                      "restId": "396748",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "396748",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "396748",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "396748",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "offersFilter": {
                        "attributes": {
                          "displayText": "60% OFF"
                        }
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1650322",
                          "creativeId": "TopPicks/MGCRBO",
                          "title": "Mughlai Grilled Chicken Rice Bowl with Omelette",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116541923",
                              "name": "Mughlai Grilled Chicken Rice Bowl with Omelette",
                              "category": "Signature Bowls",
                              "description": "Melt-in-mouth reshmi chicken when paired with delicious spicy gravy weaved a food dream like no other. Served with rice, salad and Omelette.",
                              "imageId": "5d20ca615acfa834f84874f66cdf404b",
                              "inStock": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014383",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014385",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014386",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014388",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014389",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1650693",
                          "creativeId": "TopPicks/PnrTiRB",
                          "title": "Paneer Tikka Rice Bowl",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "113759757",
                              "name": "Paneer Tikka Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Drumroll King of the tikkas is here. Soft and spicy paneer tikka in rich spicy gravy served on a bed of rice and salad.",
                              "imageId": "63e1bda2f06b8c951a9bbc15cbd5d2f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014368",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014370",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014371",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014373",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014374",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1650889",
                          "creativeId": "TopPicks/CTMCPB",
                          "title": "Chicken Tikka Mac & Cheese Pasta Bowl",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116530985",
                              "name": "Chicken Tikka Mac & Cheese Pasta Bowl",
                              "category": "Fusion Mac & Cheese Bowls",
                              "description": "Spicy Chicken Tikka when served with creamy mac and cheese in Mughlai gravy is a twist you willl love to eat.",
                              "imageId": "a9f1ed902b55e5d287a20525a765ae21",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657510",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531360",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531363",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531366",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531369",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1651265",
                          "creativeId": "TopPicks/CknLaRB",
                          "title": "Chicken Lababdar Rice Bowl",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "124848099",
                              "name": "Chicken Lababdar Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Boneless chicken in creamy tomato gravy with flavourful rice is sure to leave you wanting for more.",
                              "imageId": "dbba34cc3760c9c7e4713d4e1b63ad6b",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657400",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516748",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516749",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516750",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516751",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1651654",
                          "creativeId": "TopPicks/ClsRajRB",
                          "title": "Classic Rajma Rice Bowl",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "113759764",
                              "name": "Classic Rajma Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Kidney beans a great vegetarian source of protein, slowly-cooked in thick and spicy onion tomato gravy served on a bed of rice and salad. Who can say no to this bowl full of goodness, fiber and protein. Calories (Kcals) 627, Carbs (Gms) 88, Proteins (Gms) 13, Fats (Gms) 25",
                              "imageId": "294eadaf452e7fb6d314ada8095f8a91",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657244",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531860",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531862",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531864",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531865",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Signature Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116542054",
                              "name": "Roast Vegetables Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Exotic vegetables cooked in creamy gravy and served with Hyderabadi rice. What else do you want",
                              "imageId": "86a65020f564d232bfb5241bf6853fad",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014362",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014364",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014365",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014366",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014367",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759757",
                              "name": "Paneer Tikka Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Drumroll King of the tikkas is here. Soft and spicy paneer tikka in rich spicy gravy served on a bed of rice and salad.",
                              "imageId": "63e1bda2f06b8c951a9bbc15cbd5d2f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014368",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014370",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014371",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014373",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014374",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116542039",
                              "name": "Mughlai Falafel Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "No rules. All heart! Crispy falafels dropped in a bubbling gravy is where Middle East meets North India. Served with rice and salad.",
                              "imageId": "88a9473328ddda54b6bf27090cf02545",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014378",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014379",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014380",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014381",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014382",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541923",
                              "name": "Mughlai Grilled Chicken Rice Bowl with Omelette",
                              "category": "Signature Bowls",
                              "description": "Melt-in-mouth reshmi chicken when paired with delicious spicy gravy weaved a food dream like no other. Served with rice, salad and Omelette.",
                              "imageId": "5d20ca615acfa834f84874f66cdf404b",
                              "inStock": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014383",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014385",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014386",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014388",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014389",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759762",
                              "name": "Desi Barbeque Chicken Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Caution: Not your average bowl. Barbeque chicken in spicy gravy accompanied with rice and salad. A perfect fusion of unique flavors.",
                              "imageId": "3fca764abaeb814e27e2c6ade30abad6",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014393",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014394",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014395",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014396",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014397",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994370",
                              "name": "Bhuna Chicken Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Tender chicken cooked in fresh bhuna spices, served with flavoured rice and salad is here to make your day!",
                              "imageId": "baa70cdac1720756c9c6669f9db2bda9",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014399",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014400",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014402",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014403",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014405",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994381",
                              "name": "Creamy Chicken Tikka Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Your tatsebuds will say gracias with this bowl made of Creamy smoked tandoori chicken in rich gravy. Served with rice and salad.",
                              "imageId": "cb0438294b06480538d146fccd3550ac",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014408",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014409",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014410",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014411",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014412",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994378",
                              "name": "Chicken Kheema Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Let the good times roll with this all-time favourite bowl. Minced chicken kheema with Hyderabadi rice and a side of salad. Must try!",
                              "imageId": "7af74edcf1cfa8ed399c4443e9c97603",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014413",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014415",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014417",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014419",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014421",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994343",
                              "name": "Mughlai Chicken Kofta Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "An extraordinary twist youll fall in love with. Soft chicken meatballs dipped in pipping hot gravy served with rice & salad.",
                              "imageId": "f03472cecbef857ecd6f659d3b7ff526",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014426",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014427",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014429",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014430",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014432",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541959",
                              "name": "Chicken Tikki Rice Bowl Served With Omelette",
                              "category": "Signature Bowls",
                              "description": "A flavour-packed surprise only for you! Delicious chicken tikki, dipped in spicy gravy accompanied with rice, salad and omelette. Dig in!",
                              "imageId": "7b8ee53bb228618b0a4e69bbb9a59ee7",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014433",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014434",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014435",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014436",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014437",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128804616",
                              "name": "Mughlai Mutton Rice Bowl",
                              "category": "Signature Bowls",
                              "description": "Mutton stewed with spices and cooked in mughlai gravy brings that perfect flavour to this rice bowl. In a mood for a delicious meaty meal. You have to try this one!",
                              "imageId": "a07ed1d6b21f249bb25a4c5192b40214",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128014442",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014444",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014445",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014446",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128014447",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Classic Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759758",
                              "name": "Chole Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Zesty Chole on a bed of warm rice - that's what culinary dreams are made of. Try this protein rich combination that is sure to win hearts. Calories (Kcals) 597, Carbs (Gms) 16,  Proteins (Gms) 96, Fats (Gms) 18",
                              "imageId": "724141e5610d50724b6c882f32995133",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657255",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531474",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531475",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531476",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531477",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759764",
                              "name": "Classic Rajma Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Kidney beans a great vegetarian source of protein, slowly-cooked in thick and spicy onion tomato gravy served on a bed of rice and salad. Who can say no to this bowl full of goodness, fiber and protein. Calories (Kcals) 627, Carbs (Gms) 88, Proteins (Gms) 13, Fats (Gms) 25",
                              "imageId": "294eadaf452e7fb6d314ada8095f8a91",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657244",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531860",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531862",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531864",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531865",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759761",
                              "name": "Dal Makhani Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "If soul food had a name, it would be Dal Makhani and rice. Protein-packed lentils smeared with fresh butter, served with warm rice is a perfect meal to lift your spirits.",
                              "imageId": "3ba7b01d95dc608ea4d7a144cbc50e2a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657496",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531896",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531899",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531903",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531905",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994494",
                              "name": "Palak Paneer Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Soft paneer cubes cooked in velverty spinach gravy served with basmati rice and salad. This delicious meal rich in iron and protien is a must try!",
                              "imageId": "f7b8b2b8b2c2965f804dc3e5b14471cc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657200",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532098",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532099",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532100",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532101",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113759755",
                              "name": "Good'ol Butter Chicken Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Butter makes everything better. So does our protein-packed butter chicken bowl served with rice and salad. Calories (Kcals) 385, Carbs (Gms) 32, Proteins (Gms) 23, Fats (Gms) 18",
                              "imageId": "b7b37240d343161756c7ce650242fcd8",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657506",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531848",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531851",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531855",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531857",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994506",
                              "name": "Palak Chicken Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "Iron and protien in one bowl - that's what our Palak Chicken bowl is all about. Served with rice and salad.",
                              "imageId": "649b065fa1fdfff09118d46bb0c52934",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657378",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123933652",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123933653",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123933654",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123933655",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994287",
                              "name": "Corn Masala Rice Bowl",
                              "category": "Classic Bowls",
                              "description": "The goodness of Mexican techniques and Indian spices makes our Makai masala bowl a meal to remember. Served with warm rice and salad.",
                              "imageId": "b6b9e1054d2cc294b38b969892666d68",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657190",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531306",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531309",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531312",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531316",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "(New) North Indian Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848105",
                              "name": "Paneer Lababdar Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "As the name suggests, this dish is truly lababdar! Soft Paneer cooked with aromatic spices and creamy gravy with flavourful rice is all you need today.",
                              "imageId": "b7b891ddabd0824a05ca3e7d1d893a82",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657473",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516774",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516775",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516776",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516777",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848099",
                              "name": "Chicken Lababdar Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Boneless chicken in creamy tomato gravy with flavourful rice is sure to leave you wanting for more.",
                              "imageId": "dbba34cc3760c9c7e4713d4e1b63ad6b",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657400",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516748",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516749",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516750",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516751",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848101",
                              "name": "Paneer Kadhai Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Soft paneer made in spicy onion and tomato gravy with bell peppers, served with flavourful rice is the perfect meal when in mood for something tasty!",
                              "imageId": "dd68ff80f10e4f68bee2ac57c5bf5638",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657370",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516762",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516763",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516764",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516765",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848103",
                              "name": "Chicken Kadhai Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Boneless Chicken made in spicy kadhai garvy with bell peppers, is served with flavourful rice. A wholesome meal for your cravings.",
                              "imageId": "a6113013ff20e5436be513a329ac2ff1",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657517",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516770",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516771",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516772",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516773",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848100",
                              "name": "Paneer Tikka Masala Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Paneer marinated in spices, tandoored for that perfect smoky flavour, this Paneer Tikka Masala rice bowl is deliciously made for you.",
                              "imageId": "44dcc26a0d9cd22c1385a9786fef5311",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657478",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516752",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516753",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516754",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516755",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124848102",
                              "name": "Chicken Tikka Masala Rice Bowl",
                              "category": "(New) North Indian Bowls",
                              "description": "Smoky, juicy peices of chicken is the secret to this extremely delicious dish. Marinated chicken is tandoored and cooked to perfection in a masala gravy. Served with flavourful rice this dish is sure to make your day!",
                              "imageId": "0cf331a03ea0727428ce23f86339f2eb",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657513",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516766",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516767",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516768",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124516769",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fusion Mac & Cheese Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116530986",
                              "name": "Paneer Tikka Mac & Cheese Pasta Bowl",
                              "category": "Fusion Mac & Cheese Bowls",
                              "description": "Delicious Mac and Cheese got a tikka twist and we dont complain. Creamy Mac and Cheese in spicy mughlai gravy topped with soft paneer tikka and garnished with salad",
                              "imageId": "fc22465c7089c1497cb3bab3d80833a2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657207",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531458",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531459",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531461",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531463",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531000",
                              "name": "Falafel Mac & Cheese Pasta Bowl",
                              "category": "Fusion Mac & Cheese Bowls",
                              "description": "Who would have ever thought crispy falafel and cheesy mac and cheese will rock a bowl. Well, we thought and created it. Enjoy!",
                              "imageId": "2c84c1c6800d5f0d3b5fb453601c3025",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657320",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531527",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531531",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531533",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531535",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116530985",
                              "name": "Chicken Tikka Mac & Cheese Pasta Bowl",
                              "category": "Fusion Mac & Cheese Bowls",
                              "description": "Spicy Chicken Tikka when served with creamy mac and cheese in Mughlai gravy is a twist you willl love to eat.",
                              "imageId": "a9f1ed902b55e5d287a20525a765ae21",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657510",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531360",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531363",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531366",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531369",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116530981",
                              "name": "Chicken Kheema Mac & Cheese Pasta Bowl",
                              "category": "Fusion Mac & Cheese Bowls",
                              "description": "Delicately spiced chicken kheema layered on a bed of creamy mac and cheese in Mughlai gravy is an experience to remember. Try now!",
                              "imageId": "7d6afcf14e6e51b34c3ad6bfe0786279",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657340",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531346",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531349",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531352",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531356",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "High Protein Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105575858",
                              "name": "Palak Chicken Rice Bowl with Chicken Kebab",
                              "category": "High Protein Bowls",
                              "description": "Chicken power like no other. Tender chicken in creamy palak gravy served with rice, salad and melt-in-mouth Chicken Haleem Kebab. Calories (Kcals) 904, Carbs (Gms) 87, Proteins (Gms) 43, Fats (Gms) 44",
                              "imageId": "2d2692e58d32926ef013cf8a084c5a67",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105575859",
                              "name": "Dal Makhni Rice Bowl with Dahi Kebab",
                              "category": "High Protein Bowls",
                              "description": "Best of both the worlds in a bowl. Creamy dal makhani served with rice, salad and soft dahi kebabs. Calories (Kcals) 765, Carbs (Gms) 101, Proteins (Gms) 24, Fats (Gms) 31",
                              "imageId": "ed69a08fd8d5d93ff42f023f5781cecc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105575861",
                              "name": "Butter Chicken Rice Bowl with Seekh Kebab",
                              "category": "High Protein Bowls",
                              "description": "Butter makes everything better, but chicken makes everything best! Creamy butter chicken served with rice, salad and delicious chicken seekh. Calories (Kcals): 1085, Carbs (Gms): 136, Proteins (Gms): 52, Fats (Gms): 38",
                              "imageId": "bc850df14179b835ea0dc85e5bcbfe94",
                              "inStock": 1,
                              "price": 40900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Biryani Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541857",
                              "name": "Hyderabadi Veg Biryani - Serves 1",
                              "category": "Biryani Bowls",
                              "description": "(Contains Onion and garlic) (Serves 1)(Served with raita)Vegetables in a freshly ground Hyderabadi spice mix that permeates every bite you take is dum pukht with basmati rice and garnished with fresh mint, this one you cannot miss!",
                              "imageId": "rijuo6ly5qkvcsv8gmuw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657416",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531131",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531134",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531138",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531140",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541970",
                              "name": "Paneer Biryani (Serves 1)",
                              "category": "Biryani Bowls",
                              "description": "Layers of soft, fresh paneer and fragrant zafran laden rice! Our zaikedaar paneer biryani is all flavours, no faff.",
                              "imageId": "14cfadcc66f006cc72f12fda2d4ec786",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657330",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531666",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531667",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531668",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531669",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116542059",
                              "name": "Vegetable Biryani (Serves 1)",
                              "category": "Biryani Bowls",
                              "description": "You can argue there is no such thing as vegetable biryani but we would have to ask you to give this bowl of biryani made with handpicked fresh vegetables and long-grain basmati rice, a try before you join the bandwagon.",
                              "imageId": "5aa267ed69b6e95be97980ef2ca57e19",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657501",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532081",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532084",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532087",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532090",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541853",
                              "name": "Chicken Biryani (Serves 1)",
                              "category": "Biryani Bowls",
                              "description": "(100% Safely Cooked Chicken) Lazeez describes our chicken biryani quite right, and its delicious in its own right too.",
                              "imageId": "4046a608a71f2ea8e0be8c949f76491f",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657279",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531110",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531113",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531116",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531121",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541876",
                              "name": "Hyderabadi Dum Chicken Biryani (Boneless) (Spicy) - Serves 1",
                              "category": "Biryani Bowls",
                              "description": "(Serves 1)(Served with raita)Just like Charminars secret tunnels, this biryani is made with a secret Hyderabadi spice mix that soaks the succulent chicken that is layered with mint infused basmati rice",
                              "imageId": "ohddcm29gcijztfdpjme",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657312",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531147",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531150",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531153",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531155",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116542034",
                              "name": "Hyderabadi Paneer Biryani - Serves 1",
                              "category": "Biryani Bowls",
                              "description": "(Contains Onion and garlic) (Serves 1)(Served with raita)Just the way you like it, long grain basmati rice is cooked with paneer that is marinated with a spice mix straight from the Bazaars of Hyderabad. Every bite leaves you wanting more",
                              "imageId": "v0x0ulg82oljoasidebq",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657490",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531912",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531916",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531921",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122531925",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116542061",
                              "name": "Lucknowi Mutton Dum Biryani (Boneless) - Serves 1",
                              "category": "Biryani Bowls",
                              "description": "(Served with Raita) If biryanis had a king, Mutton Biryani would always rule! spiced boneless mutton married with fragrant basmati , slow cooked to create what biryani dreams are made of.",
                              "imageId": "binzeiptfxt3rqbo7lgb",
                              "inStock": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657350",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532094",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532095",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532096",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122532097",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Super Saver Combos (Flat 20% OFF)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531005",
                              "name": "Rajma Rice Bowl Super Saver Combo (Serves 1)",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Rajma Bowl + Potato Shots + Beverage of Your Choice & 25% OFF. Now this is what you call a super deal. Enjoy!",
                              "imageId": "871839b0034843e8f81a01a76b5c8444",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127630490",
                                  "groupName": "Choose Beverage:",
                                  "choices": [
                                    {
                                      "id": "109107082",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107087",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107084",
                                      "name": "Swig Jeera",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107083",
                                      "name": "Swig Green Apple",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107085",
                                      "name": "Mint Chaas",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107089",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994554",
                              "name": "Paneer Tikka Rice Bowl Super Saver Combo (Serves 1)",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Veg Fusion Bowl + Falafel Shots + Beverage of Your Choice & 25% OFF. Amazings savings and delicious delights all in one",
                              "imageId": "ff78c7445f727c69adb3f62e88fd6292",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127630491",
                                  "groupName": "Choose Beverage:",
                                  "choices": [
                                    {
                                      "id": "109107082",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107087",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107084",
                                      "name": "Swig Jeera",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107083",
                                      "name": "Swig Green Apple",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107085",
                                      "name": "Mint Chaas",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107089",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994550",
                              "name": "Dal Makhani Rice Bowl Super Saver Combo (Serves 1)",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Veg Desi Bowl + Potato Shots + Beverage of Your Choice & 25% OFF. A perfect meal at a striking deal.",
                              "imageId": "8581f5d4b46b7ee561b0640c6522e363",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127630501",
                                  "groupName": "Choose Beverage:",
                                  "choices": [
                                    {
                                      "id": "109107082",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107087",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107084",
                                      "name": "Swig Jeera",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107083",
                                      "name": "Swig Green Apple",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107085",
                                      "name": "Mint Chaas",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107089",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994557",
                              "name": "Butter Chicken Rice Bowl Super Saver Combo (Serves 1)",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Butter Chicken Bowl + Falafel Shots + Beverage of Your Choice & 25% OFF. This combination couldnt get any better.",
                              "imageId": "64eab6f6bf1801b4f8d0f5684af4cb0e",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127630489",
                                  "groupName": "Choose Beverage:",
                                  "choices": [
                                    {
                                      "id": "109107082",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107087",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107084",
                                      "name": "Swig Jeera",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107083",
                                      "name": "Swig Green Apple",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107085",
                                      "name": "Mint Chaas",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107089",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116530979",
                              "name": "Mughlai Grilled Chicken Rice Bowl Saver Combo (Serves 1)",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Enjoy a delicious combo of your favourite Non Veg Fusion Bowl + Falafel Shots + Beverage of Your Choice",
                              "imageId": "24501d056fb90f332fa9e253f3e0f8c2",
                              "inStock": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127630500",
                                  "groupName": "Choose Beverage:",
                                  "choices": [
                                    {
                                      "id": "109107082",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107087",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107084",
                                      "name": "Swig Jeera",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107083",
                                      "name": "Swig Green Apple",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107085",
                                      "name": "Mint Chaas",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109107089",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122115284",
                              "name": "Bowl & Beverage Combos Starting at Rs 249",
                              "category": "Super Saver Combos (Flat 20% OFF)",
                              "description": "Pair your favourite Bowl with a beverage of your choice, because which meal is complete without a drink!",
                              "imageId": "27ecd1435960ec585bb3b00e4837c491",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "124516756",
                                  "groupName": "Choose your Bowl",
                                  "choices": [
                                    {
                                      "id": "100118675",
                                      "name": "Classic Rajma Rice Bowl",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118676",
                                      "name": "Chole Rice Bowl",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118677",
                                      "name": "Dal Makhani Rice Bowl",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118678",
                                      "name": "Roast Vegetables Rice Bowl",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118679",
                                      "name": "Mughlai Falafel Rice Bowl",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118680",
                                      "name": "Paneer Tikka Rice Bowl",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118681",
                                      "name": "Bhuna Chicken Rice Bowl",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118682",
                                      "name": "Creamy Chicken Tikka Rice Bowl",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118683",
                                      "name": "Mughlai Grilled Chicken Rice Bowl",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "124516757",
                                  "groupName": "Choose your Beverage",
                                  "choices": [
                                    {
                                      "id": "100118684",
                                      "name": "Masala Lemonade",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118685",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109948311",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118686",
                                      "name": "Mint Chaas",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118687",
                                      "name": "SWIG Jeera Masala",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100118688",
                                      "name": "SWIG Green Apple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Classic Wraps (Powered by Faasos)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994615",
                              "name": "Chatpate Chole Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "No one believed us when we said chole can be even more exciting. So we created a wrap that has tangy burst of chole with flavorful Indian spices and crunchy onions, wrapped in a soft roti. Try it & get surprised. I Calories (Kcals): 562 I Carbs (Gms): 72 I Proteins (Gms): 14 I Fats (Gms): 25",
                              "imageId": "7a0b056ec23998dfa83406da85894e59",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388896",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565305",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565306",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565309",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565312",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388896",
                                        "variationId": "100565305"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388896",
                                        "variationId": "100565306"
                                      }
                                    ],
                                    "price": 12400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388896",
                                        "variationId": "100565309"
                                      }
                                    ],
                                    "price": 13400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388896",
                                        "variationId": "100565312"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053317",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053309",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053311",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053308",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053308",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053309",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053311",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053317",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994613",
                              "name": "Masala Paneer Tikka Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "We dont have any pun for paneer, but we do have a lot of surprises in this exciting snack that we roll into this wrap. Fresh marinated paneer (with cooked onion) is smoked to perfection & drizzled with minty, spicy mayonnaise & wrapped in soft roti. I Calories (Kcals): 667 I Carbs (Gms): 61 I Proteins (Gms): 22 I Fats (Gms): 38",
                              "imageId": "e33b232690d715d740431f779291335f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388902",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565324",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565325",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565326",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565329",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388902",
                                        "variationId": "100565324"
                                      }
                                    ],
                                    "price": 18500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388902",
                                        "variationId": "100565325"
                                      }
                                    ],
                                    "price": 20000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388902",
                                        "variationId": "100565326"
                                      }
                                    ],
                                    "price": 21000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388902",
                                        "variationId": "100565329"
                                      }
                                    ],
                                    "price": 21500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053259",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281114"
                                      },
                                      {
                                        "groupId": "129053255",
                                        "addonId": "105281115"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053257",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053253",
                                        "addonId": "105281105"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053253",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053255",
                                  "groupName": "Add Sides",
                                  "choices": [
                                    {
                                      "id": "105281115",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281114",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053257",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053259",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994617",
                              "name": "Double Egg Chatpata Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "Why settle for something ordinary when you can get a snack that is eggstra ordinary! Like this yum wrap made with golden-fried eggs, drizzled with tangy, cheesy mayo and wrapped in a soft roti. I Calories (Kcals): 817 I Carbs (Gms): 57 I Proteins (Gms): 22 I Fats (Gms): 56",
                              "imageId": "a5be439e731c63a9cb6a914aebc21579",
                              "inStock": 1,
                              "price": 10500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388905",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565334",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565335",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565336",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565337",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388905",
                                        "variationId": "100565334"
                                      }
                                    ],
                                    "price": 10500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388905",
                                        "variationId": "100565335"
                                      }
                                    ],
                                    "price": 12000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388905",
                                        "variationId": "100565336"
                                      }
                                    ],
                                    "price": 13000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388905",
                                        "variationId": "100565337"
                                      }
                                    ],
                                    "price": 13500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053209",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053206",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053198",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053202",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053198",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053202",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053206",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053209",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994619",
                              "name": "Chicken Bhuna Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "The bestseller, rock n roll award goes to: Roasted and flavorful chicken pieces slow-cooked in spicy bhuna masala with onion and wrapped with crisp onions in a freshly made roti. Is it snack time yet I Calories (Kcals): 638 I Carbs (Gms): 60 I Proteins (Gms): 16 I Fats (Gms): 37",
                              "imageId": "766caa63ce36fee16ef34db3a8ee749d",
                              "inStock": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388909",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565348",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565349",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565350",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565351",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388909",
                                        "variationId": "100565348"
                                      }
                                    ],
                                    "price": 19500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388909",
                                        "variationId": "100565349"
                                      }
                                    ],
                                    "price": 21000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388909",
                                        "variationId": "100565350"
                                      }
                                    ],
                                    "price": 22000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388909",
                                        "variationId": "100565351"
                                      }
                                    ],
                                    "price": 22500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053285",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053280",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053271",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053276",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053271",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053276",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053280",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053285",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994622",
                              "name": "Malai Chicken Kebab Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "Fix your mundane days & let the good times roll! Oh so creamy & exotic, this Reshmi Chicken Wrap is made with soft chicken pieces cooked in creamy, rich & decadent masala. Remember, this is not made for sharing! I Calories (Kcals): 621 I Carbs (Gms): 61 I Proteins (Gms): 21 I Fats (Gms): 33",
                              "imageId": "8f27e87af044a68aec6dff39b491f0cb",
                              "inStock": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388912",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565355",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565358",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565361",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565362",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388912",
                                        "variationId": "100565355"
                                      }
                                    ],
                                    "price": 19500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388912",
                                        "variationId": "100565358"
                                      }
                                    ],
                                    "price": 21000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388912",
                                        "variationId": "100565361"
                                      }
                                    ],
                                    "price": 22000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388912",
                                        "variationId": "100565362"
                                      }
                                    ],
                                    "price": 22500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053227",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053224",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053220",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053223",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053220",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053223",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053224",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053227",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994618",
                              "name": "Masala Chicken Tikka Wrap",
                              "category": "Classic Wraps (Powered by Faasos)",
                              "description": "Bored of the same old flavours Excite your taste buds with surprises that we roll into this wrap. Smokey marinated chicken tikka (with cooked onion) taken a notch above with a generous drizzle of minty, tangy mayonnaise clubbed with crunchy onions in a soft roti. I Calories (Kcals): 626 I Carbs (Gms): 60 I Proteins (Gms): 22 I Fats (Gms): 33",
                              "imageId": "47a783a97daed3f033d30bc3c52ed60a",
                              "inStock": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32388926",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "100565407",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "100565410",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "100565413",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "100565415",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388926",
                                        "variationId": "100565407"
                                      }
                                    ],
                                    "price": 19500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388926",
                                        "variationId": "100565410"
                                      }
                                    ],
                                    "price": 21000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388926",
                                        "variationId": "100565413"
                                      }
                                    ],
                                    "price": 22000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32388926",
                                        "variationId": "100565415"
                                      }
                                    ],
                                    "price": 22500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281095"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281096"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281097"
                                      },
                                      {
                                        "groupId": "129053144",
                                        "addonId": "105281098"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281109"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281110"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281111"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281112"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "105281113"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311993"
                                      },
                                      {
                                        "groupId": "129053140",
                                        "addonId": "109311992"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281100"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526546"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526547"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "110526548"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281104"
                                      },
                                      {
                                        "groupId": "129053132",
                                        "addonId": "105281105"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281106"
                                      },
                                      {
                                        "groupId": "129053136",
                                        "addonId": "105281107"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129053132",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053136",
                                  "groupName": "Add a Side",
                                  "choices": [
                                    {
                                      "id": "105281107",
                                      "name": "Mint Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281106",
                                      "name": "Curd",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053140",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129053144",
                                  "groupName": "Add a Dessert",
                                  "choices": [
                                    {
                                      "id": "105281095",
                                      "name": "Gulab Jamun - Pack of 1",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281098",
                                      "name": "Choco Lava Cake",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281096",
                                      "name": "Kaju Katli (2 pcs)",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281097",
                                      "name": "Moong Dal Halwa (100 gm)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Starters",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994268",
                              "name": "Falafel Nuggets with Mayo Dip",
                              "category": "Starters",
                              "description": "Mediterranean inspired crispy falafel made from the finest soaked chickpeas and spices, served with a cheesy mayonnaise dip.",
                              "imageId": "1961f767777b5bd22e08a03b1c456c42",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541991",
                              "name": "Potato Wedges (Medium)",
                              "category": "Starters",
                              "description": "When you dont know what to eat next we suggest keep it simple and call for the wedges.",
                              "imageId": "0124f146ebd7e4b6400ee82c82c28e20",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541885",
                              "name": "Potato Chilli Shots with Mayo Dip",
                              "category": "Starters",
                              "description": "Crispy and spiced potato shots served with a cheesy mayonnaise dip to tantalize your tastebuds.",
                              "imageId": "9e86c8806c6d30ead54f5ed73d044bb3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "90020383",
                              "name": "Chicken Tikki (5 pcs)",
                              "category": "Starters",
                              "description": "(100% Safely Cooked Chicken) Chicken grounded and flavored with cardamom and green chilli and grilled to perfection, served with a mint dip.",
                              "imageId": "b92f0a84e83576503d122bd1eace8734",
                              "inStock": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414889",
                              "name": "Murgh Haleem Kebab (4 Pcs)",
                              "category": "Starters",
                              "description": "Try our chicken haleem kebabs for authentic Hyderabadi flavours. Spiced and ghee-infused, perfect for any occasion.",
                              "imageId": "6d38d1826e83a101fb41c151e8bdf182",
                              "inStock": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414893",
                              "name": "Dahi Kebab ( 4 Pcs)",
                              "category": "Starters",
                              "description": "Begin your meal with our yogurt-infused dahi kebabs. Made with creamy yoghurt, gently spiced, and crispy-fried to reveal a soft, velvety interior!",
                              "imageId": "07e264e7c2599de1a498c7664cbbb1d6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414888",
                              "name": "Chicken Meatball Kebab (5 Pcs)",
                              "category": "Starters",
                              "description": "Relish succulent minced chicken infused with aromatic Indian spices. Elevate your dining experience with our Murgh Kefta.",
                              "imageId": "938c8995b214215200fea4f972da3f89",
                              "inStock": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414891",
                              "name": "Mutton Galouti Kebab (4 Pcs)",
                              "category": "Starters",
                              "description": "Relish the flavour and tenderness of our Galouti Kebabs. Melt-in-the-mouth perfection, rich with aromatic spices, and tender mutton to create an unforgettable experience.",
                              "imageId": "6afb02dcf6e80a23b969862d6893c38b",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414892",
                              "name": "Veg Hara Bhara Kebab (4 Pcs)",
                              "category": "Starters",
                              "description": "Relish the magic of our Hara Bhara Kebabs made with premium potatoes, vibrant spinach, and green peas that's spiced and crispy crumb fried.",
                              "imageId": "e106c999bfb20a60e970a1db869775d3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129414890",
                              "name": "Chicken Tikki Kebab (5 pcs)",
                              "category": "Starters",
                              "description": "Introducing our Murgh Koobideh- juicy, ground chicken infused with cardamom & green chilli, shallow-fried for tender-crisp perfection!",
                              "imageId": "3b8dc1e072624a404ae4d757e4f320af",
                              "inStock": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131246237",
                              "name": "Blueberry Cheesecake",
                              "category": "Desserts",
                              "description": "The combination of delicious cream cheese and fresh blueberries is what makes our Blueberry cheesecake stand apart. Try now!",
                              "imageId": "5ab9b85bb3a75b8c7a5438e914fab1cb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994281",
                              "name": "Gulab Jamun - Pack of 1",
                              "category": "Desserts",
                              "description": "These melt in mouth sweet dumplings are the one dessert which can make your knees go weak in anticipation. Now served in a piece.",
                              "imageId": "f77717edaf8fac14cf60308667d686c1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72393611",
                              "name": "Gulab Jamun (Pack Of 2)",
                              "category": "Desserts",
                              "description": "Gulab Jamun. Soft. Plump and the way we are used to. There is nothing else in our gulab jamuns than authenticity and love.",
                              "imageId": "2c2c0e4d03dde1b74c926d3b0ca9e2bf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72393620",
                              "name": "Gulab Jamuns (Pack Of 10)",
                              "category": "Desserts",
                              "description": "Gulab Jamun. Soft. Plump and the way we are used to. There is nothing else in our gulab jamuns than authenticity and love.",
                              "imageId": "cc6e9348bb748e745a3d28396ada6e79",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541927",
                              "name": "Choco Lava Cake",
                              "category": "Desserts",
                              "description": "(Eggless) A perfect match of Chocolate Cake on the outside and molten Chocolate on the inside, our Choco Lava cake is every dessert lovers dream come true.",
                              "imageId": "bc581d5c5da4933c58262f5320a9e367",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994308",
                              "name": "Chocolate Indulgence Brownie",
                              "category": "Desserts",
                              "description": "(Eggless) Indulge in richly decadent Indulgence brownie crafted with love & topped with bittersweet chocolate that provides ultra-rich chocolate experience.",
                              "imageId": "2181e009a59d1b9edbabda8392510c7a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994509",
                              "name": "Mango Cheesecake",
                              "category": "Desserts",
                              "description": "(Eggless) This New York Style Mango Cheesecake, made with premium quality cream cheese and a crust infused with delicious mango flavor, is every dessert lovers delight!",
                              "imageId": "22cb5b6544dd912155ba957ee7023c6a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994283",
                              "name": "New York Cheesecake",
                              "category": "Desserts",
                              "description": "Dense, creamy & smooth Philadelphia cream cheese paired with a crust made with crackers & butter with a hint of ginger ,this nifty New York Cheesecake is indulgence redefined (With egg).",
                              "imageId": "e278270b3c8d900ecdb305825dfce931",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72393601",
                              "name": "Rich Red Velvet Pastry",
                              "category": "Desserts",
                              "description": "Rich and moist Red Velvet cake layered with fresh cream cheese makes our Red Velvet pastry difficult to share. Youll think twice too.",
                              "imageId": "25314893642f40a3fd2a4f82f0d74449",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128904867",
                              "name": "Death by Chocolate Cake Jar",
                              "category": "Desserts",
                              "description": "Dont take the name literally, but our Death By Chocolate Jar is a chocolate heaven sure to transport you to another level.",
                              "imageId": "3315ec37406e0cd2f7e78ade2ce7c7b5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128904868",
                              "name": "Pineapple Jar Cake",
                              "category": "Desserts",
                              "description": "Dig in straight to a tropical feeling with our moist sponge cake layered with whipped cream and topped with tart pineapples that makes this jar a sure winner.",
                              "imageId": "368e5898e36a2e472bda121dd094d23f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130405760",
                              "name": "Plum Cake (ST)",
                              "category": "Desserts",
                              "description": "The most beloved treat this season! Loaded with flavoured dry fruits, nuts and a lot of love, this Plum Cake is sure to make you drool!",
                              "imageId": "97f79532a385c71efca331a6ef0c3739",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130405761",
                              "name": "Chocolate Cheesecake",
                              "category": "Desserts",
                              "description": "Bringing the creamy richness of cheesecake and the indulgent flavour of chocolate in one because chritsmas without chocolate is definitely incomplete!",
                              "imageId": "c47fe70f3b925c5de3a241f410900038",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130405762",
                              "name": "Strawberry jar",
                              "category": "Desserts",
                              "description": "Dig into the delectable layers of strawberry jelly, cream cheese & sponge cake. This jar is a dessert you can't miss this season!",
                              "imageId": "1319010b615fabe7ddc59943c7c90f8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130304790",
                              "name": "Cold Pressed Mix Fruit Juice (250 ml)",
                              "category": "Beverages",
                              "description": "Made with no added sugars, this fresh Mixed Fruit Juice can for sure be your go-to!",
                              "imageId": "bf91d77cc56584bf43e34980137bf6f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  "title": "60% OFF",
                                  "subTitle": "USE SPECIALS",
                                  "textColor": "#DB6742",
                                  "backgroundColor": "#FAE8E3"
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123935132",
                              "name": "Masala Lemonade (180 ml)",
                              "category": "Beverages",
                              "description": "A refreshing classic drink with a combined goodness of fresh lime, himalayan pink salt & infused spices.",
                              "imageId": "6e5e863072af841f403f4a0f9e26c43b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116541892",
                              "name": "Skimmed Mint Buttermilk",
                              "category": "Beverages",
                              "description": "Mildly spiced Indian buttermilk with the freshness of mint.",
                              "imageId": "dafcdc5c1354f991385ea55974a5e00b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994611",
                              "name": "Coca-Cola Bottle (475 ML)",
                              "category": "Beverages",
                              "description": "475 ML Coca - Cola Bottle",
                              "imageId": "ydqqpussdhedmr5edm2b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994265",
                              "name": "SWIG Green Apple",
                              "category": "Beverages",
                              "description": "Aerated drink flavored with the mouth-puckering green apple. Sure to refresh you completely!",
                              "imageId": "0b76e6413a00aa350ea89779bdaaa370",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "88994261",
                              "name": "SWIG Jeera Masala Soda",
                              "category": "Beverages",
                              "description": "Aerated drink with the added zing of jeera and masala. A perfect accompaniment to your meal.",
                              "imageId": "25b016a4f3021dad1923cf8d39f2378a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126670723",
                              "name": "Thums Up 330 ml Can",
                              "category": "Beverages",
                              "description": "Thums Up 330 ml",
                              "imageId": "51ecb60ce9170ef15788585d76571cc4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6650,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "(New) Salad Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128618089",
                              "name": "Veg Greek Salad",
                              "category": "(New) Salad Bowls",
                              "description": "Served with Labneh Dressing . Serves 1.\nA classic veggie salad made with lettuce, green capsicum, cherry tomatoes, broccoli, corn, olives, and jalapenos tossed in herbs and chili. Topped with Feta Cheese, making this the perfect salad for your meal. Calories (Kcals): 211,  Carbs (Gms): 13,  Proteins (Gms): 9,  Fats (Gms): 14",
                              "imageId": "b0c3113487131b2f5ae8aadd516827dc",
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657446",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815199",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815201",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128618088",
                              "name": "Egg Greek salad",
                              "category": "(New) Salad Bowls",
                              "description": "Served with Labneh Dressing . Serves 1.\nThis Egg Greek salad is a delicious combination of lettuce, green capsicum, broccoli, cherry tomatoes, corn, olives, and jalapenos, tossed in herbs and chili. It is topped with Feta Cheese and 2 eggs, making it a filling salad for your meal. Calories (Kcals): 384,  Carbs (Gms): 13,  Proteins (Gms): 22,  Fats (Gms): 27",
                              "imageId": "d51e69a4b79207cee2ffd1ce8c955839",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657488",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815195",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815197",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128618090",
                              "name": "Garden Fresh Veg Salad",
                              "category": "(New) Salad Bowls",
                              "description": "Served with Thousand Island Dressing. Serves 1.\nExperience the freshness of veggies with lettuce, green capsicum, cherry tomatoes, corn, olives, and jalapenos tossed in herbs and chili and topped with falafel shots. Calories (Kcals): 435,  Carbs (Gms): 41,  Proteins (Gms): 11,  Fats (Gms): 26",
                              "imageId": "da1003c3d6a7b1d96b91ceff7fb567b0",
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657390",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815203",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815205",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128618086",
                              "name": "EGG-citing Green salad",
                              "category": "(New) Salad Bowls",
                              "description": "Served with Thousand Island Dressing. Serves 1.\nAn Egg Salad that's guaranteed to steal the show, with lettuce, green capsicum, cherry tomatoes, corn, olives, and jalapenos, tossed in herbs and chili, and topped with 2 eggs. Calories (Kcals): 372,  Carbs (Gms): 20,  Proteins (Gms): 18,  Fats (Gms): 25",
                              "imageId": "60a4b4053c461f8f89da31966da8c243",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127657470",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "109110942",
                                      "name": "Fries (M) + Lemonade (Save Rs 36)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109110943",
                                      "name": "Fries (M) + Thums Up 330 ML (Save Rs 37)",
                                      "price": 13900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109683852",
                                      "name": "Aloo Pattice 2 pcs + Thums Up 330 ml Can (Save Rs 20)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815187",
                                  "groupName": "Add a Starter",
                                  "choices": [
                                    {
                                      "id": "105281100",
                                      "name": "Aloo Pattice (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526546",
                                      "name": "Hara Bhara Kebab (2 pcs)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526548",
                                      "name": "Murgh Haleem Kebab (2 pcs)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110526547",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281104",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281105",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123815189",
                                  "groupName": "Add a Beverage",
                                  "choices": [
                                    {
                                      "id": "109311993",
                                      "name": "Mix Fruit Juice (250 ml)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281109",
                                      "name": "Masala Lemonade",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281110",
                                      "name": "Mint Chaas",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281112",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281111",
                                      "name": "Coca-Cola Bottle (475 ml)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105281113",
                                      "name": "Thums Up Can (330 ml)",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109311992",
                                      "name": "Orange Juice (250 ml)",
                                      "price": 12900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 12 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221333001316"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "The Good Bowl",
                      "area": "Shantinagar",
                      "completeAddress": "KMK Towers, 1st floor, WEST PORTION, 142 K H ROAD, above Tata Motors, Shanthinagar, Bangalore South, bangalore, 560027"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "pI4WbaZepy2d-dctk3SZ3zMtOfI5T2taLsUU-7t4"
},
// 20240105233443
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=30531&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "30531",
              "name": "Hotel Empire",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "empire-restaurant-central-bangalore-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "qltgnkyywuo5gmnpqzbm",
              "locality": "Brigade Road",
              "areaName": "Church Street",
              "costForTwo": "45000",
              "costForTwoMessage": "₹450 for two",
              "cuisines": [
                "North Indian",
                "Kebabs"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "30531",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "2 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "475",
              "avgRatingString": "4.4",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "30531",
                "deliveryTime": 36,
                "minDeliveryTime": 36,
                "maxDeliveryTime": 36,
                "lastMileTravel": 2.1,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "36 MINS",
                "lastMileTravelString": "2.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 03:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "empire-restaurant-central-bangalore-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Empire SuitesNo.35, Castle Street, Off Brigade Road,Bengaluru, Karnataka 560025"
                },
                {
                  "title": "Cuisines",
                  "message": "North Indian,Kebabs"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 350,
                  "maxValue": 500,
                  "priority": 1,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 10
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 10% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 10% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/30531"
              },
              "expectationNotifiers": [
                {
                  "text": "2 kms | ₹38 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>2 kms</b> | ₹38 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.96727,77.60893599999997"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT 10% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "e90f7131-2dfa-4b63-9ea6-30e32d232e43"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "30531",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "30531",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "30531",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "30531",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "30531",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Combo Meals",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624497",
                              "name": "2 Naan, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                              "category": "Empire Special Combo Meals",
                              "description": "Naan (2Nos), Hyderabadi Chicken Boneless Gravy(5 Pcs), Popcorn Kebab (5 Pcs)",
                              "imageId": "64cd5b8b56e78056bb59df1a3a587fc5",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310719",
                                  "groupName": "Choose From Desserts for 2 Naan, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741241",
                                  "groupName": "Choose From Extras for 2 Naan, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310720",
                                  "groupName": "Choose From Falooda for 2 Naan, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475816",
                              "name": "Chicken Biryani (Regular), Raita & Popcorn Kebab",
                              "category": "Empire Special Combo Meals",
                              "description": "Chicken Biriyani (Regular), Raitha, Popcorn Kebab (5 Pcs)",
                              "imageId": "d10e48e5df00b7ac4d66e9209180b03f",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310723",
                                  "groupName": "Choose From Desserts for Chicken Biryani (Regular), Raita & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741295",
                                  "groupName": "Choose From Extras for Chicken Biryani (Regular), Raita & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883978",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Biryani (Regular), Raita & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310724",
                                  "groupName": "Choose From Falooda for Chicken Biryani (Regular), Raita & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "160 ratings",
                                  "ratingCountV2": "160"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624511",
                              "name": "Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "Ghee Rice, Panner Butter Masala (5 pcs), Gobi Manchurian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310738",
                                  "groupName": "Choose From Desserts for Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741311",
                                  "groupName": "Choose From Extras for Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883985",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860995",
                                  "groupName": "Choose From Soft Drink for Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310739",
                                  "groupName": "Choose From Falooda for Ghee Rice with Paneer Butter Masala & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "125 ratings",
                                  "ratingCountV2": "125"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475817",
                              "name": "Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                              "category": "Empire Special Combo Meals",
                              "description": "Ghee Rice, Butter Chicken Bonless (5 Pcs), Manchurian Dry (5 Pcs)",
                              "imageId": "a30296021eb13be078a4d634ca9344ba",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310746",
                                  "groupName": "Choose From Desserts for Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741309",
                                  "groupName": "Choose From Extras for Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883987",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860990",
                                  "groupName": "Choose From Soft Drink for Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310747",
                                  "groupName": "Choose From Falooda for Ghee Rice Butter Chicken Combo & Chicken Manchurian Dry",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "409 ratings",
                                  "ratingCountV2": "409"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624512",
                              "name": "Veg Fried Rice & Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "Veg Fried Rice, Gobi Manchurian",
                              "imageId": "eb5424e138ba78636ab2dc1a72aef69c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310727",
                                  "groupName": "Choose From Desserts for Veg Fried Rice & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741293",
                                  "groupName": "Choose From Extras for Veg Fried Rice & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883998",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Veg Fried Rice & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860991",
                                  "groupName": "Choose From Soft Drink for Veg Fried Rice & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310728",
                                  "groupName": "Choose From Falooda for Veg Fried Rice & Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "57 ratings",
                                  "ratingCountV2": "57"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475819",
                              "name": "Ghee Rice with Dal Fry",
                              "category": "Empire Special Combo Meals",
                              "description": "Ghee Rice, Dal Fry",
                              "imageId": "106c7fc15ca92f8cec84ae276ad1dbe0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310713",
                                  "groupName": "Choose From Desserts for Ghee Rice with Dal Fry",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741313",
                                  "groupName": "Choose From Extras for Ghee Rice with Dal Fry",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883986",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice with Dal Fry",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860984",
                                  "groupName": "Choose From Soft Drink for Ghee Rice with Dal Fry",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310714",
                                  "groupName": "Choose From Falooda for Ghee Rice with Dal Fry",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "157 ratings",
                                  "ratingCountV2": "157"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624498",
                              "name": "2 Naan, Paneer Butter Masala, Gobi Manchurian",
                              "category": "Empire Special Combo Meals",
                              "description": "2Naan,Paneer Butter Masala (5 pcs),Gobi Manchurian",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310749",
                                  "groupName": "Choose From Desserts for 2 Naan, Paneer Butter Masala, Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741262",
                                  "groupName": "Choose From Extras for 2 Naan, Paneer Butter Masala, Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310750",
                                  "groupName": "Choose From Falooda for 2 Naan, Paneer Butter Masala, Gobi Manchurian",
                                  "choices": [
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "142 ratings",
                                  "ratingCountV2": "142"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624496",
                              "name": "3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                              "category": "Empire Special Combo Meals",
                              "description": "Coin Parotta (2 Nos), Hyderabadi Chicken Boneless (5 Pcs), Popcorn Kebab (5 Pcs)",
                              "imageId": "cb3b6010e953169a8fb62dfd3f101c71",
                              "inStock": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310711",
                                  "groupName": "Choose From Desserts for 3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741252",
                                  "groupName": "Choose From Extras for 3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310712",
                                  "groupName": "Choose From Falooda for 3 Coin Parotta, Hyderabadi Boneless Chicken Gravy & Popcorn Kebab",
                                  "choices": [
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "88 ratings",
                                  "ratingCountV2": "88"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85624501",
                              "name": "Ghee Rice Butter Chicken Combo",
                              "category": "Empire Special Combo Meals",
                              "description": "Ghee Rice, Butter Chicken Boneless (5 Pcs)",
                              "imageId": "04a33e989a9ad8f7846e35d0af6a91da",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310715",
                                  "groupName": "Choose From Desserts for Ghee Rice Butter Chicken Combo",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741303",
                                  "groupName": "Choose From Extras for Ghee Rice Butter Chicken Combo",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883982",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice Butter Chicken Combo",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860997",
                                  "groupName": "Choose From Soft Drink for Ghee Rice Butter Chicken Combo",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310716",
                                  "groupName": "Choose From Falooda for Ghee Rice Butter Chicken Combo",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "350 ratings",
                                  "ratingCountV2": "350"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475818",
                              "name": "Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                              "category": "Empire Special Combo Meals",
                              "description": "Ghee Rice, Mutton Varuval Bone (1 Pc), Chilly Chicken Boneless (5 Pcs)",
                              "imageId": "86af19ed2bebb68f3eaf9f66ca768cec",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129310725",
                                  "groupName": "Choose From Desserts for Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741264",
                                  "groupName": "Choose From Extras for Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883980",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860985",
                                  "groupName": "Choose From Soft Drink for Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310726",
                                  "groupName": "Choose From Falooda for Ghee Rice Mutton Varaval Bone & Chilly Chicken Boneless",
                                  "choices": [
                                    {
                                      "id": "110049238",
                                      "name": "Rabdi Falooda",
                                      "price": 15400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110049237",
                                      "name": "Empire Special Falooda",
                                      "price": 19800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Classic Dry",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296762",
                              "name": "Empire Special Chicken Kebab",
                              "category": "Empire Classic Dry",
                              "description": "Empire Special Chicken Kebab Empire Classic Dry",
                              "imageId": "278713a5bde03131f5e5d0ad0ff27712",
                              "inStock": 1,
                              "price": 10700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211350",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Empire Special Chicken Kebab (Qtr)",
                                        "default": 1,
                                        "id": "108992769",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Empire Special Chicken Kebab (Half)",
                                        "price": 87,
                                        "id": "108992770",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Empire Special Chicken Kebab (Full)",
                                        "price": 270,
                                        "id": "108992771",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211350",
                                        "variationId": "108992769"
                                      }
                                    ],
                                    "price": 10700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852242",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758844",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269364",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211350",
                                        "variationId": "108992770"
                                      }
                                    ],
                                    "price": 19400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852243",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758845",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269365",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211350",
                                        "variationId": "108992771"
                                      }
                                    ],
                                    "price": 37700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758846",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852244",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269366",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758844",
                                  "groupName": "Choose From Salads for Empire Special Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758845",
                                  "groupName": "Choose From Salads for Empire Special Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758846",
                                  "groupName": "Choose From Salads for Empire Special Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269364",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Empire Special Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269365",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Empire Special Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269366",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Empire Special Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852242",
                                  "groupName": "Choose From Soft Drink for Empire Special Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852243",
                                  "groupName": "Choose From Soft Drink for Empire Special Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852244",
                                  "groupName": "Choose From Soft Drink for Empire Special Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10700,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3280 ratings",
                                  "ratingCountV2": "3280"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296604",
                              "name": "Chicken Manchurian Boneless",
                              "category": "Empire Classic Dry",
                              "description": "Chicken Manchurian Boneless Empire Classic Dry",
                              "imageId": "24ca450dc4b3055d88a9d9b50bd1dcc4",
                              "inStock": 1,
                              "price": 13700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211281",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Manchurian Boneless (Qtr)",
                                        "default": 1,
                                        "id": "108992665",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Manchurian Boneless (Half)",
                                        "price": 115,
                                        "id": "108992666",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Manchurian Boneless (Full)",
                                        "price": 346,
                                        "id": "108992667",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211281",
                                        "variationId": "108992665"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269393",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269397",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211281",
                                        "variationId": "108992666"
                                      }
                                    ],
                                    "price": 25200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269394",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269398",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211281",
                                        "variationId": "108992667"
                                      }
                                    ],
                                    "price": 48300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269399",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269396",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269393",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Manchurian Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269394",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Manchurian Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269396",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Manchurian Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269397",
                                  "groupName": "Choose From Soft Drink for Chicken Manchurian Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269398",
                                  "groupName": "Choose From Soft Drink for Chicken Manchurian Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269399",
                                  "groupName": "Choose From Soft Drink for Chicken Manchurian Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "175 ratings",
                                  "ratingCountV2": "175"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475771",
                              "name": "Chicken Boneless Kebab",
                              "category": "Empire Classic Dry",
                              "description": "Chilly Chicken Boneless Kebab Empire Classic Dry",
                              "imageId": "015879ecc75c001c8e4ab70050d72de2",
                              "inStock": 1,
                              "price": 13200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211349",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Boneless Kebab (Qtr)",
                                        "default": 1,
                                        "id": "108992766",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Boneless Kebab (Half)",
                                        "price": 123,
                                        "id": "108992767",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Boneless Kebab (Full)",
                                        "price": 358,
                                        "id": "108992768",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211349",
                                        "variationId": "108992766"
                                      }
                                    ],
                                    "price": 13200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758835",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211349",
                                        "variationId": "108992767"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758836",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211349",
                                        "variationId": "108992768"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758837",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758835",
                                  "groupName": "Choose From Salads for Chicken Boneless Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758836",
                                  "groupName": "Choose From Salads for Chicken Boneless Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758837",
                                  "groupName": "Choose From Salads for Chicken Boneless Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296605",
                              "name": "Mutton Pepper Dry",
                              "category": "Empire Classic Dry",
                              "description": "Mutton Pepper Dry Empire Classic Dry",
                              "imageId": "c594bf0d276d9b856733936d4a6d2859",
                              "inStock": 1,
                              "price": 18500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211354",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mutton Pepper Dry (Qtr)",
                                        "default": 1,
                                        "id": "108992778",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mutton Pepper Dry (Half)",
                                        "price": 145,
                                        "id": "108992779",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mutton Pepper Dry (Full)",
                                        "price": 445,
                                        "id": "108992780",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211354",
                                        "variationId": "108992778"
                                      }
                                    ],
                                    "price": 18500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269253",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269256",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211354",
                                        "variationId": "108992779"
                                      }
                                    ],
                                    "price": 33000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269254",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269257",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211354",
                                        "variationId": "108992780"
                                      }
                                    ],
                                    "price": 63000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269255",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269258",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269253",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Pepper Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269254",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Pepper Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269255",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Pepper Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269256",
                                  "groupName": "Choose From Soft Drink for Mutton Pepper Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269257",
                                  "groupName": "Choose From Soft Drink for Mutton Pepper Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269258",
                                  "groupName": "Choose From Soft Drink for Mutton Pepper Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936064",
                              "name": "Alfaham Chicken",
                              "category": "Empire Classic Dry",
                              "description": "Alfaham Chicken Empire Classic Dry",
                              "inStock": 1,
                              "price": 13800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211347",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Alfaham Chicken (Qtr)",
                                        "default": 1,
                                        "id": "108992761",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Alfaham Chicken (Half)",
                                        "price": 107,
                                        "id": "108992762",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Alfaham Chicken (Full)",
                                        "price": 324,
                                        "id": "108992763",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211347",
                                        "variationId": "108992761"
                                      }
                                    ],
                                    "price": 13800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852245",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269265",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "125758821",
                                        "addonId": "108009018"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211347",
                                        "variationId": "108992762"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758822",
                                        "addonId": "108009018"
                                      },
                                      {
                                        "groupId": "125758827",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852246",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269266",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211347",
                                        "variationId": "108992763"
                                      }
                                    ],
                                    "price": 46200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758828",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852247",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269267",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "125758824",
                                        "addonId": "108009018"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758827",
                                  "groupName": "Choose From Salads for Alfaham Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758828",
                                  "groupName": "Choose From Salads for Alfaham Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758821",
                                  "groupName": "Choose From Extras for Alfaham Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758822",
                                  "groupName": "Choose From Extras for Alfaham Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758824",
                                  "groupName": "Choose From Extras for Alfaham Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269265",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Alfaham Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269266",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Alfaham Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269267",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Alfaham Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852245",
                                  "groupName": "Choose From Soft Drink for Alfaham Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852246",
                                  "groupName": "Choose From Soft Drink for Alfaham Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852247",
                                  "groupName": "Choose From Soft Drink for Alfaham Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13800,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "615 ratings",
                                  "ratingCountV2": "615"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297208",
                              "name": "Chilly Chicken Boneless",
                              "category": "Empire Classic Dry",
                              "description": "Chilly Chicken Boneless Empire Classic Dry",
                              "imageId": "022f437e508354da5e0905c72dfb0570",
                              "inStock": 1,
                              "price": 13700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211282",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chilly Chicken Boneless (Qtr)",
                                        "default": 1,
                                        "id": "108992668",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilly Chicken Boneless (Half)",
                                        "price": 115,
                                        "id": "108992669",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chilly Chicken Boneless (Full)",
                                        "price": 346,
                                        "id": "108992670",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211282",
                                        "variationId": "108992668"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269331",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269334",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758591",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211282",
                                        "variationId": "108992669"
                                      }
                                    ],
                                    "price": 25200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758592",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269335",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269332",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211282",
                                        "variationId": "108992670"
                                      }
                                    ],
                                    "price": 48300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269333",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269336",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758593",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758591",
                                  "groupName": "Choose From Salads for Chilly Chicken Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758592",
                                  "groupName": "Choose From Salads for Chilly Chicken Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758593",
                                  "groupName": "Choose From Salads for Chilly Chicken Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269331",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chilly Chicken Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269332",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chilly Chicken Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269333",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chilly Chicken Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269334",
                                  "groupName": "Choose From Soft Drink for Chilly Chicken Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269335",
                                  "groupName": "Choose From Soft Drink for Chilly Chicken Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269336",
                                  "groupName": "Choose From Soft Drink for Chilly Chicken Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "393 ratings",
                                  "ratingCountV2": "393"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296654",
                              "name": "Grilled Chicken",
                              "category": "Empire Classic Dry",
                              "description": "Grilled Chicken Empire Classic Dry",
                              "imageId": "f49eafa7a6d4201b9c0fa4375155f057",
                              "inStock": 1,
                              "price": 21400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211352",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Grilled Chicken (Half)",
                                        "default": 1,
                                        "id": "108992773",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Grilled Chicken (Full)",
                                        "price": 206,
                                        "id": "108992774",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211352",
                                        "variationId": "108992773"
                                      }
                                    ],
                                    "price": 21400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269287",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852254",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758852",
                                        "addonId": "108009018"
                                      },
                                      {
                                        "groupId": "125758854",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211352",
                                        "variationId": "108992774"
                                      }
                                    ],
                                    "price": 42000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758853",
                                        "addonId": "108009018"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269288",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "125758855",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "128852255",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758854",
                                  "groupName": "Choose From Salads for Grilled Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758855",
                                  "groupName": "Choose From Salads for Grilled Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758852",
                                  "groupName": "Choose From Extras for Grilled Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758853",
                                  "groupName": "Choose From Extras for Grilled Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269287",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Grilled Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269288",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Grilled Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852254",
                                  "groupName": "Choose From Soft Drink for Grilled Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128852255",
                                  "groupName": "Choose From Soft Drink for Grilled Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21400,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3302 ratings",
                                  "ratingCountV2": "3302"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297280",
                              "name": "Mutton Brain Dry Fry",
                              "category": "Empire Classic Dry",
                              "description": "Mutton Brain Dry Fry Empire Classic Dry",
                              "imageId": "990dcb5d6cffe6206343c7aa8ba78aa7",
                              "inStock": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211353",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mutton Brain Dry Fry (Qtr)",
                                        "default": 1,
                                        "id": "108992775",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mutton Brain Dry Fry (Half)",
                                        "price": 180,
                                        "id": "108992776",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mutton Brain Dry Fry (Full)",
                                        "price": 540,
                                        "id": "108992777",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211353",
                                        "variationId": "108992775"
                                      }
                                    ],
                                    "price": 18000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269430",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269427",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211353",
                                        "variationId": "108992776"
                                      }
                                    ],
                                    "price": 36000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269431",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269428",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211353",
                                        "variationId": "108992777"
                                      }
                                    ],
                                    "price": 72000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269432",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269429",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269427",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Brain Dry Fry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269428",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Brain Dry Fry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269429",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Brain Dry Fry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269430",
                                  "groupName": "Choose From Soft Drink for Mutton Brain Dry Fry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269431",
                                  "groupName": "Choose From Soft Drink for Mutton Brain Dry Fry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269432",
                                  "groupName": "Choose From Soft Drink for Mutton Brain Dry Fry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "218 ratings",
                                  "ratingCountV2": "218"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296644",
                              "name": "Pepper Chicken Dry",
                              "category": "Empire Classic Dry",
                              "description": "Pepper Chicken Dry Empire Classic Dry",
                              "imageId": "aa7f1c816c4bd99cb0cef08e4546f62a",
                              "inStock": 1,
                              "price": 13300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211283",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pepper Chicken Dry (Qtr)",
                                        "default": 1,
                                        "id": "108992671",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Chicken Dry (Half)",
                                        "price": 102,
                                        "id": "108992672",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Chicken Dry (Full)",
                                        "price": 316,
                                        "id": "108992673",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211283",
                                        "variationId": "108992671"
                                      }
                                    ],
                                    "price": 13300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758607",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269315",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269312",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211283",
                                        "variationId": "108992672"
                                      }
                                    ],
                                    "price": 23500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269313",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269316",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758608",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211283",
                                        "variationId": "108992673"
                                      }
                                    ],
                                    "price": 44900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758609",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269317",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269314",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758607",
                                  "groupName": "Choose From Salads for Pepper Chicken Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758608",
                                  "groupName": "Choose From Salads for Pepper Chicken Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758609",
                                  "groupName": "Choose From Salads for Pepper Chicken Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269312",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269313",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269314",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269315",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269316",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269317",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "198 ratings",
                                  "ratingCountV2": "198"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296598",
                              "name": "Popcorn Chicken Kebab",
                              "category": "Empire Classic Dry",
                              "description": "Popcorn Chicken Kebab Empire Classic Dry",
                              "imageId": "4a5c79051ccb0b33e80f96f363e3f1ce",
                              "inStock": 1,
                              "price": 13700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211288",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Popcorn Chicken Kebab (Qtr)",
                                        "default": 1,
                                        "id": "108992678",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Popcorn Chicken Kebab (Half)",
                                        "price": 118,
                                        "id": "108992679",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Popcorn Chicken Kebab (Full)",
                                        "price": 353,
                                        "id": "108992680",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211288",
                                        "variationId": "108992678"
                                      }
                                    ],
                                    "price": 13700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269357",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269360",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758641",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211288",
                                        "variationId": "108992679"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269361",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758642",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269358",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211288",
                                        "variationId": "108992680"
                                      }
                                    ],
                                    "price": 49000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269362",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758643",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269359",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758641",
                                  "groupName": "Choose From Salads for Popcorn Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758642",
                                  "groupName": "Choose From Salads for Popcorn Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758643",
                                  "groupName": "Choose From Salads for Popcorn Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269357",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Popcorn Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269358",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Popcorn Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269359",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Popcorn Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269360",
                                  "groupName": "Choose From Soft Drink for Popcorn Chicken Kebab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269361",
                                  "groupName": "Choose From Soft Drink for Popcorn Chicken Kebab (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269362",
                                  "groupName": "Choose From Soft Drink for Popcorn Chicken Kebab (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 13700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "604 ratings",
                                  "ratingCountV2": "604"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297324",
                              "name": "Pepper Chicken Dry Boneless",
                              "category": "Empire Classic Dry",
                              "description": "Pepper Chicken Dry Boneless Empire Classic Dry",
                              "imageId": "f03dd89dcfeda8d94ad0b25294f2ede2",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211356",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pepper Chicken Dry Boneless (Qtr)",
                                        "default": 1,
                                        "id": "108992783",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Chicken Dry Boneless (Half)",
                                        "price": 109,
                                        "id": "108992784",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Chicken Dry Boneless (Full)",
                                        "price": 336,
                                        "id": "108992785",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211356",
                                        "variationId": "108992783"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269411",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269408",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211356",
                                        "variationId": "108992784"
                                      }
                                    ],
                                    "price": 25200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269409",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269412",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211356",
                                        "variationId": "108992785"
                                      }
                                    ],
                                    "price": 47900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269410",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269413",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269408",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269409",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269410",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Dry Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269411",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269412",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269413",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Dry Boneless (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "454 ratings",
                                  "ratingCountV2": "454"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Biryani",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296568",
                              "name": "Chicken Biryani",
                              "category": "Empire Biryani",
                              "description": "Chicken Biryani Empire Biryani",
                              "imageId": "10f8b483521b9359d9c8fcd37f23c9d3",
                              "inStock": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211422",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Biryani (Reguler)",
                                        "default": 1,
                                        "id": "108992900",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Biryani (Large)",
                                        "price": 115,
                                        "id": "108992901",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211422",
                                        "variationId": "108992900"
                                      }
                                    ],
                                    "price": 18000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758959",
                                        "addonId": "108009016"
                                      },
                                      {
                                        "groupId": "125758959",
                                        "addonId": "108009014"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129310734",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129310732",
                                        "addonId": "110049232"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129310736",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758961",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211422",
                                        "variationId": "108992901"
                                      }
                                    ],
                                    "price": 29500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129310735",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129310737",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "125758960",
                                        "addonId": "108009016"
                                      },
                                      {
                                        "groupId": "125758960",
                                        "addonId": "108009014"
                                      },
                                      {
                                        "groupId": "125758962",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "129310733",
                                        "addonId": "110049232"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129310732",
                                  "groupName": "Choose From Desserts for Chicken Biryani (Reguler)",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310733",
                                  "groupName": "Choose From Desserts for Chicken Biryani (Large)",
                                  "choices": [
                                    {
                                      "id": "110049232",
                                      "name": "Tender Coconut Pudding",
                                      "price": 7100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758961",
                                  "groupName": "Choose From Salads for Chicken Biryani (Reguler)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758962",
                                  "groupName": "Choose From Salads for Chicken Biryani (Large)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758959",
                                  "groupName": "Choose From Extras for Chicken Biryani (Reguler)",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758960",
                                  "groupName": "Choose From Extras for Chicken Biryani (Large)",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310734",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Biryani (Reguler)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310735",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Biryani (Large)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310736",
                                  "groupName": "Choose From Soft Drink for Chicken Biryani (Reguler)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129310737",
                                  "groupName": "Choose From Soft Drink for Chicken Biryani (Large)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "2002 ratings",
                                  "ratingCountV2": "2002"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297149",
                              "name": "Curd Rice",
                              "category": "Empire Special Rice",
                              "description": "Yogurt and rice with a tadka of spices",
                              "imageId": "7a90ecdc0f5ebfb959c6ea46f96d3ff3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128664620",
                                  "groupName": "Choose From Salads for Curd Rice",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128664621",
                                  "groupName": "Choose From Extras for Curd Rice",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128884000",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Curd Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128664622",
                                  "groupName": "Choose From Soft Drink for Curd Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "102 ratings",
                                  "ratingCountV2": "102"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296582",
                              "name": "Jeera Rice",
                              "category": "Empire Special Rice",
                              "description": "Fresh coocked rice with jeera of cumin seeds",
                              "imageId": "d967ec98484baa319242a2e5a55d8919",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758896",
                                  "groupName": "Choose From EM Complimentary for Jeera Rice",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125758894",
                                  "groupName": "Choose From Extras for Jeera Rice",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883997",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Jeera Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758893",
                                  "groupName": "Choose From Soft Drink for Jeera Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758895",
                                  "groupName": "Choose From Salads for Jeera Rice",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "180 ratings",
                                  "ratingCountV2": "180"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296609",
                              "name": "Ghee Rice",
                              "category": "Empire Special Rice",
                              "description": "Empire's signature and must have",
                              "imageId": "3a73310cfa97442436cbe5394df115f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758891",
                                  "groupName": "Choose From Salads for Ghee Rice",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758890",
                                  "groupName": "Choose From Extras for Ghee Rice",
                                  "choices": [
                                    {
                                      "id": "108009014",
                                      "name": "Curd",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009016",
                                      "name": "Raitha",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883983",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ghee Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758889",
                                  "groupName": "Choose From Soft Drink for Ghee Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758892",
                                  "groupName": "Choose From EM Complimentary for Ghee Rice",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10100,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3859 ratings",
                                  "ratingCountV2": "3859"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Tandoori(Dry)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296740",
                              "name": "Tandoori Chicken",
                              "category": "Empire Tandoori(Dry)",
                              "description": "Tandoori Chicken Empire Tandoori(Dry)",
                              "imageId": "66cef11a7bc4db69349ec7e23b09a355",
                              "inStock": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211390",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Tandoori Chicken (Qtr)",
                                        "default": 1,
                                        "id": "108992836",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Tandoori Chicken (Half)",
                                        "price": 105,
                                        "id": "108992837",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Tandoori Chicken (Full)",
                                        "price": 320,
                                        "id": "108992838",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211390",
                                        "variationId": "108992836"
                                      }
                                    ],
                                    "price": 14000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758938",
                                        "addonId": "108009017"
                                      },
                                      {
                                        "groupId": "125758935",
                                        "addonId": "108009018"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211390",
                                        "variationId": "108992837"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758936",
                                        "addonId": "108009018"
                                      },
                                      {
                                        "groupId": "125758939",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211390",
                                        "variationId": "108992838"
                                      }
                                    ],
                                    "price": 46000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758937",
                                        "addonId": "108009018"
                                      },
                                      {
                                        "groupId": "125758940",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758938",
                                  "groupName": "Choose From Salads for Tandoori Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758939",
                                  "groupName": "Choose From Salads for Tandoori Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758940",
                                  "groupName": "Choose From Salads for Tandoori Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758935",
                                  "groupName": "Choose From Extras for Tandoori Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758936",
                                  "groupName": "Choose From Extras for Tandoori Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758937",
                                  "groupName": "Choose From Extras for Tandoori Chicken (Full)",
                                  "choices": [
                                    {
                                      "id": "108009018",
                                      "name": "Kuboos",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "405 ratings",
                                  "ratingCountV2": "405"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297467",
                              "name": "Murg Tikka",
                              "category": "Empire Tandoori(Dry)",
                              "description": "Murg Tikka Empire Tandoori(Dry)",
                              "imageId": "52daf14104afac4763b902c809e7dec5",
                              "inStock": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211389",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Murg Tikka (Qtr)",
                                        "default": 1,
                                        "id": "108992834",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Murg Tikka (Half)",
                                        "price": 105,
                                        "id": "108992835",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211389",
                                        "variationId": "108992834"
                                      }
                                    ],
                                    "price": 15000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758930",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211389",
                                        "variationId": "108992835"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758931",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758930",
                                  "groupName": "Choose From Salads for Murg Tikka (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758931",
                                  "groupName": "Choose From Salads for Murg Tikka (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297141",
                              "name": "Kalmi Kabab",
                              "category": "Empire Tandoori(Dry)",
                              "description": "Kalmi Kabab Empire Tandoori(Dry)",
                              "imageId": "b47194f76ee3ae658325b7c5a8603753",
                              "inStock": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211388",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Kalmi Kabab (Qtr)",
                                        "default": 1,
                                        "id": "108992832",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kalmi Kabab (Half)",
                                        "price": 125,
                                        "id": "108992833",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211388",
                                        "variationId": "108992832"
                                      }
                                    ],
                                    "price": 15000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758924",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211388",
                                        "variationId": "108992833"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "125758925",
                                        "addonId": "108009017"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "125758924",
                                  "groupName": "Choose From Salads for Kalmi Kabab (Qtr)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758925",
                                  "groupName": "Choose From Salads for Kalmi Kabab (Half)",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Classic Non-Veg Gravy",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296591",
                              "name": "Butter Chicken",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Butter Chicken Empire Classic Non-Veg Gravy",
                              "imageId": "81e6d6875066ba4dc01fc9f9c911e58d",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211357",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Butter Chicken (Qtr)",
                                        "default": 1,
                                        "id": "108992786",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Butter Chicken (Half)",
                                        "price": 112,
                                        "id": "108992787",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211357",
                                        "variationId": "108992786"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269339",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269341",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211357",
                                        "variationId": "108992787"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269342",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269340",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269339",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269340",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269341",
                                  "groupName": "Choose From Soft Drink for Butter Chicken (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269342",
                                  "groupName": "Choose From Soft Drink for Butter Chicken (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "466 ratings",
                                  "ratingCountV2": "466"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297259",
                              "name": "Chicken Tikka Masala",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Chicken Tikka Masala Empire Classic Non-Veg Gravy",
                              "imageId": "ec8712d535250e02fbc4245e1cd4e202",
                              "inStock": 1,
                              "price": 15300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211360",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Tikka Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992792",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Tikka Masala (Half)",
                                        "price": 120,
                                        "id": "108992793",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211360",
                                        "variationId": "108992792"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269276",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269274",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211360",
                                        "variationId": "108992793"
                                      }
                                    ],
                                    "price": 27300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269275",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269277",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269274",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Tikka Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269275",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Tikka Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269276",
                                  "groupName": "Choose From Soft Drink for Chicken Tikka Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269277",
                                  "groupName": "Choose From Soft Drink for Chicken Tikka Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "505 ratings",
                                  "ratingCountV2": "505"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297181",
                              "name": "Butter Chicken Boneless",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Butter Chicken Boneless Empire Classic Non-Veg Gravy",
                              "imageId": "81e6d6875066ba4dc01fc9f9c911e58d",
                              "inStock": 1,
                              "price": 15300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211358",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Butter Chicken Boneless (Qtr)",
                                        "default": 1,
                                        "id": "108992788",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Butter Chicken Boneless (Half)",
                                        "price": 112,
                                        "id": "108992789",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211358",
                                        "variationId": "108992788"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269343",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269345",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211358",
                                        "variationId": "108992789"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269344",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269346",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269343",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Chicken Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269344",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Chicken Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269345",
                                  "groupName": "Choose From Soft Drink for Butter Chicken Boneless (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269346",
                                  "groupName": "Choose From Soft Drink for Butter Chicken Boneless (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "889 ratings",
                                  "ratingCountV2": "889"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297491",
                              "name": "Chicken Varaval",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Empire special recipe with spices and coconut milk.",
                              "imageId": "6815ab0a6b89777a1e71fa655461e2ac",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211361",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Varaval (Qtr)",
                                        "default": 1,
                                        "id": "108992794",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Varaval (Half)",
                                        "price": 112,
                                        "id": "108992795",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211361",
                                        "variationId": "108992794"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269304",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269302",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211361",
                                        "variationId": "108992795"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269303",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269305",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269302",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Varaval (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269303",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Varaval (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269304",
                                  "groupName": "Choose From Soft Drink for Chicken Varaval (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269305",
                                  "groupName": "Choose From Soft Drink for Chicken Varaval (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "180 ratings",
                                  "ratingCountV2": "180"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296636",
                              "name": "Pepper Chicken Masala",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Pepper Chicken Masala Empire Classic Non-Veg Gravy",
                              "imageId": "17c4f65431a67dd500bc9ac2ad079be3",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211363",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pepper Chicken Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992798",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Chicken Masala (Half)",
                                        "price": 112,
                                        "id": "108992799",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211363",
                                        "variationId": "108992798"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269372",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269374",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211363",
                                        "variationId": "108992799"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269373",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269375",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269372",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269373",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Chicken Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269374",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269375",
                                  "groupName": "Choose From Soft Drink for Pepper Chicken Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "172 ratings",
                                  "ratingCountV2": "172"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296652",
                              "name": "Chicken Kurma",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Chicken Kurma Empire Classic Non-Veg Gravy",
                              "imageId": "2540db6f63cfe6b6ecc882c97f8eda37",
                              "inStock": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211359",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Kurma (Qtr)",
                                        "default": 1,
                                        "id": "108992790",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Kurma (Half)",
                                        "price": 112,
                                        "id": "108992791",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211359",
                                        "variationId": "108992790"
                                      }
                                    ],
                                    "price": 14300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269386",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269384",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211359",
                                        "variationId": "108992791"
                                      }
                                    ],
                                    "price": 25500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269385",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269387",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269384",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Kurma (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269385",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Kurma (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269386",
                                  "groupName": "Choose From Soft Drink for Chicken Kurma (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269387",
                                  "groupName": "Choose From Soft Drink for Chicken Kurma (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296626",
                              "name": "Chicken Tandoori Masala",
                              "category": "Empire Classic Non-Veg Gravy",
                              "imageId": "1a9f392afb211030d33f9be5b3c3744c",
                              "inStock": 1,
                              "price": 15800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211241",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chicken Tandoori Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992623",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chicken Tandoori Masala (Half)",
                                        "price": 117,
                                        "id": "108992624",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211241",
                                        "variationId": "108992623"
                                      }
                                    ],
                                    "price": 15800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269389",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269391",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211241",
                                        "variationId": "108992624"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269390",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269392",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269389",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Tandoori Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269390",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Tandoori Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269391",
                                  "groupName": "Choose From Soft Drink for Chicken Tandoori Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269392",
                                  "groupName": "Choose From Soft Drink for Chicken Tandoori Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "145 ratings",
                                  "ratingCountV2": "145"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297357",
                              "name": "Mutton Varaval",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Mutton Varaval Empire Classic Non-Veg Gravy",
                              "imageId": "e3d45a109493743975cc7d703634884f",
                              "inStock": 1,
                              "price": 17300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211362",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mutton Varaval (Qtr)",
                                        "default": 1,
                                        "id": "108992796",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mutton Varaval (Half)",
                                        "price": 152,
                                        "id": "108992797",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211362",
                                        "variationId": "108992796"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269320",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269322",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211362",
                                        "variationId": "108992797"
                                      }
                                    ],
                                    "price": 32500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269323",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269321",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269320",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Varaval (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269321",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Mutton Varaval (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269322",
                                  "groupName": "Choose From Soft Drink for Mutton Varaval (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269323",
                                  "groupName": "Choose From Soft Drink for Mutton Varaval (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 17300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297005",
                              "name": "Pepper Mutton Masala",
                              "category": "Empire Classic Non-Veg Gravy",
                              "description": "Pepper Mutton Masala Empire Classic Non-Veg Gravy",
                              "imageId": "1560a292e8805d72940c4ac8f3f446af",
                              "inStock": 1,
                              "price": 17300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211364",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pepper Mutton Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992800",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pepper Mutton Masala (Half)",
                                        "price": 152,
                                        "id": "108992801",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211364",
                                        "variationId": "108992800"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269261",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269259",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211364",
                                        "variationId": "108992801"
                                      }
                                    ],
                                    "price": 32500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269260",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269263",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269259",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Mutton Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269260",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Pepper Mutton Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269261",
                                  "groupName": "Choose From Soft Drink for Pepper Mutton Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269263",
                                  "groupName": "Choose From Soft Drink for Pepper Mutton Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 17300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Non Veg Gravy",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297502",
                              "name": "Hyderabadi Chicken Boneless Gravy",
                              "category": "Non Veg Gravy",
                              "description": "Hyderabadi Chicken Boneless Gravy Non Veg Gravy",
                              "imageId": "4c58f48cdbfbe4ffcbddac7221ef99e8",
                              "inStock": 1,
                              "price": 15300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211428",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Hyderabadi Chicken Boneless Gravy (Qtr)",
                                        "default": 1,
                                        "id": "108992912",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hyderabadi Chicken Boneless Gravy (Half)",
                                        "price": 112,
                                        "id": "108992913",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211428",
                                        "variationId": "108992912"
                                      }
                                    ],
                                    "price": 15300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269378",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269380",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211428",
                                        "variationId": "108992913"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269379",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269381",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269378",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Hyderabadi Chicken Boneless Gravy (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269379",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Hyderabadi Chicken Boneless Gravy (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269380",
                                  "groupName": "Choose From Soft Drink for Hyderabadi Chicken Boneless Gravy (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269381",
                                  "groupName": "Choose From Soft Drink for Hyderabadi Chicken Boneless Gravy (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 15300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Gravy",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475770",
                              "name": "Dal Thadaka",
                              "category": "Veg Gravy",
                              "description": "Dal Thadaka Veg Gravy",
                              "imageId": "1cf2d0c134fe2f29644a9e0b25d0fde4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211346",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Dal Thadaka (Qtr)",
                                        "default": 1,
                                        "id": "108992759",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Dal Thadaka (Half)",
                                        "price": 51,
                                        "id": "108992760",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211346",
                                        "variationId": "108992759"
                                      }
                                    ],
                                    "price": 7700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269403",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269405",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211346",
                                        "variationId": "108992760"
                                      }
                                    ],
                                    "price": 12800,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269406",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269404",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269403",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Dal Thadaka (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269404",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Dal Thadaka (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269405",
                                  "groupName": "Choose From Soft Drink for Dal Thadaka (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269406",
                                  "groupName": "Choose From Soft Drink for Dal Thadaka (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296911",
                              "name": "Dal Fry",
                              "category": "Veg Gravy",
                              "description": "Dal Fry Veg Gravy",
                              "imageId": "154ea12ea9c2442e76a2f1f185d419af",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211395",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Dal Fry (Qtr)",
                                        "default": 1,
                                        "id": "108992847",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Dal Fry (Half)",
                                        "price": 51,
                                        "id": "108992848",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211395",
                                        "variationId": "108992847"
                                      }
                                    ],
                                    "price": 7100,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269271",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269269",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211395",
                                        "variationId": "108992848"
                                      }
                                    ],
                                    "price": 12200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269272",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269270",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269269",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Dal Fry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269270",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Dal Fry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269271",
                                  "groupName": "Choose From Soft Drink for Dal Fry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269272",
                                  "groupName": "Choose From Soft Drink for Dal Fry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "628 ratings",
                                  "ratingCountV2": "628"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297512",
                              "name": "Kadai Paneer",
                              "category": "Veg Gravy",
                              "description": "Kadai Paneer Veg Gravy",
                              "imageId": "aaf1f1582b650830fd30420eceb09f0b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211396",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Kadai Paneer (Qtr)",
                                        "default": 1,
                                        "id": "108992849",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kadai Paneer (Half)",
                                        "price": 107,
                                        "id": "108992850",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211396",
                                        "variationId": "108992849"
                                      }
                                    ],
                                    "price": 13300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269347",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269349",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211396",
                                        "variationId": "108992850"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269348",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269350",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269347",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Kadai Paneer (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269348",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Kadai Paneer (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269349",
                                  "groupName": "Choose From Soft Drink for Kadai Paneer (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269350",
                                  "groupName": "Choose From Soft Drink for Kadai Paneer (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "110 ratings",
                                  "ratingCountV2": "110"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297472",
                              "name": "Paneer Tikka Masala",
                              "category": "Veg Gravy",
                              "description": "Paneer Tikka Masala Veg Gravy",
                              "imageId": "c52d0515bce7dfae30c6291d3429ef1d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211397",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Paneer Tikka Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992851",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Paneer Tikka Masala (Half)",
                                        "price": 107,
                                        "id": "108992852",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211397",
                                        "variationId": "108992851"
                                      }
                                    ],
                                    "price": 13300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269370",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269368",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211397",
                                        "variationId": "108992852"
                                      }
                                    ],
                                    "price": 24000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269369",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269371",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269368",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Tikka Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269369",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Tikka Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269370",
                                  "groupName": "Choose From Soft Drink for Paneer Tikka Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269371",
                                  "groupName": "Choose From Soft Drink for Paneer Tikka Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "133 ratings",
                                  "ratingCountV2": "133"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297471",
                              "name": "Paneer Butter Masala",
                              "category": "Veg Gravy",
                              "description": "Paneer Butter Masala Veg Gravy",
                              "imageId": "9e08e9eda22c6c329fd2e8940f284479",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211348",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Paneer Butter Masala (Qtr)",
                                        "default": 1,
                                        "id": "108992764",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Paneer Butter Masala (Half)",
                                        "price": 77,
                                        "id": "108992765",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211348",
                                        "variationId": "108992764"
                                      }
                                    ],
                                    "price": 11200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269293",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269291",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211348",
                                        "variationId": "108992765"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269292",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269294",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269291",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Butter Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269292",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Butter Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269293",
                                  "groupName": "Choose From Soft Drink for Paneer Butter Masala (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269294",
                                  "groupName": "Choose From Soft Drink for Paneer Butter Masala (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "827 ratings",
                                  "ratingCountV2": "827"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Veg Dry",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296714",
                              "name": "Gobi Manchurian",
                              "category": "Veg Dry",
                              "description": "Gobi Manchurian Veg Dry",
                              "imageId": "5df0fa2cee7b91cb19b25800aa57d0c9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211343",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Gobi Manchurian (Qtr)",
                                        "default": 1,
                                        "id": "108992752",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Gobi Manchurian (Half)",
                                        "price": 76,
                                        "id": "108992753",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211343",
                                        "variationId": "108992752"
                                      }
                                    ],
                                    "price": 9700,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269282",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269284",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211343",
                                        "variationId": "108992753"
                                      }
                                    ],
                                    "price": 17300,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269285",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269283",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269282",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Gobi Manchurian (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269283",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Gobi Manchurian (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269284",
                                  "groupName": "Choose From Soft Drink for Gobi Manchurian (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269285",
                                  "groupName": "Choose From Soft Drink for Gobi Manchurian (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "384 ratings",
                                  "ratingCountV2": "384"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296804",
                              "name": "Paneer Chilly Dry",
                              "category": "Veg Dry",
                              "description": "Paneer Chilly Dry Veg Dry",
                              "imageId": "7b26f14db483653310b75cc1f8436e1a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211344",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Paneer Chilly Dry (Qtr)",
                                        "default": 1,
                                        "id": "108992754",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Paneer Chilly Dry (Half)",
                                        "price": 77,
                                        "id": "108992755",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211344",
                                        "variationId": "108992754"
                                      }
                                    ],
                                    "price": 10200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269353",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269351",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211344",
                                        "variationId": "108992755"
                                      }
                                    ],
                                    "price": 17900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269352",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269354",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269351",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Chilly Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269352",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Chilly Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269353",
                                  "groupName": "Choose From Soft Drink for Paneer Chilly Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269354",
                                  "groupName": "Choose From Soft Drink for Paneer Chilly Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297579",
                              "name": "Paneer Tikka Dry",
                              "category": "Veg Dry",
                              "description": "Paneer Tikka Dry Veg Dry",
                              "imageId": "f297ea8bd14a74fce581005fb673662f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211345",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Paneer Tikka Dry (Qtr)",
                                        "default": 1,
                                        "id": "108992756",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Paneer Tikka Dry (Half)",
                                        "price": 92,
                                        "id": "108992757",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Paneer Tikka Dry (Full)",
                                        "price": 248,
                                        "id": "108992758",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211345",
                                        "variationId": "108992756"
                                      }
                                    ],
                                    "price": 11200,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269423",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269420",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211345",
                                        "variationId": "108992757"
                                      }
                                    ],
                                    "price": 20400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269421",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269424",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211345",
                                        "variationId": "108992758"
                                      }
                                    ],
                                    "price": 36000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269425",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269422",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269420",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Tikka Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269421",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Tikka Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269422",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Paneer Tikka Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269423",
                                  "groupName": "Choose From Soft Drink for Paneer Tikka Dry (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269424",
                                  "groupName": "Choose From Soft Drink for Paneer Tikka Dry (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269425",
                                  "groupName": "Choose From Soft Drink for Paneer Tikka Dry (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 11200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "91 ratings",
                                  "ratingCountV2": "91"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Empire Special Tawa Dishes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475815",
                              "name": "Hot Chilly Prawns",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Prawns cooked to perfection on the tawa served with a hot chilly sauce.",
                              "imageId": "363b51942905617f9cc4d5156c89ce71",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128883996",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Hot Chilly Prawns",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758974",
                                  "groupName": "Choose From Soft Drink for Hot Chilly Prawns",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296769",
                              "name": "Fiery Basa Fish Fillet",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Fillet slice of basa fish served with a spicy dip.",
                              "imageId": "8b1fbf619635b2595a0f5595dee0b90d",
                              "inStock": 1,
                              "price": 42500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128664637",
                                  "groupName": "Choose From Extras for Fiery Basa Fish Fillet",
                                  "choices": [
                                    {
                                      "id": "109655006",
                                      "name": "Grill Chutney",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655004",
                                      "name": "Mayonnaise 40 ML",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109654999",
                                      "name": "Mint Chutney 40 ML",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883992",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Fiery Basa Fish Fillet",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128664638",
                                  "groupName": "Choose From Soft Drink for Fiery Basa Fish Fillet",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 42500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475814",
                              "name": "Hot Chilly Seer Fish Tawa Fry",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Hot Chilly Seer Fish Tawa Fry Empire Special Tawa Dishes",
                              "imageId": "d76af01af54b2ec87f5eb9029b5c40b7",
                              "inStock": 1,
                              "price": 22500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211425",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Hot Chilly Seer Fish Tawa Fry (Big)",
                                        "price": 275,
                                        "default": 1,
                                        "id": "108992907",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Hot Chilly Seer Fish Tawa Fry (Small)",
                                        "id": "108992908",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211425",
                                        "variationId": "108992907"
                                      }
                                    ],
                                    "price": 50000
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211425",
                                        "variationId": "108992908"
                                      }
                                    ],
                                    "price": 22500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 50000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297647",
                              "name": "Fiery Chicken Wings",
                              "category": "Empire Special Tawa Dishes",
                              "description": "Spicy tawa fried wings of chicken",
                              "imageId": "0f5d4a8c8e49ab9c469899d0580de0e2",
                              "inStock": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211424",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Fiery Chicken Wings (Qtr)",
                                        "default": 1,
                                        "id": "108992904",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Fiery Chicken Wings (Half)",
                                        "price": 125,
                                        "id": "108992905",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Fiery Chicken Wings (Full)",
                                        "price": 355,
                                        "id": "108992906",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211424",
                                        "variationId": "108992904"
                                      }
                                    ],
                                    "price": 14500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269328",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269325",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211424",
                                        "variationId": "108992905"
                                      }
                                    ],
                                    "price": 27000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269329",
                                        "addonId": "109840276"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269326",
                                        "addonId": "109840288"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211424",
                                        "variationId": "108992906"
                                      }
                                    ],
                                    "price": 50000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840280"
                                      },
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840273"
                                      },
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840274"
                                      },
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840271"
                                      },
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840282"
                                      },
                                      {
                                        "groupId": "129269327",
                                        "addonId": "109840288"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109655018"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109793585"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109840275"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109840287"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109840285"
                                      },
                                      {
                                        "groupId": "129269330",
                                        "addonId": "109840276"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129269325",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Fiery Chicken Wings (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269326",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Fiery Chicken Wings (Half)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269327",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Fiery Chicken Wings (Full)",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269328",
                                  "groupName": "Choose From Soft Drink for Fiery Chicken Wings (Qtr)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269329",
                                  "groupName": "Choose From Soft Drink for Fiery Chicken Wings (Half)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129269330",
                                  "groupName": "Choose From Soft Drink for Fiery Chicken Wings (Full)",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "102 ratings",
                                  "ratingCountV2": "102"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fried Rice",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297030",
                              "name": "Chicken Fried Rice",
                              "category": "Fried Rice",
                              "description": "Indo chinese rice with chicken",
                              "imageId": "0d4b003b0a2c0ff4cefb6aa20fe08e42",
                              "inStock": 1,
                              "price": 21400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128883999",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758979",
                                  "groupName": "Choose From Soft Drink for Chicken Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "316 ratings",
                                  "ratingCountV2": "316"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297163",
                              "name": "Veg Fried Rice",
                              "category": "Fried Rice",
                              "description": "Indo chinese rice with cabbage,beans and carrot",
                              "imageId": "b0da206ae5bb7b68ae9aa48777426d4b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128883990",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Veg Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758981",
                                  "groupName": "Choose From Soft Drink for Veg Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "129 ratings",
                                  "ratingCountV2": "129"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297329",
                              "name": "Egg Fried Rice",
                              "category": "Fried Rice",
                              "description": "Indo chinese rice with egg",
                              "imageId": "ec3b24fbac0ed0ee6bb5d3a791bab1e9",
                              "inStock": 1,
                              "price": 19400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128884003",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Egg Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758980",
                                  "groupName": "Choose From Soft Drink for Egg Fried Rice",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19400,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "159 ratings",
                                  "ratingCountV2": "159"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Parottas",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296917",
                              "name": "Coin Parotta",
                              "category": "Parottas",
                              "description": "Empire's Classic Mini porotas ,Highly recommended",
                              "imageId": "3ee19ed5001ad0edb65fc13e0f75fc21",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269418",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Coin Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860987",
                                  "groupName": "Choose From Soft Drink for Coin Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758903",
                                  "groupName": "Choose From EM Complimentary for Coin Parotta",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1051 ratings",
                                  "ratingCountV2": "1051"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296812",
                              "name": "Malabar Parotta",
                              "category": "Parottas",
                              "imageId": "ee5a7eca4966aa54c61cdd130f3e82ab",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269290",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Malabar Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860988",
                                  "groupName": "Choose From Soft Drink for Malabar Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758911",
                                  "groupName": "Choose From EM Complimentary for Malabar Parotta",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "984 ratings",
                                  "ratingCountV2": "984"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297572",
                              "name": "Empire Mix Parotta",
                              "category": "Parottas",
                              "description": "Strips of the Porota cooked with Egg,Mutton,Chiken and Vegetables",
                              "imageId": "7db1097cb04868fb5baf89789cb50fd5",
                              "inStock": 1,
                              "price": 19000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269401",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Empire Mix Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860729",
                                  "groupName": "Choose From Soft Drink for Empire Mix Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296666",
                              "name": "Kerala Parotta",
                              "category": "Parottas",
                              "description": "Fluffy Kerala speciality bread",
                              "imageId": "d8c4fee342c1f25ba8a6eaae25ee0c09",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269295",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Kerala Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860994",
                                  "groupName": "Choose From Soft Drink for Kerala Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758910",
                                  "groupName": "Choose From EM Complimentary for Kerala Parotta",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "1038 ratings",
                                  "ratingCountV2": "1038"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297577",
                              "name": "Empire Special Porota",
                              "category": "Parottas",
                              "description": "Porota",
                              "imageId": "e15a86ac4e8e74993464aeed6b88cb7d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758908",
                                  "groupName": "Choose From EM Complimentary for Empire Special Porota",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 5000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "165 ratings",
                                  "ratingCountV2": "165"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296929",
                              "name": "Dry Chapati",
                              "category": "Parottas",
                              "description": "Whole wheat flat bread",
                              "imageId": "c04236075dac2a36cbe2d251222ba223",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758905",
                                  "groupName": "Choose From EM Complimentary for Dry Chapati",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3000,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "324 ratings",
                                  "ratingCountV2": "324"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296826",
                              "name": "Egg Parotta",
                              "category": "Parottas",
                              "description": "Egg Layered with traditional Porota",
                              "imageId": "6e1237635f100282368418bb934626cd",
                              "inStock": 1,
                              "price": 9100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269306",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Egg Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860731",
                                  "groupName": "Choose From Soft Drink for Egg Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 9100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296659",
                              "name": "Wheat Parotta",
                              "category": "Parottas",
                              "description": "Tawa Porota made from wheat",
                              "imageId": "ba674cca4da1b2060327b278aa4188bc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269289",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Wheat Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860992",
                                  "groupName": "Choose From Soft Drink for Wheat Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758780",
                                  "groupName": "Choose From EM Complimentary for Wheat Parotta",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "475 ratings",
                                  "ratingCountV2": "475"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296857",
                              "name": "Ghee Chapati",
                              "category": "Parottas",
                              "description": "Wheat flat bred with ghee",
                              "imageId": "da3661ce736df1c11f17e3c88e93d32e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758749",
                                  "groupName": "Choose From EM Complimentary for Ghee Chapati",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3300,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "147 ratings",
                                  "ratingCountV2": "147"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297391",
                              "name": "Ceylon Parotta",
                              "category": "Parottas",
                              "description": "Flaky and soft porrota",
                              "imageId": "73a71339912b8f694a1ffae0ea9c14b1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269279",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Ceylon Parotta",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128860989",
                                  "groupName": "Choose From Soft Drink for Ceylon Parotta",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758901",
                                  "groupName": "Choose From EM Complimentary for Ceylon Parotta",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "738 ratings",
                                  "ratingCountV2": "738"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Rotis",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297594",
                              "name": "Butter Kulcha",
                              "category": "Rotis",
                              "description": "North Indian bread with butter",
                              "imageId": "eea4ba872bc950d622a4a91776297216",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269338",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Kulcha",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758912",
                                  "groupName": "Choose From Soft Drink for Butter Kulcha",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758913",
                                  "groupName": "Choose From EM Complimentary for Butter Kulcha",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "116 ratings",
                                  "ratingCountV2": "116"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296810",
                              "name": "Tandoori Roti",
                              "category": "Rotis",
                              "description": "Smoky charcoal cooked whole wheat bread.Made in clay pot",
                              "imageId": "5447af2d6b952ade8171adae3b7dc4c9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269310",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Tandoori Roti",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758918",
                                  "groupName": "Choose From Soft Drink for Tandoori Roti",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758919",
                                  "groupName": "Choose From EM Complimentary for Tandoori Roti",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "300 ratings",
                                  "ratingCountV2": "300"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296937",
                              "name": "Butter Naan",
                              "category": "Rotis",
                              "description": "Butter smeared on bread",
                              "imageId": "f667f72536e98a0614ddafe1e3929d76",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269376",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Naan",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758916",
                                  "groupName": "Choose From Soft Drink for Butter Naan",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758917",
                                  "groupName": "Choose From EM Complimentary for Butter Naan",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 4500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "461 ratings",
                                  "ratingCountV2": "461"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296934",
                              "name": "Kulcha",
                              "category": "Rotis",
                              "description": "North Indian bread",
                              "imageId": "37d74d7b74fad02b1b47786a33141cff",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269297",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Kulcha",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758791",
                                  "groupName": "Choose From Soft Drink for Kulcha",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758792",
                                  "groupName": "Choose From EM Complimentary for Kulcha",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "367 ratings",
                                  "ratingCountV2": "367"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296710",
                              "name": "Tandoori Naan",
                              "category": "Rotis",
                              "description": "Smoky charcoal cooked bread.Made in clay pot",
                              "imageId": "7b79f8b5c8267a18577c9a08b1ddc1b6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269309",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Tandoori Naan",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758797",
                                  "groupName": "Choose From Soft Drink for Tandoori Naan",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758798",
                                  "groupName": "Choose From EM Complimentary for Tandoori Naan",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "187 ratings",
                                  "ratingCountV2": "187"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296835",
                              "name": "Romali Roti",
                              "category": "Rotis",
                              "description": "Thin \"\"handkerchief\"\" roti. Highest selling on our menu",
                              "imageId": "c48718b2c80a957a46990ba84d2ed870",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269281",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Romali Roti",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758788",
                                  "groupName": "Choose From Soft Drink for Romali Roti",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758789",
                                  "groupName": "Choose From EM Complimentary for Romali Roti",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "559 ratings",
                                  "ratingCountV2": "559"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296642",
                              "name": "Butter Roti",
                              "category": "Rotis",
                              "description": "Butter smeared on wheat flat bread",
                              "imageId": "8dcc882c3ef806ed543571ea10fd58cd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269337",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Butter Roti",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758914",
                                  "groupName": "Choose From Soft Drink for Butter Roti",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758915",
                                  "groupName": "Choose From EM Complimentary for Butter Roti",
                                  "choices": [
                                    {
                                      "id": "108009080",
                                      "name": "Complementary Dal",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108009081",
                                      "name": "Complementary Red Gravy",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 3600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Egglicious",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296640",
                              "name": "Egg Burji",
                              "category": "Egglicious",
                              "description": "Eggs beaten into a mix of fried onions and spices and well cooked",
                              "imageId": "e4e204d21f4b18b286063f18f873ba23",
                              "inStock": 1,
                              "price": 8200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297316",
                              "name": "Boiled Egg (2 Nos)",
                              "category": "Egglicious",
                              "imageId": "266e0b2ea35373d2e0c69c8e4732638e",
                              "inStock": 1,
                              "price": 4100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Shawarma",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24690504",
                              "name": "Chicken Shawarma",
                              "category": "Shawarma",
                              "description": "Arabic favorite , Pita rolled with lots of chicken,some veggies and mayonnaise.",
                              "imageId": "6bc534a97a01721b4151af2a7535b972",
                              "inStock": 1,
                              "price": 9000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128664814",
                                  "groupName": "Choose From Extras for Chicken Shawarma",
                                  "choices": [
                                    {
                                      "id": "109655004",
                                      "name": "Mayonnaise 40 ML",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883994",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Chicken Shawarma",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758806",
                                  "groupName": "Choose From Soft Drink for Chicken Shawarma",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 9000,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1831 ratings",
                                  "ratingCountV2": "1831"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297614",
                              "name": "Tawa Shawarma",
                              "category": "Shawarma",
                              "imageId": "d69e799b0e0d77a9635d910df94e08de",
                              "inStock": 1,
                              "price": 16200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129269319",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Tawa Shawarma",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128741239",
                                  "groupName": "Choose From Soft Drink for Tawa Shawarma",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 16200,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "667 ratings",
                                  "ratingCountV2": "667"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soup",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296866",
                              "name": "Lemon Coriander Chicken Soup",
                              "category": "Soup",
                              "description": "This Soup flavored with fresh lemon and herbs in chicken",
                              "inStock": 1,
                              "price": 9100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Salads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296833",
                              "name": "Green Salad",
                              "category": "Salads",
                              "description": "Simple collection of salad vegetables in slices",
                              "imageId": "81322d54e2819a3a4385ca12fb906370",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296657",
                              "name": "Masala Papad Salad",
                              "category": "Salads",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83973967",
                              "name": "Tender Coconut Pudding",
                              "category": "Desserts",
                              "description": "A refreshing delight with delicate flavors made from tender coconut, all set to melt in your mouth.(100gms)",
                              "imageId": "82c1125db4d23db78bef335efdf20d8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "748 ratings",
                                  "ratingCountV2": "748"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dessert",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297365",
                              "name": "Arabian Dry Fruit Sundae",
                              "category": "Dessert",
                              "imageId": "24d19b5bc6739a34c9f51ad555cef3ff",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125780400",
                              "name": "Falooda Fruit Bowl",
                              "category": "Dessert",
                              "imageId": "270a7dbf556a65b22d67265ae0cb68d5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475823",
                              "name": "Gud Bud",
                              "category": "Dessert",
                              "imageId": "8fd3088d2a6b814c2b31793cf4679795",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475824",
                              "name": "Fruit Salad W Ice Cream",
                              "category": "Dessert",
                              "description": "Delicious sweet salad with Ice Cream",
                              "imageId": "bfd98d73b722d9a9c2c9ce2e64505c5d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extras",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296874",
                              "name": "Pappad",
                              "category": "Extras",
                              "imageId": "2afd2805179e0f2490b713ca1a0d2341",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475666",
                              "name": "Raitha",
                              "category": "Extras",
                              "imageId": "a4fa521b8405c2f6b8dc468a4cfbaa8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475669",
                              "name": "Curd",
                              "category": "Extras",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475667",
                              "name": "Kuboos",
                              "category": "Extras",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130350489",
                              "name": "Gift Shop",
                              "category": "Extras",
                              "description": "Gift Shop Staff",
                              "inStock": 1,
                              "price": 10476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chocolate Fest",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104035809",
                              "name": "Hot Chocolate Fudge",
                              "category": "Chocolate Fest",
                              "imageId": "e0a102a98dc84f9a877c8623ea60f464",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25442581",
                              "name": "Death By Chocolate",
                              "category": "Chocolate Fest",
                              "imageId": "f6bf0310072794a0c30767e0ab2184d4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129504087",
                              "name": "Chocolate Fruit Bowl",
                              "category": "Chocolate Fest",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fresh Fruit Juices & Coolers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475842",
                              "name": "Pulpy Grapee Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211445",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pulpy Grape Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992941",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pulpy Grape Juice (1 Ltr)",
                                        "price": 198,
                                        "id": "108992942",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211445",
                                        "variationId": "108992941"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211445",
                                        "variationId": "108992942"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475843",
                              "name": "Mojito Mint Coolers",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211446",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mojito Mint (300 Ml)",
                                        "default": 1,
                                        "id": "108992943",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mojito Mint (1 Ltr)",
                                        "price": 198,
                                        "id": "108992944",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211446",
                                        "variationId": "108992943"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211446",
                                        "variationId": "108992944"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86519231",
                              "name": "Blueberry Mojito",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "87dec18f82bbbbe8c978678235f3acef",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211448",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Blueberry Mojito (300 Ml)",
                                        "default": 1,
                                        "id": "108992947",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Blueberry Mojito (1 Ltr)",
                                        "price": 209,
                                        "id": "108992948",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211448",
                                        "variationId": "108992947"
                                      }
                                    ],
                                    "price": 10500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211448",
                                        "variationId": "108992948"
                                      }
                                    ],
                                    "price": 31400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86519234",
                              "name": "Green Apple Mojito",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "4a608d911ca7fbf5a0c7b6cb4f4441f9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211447",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Green Apple Mojito (300 Ml)",
                                        "default": 1,
                                        "id": "108992945",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Green Apple Mojito (1 Ltr)",
                                        "price": 198,
                                        "id": "108992946",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211447",
                                        "variationId": "108992945"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211447",
                                        "variationId": "108992946"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86519173",
                              "name": "Rich Anar Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "0689fbdb67aba93a2f213a2c189e9f6b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211450",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Rich Anar Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992951",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Rich Anar Juice (1 Ltr)",
                                        "price": 275,
                                        "id": "108992952",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211450",
                                        "variationId": "108992951"
                                      }
                                    ],
                                    "price": 13800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211450",
                                        "variationId": "108992952"
                                      }
                                    ],
                                    "price": 41300
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296634",
                              "name": "Lime Mint Cooler",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "8143df2ac2142f8e6d472adaa5ac98ca",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211449",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Lime Mint Cooler (300 Ml)",
                                        "default": 1,
                                        "id": "108992949",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lime Mint Cooler (1 Ltr)",
                                        "price": 143,
                                        "id": "108992950",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211449",
                                        "variationId": "108992949"
                                      }
                                    ],
                                    "price": 7200
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211449",
                                        "variationId": "108992950"
                                      }
                                    ],
                                    "price": 21500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475837",
                              "name": "Lassi (Salt) (1 Ltr)",
                              "category": "Fresh Fruit Juices & Coolers",
                              "imageId": "4fdc3c3e61c842f5d51118d476f6533f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475839",
                              "name": "Lassi (Salt) (300 Ml)",
                              "category": "Fresh Fruit Juices & Coolers",
                              "imageId": "4fdc3c3e61c842f5d51118d476f6533f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297256",
                              "name": "Lime Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "f5f81d333dd05b76fddde3f6085f7cc9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211435",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Lime Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992921",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lime Juice (1 Ltr)",
                                        "price": 110,
                                        "id": "108992922",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211435",
                                        "variationId": "108992921"
                                      }
                                    ],
                                    "price": 5500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211435",
                                        "variationId": "108992922"
                                      }
                                    ],
                                    "price": 16500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 5500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936279",
                              "name": "Pineapple Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "d7eb8a216ecda0f37fdb17167127ec8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211440",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Pineapple Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992931",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pineapple Juice (1 Ltr)",
                                        "price": 154,
                                        "id": "108992932",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211440",
                                        "variationId": "108992931"
                                      }
                                    ],
                                    "price": 7700
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211440",
                                        "variationId": "108992932"
                                      }
                                    ],
                                    "price": 23100
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475836",
                              "name": "Lime Soda Coolers",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211436",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Lime Soda (300Ml)",
                                        "default": 1,
                                        "id": "108992923",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lime Soda (1 Ltr)",
                                        "price": 132,
                                        "id": "108992924",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211436",
                                        "variationId": "108992923"
                                      }
                                    ],
                                    "price": 6600
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211436",
                                        "variationId": "108992924"
                                      }
                                    ],
                                    "price": 19800
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 6600,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475838",
                              "name": "Lassi (Sweet / Salt)",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "4fdc3c3e61c842f5d51118d476f6533f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211438",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Lassi (Sweet) (300 Ml)",
                                        "default": 1,
                                        "id": "108992927",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lassi (Sweet) (1 Ltr)",
                                        "price": 154,
                                        "id": "108992928",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211438",
                                        "variationId": "108992927"
                                      }
                                    ],
                                    "price": 7700
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211438",
                                        "variationId": "108992928"
                                      }
                                    ],
                                    "price": 23100
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475840",
                              "name": "Water Melon Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "9045f2dcfd56552a490e563448be3031",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211441",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Water Melon Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992933",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Water Melon Juice (1 Ltr)",
                                        "price": 154,
                                        "id": "108992934",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211441",
                                        "variationId": "108992933"
                                      }
                                    ],
                                    "price": 7700
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211441",
                                        "variationId": "108992934"
                                      }
                                    ],
                                    "price": 23100
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25442608",
                              "name": "Blue Angel",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "603587428410381d1491dcc279926961",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211434",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Blue Angel (300 Ml)",
                                        "default": 1,
                                        "id": "108992919",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Blue Angel (1 Ltr)",
                                        "price": 198,
                                        "id": "108992920",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211434",
                                        "variationId": "108992919"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211434",
                                        "variationId": "108992920"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936259",
                              "name": "Ginger Lime Soda",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "761e8d83ca113bf5befe02da8fefe03c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211437",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Ginger Lime Soda (300 Ml)",
                                        "default": 1,
                                        "id": "108992925",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Ginger Lime Soda (1 Ltr)",
                                        "price": 143,
                                        "id": "108992926",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211437",
                                        "variationId": "108992925"
                                      }
                                    ],
                                    "price": 7200
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211437",
                                        "variationId": "108992926"
                                      }
                                    ],
                                    "price": 21500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7200,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "92429845",
                              "name": "Mango Punch Cooler",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "44fa3b8349cdc2e27976e7e3821c6ea0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211439",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mango Punch Cooler (300 Ml)",
                                        "default": 1,
                                        "id": "108992929",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mango Punch Cooler (1 Ltr)",
                                        "price": 154,
                                        "id": "108992930",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211439",
                                        "variationId": "108992929"
                                      }
                                    ],
                                    "price": 7700
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211439",
                                        "variationId": "108992930"
                                      }
                                    ],
                                    "price": 23100
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 7700,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936278",
                              "name": "Mosambi Juice",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "f2fef832df36f7b011526a6916d9a3ff",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211443",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mosambi Juice (300 Ml)",
                                        "default": 1,
                                        "id": "108992937",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mosambi Juice (1 Ltr)",
                                        "price": 176,
                                        "id": "108992938",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211443",
                                        "variationId": "108992937"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211443",
                                        "variationId": "108992938"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296596",
                              "name": "Blue Lime Soda",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "d580da353b40524dec0a0d3ca8fe96ee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211442",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Blue Lime Soda (300 Ml)",
                                        "default": 1,
                                        "id": "108992935",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Blue Lime Soda (1 Ltr)",
                                        "price": 176,
                                        "id": "108992936",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211442",
                                        "variationId": "108992935"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211442",
                                        "variationId": "108992936"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475841",
                              "name": "Orange Juice (Seasonal)",
                              "category": "Fresh Fruit Juices & Coolers",
                              "description": "Fresh Juices direct from Juice Shop",
                              "imageId": "2cd2a267e3dfb7d698af8ad698f6df75",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211444",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Orange Juice (Seasonal) (300 Ml)",
                                        "default": 1,
                                        "id": "108992939",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Orange Juice (Seasonal) (1 Ltr)",
                                        "price": 198,
                                        "id": "108992940",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211444",
                                        "variationId": "108992939"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211444",
                                        "variationId": "108992940"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Thickshakes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475845",
                              "name": "Apple",
                              "category": "Thickshakes",
                              "description": "Delicious Apple Thickshakes",
                              "imageId": "06bd6b1f8255ed961e23b8b0dd7d522a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211451",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Apple Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992953",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Apple Thick Shake (1 Ltr)",
                                        "price": 198,
                                        "id": "108992954",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211451",
                                        "variationId": "108992953"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211451",
                                        "variationId": "108992954"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475847",
                              "name": "Chocolate Thikshake",
                              "category": "Thickshakes",
                              "description": "Delicious Chocolate Thikshake Thickshakes",
                              "imageId": "f40fe7a1268b02587fcd17251da55904",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211454",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chocolate Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992959",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chocolate Thick Shake (1 Ltr)",
                                        "price": 176,
                                        "id": "108992960",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211454",
                                        "variationId": "108992959"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211454",
                                        "variationId": "108992960"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47296653",
                              "name": "Cold Coffee",
                              "category": "Thickshakes",
                              "description": "Delicious Cold Coffee Thickshakes",
                              "imageId": "1d601bda2896e9b5d69a0fc281beef6b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211456",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Cold Coffee (300 Ml)",
                                        "default": 1,
                                        "id": "108992963",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Cold Coffee (1 Ltr)",
                                        "price": 242,
                                        "id": "108992964",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211456",
                                        "variationId": "108992963"
                                      }
                                    ],
                                    "price": 12100
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211456",
                                        "variationId": "108992964"
                                      }
                                    ],
                                    "price": 36300
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 12100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475850",
                              "name": "Oreo",
                              "category": "Thickshakes",
                              "description": "Delicious Oreo Thickshakes",
                              "imageId": "e7c15eb7172ef8ec76883cc143039196",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211459",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Oreo Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992969",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Oreo Thick Shake (1 Ltr)",
                                        "price": 275,
                                        "id": "108992970",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211459",
                                        "variationId": "108992969"
                                      }
                                    ],
                                    "price": 13800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211459",
                                        "variationId": "108992970"
                                      }
                                    ],
                                    "price": 41300
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936238",
                              "name": "Arabian Dry Fruit",
                              "category": "Thickshakes",
                              "description": "Delicious Arabian Dry Fruit Thickshakes",
                              "imageId": "a22fb23824bcfd028dca895c9f6cc20e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211452",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Arabian Dry Fruit (300 Ml)",
                                        "default": 1,
                                        "id": "108992955",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Arabian Dry Fruit (1 Ltr)",
                                        "price": 330,
                                        "id": "108992956",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211452",
                                        "variationId": "108992955"
                                      }
                                    ],
                                    "price": 16500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211452",
                                        "variationId": "108992956"
                                      }
                                    ],
                                    "price": 49500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475848",
                              "name": "Fig (Anjeer)",
                              "category": "Thickshakes",
                              "description": "Delicious Fig (Anjeer) Thickshakes",
                              "imageId": "f95fb0faa9107722f6208eb31ae82418",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211457",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Fig (Anjeer) Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992965",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Fig (Anjeer) Thick Shake (1 Ltr)",
                                        "price": 198,
                                        "id": "108992966",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211457",
                                        "variationId": "108992965"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211457",
                                        "variationId": "108992966"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "47297609",
                              "name": "Chocolate Splash",
                              "category": "Thickshakes",
                              "description": "Delicious Chocolate Splash Thickshakes",
                              "imageId": "718e70d4eabad5574c7c3ab3708bba3b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12100,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211455",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chocolate Splash (300 Ml)",
                                        "default": 1,
                                        "id": "108992961",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chocolate Splash (1 Ltr)",
                                        "price": 242,
                                        "id": "108992962",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211455",
                                        "variationId": "108992961"
                                      }
                                    ],
                                    "price": 12100
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211455",
                                        "variationId": "108992962"
                                      }
                                    ],
                                    "price": 36300
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 12100,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475849",
                              "name": "Mango Thikshake",
                              "category": "Thickshakes",
                              "description": "Delicious Mango Thikshake Thickshakes",
                              "imageId": "f848dfa98d27c494770f9eb37e49b337",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211458",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Mango Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992967",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Mango Thick Shake (1 Ltr)",
                                        "price": 176,
                                        "id": "108992968",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211458",
                                        "variationId": "108992967"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211458",
                                        "variationId": "108992968"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475852",
                              "name": "Strawberry Thikshakes",
                              "category": "Thickshakes",
                              "description": "Delicious Strawberry Thikshakes Thickshakes",
                              "imageId": "60c46adc9699c370cc4e44b0286df445",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211464",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Strawberry Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992979",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Strawberry Thick Shake (1 Ltr)",
                                        "price": 176,
                                        "id": "108992980",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211464",
                                        "variationId": "108992979"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211464",
                                        "variationId": "108992980"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475851",
                              "name": "Sharjah",
                              "category": "Thickshakes",
                              "description": "Delicious Sharjah Thickshakes",
                              "imageId": "cf4d20526757e29488c8b85d93a771ee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211460",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Sharjah Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992971",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Sharjah Thick Shake (1 Ltr)",
                                        "price": 198,
                                        "id": "108992972",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211460",
                                        "variationId": "108992971"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211460",
                                        "variationId": "108992972"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475853",
                              "name": "Vanilla Thikshakes",
                              "category": "Thickshakes",
                              "description": "Delicious Vanilla Thikshakes Thickshakes",
                              "imageId": "d57e836f5bba765f73fb81b77b1af07b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211465",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Vanilla Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992981",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Vanilla Thick Shake (1 Ltr)",
                                        "price": 176,
                                        "id": "108992982",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211465",
                                        "variationId": "108992981"
                                      }
                                    ],
                                    "price": 8800
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211465",
                                        "variationId": "108992982"
                                      }
                                    ],
                                    "price": 26400
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 8800,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475846",
                              "name": "Chickoo",
                              "category": "Thickshakes",
                              "description": "Delicious Chickoo Thickshakes",
                              "imageId": "675795f3faeefe548b7abe46a7005d99",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35211453",
                                    "name": "Choose From Variant",
                                    "variations": [
                                      {
                                        "name": "Chickoo Thick Shake (300 Ml)",
                                        "default": 1,
                                        "id": "108992957",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chickoo Thick Shake (1 Ltr)",
                                        "price": 198,
                                        "id": "108992958",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211453",
                                        "variationId": "108992957"
                                      }
                                    ],
                                    "price": 9900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35211453",
                                        "variationId": "108992958"
                                      }
                                    ],
                                    "price": 29700
                                  }
                                ]
                              },
                              "nextAvailableAtMessage": "Next available at 12:11 pm, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 9900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Ice Creams (Single Scoop)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475830",
                              "name": "Mango Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "e4317ce6027775dd63db0b6df4840b76",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475826",
                              "name": "Butterscotch Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "0ee475bbbc12c12b2788471420a7710f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475827",
                              "name": "Black Currant Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "a18eb3e0af07218daf4cfa8b62bbcc93",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475834",
                              "name": "Vanilla Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "73f38bacf20926122a9dcd426a76d828",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475829",
                              "name": "Fig & Honey Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "d311760fcc8e0124d424dbfa016bbbf0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475828",
                              "name": "Chocolate Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "16056c5fbecbe4e5df442c7a8ba55871",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475832",
                              "name": "Strawberry Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "f03f2fd53cc56ea9de1449bbd552e79b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475833",
                              "name": "Pista Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "83d532d2824e7bd483faf17e551a637e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129475831",
                              "name": "Kulfi Ice Creams",
                              "category": "Ice Creams (Single Scoop)",
                              "imageId": "6e4b79d5af4d97e813eab557ac0f7d74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Falooda",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86519215",
                              "name": "Empire Special Falooda",
                              "category": "Falooda",
                              "imageId": "c0785ed443218bf40c5cada9bb687f70",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5936234",
                              "name": "Rabdi Falooda",
                              "category": "Falooda",
                              "imageId": "fbf1bdc3c040cfbec610117db47282a6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25442485",
                              "name": "Kulfi Falooda",
                              "category": "Falooda",
                              "imageId": "45664e635439cda6609a44f88ae39fe1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "25442493",
                              "name": "Bombay Falooda",
                              "category": "Falooda",
                              "imageId": "54b76337a4c7d52bdad395c9e931bc9c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "60 ratings",
                                  "ratingCountV2": "60"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86519221",
                              "name": "Tender Coconut Falooda",
                              "category": "Falooda",
                              "imageId": "9fb23866bae93a5f8fa27e80e054e355",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soft Drink",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130882645",
                              "name": "Kinley Mineral Water 1 L",
                              "category": "Soft Drink",
                              "imageId": "fc5a04d4de68a3bc7f951565f4bf92bd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130980564",
                              "name": "Fanta Can 330ML",
                              "category": "Soft Drink",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130980568",
                              "name": "Sprite Can 330ML",
                              "category": "Soft Drink",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130980565",
                              "name": "Thumsup Can 330ML",
                              "category": "Soft Drink",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128118321",
                              "name": "Coca Cola Can 330 ml",
                              "category": "Soft Drink",
                              "imageId": "1593522fd1a099dabe701fb306bf1a7f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130941533",
                              "name": "Coca Cola 475ML",
                              "category": "Soft Drink",
                              "imageId": "f5fbb8f866d5b679659ffd3844b67250",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Thali",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "24690479",
                              "name": "Non Veg Thali",
                              "category": "Thali",
                              "description": "Chicken Kebab,Chilli Chicken,Butter Chicken Gravy,Mutton Curry With Bone,Dal Fry,Ghee Rice.Coin Parota,Curd,Poriyal,Pickle&Sweet",
                              "imageId": "b491ad34cbdad2d7c7ed112975c66f5e",
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758849",
                                  "groupName": "Choose From Salads for Non Veg Thali",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758848",
                                  "groupName": "Choose From Extras for Non Veg Thali",
                                  "choices": [
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128884002",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Non Veg Thali",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758847",
                                  "groupName": "Choose From Soft Drink for Non Veg Thali",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 29900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69091329",
                              "name": "Veg Thali",
                              "category": "Thali",
                              "description": "Ghee Rice,Coin Parota,Gobi Manchurian Dry,Paneer Chilli Dry,Veg Kuruma,Dal Fry,Paneer Butter MasalaCurd,Pickle,&Sweet",
                              "imageId": "867a59fa1cf28706ea1c4469d6bf8124",
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125758949",
                                  "groupName": "Choose From Salads for Veg Thali",
                                  "choices": [
                                    {
                                      "id": "108009017",
                                      "name": "Green Salad",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758948",
                                  "groupName": "Choose From Extras for Veg Thali",
                                  "choices": [
                                    {
                                      "id": "108009015",
                                      "name": "Pappad",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "128883981",
                                  "groupName": "Choose From Fresh Fruit Juices & Coolers for Veg Thali",
                                  "choices": [
                                    {
                                      "id": "109840274",
                                      "name": "Pulpy Grape Juice (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840273",
                                      "name": "Blue Lime Soda (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840271",
                                      "name": "Mojito Mint (300 Ml)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840282",
                                      "name": "Lime Juice (300 Ml)",
                                      "price": 5500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840280",
                                      "name": "Mosambi Juice (300 Ml)",
                                      "price": 8800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840288",
                                      "name": "Water Melon Juice (300 Ml)",
                                      "price": 7700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125758947",
                                  "groupName": "Choose From Soft Drink for Veg Thali",
                                  "choices": [
                                    {
                                      "id": "109840276",
                                      "name": "Limca Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840287",
                                      "name": "Sprite Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109793585",
                                      "name": "Coca Cola 475ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840275",
                                      "name": "Fanta Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109840285",
                                      "name": "Thumsup Can 330ML",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109655018",
                                      "name": "Coca Cola Can 330 ml",
                                      "price": 6667,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 11 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 22900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "88 ratings",
                                  "ratingCountV2": "88"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11214333001203"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Hotel Empire",
                      "area": "Church Street",
                      "completeAddress": "Empire SuitesNo.35, Castle Street, Off Brigade Road,Bengaluru, Karnataka 560025"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "U8EVoGWejdBO-cEPP4vMq9St_ibY_iVv4IpVvn-E"
},
// 20240105233510
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=65797&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "65797",
              "name": "Leon's - Burgers & Wings (Leon Grill)",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "leon-grill-koramangala-koramangala",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "b2edbc28b7b8219d6e0a9c049ce06658",
              "locality": "Koramangala",
              "areaName": "Koramangala",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "American",
                "Snacks"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "65797",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 7800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 7800,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (6.4 kms) | Additional delivery fee will apply"
              },
              "parentId": "371281",
              "avgRatingString": "4.4",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "65797",
                "deliveryTime": 32,
                "minDeliveryTime": 32,
                "maxDeliveryTime": 32,
                "lastMileTravel": 6.4,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 1,
                "slaString": "32 MINS",
                "lastMileTravelString": "6.4 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 04:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹349",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹349 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "leon-grill-koramangala-koramangala",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Plot No.123 K.H.B Colony, 5th Block , Koramangala , Bangalore -95"
                },
                {
                  "title": "Cuisines",
                  "message": "American,Snacks"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹349",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹349 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 244,
                  "maxValue": 349,
                  "priority": 1,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/65797"
              },
              "expectationNotifiers": [
                {
                  "text": "Far (6.4 kms) | Additional delivery fee will apply",
                  "icon": {
                    "imageId": "v1648208530/surgecreatives/info"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_FOOD_LM",
                  "enrichedText": "<b>Far (6.4 kms)</b> | Additional delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.93468249,77.61615649",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "679f251b-5617-4a62-9c6e-d6a5cb3fa545"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹349",
                      "offerType": "offers",
                      "restId": "65797",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "65797",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "65797",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "65797",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "65797",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Leon Gourmet ( Burgers and Sides )",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656414",
                              "name": "Double Lamb Cheese Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Two smashed lamb patties with house seasoning, double cheese, sliced gherkins, onions, lettuce, tomato and gourmet sauce nestled on a toasted bun",
                              "imageId": "9dcc39adff467230c6981b067b432524",
                              "inStock": 1,
                              "price": 48900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050860",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648848",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648849",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648850",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656459",
                              "name": "Single Lamb Cheese Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | A succulent smashed lamb patty with house seasoning, cheese, sliced gherkins, onions, lettuce, tomato and gourmet sauce on a toasted bun",
                              "imageId": "57a1bdfe8ff2e0c1d2f90bb734d006d0",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051405",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648941",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648942",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648943",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656462",
                              "name": "Tender Hot Chicken Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Leon's juicy hot chicken tenders with cabbage slaw, sliced gherkins, lettuce, and gourmet sauce",
                              "imageId": "ccb74f434ff4dca9f80cd20aa07e20e1",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051414",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648944",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648945",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648946",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656444",
                              "name": "Korean Chicken Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Korean style fried chicken glazed with tantalizing gochujang sauce, topped with toasted sesame seeds that sits over red cabbage slaw with lettuce, cheese and gourmet sauce on a fluffy toasted bun",
                              "imageId": "31a5a5d5939505e7bf0fadf5356362d6",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051174",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648920",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648921",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648922",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656407",
                              "name": "Chilli Cheese Chicken Tikka Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Authentic and delicious chicken tikka breast marinated in house with various spices, lettuce, tomato, onions, sliced gherkins, cheese and gourmet sauce in a toasted bun",
                              "imageId": "fdaf6d9c04401710c7f31498ec9a9986",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050795",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648835",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648837",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648838",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656443",
                              "name": "Korean Cheese Delight Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Korean style fried gooey cheese patty glazed with gochujang sauce, topped with toasted sesame seeds that sits over red cabbage slaw, with lettuce, cheese and gourmet sauce on a toasted bun",
                              "imageId": "1471afc70a7852b3987dc456573dd168",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051171",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648914",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648918",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656448",
                              "name": "Korean Paneer Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Korean style fried paneer patty glazed with gochujang sauce, topped with toasted sesame seeds that sits over red cabbage slaw, with lettuce, cheese and gourmet sauce on a toasted bun",
                              "imageId": "6a0b44d6fbff2a05ae133c479d66f1bf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051202",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648923",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648925",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656450",
                              "name": "Korean Veg Supreme Burger",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Korean style fried veg patty, glazed with gochujang sauce, topped with toasted sesame seeds that sits over red cabbage slaw, with lettuce, cheese and gourmet sauce on a toasted bun",
                              "imageId": "fd5a865c7310527520aead4e08c5cf5c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051210",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648938",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121648940",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656446",
                              "name": "Lamb Loaded fries",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Fries loaded with grilled smash lamb patty, onions, sliced gherkins, cheese and gourmet sauce",
                              "imageId": "8c624d59f69282607ee3004d95a6f555",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656445",
                              "name": "Korean Chicken Loaded fries",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Fries loaded with Korean style fried chicken popcorn, sliced gherkins and gourmet sauce",
                              "imageId": "8974f19b34f4ed4387dbdccb02205956",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656449",
                              "name": "Korean Paneer Loaded fries",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Fries loaded with Korean style paneer, sliced gherkins and gourmet sauce",
                              "imageId": "ca6646c55154048a3aa04a4bab940e65",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125081692",
                              "name": "8pc Onion Rings",
                              "category": "Leon Gourmet ( Burgers and Sides )",
                              "description": "Serves 1 | Cut onion rings battered with a subtle blend of spice and fried until golden and crispy",
                              "imageId": "22443e63a0efba967ff67405ca18f7aa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Leon Burgers and Burger Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102546396",
                              "name": "Peri Peri Paneer Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 27% with this combo of peri-peri paneer burger + 8 Pcs potato pops with fries & 250 Ml Beverage.",
                              "imageId": "6acfb4ac9e821a36bda5082a520e2a58",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34133,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051361",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051363",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051359",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "65 ratings",
                                  "ratingCountV2": "65"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102546395",
                              "name": "Veggie Supreme Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 23% with this combo of Veggie supreme burger+ 8 Pcs potato pops with fries & 250 Ml beverage.",
                              "imageId": "803bb61382eaccaf79ce905cca5c7a08",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30933,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051428",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051429",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051427",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "123 ratings",
                                  "ratingCountV2": "123"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772784",
                              "name": "Grilled Lamb Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 14% with this combo of grilled lamb burger combo, our signature grilled lamb burger patty topped with crunchy lettuce, cheese, and onions served with garlic mayo on a toasted burger bun served with 2pc of peri peri chicken wings, along with fries & 250 Ml beverage.",
                              "imageId": "56366856919b9b8574f3b6ac2c13636b",
                              "inStock": 1,
                              "price": 46000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051052",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051054",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051049",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772864",
                              "name": "Grilled Peri Peri Chicken Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 12% with this combo, our peri peri chicken burger fresh grilled peri peri chicken fillet, crunchy lettuce, cheese, onions, sliced tomatoes, and signature sauce on a toasted burger bun served with 2pc of peri peri chicken wings, fries & 250 Ml beverage.",
                              "imageId": "f13d50a49a9bf73c0d24dc897db8a820",
                              "inStock": 1,
                              "price": 34857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051073",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051074",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051071",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "92 ratings",
                                  "ratingCountV2": "92"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102546397",
                              "name": "Jumbo Royal Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 17% with this combo of Jumbo royal chicken burger + 2 pcs Hot & Spicy Chicken wings with Fries & 250 Ml Beverage",
                              "imageId": "9041462c7b56ad9299c9c9fc38d76bbd",
                              "inStock": 1,
                              "price": 47095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051150",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051151",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051147",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "231 ratings",
                                  "ratingCountV2": "231"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102546394",
                              "name": "Chicken Fillet Burger Combo",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Save 22% with this combo of chicken fillet burger + 2 Pcs h&s wings with fries & 250 Ml Beverage.",
                              "imageId": "d303a2ab99078ca611713fe46035d815",
                              "inStock": 1,
                              "price": 38857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050728",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050730",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050727",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1000 ratings",
                                  "ratingCountV2": "1000"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527952",
                              "name": "All American Veg Cheese Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Our delicious mix veggie patty with crunchy lettuce cheese chipotle mayo in a toasted burger bun serving size: 320 Gms energy: 837 K Cal.",
                              "imageId": "f4e5e074b24951d468817a718c60cdb5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050550",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050548",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "75 ratings",
                                  "ratingCountV2": "75"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110569749",
                              "name": "Peri Peri Paneer Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Its a cottage cheese patty burger breaded with peri peri spice garnished sriacha sauce",
                              "imageId": "0fae88226c8d7ad94a3c41fbf62c62e3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20658,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051331",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051330",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "895 ratings",
                                  "ratingCountV2": "895"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212196",
                              "name": "Veggie Jumbo Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Its a potato based patty burger with green peas and carrot garnished with tomato onions and chesse serving size: 271 Gms energy: 814 K Cal.",
                              "imageId": "b46fc205eca198afedd4f114d3f20cd7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051423",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051422",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "759 ratings",
                                  "ratingCountV2": "759"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117301657",
                              "name": "Veggie Supreme Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Delightful veg patty, layered with cheese, crunchy lettuce and jalapeno sauce on a toasted burger bun serving size: 162 Gms energy: 398 K Cal.",
                              "imageId": "235d8018a62c25c8cae661f90a82d746",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051426",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051425",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "308 ratings",
                                  "ratingCountV2": "308"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126102532",
                              "name": "Spicy Aloo Tikki Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Serves 1",
                              "imageId": "f4849514f3e72985c51329b907f27899",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11320,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527948",
                              "name": "Aloo Tikki Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "A flavourful mix of marinated onions, crowned with a satisfying potato masala tikki patty. A classic twist that's comfort and taste in every bite.",
                              "imageId": "243860c96351bbdd266f07e6ffb32f78",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10277,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050555",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050553",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108305338",
                              "name": "Grilled Spicy Lamb Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Its a grilled soft and juicy lamb patty burger garnished with lettuce ,onions ,tomato & cheese serving size: 297 Gms energy: 596 K Cal.",
                              "imageId": "32a56812a47bb475598d58ef5267b823",
                              "inStock": 1,
                              "price": 29586,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051087",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051083",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051084",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051079",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "550 ratings",
                                  "ratingCountV2": "550"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108305337",
                              "name": "Grilled Peri Peri Chicken Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "It's a grilled peri peri fillet burger garnished with onions tomatoes and peri peri sauce serving size: 245 Gms energy: 390 K Cal.",
                              "imageId": "b8f72c8289a12541e33242c1663ab635",
                              "inStock": 1,
                              "price": 20857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051064",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051061",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051062",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051058",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "29 ratings",
                                  "ratingCountV2": "29"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108305339",
                              "name": "Jumbo Royal Chicken Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "It's a double fillet crunchy burger garnished with pickle gerkins and cheese serving size: 366 Gms energy: 738 K Cal.",
                              "imageId": "2d88d18c674b71d3b6777d03c3db6b50",
                              "inStock": 1,
                              "price": 33067,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051165",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051161",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051162",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051156",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "326 ratings",
                                  "ratingCountV2": "326"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527980",
                              "name": "Louisiana Chicken Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Big, thick, crunchy and juicy fried chicken fillet, topped with chicken bacon, crispy onion and Louisiana mayo on a toasted burger bun serving size: 289 Gms energy: 487.05 K Cal.",
                              "imageId": "a8474c2c44cb3ca359ab3030006bf0bf",
                              "inStock": 1,
                              "price": 27733,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051221",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051219",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051220",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051217",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "410 ratings",
                                  "ratingCountV2": "410"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108305336",
                              "name": "Chilli Cheese Chicken Fillet Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "It's a crunchy juicy fillet burger garnised with jalepenos serving size: 249 Gms energy: 738 K Cal.",
                              "imageId": "3bc48cc676d9834e28c0f58a50941cfe",
                              "inStock": 1,
                              "price": 26133,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050792",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050790",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050791",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050786",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "1323 ratings",
                                  "ratingCountV2": "1323"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117301658",
                              "name": "Chicken Fillet Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Big, thick, crunchy and juicy fried chicken fillet, lettuce, signature sauce on a toasted burger bun serving size: 232 Gms energy: 451.9 K Cal.",
                              "imageId": "19e37f4ea1613fe129534d0d6c2447d6",
                              "inStock": 1,
                              "price": 22838,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050719",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050712",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050716",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050709",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4003 ratings",
                                  "ratingCountV2": "4003"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527966",
                              "name": "Classic Chicken Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "Fresh hand-breaded crispy 100% chicken breast with crunchy lettuce, and mayo in a toasted burger bun serving size: 90 Gms energy: 290 K Cal.",
                              "imageId": "0715c56fde6da6f00847088235c100f5",
                              "inStock": 1,
                              "price": 14743,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050832",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050828",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050831",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050824",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "733 ratings",
                                  "ratingCountV2": "733"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527958",
                              "name": "Chicken Strip Burger",
                              "category": "Leon Burgers and Burger Combos",
                              "description": "2 spicy 100% chicken strips\", crunchy lettuce and mayo served with a toasted burger bun serving size: 87 Gms energy: 287 K Cal.",
                              "imageId": "5c941ab0013286237944c4168ed22011",
                              "inStock": 1,
                              "price": 12600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050782",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050780",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050781",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050778",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "441 ratings",
                                  "ratingCountV2": "441"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Hot & Spicy Chicken",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212168",
                              "name": "Hot & Spicy Wings Bucket",
                              "category": "Hot & Spicy Chicken",
                              "description": "Serves 1 | 16pcs Hot & Spicy Wings",
                              "imageId": "0beb9a04a6eae6afdff9628fc1974d13",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115597507",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115597506",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "206 ratings",
                                  "ratingCountV2": "206"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110527993",
                              "name": "5pcs Hot & Spicy Chicken Drumstick",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our fresh and famous h&s chicken drumstick in our spicy marinade fried to perfection serving size:600 Gms energy per 100 Gms:191.66 K Cal.",
                              "imageId": "3814203f760a51214565f8510a1e13a0",
                              "inStock": 1,
                              "price": 50900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050500",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050496",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050498",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656396",
                              "name": "8Pc Hot and Spicy Wings",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our fresh and famous hot & spicy chicken wings in our spicy marinade fried to perfection serving size:440 Gms energy per 100 Gms: 174.54 K Cal.",
                              "imageId": "0f377a0eb08935c862ec35c40a244ce4",
                              "inStock": 1,
                              "price": 32200,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656386",
                              "name": "4Pc Hot and Spicy Wings",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our fresh and famous hot & spicy chicken wings in our spicy marinade fried to perfection serving size:220 Gms energy per 100 Gms:174.54 K Cal.",
                              "imageId": "0f377a0eb08935c862ec35c40a244ce4",
                              "inStock": 1,
                              "price": 17128,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113892521",
                              "name": "4pc Hot & Spicy Chicken",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our fresh and famous hot & spicy chicken in our spicy marinade fried to perfection serving size: 400 Gms energy per 100 Gms:197.5 K Cal.",
                              "imageId": "46d35b660d537f5a4200c0ed01062a35",
                              "inStock": 1,
                              "price": 45676,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113892524",
                              "name": "2pc Hot & Spicy Chicken",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our fresh and famous hot & spicy chicken in our spicy marinade fried to perfection serving size:190 Gms energy per 100 Gms:197.5 K Cal.",
                              "imageId": "48a6b7c8e58470271408075dc74114e9",
                              "inStock": 1,
                              "price": 24000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "93 ratings",
                                  "ratingCountV2": "93"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130919028",
                              "name": "1 Pc Hot & Spicy Chicken",
                              "category": "Hot & Spicy Chicken",
                              "description": "Serves 1",
                              "imageId": "76d35535f7102f9460a65d6100c8554d",
                              "inStock": 1,
                              "price": 12457,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130919024",
                              "name": "12Pcs Chicken Strips",
                              "category": "Hot & Spicy Chicken",
                              "description": "Serves 1 | Our 100% chicken boneless strips hand breaded and deep fried served.",
                              "imageId": "ca3f690fca13a79e2f80fee630a85acd",
                              "inStock": 1,
                              "price": 54900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656389",
                              "name": "6Pcs Chicken Strips",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our 100% chicken boneless strips hand breaded and deep fried served.",
                              "imageId": "ca3f690fca13a79e2f80fee630a85acd",
                              "inStock": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656381",
                              "name": "3Pcs Chicken Strips",
                              "category": "Hot & Spicy Chicken",
                              "description": "Our 100% chicken boneless strips hand breaded and deep fried served.",
                              "imageId": "ca3f690fca13a79e2f80fee630a85acd",
                              "inStock": 1,
                              "price": 17500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Peri Peri Chicken",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581106",
                              "name": "Half Peri Peri Chicken",
                              "category": "Peri Peri Chicken",
                              "description": "Ours soft juicy, spicy & tangy peri peri chicken in our signature marinade grilled to perfection serving size:418gms energy per 100 Gms:164.94 K Cal.",
                              "imageId": "2d1532b01f63b476119dfae2c84ddc67",
                              "inStock": 1,
                              "price": 39429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051096",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051092",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051094",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "271 ratings",
                                  "ratingCountV2": "271"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772879",
                              "name": "Quater Peri Peri Chicken",
                              "category": "Peri Peri Chicken",
                              "description": "Ours soft juicy, spicy & tangy peri peri chicken in our signature marinade grilled to perfection serving size:194gms energy per 100 Gms:164.94 K Cal.",
                              "imageId": "2a1476bf5ea678244a382b557aad594e",
                              "inStock": 1,
                              "price": 20810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051392",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051388",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051390",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656398",
                              "name": "8pc Peri Peri wings",
                              "category": "Peri Peri Chicken",
                              "description": "Ours soft juicy, spicy & tangy peri peri chicken wings in our signature marinade grilled to perfection serving size:310 Gms energy per 100 Gms:204.51 K Cal.",
                              "imageId": "020c84604c2432e07f39e840229178ce",
                              "inStock": 1,
                              "price": 32181,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050531",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050523",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050527",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "52 ratings",
                                  "ratingCountV2": "52"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113829520",
                              "name": "4pc Peri Peri Wings",
                              "category": "Peri Peri Chicken",
                              "description": "Ours soft juicy, spicy & tangy peri peri chicken wings in our signature marinade grilled to perfection serving size:155 Gms energy per 100 Gms:204.51 K Cal.",
                              "imageId": "f7493f1471ffd339cc9727e1e9ff51f7",
                              "inStock": 1,
                              "price": 17129,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "133 ratings",
                                  "ratingCountV2": "133"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772556",
                              "name": "5pcs Peri Peri Chicken Drumstick",
                              "category": "Peri Peri Chicken",
                              "description": "Our fresh and famous peri peri chicken drumstick in our signature marinade grilled to perfection serving size:490 Gms energy per 100 Gms:206.12 K Cal.",
                              "imageId": "d37793576f829e6dca7c68e12c143047",
                              "inStock": 1,
                              "price": 50920,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "London Doners",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107942440",
                              "name": "Peri Peri Chicken Wrap",
                              "category": "London Doners",
                              "description": "Its chunks of juicy grilled chicken strips on a bed of fresh salad mix garnished with chilli sauce serving size: 326 Gms energy: 320 K Cal.",
                              "imageId": "4edd31a00c198d9f260e140044ec44b2",
                              "inStock": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051319",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051314",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051316",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051311",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "335 ratings",
                                  "ratingCountV2": "335"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656457",
                              "name": "Peri-Peri Paneer Wrap",
                              "category": "London Doners",
                              "description": "Deep fried peri peri paneer patty, lettuce, tomato, cucumber, onion, hummus, homemade chilli & garlic sauce in a tortilla wrap serving size: 315 Gms energy: 432 K Cal.",
                              "imageId": "05fbb0b7a98ca5738d5c6a2461b18021",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051370",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051367",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051369",
                                  "groupName": "Choose Your Fries",
                                  "choices": [
                                    {
                                      "id": "101954224",
                                      "name": "Chicken Popcorn Loaded Fries",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954225",
                                      "name": "Cheesy House Fries Veg",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954226",
                                      "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                                      "price": 25600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954227",
                                      "name": "Falafel Fries With Garlic Sauce",
                                      "price": 15571,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "253 ratings",
                                  "ratingCountV2": "253"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107942418",
                              "name": "Chicken Doner Wrap",
                              "category": "London Doners",
                              "description": "Grilled chicken with lettuce, tomato, cabbage, cucumber, onion, capsicum, red cabbage, hummus, homemade chilli & garlic sauce in a tortilla wrap serving size: 304 Gms energy: 320 K Cal.",
                              "imageId": "c3b2aebe12625786b043d960f676d25d",
                              "inStock": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050671",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050662",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050666",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050656",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1163 ratings",
                                  "ratingCountV2": "1163"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107942407",
                              "name": "Chicken Doner Pitta",
                              "category": "London Doners",
                              "description": "It's a grilled pita with full of fresh veggies, hummus and chunks of spicy chicken doner meat garnished with chilli garlic sauce serving size: 410 Gms energy: 485 K Cal.",
                              "imageId": "72979bbc51fd972d5554879b661366c3",
                              "inStock": 1,
                              "price": 26286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050624",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050621",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050623",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050616",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "1275 ratings",
                                  "ratingCountV2": "1275"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656439",
                              "name": "Hummus With Chicken and Pitta",
                              "category": "London Doners",
                              "description": "Its a grilled pita bread with hummus sauce and crunchy chicken doner meat serving size: 27 Gms energy: 340 K Cal.",
                              "imageId": "9283958683905eb26cbe659fb0715494",
                              "inStock": 1,
                              "price": 22400,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051123",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051121",
                                  "groupName": "Veg Snacks Option",
                                  "choices": [
                                    {
                                      "id": "106050264",
                                      "name": "8pc Onion Rings",
                                      "price": 18900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954191",
                                      "name": "Crispy Pizza Strips",
                                      "price": 16610,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954194",
                                      "name": "Paneer Popcorn Medium",
                                      "price": 16600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954192",
                                      "name": "Jalapeno Poppers",
                                      "price": 14533,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954193",
                                      "name": "Peri Peri Fries Medium",
                                      "price": 11400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051122",
                                  "groupName": "Non Veg Snacks Options",
                                  "choices": [
                                    {
                                      "id": "101954254",
                                      "name": "4pc Hot And Spicy Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102415987",
                                      "name": "1 Pc Hot & Spicy Chicken",
                                      "price": 12457,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954257",
                                      "name": "8 Pcs Chicken Nuggets",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954258",
                                      "name": "4pc Peri Peri Wings",
                                      "price": 17129,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954255",
                                      "name": "4 Pcs Chicken Nuggets",
                                      "price": 12600,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954256",
                                      "name": "3pcs Chicken Strips",
                                      "price": 17500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051119",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "1318 ratings",
                                  "ratingCountV2": "1318"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Leon Loaded Fries",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656425",
                              "name": "Fries with Chilli Garlic Sauce",
                              "category": "Leon Loaded Fries",
                              "description": "French fries topped with homemade chilli & garlic sauce serving size: 145 Gms energy: 301 K Cal.",
                              "imageId": "63e1040c62632f8257420810e3db7b4b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050975",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050970",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050973",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "221 ratings",
                                  "ratingCountV2": "221"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "18392616",
                              "name": "Cheesy House Fries Veg",
                              "category": "Leon Loaded Fries",
                              "description": "Loaded fries topped with grilled peppers and onions, jalapeno cheese sauce serving size: 175 Gms energy: 361 K Cal.",
                              "imageId": "a2ae90db25b5d1fdfd50a61916faf035",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16610,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050602",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050604",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "616 ratings",
                                  "ratingCountV2": "616"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "61835042",
                              "name": "Paneer Popcorn Loaded Fries",
                              "category": "Leon Loaded Fries",
                              "description": "Serves 1",
                              "imageId": "d1f50eef98cf65dac14ecf0cf7fd67b0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051263",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051265",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "119 ratings",
                                  "ratingCountV2": "119"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212184",
                              "name": "Chicken Popcorn Loaded Fries",
                              "category": "Leon Loaded Fries",
                              "description": "Loaded fries with 12 Pcs chicken popcorn, homemade chilli & garlic sauce serving size: 235 Gms energy: 431 K Cal.",
                              "imageId": "164e41e7fdd78d3120a617c34499ff87",
                              "inStock": 1,
                              "price": 26286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050763",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050767",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1368 ratings",
                                  "ratingCountV2": "1368"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581044",
                              "name": "Doner Chicken Fries With Chilli Garlic Sauce",
                              "category": "Leon Loaded Fries",
                              "description": "Loaded fries with grilled doner chicken, homemade chilli garlic sauce serving size: 235 Gms energy: 421 K Cal.",
                              "imageId": "3f15cb116a00398571fc40ab8443de71",
                              "inStock": 1,
                              "price": 26286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050846",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050852",
                                  "groupName": "Pick Your Burger",
                                  "choices": [
                                    {
                                      "id": "101954221",
                                      "name": "Aloo Tikki Burger",
                                      "price": 10277,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954223",
                                      "name": "Chicken Strip Burger",
                                      "price": 11004,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "278 ratings",
                                  "ratingCountV2": "278"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Leon Biryani Bowl & Platter",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656426",
                              "name": "Gourmet Chicken Kheema Biryani",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "Serves 1 | Flavourful minced chicken kheema served on a bowl of freshly prepared biryani rice along with a side of gravy and salad.",
                              "imageId": "29ea54a6e695321f7effe56ee7dd9bf4",
                              "inStock": 1,
                              "price": 34900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772574",
                              "name": "Chicken Doner Biryani Platter",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "Grilled donner chicken, half pitta, salad, and freshly prepared biryani served as a complete meal serving size: 562 Gms energy: 368 K Cal.",
                              "imageId": "e5f543f85ee978ef3eb9b311b952ba99",
                              "inStock": 1,
                              "price": 29867,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050610",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050607",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "80 ratings",
                                  "ratingCountV2": "80"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772615",
                              "name": "Chicken Popcorn Biryani Platter.",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "12pc Chicken popcorn, half pitta, salad, freshly prepared biryani rice served as a complete meal serving size: 562 Gms energy: 401 K Cal.",
                              "imageId": "e5f543f85ee978ef3eb9b311b952ba99",
                              "inStock": 1,
                              "price": 29867,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050742",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050739",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "187 ratings",
                                  "ratingCountV2": "187"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772875",
                              "name": "Peri Peri Wings Biryani Platter",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "4 Pieces tender & juicy peri peri chicken wings, half pitta, salad, freshly prepared biryani rice served as a complete meal serving size: 562 Gms energy: 422 K Cal.",
                              "imageId": "7291ac8d911d741ef317965b71032bd4",
                              "inStock": 1,
                              "price": 29857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051382",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051377",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "81 ratings",
                                  "ratingCountV2": "81"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772818",
                              "name": "Paneer Popcorn Biryani Bowl",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "12 Pieces of crispy paneer popcorn served on bowl of freshly prepared biryani rice.",
                              "imageId": "defa237ca68138c07209587e3ad893ca",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27904,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051258",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051253",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772587",
                              "name": "Chicken Popcorn Biryani Bowl",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "12 Pieces of hot & spicy crunchy chicken popcorn served on bowl of freshly prepared biryani rice.",
                              "imageId": "ec6f894431ffae2e0ca84c6e7286bc6a",
                              "inStock": 1,
                              "price": 27904,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050736",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050733",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "108 ratings",
                                  "ratingCountV2": "108"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772825",
                              "name": "Paneer Popcorn Biryani Platter",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "12 Pieces paneer popcorn, half pitta, salad, freshly prepared biryani rice served as a complete meal serving size: 562 Gms energy: 543 K Cal.",
                              "imageId": "fbe9c075dca6f87adf9416ad4b441591",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29867,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051262",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051260",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772834",
                              "name": "Peri Peri Chicken Biryani Bowl",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "Soft, juicy, spicy and tangy peri peri chicken drumstick served with bowl of freshly prepared biryani rice.",
                              "imageId": "07ca37c0626a0ad0900c0e762e0cf292",
                              "inStock": 1,
                              "price": 26952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051302",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051299",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656438",
                              "name": "Hot and Crispy Chicken Biryani Bowl",
                              "category": "Leon Biryani Bowl & Platter",
                              "description": "Crunchy, tender and juicy chicken drumstick served on bowl of freshly prepared biryani rice.",
                              "imageId": "d599c5945a7dc1833dc3236983e5fe57",
                              "inStock": 1,
                              "price": 26952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051116",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051112",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Snacks",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113212638",
                              "name": "Paneer Popcorn Large",
                              "category": "Snacks",
                              "description": "Fresh bite-sized paneer seasoned with our spicy marinade, deep fried to perfection",
                              "imageId": "339420007182485ebd1763012f14e573",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113212639",
                              "name": "Paneer Popcorn Medium",
                              "category": "Snacks",
                              "description": "Fresh bite-sized paneer seasoned with our spicy marinade, deep fried to perfection serving size:110 Gms energy per 100 Gms : 225.45 K Cal.",
                              "imageId": "339420007182485ebd1763012f14e573",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16610,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212210",
                              "name": "Crispy Pizza Strips",
                              "category": "Snacks",
                              "description": "8pc crispy, 100% mozzarella pizza strips serving size:143 Gms energy: 346 K Cal.",
                              "imageId": "1338de5e1628c6dadb14fcbb19fa284b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16610,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "444 ratings",
                                  "ratingCountV2": "444"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212209",
                              "name": "Jalapeno Poppers",
                              "category": "Snacks",
                              "description": "8 Pcs crispy, golden Jalapeno cheese poppers serving size:112 Gms energy: 320 K Cal.",
                              "imageId": "b7f4ada05124901cd31f8cc962630902",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14533,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "371 ratings",
                                  "ratingCountV2": "371"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113828397",
                              "name": "Peri Peri Fries Large",
                              "category": "Snacks",
                              "description": "Deliciously seasoned peri peri fries, crispy and crunch on the outside, fluffy and hot on the inside serving size: 135 Gms energy: 390.17 K Cal.",
                              "imageId": "0d321edc2f844b287d2d989e26ebd6bc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14533,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113828399",
                              "name": "Peri Peri Fries Medium",
                              "category": "Snacks",
                              "description": "Deliciously seasoned peri peri fries, crispy and crunch on the outside, fluffy and hot on the inside serving size: 110g Gms energy: 317.92 K Cal.",
                              "imageId": "08cbe1f05d15b879b20136bfc1b56c1e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11419,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "68 ratings",
                                  "ratingCountV2": "68"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "104772719",
                              "name": "French Fries Large",
                              "category": "Snacks",
                              "description": "Deliciously seasoned fries, crispy and crunch on the outside, fluffy and hot on the inside serving size: 135 Gms energy: 387.35 K Cal.",
                              "imageId": "c06b3ef1b14ad18052b57e48d598f686",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12457,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "103 ratings",
                                  "ratingCountV2": "103"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113828398",
                              "name": "French Fries Medium",
                              "category": "Snacks",
                              "description": "Deliciously seasoned fries, crispy and crunch on the outside, fluffy and hot on the inside serving size: 110 Gms energy: 315.62 K Cal.",
                              "imageId": "c06b3ef1b14ad18052b57e48d598f686",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9862,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "122 ratings",
                                  "ratingCountV2": "122"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113212640",
                              "name": "Chicken Popcorn Large",
                              "category": "Snacks",
                              "description": "Fresh tender bite-sized 100% chicken breast seasoned with our spicy marinade hand breaded and deep fried to perfection.",
                              "imageId": "b9f256ecba774f07365db89bff33d882",
                              "inStock": 1,
                              "price": 26560,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113212641",
                              "name": "Chicken Popcorn Medium",
                              "category": "Snacks",
                              "description": "Fresh tender bite-sized 100% chicken breast seasoned with our spicy marinade hand breaded and deep fried to perfection.",
                              "imageId": "b9f256ecba774f07365db89bff33d882",
                              "inStock": 1,
                              "price": 18582,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "161 ratings",
                                  "ratingCountV2": "161"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "17212216",
                              "name": "8 Pcs Chicken Nuggets",
                              "category": "Snacks",
                              "description": "Chicken nuggets serving size:136 Gms energy: 361.66 K Cal.",
                              "imageId": "d5b51d397edd3a738b989515274bb893",
                              "inStock": 1,
                              "price": 17129,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "753 ratings",
                                  "ratingCountV2": "753"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "107942399",
                              "name": "4 Pcs Chicken Nuggets",
                              "category": "Snacks",
                              "description": "Chicken nuggets serving size:68 Gms energy: 180.83 K Cal.",
                              "imageId": "d5b51d397edd3a738b989515274bb893",
                              "inStock": 1,
                              "price": 8564,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "55 ratings",
                                  "ratingCountV2": "55"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "98453516",
                              "name": "Sprite 330ml",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656463",
                              "name": "Zero coke 330ml",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "48 ratings",
                                  "ratingCountV2": "48"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "105111707",
                              "name": "330ml Can Coke",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94738105",
                              "name": "Leon Grill's Mineral Water Bottle (1000ml)",
                              "category": "Beverages",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110594742",
                              "name": "Chocolate Brownie",
                              "category": "Desserts",
                              "imageId": "d8284c33622b1232440ca36a521b1f9d",
                              "inStock": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "341 ratings",
                                  "ratingCountV2": "341"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656410",
                              "name": "Chocolate mousse",
                              "category": "Desserts",
                              "imageId": "3fd06ed6979f77c732d1ae978bcbee34",
                              "inStock": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "232 ratings",
                                  "ratingCountV2": "232"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dips/Sauces",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126308443",
                              "name": "Gourmet Sauce",
                              "category": "Dips/Sauces",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581114",
                              "name": "Hummus",
                              "category": "Dips/Sauces",
                              "description": "Mashed chickpeas blended with tahini and lemon juice.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 3000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "131 ratings",
                                  "ratingCountV2": "131"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581115",
                              "name": "Chilli Sauce",
                              "category": "Dips/Sauces",
                              "description": "Fresh red chillies and garlic along with good tang of tomato.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581117",
                              "name": "Chilli Garlic Mayo",
                              "category": "Dips/Sauces",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "199 ratings",
                                  "ratingCountV2": "199"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "45581111",
                              "name": "Garlic Mayo",
                              "category": "Dips/Sauces",
                              "description": "Our signature dip enhanced with fresh garlic.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "351 ratings",
                                  "ratingCountV2": "351"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "93108894",
                              "name": "Sriracha Sauce",
                              "category": "Dips/Sauces",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Leon Breakfast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353413",
                              "name": "Breakfast Burrito (Veg)",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Love Paneer? Us too. So We Put Paneer, Chopped Mushroom, Capsicum, Pepper, Onion, Chilli, Hash Brown, into a Flour Tortilla With Chipotle Sauce and Cheese.",
                              "imageId": "bc17ecf40f13dbe23495a29d9197726a",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050578",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050580",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050581",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353416",
                              "name": "Full Monty",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Scrambled eggs , hash brown, 2 chicken sausages, 2 chicken bacons, grilled tomato, saut?ed mushroom, backed beans, 2 slices of toast. tell you stomach to make a room.",
                              "imageId": "55a21fe68952c10e46dc165988c4f31e",
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050976",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050978",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050977",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050979",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353402",
                              "name": "Chicken Egg & Hash Sandwich",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Hand breaded crispy chicken, with egg & hash brown on a toasted buttery bun. so simple, so good yet so yum. it want you make more",
                              "imageId": "900e7c4b4c8dca6695090ad8a114f233",
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050682",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050689",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050685",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050692",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "99 ratings",
                                  "ratingCountV2": "99"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353408",
                              "name": "Double Sausage & Egg Sandwich",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | 2 Nos grilled sausages, melty cheese, freshly cracked eggs on a toasted buttery bun. your stomach makes you one for this.",
                              "imageId": "de055fccf9791f829c9b9bd069cb94c0",
                              "price": 15800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050881",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050886",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050882",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050888",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "26464431",
                              "name": "Breakfast Butty",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Freshly cracked eggs, grilled bacon, grilled sausage, hash brown & melty cheese on a toasted bun. boom, loaded.",
                              "imageId": "b993bfa17a850def08199035d9fdfebd",
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050586",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050590",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050589",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050592",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "108 ratings",
                                  "ratingCountV2": "108"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353414",
                              "name": "Sausage Egg & Cheese Sandwich",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Grilled sausage, a freshly cracked egg & melty cheese on a toasted buttery bun. pretty much the definition of starting the day. right?",
                              "imageId": "2e5b74b6a2e4c34c06b7831d4d0346ac",
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051394",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051398",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051396",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051399",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "67 ratings",
                                  "ratingCountV2": "67"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "26464384",
                              "name": "Fully Loaded Omelette",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Our omelete is prepared with freshest ingredients, made with 3 eggs, chicken sausages, chicken bacon, diced onion, pepper, chilli, coriander & cheese.",
                              "imageId": "6812a790775575bb41dda4421b0d2052",
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050986",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050991",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050988",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050993",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "125 ratings",
                                  "ratingCountV2": "125"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353410",
                              "name": "Mushroom & Cheese Omelette",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Our omelete is prepared with freshest ingrediants, made with 3 eggs, sliced mushrooms, onion, chilli, corriandar & cheese.",
                              "imageId": "0345c62fc8b411b8179e75cc23e06ebf",
                              "price": 15800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051226",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051229",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051228",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051230",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110353404",
                              "name": "Breakfast Burrito (Non- Veg)",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Love meat? us too. so we put bacon, grilled sausage, grilled onion, peppers , chilli, hash brown, hot sauce into a flour tortilla with chipotle sauce, scrambled egg and cheese.",
                              "imageId": "1f2182c5ca8b7c87aa462e6a7ee0a21d",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115050566",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050573",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050570",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115050576",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125656436",
                              "name": "Hashbrown ( 2Pcs )",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | No breakfast is complete without a golden brown, perfectly crisp, amazingly delicious hashbrown. remember the hashbrown always",
                              "imageId": "99b6e37210e9f75322a907db52f18d43",
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115051100",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051101",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115051102",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127939609",
                              "name": "Peri Peri Paneer Burger .",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Its a cottage cheese patty burger breaded with peri peri spice garnished sriacha sauce",
                              "imageId": "aeb984aaa310015bc1f3ed487e374c60",
                              "isVeg": 1,
                              "price": 20600,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121877929",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877930",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877931",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877932",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "895 ratings",
                                  "ratingCountV2": "895"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127642800",
                              "name": "Veggie Supreme Burger .",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Delightful veg patty, layered with cheese, crunchy lettuce and jalapeno sauce on a toasted burger bun serving size: 162 Gms energy: 398 K Cal.",
                              "imageId": "235d8018a62c25c8cae661f90a82d746",
                              "isVeg": 1,
                              "price": 15571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121191194",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191192",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191193",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127939608",
                              "name": "Chicken Fillet Burger .",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Big, thick, crunchy and juicy fried chicken fillet, lettuce, signature sauce on a toasted burger bun serving size: 232 Gms energy: 451.9 K Cal.",
                              "imageId": "19e37f4ea1613fe129534d0d6c2447d6",
                              "price": 22800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121877924",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877925",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877926",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877927",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121877928",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4003 ratings",
                                  "ratingCountV2": "4003"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127642795",
                              "name": "Classic Chicken Burger .",
                              "category": "Leon Breakfast",
                              "description": "Serves 1 | Fresh hand-breaded crispy 100% chicken breast with crunchy lettuce, and mayo in a toasted burger bun serving size: 9 Gms energy: 290 K Cal.",
                              "imageId": "0715c56fde6da6f00847088235c100f5",
                              "price": 14743,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "121191190",
                                  "groupName": "Meal Option",
                                  "choices": [
                                    {
                                      "id": "101954195",
                                      "name": "Regular Fries + 250ml Coke",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191191",
                                  "groupName": "Choose Your Desserts",
                                  "choices": [
                                    {
                                      "id": "101954196",
                                      "name": "Chocolate Mousse",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954197",
                                      "name": "Chocolate Brownie",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191188",
                                  "groupName": "Choose your veg add-ons",
                                  "choices": [
                                    {
                                      "id": "101954199",
                                      "name": "Hashbrown",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191187",
                                  "groupName": "Choose Your Non-veg Addons",
                                  "choices": [
                                    {
                                      "id": "101954236",
                                      "name": "Sausages (2pc)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954237",
                                      "name": "Chicken Bacon (2pc)",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954238",
                                      "name": "Scrambeled Eggs",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954239",
                                      "name": "Chicken Nuggets (4pc)",
                                      "price": 8560,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "121191189",
                                  "groupName": "Choose Your Beverages option",
                                  "choices": [
                                    {
                                      "id": "101954201",
                                      "name": "Sparkling Ice tea",
                                      "price": 12800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954200",
                                      "name": "Irish Cold Cofee",
                                      "price": 12800,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101954202",
                                      "name": "Hazel Nut Cold  Cofee",
                                      "price": 17900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "733 ratings",
                                  "ratingCountV2": "733"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127642794",
                              "name": "Chocolate Brownie .",
                              "category": "Leon Breakfast",
                              "description": "Serves 1",
                              "imageId": "d8284c33622b1232440ca36a521b1f9d",
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "341 ratings",
                                  "ratingCountV2": "341"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11218334000498"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Leon's - Burgers & Wings (Leon Grill)",
                      "area": "Koramangala",
                      "completeAddress": "Plot No.123 K.H.B Colony, 5th Block , Koramangala , Bangalore -95"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "oVk4CGwWlIQa-TtIvWnxN_5aY48LRrQO1G2YoNo8"
},
// 20240105233543
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=614642&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "614642",
              "name": "Soul Rasa",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "soul-rasa-basavanagudi-basavanagudi",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "v9fczzlua1wnrx63fh1g",
              "locality": "Akkithimanahalli",
              "areaName": "Shanti Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Indian",
                "Healthy Food"
              ],
              "avgRating": 4.6,
              "feeDetails": {
                "restaurantId": "614642",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4600
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4600,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "3 kms | ₹46 Delivery fee will apply"
              },
              "parentId": "239281",
              "avgRatingString": "4.6",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "614642",
                "deliveryTime": 28,
                "minDeliveryTime": 28,
                "maxDeliveryTime": 28,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 33,
                "slaString": "28 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 11:30 am, tomorrow",
                "nextOpenTime": "2024-01-06 11:30:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use GUILTFREE",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT125 off  | Use LNBINGE",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹110 | Use code GUILTFREE",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT125 off  | Use LNBINGE",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "soul-rasa-basavanagudi-basavanagudi",
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "The Bowl Company, # 299,1st Floor, BBMP ward no 117, Akkithimanahalli , Shanthinagar, Bangalore 560025."
                },
                {
                  "title": "Cuisines",
                  "message": "Indian,Healthy Food"
                }
              ],
              "logo": "v1659437233/Brand logo/Soul_Rasa",
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use GUILTFREE",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT125 off  | Use LNBINGE",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹110 | Use code GUILTFREE",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "FLAT125 off  | Use LNBINGE",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 244,
                  "maxValue": 349,
                  "priority": 7,
                  "couponCode": "FLAT125",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code FLAT125",
                  "unlockedMessage": "FLAT125 Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/614642"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 11:30 am, tomorrow",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:30 AM tomorrow",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.96076,77.60047"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "60% OFF UPTO ₹110",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "e38dbd49-ca7d-4ad0-a81d-e876b5b17a3d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE GUILTFREE",
                      "description": "ABOVE ₹179",
                      "offerType": "offers",
                      "restId": "614642",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "LATE NIGHT",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "92648bfc-2b43-44f5-87a3-7c87f5b501dd"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE LNBINGE",
                      "description": "ABOVE ₹449",
                      "offerType": "offers",
                      "restId": "614642",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "a48a3154-c6fd-4a11-8d0d-3a5969f27bc6"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLATDEAL",
                      "description": "ABOVE ₹749",
                      "offerType": "offers",
                      "restId": "614642",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "614642",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "614642",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Soul Rasa Specials",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126600770",
                              "name": "Chole Paneer Masala",
                              "category": "Soul Rasa Specials",
                              "description": "A delightful fusion of chickpeas and paneer in a gently spiced tomato-onion gravy enriched with traditional Indian spices.",
                              "imageId": "540c475a6938b5fff5e6db9a0876b8e0",
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117315491",
                                  "groupName": "Quantity",
                                  "choices": [
                                    {
                                      "id": "103015656",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103015657",
                                      "name": "Serves 2",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126600772",
                              "name": "Dal Panchmahel",
                              "category": "Soul Rasa Specials",
                              "description": "Savour the rich flavours of Rajasthan with our Panchmel Dal, a wholesome blend of five lentils: black masoor dal, chana dal, green moong dal, yellow moong dal, and toor dal.",
                              "imageId": "c1283e64d265d0364995549b6ce1c0f8",
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117315495",
                                  "groupName": "Quantity",
                                  "choices": [
                                    {
                                      "id": "103015658",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103015659",
                                      "name": "Serves 2",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127350744",
                              "name": "Bhuna Chicken Tamatar Curry",
                              "category": "Soul Rasa Specials",
                              "description": "A wholesome curry with tender chicken simmered in a mildly spicy tomato-onion gravy, enriched with creamy coconut milk and a blend of aromatic Indian spices.",
                              "imageId": "579401c682a3b639d0b464e0b94a1e49",
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120137464",
                                  "groupName": "Quantity",
                                  "choices": [
                                    {
                                      "id": "103874624",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103874625",
                                      "name": "Serves 2",
                                      "price": 19900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441595",
                              "name": "Ragi Coconut Ladoo (3 Pcs)",
                              "category": "Soul Rasa Specials",
                              "description": "Nutritious ladoos made of ragi, coconuts, cashewnuts and sweetened with jaggery. Good for your taste buds. Contains milk & nut. Energy : 334.52 Kcal. (80 gms).",
                              "imageId": "01002182ec08a4115d50ee12ac14c098",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441596",
                              "name": "Til & Jaggery Ladoo (3 Pcs)",
                              "category": "Soul Rasa Specials",
                              "description": "Crunchy sesame seed laddos enriched with jaggery; a guilt-free treat for your sweet tooth! Contains milk & nut. Energy : 403.92 Kcal. (80 gms).",
                              "imageId": "f25018ead86b134e1515124d27a72e01",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441584",
                              "name": "Moong Dal and Jaggery Halwa",
                              "category": "Soul Rasa Specials",
                              "description": "Our take on the classic moong dal halwa; lighter and sweetened with the jaggery. Satisfy your sugar cravings, guilt-free! Contains milk & nut. Energy : 280.2 Kcal. (80 gms).",
                              "imageId": "59871196e130bf9d0ae61b4376f031c0",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "70 ratings",
                                  "ratingCountV2": "70"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441585",
                              "name": "Pumpkin and Jaggery Halwa",
                              "category": "Soul Rasa Specials",
                              "description": "A classic pumpkin halwa sweetened with jaggery and garnished with dry fruits. End your meal on a sweet note! Contains milk & nut. Energy : 133.02 Kcal. (80 gms).",
                              "imageId": "8c94b4c3e1201c2ca8c7ffe54b366a03",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Mains- A la Carte",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118189938",
                              "name": "Green Moong Dal",
                              "category": "Mains- A la Carte",
                              "description": "Green Moong dal cooked with special tadka; a perfect companion dish",
                              "imageId": "d66ef95481091261d02987b95520a99a",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852832",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852833",
                                  "groupName": "Quantity",
                                  "choices": [
                                    {
                                      "id": "100391744",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391745",
                                      "name": "Serves 2",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852834",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852835",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441548",
                              "name": "Masoor Palak Dal",
                              "category": "Mains- A la Carte",
                              "description": "Whole masoor dal cooked with spinach and a light tadka of jeera and chillies. A perfect side, indeed! Energy : 149.6 Kcal. (Serves 1 : 200 gms, Serves 2 : 450 gms).",
                              "imageId": "28c8c4c3ae9439eb342c78c994e5f60d",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852746",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852745",
                                  "groupName": "Quantity - Masoor Dal Palak",
                                  "choices": [
                                    {
                                      "id": "100391721",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391722",
                                      "name": "Serves 2",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852747",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852748",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "86 ratings",
                                  "ratingCountV2": "86"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441557",
                              "name": "Gajar Matar",
                              "category": "Mains- A la Carte",
                              "description": "A classic for the ages; carrots and peas tossed in a mix of simple spices and oven roasted till tender. Energy : 151.4 Kcal. (Serves 1 : 180 gms, Serves 2 : 300 gms).",
                              "imageId": "b38abdbd7b23e70cf40c97e4881da5e8",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852734",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852733",
                                  "groupName": "Quantity - Gajar Matar",
                                  "choices": [
                                    {
                                      "id": "100391718",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391719",
                                      "name": "Serves 2",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852735",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852736",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441594",
                              "name": "Turai Chana dal",
                              "category": "Mains- A la Carte",
                              "description": "Turai (ridge gourd) cooked in a tadka of jeera, mustard and turmeric along with slightly crunchy channa dal. A delicious side! Energy : 143.6 Kcal. (Serves 1 : 220 gms, Serves 2 : 425 gms).",
                              "imageId": "fc0cd7a1eb9981024b8f9b6fad6f57d2",
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852775",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852774",
                                  "groupName": "Quantity - Turai Chana dal",
                                  "choices": [
                                    {
                                      "id": "100391738",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391739",
                                      "name": "Serves 2",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852776",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852777",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441601",
                              "name": "Chatpata Sprouts",
                              "category": "Mains- A la Carte",
                              "description": "A medley of crunchy sprouts cooked in a tomato-onion masala: simple and pro! Energy : 153.2 Kcal. (Serves 1 : 180 gms, Serves 2 : 350 gms).",
                              "imageId": "712d20d101fa89d937db8f637818bc51",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852727",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852726",
                                  "groupName": "Quantity - Chatpata Sprouts",
                                  "choices": [
                                    {
                                      "id": "100391716",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391717",
                                      "name": "Serves 2",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852728",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852729",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441544",
                              "name": "Beans Carrot Poriyal",
                              "category": "Mains- A la Carte",
                              "description": "Dices of carrots and beans cooked in a simple tadka of mustard seeds, curry leaves and fresh coconuts. Simple and comforting! Energy : 162.45 Kcal. (Serves 1 : 160 gms, Serves 2 : 300 gms).",
                              "imageId": "f4f4785a15931293791513e2cee94935",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852719",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852718",
                                  "groupName": "Quantity - Beans Carrot Poriyal",
                                  "choices": [
                                    {
                                      "id": "100391712",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391713",
                                      "name": "Serves 2",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852720",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852721",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441597",
                              "name": "Roasted Broccoli & Gobi",
                              "category": "Mains- A la Carte",
                              "description": "Florets of broccoli and cauliflower, oven roasted till tender and topped with a mildly spiced yoghurt and nut gravy. Slightly creamy, packed with goodness! Contains milk & nut. Energy : 144.612 Kcal. (180 gms).",
                              "imageId": "f9073838f1bd418344af4617c0a0d7f9",
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852765",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852766",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852767",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441593",
                              "name": "Anda Masala",
                              "category": "Mains- A la Carte",
                              "description": "Hard boiled eggs simmered in a tomato-onion gravy and seasoned with classic spices. Packed with goodness, yum!  Contains egg. Energy : 269.44 Kcal. (Serves 1 : 200 gms, Serves 2 : 360 gms).",
                              "imageId": "f9e8e783ed7f87bfc59087baf6002fd7",
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852709",
                                  "groupName": "Quantity - Anda Masala",
                                  "choices": [
                                    {
                                      "id": "100391687",
                                      "name": "Serves 1",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391688",
                                      "name": "Serves 2",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852710",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852711",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852712",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Nourishing Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123836554",
                              "name": "Green Moong Dal Bowl",
                              "category": "Nourishing Bowls",
                              "description": "Protien rich green moong dal served with choice of Rice/Millet.",
                              "imageId": "c21180910097f09dcbd45f183ed9afe7",
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852860",
                                  "groupName": "Choose Your Grain",
                                  "choices": [
                                    {
                                      "id": "100391749",
                                      "name": "Brown Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391748",
                                      "name": "Jeera Millets",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852859",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "100391698",
                                      "name": "Ragi Coconut Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391699",
                                      "name": "Til & Jaggery Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391700",
                                      "name": "Moong Dal and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391701",
                                      "name": "Pumpkin and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852861",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123836556",
                              "name": "Masoor Palak Dal Bowl",
                              "category": "Nourishing Bowls",
                              "description": "Rich in protein and fiber masoor dal served with choice of Rice/ Millet.",
                              "imageId": "97c738ae6dad9c016c841dbd11b74942",
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852862",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "100391698",
                                      "name": "Ragi Coconut Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391699",
                                      "name": "Til & Jaggery Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391700",
                                      "name": "Moong Dal and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391701",
                                      "name": "Pumpkin and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852863",
                                  "groupName": "Choose Your Grain",
                                  "choices": [
                                    {
                                      "id": "100391749",
                                      "name": "Brown Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391748",
                                      "name": "Jeera Millets",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852864",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441571",
                              "name": "Kala Chana & Sprouts Chaat",
                              "category": "Nourishing Bowls",
                              "description": "A mix of steamed Kala channa & sprouts, with onions, tomatoes, chillies tossed with chaat masala and lime. A nutritious & yummy snack! Contains nuts. Energy : 587.52 Kcal. (260 gms).",
                              "imageId": "16abf2a6e1fa49cf83d9c2291db2b01d",
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852741",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "100391698",
                                      "name": "Ragi Coconut Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391699",
                                      "name": "Til & Jaggery Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391700",
                                      "name": "Moong Dal and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391701",
                                      "name": "Pumpkin and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852742",
                                  "groupName": "Extra Veggies",
                                  "choices": [
                                    {
                                      "id": "100391702",
                                      "name": "Chatpata Sprouts",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391703",
                                      "name": "Gajar Matar Sabzi",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391705",
                                      "name": "Turai Chana Dal",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852743",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852744",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Roti, Rice & Khichdi",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115811226",
                              "name": "Ajwaini Chapati (3 Rotis)",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Whole wheat rotis flavoured with Ajwain or carom seeds. Contains milk & wheat. Energy : 185.1 Kcal. (80 gms).",
                              "imageId": "cbd761db3bc96cf425404e4932c5d280",
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115811252",
                              "name": "Palak Chapati (3 Rotis)",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Whole wheat rotis loaded with all the goodness of Palak. Contains milk & wheat. Energy : 180.1 Kcal. (80 gms).",
                              "imageId": "420deecd3ac87c9ab37038dc727b2b3f",
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115811276",
                              "name": "Whole Wheat Chapati (3 Rotis)",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Classic rotis made of whole wheat flour. Contains wheat. Energy : 188.7 Kcal. (80 gms).",
                              "imageId": "ab567b499909d2c7a8eef1806d22b588",
                              "isVeg": 1,
                              "price": 4900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118189936",
                              "name": "Brown Jeera Rice",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Fragrant & Flavourful brown rice cooked with cumin seeds; a healthier alternative to white rice & perfectly complements a curries, vegetables & meats.",
                              "imageId": "5e28ef855eee2881f37a8f938ad57dbd",
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441602",
                              "name": "Jeera Millets",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Fluffy kodo millet cooked with finely chopped beans, carrots and some whole spices. Wholesome and delicious. Energy : 316.7 Kcal. (300 gms).",
                              "imageId": "1ec63ccc15df5555d882a9a09021e975",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441573",
                              "name": "Classic Dal & Brown Rice Khichdi",
                              "category": "Roti, Rice & Khichdi",
                              "description": "Our take on a classic dal khichdi is made with whole masoor dal & brown rice, and tempered with hing & jeera. Served with Papad & Curd, this is a comforting meal for one. Contains milk. Energy : 312.8 Kcal. (542 gms).",
                              "imageId": "0343495461cfccd21f6f4a3b70889bd9",
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852730",
                                  "groupName": "Extra Veggies",
                                  "choices": [
                                    {
                                      "id": "100391702",
                                      "name": "Chatpata Sprouts",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391703",
                                      "name": "Gajar Matar Sabzi",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391705",
                                      "name": "Turai Chana Dal",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852731",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852732",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "88 ratings",
                                  "ratingCountV2": "88"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109770721",
                              "name": "Methi Palak Brown Rice Khichdi",
                              "category": "Roti, Rice & Khichdi",
                              "description": "A comforting khichdi made with whole masoor dal & brown rice, cooked with methi and spinach. Served with Papad & Curd, yum! Good for one. Contains milk. Energy : 296.7 Kcal. (542 gms).",
                              "imageId": "49cefac0bb0dff2fe9c163f52b5942fa",
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852779",
                                  "groupName": "Grains",
                                  "choices": [
                                    {
                                      "id": "100391689",
                                      "name": "Jeera Millets",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391690",
                                      "name": "Brown Jeera Rice",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391691",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "price": 5900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391692",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391693",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852778",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "100391698",
                                      "name": "Ragi Coconut Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391699",
                                      "name": "Til & Jaggery Ladoo (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391700",
                                      "name": "Moong Dal and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391701",
                                      "name": "Pumpkin and Jaggery Halwa",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852780",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "100391694",
                                      "name": "Buttermilk",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111852781",
                                  "groupName": "Add Ons",
                                  "choices": [
                                    {
                                      "id": "100391695",
                                      "name": "Cucumber Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391696",
                                      "name": "Roasted Papad",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391697",
                                      "name": "Onion Circles",
                                      "price": 1900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "102 ratings",
                                  "ratingCountV2": "102"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Curated Nourishing Plates",
                      "categories": [
                        {
                          "title": "Vegetarian Meals",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126600771",
                                  "name": "Chole Paneer Masala with Brown Rice",
                                  "category": "Curated Nourishing Plates",
                                  "description": "A soulful meal with a fusion curry made of chole and paneer. Along with jeera flavoured brown rice.",
                                  "imageId": "63e1241e7c60bb353b0264f82185aad6",
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "117315492",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117315493",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117315494",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126600773",
                                  "name": "Rajasthani Panchmel Dal with Brown Rice",
                                  "category": "Curated Nourishing Plates",
                                  "description": "A nutritious yet tasty meal with Panchmel Dal - a traditional Rajasthani dish packed with the goodness of five lentils: black masoor dal, chana dal, green moong dal, yellow moong dal, and toor dal. Served with jeera flavoured brown rice.",
                                  "imageId": "f8e554c84e696427790beb0abc84ab13",
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "117315496",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117315497",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117315498",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110567664",
                                  "name": "Turai & Masoor Palak Dal!",
                                  "category": "Curated Nourishing Plates",
                                  "description": "Turai (ridge gourd) and chana dal cooked in a simple tadka of jeera and spices, served along with palak-masoor dal. Comes with your choice of grain or 3 chapatis. Good for one. Energy : 158.72 Kcal.",
                                  "imageId": "ee1726efdce1f3fd744b81c0efcb9fdc",
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "111852823",
                                      "groupName": "Choose your Grain",
                                      "choices": [
                                        {
                                          "id": "100391707",
                                          "name": "Jeera Millets",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391709",
                                          "name": "Palak Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391710",
                                          "name": "Ajwaini Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391711",
                                          "name": "Whole Wheat Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "111852822",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852824",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852825",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110567653",
                                  "name": "Gajar Matar & Masoor Palak Dal!",
                                  "category": "Curated Nourishing Plates",
                                  "description": "Classic carrot-peas sabzi, alongside whole masoor dal cooked with palak and simple spices. Enjoy with your choice of grain or 3 chapatis. This combination is good for one! Contains milk & wheat (Palak Chapati). Energy : 142.43 Kcal.",
                                  "imageId": "2c9e23f55ef64dcee75a04ecdc8aa47b",
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "111852799",
                                      "groupName": "Choose your Grain",
                                      "choices": [
                                        {
                                          "id": "100391707",
                                          "name": "Jeera Millets",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391709",
                                          "name": "Palak Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391710",
                                          "name": "Ajwaini Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391711",
                                          "name": "Whole Wheat Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "111852798",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852800",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852801",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110567646",
                                  "name": "Chatpata Sprouts with Beans Carrot Poriyal & Masoor Palak Dal!",
                                  "category": "Curated Nourishing Plates",
                                  "description": "Crunchy sprouts in a spicy-tangy masala, paired with beans-carrot sauteed with shredded coconuts and whole masoor dal. This powerhouse meal for one is served with your choice of grain or 3 chapatis. Energy : 209.21 Kcal.",
                                  "imageId": "5e268818f870e1f8a1a743cfafcaf3ea",
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "111852791",
                                      "groupName": "Choose your Grain",
                                      "choices": [
                                        {
                                          "id": "100391707",
                                          "name": "Jeera Millets",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391709",
                                          "name": "Palak Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391710",
                                          "name": "Ajwaini Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391711",
                                          "name": "Whole Wheat Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "111852790",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852792",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852793",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-vegetarian Meals",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127350745",
                                  "name": "Bhuna Chicken Tamatar Curry with Brown Rice",
                                  "category": "Curated Nourishing Plates",
                                  "description": "A wholesome meal with succulent chicken in a with mildly spicy and creamy tomato-onion gravy, served with jeera flavoured brown rice.",
                                  "imageId": "6b51c3a4eeccb4fba096847ca46e909c",
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "120137466",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "120137467",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "120137468",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101441549",
                                  "name": "Anda Masala & Masoor Palak Dal",
                                  "category": "Curated Nourishing Plates",
                                  "description": "Two boiled eggs in tomato-onion gravy, alongside whole masoor dal. Served with your choice of grain or 3 chapatis. An egg protein-packed plate for one. Contains egg, milk & wheat (Palak Chapati). Energy : 281.4 Kcal. (580 gms).",
                                  "imageId": "22711efb64669db1369b483d2b563f23",
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "111852713",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "100391698",
                                          "name": "Ragi Coconut Ladoo (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391699",
                                          "name": "Til & Jaggery Ladoo (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391700",
                                          "name": "Moong Dal and Jaggery Halwa",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391701",
                                          "name": "Pumpkin and Jaggery Halwa",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852715",
                                      "groupName": "Choose your Grain",
                                      "choices": [
                                        {
                                          "id": "100391707",
                                          "name": "Jeera Millets",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391709",
                                          "name": "Palak Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391710",
                                          "name": "Ajwaini Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391711",
                                          "name": "Whole Wheat Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "111852714",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852716",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852717",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "160 ratings",
                                      "ratingCountV2": "160"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110567645",
                                  "name": "Anda Masala with Gajar Matar & Masoor Palak Dal!",
                                  "category": "Curated Nourishing Plates",
                                  "description": "Boiled eggs in a tomato-onion curry, accompanied with carrot-peas sabzi and whole masoor dal. Served with your choice of grain or 3 chapatis. A delicious meal for one. Contains egg, milk & wheat (Palak Chapati). Energy : 320.9 Kcal.",
                                  "imageId": "2ae03a07ec1f4fe3f44033f875cfb806",
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "111852787",
                                      "groupName": "Choose your Grain",
                                      "choices": [
                                        {
                                          "id": "100391707",
                                          "name": "Jeera Millets",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391709",
                                          "name": "Palak Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391710",
                                          "name": "Ajwaini Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391711",
                                          "name": "Whole Wheat Chapati (3 Rotis)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "111852786",
                                      "groupName": "Extra Veggies",
                                      "choices": [
                                        {
                                          "id": "100391702",
                                          "name": "Chatpata Sprouts",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391703",
                                          "name": "Gajar Matar Sabzi",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391705",
                                          "name": "Turai Chana Dal",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852788",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "100391694",
                                          "name": "Buttermilk",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111852789",
                                      "groupName": "Add Ons",
                                      "choices": [
                                        {
                                          "id": "100391695",
                                          "name": "Cucumber Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391696",
                                          "name": "Roasted Papad",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100391697",
                                          "name": "Onion Circles",
                                          "price": 1900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Full Meal Nourishing Plates",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127535679",
                              "name": "Chole Paneer with Gajar matar & Masoor Palak Dal + Choice of Guiltfree Dessert",
                              "category": "Full Meal Nourishing Plates",
                              "description": "Paneer chunks in Cholewholesome meal served with your choice of grain or 3 chapati, and a guilt-free, accompanied with carrot-peas sabzi and whole masoor dal. A simple, yet wholesome meal served with your choice of grain or 3 chapati, and a choice of guiltfree dessert. Indulgence for one. Contains milk & wheat (Palak Chapati).",
                              "imageId": "285eb4b9f050b76b6778b0164c648aa4",
                              "isVeg": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120766525",
                                  "groupName": "Choice of Guiltfree Dessert",
                                  "choices": [
                                    {
                                      "id": "100391740",
                                      "name": "Moong Dal Halwa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391741",
                                      "name": "Pumpkin Jaggery Halwa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391742",
                                      "name": "Till & Jaggery Ladoo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391743",
                                      "name": "Ragi Coconut Ladoo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "121872351",
                                  "groupName": "Choose your Grain",
                                  "choices": [
                                    {
                                      "id": "100391707",
                                      "name": "Jeera Millets",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391709",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391710",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391711",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114679372",
                              "name": "Anda Masala with Gajar Matar & Masoor Palak Dal + Choice of Guiltfree Dessert",
                              "category": "Full Meal Nourishing Plates",
                              "description": "Boiled eggs in a tomato-onion curry, accompanied with carrot-peas sabzi and whole masoor dal. Served with your choice of grain or 3 chapatis, and a choice of guiltfree dessert. A delicious meal for one. Contains egg, milk & wheat (Palak Chapati).",
                              "imageId": "663e8058bc67a5456bb17cfedf42f19f",
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111852826",
                                  "groupName": "Choice of Guiltfree Dessert",
                                  "choices": [
                                    {
                                      "id": "100391740",
                                      "name": "Moong Dal Halwa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391741",
                                      "name": "Pumpkin Jaggery Halwa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391742",
                                      "name": "Till & Jaggery Ladoo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391743",
                                      "name": "Ragi Coconut Ladoo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111852827",
                                  "groupName": "Choose your Grain",
                                  "choices": [
                                    {
                                      "id": "100391707",
                                      "name": "Jeera Millets",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391709",
                                      "name": "Palak Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391710",
                                      "name": "Ajwaini Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100391711",
                                      "name": "Whole Wheat Chapati (3 Rotis)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides & Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441578",
                              "name": "Roasted Papad",
                              "category": "Sides & Beverages",
                              "description": "Energy : 46.48 Kcal. (12 gms).",
                              "imageId": "d333361dc3cb83628ad82ebb1789a8b1",
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441579",
                              "name": "Onion Circles",
                              "category": "Sides & Beverages",
                              "description": "Energy : 14 Kcal. (60 gms).",
                              "imageId": "c92d884ecd6897d16bad4126c82abfd1",
                              "isVeg": 1,
                              "price": 1900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441577",
                              "name": "Cucumber Raita",
                              "category": "Sides & Beverages",
                              "description": "Energy : 50.72 Kcal. (90 gms).",
                              "imageId": "be15a3645024f772784bd94875a1b8b2",
                              "isVeg": 1,
                              "price": 2500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101441565",
                              "name": "Buttermilk",
                              "category": "Sides & Beverages",
                              "description": "Beat the summer heat with our refreshing and tasty buttermilk . I am sure you would love it! Contains milk. Energy : 87 Kcal. (300 gms).",
                              "imageId": "7ed231c68ef39b990bd05d436131a5f8",
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221333002431"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Soul Rasa",
                      "area": "Shanti Nagar",
                      "completeAddress": "The Bowl Company, # 299,1st Floor, BBMP ward no 117, Akkithimanahalli , Shanthinagar, Bangalore 560025."
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "esffzPtYT8I2-0oz5N4MoGwI8enuqL05hpuC4tHc"
},
// 20240105233609
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=3434&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "3434",
              "name": "Nandhini Deluxe",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "hotel-nandhini-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "dlt4ml0id5wei4yi840b",
              "locality": "St. Marks Road",
              "areaName": "St Marks Road",
              "costForTwo": "50000",
              "costForTwoMessage": "₹500 for two",
              "cuisines": [
                "Andhra",
                "Biryani"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "3434",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4500
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4500,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.8 kms | ₹45 Delivery fee will apply"
              },
              "parentId": "2451",
              "avgRatingString": "4.3",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "3434",
                "deliveryTime": 31,
                "minDeliveryTime": 31,
                "maxDeliveryTime": 31,
                "lastMileTravel": 0.9,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "31 MINS",
                "lastMileTravelString": "0.8 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-05 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off up to ₹40 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "hotel-nandhini-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": " #22, 1st floor, St Marks Road, Shanthala nagar , Ashok Nagar, Bangalore -560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Andhra,Biryani"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "10% off",
                "shortDescriptionList": [
                  {
                    "meta": "10% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "10% off up to ₹40 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off | Use code PARTY",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 630,
                  "maxValue": 900,
                  "priority": 2,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 15
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 15% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 15% off",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 349,
                  "maxValue": 499,
                  "priority": 3,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/3434"
              },
              "expectationNotifiers": [
                {
                  "text": "0.8 kms | ₹45 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>0.8 kms</b> | ₹45 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "imageId": "trending_solid",
                  "fontColor": "#7E808C",
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9716764,77.6009391"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "10% OFF UPTO ₹40",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "88080be4-c93b-4d5e-89b1-30bde0baf8b4"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹159",
                      "offerType": "offers",
                      "restId": "3434",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 15% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "04bd9e82-6759-4f1d-a11f-d4587cc4230f"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹900",
                      "offerType": "offers",
                      "restId": "3434",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "c059dd32-a20c-422a-be9f-7eeac7ee4133"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "3434",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "3434",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "3434",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101089755",
                              "name": "Andhra Chicken Biryani",
                              "category": "Truly Andhra Biryani.",
                              "description": "Serve for 2 | it is fiery and aromatic, a spiced mix of succulant tender chicken and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                              "imageId": "b7df40343b2a9df3f275024aff13d5df",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109499538",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "99107966",
                                      "name": "Pepsi ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107965",
                                      "name": "Mirinda",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107964",
                                      "name": "Mineral Water 1 Ltr",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107963",
                                      "name": "7 Up ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499539",
                                  "groupName": "Choice Of Desserts",
                                  "choices": [
                                    {
                                      "id": "99107967",
                                      "name": "Gulab Jamun",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107969",
                                      "name": "Matka Ras",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107968",
                                      "name": "Matka Gulla",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107970",
                                      "name": "Rasmalai",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499540",
                                  "groupName": "Choice Of Accompaniments",
                                  "choices": [
                                    {
                                      "id": "99107973",
                                      "name": "Curd",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107972",
                                      "name": "Boiled Egg",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107975",
                                      "name": "Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107974",
                                      "name": "Green Salad",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107971",
                                      "name": "Beeda (Maghai)",
                                      "price": 3900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499542",
                                  "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "99107988",
                                      "name": "Gobi 65 - Half Portion",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107987",
                                      "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107991",
                                      "name": "Paneer Sholay Kebab - Half Portion",
                                      "price": 15500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107990",
                                      "name": "Mushroom Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107981",
                                      "name": "Andhra Chicken Kebab - Half Portion",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107984",
                                      "name": "Baby Corn Pudina Dry - Half Portion",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107983",
                                      "name": "Baby Corn Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107985",
                                      "name": "Chicken French Fry - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107989",
                                      "name": "Guntur Chicken Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107982",
                                      "name": "Andhra Chilli Chicken - Half Portion",
                                      "price": 16000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107986",
                                      "name": "Chicken Lollipop Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 11,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "255 ratings",
                                  "ratingCountV2": "255"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109374873",
                              "name": "Andhra Mutton Biryani",
                              "category": "Truly Andhra Biryani.",
                              "description": "Serve for 2 | it is fiery and aromatic, a spiced mix of succulant lamb and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                              "imageId": "epljftggczbi9rzbawpt",
                              "inStock": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109499493",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "99107966",
                                      "name": "Pepsi ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107965",
                                      "name": "Mirinda",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107964",
                                      "name": "Mineral Water 1 Ltr",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107963",
                                      "name": "7 Up ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499494",
                                  "groupName": "Choice Of Desserts",
                                  "choices": [
                                    {
                                      "id": "99107967",
                                      "name": "Gulab Jamun",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107969",
                                      "name": "Matka Ras",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107968",
                                      "name": "Matka Gulla",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107970",
                                      "name": "Rasmalai",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499495",
                                  "groupName": "Choice Of Accompaniments",
                                  "choices": [
                                    {
                                      "id": "99107973",
                                      "name": "Curd",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107972",
                                      "name": "Boiled Egg",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107975",
                                      "name": "Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107974",
                                      "name": "Green Salad",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107971",
                                      "name": "Beeda (Maghai)",
                                      "price": 3900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499497",
                                  "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "99107988",
                                      "name": "Gobi 65 - Half Portion",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107987",
                                      "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107991",
                                      "name": "Paneer Sholay Kebab - Half Portion",
                                      "price": 15500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107990",
                                      "name": "Mushroom Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107981",
                                      "name": "Andhra Chicken Kebab - Half Portion",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107984",
                                      "name": "Baby Corn Pudina Dry - Half Portion",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107983",
                                      "name": "Baby Corn Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107985",
                                      "name": "Chicken French Fry - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107989",
                                      "name": "Guntur Chicken Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107982",
                                      "name": "Andhra Chilli Chicken - Half Portion",
                                      "price": 16000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107986",
                                      "name": "Chicken Lollipop Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 11,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "174 ratings",
                                  "ratingCountV2": "174"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68711311",
                              "name": "Premier Chicken Biryani Boneless",
                              "category": "Truly Andhra Biryani.",
                              "description": "Serve for 2 | a nandhini speciality boneless version …seasoned long grain basumati rice flavored fragrant spices sucha as saffron and layered with personaly handpickeds superior boneless chicken finished with home made thick gravy,our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                              "imageId": "wdjabuco4mhrql5jqt2a",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109499543",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "99107966",
                                      "name": "Pepsi ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107965",
                                      "name": "Mirinda",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107964",
                                      "name": "Mineral Water 1 Ltr",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107963",
                                      "name": "7 Up ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499544",
                                  "groupName": "Choice Of Desserts",
                                  "choices": [
                                    {
                                      "id": "99107967",
                                      "name": "Gulab Jamun",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107969",
                                      "name": "Matka Ras",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107968",
                                      "name": "Matka Gulla",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107970",
                                      "name": "Rasmalai",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499545",
                                  "groupName": "Choice Of Accompaniments",
                                  "choices": [
                                    {
                                      "id": "99107973",
                                      "name": "Curd",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107972",
                                      "name": "Boiled Egg",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107975",
                                      "name": "Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107974",
                                      "name": "Green Salad",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107971",
                                      "name": "Beeda (Maghai)",
                                      "price": 3900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499547",
                                  "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "99107988",
                                      "name": "Gobi 65 - Half Portion",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107987",
                                      "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107991",
                                      "name": "Paneer Sholay Kebab - Half Portion",
                                      "price": 15500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107990",
                                      "name": "Mushroom Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107981",
                                      "name": "Andhra Chicken Kebab - Half Portion",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107984",
                                      "name": "Baby Corn Pudina Dry - Half Portion",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107983",
                                      "name": "Baby Corn Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107985",
                                      "name": "Chicken French Fry - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107989",
                                      "name": "Guntur Chicken Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107982",
                                      "name": "Andhra Chilli Chicken - Half Portion",
                                      "price": 16000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107986",
                                      "name": "Chicken Lollipop Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 11,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "218 ratings",
                                  "ratingCountV2": "218"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101089835",
                              "name": "Andhra Mutton Biryani Family Pack",
                              "category": "Truly Andhra Biryani.",
                              "description": "Serve for 3 | it is fiery and aromatic, a spiced mix of succulant lamb and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. Served with three portion size of andhra mutton biryani, gravy & raita. ",
                              "imageId": "f7d74df9aa5e9c868424a33cca54cf37",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109499402",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "99107966",
                                      "name": "Pepsi ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107965",
                                      "name": "Mirinda",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107964",
                                      "name": "Mineral Water 1 Ltr",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107963",
                                      "name": "7 Up ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499406",
                                  "groupName": "Choice Of Desserts",
                                  "choices": [
                                    {
                                      "id": "99107967",
                                      "name": "Gulab Jamun",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107969",
                                      "name": "Matka Ras",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107968",
                                      "name": "Matka Gulla",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107970",
                                      "name": "Rasmalai",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499408",
                                  "groupName": "Choice Of Accompaniments",
                                  "choices": [
                                    {
                                      "id": "99107973",
                                      "name": "Curd",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107972",
                                      "name": "Boiled Egg",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107975",
                                      "name": "Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107974",
                                      "name": "Green Salad",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107971",
                                      "name": "Beeda (Maghai)",
                                      "price": 3900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499415",
                                  "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "99107988",
                                      "name": "Gobi 65 - Half Portion",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107987",
                                      "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107991",
                                      "name": "Paneer Sholay Kebab - Half Portion",
                                      "price": 15500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107990",
                                      "name": "Mushroom Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107981",
                                      "name": "Andhra Chicken Kebab - Half Portion",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107984",
                                      "name": "Baby Corn Pudina Dry - Half Portion",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107983",
                                      "name": "Baby Corn Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107985",
                                      "name": "Chicken French Fry - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107989",
                                      "name": "Guntur Chicken Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107982",
                                      "name": "Andhra Chilli Chicken - Half Portion",
                                      "price": 16000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107986",
                                      "name": "Chicken Lollipop Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 11,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101089808",
                              "name": "Andhra Chicken Biryani Family Pack",
                              "category": "Truly Andhra Biryani.",
                              "description": "Serve for 3 | it is fiery and aromatic, a spiced mix of succulant tender chicken and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. Served with three portion size of andhra chicken biryani, gravy & raita",
                              "imageId": "ad308539df5f8a532ff50b23e72070bb",
                              "inStock": 1,
                              "price": 109900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109499323",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "99107966",
                                      "name": "Pepsi ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107965",
                                      "name": "Mirinda",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107964",
                                      "name": "Mineral Water 1 Ltr",
                                      "price": 2900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107963",
                                      "name": "7 Up ",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499325",
                                  "groupName": "Choice Of Desserts",
                                  "choices": [
                                    {
                                      "id": "99107967",
                                      "name": "Gulab Jamun",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107969",
                                      "name": "Matka Ras",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107968",
                                      "name": "Matka Gulla",
                                      "price": 11900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107970",
                                      "name": "Rasmalai",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499327",
                                  "groupName": "Choice Of Accompaniments",
                                  "choices": [
                                    {
                                      "id": "99107973",
                                      "name": "Curd",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107972",
                                      "name": "Boiled Egg",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107975",
                                      "name": "Raita",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107974",
                                      "name": "Green Salad",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107971",
                                      "name": "Beeda (Maghai)",
                                      "price": 3900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109499332",
                                  "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                  "choices": [
                                    {
                                      "id": "99107988",
                                      "name": "Gobi 65 - Half Portion",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107987",
                                      "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107991",
                                      "name": "Paneer Sholay Kebab - Half Portion",
                                      "price": 15500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107990",
                                      "name": "Mushroom Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107981",
                                      "name": "Andhra Chicken Kebab - Half Portion",
                                      "price": 16000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107984",
                                      "name": "Baby Corn Pudina Dry - Half Portion",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107983",
                                      "name": "Baby Corn Pepper Dry - Half Portion",
                                      "price": 15000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107985",
                                      "name": "Chicken French Fry - Half Portion",
                                      "price": 16500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107989",
                                      "name": "Guntur Chicken Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107982",
                                      "name": "Andhra Chilli Chicken - Half Portion",
                                      "price": 16000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99107986",
                                      "name": "Chicken Lollipop Dry - Half Portion",
                                      "price": 16500,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 11,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "102 ratings",
                                  "ratingCountV2": "102"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "71316613",
                              "name": "Andhra Mutton Biryani With Mutton Fry Box",
                              "category": "Express Biryani Combos.",
                              "description": "Serve for 1 | a compact food box for one person, which includes andhra mutton biryani, andhra mutton fry, gravy and raita. Packed in 4 compartment meal tray. ",
                              "imageId": "fmbm7boskilzhipmnlra",
                              "inStock": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5330921",
                              "name": "Gobi 65",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | a signture preparation of the house",
                              "imageId": "pogfqcycmr4a9o9obph2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68426458",
                              "name": "Baby Corn 65",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | a signture preparation of the house",
                              "imageId": "acph8yyes8brpsaqz4jo",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.3",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83269794",
                              "name": "Mushroom Pepper Dry",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | a signture preparation of the house",
                              "imageId": "feip24j7ludxwnaflenm",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68426464",
                              "name": "Chicken Sholay Kebab",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | batter fried chicken sauteed and tossed with yogurt sauce and rich spices. ",
                              "imageId": "inrznoe9vixbcb5gwlfd",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "129 ratings",
                                  "ratingCountV2": "129"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83226831",
                              "name": "Andhra Chicken Kebab",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | marinated chicken chunks & fried chicken pieces",
                              "imageId": "smr8ewfsqotiui3j9zwo",
                              "inStock": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "5330981",
                              "name": "Chicken Manchurian Dry",
                              "category": "Nandhini Super Hit Starters.",
                              "description": "Serve for 1 | manchurian is a class of chinese dish made by roughly chopping and deep-fried battered chicken piece , and saut?eing it in a sauce flavored with soy sauce",
                              "imageId": "zfp2k7ted1ftz9svkmki",
                              "inStock": 1,
                              "price": 32900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94851901",
                                  "groupName": "Addon (Chicken Manchurian )",
                                  "choices": [
                                    {
                                      "id": "92429635",
                                      "name": "Chicken Fried Rice",
                                      "price": 27900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92429636",
                                      "name": "Veg Fried Rice",
                                      "price": 24900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92429637",
                                      "name": "Curd Rice",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "94851902",
                                  "groupName": "Choice Of Beverages",
                                  "choices": [
                                    {
                                      "id": "92429613",
                                      "name": "Pepsi (250 Ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92429614",
                                      "name": "Pepsi  (500ml)",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "16919914",
                              "name": "Paneer Sholay Kebab",
                              "category": "Nandhini's Super Hit Starters",
                              "description": "Serve for 2 | a signture preparation of the house",
                              "imageId": "yzdzj9rtaxuerpsea6vi",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.8",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Truly Andhra Biryani.",
                      "categories": [
                        {
                          "title": "Veg Biryani (Serves 2)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101090003",
                                  "name": "Paneer Biryani",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | a nandhini speciality paneer biryani version …seasoned long grain basumati rice flavored fragrant spices sucha as saffron and layered with fried onion and paneer finished with home made thick gravy and served with gravy and raita. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "imageId": "eb8ce727f881b34708b4e16b227eb5f1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499469",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499470",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499471",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499476",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "161 ratings",
                                      "ratingCountV2": "161"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089682",
                                  "name": "Mushroom Biryani",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | a nandhini speciality mushroom biryani version …seasoned long grain basumati rice flavored fragrant spices sucha as saffron and layered withfried onion and mushroom finished with home made thick gravy and served with gravy and raita. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499441",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499442",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499443",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499445",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-veg Biryani (Serves 2)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089755",
                                  "name": "Andhra Chicken Biryani",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | it is fiery and aromatic, a spiced mix of succulant tender chicken and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "imageId": "b7df40343b2a9df3f275024aff13d5df",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499538",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499539",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499540",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499542",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "255 ratings",
                                      "ratingCountV2": "255"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109374873",
                                  "name": "Andhra Mutton Biryani",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | it is fiery and aromatic, a spiced mix of succulant lamb and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "imageId": "epljftggczbi9rzbawpt",
                                  "inStock": 1,
                                  "price": 40500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499493",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499494",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499495",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499497",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "174 ratings",
                                      "ratingCountV2": "174"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68711311",
                                  "name": "Premier Chicken Biryani Boneless",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | a nandhini speciality boneless version …seasoned long grain basumati rice flavored fragrant spices sucha as saffron and layered with personaly handpickeds superior boneless chicken finished with home made thick gravy,our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "imageId": "wdjabuco4mhrql5jqt2a",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499543",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499544",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499545",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499547",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "218 ratings",
                                      "ratingCountV2": "218"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330909",
                                  "name": "Egg Biryani",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 2 | a nandhini speciality egg biryani version seasoned long grain basumati rice flavored fragrant spices sucha as saffron and layered withfried onion and mushroom finished with home made thick gravy and served with gravy and raita. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. ",
                                  "imageId": "07900288319c46d5728082a457f02e07",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499503",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499504",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499505",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499509",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "216 ratings",
                                      "ratingCountV2": "216"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Veg Biryani Family Pack (Serves 3)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101090076",
                                  "name": "Paneer Biryani Family Pack",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 3 | aromatic rice packed with marinated paneer and whole spices to create the best comfort food and serve with three portion size of paneer biryani, gravy and raita. ",
                                  "imageId": "ywlzcqxhxjpjtyha1ovz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499453",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499455",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499456",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499459",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089982",
                                  "name": "Mushroom Biryani Family Pack",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 3 | mushroom biryani is the classic vegetarian version of biryani with meaty mushrooms, jeerasamba rice and flavourful spices and herbs and serve with three portion size of mushroom biryani, gravy and raita. ",
                                  "imageId": "ywlzcqxhxjpjtyha1ovz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 89900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499381",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499384",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499387",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499394",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Biryani Family Pack (Serves 3)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089835",
                                  "name": "Andhra Mutton Biryani Family Pack",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 3 | it is fiery and aromatic, a spiced mix of succulant lamb and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. Served with three portion size of andhra mutton biryani, gravy & raita. ",
                                  "imageId": "f7d74df9aa5e9c868424a33cca54cf37",
                                  "inStock": 1,
                                  "price": 119900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499402",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499406",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499408",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499415",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089808",
                                  "name": "Andhra Chicken Biryani Family Pack",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "Serve for 3 | it is fiery and aromatic, a spiced mix of succulant tender chicken and rice , traditional cooked over an open fire and dum preparation. Our biryanis are very popular because of its rich flavour. It is a hearty meal that one can enjoy at any hour of the day or night. It is appealing to every palate and age group that is our succees since three decades. Served with three portion size of andhra chicken biryani, gravy & raita",
                                  "imageId": "ad308539df5f8a532ff50b23e72070bb",
                                  "inStock": 1,
                                  "price": 109900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499323",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499325",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499327",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499332",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "102 ratings",
                                      "ratingCountV2": "102"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "70596602",
                                  "name": "Premier Chicken Biryani Boneless Family Pack",
                                  "category": "Truly Andhra Biryani.",
                                  "description": "A nandhini speciality boneless version easoned long grain basumati rice flavored fragrant spices sucha as saffron and layered with personaly handpickeds superior boneless chicken finished with home made thick gravy, served with three portion size of premier chicken biryani bonless biryani, gravy and raita. ",
                                  "imageId": "wiyxitr8sql4hzphyvqc",
                                  "inStock": 1,
                                  "price": 109900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109499313",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "99107966",
                                          "name": "Pepsi ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107965",
                                          "name": "Mirinda",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107964",
                                          "name": "Mineral Water 1 Ltr",
                                          "price": 2900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107963",
                                          "name": "7 Up ",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499315",
                                      "groupName": "Choice Of Desserts",
                                      "choices": [
                                        {
                                          "id": "99107967",
                                          "name": "Gulab Jamun",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107969",
                                          "name": "Matka Ras",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107968",
                                          "name": "Matka Gulla",
                                          "price": 11900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107970",
                                          "name": "Rasmalai",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499317",
                                      "groupName": "Choice Of Accompaniments",
                                      "choices": [
                                        {
                                          "id": "99107973",
                                          "name": "Curd",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107972",
                                          "name": "Boiled Egg",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107975",
                                          "name": "Raita",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107974",
                                          "name": "Green Salad",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107971",
                                          "name": "Beeda (Maghai)",
                                          "price": 3900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109499321",
                                      "groupName": "Choice Of Super Hits Veg And Non Veg Starters",
                                      "choices": [
                                        {
                                          "id": "99107988",
                                          "name": "Gobi 65 - Half Portion",
                                          "price": 13500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107987",
                                          "name": "Chicken Sholay Kebab Boneless - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107991",
                                          "name": "Paneer Sholay Kebab - Half Portion",
                                          "price": 15500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107990",
                                          "name": "Mushroom Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107981",
                                          "name": "Andhra Chicken Kebab - Half Portion",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107984",
                                          "name": "Baby Corn Pudina Dry - Half Portion",
                                          "price": 14500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107983",
                                          "name": "Baby Corn Pepper Dry - Half Portion",
                                          "price": 15000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107985",
                                          "name": "Chicken French Fry - Half Portion",
                                          "price": 16500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107989",
                                          "name": "Guntur Chicken Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107982",
                                          "name": "Andhra Chilli Chicken - Half Portion",
                                          "price": 16000,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99107986",
                                          "name": "Chicken Lollipop Dry - Half Portion",
                                          "price": 16500,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 11,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Express Biryani Combos.",
                      "categories": [
                        {
                          "title": "Non Veg Combo Boxes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71316613",
                                  "name": "Andhra Mutton Biryani With Mutton Fry Box",
                                  "category": "Express Biryani Combos.",
                                  "description": "Serve for 1 | a compact food box for one person, which includes andhra mutton biryani, andhra mutton fry, gravy and raita. Packed in 4 compartment meal tray. ",
                                  "imageId": "fmbm7boskilzhipmnlra",
                                  "inStock": 1,
                                  "price": 44900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71317426",
                                  "name": "Andhra Chicken Biryani With Chicken Fry Box",
                                  "category": "Express Biryani Combos.",
                                  "description": "Serve for 1 | a compact food box for one person, which includes andhra chicken biryani , andhra chicken fry ,gravy and raita. Packed in 4 compartment meals tray. ",
                                  "imageId": "cec2igzlbhgieqdjtpyd",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "50 ratings",
                                      "ratingCountV2": "50"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71317428",
                                  "name": "Andhra Chicken Biryani With Mutton Fry Box",
                                  "category": "Express Biryani Combos.",
                                  "description": "Serve for 1 | a compact food box for 1 person, which includes andhra chicken biryani, chicken sholay kebab,gravy and raita. Packed in 4 cp meal tray",
                                  "imageId": "fmbm7boskilzhipmnlra",
                                  "inStock": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Nandhini Super Hit Starters.",
                      "categories": [
                        {
                          "title": "Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330924",
                                  "name": "Carrot 65",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "eibrdwz8nd1c3hejp6kp",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330921",
                                  "name": "Gobi 65",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "pogfqcycmr4a9o9obph2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269787",
                                  "name": "Gobi Sholay Kebab",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "da3888f4a305740b52b0e8392d30e82f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939250",
                                  "name": "Gobi Pudhina Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "rwokiwvvthmfbykdimqn",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269795",
                                  "name": "Gobi Pepper Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "ztmwofzspjh44hfsnsuf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426458",
                                  "name": "Baby Corn 65",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "acph8yyes8brpsaqz4jo",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.3",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939251",
                                  "name": "Baby Corn Sholay Kebab",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "ebaa6681f3ac92b7f16a4d70ce66acf0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "34495820",
                                  "name": "Baby Corn Pepper Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "i1ifhrhuxt2xiqwnvr9o",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 31900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269790",
                                  "name": "Baby Corn Pudina Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "ibyplts87dbemh6csz65",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.4",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269794",
                                  "name": "Mushroom Pepper Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "feip24j7ludxwnaflenm",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330915",
                                  "name": "Paneer Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | fresh cubes of cottage cheese battered and deep fried finshed with manchurian sauce",
                                  "imageId": "b2mgaw6mfy8raptienf8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "59 ratings",
                                      "ratingCountV2": "59"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269824",
                                  "name": "Gobi Tikka",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | skewered fresh marinated caulif;lower cooked in clay pot",
                                  "imageId": "nay7wstuvhu7xmpslikg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330911",
                                  "name": "Gobi Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "epdyeultyj9ip0wlbstx",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "178 ratings",
                                      "ratingCountV2": "178"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939254",
                                  "name": "Gobi Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | chilly is a class of chinese dish made by roughly chopping and deep-frying cauliflower, and then sautéeing it in a sauce flavored with soy sauce",
                                  "imageId": "pogfqcycmr4a9o9obph2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68756375",
                                  "name": "Baby Corn Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signture preparation of the house",
                                  "imageId": "258c88ac18c9e0be86f5e0d5746a645f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109373604",
                                  "name": "Baby Corn Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | deep fried baby corn finished with spicy masala with green chilly",
                                  "imageId": "71682bda130b323e7f5a00d0aa776906",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330917",
                                  "name": "Mushroom Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | manchurian is a class of chinese dish made by roughly chopping and deep-fried button mushrooms,and then sautéeing it in a sauce flavored with soy sauce",
                                  "imageId": "jb29ywnsasebz6elq8rc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330918",
                                  "name": "Mushroom Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | battered button of fresh mushroom finished with flavored full masala and green chilly",
                                  "imageId": "b8c5ba0a1aa4a319a9990e52bcae3262",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "13 ratings",
                                      "ratingCountV2": "13"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426456",
                                  "name": "Paneer Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | cubes fresh paneer & diced capsicum tossed with authenticaly in chinese masala",
                                  "imageId": "b2mgaw6mfy8raptienf8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Eggetarian Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939258",
                                  "name": "Andhra Egg Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | eggs cooked in real spices of telangana region",
                                  "imageId": "d0595ee189f1c08c7d9e42380d066453",
                                  "inStock": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68726704",
                                  "name": "Egg Sholay",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | batter fried eggs sauteed and tossed with yogurt sauce and rich spices. ",
                                  "imageId": "xpjuloju1ck33y9pvyyi",
                                  "inStock": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939259",
                                  "name": "Egg Omlette",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | omlette is a dish made from beaten eggs. ",
                                  "imageId": "s11hqc5bpzczqq64jl0y",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939260",
                                  "name": "Egg Burji",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | scrambled egg",
                                  "imageId": "nthbvbdhkpynzudr91tu",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330875",
                                  "name": "Boiled Egg",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | boiled eggs",
                                  "imageId": "tznej47efjxvznjfvyw1",
                                  "inStock": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426455",
                                  "name": "Egg Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | manchurian is a class of chinese dish made by roughly chopping and deep-fried coated boiled eggs cubes,and then sautéeing it in a sauce flavored with soy sauce",
                                  "imageId": "kyunjlrku0rppvnjmami",
                                  "inStock": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426453",
                                  "name": "Egg Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | cubes eggs & diced capsicum tossed with authenticaly in chinese masala",
                                  "imageId": "b9v0sqr2zoopcicczghp",
                                  "inStock": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Chicken Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269806",
                                  "name": "Nandhini Chicken Roast (Boneless)",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | marinated and parboiled tender boneless chicken sauteed in ghee until dry, seasoned with hand pound masala and curry leaves, a classic dish of nandhini. ",
                                  "imageId": "yazhmlvr7rpwkfx9m3bc",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269807",
                                  "name": "Chicken Sixer Dry Boneless",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | batter fried boneless chicken pieces,sauteed with fresh green chillies and curry leaves. ",
                                  "imageId": "bmvgh2z7nkw0kl02n58c",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426464",
                                  "name": "Chicken Sholay Kebab",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | batter fried chicken sauteed and tossed with yogurt sauce and rich spices. ",
                                  "imageId": "inrznoe9vixbcb5gwlfd",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "129 ratings",
                                      "ratingCountV2": "129"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939239",
                                  "name": "Chicken French Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | strips of chicken breast tossed with andhra spices. ",
                                  "imageId": "89afb6a44282f3a3eaea8d4fbc4e25e9",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939240",
                                  "name": "Chicken Red Chilly Dry Boneless",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | batter fried boneless chicken pieces, sauteed with red chilly flakes and curry leaves,",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269808",
                                  "name": "Lemon Chicken Dry Boneless",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | batter fried boneless chicken pieces,sauteed with fresh lemon with onions, ginger and capsicums",
                                  "imageId": "cidoscexqwko827obwny",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82552517",
                                  "name": "Andhra Chicken Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | chicken chunks cooked in real spices of telangana region",
                                  "imageId": "uprji9jg1f4ftqemdbkc",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83226831",
                                  "name": "Andhra Chicken Kebab",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | marinated chicken chunks & fried chicken pieces",
                                  "imageId": "smr8ewfsqotiui3j9zwo",
                                  "inStock": 1,
                                  "price": 31900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "47 ratings",
                                      "ratingCountV2": "47"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330981",
                                  "name": "Chicken Manchurian Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | manchurian is a class of chinese dish made by roughly chopping and deep-fried battered chicken piece , and saut?eing it in a sauce flavored with soy sauce",
                                  "imageId": "zfp2k7ted1ftz9svkmki",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94851901",
                                      "groupName": "Addon (Chicken Manchurian )",
                                      "choices": [
                                        {
                                          "id": "92429635",
                                          "name": "Chicken Fried Rice",
                                          "price": 27900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92429636",
                                          "name": "Veg Fried Rice",
                                          "price": 24900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92429637",
                                          "name": "Curd Rice",
                                          "price": 12900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "94851902",
                                      "groupName": "Choice Of Beverages",
                                      "choices": [
                                        {
                                          "id": "92429613",
                                          "name": "Pepsi (250 Ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92429614",
                                          "name": "Pepsi  (500ml)",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426473",
                                  "name": "Chilly Chicken Boneless",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | chicken pieces & diced capsicum tossed with authenticaly in chinese masala",
                                  "imageId": "680f713b8a4e733b397977d9e5351d1c",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Mutton Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939261",
                                  "name": "Andhra Mutton Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | tender lamb pieces cooked in traditional andhra spices",
                                  "imageId": "vufuoyykkbmnmoffvv3g",
                                  "inStock": 1,
                                  "price": 41900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330889",
                                  "name": "Mutton Roast",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signature recipe with a delectable flavour of pepper embedded in the masala and mutton",
                                  "imageId": "znuvjspxr2zccyq7h5hw",
                                  "inStock": 1,
                                  "price": 41900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "43 ratings",
                                      "ratingCountV2": "43"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "71717941",
                                  "name": "Mutton Kheema Ball",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | finely minced lamb dumplings deep fried till golden brown and served",
                                  "imageId": "mx8hus8860ycad6mfiak",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269809",
                                  "name": "Mutton Pepper Fry Boneless",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | a signature recipe with a delectable flavour of pepper embedded in the masala and mutton boneless",
                                  "imageId": "ryxkbmjt1omo11kstm5v",
                                  "inStock": 1,
                                  "price": 41900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Seafood Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "84212414",
                                  "name": "Andhra Fish Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | slice of seer fish ( anjal fish) deep fried with andhra spices",
                                  "imageId": "hvgvqwj8cgltrgfkdkxb",
                                  "inStock": 1,
                                  "price": 45900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330898",
                                  "name": "Prawns Pepper Fry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | fresh prawns shallow fried, and finished with chef's special spices. ",
                                  "imageId": "koxn6whuqvx1wsivrznc",
                                  "inStock": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5331032",
                                  "name": "Fish Tikka",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | fresh mahi mahi fine cubes marinated with unique aromatic masala finished with charcol fire , its fingerlicking good, lemony and filled with flavor",
                                  "imageId": "u3vvok6fmei0sn0ayxq3",
                                  "inStock": 1,
                                  "price": 40900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108848494",
                                  "name": "Prawns Manchurian Dry",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | fresh tender prawn chinese dish made by roughly chopping and deep-fried battered prawn sautéeing it in a sauce flavored with soy sauce",
                                  "imageId": "kyunjlrku0rppvnjmami",
                                  "inStock": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939266",
                                  "name": "Prawns Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | masala soaked prawn & diced capsicum tossed with authenticaly in chinese masala",
                                  "imageId": "7b711dd83066bc44b0bf59e3b143c883",
                                  "inStock": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939267",
                                  "name": "Fish Manchurian",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | chunks of fish cubes cooked with roughly chopping and deep-fried and sautéeing it in a sauce flavored with soy sauce and manchurian sauce",
                                  "imageId": "258c88ac18c9e0be86f5e0d5746a645f",
                                  "inStock": 1,
                                  "price": 40900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426478",
                                  "name": "Fish Chilly",
                                  "category": "Nandhini Super Hit Starters.",
                                  "description": "Serve for 1 | seasoned fish & diced capsicum and tomato tossed with authenticaly in chinese masala",
                                  "imageId": "fcz7lzb2s5yqmgplxocg",
                                  "inStock": 1,
                                  "price": 40900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Main Course.",
                      "categories": [
                        {
                          "title": "Veg Main Course",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330945",
                                  "name": "Paneer Butter Masala",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | cottage cheese simmered in rich tomato &amp; butter gravy",
                                  "imageId": "05e0b0f447f02b138ac826382cd642b8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "224 ratings",
                                      "ratingCountV2": "224"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "34495806",
                                  "name": "Kadai Paneer",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | cottage cheese cubes cooked in a spicy masala with tomato & capsicum",
                                  "imageId": "qk2yciovmgjvmm9nwajv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330947",
                                  "name": "Palak Paneer",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | cubes of paneer cooked with spinach paste with aromatic gravy",
                                  "imageId": "lwxrfdqbaclxdzo80hby",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "34495808",
                                  "name": "Mushroom Masala",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | is a delicious indian curry made with fresh button mushrooms cooked with onions , tomato , spices and herbs",
                                  "imageId": "hcwazv2vqqh30qfzenik",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330933",
                                  "name": "Aloo Gobi Masala",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | simple delicious flavor packed & healthy, this spiced potato and caulifolwer stir fry one of the popular dish",
                                  "imageId": "mv1vbjaqcebz4pzqupaf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426481",
                                  "name": "Dal Fry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | simple and delicious evergreen yellow dal tempered with jeera and spices",
                                  "imageId": "jootatd1adryxx3dyy4m",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "144 ratings",
                                      "ratingCountV2": "144"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Main Course",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269810",
                                  "name": "Andhra Chicken Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | chicken is cooked in a spicy masala base with corriander leaves. ",
                                  "imageId": "rwnuslmfolbilbouq3nt",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269833",
                                  "name": "Chicken Masala",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | a nandhini speciality, ribs of lamb cooked in tangy and spicy sauce",
                                  "imageId": "sjobv41qj46thled8xdf",
                                  "inStock": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330884",
                                  "name": "Mutton Chops",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | a nandhini speciality, ribs of lamb cooked in tangy and spicy sauce",
                                  "imageId": "giint0uw2bvuqj8pfcus",
                                  "inStock": 1,
                                  "price": 41900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "153 ratings",
                                      "ratingCountV2": "153"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269811",
                                  "name": "Andhra Mutton Masala",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | mutton cooked with authentic spices from rayalaseema region",
                                  "imageId": "ety9ber8lxvrrk9d1jnz",
                                  "inStock": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269814",
                                  "name": "Andhra Prawns Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | prawn cooked with authentic spices from rayalaseema region",
                                  "imageId": "ic24v5addpxftqwo6oqd",
                                  "inStock": 1,
                                  "price": 41900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269813",
                                  "name": "Andhra Egg Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | eggs in kadai gravy ganished with green chillies and tomato",
                                  "imageId": "vnrqin11505oqzalzckd",
                                  "inStock": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426485",
                                  "name": "Butter Chicken Boneless",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | char grilled pieces of tender shredded boneless chicken cooked in rich butter &amp; tomato based gravy",
                                  "imageId": "kiqmi4ijjjyoyd6o1vxa",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269828",
                                  "name": "Kadai Chicken Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | spicy and flavored full dish made with chicken ,onions, tomato, ginger and garlic cooked with fresh ground nut kadai masala",
                                  "imageId": "q8uuiozink0srmyomynl",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269834",
                                  "name": "Methi Chicken Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 | must try dish the bitter taste of fenugreek greens complements the chicken exceptionally well. The addition of cream further mellows down the bitterness thereby adding to the rich quotient of this dish. ",
                                  "imageId": "xri0mgaqtyjn9qb72qxp",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939201",
                                  "name": "Chicken Kolapuri Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 |tender chicken pieces cooked in tipical spicy masala",
                                  "imageId": "kvuc6kypzcy3omddhtq0",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089793",
                                  "name": "Chicken Kalimirch Curry",
                                  "category": "Main Course.",
                                  "description": "Serve for 1 |boneless chicken cooked with fresh pepper corn",
                                  "imageId": "q8uuiozink0srmyomynl",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Rice And Noodles.",
                      "categories": [
                        {
                          "title": "Veg Rice And Noodles",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426490",
                                  "name": "Veg Fried Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | its an delicious meal prepared with long grain basumati rice and vegetables",
                                  "imageId": "weslqtahwbslb2adczmu",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426491",
                                  "name": "Veg Noodles",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | soft soaked noodles cooked with vegetables with authentical chinese style",
                                  "imageId": "jon99ciglr9pvhramfwi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68426492",
                                  "name": "Veg Pulao",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | long grain basumati cooked with fresh vegetable prepared in dum way",
                                  "imageId": "vur7secyfcskeangwwho",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "59 ratings",
                                      "ratingCountV2": "59"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330958",
                                  "name": "Jeera Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | longb grain basumati tempered with jeera",
                                  "imageId": "xw89cwptxhloyb5q6c38",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "51 ratings",
                                      "ratingCountV2": "51"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330956",
                                  "name": "Ghee Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | longb grain basumati tossed with ghee",
                                  "imageId": "gppfhjnx1es1r7mqtffb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "105 ratings",
                                      "ratingCountV2": "105"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330957",
                                  "name": "Curd Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | an evergreen south indian yogurt rice",
                                  "imageId": "h496eisyn8lmdeitfc4x",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "391 ratings",
                                      "ratingCountV2": "391"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Rice And Noodles",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5331002",
                                  "name": "Chicken Noodles",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | soft soaked noodles cooked with chicken with authentical chinese style",
                                  "imageId": "oe8q4bjnoe7grxst1z5v",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330997",
                                  "name": "Chicken Fried Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | its an delicious meal prepared with long grain basumati rice and boneless shredded chicken",
                                  "imageId": "yjtzup8tzgbp7fjzb5aq",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "88 ratings",
                                      "ratingCountV2": "88"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939232",
                                  "name": "Prawns Fried Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | shreded prawn prepared with long grain basumati rice cooked with authentc chinese style",
                                  "imageId": "29a40b9e8ccac50bed83269d1aa8dc04",
                                  "inStock": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939233",
                                  "name": "Prawns Noodles",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | soft soaked noodles cooked with prawn with authentical chinese style",
                                  "imageId": "dca8674d63df4b492644c4ab3d20ad8e",
                                  "inStock": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "5330996",
                                  "name": "Egg Fried Rice",
                                  "category": "Rice And Noodles.",
                                  "description": "Serve for 1 | long grain basumati cooked with beaten eggs and fla vored full masala",
                                  "imageId": "zpndegvsbzjhf7f4wipl",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "57 ratings",
                                      "ratingCountV2": "57"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Beverages.",
                      "categories": [
                        {
                          "title": "Beverages",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269856",
                                  "name": "Mirinda",
                                  "category": "Beverages.",
                                  "description": "Fizzy, fruity and refreshing soft drink that energizes your?taste?buds. ",
                                  "imageId": "gvt0ccxxikwhttip4t6b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31390183",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "250 ml",
                                            "default": 1,
                                            "id": "97237815",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 ml",
                                            "id": "97237816",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31390183",
                                            "variationId": "97237815"
                                          }
                                        ],
                                        "price": 3900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31390183",
                                            "variationId": "97237816"
                                          }
                                        ],
                                        "price": 6900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 3900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939225",
                                  "name": "Mountain Dew",
                                  "category": "Beverages.",
                                  "description": "Bold, citrusy, and energizing soft?drink. ",
                                  "imageId": "w81bffown656dr7q0rsd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31390184",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "250 ml",
                                            "default": 1,
                                            "id": "97237817",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 ml",
                                            "id": "97237818",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31390184",
                                            "variationId": "97237817"
                                          }
                                        ],
                                        "price": 3900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31390184",
                                            "variationId": "97237818"
                                          }
                                        ],
                                        "price": 6900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 3900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101089646",
                                  "name": "Pepsi",
                                  "category": "Beverages.",
                                  "description": "Classic, refreshing cola with a perfect balance of sweetness?and?bubbles. ",
                                  "imageId": "ptkotzwq0xpbfsfuokqr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23860883",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "250 ml",
                                            "default": 1,
                                            "id": "77199539",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 ml",
                                            "id": "77199540",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23860883",
                                            "variationId": "77199539"
                                          }
                                        ],
                                        "price": 3900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23860883",
                                            "variationId": "77199540"
                                          }
                                        ],
                                        "price": 6900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 3900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "83269858",
                                  "name": "7 Up",
                                  "category": "Beverages.",
                                  "imageId": "t4xolkj1ioznxdjye3pz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23860884",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "250 ml",
                                            "default": 1,
                                            "id": "77199542",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 ml",
                                            "id": "77199541",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23860884",
                                            "variationId": "77199542"
                                          }
                                        ],
                                        "price": 3900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23860884",
                                            "variationId": "77199541"
                                          }
                                        ],
                                        "price": 6900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 3900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Desserts.",
                      "categories": [
                        {
                          "title": "Sweets",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108939221",
                                  "name": "Gulab Jamun",
                                  "category": "Desserts.",
                                  "description": "Serve for 1 | it comes with 2 pcs",
                                  "imageId": "lp0apn7tgykmq8ukqjqk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Nandhini Masala - Ready To Cook Paste",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114924425",
                              "name": "Tandoori Tikka  Paste (80 Grm)",
                              "category": "Nandhini Masala - Ready To Cook Paste",
                              "description": "Ready-to-cook blend for creating mouthwatering and authentic tandoori tikka dishes. ",
                              "imageId": "012dd41cc00b075c34c28fade88e4b03",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Extra Items",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126805409",
                              "name": "Cup Curd",
                              "category": "Extra Items",
                              "description": "Fresh yogurt",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72085890",
                              "name": "Leaf",
                              "category": "Extra Items",
                              "imageId": "hyzgftcauecfadrsgpm1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111802640",
                              "name": "Appalam",
                              "category": "Extra Items",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Nandhini's Super Hit Starters",
                      "categories": [
                        {
                          "title": "Veg Starters",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "16919914",
                                  "name": "Paneer Sholay Kebab",
                                  "category": "Nandhini's Super Hit Starters",
                                  "description": "Serve for 2 | a signture preparation of the house",
                                  "imageId": "yzdzj9rtaxuerpsea6vi",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "1.8",
                                      "ratingCount": "36 ratings",
                                      "ratingCountV2": "36"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220333000001"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Nandhini Deluxe",
                      "area": "St Marks Road",
                      "completeAddress": " #22, 1st floor, St Marks Road, Shanthala nagar , Ashok Nagar, Bangalore -560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "rDabxkbhqjoH-yF0Ru7uKA8kQR64PBMlejitHUf4"
},
// 20240105233641
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=69876&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "69876",
              "name": "Subway",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "subway-central-bangalore1-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "1ace5fa65eff3e1223feb696c956b38b",
              "locality": "UB City",
              "areaName": "Ashok Nagar",
              "costForTwo": "35000",
              "costForTwoMessage": "₹350 for two",
              "cuisines": [
                "Salads",
                "Snacks"
              ],
              "avgRating": 4.2,
              "feeDetails": {
                "restaurantId": "69876",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.6 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "2",
              "avgRatingString": "4.2",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "69876",
                "deliveryTime": 39,
                "minDeliveryTime": 39,
                "maxDeliveryTime": 39,
                "lastMileTravel": 0.6,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "39 MINS",
                "lastMileTravelString": "0.6 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 9 am, tomorrow",
                "nextOpenTime": "2024-01-06 09:00:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "30% off",
                "shortDescriptionList": [
                  {
                    "meta": "30% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "30% off up to ₹75 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "subway-central-bangalore1-central-bangalore",
              "multiOutlet": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Ubcity 2nd level Vital mallya Road Bangalore"
                },
                {
                  "title": "Cuisines",
                  "message": "Salads,Snacks"
                }
              ],
              "logo": "v1675752975/Brand logo/Subway",
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "30% off",
                "shortDescriptionList": [
                  {
                    "meta": "30% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "30% off up to ₹75 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/69876"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 9 am, tomorrow",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 9:00 AM tomorrow",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "nearestOutletNudge": {
                "nearestOutletInfo": {
                  "siblingOutlet": {
                    "id": "672074",
                    "city": "0",
                    "slugs": {
                      
                    },
                    "areaName": "Sobha Mall",
                    "costForTwo": "0",
                    "feeDetails": {
                      
                    },
                    "sla": {
                      "deliveryTime": 28,
                      "lastMileTravel": 1.6,
                      "slaString": "28 MINS",
                      "lastMileTravelString": "1.6 km",
                      "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                      "restaurantClosedMeta": {
                        
                      }
                    },
                    "aggregatedDiscountInfo": {
                      "visible": true
                    },
                    "badges": {
                      
                    },
                    "aggregatedDiscountInfoV2": {
                      "visible": true
                    },
                    "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                    "cartOrderabilityNudgeBanner": {
                      "parameters": {
                        
                      },
                      "presentation": {
                        
                      }
                    }
                  }
                },
                "nearestOutletComms": {
                  "title": {
                    "text": "Don't worry! Try our outlet that's delivering"
                  },
                  "subTitle": {
                    "text": "Switch to the fastest alternate"
                  }
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.971785957440407,77.59616766124964"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "30% OFF UPTO ₹75",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "29fc32b9-2c53-4534-92e7-3eeb9c5b92b2"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹159",
                      "offerType": "offers",
                      "restId": "69876",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "69876",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "69876",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "69876",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "69876",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                      "categories": [
                        {
                          "title": "Grills - Combos (Save upto 46%)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666284",
                                  "name": "Delhi Tikki Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink and a cookie or veg kebabs.",
                                  "imageId": "3b1bb2e4ab7a6f145d675e811b4ee0a3",
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272756",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454255",
                                          "name": "Delhi Tikki 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272757",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272758",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454268",
                                          "name": "Extra Delhi Patty",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272759",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272760",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272761",
                                      "groupName": "Choose From Offers @99 for Delhi Tikki Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666286",
                                  "name": "Bombay Grill Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink and a cookie or veg kebabs.",
                                  "imageId": "6f6f6cdda05e7a857f18bd8459f231ce",
                                  "isVeg": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272762",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454254",
                                          "name": "Bombay Grill 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272763",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272764",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454248",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272765",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272766",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272767",
                                      "groupName": "Choose From Offers @99 for Bombay Grill Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666287",
                                  "name": "3 Cheese Melt Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink and any choice of side.",
                                  "imageId": "c3f54b48c8a70db042cbd09accbe0931",
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272768",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454276",
                                          "name": "3 Cheese Melt 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272769",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272770",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454248",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272771",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272772",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272773",
                                      "groupName": "Choose From Offers @99 for 3 Cheese Melt Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666288",
                                  "name": "Egg 'n Cheese Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink and any choice of side.",
                                  "imageId": "8740a76234a1c48351f27e1b935cd795",
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272774",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454277",
                                          "name": "Egg 'n Cheese 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272775",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272776",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454262",
                                          "name": "Extra Potato Omelette Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272777",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272778",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272779",
                                      "groupName": "Choose From Offers @99 for Egg 'n Cheese Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666289",
                                  "name": "Chicken Keema Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink?and?a?cookie.",
                                  "imageId": "40730c1ec1c9294fe8a537c0fb2a061f",
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272780",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454261",
                                          "name": "Chicken Keema 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272781",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272782",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272783",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272784",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272785",
                                      "groupName": "Choose From Offers @99 for Chicken Keema Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666290",
                                  "name": "Roast Chicken Melt Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Grills sandwich with a choice of drink?and?a?cookie.",
                                  "imageId": "66f7dfa9d7f0e3b1ad27ced7e673544e",
                                  "price": 33900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272786",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454244",
                                          "name": "Roast Chicken Melt 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272787",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454270",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454206",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454221",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272788",
                                      "groupName": "Choose From Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454207",
                                          "name": "Extra Smoked Chicken Strips",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454256",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272789",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272790",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272791",
                                      "groupName": "Choose From Offers @99 for Roast Chicken Melt Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 33900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Signature Sub Combos (Save upto 37%)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184122",
                                  "name": "Paneer Achari Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "b9016987d7c9a36ccae5c21b9772c265",
                                  "isVeg": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547253",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835595",
                                          "name": "Paneer Achari 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547254",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "100143981",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272751",
                                      "groupName": "Choose From Offers @99 for Paneer Achari Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 35900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184123",
                                  "name": "Crunchy Mexican Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "694b329ba400202058dd2793e2d8ab5d",
                                  "isVeg": 1,
                                  "price": 36900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547255",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835596",
                                          "name": "Crunchy Mexican 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "100143982",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547256",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272666",
                                      "groupName": "Choose From Offers @99 for Crunchy Mexican Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 36900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184124",
                                  "name": "Chilli Cheese Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "9020a32adc2b5fc28ac6ed497ea14a3a",
                                  "isVeg": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547257",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835585",
                                          "name": "Chilli Cheese 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547258",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "100143987",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272700",
                                      "groupName": "Choose From Offers @99 for Chilli Cheese Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 35900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184119",
                                  "name": "Great American BBQ Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "b4e32b37ea2c71cfc7b28f885aa668fe",
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547248",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835615",
                                          "name": "Great American BBQ 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547249",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "100143978",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272701",
                                      "groupName": "Choose From Offers @99 for Great American BBQ Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 39900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184141",
                                  "name": "Chicken Tikka Achari Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "d5b2788ab3775a0fb26ac66f061f7146",
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547345",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835617",
                                          "name": "Chicken Tikka Achari 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547346",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "100144065",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272726",
                                      "groupName": "Choose From Offers @99 for Chicken Tikka Achari Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666283",
                                  "name": "Pepper Chicken Sandwich + Side + Coke",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy your favourite Hotseller sub with a choice of cookie and a choice of drink.",
                                  "imageId": "0ef152b30a9ba056580b6d1da96e5678",
                                  "price": 38900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272752",
                                      "groupName": "CHOOSE YOUR SUB",
                                      "choices": [
                                        {
                                          "id": "94835583",
                                          "name": "Pepper Chicken 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272753",
                                      "groupName": "CHOOSE YOUR DRINK",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272754",
                                      "groupName": "CHOOSE YOUR COOKIE",
                                      "choices": [
                                        {
                                          "id": "109454203",
                                          "name": "Crispers",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272755",
                                      "groupName": "Choose From Offers @99 for Pepper Chicken Sandwich + Side + Coke",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 38900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Season Special Combos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666291",
                                  "name": "Veg Subs + Side +  Coke (Save upto Rs199)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy a veg Create Your Own sub of your choice, with your favourite drink and a cookie or veg kebabs. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "9217721b7b7add6e4b971afa2b769354",
                                  "isVeg": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272792",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454250",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454235",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454240",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454236",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454238",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454239",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454258",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272793",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454222",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454223",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454249",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272794",
                                      "groupName": "Choice of Prep",
                                      "choices": [
                                        {
                                          "id": "109454216",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454210",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454213",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454265",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272795",
                                      "groupName": "Choose Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454211",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272796",
                                      "groupName": "Choose from Veg",
                                      "choices": [
                                        {
                                          "id": "109454215",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454253",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454214",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454208",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454251",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454246",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454252",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454245",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454247",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272797",
                                      "groupName": "Choice of Sauces(Max 3)",
                                      "choices": [
                                        {
                                          "id": "109454209",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454186",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454187",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454188",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454271",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454274",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454266",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454267",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272798",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272799",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "109454205",
                                          "name": "Veg Kebab -3 Pieces",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272800",
                                      "groupName": "Choose From Offers @99 for Veg Sub + Side + Drink (Save upto 199 Rs)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 35900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666292",
                                  "name": "Non-Veg Subs + Side + Coke (Save upto Rs155)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Enjoy any non-veg sub of your choice, with your favourite drink and a cookie. Offers customisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "839bf33357ea53c439eaecb3a1b06083",
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272801",
                                      "groupName": "Choose from Sub",
                                      "choices": [
                                        {
                                          "id": "109454259",
                                          "name": "Chicken Koftas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454217",
                                          "name": "New Peri Peri Chicken 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454264",
                                          "name": "Roasted Chicken Strips 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454275",
                                          "name": "Tandoori Chicken Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454218",
                                          "name": "New B.M.T. 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454260",
                                          "name": "Chicken Teriyaki 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272802",
                                      "groupName": "Choice of Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454249",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454222",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454223",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272803",
                                      "groupName": "Choice of Prep",
                                      "choices": [
                                        {
                                          "id": "109454210",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454265",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454216",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454213",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272804",
                                      "groupName": "Choose Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454211",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272805",
                                      "groupName": "Choose from Veg",
                                      "choices": [
                                        {
                                          "id": "109454251",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454252",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454253",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454208",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454214",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454247",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454215",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454245",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454246",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272806",
                                      "groupName": "Choice of Sauces(Max 3)",
                                      "choices": [
                                        {
                                          "id": "109454186",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454274",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454187",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454188",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454266",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454209",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454267",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454271",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272807",
                                      "groupName": "Choose from Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272808",
                                      "groupName": "Choose from Side",
                                      "choices": [
                                        {
                                          "id": "93560315",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560316",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560317",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272809",
                                      "groupName": "Choose From Offers @99 for Non-Veg Subs + Side + Coke (Save upto Rs155)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666293",
                                  "name": "2 Veg Subs + Coke (Save upto Rs169)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Combo of two freshly made veg subs of your choice with a drink. Offers customisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "ee64a82a067f0184fb83510609668666",
                                  "isVeg": 1,
                                  "price": 43900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272810",
                                      "groupName": "Choose from 1st Sub",
                                      "choices": [
                                        {
                                          "id": "109454236",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454250",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454240",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454238",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454239",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454235",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272811",
                                      "groupName": "Choice of 1st Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454249",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454222",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454223",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272812",
                                      "groupName": "Choice of 1st Prep",
                                      "choices": [
                                        {
                                          "id": "109454210",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454265",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454216",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454213",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272813",
                                      "groupName": "Choose 1st Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454211",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272814",
                                      "groupName": "Choice of 1st Veg",
                                      "choices": [
                                        {
                                          "id": "109454251",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454252",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454253",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454208",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454214",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454247",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454215",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454245",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454246",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272815",
                                      "groupName": "Choice of 1st Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "109454186",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454274",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454187",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454188",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454266",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454209",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454267",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454271",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128791823",
                                      "groupName": "Choose from 2nd Sub",
                                      "choices": [
                                        {
                                          "id": "109736021",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736029",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736032",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736030",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736023",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736033",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272816",
                                      "groupName": "Choice of 2nd Sub Bread",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272817",
                                      "groupName": "Choice of 2nd Sub Preparation",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272818",
                                      "groupName": "Choose 2nd Sub Add Ons",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272819",
                                      "groupName": "Choice of 2nd Sub Vegetables",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272820",
                                      "groupName": "Choice of 2nd Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272821",
                                      "groupName": "Choose Your Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272822",
                                      "groupName": "Choose From Offers",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 43900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666294",
                                  "name": "2 Veg Signature Subs + Coke (Save upto Rs219)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Combo of two freshly made veg Hotseller subs of your choice with a drink. Offers minimal cusomisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "d8f9fce73842cdd47051fff08125a6b6",
                                  "isVeg": 1,
                                  "price": 48900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272823",
                                      "groupName": "Choose from 1st Sub",
                                      "choices": [
                                        {
                                          "id": "94835585",
                                          "name": "Chilli Cheese 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94835596",
                                          "name": "Crunchy Mexican 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94835595",
                                          "name": "Paneer Achari 15cm (6 inches)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128791821",
                                      "groupName": "Choose From 2nd Sub",
                                      "choices": [
                                        {
                                          "id": "109736018",
                                          "name": "Paneer Achari 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736032",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736017",
                                          "name": "Crunchy Mexican 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272824",
                                      "groupName": "Choose Your Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272825",
                                      "groupName": "Choose From Offers",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 48900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666295",
                                  "name": "2 Veg Premium Subs + Coke (Save upto Rs179)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Combo of two freshly made veg subs of your choice from our premium range with a drink. Offers customisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "5280b1e4c4c386ce2a4f8ff049e2887d",
                                  "isVeg": 1,
                                  "price": 48900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272826",
                                      "groupName": "Choose from 1st Sub",
                                      "choices": [
                                        {
                                          "id": "109454236",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454250",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454258",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454240",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454235",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272827",
                                      "groupName": "Choice of 1st Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454249",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454222",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454223",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272828",
                                      "groupName": "Choice of 1st Prep",
                                      "choices": [
                                        {
                                          "id": "109454210",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454265",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454216",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454213",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272829",
                                      "groupName": "Choose 1st Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454211",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272830",
                                      "groupName": "Choice of 1st Veg",
                                      "choices": [
                                        {
                                          "id": "109454251",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454252",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454253",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454208",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454214",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454247",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454215",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454245",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454246",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272831",
                                      "groupName": "Choice of 1st Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "109454186",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454274",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454187",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454188",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454266",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454209",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454267",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454271",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128791822",
                                      "groupName": "Choose from 2nd Sub",
                                      "choices": [
                                        {
                                          "id": "109736029",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736032",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736031",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736030",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736023",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272832",
                                      "groupName": "Choice of 2nd Sub Bread",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272833",
                                      "groupName": "Choice of 2nd Sub Preparation",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272834",
                                      "groupName": "Choose 2nd Sub Add Ons",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272835",
                                      "groupName": "Choice of 2nd Sub Vegetables",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272836",
                                      "groupName": "Choice of 2nd Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272837",
                                      "groupName": "Choose Your Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272838",
                                      "groupName": "Choose From Offers",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 48900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666296",
                                  "name": "2 Non-Veg Signature Subs + Coke (Save upto Rs179)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Combo of two freshly made non-veg Hotseller subs of your choice with a drink. Offers minimal customisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "0b7c330e32ac95cf1b3ccbc1f2b84fdd",
                                  "price": 58900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272839",
                                      "groupName": "Choose from 1st Sub",
                                      "choices": [
                                        {
                                          "id": "94835583",
                                          "name": "Pepper Chicken 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94835615",
                                          "name": "Great American BBQ 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94835617",
                                          "name": "Chicken Tikka Achari 15cm (6 inches)",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128791819",
                                      "groupName": "Choose From 2nd Sub",
                                      "choices": [
                                        {
                                          "id": "109736028",
                                          "name": "Great American BBQ Chicken 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736027",
                                          "name": "Chicken Tikka Achari 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736026",
                                          "name": "Pepper Chicken 15cm with Creamy Italian Dip [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272840",
                                      "groupName": "Choose Your Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272841",
                                      "groupName": "Choose From Offers",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 58900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666297",
                                  "name": "Any 2 Veg/Non-Veg Subs + Coke (Save upto Rs200)",
                                  "category": "SUPER SAVER COMBOS - SAVE UPTO 46%",
                                  "description": "Combo of any two freshly made veg/non-veg subs of your choice with a drink. Offers customisation. Drink can be 'pet bottle' or 'can' as per availability.",
                                  "imageId": "fef076b2b7555a73c92f6499af1466cd",
                                  "price": 53900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272842",
                                      "groupName": "Choose from 1st Sub",
                                      "choices": [
                                        {
                                          "id": "109454250",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454240",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454264",
                                          "name": "Roasted Chicken Strips 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454275",
                                          "name": "Tandoori Chicken Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454218",
                                          "name": "New B.M.T. 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454260",
                                          "name": "Chicken Teriyaki 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454236",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454258",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454259",
                                          "name": "Chicken Koftas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454238",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454217",
                                          "name": "New Peri Peri Chicken 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454239",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454235",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272843",
                                      "groupName": "Choice of 1st Bread",
                                      "choices": [
                                        {
                                          "id": "109454225",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454249",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454222",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454223",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454224",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272844",
                                      "groupName": "Choice of 1st Prep",
                                      "choices": [
                                        {
                                          "id": "109454210",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454265",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454216",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454213",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272845",
                                      "groupName": "Choose 1st Add Ons",
                                      "choices": [
                                        {
                                          "id": "109454211",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454226",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272846",
                                      "groupName": "Choice of 1st Veg",
                                      "choices": [
                                        {
                                          "id": "109454251",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454252",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454253",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454208",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454214",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454247",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454215",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454245",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454246",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272847",
                                      "groupName": "Choice of 1st Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "109454186",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454274",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454187",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454188",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454266",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454209",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454267",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454271",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128791820",
                                      "groupName": "Choose from 2nd Sub1",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736029",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736016",
                                          "name": "B.M.T. 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736025",
                                          "name": "Roasted Chicken Strips 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736024",
                                          "name": "Chicken Teriyaki 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736023",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736034",
                                          "name": "Tandoori Chicken Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736022",
                                          "name": "Chicken Koftas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736033",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736019",
                                          "name": "Peri Peri Chicken 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736021",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736032",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736020",
                                          "name": "Tuna 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736031",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736030",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272848",
                                      "groupName": "Choose from 2nd Sub",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736029",
                                          "name": "Corn & Peas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736016",
                                          "name": "B.M.T. 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736025",
                                          "name": "Roasted Chicken Strips 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736024",
                                          "name": "Chicken Teriyaki 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736023",
                                          "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736034",
                                          "name": "Tandoori Chicken Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736022",
                                          "name": "Chicken Koftas 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736033",
                                          "name": "Veggie Delite 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736019",
                                          "name": "Peri Peri Chicken 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736021",
                                          "name": "Aloo Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736032",
                                          "name": "Chilli Bean Patty 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736020",
                                          "name": "Tuna 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736031",
                                          "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109736030",
                                          "name": "Veg Shammi 15cm [6 Inches]",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272849",
                                      "groupName": "Choice of 2nd Sub Preparation",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272850",
                                      "groupName": "Choose 2nd Sub Add Ons",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272851",
                                      "groupName": "Choice of 2nd Sub Vegetables",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272852",
                                      "groupName": "Choice of 2nd Sub Sauces(3 Max)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272853",
                                      "groupName": "Choose Your Drink",
                                      "choices": [
                                        {
                                          "id": "109454230",
                                          "name": "Sprite 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454241",
                                          "name": "Thums Up 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454231",
                                          "name": "Coke 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454242",
                                          "name": "Sprite 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454237",
                                          "name": "Fanta 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454232",
                                          "name": "Coke Zero 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454243",
                                          "name": "Coke 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454233",
                                          "name": "Thums Up 475ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454234",
                                          "name": "Coca-Cola zero 330ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272854",
                                      "groupName": "Choose From Offers",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 53900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "TRY NEW GRILLS - HOT SANDWICHES",
                      "categories": [
                        {
                          "title": "Grills - Sub",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666298",
                                  "name": "Delhi Tikki Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "Grilled Italian white bread stuffed with flavourful aloo patty, onion, chilli mayo and creamy cheezy sauce for a desi twist. Serving size -192 g / 535 kcal. Allergens - Contains wheat, milk, Barley, Oats and Soy.",
                                  "imageId": "e1845badebbbfd08dbe77b2263d3f509",
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272855",
                                      "groupName": "Choose From Choice of Bread for Delhi Tikki 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272856",
                                      "groupName": "Choose From P. Add On for Delhi Tikki 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454204",
                                          "name": "Extra Delhi Patty",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272857",
                                      "groupName": "Choose From Offers @99 for Delhi Tikki 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666299",
                                  "name": "Bombay Grill Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "The classic Bombay sandwich in grilled Italian white bread loaded with tomato, cucumber, onion, capsicum, coriander & green chillies chutney and a whole lotta love. Serving size 219 g / 443 kcal. Contains wheat and milk.",
                                  "imageId": "bebf43fa34009cb7984f6ac61a893333",
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272858",
                                      "groupName": "Choose From Choice of Bread for Bombay Grill 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272859",
                                      "groupName": "Choose From P. Add On for Bombay Grill 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272860",
                                      "groupName": "Choose From Offers @99 for Bombay Grill 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666300",
                                  "name": "3 Cheese Melt Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "Have a cheese blast with Three Cheese Grill sandwich. Freshly grilled Italian white bread stuffed with potato patty, lettuce, onion, capsicum and jalapenos, topped with oregano spice mix and the cheesy trio of cheese slice, liquid cheese and mozzarella. Serving size 244g/633 Kcal. Contains wheat, milk, Barley, Oats and Soy.",
                                  "imageId": "53efe325837a08a53777c3f246e165a2",
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272861",
                                      "groupName": "Choose From Choice of Bread for 3 Cheese Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272862",
                                      "groupName": "Choose From P. Add On for 3 Cheese Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272863",
                                      "groupName": "Choose From Offers @99 for 3 Cheese Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666301",
                                  "name": "Egg 'n Cheese Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "The classic all-day breakfast. Eggwich is a freshly grilled Italian white bread stuffed with potato omelette, capsicum, onion, topped with oregano spice mix, chilli mayo, liquid cheese, mozzarella and cheese slice for some extra oozing cheesiness. Serving size -259 g / 683 kcal. Allergens- Contains wheat, milk, egg., barley, Oats and soy.",
                                  "imageId": "ce72cd3e22495120b57a8d00f6495046",
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272864",
                                      "groupName": "Choose From Choice of Bread for Egg 'n Cheese 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272865",
                                      "groupName": "Choose From P. Add On for Egg 'n Cheese 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454212",
                                          "name": "Extra Potato Omelette Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272866",
                                      "groupName": "Choose From Offers @99 for Egg 'n Cheese 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666302",
                                  "name": "Chicken Keema Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "Juicy chicken keema in grilled Italian white bread loaded with onion, chilli mayo and creamy cheezy sauce. Serving size -179 g / 508 kcal. Allergens- Contains wheat, milk, Soy, Barley, Oats, and nuts.",
                                  "imageId": "3b41e96804608a42c8724dfc7c302ab2",
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272867",
                                      "groupName": "Choose From Choice of Bread for Chicken Keema 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272868",
                                      "groupName": "Choose From P. Add On for Chicken Keema 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272869",
                                      "groupName": "Choose From Offers @99 for Chicken Keema 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666303",
                                  "name": "Roast Chicken Melt Sandwich",
                                  "category": "TRY NEW GRILLS - HOT SANDWICHES",
                                  "description": "Smokin? pepper chicken strips stuffed in grilled Italian white bread topped with lettuce, onion, jalapenos, honey mustard, oozing cheese slice and creamy cheezy sauce. Serving size -202 g / 506 kcal. Contains wheat, milk, Soy, Barley, Oats and nuts.",
                                  "imageId": "372031a94cb10f874fcf37fbdb90feb3",
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272870",
                                      "groupName": "Choose From Choice of Bread for Roast Chicken Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454201",
                                          "name": "Multigrain Honey Oats Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454269",
                                          "name": "Roasted Garlic Bread",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454193",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272871",
                                      "groupName": "Choose From P. Add On for Roast Chicken Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929522",
                                          "name": "Extra Smoked Chicken Strips",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272872",
                                      "groupName": "Choose From Offers @99 for Roast Chicken Melt 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Signature Subs - Chef's Spl Sandwiches",
                      "categories": [
                        {
                          "title": "Hotsellers - Sub",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184114",
                                  "name": "Paneer Achari Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "Multigrain toasted Sub with chunks of paneer, achari mayo, pickled onion, capsicum, tomato and chilli mayo. Serving size - 240 g/ 589 kcal. Allergens - Contains wheat, rye, barley, oats, milk & soy.",
                                  "imageId": "b33b19910a5f966e3afe9149b0326f88",
                                  "isVeg": 1,
                                  "price": 27310,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547234",
                                      "groupName": "Choose From P. Add On for Paneer Achari 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "93560313",
                                          "name": "Extra Paneer Achari",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547235",
                                      "groupName": "Choose From Offers @99 for Paneer Achari 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27310,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184115",
                                  "name": "Crunchy Mexican Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "Multigrain toasted Sub with Mexican bean patty, tomato, capsicum, onion, olives, jalape?o, southwest chipotle sauce & crunchy nachos. Serving size - 295 g/ 702 kcal. Allergens - Contains wheat, rye, barley, oats, milk & soy.",
                                  "imageId": "d7cd2bf55697e97c568f5789299822a7",
                                  "isVeg": 1,
                                  "price": 28262,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547238",
                                      "groupName": "Choose From P. Add On for Crunchy Mexican 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547239",
                                      "groupName": "Choose From Offers @99 for The Mexican 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28262,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184118",
                                  "name": "Chilli Cheese Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "Multigrain, 3-cheese toasted Sub with herby aloo patty, jalape?o, onion & capsicum with chilli mayo. Serving size - 284 g/ 678 kcal. Allergens - Contains wheat, rye, barley, oats, milk & soy.",
                                  "imageId": "c6b1c34fc51dc5f268ea14834569fb7d",
                                  "isVeg": 1,
                                  "price": 27310,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547244",
                                      "groupName": "Choose From P. Add On for Chilli Cheese 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547245",
                                      "groupName": "Choose From Offers @99 for Chilli Cheese 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27310,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184135",
                                  "name": "Great American BBQ Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "Multigrain toasted sub with chicken pepperoni, chicken slice, smoked chicken strips, onion, pickle, capsicum, eggless mayo and barbecue sauce. Serving size - 253 g/ 539 kcal. Allergens - Contains wheat, rye, barley, oats, milk & soy.",
                                  "imageId": "00d08fc6f6b05ccbc092cea7d111b648",
                                  "price": 31595,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547323",
                                      "groupName": "Choose From P. Add On for Great American BBQ Chicken 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "93560333",
                                          "name": "Extra American BBQ Chicken",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547324",
                                      "groupName": "Choose From Offers @99 for Great American BBQ Chicken 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 31595,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184139",
                                  "name": "Chicken Tikka Achari Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "Multigrain toasted sub with Tandoori Chicken, achari mayo, pickled onion, capsicum and tomato, topped  with chilli mayo for an extra kick. Serving size - 240 g/ 520 kcal. Allergens - Contains wheat, rye, barley, oats, milk & soy.",
                                  "imageId": "c1086fc260449f7fc5ce31a3b1618d68",
                                  "price": 27310,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547337",
                                      "groupName": "Choose From P. Add On for Chicken Tikka Achari 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "93560338",
                                          "name": "Extra Chicken Tikka Achari",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547338",
                                      "groupName": "Choose From Offers @99 for Tandoori Chicken 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 27310,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666305",
                                  "name": "Pepper Chicken Sandwich",
                                  "category": "Signature Subs - Chef's Spl Sandwiches",
                                  "description": "A flavourful toasted sub loaded with capsicum, olives & jalape?os. This warm sandwich has juicy black pepper chicken paired with creamy Italian sauce and white Italian bread as the base. Requires no customization. Serving size - 189 g/359 kcal. Allergens - Contains wheat, rye, barley, oats, milk, nuts & soy.",
                                  "imageId": "9ea89694742bcf4193170f356c303f03",
                                  "price": 30643,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272873",
                                      "groupName": "Choose From P. Add On for Pepper Chicken 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "94835584",
                                          "name": "Extra Pepper Chicken",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272874",
                                      "groupName": "Choose From Offers @99 for Pepper Chicken 15cm (6 inches)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30643,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Create Your Own Sandwiches",
                      "categories": [
                        {
                          "title": "Breakfast Sandwiches",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472228",
                                  "name": "Cheese Omelette Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | A classic for a reason. Our egg and cheese is simply delicious. Enjoy high protein fluffy egg omelet with cheese. Try it toasted - It's unbeatable. Serving size : 15 cm - 154 g / 366 kcal , 30 cm - 308 g / 732 kcal. Allergens - Contains wheat, rye, barley, oats, egg, milk, soy. Values include multigrain bread and American Cheese.",
                                  "imageId": "sej4xnxeaii1xlyxfxvw",
                                  "price": 19520,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359055",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Cheese Omelette 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088767",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Cheese Omelette 30 cm (Footlong)",
                                            "price": 142.9,
                                            "id": "76088768",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359055",
                                            "variationId": "76088767"
                                          }
                                        ],
                                        "price": 19520,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790686",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790682",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790682",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790682",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368722",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790684",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790680",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790680",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790680",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790680",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790678",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790678",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790678",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790678",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790678",
                                            "addonId": "58929035"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359055",
                                            "variationId": "76088768"
                                          }
                                        ],
                                        "price": 33810,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790681",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790681",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790681",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790681",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790685",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790679",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790679",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790679",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790679",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790679",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368723",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790687",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790683",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790683",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790683",
                                            "addonId": "94836159"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790678",
                                      "groupName": "Choose From Choice of Bread for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790679",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790680",
                                      "groupName": "Choose From Choice of Preparation for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790681",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790682",
                                      "groupName": "Choose From P. Add On for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790683",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790684",
                                      "groupName": "Choose From Choice of Vegetable for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790685",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790686",
                                      "groupName": "Choose From Choice of Sauces for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790687",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368722",
                                      "groupName": "Choose From Offers @99 for Egg & Cheese 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368723",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 19520,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Veg Sandwiches",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472230",
                                  "name": "Aloo Patty Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Aloo patty seasoned with special herbs and spices, paired with your choice of nutritious veggies, on a freshly baked bread. Serving size : 15 cm - 219 g / 337 kcal , 30 cm - 438 g / 674 kcal , Allergens - Contains wheat, rye, barley, oats. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "ttoydnlmxjmsy4bnxptn",
                                  "isVeg": 1,
                                  "price": 21430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359057",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Aloo Patty 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088771",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Aloo Patty Combo(Side+Drink) Save upto 49%",
                                            "price": 94.7,
                                            "id": "111292679",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 161.9,
                                            "id": "76088772",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359057",
                                            "variationId": "76088771"
                                          }
                                        ],
                                        "price": 21430,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790702",
                                            "addonId": "58929117"
                                          },
                                          {
                                            "groupId": "73790702",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790702",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790702",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790702",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368726",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790698",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790698",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790698",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790698",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790698",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790700",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790704",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790706",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359057",
                                            "variationId": "111292679"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272683",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272683",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272683",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272683",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272683",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272683",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272682",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272677",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272680",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272678",
                                            "addonId": "58929117"
                                          },
                                          {
                                            "groupId": "128272678",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272678",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272681",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272679",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272679",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272679",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272679",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272679",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272676",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272676",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272676",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272676",
                                            "addonId": "109454189"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359057",
                                            "variationId": "76088772"
                                          }
                                        ],
                                        "price": 37620,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368727",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368727",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368727",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368727",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368727",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368727",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790707",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790703",
                                            "addonId": "58929121"
                                          },
                                          {
                                            "groupId": "73790703",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790703",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790703",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790703",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "73790699",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790699",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790699",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790699",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790699",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790701",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790705",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272676",
                                      "groupName": "Choose From Snacks for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272677",
                                      "groupName": "Choose From Drinks Coke for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790698",
                                      "groupName": "Choose From Choice of Bread for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790699",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272678",
                                      "groupName": "Choose From P. Add On for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790700",
                                      "groupName": "Choose From Choice of Preparation for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790701",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272679",
                                      "groupName": "Choose From Choice of Bread for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790702",
                                      "groupName": "Choose From P. Add On for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790703",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929121",
                                          "name": "Extra Aloo Patty Footlong",
                                          "price": 12380,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272680",
                                      "groupName": "Choose From Choice of Preparation for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790704",
                                      "groupName": "Choose From Choice of Vegetable for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790705",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272681",
                                      "groupName": "Choose From Choice of Vegetable for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790706",
                                      "groupName": "Choose From Choice of Sauces for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790707",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272682",
                                      "groupName": "Choose From Choice of Sauces for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368726",
                                      "groupName": "Choose From Offers @99 for Aloo Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368727",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272683",
                                      "groupName": "Choose From Offers @99 for Aloo Patty Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 21430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472233",
                                  "name": "Corn & Peas Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | A delicious assortment of green peas, golden corn and diced carrots, dressed with a creamy mixture of eggless mayo sauce, and served on your favourite bread. Serving size : 15 cm - 219 g / 359 kcal , 30 cm - 438 g / 718 kcal. Allergens - Contains wheat, rye, barley, oats, milk. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "coa7kctbp1agxlivimql",
                                  "isVeg": 1,
                                  "price": 21430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359059",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Corn & Peas 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088775",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Corn & Peas Combo(Side+Drink) Save upto 49%",
                                            "price": 94.7,
                                            "id": "111292682",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 161.9,
                                            "id": "76088776",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359059",
                                            "variationId": "76088775"
                                          }
                                        ],
                                        "price": 21430,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790724",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790722",
                                            "addonId": "58929256"
                                          },
                                          {
                                            "groupId": "73790722",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790722",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790722",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790722",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368730",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790726",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790720",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790718",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790718",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790718",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790718",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790718",
                                            "addonId": "58929035"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359059",
                                            "variationId": "111292682"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272707",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272703",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272706",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272709",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272705",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272705",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272705",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272705",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272705",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272704",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272704",
                                            "addonId": "58929256"
                                          },
                                          {
                                            "groupId": "128272704",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272702",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272702",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272702",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272702",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272708",
                                            "addonId": "58929151"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359059",
                                            "variationId": "76088776"
                                          }
                                        ],
                                        "price": 37620,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790723",
                                            "addonId": "58929261"
                                          },
                                          {
                                            "groupId": "73790723",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790723",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790723",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790723",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "73790719",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790719",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790719",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790719",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790719",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790721",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368731",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790725",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790727",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272702",
                                      "groupName": "Choose From Snacks for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272703",
                                      "groupName": "Choose From Drinks Coke for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790718",
                                      "groupName": "Choose From Choice of Bread for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790719",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272704",
                                      "groupName": "Choose From P. Add On for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929256",
                                          "name": "Extra Corn & Peas",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790720",
                                      "groupName": "Choose From Choice of Preparation for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790721",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272705",
                                      "groupName": "Choose From Choice of Bread for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790722",
                                      "groupName": "Choose From P. Add On for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929256",
                                          "name": "Extra Corn & Peas",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790723",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929261",
                                          "name": "Extra Corn & Peas Footlong",
                                          "price": 12380,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272706",
                                      "groupName": "Choose From Choice of Preparation for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790724",
                                      "groupName": "Choose From Choice of Vegetable for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790725",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272707",
                                      "groupName": "Choose From Choice of Vegetable for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790726",
                                      "groupName": "Choose From Choice of Sauces for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790727",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272708",
                                      "groupName": "Choose From Choice of Sauces for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368730",
                                      "groupName": "Choose From Offers @99 for Corn & Peas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368731",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272709",
                                      "groupName": "Choose From Offers @99 for Corn & Peas Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 21430,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472237",
                                  "name": "Tangy Paneer Tikka Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Your favourite cheese cubes marinated with tandoori sauce, spices and condiments, cooked in an oven to give a smoky taste. Served with a choice of nutritious veggies and a freshly baked bread. Serving size : 15 cm - 224 g / 410 kcal , 30 cm - 448 g / 820 kcal. Allergens - Contains wheat, rye, barley, oats, milk, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "ibvtgsayrbcarr4w1lgd",
                                  "isVeg": 1,
                                  "price": 23330,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359062",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Tangy Paneer Tikka 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088781",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                            "price": 125.7,
                                            "id": "111292681",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 181,
                                            "id": "76088782",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359062",
                                            "variationId": "76088781"
                                          }
                                        ],
                                        "price": 23330,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790762",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790762",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790762",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790762",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790762",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790762",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790764",
                                            "addonId": "58929450"
                                          },
                                          {
                                            "groupId": "73790764",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790764",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790764",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790764",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790767",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368736",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790769",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790760",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790760",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790760",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790760",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790760",
                                            "addonId": "58929033"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359062",
                                            "variationId": "111292681"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272695",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272695",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272695",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272695",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272695",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272692",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272692",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272692",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272692",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272693",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272696",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272697",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272698",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272694",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272694",
                                            "addonId": "58929450"
                                          },
                                          {
                                            "groupId": "128272694",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272699",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359062",
                                            "variationId": "76088782"
                                          }
                                        ],
                                        "price": 41430,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368737",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368737",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368737",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368737",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368737",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368737",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790770",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790765",
                                            "addonId": "58929126"
                                          },
                                          {
                                            "groupId": "73790765",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790765",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790765",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "73790765",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790761",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790761",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790761",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790761",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790761",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790763",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790768",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272692",
                                      "groupName": "Choose From Snacks for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272693",
                                      "groupName": "Choose From Drinks Coke for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790760",
                                      "groupName": "Choose From Choice of Bread for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790761",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272694",
                                      "groupName": "Choose From P. Add On for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929450",
                                          "name": "Extra Paneer Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790762",
                                      "groupName": "Choose From Choice of Preparation for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790763",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272695",
                                      "groupName": "Choose From Choice of Bread for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790764",
                                      "groupName": "Choose From P. Add On for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929450",
                                          "name": "Extra Paneer Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790765",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929126",
                                          "name": "Extra Paneer Tikka Footlong",
                                          "price": 12380,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272696",
                                      "groupName": "Choose From Choice of Preparation for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790767",
                                      "groupName": "Choose From Choice of Vegetable for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790768",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272697",
                                      "groupName": "Choose From Choice of Vegetable for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790769",
                                      "groupName": "Choose From Choice of Sauces for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790770",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272698",
                                      "groupName": "Choose From Choice of Sauces for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368736",
                                      "groupName": "Choose From Offers @99 for Paneer Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368737",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272699",
                                      "groupName": "Choose From Offers @99 for Tangy Paneer Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 23330,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "32 ratings",
                                      "ratingCountV2": "32"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472239",
                                  "name": "Veg Shammi Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Experience authentic flavours with kebab made of lentils and enriched with mouth-watering hints of garlic and onion accompanied by nutritious veggies, in your favourite bread. Serving size : 15 cm - 224 g / 365 kcal , 30 cm - 448 g / 730 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "flljroxppxxq8o47uijs",
                                  "isVeg": 1,
                                  "price": 23330,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359064",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Veg Shammi 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088785",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Veg Shammi Combo(Side+Drink) Save upto 49%",
                                            "price": 95.7,
                                            "id": "111292683",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 181,
                                            "id": "76088786",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359064",
                                            "variationId": "76088785"
                                          }
                                        ],
                                        "price": 23330,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790790",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790793",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790786",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790783",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790783",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790783",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790783",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790783",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790788",
                                            "addonId": "58929453"
                                          },
                                          {
                                            "groupId": "73790788",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790788",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790788",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790788",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368740",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359064",
                                            "variationId": "111292683"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272714",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272714",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272714",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272714",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272714",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272714",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272712",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272712",
                                            "addonId": "58929453"
                                          },
                                          {
                                            "groupId": "128272712",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272715",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272713",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272713",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272713",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272713",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272713",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272710",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272710",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272710",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272710",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272717",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272716",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272711",
                                            "addonId": "109454272"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359064",
                                            "variationId": "76088786"
                                          }
                                        ],
                                        "price": 41430,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790791",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790789",
                                            "addonId": "58929127"
                                          },
                                          {
                                            "groupId": "73790789",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790789",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790789",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790789",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368741",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790787",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790795",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790785",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790785",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790785",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790785",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790785",
                                            "addonId": "58929039"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272710",
                                      "groupName": "Choose From Snacks for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272711",
                                      "groupName": "Choose From Drinks Coke for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790783",
                                      "groupName": "Choose From Choice of Bread for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790785",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272712",
                                      "groupName": "Choose From P. Add On for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929453",
                                          "name": "Extra Veg Shammi",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790786",
                                      "groupName": "Choose From Choice of Preparation for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790787",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272713",
                                      "groupName": "Choose From Choice of Bread for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790788",
                                      "groupName": "Choose From P. Add On for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929453",
                                          "name": "Extra Veg Shammi",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790789",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929127",
                                          "name": "Extra Veg Shammi Footlong",
                                          "price": 12380,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272714",
                                      "groupName": "Choose From Choice of Preparation for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790790",
                                      "groupName": "Choose From Choice of Vegetable for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790791",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272715",
                                      "groupName": "Choose From Choice of Vegetable for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790793",
                                      "groupName": "Choose From Choice of Sauces for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790795",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272716",
                                      "groupName": "Choose From Choice of Sauces for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368740",
                                      "groupName": "Choose From Offers @99 for Veg Shammi 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368741",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272717",
                                      "groupName": "Choose From Offers @99 for Veg Shammi Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 23330,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472240",
                                  "name": "Veggie Delite® Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Delicious combination of fresh lettuce, tomatoes, green peppers, cucumbers, onions, olives and pickles served on a freshly baked bread. Serving size : 15 cm - 164 g / 242 kcal , 30 cm - 328 g / 484 kcal. Allergens - Contains wheat, rye, barley, oats. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "nyijndkvbvxlzytlo5e7",
                                  "isVeg": 1,
                                  "price": 19520,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359065",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Veggie Delite 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088787",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 142.9,
                                            "id": "76088788",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Veggie Delite Combo(Side+Drink) Save upto 49",
                                            "price": 103.8,
                                            "id": "111292686",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359065",
                                            "variationId": "76088787"
                                          }
                                        ],
                                        "price": 19520,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790804",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790802",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790796",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790796",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790796",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790796",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790796",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790798",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790798",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790798",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790798",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790798",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790800",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790800",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790800",
                                            "addonId": "58929053"
                                          },
                                          {
                                            "groupId": "73790800",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "109454192"
                                          },
                                          {
                                            "groupId": "78368742",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359065",
                                            "variationId": "76088788"
                                          }
                                        ],
                                        "price": 33810,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790805",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790803",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790797",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790797",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790797",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790797",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790797",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790799",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790799",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790799",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790799",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790799",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "109454192"
                                          },
                                          {
                                            "groupId": "78368743",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790801",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790801",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790801",
                                            "addonId": "58929057"
                                          },
                                          {
                                            "groupId": "73790801",
                                            "addonId": "93560330"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359065",
                                            "variationId": "111292686"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272742",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272740",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272738",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272741",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272741",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272741",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272741",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272739",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272735",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272735",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272736",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272736",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272736",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272736",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272736",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272737",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272735",
                                      "groupName": "Choose From P. Add On for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272736",
                                      "groupName": "Choose From Choice of Bread for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790796",
                                      "groupName": "Choose From Choice of Bread for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790797",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272737",
                                      "groupName": "Choose From Choice of Vegetable for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790798",
                                      "groupName": "Choose From Choice of Preparation for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790799",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272738",
                                      "groupName": "Choose From Choice of Sauces for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790800",
                                      "groupName": "Choose From P. Add On for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790801",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929057",
                                          "name": "Extra Mozzarella Cheese Footlong",
                                          "price": 5710,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272739",
                                      "groupName": "Choose From Choice of Preparation for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790802",
                                      "groupName": "Choose From Choice of Vegetable for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790803",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272740",
                                      "groupName": "Choose From Offers @99 for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790804",
                                      "groupName": "Choose From Choice of Sauces for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790805",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272741",
                                      "groupName": "Choose From Snacks for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368742",
                                      "groupName": "Choose From Offers @99 for Veggie Delite 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368743",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272742",
                                      "groupName": "Choose From Drinks Coke for Veggie Delite Combo(Side+Drink) Save upto 49",
                                      "choices": [
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 10,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 19520,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "38 ratings",
                                      "ratingCountV2": "38"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184134",
                                  "name": "Spinach'n Cheese Patty Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "The goodness of a nutritious spinach, green peas & cottage cheese based patty  combined with your favourite veggies and sauces served on a bread of your choice. Serving size : 15 cm - 280 g / 524 kcal , 30 cm - 560 g / 1048 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "isVeg": 1,
                                  "price": 23809,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29364697",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Spinach'n Cheese Patty 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "92026363",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Spinach'n Cheese Patty (Footlong)",
                                            "price": 185.71,
                                            "id": "92026364",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "29364697",
                                            "variationId": "92026363"
                                          }
                                        ],
                                        "price": 23810,
                                        "addonCombinations": [
                                          {
                                            "groupId": "97547303",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "97547303",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "97547303",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "97547303",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "97547303",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "97547307",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "97547313",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "97547320",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "97547317",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "97547311",
                                            "addonId": "93560331"
                                          },
                                          {
                                            "groupId": "97547311",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "97547311",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "97547311",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "97547311",
                                            "addonId": "93560312"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "29364697",
                                            "variationId": "92026364"
                                          }
                                        ],
                                        "price": 42381,
                                        "addonCombinations": [
                                          {
                                            "groupId": "97547321",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "97547321",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "97547321",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "97547321",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "97547321",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "97547321",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "97547304",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "97547304",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "97547304",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "97547304",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "97547304",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "97547312",
                                            "addonId": "93560332"
                                          },
                                          {
                                            "groupId": "97547312",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "97547312",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "97547312",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "97547312",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "97547318",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "97547308",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "97547314",
                                            "addonId": "58929131"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547303",
                                      "groupName": "Choose From Choice of Bread for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547304",
                                      "groupName": "Choose From Choice of Bread for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547307",
                                      "groupName": "Choose From Choice of Preparation for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547308",
                                      "groupName": "Choose From Choice of Preparation for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547311",
                                      "groupName": "Choose From P. Add On for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "93560331",
                                          "name": "Extra Spinach'n Cheese Patty",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547312",
                                      "groupName": "Choose From P. Add On for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "93560332",
                                          "name": "Extra Spinach'n Cheese Patty Footlong",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547313",
                                      "groupName": "Choose From Choice of Vegetable for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547314",
                                      "groupName": "Choose From Choice of Vegetable for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547317",
                                      "groupName": "Choose From Choice of Sauces for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547318",
                                      "groupName": "Choose From Choice of Sauces for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547320",
                                      "groupName": "Choose From Offers @99 for Spinach'n Cheese Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547321",
                                      "groupName": "Choose From Offers @99 for Spinach'n Cheese Patty (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23810,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184133",
                                  "name": "Chilli Bean Patty Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "A refreshing filling of red and black kidney beans patty topped with aromatic seasoning along with your choice of veggies and sauces served on a freshly baked bread. Serving size : 15 cm - 280 g / 555 kcal , 30 cm - 560 g / 1516 kcal. Allergens -Contains wheat, rye, barley, oats. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "isVeg": 1,
                                  "price": 23809,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29364696",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Chilli Bean Patty 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "92026359",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chilli Bean Patty 30cm (Footlong)",
                                            "price": 185.71,
                                            "id": "92026360",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "29364696",
                                            "variationId": "92026359"
                                          }
                                        ],
                                        "price": 23810,
                                        "addonCombinations": [
                                          {
                                            "groupId": "97547299",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "97547299",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "97547299",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "97547299",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "97547299",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "97547299",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "97547297",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "97547291",
                                            "addonId": "93560328"
                                          },
                                          {
                                            "groupId": "97547291",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "97547291",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "97547291",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "97547291",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "97547293",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "97547283",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "97547283",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "97547283",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "97547283",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "97547283",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "97547287",
                                            "addonId": "83747380"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "29364696",
                                            "variationId": "92026360"
                                          }
                                        ],
                                        "price": 42381,
                                        "addonCombinations": [
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "97547298",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "97547294",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "97547288",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "97547292",
                                            "addonId": "93560329"
                                          },
                                          {
                                            "groupId": "97547292",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "97547292",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "97547292",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "97547292",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "97547284",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "97547284",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "97547284",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "97547284",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "97547284",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "97547300",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547283",
                                      "groupName": "Choose From Choice of Bread for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547284",
                                      "groupName": "Choose From Choice of Bread for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547287",
                                      "groupName": "Choose From Choice of Preparation for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547288",
                                      "groupName": "Choose From Choice of Preparation for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547291",
                                      "groupName": "Choose From P. Add On for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "93560328",
                                          "name": "Extra Chilli Bean Patty",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547292",
                                      "groupName": "Choose From P. Add On for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "93560329",
                                          "name": "Extra Chilli Bean Patty Footlong",
                                          "price": 13000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547293",
                                      "groupName": "Choose From Choice of Vegetable for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547294",
                                      "groupName": "Choose From Choice of Vegetable for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547297",
                                      "groupName": "Choose From Choice of Sauces for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547298",
                                      "groupName": "Choose From Choice of Sauces for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547299",
                                      "groupName": "Choose From Offers @99 for Chilli Bean Patty 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547300",
                                      "groupName": "Choose From Offers @99 for Chilli Bean Patty 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23810,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Sandwiches",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472241",
                                  "name": "Chicken Kofta Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Authentic indian meatballs perfectly seasoned and spiced served along with wholesome veggies and packed in your choice of freshly baked bread. Serving size : 15 cm - 224 g / 379 kcal , 30 cm - 448 g / 758 kcal. Allergens - Contains wheat, rye, barley, oats, soy, milk. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "sxljrq8gbaotjhs9dw2j",
                                  "price": 25240,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359066",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Chicken Koftas 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088789",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 200,
                                            "id": "76088790",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359066",
                                            "variationId": "76088789"
                                          }
                                        ],
                                        "price": 25240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790815",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368845",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790809",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790811",
                                            "addonId": "58929454"
                                          },
                                          {
                                            "groupId": "73790811",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790811",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790811",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790811",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790806",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790806",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790806",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790806",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790806",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790813",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359066",
                                            "variationId": "76088790"
                                          }
                                        ],
                                        "price": 45240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368846",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368846",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368846",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368846",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368846",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368846",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790814",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790812",
                                            "addonId": "58929455"
                                          },
                                          {
                                            "groupId": "73790812",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790812",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790812",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790812",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790810",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790808",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790808",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790808",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790808",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790808",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790817",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790806",
                                      "groupName": "Choose From Choice of Bread for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790808",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790809",
                                      "groupName": "Choose From Choice of Preparation for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790810",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790811",
                                      "groupName": "Choose From P. Add On for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929454",
                                          "name": "Extra Chicken Kofta",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790812",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929455",
                                          "name": "Extra Chicken Koftas Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790813",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790814",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790815",
                                      "groupName": "Choose From Choice of Sauces for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790817",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368845",
                                      "groupName": "Choose From Offers @99 for Chicken Koftas 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368846",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 25240,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472242",
                                  "name": "Chicken Slice Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Sliced smoked chicken with your choice of nutritious vegetables, served on a freshly baked bread. Serving size : 15 cm - 209 g / 290 kcal , 30 cm - 418 g / 580 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "bcgv9fq4aswuogw7owbt",
                                  "price": 25240,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359067",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Chicken Slice 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088791",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 200,
                                            "id": "76088792",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359067",
                                            "variationId": "76088791"
                                          }
                                        ],
                                        "price": 25240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368854",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368854",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368854",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368854",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368854",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368854",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790827",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790819",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790819",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790819",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790819",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790819",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790825",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790821",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790823",
                                            "addonId": "58929084"
                                          },
                                          {
                                            "groupId": "73790823",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790823",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790823",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790823",
                                            "addonId": "93560312"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359067",
                                            "variationId": "76088792"
                                          }
                                        ],
                                        "price": 45240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790820",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790820",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790820",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790820",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790820",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790822",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790826",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790829",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368855",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790824",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790824",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790824",
                                            "addonId": "58929089"
                                          },
                                          {
                                            "groupId": "73790824",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790824",
                                            "addonId": "93560330"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790819",
                                      "groupName": "Choose From Choice of Bread for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790820",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790821",
                                      "groupName": "Choose From Choice of Preparation for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790822",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790823",
                                      "groupName": "Choose From P. Add On for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929084",
                                          "name": "Extra Chicken Slice",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790824",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929089",
                                          "name": "Extra Chicken Slice Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790825",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790826",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790827",
                                      "groupName": "Choose From Choice of Sauces for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790829",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368854",
                                      "groupName": "Choose From Offers @99 for Chicken Slice 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368855",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 25240,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472243",
                                  "name": "Chicken Teriyaki Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Chicken strips glazed with teriyaki sauce, combined with your favourite veggies and topped with our signature sweet onion sauce served hot in a freshly baked bread of your choice. Serving size : 15 cm - 224 g / 311 kcal , 30 cm - 448 g / 622 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "iigw3gyqdbteyyo8pzzr",
                                  "price": 26190,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359068",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Chicken Teriyaki 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088793",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                            "price": 117.1,
                                            "id": "111292685",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 209.5,
                                            "id": "76088794",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359068",
                                            "variationId": "76088793"
                                          }
                                        ],
                                        "price": 26190,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790836",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790838",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368857",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790830",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790830",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790830",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790830",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790830",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790834",
                                            "addonId": "58929456"
                                          },
                                          {
                                            "groupId": "73790834",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790834",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790834",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790834",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790832",
                                            "addonId": "83747379"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359068",
                                            "variationId": "111292685"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272728",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272732",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272733",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272730",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272730",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272730",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272730",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272730",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272731",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272729",
                                            "addonId": "58929456"
                                          },
                                          {
                                            "groupId": "128272729",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272729",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272727",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272727",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272727",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272727",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272734",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359068",
                                            "variationId": "76088794"
                                          }
                                        ],
                                        "price": 47140,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790833",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790833",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790833",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790833",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790833",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790833",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790835",
                                            "addonId": "58929457"
                                          },
                                          {
                                            "groupId": "73790835",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790835",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790835",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790835",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790837",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790831",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790831",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790831",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790831",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790831",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790839",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368858",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272727",
                                      "groupName": "Choose From Snacks for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272728",
                                      "groupName": "Choose From Drinks Coke for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790830",
                                      "groupName": "Choose From Choice of Bread for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790831",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272729",
                                      "groupName": "Choose From P. Add On for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929456",
                                          "name": "Extra Chicken Teriyaki",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790832",
                                      "groupName": "Choose From Choice of Preparation for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790833",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272730",
                                      "groupName": "Choose From Choice of Bread for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790834",
                                      "groupName": "Choose From P. Add On for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929456",
                                          "name": "Extra Chicken Teriyaki",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790835",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929457",
                                          "name": "Extra Chicken Teriyaki Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272731",
                                      "groupName": "Choose From Choice of Preparation for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790836",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790837",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272732",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790838",
                                      "groupName": "Choose From Choice of Sauces for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790839",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272733",
                                      "groupName": "Choose From Choice of Sauces for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368857",
                                      "groupName": "Choose From Offers @99 for Chicken Teriyaki 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368858",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272734",
                                      "groupName": "Choose From Offers @99 for Chicken Teriyaki Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 26190,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472253",
                                  "name": "New B.M.T Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Protein-enriched classic Italian B.M.T. sub with a mix of tasty chicken pepperoni, smoked chicken slice topped with your fav sauce to deliver a flavour burst that is served in your choice of freshly baked bread. Serving size : 15 cm - 251 g / 349 kcal , 30 cm - 502 g / 698 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "lsq20yevnkxuoripkq5z",
                                  "price": 26190,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359077",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "New B.M.T. 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088811",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "B.M.T. Combo(Side+Drink) Save upto 49%",
                                            "price": 137.1,
                                            "id": "111292678",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "New B.M.T. 30cm (Footlong)",
                                            "price": 209.5,
                                            "id": "76088812",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359077",
                                            "variationId": "76088811"
                                          }
                                        ],
                                        "price": 26190,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368964",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368964",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368964",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368964",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368964",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368964",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790966",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790958",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790958",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790958",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790958",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790958",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790960",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790962",
                                            "addonId": "58929537"
                                          },
                                          {
                                            "groupId": "73790962",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790962",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790962",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790962",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790964",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359077",
                                            "variationId": "111292678"
                                          }
                                        ],
                                        "price": 39900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272667",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272667",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272667",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272667",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272670",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272670",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272670",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272670",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272670",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272671",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272669",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272669",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272674",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272672",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272668",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272673",
                                            "addonId": "58929151"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359077",
                                            "variationId": "76088812"
                                          }
                                        ],
                                        "price": 47140,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790961",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790961",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790961",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790961",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790961",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790961",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790963",
                                            "addonId": "58929596"
                                          },
                                          {
                                            "groupId": "73790963",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790963",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790963",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790959",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790959",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790959",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790959",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790959",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790965",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790967",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368965",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272667",
                                      "groupName": "Choose From Snacks for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272668",
                                      "groupName": "Choose From Drinks Coke for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790958",
                                      "groupName": "Choose From Choice of Bread for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790959",
                                      "groupName": "Choose From Choice of Bread for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272669",
                                      "groupName": "Choose From P. Add On for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790960",
                                      "groupName": "Choose From Choice of Preparation for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790961",
                                      "groupName": "Choose From Choice of Preparation for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272670",
                                      "groupName": "Choose From Choice of Bread for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790962",
                                      "groupName": "Choose From P. Add On for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929537",
                                          "name": "Extra New B.M.T. Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790963",
                                      "groupName": "Choose From P. Add On for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929596",
                                          "name": "Extra New B.M.T. Add30",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272671",
                                      "groupName": "Choose From Choice of Preparation for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790964",
                                      "groupName": "Choose From Choice of Vegetable for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790965",
                                      "groupName": "Choose From Choice of Vegetable for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272672",
                                      "groupName": "Choose From Choice of Vegetable for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790966",
                                      "groupName": "Choose From Choice of Sauces for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790967",
                                      "groupName": "Choose From Choice of Sauces for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272673",
                                      "groupName": "Choose From Choice of Sauces for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368964",
                                      "groupName": "Choose From Offers @99 for New B.M.T. 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368965",
                                      "groupName": "Choose From Offers @99 for New B.M.T. 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272674",
                                      "groupName": "Choose From Offers @99 for B.M.T. Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 26190,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472255",
                                  "name": "New Peri Peri Chicken Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Let your tastebuds travel the world with African peri-peri flavoured chicken served with nutritious veggies and packaged in your favourite bread of choice. Serving size : 15 cm - 230 g / 383 kcal , 30 cm - 460 g / 766 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "m1ycfwqyybzqrwoemqfa",
                                  "price": 25240,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359079",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "New Peri Peri Chicken 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088815",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                            "price": 97.6,
                                            "id": "111292680",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "New Peri Peri Chicken 30cm (Footlong)",
                                            "price": 200,
                                            "id": "76088816",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359079",
                                            "variationId": "76088815"
                                          }
                                        ],
                                        "price": 25240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790986",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790982",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790980",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790980",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790980",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790980",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790980",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790988",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368969",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790984",
                                            "addonId": "58929599"
                                          },
                                          {
                                            "groupId": "73790984",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790984",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790984",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790984",
                                            "addonId": "58929052"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359079",
                                            "variationId": "111292680"
                                          }
                                        ],
                                        "price": 35000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272689",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272690",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272691",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272686",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272686",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272684",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272684",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272684",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272684",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272687",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272687",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272687",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272687",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272687",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272685",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272688",
                                            "addonId": "83747380"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359079",
                                            "variationId": "76088816"
                                          }
                                        ],
                                        "price": 45240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "78368970",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368970",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368970",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368970",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368970",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368970",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790985",
                                            "addonId": "58929600"
                                          },
                                          {
                                            "groupId": "73790985",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790985",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790985",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790987",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790983",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790981",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790981",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790981",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790981",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790981",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790989",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272684",
                                      "groupName": "Choose From Snacks for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272685",
                                      "groupName": "Choose From Drinks Coke for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790980",
                                      "groupName": "Choose From Choice of Bread for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790981",
                                      "groupName": "Choose From Choice of Bread for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272686",
                                      "groupName": "Choose From P. Add On for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790982",
                                      "groupName": "Choose From Choice of Preparation for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790983",
                                      "groupName": "Choose From Choice of Preparation for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272687",
                                      "groupName": "Choose From Choice of Bread for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790984",
                                      "groupName": "Choose From P. Add On for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929599",
                                          "name": "Extra New Peri Peri Chicken Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790985",
                                      "groupName": "Choose From P. Add On for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929600",
                                          "name": "Extra New Peri Peri Chicken Add30",
                                          "price": 16000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272688",
                                      "groupName": "Choose From Choice of Preparation for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790986",
                                      "groupName": "Choose From Choice of Vegetable for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790987",
                                      "groupName": "Choose From Choice of Vegetable for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272689",
                                      "groupName": "Choose From Choice of Vegetable for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790988",
                                      "groupName": "Choose From Choice of Sauces for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790989",
                                      "groupName": "Choose From Choice of Sauces for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272690",
                                      "groupName": "Choose From Choice of Sauces for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368969",
                                      "groupName": "Choose From Offers @99 for New Peri Peri Chicken 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368970",
                                      "groupName": "Choose From Offers @99 for New Peri Peri Chicken 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272691",
                                      "groupName": "Choose From Offers @99 for Peri Peri Chicken Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 25240,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "34 ratings",
                                      "ratingCountV2": "34"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472248",
                                  "name": "Tandoori Chicken Tikka Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Hearty chicken marinated with flavorful ingredients like yogurt, garlic and ginger, oven cooked with trademark tandoori tikka taste and served with veggies and sauces in your favourite bread. Serving size : 15 cm - 224 g / 341 kcal , 30 cm - 448 g / 682 kcal. Allergens - Contains wheat, rye, barley, oats, soy, milk. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "zpmz8kmwbbfptd8ahya0",
                                  "price": 25240,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359072",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Tandoori Chicken Tikka 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088801",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                            "price": 97.6,
                                            "id": "111292687",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 200,
                                            "id": "76088802",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359072",
                                            "variationId": "76088801"
                                          }
                                        ],
                                        "price": 25240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790894",
                                            "addonId": "58929524"
                                          },
                                          {
                                            "groupId": "73790894",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790894",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790894",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790894",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790898",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368867",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790890",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790890",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790890",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790890",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790890",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790892",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790896",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359072",
                                            "variationId": "111292687"
                                          }
                                        ],
                                        "price": 35000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272744",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272749",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272750",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272748",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272747",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272745",
                                            "addonId": "58929524"
                                          },
                                          {
                                            "groupId": "128272745",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272745",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272746",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272746",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272746",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272746",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272746",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272743",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272743",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272743",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272743",
                                            "addonId": "109454189"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359072",
                                            "variationId": "76088802"
                                          }
                                        ],
                                        "price": 45240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790893",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790893",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790893",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790893",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790893",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790893",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790895",
                                            "addonId": "58929539"
                                          },
                                          {
                                            "groupId": "73790895",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790895",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790895",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790891",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790891",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790891",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790891",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790891",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790897",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790899",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368868",
                                            "addonId": "109454190"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272743",
                                      "groupName": "Choose From Snacks for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272744",
                                      "groupName": "Choose From Drinks Coke for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790890",
                                      "groupName": "Choose From Choice of Bread for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790891",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272745",
                                      "groupName": "Choose From P. Add On for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929524",
                                          "name": "Extra Tandoori Chicken Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790892",
                                      "groupName": "Choose From Choice of Preparation for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790893",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272746",
                                      "groupName": "Choose From Choice of Bread for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790894",
                                      "groupName": "Choose From P. Add On for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929524",
                                          "name": "Extra Tandoori Chicken Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790895",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929539",
                                          "name": "Extra Tandoori Chicken Tikka Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272747",
                                      "groupName": "Choose From Choice of Preparation for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790896",
                                      "groupName": "Choose From Choice of Vegetable for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790897",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272748",
                                      "groupName": "Choose From Choice of Vegetable for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790898",
                                      "groupName": "Choose From Choice of Sauces for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790899",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272749",
                                      "groupName": "Choose From Choice of Sauces for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368867",
                                      "groupName": "Choose From Offers @99 for Tandoori Chicken Tikka 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368868",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272750",
                                      "groupName": "Choose From Offers @99 for Tandoori Chicken Tikka Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 25240,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472250",
                                  "name": "Tuna Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Flaked light tuna mixed with eggless mayo and heaped onto your choice of freshly baked bread. You will love every bite of our classic tuna sandwich. Serving size : 15 cm - 219 g / 384 kcal , 30 cm - 438 g / 768 kcal. Allergens - Contains wheat, rye, barley, oats, fish, milk. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "phmsnwsh4igtnsu1zmsu",
                                  "price": 26190,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359074",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Tuna 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088805",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 209.5,
                                            "id": "76088806",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359074",
                                            "variationId": "76088805"
                                          }
                                        ],
                                        "price": 26190,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790913",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790913",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790913",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790913",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790913",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790915",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790915",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790915",
                                            "addonId": "58929053"
                                          },
                                          {
                                            "groupId": "73790915",
                                            "addonId": "58929525"
                                          },
                                          {
                                            "groupId": "73790915",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "73790911",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790911",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790911",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790911",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790911",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790919",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790917",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368869",
                                            "addonId": "109454192"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359074",
                                            "variationId": "76088806"
                                          }
                                        ],
                                        "price": 47140,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790920",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790918",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790914",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790914",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790914",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790914",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790914",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790912",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790912",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790912",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790912",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790912",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368870",
                                            "addonId": "109454192"
                                          },
                                          {
                                            "groupId": "73790916",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790916",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790916",
                                            "addonId": "58929057"
                                          },
                                          {
                                            "groupId": "73790916",
                                            "addonId": "58929556"
                                          },
                                          {
                                            "groupId": "73790916",
                                            "addonId": "93560330"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790911",
                                      "groupName": "Choose From Choice of Bread for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790912",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790913",
                                      "groupName": "Choose From Choice of Preparation for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790914",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790915",
                                      "groupName": "Choose From P. Add On for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929525",
                                          "name": "Extra Tuna",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790916",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929057",
                                          "name": "Extra Mozzarella Cheese Footlong",
                                          "price": 5710,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929556",
                                          "name": "Extra Tuna Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790917",
                                      "groupName": "Choose From Choice of Vegetable for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790918",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790919",
                                      "groupName": "Choose From Choice of Sauces for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790920",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368869",
                                      "groupName": "Choose From Offers @99 for Tuna 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368870",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 26190,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472247",
                                  "name": "Roasted Chicken Strip Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Serves 1 | Classic preparation of succulent strips of smoked chicken served with veggies and sauces in your choice of freshly baked bread. Serving size : 15 cm - 224 g / 301 kcal , 30 cm - 448 g / 602 kcal. Allergens - Contains wheat, rye, barley, oats, soy. Values include multigrain bread, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "pjs0s2n8fc5fbhb4xjvk",
                                  "price": 25240,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "23359071",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Roasted Chicken Strips 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "76088799",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                            "price": 97.6,
                                            "id": "111292684",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "30 cm (Footlong)",
                                            "price": 200,
                                            "id": "76088800",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359071",
                                            "variationId": "76088799"
                                          }
                                        ],
                                        "price": 25240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790886",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790880",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "73790880",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "73790880",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "73790880",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "73790880",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790882",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "73790884",
                                            "addonId": "58929522"
                                          },
                                          {
                                            "groupId": "73790884",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "73790884",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "73790884",
                                            "addonId": "58929052"
                                          },
                                          {
                                            "groupId": "73790884",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368862",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790888",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359071",
                                            "variationId": "111292684"
                                          }
                                        ],
                                        "price": 35000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "128272722",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "128272722",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "128272722",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "128272722",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "128272722",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "128272722",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "128272720",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "128272720",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "128272721",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "128272721",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "128272721",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "128272721",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "128272721",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "128272718",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "128272718",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "128272718",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "128272718",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "128272724",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "128272719",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "128272725",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "128272723",
                                            "addonId": "58929059"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "23359071",
                                            "variationId": "76088800"
                                          }
                                        ],
                                        "price": 45240,
                                        "addonCombinations": [
                                          {
                                            "groupId": "73790881",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "73790881",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "73790881",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "73790881",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "73790881",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "73790885",
                                            "addonId": "58929541"
                                          },
                                          {
                                            "groupId": "73790885",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "73790885",
                                            "addonId": "58929056"
                                          },
                                          {
                                            "groupId": "73790885",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "73790883",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "78368863",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "73790887",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "73790889",
                                            "addonId": "58929155"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "128272718",
                                      "groupName": "Choose From Snacks for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272719",
                                      "groupName": "Choose From Drinks Coke for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790880",
                                      "groupName": "Choose From Choice of Bread for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790881",
                                      "groupName": "Choose From Choice of Bread for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272720",
                                      "groupName": "Choose From P. Add On for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790882",
                                      "groupName": "Choose From Choice of Preparation for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790883",
                                      "groupName": "Choose From Choice of Preparation for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272721",
                                      "groupName": "Choose From Choice of Bread for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790884",
                                      "groupName": "Choose From P. Add On for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929522",
                                          "name": "Extra Smoked Chicken Strips",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790885",
                                      "groupName": "Choose From P. Add On for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929541",
                                          "name": "Extra Smoked Chicken Strips Footlong",
                                          "price": 13330,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929056",
                                          "name": "Extra Double Egg Footlong",
                                          "price": 8570,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272722",
                                      "groupName": "Choose From Choice of Preparation for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790886",
                                      "groupName": "Choose From Choice of Vegetable for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790887",
                                      "groupName": "Choose From Choice of Vegetable for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272723",
                                      "groupName": "Choose From Choice of Vegetable for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790888",
                                      "groupName": "Choose From Choice of Sauces for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790889",
                                      "groupName": "Choose From Choice of Sauces for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "128272724",
                                      "groupName": "Choose From Choice of Sauces for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368862",
                                      "groupName": "Choose From Offers @99 for Roasted Chicken Strips 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368863",
                                      "groupName": "Choose From Offers @99 for 30 cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "128272725",
                                      "groupName": "Choose From Offers @99 for Roasted Chicken Strips Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 25240,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131084634",
                                  "name": "Spicy Chicken Keema Sandwich",
                                  "category": "Create Your Own Sandwiches",
                                  "description": "Spicy & juicy chicken keema served along with wholesome veggies and packed in your choice of freshly baked bread. Serving size -280 g / 510 kcal. Allergens- Contains wheat, rye, barley, oats, milk, soy.",
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36018893",
                                        "name": "Choose From Variant",
                                        "variations": [
                                          {
                                            "name": "Spicy Chicken Keema 15cm [6 Inches]",
                                            "default": 1,
                                            "id": "111827023",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                            "price": 150,
                                            "id": "111827024",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Make Cheese Pull Spicy Chicken Keema 15cm",
                                            "price": 50,
                                            "id": "111827025",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Make Cheese Pull Spicy Chicken Keema 30cm",
                                            "price": 260,
                                            "id": "111827026",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Spicy Chicken Keema 30cm (Footlong)",
                                            "price": 160,
                                            "id": "111827027",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36018893",
                                            "variationId": "111827023"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129036866",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "129036866",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "129036866",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "129036866",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "129036866",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "129036870",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "129036876",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "129036879",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "129036882",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "129036873",
                                            "addonId": "94836158"
                                          },
                                          {
                                            "groupId": "129036873",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "129036873",
                                            "addonId": "93560312"
                                          },
                                          {
                                            "groupId": "129036873",
                                            "addonId": "58929053"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36018893",
                                            "variationId": "111827024"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129036884",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "129036884",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "129036884",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "129036884",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "129036884",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "129036884",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454191"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454257"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454199"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454196"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454197"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454198"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454194"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454195"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454273"
                                          },
                                          {
                                            "groupId": "129036865",
                                            "addonId": "109454272"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "109454227"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "109454228"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "129036875",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "129036864",
                                            "addonId": "109454200"
                                          },
                                          {
                                            "groupId": "129036864",
                                            "addonId": "109454219"
                                          },
                                          {
                                            "groupId": "129036864",
                                            "addonId": "109454229"
                                          },
                                          {
                                            "groupId": "129036864",
                                            "addonId": "109454189"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "129036881",
                                            "addonId": "58929151"
                                          },
                                          {
                                            "groupId": "129036872",
                                            "addonId": "58929034"
                                          },
                                          {
                                            "groupId": "129036872",
                                            "addonId": "58929031"
                                          },
                                          {
                                            "groupId": "129036872",
                                            "addonId": "58929032"
                                          },
                                          {
                                            "groupId": "129036872",
                                            "addonId": "58929033"
                                          },
                                          {
                                            "groupId": "129036872",
                                            "addonId": "58929035"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "129036878",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "129036868",
                                            "addonId": "58929051"
                                          },
                                          {
                                            "groupId": "129036868",
                                            "addonId": "94836158"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36018893",
                                            "variationId": "111827025"
                                          }
                                        ],
                                        "price": 24900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36018893",
                                            "variationId": "111827026"
                                          }
                                        ],
                                        "price": 45900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36018893",
                                            "variationId": "111827027"
                                          }
                                        ],
                                        "price": 35900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929132"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929135"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929137"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929059"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929130"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929133"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929129"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929134"
                                          },
                                          {
                                            "groupId": "129036877",
                                            "addonId": "58929131"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "63235876"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "63235874"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "63235875"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "63235878"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "63235877"
                                          },
                                          {
                                            "groupId": "129036883",
                                            "addonId": "109454190"
                                          },
                                          {
                                            "groupId": "129036867",
                                            "addonId": "58929040"
                                          },
                                          {
                                            "groupId": "129036867",
                                            "addonId": "58929037"
                                          },
                                          {
                                            "groupId": "129036867",
                                            "addonId": "58929036"
                                          },
                                          {
                                            "groupId": "129036867",
                                            "addonId": "58929038"
                                          },
                                          {
                                            "groupId": "129036867",
                                            "addonId": "58929039"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "58929041"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "58929044"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "109454220"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "109454202"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "83747379"
                                          },
                                          {
                                            "groupId": "129036871",
                                            "addonId": "83747380"
                                          },
                                          {
                                            "groupId": "129036874",
                                            "addonId": "58929055"
                                          },
                                          {
                                            "groupId": "129036874",
                                            "addonId": "58929057"
                                          },
                                          {
                                            "groupId": "129036874",
                                            "addonId": "94836159"
                                          },
                                          {
                                            "groupId": "129036874",
                                            "addonId": "93560330"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929149"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929155"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929152"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929147"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929154"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929061"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929153"
                                          },
                                          {
                                            "groupId": "129036880",
                                            "addonId": "58929151"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129036864",
                                      "groupName": "Choose From Snacks for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454200",
                                          "name": "Oatmeal Raisin Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454219",
                                          "name": "Double Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454229",
                                          "name": "Dark Chunk Chocolate Cookie",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454189",
                                          "name": "Crispers - New",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036865",
                                      "groupName": "Choose From Drinks Coke for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "109454191",
                                          "name": "Coke 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454257",
                                          "name": "Fanta 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454199",
                                          "name": "Thums Up 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454196",
                                          "name": "Coke Zero 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454197",
                                          "name": "Sprite 330Ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454198",
                                          "name": "Coke 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454194",
                                          "name": "Sprite 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454195",
                                          "name": "Fanta 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454273",
                                          "name": "Coke Zero 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454272",
                                          "name": "Thums Up 475Ml Pet",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036866",
                                      "groupName": "Choose From Choice of Bread for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036867",
                                      "groupName": "Choose From Choice of Bread for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929040",
                                          "name": "White Italian Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929037",
                                          "name": "Multigrain Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929036",
                                          "name": "Multigrain Honey Oats Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929038",
                                          "name": "Parmesan Oregano Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929039",
                                          "name": "Roasted Garlic Bread 30cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036868",
                                      "groupName": "Choose From P. Add On for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036870",
                                      "groupName": "Choose From Choice of Preparation for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036871",
                                      "groupName": "Choose From Choice of Preparation for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454220",
                                          "name": "Grilled - footlong",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454202",
                                          "name": "Grilled n cheezy - footlong",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036872",
                                      "groupName": "Choose From Choice of Bread for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929034",
                                          "name": "White Italian Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929031",
                                          "name": "Multigrain Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929032",
                                          "name": "Multigrain Honey Oats Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929033",
                                          "name": "Parmesan Oregano Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929035",
                                          "name": "Roasted Garlic Bread 15cm",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036873",
                                      "groupName": "Choose From P. Add On for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "94836158",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 4762,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036874",
                                      "groupName": "Choose From P. Add On for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929055",
                                          "name": "Extra Cheese Slice Footlong",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929057",
                                          "name": "Extra Mozzarella Cheese Footlong",
                                          "price": 5710,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "94836159",
                                          "name": "Cheese Pull (Mozzarella)",
                                          "price": 9524,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560330",
                                          "name": "Pickled Onions Add30",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036875",
                                      "groupName": "Choose From Choice of Preparation for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929041",
                                          "name": "Plain Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929044",
                                          "name": "Toasted Bread",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454227",
                                          "name": "Grilled - 6-inch",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454228",
                                          "name": "Grilled n cheezy 6-inch",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747379",
                                          "name": "Plain n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747380",
                                          "name": "Toasted n cheezy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036876",
                                      "groupName": "Choose From Choice of Vegetable for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036877",
                                      "groupName": "Choose From Choice of Vegetable for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036878",
                                      "groupName": "Choose From Choice of Vegetable for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036879",
                                      "groupName": "Choose From Choice of Sauces for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036880",
                                      "groupName": "Choose From Choice of Sauces for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036881",
                                      "groupName": "Choose From Choice of Sauces for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036882",
                                      "groupName": "Choose From Offers @99 for Spicy Chicken Keema 15cm [6 Inches]",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036883",
                                      "groupName": "Choose From Offers @99 for Spicy Chicken Keema 30cm (Footlong)",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036884",
                                      "groupName": "Choose From Offers @99 for Spicy Chicken Keema Combo(Side+Drink) Save upto 49%",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 19900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Salads",
                      "categories": [
                        {
                          "title": "Veg Salads",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305228",
                                  "name": "Corn & Peas Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Experience a symphony of colours with the corn and peas salad. Green peas, golden corn and diced carrots, all held together with a smooth and creamy eggless mayonnaise sauce. Serving size : 328 g / 169 kcal. Allergens - Contains milk. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "isVeg": 1,
                                  "price": 28570,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790990",
                                      "groupName": "Choose From Choice of Vegetable for Corn & Peas Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790991",
                                      "groupName": "Choose From P. Add On for Corn & Peas Salad",
                                      "choices": [
                                        {
                                          "id": "58929256",
                                          "name": "Extra Corn & Peas",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790992",
                                      "groupName": "Choose From Choice of Sauces for Corn & Peas Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369002",
                                      "groupName": "Choose From Offers @99 for Corn & Peas Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 28570,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305225",
                                  "name": "Aloo Patty Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Everything but the bread! A combination of perfectly blended aloo patty, tasty veggies and a lip-smacking dressing. Serving size : 328 g / 146 kcal. Allergens - NA. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "isVeg": 1,
                                  "price": 28570,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790994",
                                      "groupName": "Choose From Choice of Vegetable for Aloo Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790995",
                                      "groupName": "Choose From P. Add On for Aloo Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929117",
                                          "name": "Extra Aloo Patty",
                                          "price": 6190,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790996",
                                      "groupName": "Choose From Choice of Sauces for Aloo Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369003",
                                      "groupName": "Choose From Offers @99 for Aloo Patty Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 28570,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "21139158",
                                  "name": "Veggie Delite Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Enjoy the simpler things, the veggie delite salad is simply delish. A pile of your favourite veggies, finished with the dressing of your choice. Nutritious. Delicious. All for you. Serving size : 273 g / 52 kcal. Allergens - NA. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "isVeg": 1,
                                  "price": 28570,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73790997",
                                      "groupName": "Choose From Choice of Vegetable for Veggie Delite Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73790998",
                                      "groupName": "Choose From P. Add On for Veggie Delite Salad",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73790999",
                                      "groupName": "Choose From Choice of Sauces for Veggie Delite Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369011",
                                      "groupName": "Choose From Offers @99 for Veggie Delite Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 28570,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "70 ratings",
                                      "ratingCountV2": "70"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305224",
                                  "name": "Veg Shammi Kebab Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Experience authentic Indian flavours with the veg shammi kebab salad. A delicious kebab made of lentils & aromatic spices combined with veggies and your favourite dressing. Serving size : 333 g / 175 kcal. Allergens - Contains soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "isVeg": 1,
                                  "price": 28570,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791015",
                                      "groupName": "Choose From Choice of Vegetable for Veg Shammi Kebab Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791016",
                                      "groupName": "Choose From P. Add On for Veg Shammi Kebab Salad",
                                      "choices": [
                                        {
                                          "id": "58929453",
                                          "name": "Extra Veg Shammi",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791017",
                                      "groupName": "Choose From Choice of Sauces for Veg Shammi Kebab Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369015",
                                      "groupName": "Choose From Offers @99 for Veg Shammi Kebab Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 28570,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305226",
                                  "name": "Tangy Paneer Tikka Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Want a familiar taste taken up a notch? Try the paneer tikka salad. Perfectly cooked paneer tikka combined with fresh veggies and a dressing of your choice. Serving size : 333 g / 220 kcal. Allergens - Contains milk, soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "isVeg": 1,
                                  "price": 28570,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791022",
                                      "groupName": "Choose From Choice of Vegetable for Paneer Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791023",
                                      "groupName": "Choose From P. Add On for Paneer Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929450",
                                          "name": "Extra Paneer Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791024",
                                      "groupName": "Choose From Choice of Sauces for Paneer Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369020",
                                      "groupName": "Choose From Offers @99 for Paneer Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 28570,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184140",
                                  "name": "Spinach'n Cheese Patty Salad",
                                  "category": "Salads",
                                  "description": "Want to go green, then go for the spinach'n cheese salad. A spinach, peas & cottage cheese based patty combined with the variety of veggies, and topped with your favourite dressing. Serving+D7 size : 425 g / 409 kcal. Allergens - Contains wheat, soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives. Values do not include salad dressing or croutons, unless noted.",
                                  "isVeg": 1,
                                  "price": 28571,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547341",
                                      "groupName": "Choose From Choice of Vegetable for Spinach'n Cheese Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547342",
                                      "groupName": "Choose From P. Add On for Spinach'n Cheese Patty Salad",
                                      "choices": [
                                        {
                                          "id": "93560331",
                                          "name": "Extra Spinach'n Cheese Patty",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547343",
                                      "groupName": "Choose From Choice of Sauces for Spinach'n Cheese Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547344",
                                      "groupName": "Choose From Offers @99 for Spinach'n Cheese Patty Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28571,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184132",
                                  "name": "Chilli Bean Patty Salad",
                                  "category": "Salads",
                                  "description": "Want to try something with a kick, then go for the chili bean patty. A tasty patty made with red and black kidney beans, combined with your favourite veggies and dressing to give you a masterpiece. Serving size : 425 g / 455 kcal. Allergens - Contains wheat. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives. Values do not include salad dressing or croutons, unless noted.",
                                  "isVeg": 1,
                                  "price": 28571,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547279",
                                      "groupName": "Choose From Choice of Vegetable for Chilli Bean Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547280",
                                      "groupName": "Choose From P. Add On for Chilli Bean Patty Salad",
                                      "choices": [
                                        {
                                          "id": "93560328",
                                          "name": "Extra Chilli Bean Patty",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547281",
                                      "groupName": "Choose From Choice of Sauces for Chilli Bean Patty Salad",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547282",
                                      "groupName": "Choose From Offers @99 for Chilli Bean Patty Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28571,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Salads",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305234",
                                  "name": "Chicken Slice Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Simple. Delicious. Smoked chicken slices topped on wholesome and nutritious veggies with your favourite sauce. Serving size : 318 g / 100 kcal. Allergens - Contains soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791030",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Slice Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791032",
                                      "groupName": "Choose From P. Add On for Chicken Slice Salad",
                                      "choices": [
                                        {
                                          "id": "58929084",
                                          "name": "Extra Chicken Slice",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791033",
                                      "groupName": "Choose From Choice of Sauces for Chicken Slice Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369028",
                                      "groupName": "Choose From Offers @99 for Chicken Slice Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472259",
                                  "name": "Smoked Chicken Strips Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Classic preparation of succulent smoked chicken strips, along with your favourite veggies and sauces. Serving size : 333 g / 110 kcal. Allergens - Contains soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791034",
                                      "groupName": "Choose From Choice of Vegetable for Smoked Chicken Strips Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791035",
                                      "groupName": "Choose From P. Add On for Smoked Chicken Strips Salad",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929522",
                                          "name": "Extra Smoked Chicken Strips",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791036",
                                      "groupName": "Choose From Choice of Sauces for Smoked Chicken Strips Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369030",
                                      "groupName": "Choose From Offers @99 for Smoked Chicken Strips Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305236",
                                  "name": "Chicken Teriyaki Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Enjoy our teriyaki flavours in a salad. Chicken strips glazed with teriyaki sauce, served with a generous pile of veggies and topped with sweet onion sauce. Serving size : 333 g / 120 kcal. Allergens - Contains wheat, soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791037",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Teriyaki Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791038",
                                      "groupName": "Choose From P. Add On for Chicken Teriyaki Salad",
                                      "choices": [
                                        {
                                          "id": "58929456",
                                          "name": "Extra Chicken Teriyaki",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791039",
                                      "groupName": "Choose From Choice of Sauces for Chicken Teriyaki Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369032",
                                      "groupName": "Choose From Offers @99 for Chicken Teriyaki Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "48 ratings",
                                      "ratingCountV2": "48"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472261",
                                  "name": "New B.M.T. Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Who said salads have to be boring! Turn your favourite sub into a salad today for a lighter option than your usual sub. Load it up with all the crisp veggies and top it with a tasty sauce. Our salads will have you coming back for more. Serving size : 397 g / 164 kcal. Allergens - Contains soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791064",
                                      "groupName": "Choose From Choice of Vegetable for New B.M.T. Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791065",
                                      "groupName": "Choose From P. Add On for New B.M.T. Salad",
                                      "choices": [
                                        {
                                          "id": "58929537",
                                          "name": "Extra New B.M.T. Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791066",
                                      "groupName": "Choose From Choice of Sauces for New B.M.T. Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369044",
                                      "groupName": "Choose From Offers @99 for New B.M.T. Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472262",
                                  "name": "New Peri Peri Chicken Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Let your tastebuds travel the world with African peri-peri flavoured chicken served with your favourite veggies and a delicious dressing. Serving size : 376 g / 199 kcal. Allergens - Contains soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791067",
                                      "groupName": "Choose From Choice of Vegetable for New Peri Peri Chicken Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791068",
                                      "groupName": "Choose From P. Add On for New Peri Peri Chicken Salad",
                                      "choices": [
                                        {
                                          "id": "58929599",
                                          "name": "Extra New Peri Peri Chicken Add15",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791069",
                                      "groupName": "Choose From Choice of Sauces for New Peri Peri Chicken Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369045",
                                      "groupName": "Choose From Offers @99 for New Peri Peri Chicken Salad",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472260",
                                  "name": "Chicken Koftas Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | The chicken meatball salad is the ultimate craving crusher. Authentic Indian meatballs sitting on a bed of your favourite veggies along with your favourite dressing. Serving size : 333 g / 189 kcal. Allergens - Contains wheat, milk, soy. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791043",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Koftas Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791044",
                                      "groupName": "Choose From P. Add On for Chicken Koftas Salad",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929454",
                                          "name": "Extra Chicken Kofta",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791045",
                                      "groupName": "Choose From Choice of Sauces for Chicken Koftas Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369035",
                                      "groupName": "Choose From Offers @99 for Chicken Koftas Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305238",
                                  "name": "Tuna Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Flaked light tuna mixed with eggless mayo and added to your choice of veggies. A classic. Serving size : 328 g / 194 kcal. Allergens - Contains milk, fish. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791046",
                                      "groupName": "Choose From Choice of Vegetable for Tuna Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791047",
                                      "groupName": "Choose From P. Add On for Tuna Salad",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929525",
                                          "name": "Extra Tuna",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791048",
                                      "groupName": "Choose From Choice of Sauces for Tuna Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78369038",
                                      "groupName": "Choose From Offers @99 for Tuna Salad",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "39 ratings",
                                      "ratingCountV2": "39"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305232",
                                  "name": "Tandoori Chicken Tikka Salad",
                                  "category": "Salads",
                                  "description": "Serves 1 | Hearty chicken marinated with Indian spices and cooked to perfection. This hearty taste is combined with fresh veggies and your choice of dressing. Serving size : 333 g / 151 kcal. Allergens - Contains milk, soy, wheat. Values include lettuce, tomatoes, green peppers, cucumbers, onions and olives.  Values do not include salad dressing or croutons, unless noted.",
                                  "imageId": "tummkh3izaotrutlavn5",
                                  "price": 31430,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791049",
                                      "groupName": "Choose From Choice of Vegetable for Tandoori Chicken Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791050",
                                      "groupName": "Choose From P. Add On for Tandoori Chicken Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929524",
                                          "name": "Extra Tandoori Chicken Tikka",
                                          "price": 6670,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929052",
                                          "name": "Double Egg",
                                          "price": 4290,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791051",
                                      "groupName": "Choose From Choice of Sauces for Tandoori Chicken Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369042",
                                      "groupName": "Choose From Offers @99 for Tandoori Chicken Tikka Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 31430,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "27 ratings",
                                      "ratingCountV2": "27"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131084635",
                                  "name": "Spicy Chicken Keema Salad",
                                  "category": "Salads",
                                  "description": "Spicy & juicy chicken keema served along with wholesome veggies. Serving size -425 g / 393 kcal. Allergens- Contains wheat, milk, soy.",
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129036885",
                                      "groupName": "Choose From Choice of Vegetable for Spicy Chicken Keema Salad",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036886",
                                      "groupName": "Choose From P. Add On for Spicy Chicken Keema Salad",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036887",
                                      "groupName": "Choose From Choice of Sauces for Spicy Chicken Keema Salad",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036888",
                                      "groupName": "Choose From Offers @99 for Spicy Chicken Keema Salad",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Signature Wraps",
                      "categories": [
                        {
                          "title": "Veg Signature Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472265",
                                  "name": "Veggie Delite Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | A wholesome wrap that gives you double portion of nutritious veggies you love, with the best of sauces, packed inside a tortilla of your choice. Serving size : 181 g / 287 kcal. Allergens - Contains wheat, barley, oats. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "raeb758kq0nnji0q9mmc",
                                  "isVeg": 1,
                                  "price": 27140,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791079",
                                      "groupName": "Choose From Choice of Tortillas for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791080",
                                      "groupName": "Choose From Choice of Preparation for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791081",
                                      "groupName": "Choose From P. Add On for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791082",
                                      "groupName": "Choose From Choice of Vegetable for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791083",
                                      "groupName": "Choose From Choice of Sauces for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368972",
                                      "groupName": "Choose From Offers @99 for Veggie Delite Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 27140,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472268",
                                  "name": "Corn & Peas Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Not just colourful, but with double the filling. Double portion of nutritious green peas, golden corn, and diced carrots combined with a creamy eggless mayo sauces along with selected nutritious veggies and wrapped to perfection packed inside a tortilla of your choice. Serving size : 291 g / 521 kcal. Allergens - Contains wheat, barley, oats, milk. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "xj3obl9t3tmleemgworn",
                                  "isVeg": 1,
                                  "price": 27140,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791101",
                                      "groupName": "Choose From Choice of Tortillas for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791102",
                                      "groupName": "Choose From Choice of Preparation for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791104",
                                      "groupName": "Choose From P. Add On for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791105",
                                      "groupName": "Choose From Choice of Vegetable for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791106",
                                      "groupName": "Choose From Choice of Sauces for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368977",
                                      "groupName": "Choose From Offers @99 for Corn & Peas Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 27140,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472269",
                                  "name": "Aloo Patty Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Unique flavours that are truly one of a kind. Double portion of crispy aloo patty, topped with nutritious veggies and yummy sauces, packed inside a tortilla of your choice. Serving size : 291 g / 476 kcal. Allergens - Contains wheat, barley, oats. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "emek19gqqklrxw8e6dqz",
                                  "isVeg": 1,
                                  "price": 27140,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791107",
                                      "groupName": "Choose From Choice of Tortillas for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791108",
                                      "groupName": "Choose From Choice of Preparation for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791109",
                                      "groupName": "Choose From P. Add On for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791110",
                                      "groupName": "Choose From Choice of Vegetable for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791111",
                                      "groupName": "Choose From Choice of Sauces for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368978",
                                      "groupName": "Choose From Offers @99 for Aloo Patty Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 27140,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472273",
                                  "name": "Tangy Paneer Tikka Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Double the yum with double portion of roasted paneer tikka, along with nutritious veggies and your favourite sauces, inside a tortilla of your choice. Serving size : 301 g / 623 kcal. Allergens - Contains wheat, barley, oats, milk, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "ckvm3wl4lj4ahhodgmry",
                                  "isVeg": 1,
                                  "price": 27140,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791129",
                                      "groupName": "Choose From Choice of Tortillas for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791130",
                                      "groupName": "Choose From Choice of Preparation for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791131",
                                      "groupName": "Choose From P. Add On for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791132",
                                      "groupName": "Choose From Choice of Vegetable for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791133",
                                      "groupName": "Choose From Choice of Sauces for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368990",
                                      "groupName": "Choose From Offers @99 for Paneer Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 27140,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472272",
                                  "name": "Veg Shammi Kebab Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Double your dose of daily goodness. Enjoy mouth-watering kebab made of lentils, paired with selected veggies and tasty sauces, packed inside a tortilla of your choice. Serving size : 301 g / 533 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "dgenqzkyccmyohmdktyz",
                                  "isVeg": 1,
                                  "price": 27140,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791123",
                                      "groupName": "Choose From Choice of Tortillas for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791124",
                                      "groupName": "Choose From Choice of Preparation for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791125",
                                      "groupName": "Choose From P. Add On for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791126",
                                      "groupName": "Choose From Choice of Vegetable for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791127",
                                      "groupName": "Choose From Choice of Sauces for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368981",
                                      "groupName": "Choose From Offers @99 for Veg Shammi Kebab Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 27140,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184131",
                                  "name": "Spinach'n Cheese Patty Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Enjoy a wrap that is filled with double portion of nutritious and  spinach, peas & cottage cheese based patty. Topped with selected veggies and yummy sauces, packed inside a tortilla of your choice. Serving size : 350 g / 705 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\"\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "isVeg": 1,
                                  "price": 28095,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547273",
                                      "groupName": "Choose From Choice of Tortillas for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547274",
                                      "groupName": "Choose From Choice of Preparation for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547275",
                                      "groupName": "Choose From P. Add On for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547276",
                                      "groupName": "Choose From Choice of Vegetable for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547277",
                                      "groupName": "Choose From Choice of Sauces for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547278",
                                      "groupName": "Choose From Offers @99 for Spinach'n Cheese Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28095,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119184130",
                                  "name": "Chilli Bean Patty Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Enjoy this serving filled with double portion of chili bean patty you love, on a tortilla of your choice. Top it with your favourite veggies and sauces. Serving size : 350 g / 752 kcal. Allergens - Contains wheat, barley, oats. Values include 11.5\"\"\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "isVeg": 1,
                                  "price": 28095,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "97547267",
                                      "groupName": "Choose From Choice of Tortillas for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547268",
                                      "groupName": "Choose From Choice of Preparation for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547269",
                                      "groupName": "Choose From P. Add On for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "97547270",
                                      "groupName": "Choose From Choice of Vegetable for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547271",
                                      "groupName": "Choose From Choice of Sauces for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "97547272",
                                      "groupName": "Choose From Offers @99 for Chilli Bean Patty Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 28095,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non Veg Signature Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472274",
                                  "name": "Smoked Chicken Strips Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | A classic that packs the goodness of double the filling. Double portion of strips of smoked chicken, along with nutritious veggies and delicious sauces, served inside a tortilla of your choice. Serving size : 301 g / 404 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "spfj4dmcr8af4gbs1oy9",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791141",
                                      "groupName": "Choose From Choice of Tortillas for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791142",
                                      "groupName": "Choose From Choice of Preparation for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791143",
                                      "groupName": "Choose From P. Add On for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791144",
                                      "groupName": "Choose From Choice of Vegetable for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791146",
                                      "groupName": "Choose From Choice of Sauces for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368991",
                                      "groupName": "Choose From Offers @99 for Smoked Chicken Strips Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472275",
                                  "name": "Chicken Slice Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Get an explosion of yumminess! Double portion of sliced chicken combined with selected nutritious veggies and tasty sauces, wrapped to perfection inside a tortilla. Serving size : 271 g / 383 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "c5ahqsnxhstdzauttgg1",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791147",
                                      "groupName": "Choose From Choice of Tortillas for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791148",
                                      "groupName": "Choose From Choice of Preparation for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791149",
                                      "groupName": "Choose From P. Add On for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791150",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791151",
                                      "groupName": "Choose From Choice of Sauces for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368992",
                                      "groupName": "Choose From Offers @99 for Chicken Slice Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472282",
                                  "name": "New B.M.T. Sig Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | A protein overload that's balanced to perfection. Get double portion of chicken pepperoni, smoked chicken and topped with nutritious veggies along with yummy sauces, all wrapped inside a tortilla of your choice. Serving size : 349 g / 500 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "kzdlran9igeuts6jaslx",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791187",
                                      "groupName": "Choose From Choice of Tortillas for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791188",
                                      "groupName": "Choose From Choice of Preparation for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791189",
                                      "groupName": "Choose From P. Add On for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791190",
                                      "groupName": "Choose From Choice of Vegetable for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791191",
                                      "groupName": "Choose From Choice of Sauces for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368999",
                                      "groupName": "Choose From Offers @99 for New B.M.T. Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472283",
                                  "name": "New Peri Peri Chicken Sig Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Double portion of African peri-peri flavoured chicken, along with high protein nutritious veggies and sauces, inside a tortilla of your choice. Serving size : 307 g / 571 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "ipqfu3sga6t70kluxj7n",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791192",
                                      "groupName": "Choose From Choice of Tortillas for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791193",
                                      "groupName": "Choose From Choice of Preparation for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791194",
                                      "groupName": "Choose From P. Add On for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791195",
                                      "groupName": "Choose From Choice of Vegetable for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791196",
                                      "groupName": "Choose From Choice of Sauces for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78369000",
                                      "groupName": "Choose From Offers @99 for New Peri Peri Chicken Sig Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472276",
                                  "name": "Chicken Kofta Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Enjoy twice the amount of filling with this wrap. Double portion of authentic Indian chicken meatballs combined with nutritious veggies, inside a tortilla of your choice. Serving size : 301 g / 561 kcal. Allergens - Contains wheat, barley, oats, soy, milk. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "v3ty6vxbvfnraypmpvqy",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791153",
                                      "groupName": "Choose From Choice of Tortillas for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791154",
                                      "groupName": "Choose From Choice of Preparation for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791155",
                                      "groupName": "Choose From P. Add On for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791156",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791157",
                                      "groupName": "Choose From Choice of Sauces for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368993",
                                      "groupName": "Choose From Offers @99 for Chicken Kofta Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472277",
                                  "name": "Chicken Teriyaki Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Get double the goodness. Double portion of teriyaki glazed chicken strips along with nutritious veggies and your choice of sauces, wrapped inside a tortilla that you desire. Serving size : 301 g / 423 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "udrshjebt8ugwfthtpkj",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791158",
                                      "groupName": "Choose From Choice of Tortillas for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791159",
                                      "groupName": "Choose From Choice of Preparation for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791160",
                                      "groupName": "Choose From P. Add On for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791161",
                                      "groupName": "Choose From Choice of Vegetable for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791162",
                                      "groupName": "Choose From Choice of Sauces for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368994",
                                      "groupName": "Choose From Offers @99 for Chicken Teriyaki Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472279",
                                  "name": "Tuna Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Yummmy, its the tuna wrap! Double portion of flaked tuna mixed with mayo sauce, topped with selected veggies and wrapped inside a tortilla of your choice. Serving size : 291 g / 571 kcal. Allergens - Contains wheat, barley, oats, milk, fish. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "z2nml0idtptwswsdvpol",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791170",
                                      "groupName": "Choose From Choice of Tortillas for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791171",
                                      "groupName": "Choose From Choice of Preparation for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791172",
                                      "groupName": "Choose From P. Add On for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791173",
                                      "groupName": "Choose From Choice of Vegetable for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791174",
                                      "groupName": "Choose From Choice of Sauces for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "78368996",
                                      "groupName": "Choose From Offers @99 for Tuna Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454192",
                                          "name": "Veg Kebab (3 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472280",
                                  "name": "Tandoori Chicken Tikka Signature Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Serves 1 | Enjoy double the filling in this hearty wrap. Double portion of chicken paired with nutritious wonderful veggies and your choice of sauces, inside a tortilla. Now that's a meal for the soul! Serving size : 301 g / 485 kcal. Allergens - Contains wheat, barley, oats, soy, milk. Values include 11.5\"\" multigrain wrap, lettuce, tomatoes, onions, green peppers and cucumbers.",
                                  "imageId": "hhwfvq7sbweeje357vhs",
                                  "price": 30000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "73791178",
                                      "groupName": "Choose From Choice of Tortillas for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791177",
                                      "groupName": "Choose From Choice of Preparation for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791176",
                                      "groupName": "Choose From P. Add On for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "73791179",
                                      "groupName": "Choose From Choice of Vegetable for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "73791180",
                                      "groupName": "Choose From Choice of Sauces for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "78368997",
                                      "groupName": "Choose From Offers @99 for Tandoori Chicken Tikka Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "defaultPrice": 30000,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131084636",
                                  "name": "Spicy Chicken Keema Sig. Wrap",
                                  "category": "Signature Wraps",
                                  "description": "Spicy & juicy chicken keema served along with wholesome veggies and packed in your choice of wrap. Serving size -350 g / 677 kcal. Allergens- Contains wheat, rye, barley, oats, milk, soy.",
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129036889",
                                      "groupName": "Choose From Choice of Tortillas for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "58929633",
                                          "name": "Spinach Tortilla",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929632",
                                          "name": "Multigrain Tortillas",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036890",
                                      "groupName": "Choose From Choice of Preparation for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "58929635",
                                          "name": "Wrap Without Cheese",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "83747413",
                                          "name": "Warm n cheezy wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036891",
                                      "groupName": "Choose From P. Add On for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "58929053",
                                          "name": "Extra Mozzarella Cheese",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929051",
                                          "name": "Extra Cheese Slice",
                                          "price": 2860,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "93560312",
                                          "name": "Pickled Onions Add15",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129036892",
                                      "groupName": "Choose From Choice of Vegetable for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "58929132",
                                          "name": "Lettuce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929135",
                                          "name": "Pickle",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929137",
                                          "name": "Tomato",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929059",
                                          "name": "Salt & Pepper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929130",
                                          "name": "Cucumber",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929133",
                                          "name": "Olives",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929129",
                                          "name": "Capsicum",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929134",
                                          "name": "Onions",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929131",
                                          "name": "Jalapenos",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036893",
                                      "groupName": "Choose From Choice of Sauces for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "58929149",
                                          "name": "Honey Mustard Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929155",
                                          "name": "Tandoori Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929152",
                                          "name": "Red Chilli Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929147",
                                          "name": "Barbeque Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929154",
                                          "name": "Sweet Onion Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929061",
                                          "name": "Eggless Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929153",
                                          "name": "Southwest Chipotle Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "58929151",
                                          "name": "Mint Mayonnaise Sauce",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "129036894",
                                      "groupName": "Choose From Offers @99 for Spicy Chicken Keema Sig. Wrap",
                                      "choices": [
                                        {
                                          "id": "63235876",
                                          "name": "2 Oatmeal Raisin Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235874",
                                          "name": "2 Dark Chunk Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235875",
                                          "name": "2 Double Dark Choc Cookies",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235878",
                                          "name": "Chicken Meatballs (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "63235877",
                                          "name": "Veg Kebab (5 Pieces)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Sides - Try New Crispers",
                      "categories": [
                        {
                          "title": "Snacks",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666306",
                                  "name": "Crispers",
                                  "category": "Sides - Try New Crispers",
                                  "imageId": "bffe3c1557fb9a2a253427d55b6280f5",
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472285",
                                  "name": "Veg Kebab [5 Pieces]",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1 | Experience authentic flavours with a kebab made of lentils and enriched with mouth-watering hints of garlic and onion accompanied by nutritious veggies. Serving size - 100 g/ 205 kcal. Allergens - Contains soy.",
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472286",
                                  "name": "Chicken Meatballs [5 Pieces]",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1 | Authentic indian meatballs perfectly seasoned, spiced and served along with wholesome veggies. Serving size - 100 g/ 228 kcal. Allergens - Contains wheat, soy, milk.",
                                  "price": 13900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Sub Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "21138801",
                                  "name": "Veg Shammi Subwrap",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Multigrain tortilla filled with flavourful veg shammi kebab, lettuce, onion, tomato and mint mayo sauce. Serving size - 132 g/ 243 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 8\" multigrain wrap, lettuce, tomatoes and onions without sauce, unless noted.",
                                  "imageId": "tewjl7kqc4vrmm3hlb6u",
                                  "isVeg": 1,
                                  "price": 10480,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "20 ratings",
                                      "ratingCountV2": "20"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "21138815",
                                  "name": "Chicken Kofta Subwrap",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Multigrain tortilla filled with delectable chicken kofta, lettuce, onion, tomato and mint mayo sauce. Serving size - 112 g/ 211 kcal. Allergens - Contains wheat, barley, oats, soy, milk. Values include 8\" multigrain wrap, lettuce, tomatoes and onions without sauce, unless noted.",
                                  "imageId": "dwzghnr48fjifeynmv4s",
                                  "price": 12380,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472287",
                                  "name": "New Chicken Strips Sub Wrap",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Multigrain tortilla filled with high protein, delectable chicken strips, lettuce, onion, tomato and southwest mayo sauce. Serving size - 132 g/ 182 kcal. Allergens - Contains wheat, barley, oats, soy. Values include 8\" multigrain wrap, lettuce, tomatoes and onions without sauce, unless noted.",
                                  "price": 12380,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129036895",
                                      "groupName": "Choose From Offers @99 for New Chicken Strips Sub Wrap",
                                      "choices": [
                                        {
                                          "id": "109454190",
                                          "name": "Crispers - Try New",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 12380,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Toasties",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "96141649",
                                  "name": "Veggie & Cheese Toastie",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1 | The perfect on-the-go snack, enriched with mozzarella cheese and vegetables  - on a toasted bread. Serving size - 85 g/ 119 kcal. Allergens - Contains wheat, milk. Values include white bread, tomatoes, green peppers, onions with recommended sauce and mozzarella cheese.",
                                  "imageId": "clybq0zhqvc6kslbeqxx",
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Chips",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472288",
                                  "name": "Lays American Style Cream And Onion",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1",
                                  "imageId": "omcwlxpxpfkubthi2j50",
                                  "isVeg": 1,
                                  "price": 1428,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472289",
                                  "name": "Sizzling Jalapeno Cornitos",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1",
                                  "isVeg": 1,
                                  "price": 2860,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472291",
                                  "name": "Peri Peri Cornitos",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1",
                                  "isVeg": 1,
                                  "price": 2860,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472292",
                                  "name": "Cheese & Herbs Cornitos",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1",
                                  "isVeg": 1,
                                  "price": 2860,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472293",
                                  "name": "Barbeque Cornitos",
                                  "category": "Sides - Try New Crispers",
                                  "description": "Serves 1",
                                  "isVeg": 1,
                                  "price": 2860,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666307",
                                  "name": "Bingo Chip - C&O",
                                  "category": "Sides - Try New Crispers",
                                  "isVeg": 1,
                                  "price": 1905,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666308",
                                  "name": "Bingo Chips - Salt",
                                  "category": "Sides - Try New Crispers",
                                  "isVeg": 1,
                                  "price": 1905,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Beverages",
                      "categories": [
                        {
                          "title": "Drinks Coke",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666309",
                                  "name": "Coke 330ml Can",
                                  "category": "Beverages",
                                  "imageId": "210ce8741987e628d9dd4759cfdb0ed1",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666310",
                                  "name": "Coca-Cola zero 330ml Can",
                                  "category": "Beverages",
                                  "imageId": "a16e3b25a476d546a9b5a9a1bf0677e1",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666311",
                                  "name": "Sprite 330ml Can",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666312",
                                  "name": "Thums Up 330ml Can",
                                  "category": "Beverages",
                                  "imageId": "368728e01f525c3adf17b722eece3558",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666313",
                                  "name": "Fanta 330ml Can",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666314",
                                  "name": "Maaza 300ml Can",
                                  "category": "Beverages",
                                  "imageId": "126451dfd12260b0b71d827537ad3610",
                                  "isVeg": 1,
                                  "price": 9524,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666315",
                                  "name": "Minute Maid Pulpy orange 300ml Can",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 9524,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666316",
                                  "name": "Coke 475ml Pet",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666317",
                                  "name": "Coke Zero 475ml Pet",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666318",
                                  "name": "Sprite 475ml Pet",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666319",
                                  "name": "Thums Up 475ml Pet",
                                  "category": "Beverages",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130666320",
                                  "name": "Schweppes Water 500ml Pet",
                                  "category": "Beverages",
                                  "imageId": "cf669d5f29ed1c1d6a7e6bfffd7368fb",
                                  "isVeg": 1,
                                  "price": 6667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Raw Pressery",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115967656",
                                  "name": "Raw Choco Mint Protein Shake 195ml",
                                  "category": "Beverages",
                                  "imageId": "ebb3c8c06838a9a93ebb9bc819582868",
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115967655",
                                  "name": "Raw Mixed Fruit 175ml",
                                  "category": "Beverages",
                                  "imageId": "2f78c31b93c7664be7032b4af2dc6cd2",
                                  "isVeg": 1,
                                  "price": 9524,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115967652",
                                  "name": "Raw Sugarcane 245ml",
                                  "category": "Beverages",
                                  "imageId": "7d6169176a00a6acb8cdfef738df0aed",
                                  "isVeg": 1,
                                  "price": 9524,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115967651",
                                  "name": "Raw Valencia Orange 245ml",
                                  "category": "Beverages",
                                  "imageId": "10ebfec3bee06487121cb5c462fb3328",
                                  "isVeg": 1,
                                  "price": 11428,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472308",
                                  "name": "Raw Coconut Water 200ml",
                                  "category": "Beverages",
                                  "description": "Serves 1",
                                  "imageId": "qihrmi6uzvvpxkyppkjm",
                                  "isVeg": 1,
                                  "price": 9523,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "107472315",
                                  "name": "Raw Alphonso Mango Juice",
                                  "category": "Beverages",
                                  "description": "Serves 1",
                                  "isVeg": 1,
                                  "price": 9524,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Desserts",
                      "categories": [
                        {
                          "title": "Cookies",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "19305211",
                                  "name": "Oatmeal Raisin Cookie",
                                  "category": "Desserts",
                                  "description": "Serves 1 | Like something extra and sweet add some sweetness with your favourite oatmeal raisin cookies. Serving size : 50 g / 223 kcal. Allergens - Contains wheat, oats, egg.",
                                  "imageId": "qyog0wggjjguvv2gxt8t",
                                  "price": 5714,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68462179",
                                  "name": "Double Dark Chunk Chocolate Cookie",
                                  "category": "Desserts",
                                  "description": "Serves 1 | Tasty & chocolatey. Now enjoy your favourite double dark chocolate chunk cookie. Serving size : 50 g / 246 kcal. Allergens - Contains wheat, egg, soy.",
                                  "imageId": "axsqp4fz5gxddusk39ih",
                                  "price": 5710,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "49 ratings",
                                      "ratingCountV2": "49"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "68462190",
                                  "name": "Dark Chunk Chocolate Cookie",
                                  "category": "Desserts",
                                  "description": "Serves 1 | Craving for chocolate, now enjoy your favourite dark chunk chocolate cookie.Serving size : 50 g / 242 kcal. Allergens - Contains wheat, egg, milk, soy.",
                                  "imageId": "bzvs39tu9xkpmzxuhav8",
                                  "price": 5710,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "0 gram"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "36 ratings",
                                      "ratingCountV2": "36"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11219333000117"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Subway",
                      "area": "Ashok Nagar",
                      "completeAddress": "Ubcity 2nd level Vital mallya Road Bangalore"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "SioI8SMzCUoC-zTKC-zXPco43xw1bbJ2vFaBLKy0"
},
// 20240105233714
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=12808&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "12808",
              "name": "A2B - Adyar Ananda Bhavan",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "a2b-veg-cbd-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "pdod4o1em9potwsd22rs",
              "locality": "Wilson Garden",
              "areaName": "Shanti Nagar",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "South Indian",
                "North Indian"
              ],
              "avgRating": 4.5,
              "veg": true,
              "feeDetails": {
                "restaurantId": "12808",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4600
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4600,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "3 kms | ₹46 Delivery fee will apply"
              },
              "parentId": "22",
              "avgRatingString": "4.5",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "12808",
                "deliveryTime": 22,
                "minDeliveryTime": 22,
                "maxDeliveryTime": 22,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 33,
                "slaString": "22 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 5:30 am, Thursday",
                "nextOpenTime": "1970-01-01 05:30:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "a2b-veg-cbd-central-bangalore",
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Ground Floor, TTMC Shanthi Nagar, BMTC Bus Stand,Bangalore - 560027"
                },
                {
                  "title": "Cuisines",
                  "message": "South Indian,North Indian"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "visible": true
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/12808"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 5:30 am, Thursday",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! The outlet is not accepting orders at the moment. We're working to get them back online",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9544675,77.59312469999998"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220333000644"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "A2B - Adyar Ananda Bhavan",
                      "area": "Shanti Nagar",
                      "completeAddress": "Ground Floor, TTMC Shanthi Nagar, BMTC Bus Stand,Bangalore - 560027"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "B2tKwNEikxSy-Bo7vni-WB77KLOzstYo4_hn61g4"
},
// 20240105233746
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=396741&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "396741",
              "name": "Faasos - Wraps, Rolls & Shawarma",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "faasos-residency-road-shantinagar",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "af33b81798b11deba338e94b7585d348",
              "locality": "Residency Road",
              "areaName": "Shantinagar",
              "costForTwo": "20000",
              "costForTwoMessage": "₹200 for two",
              "cuisines": [
                "Kebabs",
                "Fast Food"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "396741",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 3800
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 3800,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "2.5 kms | ₹38 Delivery fee will apply"
              },
              "parentId": "21809",
              "avgRatingString": "4.3",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "396741",
                "deliveryTime": 23,
                "minDeliveryTime": 23,
                "maxDeliveryTime": 23,
                "lastMileTravel": 2.5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 33,
                "slaString": "23 MINS",
                "lastMileTravelString": "2.5 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-05 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "faasos-residency-road-shantinagar",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "KMK Towers, 1st floor, WEST PORTION, 142 K H ROAD, above Tata Motors, Shanthinagar, Bangalore South, bangalore, 560027"
                },
                {
                  "title": "Cuisines",
                  "message": "Kebabs,Fast Food"
                }
              ],
              "logo": "v1668596012/Brand logo/Faasos",
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 209,
                  "maxValue": 299,
                  "priority": 1,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/396741"
              },
              "expectationNotifiers": [
                {
                  "text": "2.5 kms | ₹38 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>2.5 kms</b> | ₹38 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.961774,77.594236",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9d66cb4a-24d8-43fd-87e3-0c06c183f94a"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "396741",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "396741",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "396741",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "396741",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "396741",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1633067",
                          "creativeId": "TopPicks/CMMCWrap",
                          "title": "Cheesynator Melt Malai Chicken Wrap",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "129883276",
                              "name": "Cheesynator Melt Malai Chicken Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Indulge in a delicious wrap loaded with smoky malai chicken tikka and double the cheese! The answer to your cravings!",
                              "imageId": "cbd81b8ad9c0d2318f994a0e9635cbfe",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465098",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859995",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859996",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859997",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859998",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859995"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859996"
                                      }
                                    ],
                                    "price": 26400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859997"
                                      }
                                    ],
                                    "price": 27400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859998"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817189",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817190",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817191",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817192",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1633480",
                          "creativeId": "TopPicks/CMPWrap",
                          "title": "Cheesynator Melt Paneer Wrap",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "129883270",
                              "name": "Cheesynator Melt Paneer Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "What's better than a classic wrap, A classic wrap with EXTRA cheese! Enjoy this delish wrap made with marinated paneer tikka chunks, onion, all wrapped up in deliciousness!",
                              "imageId": "bbdc8a8e9d2da6b9f965b6e11834dc74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465097",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859991",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859992",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859993",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859994",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859991"
                                      }
                                    ],
                                    "price": 23500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859992"
                                      }
                                    ],
                                    "price": 25000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859993"
                                      }
                                    ],
                                    "price": 26000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859994"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817185",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817186",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817187",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817188",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1633767",
                          "creativeId": "TopPicks/CMCTWrap",
                          "title": "Cheesynator Melt Chicken Tikka Wrap",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "129883281",
                              "name": "Cheesynator Melt Chicken Tikka Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Relish juicy chicken tikka chunks and onion wrapped in a soft roti with double the cheese! This wrap will surely tick all your  boxes.",
                              "imageId": "e65e264385b6d6d5c07de491e4a9bbfc",
                              "inStock": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465099",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859999",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109860000",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109860001",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109860002",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109859999"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860000"
                                      }
                                    ],
                                    "price": 26000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860001"
                                      }
                                    ],
                                    "price": 27000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860002"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817193",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817194",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817195",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817196",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1634158",
                          "creativeId": "TopPicks/PTShawarma",
                          "title": "Paneer Tikka Shawarma",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "128650091",
                              "name": "Paneer Tikka Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Your Lebanese cravings have met their match! Bite into a paneer shawarma wrapped in warm kuboos or rumali roti, with marinated paneer tikka, garlic mayo, hummus, french fries, pickled veggies and cabbage!",
                              "imageId": "b43e1abbc9c717c0f173c2d981fc93b7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34602230",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "106971297",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805222",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602230",
                                        "variationId": "110805222"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602230",
                                        "variationId": "106971297"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "123849907",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849908",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849909",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1634459",
                          "creativeId": "TopPicks/SPCShawarma",
                          "title": "Special Peppy Chicken Shawarma",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "128650092",
                              "name": "Special Peppy Chicken Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Soft, warm kuboos or rumali roti, loaded with Arabic spiced chicken, creamy hummus, garlic mayo, and french fries. Talk about shawarma for days!",
                              "imageId": "d6d6432f537b39b03a9420cda8f73c63",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34746058",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "107487156",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805218",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746058",
                                        "variationId": "110805218"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746058",
                                        "variationId": "107487156"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "124502341",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502343",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502344",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883256",
                              "name": "Cheesynator Corn Salsa Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Dive into a tantalizing Mexican fiesta with our Corn and Salsa delight, with double the cheesy goodness in every bite.",
                              "imageId": "24bad954c0e7885975cfc892974546fc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465088",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859961",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859962",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859963",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859965",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465088",
                                        "variationId": "109859961"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465088",
                                        "variationId": "109859962"
                                      }
                                    ],
                                    "price": 22400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465088",
                                        "variationId": "109859963"
                                      }
                                    ],
                                    "price": 23400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465088",
                                        "variationId": "109859965"
                                      }
                                    ],
                                    "price": 23900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817173",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817175",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817176",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817174",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817173",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817174",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817175",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817176",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883261",
                              "name": "Cheesynator Melt Chicken Bhuna Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Spice up your day with tender chicken chunks cooked in bhuna masala, onion, wrapped in a soft roti, loaded with extra cheese, it will definitely make you come back for more.",
                              "imageId": "41c6d35dbf0ebc66db6bd1b5df1e021a",
                              "inStock": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465092",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859974",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859975",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859976",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859977",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465092",
                                        "variationId": "109859974"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465092",
                                        "variationId": "109859975"
                                      }
                                    ],
                                    "price": 26000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465092",
                                        "variationId": "109859976"
                                      }
                                    ],
                                    "price": 27000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465092",
                                        "variationId": "109859977"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817177",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817179",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817180",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817178",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817177",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817178",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817179",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817180",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883266",
                              "name": "Cheesynator Egg-Chicken Sausage Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Double the cheese along with juicy chicken sausages and fluffy omelette to help you wrap you up your cravings!",
                              "imageId": "e2afe4af92b10a87be43f76d15dba5d5",
                              "inStock": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465096",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859987",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859988",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859989",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859990",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465096",
                                        "variationId": "109859987"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465096",
                                        "variationId": "109859988"
                                      }
                                    ],
                                    "price": 20400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465096",
                                        "variationId": "109859989"
                                      }
                                    ],
                                    "price": 21400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465096",
                                        "variationId": "109859990"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817181",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817183",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817184",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817182",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817181",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817182",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817183",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817184",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883270",
                              "name": "Cheesynator Melt Paneer Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "What's better than a classic wrap, A classic wrap with EXTRA cheese! Enjoy this delish wrap made with marinated paneer tikka chunks, onion, all wrapped up in deliciousness!",
                              "imageId": "bbdc8a8e9d2da6b9f965b6e11834dc74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465097",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859991",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859992",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859993",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859994",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859991"
                                      }
                                    ],
                                    "price": 23500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859992"
                                      }
                                    ],
                                    "price": 25000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859993"
                                      }
                                    ],
                                    "price": 26000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465097",
                                        "variationId": "109859994"
                                      }
                                    ],
                                    "price": 26500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817185",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817187",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817188",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817186",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817185",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817186",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817187",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817188",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 23500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883276",
                              "name": "Cheesynator Melt Malai Chicken Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Indulge in a delicious wrap loaded with smoky malai chicken tikka and double the cheese! The answer to your cravings!",
                              "imageId": "cbd81b8ad9c0d2318f994a0e9635cbfe",
                              "inStock": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465098",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859995",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109859996",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109859997",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109859998",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859995"
                                      }
                                    ],
                                    "price": 24900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859996"
                                      }
                                    ],
                                    "price": 26400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859997"
                                      }
                                    ],
                                    "price": 27400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465098",
                                        "variationId": "109859998"
                                      }
                                    ],
                                    "price": 27900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817189",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817191",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817192",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817190",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817189",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817190",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817191",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817192",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129883281",
                              "name": "Cheesynator Melt Chicken Tikka Wrap",
                              "category": "The Cheesynators - 2X Cheese (Swiggy Exclusive)",
                              "description": "Relish juicy chicken tikka chunks and onion wrapped in a soft roti with double the cheese! This wrap will surely tick all your  boxes.",
                              "imageId": "e65e264385b6d6d5c07de491e4a9bbfc",
                              "inStock": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35465099",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "109859999",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "109860000",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "109860001",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "109860002",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109859999"
                                      }
                                    ],
                                    "price": 24500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860000"
                                      }
                                    ],
                                    "price": 26000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860001"
                                      }
                                    ],
                                    "price": 27000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35465099",
                                        "variationId": "109860002"
                                      }
                                    ],
                                    "price": 27500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "126817193",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "126817195",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734438"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734442"
                                      },
                                      {
                                        "groupId": "126817196",
                                        "addonId": "99734445"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "126817194",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "126817193",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817194",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817195",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "126817196",
                                  "groupName": "Customize Your Order",
                                  "choices": [
                                    {
                                      "id": "99734445",
                                      "name": "Extra Cheese (In The Wrap)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734438",
                                      "name": "No Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99734442",
                                      "name": "No Raw Onion",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 24500,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Shawarma (Newly Launched)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650095",
                              "name": "Classic Peppy Chicken Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Wrap your taste buds around warm kuboos or rumali roti, with spiced chicken, creamy hummus, garlic mayo, pickled veggies, and french fries. You don't need a genie to satisfy this food craving!",
                              "imageId": "af9cad4e53b7e5be00062da8181694b3",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34746059",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "107487158",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805220",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746059",
                                        "variationId": "110805220"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746059",
                                        "variationId": "107487158"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502345",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502348",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502347",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "124502345",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502347",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502348",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650098",
                              "name": "Classic Smoky Chicken Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Experience Arabic enchantment with thin, soft kuboos or rumali of your choice, enveloping marinated grilled chicken, hummus, pickles, french fries galore, and cabbage! Yalla Habibi!",
                              "imageId": "17b72814c418a80f0ec7d8aec13b974d",
                              "inStock": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34602237",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "106971309",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805225",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602237",
                                        "variationId": "110805225"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602237",
                                        "variationId": "106971309"
                                      }
                                    ],
                                    "price": 20900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849928",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849930",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849929",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "123849928",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849929",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849930",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 19900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650093",
                              "name": "Sizzled Falafel Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Experience Turkish magic wrapped in warm kuboos or rumali roti, with crispy fried falafels, garlic mayo, creamy hummus, french fries and pickled veggies.",
                              "imageId": "231c03bd5cff5f21dfcbbf2bedbead8e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34602232",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "106971301",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805226",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602232",
                                        "variationId": "110805226"
                                      }
                                    ],
                                    "price": 17900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602232",
                                        "variationId": "106971301"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849913",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849915",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849914",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "123849913",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849914",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849915",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650091",
                              "name": "Paneer Tikka Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Your Lebanese cravings have met their match! Bite into a paneer shawarma wrapped in warm kuboos or rumali roti, with marinated paneer tikka, garlic mayo, hummus, french fries, pickled veggies and cabbage!",
                              "imageId": "b43e1abbc9c717c0f173c2d981fc93b7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34602230",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "106971297",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805222",
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602230",
                                        "variationId": "110805222"
                                      }
                                    ],
                                    "price": 18900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34602230",
                                        "variationId": "106971297"
                                      }
                                    ],
                                    "price": 19900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "123849907",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "123849909",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "123849908",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "123849907",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849908",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "123849909",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650092",
                              "name": "Special Peppy Chicken Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Soft, warm kuboos or rumali roti, loaded with Arabic spiced chicken, creamy hummus, garlic mayo, and french fries. Talk about shawarma for days!",
                              "imageId": "d6d6432f537b39b03a9420cda8f73c63",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34746058",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "107487156",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805218",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746058",
                                        "variationId": "110805218"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746058",
                                        "variationId": "107487156"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502341",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502344",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502343",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "124502341",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502343",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502344",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128650096",
                              "name": "Special Smoky Chicken Shawarma",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Brace yourself for a Mediterranean treat with warm kuboos or rumali roti, loaded with juicy, marinated grilled chicken, velvety hummus, and french fries!",
                              "imageId": "b516994fdc5f413af391d6212881f68d",
                              "inStock": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "34746061",
                                    "name": "Choose Your Shawarma Base",
                                    "variations": [
                                      {
                                        "name": "Rumali Roti (8-inch folded)",
                                        "price": 10,
                                        "id": "107487163",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Kuboos (8-inch)",
                                        "default": 1,
                                        "id": "110805217",
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746061",
                                        "variationId": "110805217"
                                      }
                                    ],
                                    "price": 21900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "34746061",
                                        "variationId": "107487163"
                                      }
                                    ],
                                    "price": 22900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "124502351",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393389"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393390"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393391"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476049"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "100393392"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476052"
                                      },
                                      {
                                        "groupId": "124502354",
                                        "addonId": "109476047"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "124502353",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "124502351",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502353",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "124502354",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 21900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591308",
                              "name": "Veg Shawarma & Side Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Super savings of up to Rs 70 with your fav veg shawarma and a side of your choice! A feast from the Middle East!",
                              "imageId": "13cff6ad67849ff4dea531423e409c0e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961113",
                                  "groupName": "Choose Your Shawarma (Veg)",
                                  "choices": [
                                    {
                                      "id": "104090165",
                                      "name": "Sizzled Falafel Shawarma with Rumali",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104090167",
                                      "name": "Paneer Tikka Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163916",
                                      "name": "Sizzled Falafel Shawarma with Kuboos (8\")",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163913",
                                      "name": "Classic Paneer Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961114",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "108148963",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148965",
                                      "name": "Falafel Shots (6 pieces)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148956",
                                      "name": "Potato Chilli Shots (6 Pcs)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148968",
                                      "name": "Potato Wedges (Medium)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148962",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148967",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148960",
                                      "name": "French Fries (Medium)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148958",
                                      "name": "Potato Wedges (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108761903",
                                      "name": "French Fries (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591309",
                              "name": "Non-Veg Shawarma & Side Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Savour and save up to Rs 80 with a delicious non veg shawarma and choice of side! Your fav duo for Middle Eastern cravings!",
                              "imageId": "e8f6e9df4137602fbcdb51cbcf2df2f2",
                              "inStock": 1,
                              "price": 25800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961115",
                                  "groupName": "Choose Your Shawarma (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "105270095",
                                      "name": "Classic Smoky Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270096",
                                      "name": "Special Smoky Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714371",
                                      "name": "Classic Peppy Chicken Shawarma with Rumali",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714372",
                                      "name": "Special Peppy Chicken Shawarma with Rumali",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270097",
                                      "name": "Open Smoky Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714373",
                                      "name": "Open Peppy Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163906",
                                      "name": "Classic Peppy Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163905",
                                      "name": "Special Peppy Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163912",
                                      "name": "Classic Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163911",
                                      "name": "Special Smoky Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961116",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "108148963",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148965",
                                      "name": "Falafel Shots (6 pieces)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148956",
                                      "name": "Potato Chilli Shots (6 Pcs)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148968",
                                      "name": "Potato Wedges (Medium)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148962",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148967",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148960",
                                      "name": "French Fries (Medium)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148958",
                                      "name": "Potato Wedges (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108761903",
                                      "name": "French Fries (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591310",
                              "name": "Veg Shawarma & Beverage Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Hold onto that trip to the Middle East! Save up to Rs 28 and order this instead- your choice of veg shawarma and a beverage!",
                              "imageId": "e8af80635cdbf7b20a47b283089273bc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961117",
                                  "groupName": "Choose Your Shawarma (Veg)",
                                  "choices": [
                                    {
                                      "id": "104090165",
                                      "name": "Sizzled Falafel Shawarma with Rumali",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104090167",
                                      "name": "Paneer Tikka Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163916",
                                      "name": "Sizzled Falafel Shawarma with Kuboos (8\")",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163913",
                                      "name": "Classic Paneer Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961118",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "108148966",
                                      "name": "Masala Lemonade (180 ml)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148964",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148959",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148957",
                                      "name": "SWIG Green Apple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476051",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591311",
                              "name": "Non-Veg Shawarma & Beverage Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Habibi, we got a double surprise for you- savings up to Rs 38 and a combo duo of your fav non veg shawarma and choice of beverage!",
                              "imageId": "26bacd28973b60d1f618c146f902a59e",
                              "inStock": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961119",
                                  "groupName": "Choose Your Shawarma (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "105270095",
                                      "name": "Classic Smoky Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270096",
                                      "name": "Special Smoky Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714371",
                                      "name": "Classic Peppy Chicken Shawarma with Rumali",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714372",
                                      "name": "Special Peppy Chicken Shawarma with Rumali",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270097",
                                      "name": "Open Smoky Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714373",
                                      "name": "Open Peppy Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163906",
                                      "name": "Classic Peppy Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163905",
                                      "name": "Special Peppy Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163912",
                                      "name": "Classic Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163911",
                                      "name": "Special Smoky Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961120",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "108148966",
                                      "name": "Masala Lemonade (180 ml)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148964",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148959",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148957",
                                      "name": "SWIG Green Apple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476051",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591312",
                              "name": "Veg Shawarma with Side & Beverage Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "A meal fit for a Sheikh! Your choice of veg shawarma, side and beverage. Order now and save up to Rs 84 on this trio!",
                              "imageId": "0e685a35261ebd4c8a071296d4321abf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961121",
                                  "groupName": "Choose Your Shawarma (Veg)",
                                  "choices": [
                                    {
                                      "id": "104090165",
                                      "name": "Sizzled Falafel Shawarma with Rumali",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104090167",
                                      "name": "Paneer Tikka Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163916",
                                      "name": "Sizzled Falafel Shawarma with Kuboos (8\")",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163913",
                                      "name": "Classic Paneer Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961122",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "108148963",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148965",
                                      "name": "Falafel Shots (6 pieces)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148956",
                                      "name": "Potato Chilli Shots (6 Pcs)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148968",
                                      "name": "Potato Wedges (Medium)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148962",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148967",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148960",
                                      "name": "French Fries (Medium)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148958",
                                      "name": "Potato Wedges (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108761903",
                                      "name": "French Fries (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961123",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "108148966",
                                      "name": "Masala Lemonade (180 ml)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148964",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148959",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148957",
                                      "name": "SWIG Green Apple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476051",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129591313",
                              "name": "Non-Veg Shawarma with Side & Beverage Meal",
                              "category": "Shawarma (Newly Launched)",
                              "description": "Feast like a royal with your fav non veg shawarma, choice of side and a beverage. Best part-Save up to Rs 94 with this wholesome meal!",
                              "imageId": "c886b73fd6d2752faddbf61db7bc0711",
                              "inStock": 1,
                              "price": 27800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "125961124",
                                  "groupName": "Choose Your Shawarma (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "105270095",
                                      "name": "Classic Smoky Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270096",
                                      "name": "Special Smoky Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714371",
                                      "name": "Classic Peppy Chicken Shawarma with Rumali",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714372",
                                      "name": "Special Peppy Chicken Shawarma with Rumali",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270097",
                                      "name": "Open Smoky Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714373",
                                      "name": "Open Peppy Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163906",
                                      "name": "Classic Peppy Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163905",
                                      "name": "Special Peppy Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163912",
                                      "name": "Classic Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163911",
                                      "name": "Special Smoky Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961125",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "108148963",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148965",
                                      "name": "Falafel Shots (6 pieces)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148956",
                                      "name": "Potato Chilli Shots (6 Pcs)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148968",
                                      "name": "Potato Wedges (Medium)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148962",
                                      "name": "Potato Chilli Shots with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148967",
                                      "name": "Falafel Nuggets with Mayo Dip",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148960",
                                      "name": "French Fries (Medium)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148958",
                                      "name": "Potato Wedges (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108761903",
                                      "name": "French Fries (Large)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "125961126",
                                  "groupName": "Choose Your Beverage",
                                  "choices": [
                                    {
                                      "id": "108148966",
                                      "name": "Masala Lemonade (180 ml)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148964",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148959",
                                      "name": "SWIG Jeera Masala Soda",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108148957",
                                      "name": "SWIG Green Apple",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476051",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Super Saver Wrap Duos (starting at 198)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314887",
                              "name": "1 Cheese Melt Paneer Wrap + 1 Masala Paneer Tikka Wrap",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "A paneer-lovers paradise. This Masala Paneer Tikka Wrap & Cheese Melt Paneer Wrap combo is THE perfect deal. Now order, save, repeat.",
                              "imageId": "c0e16914d42ec123d43024b5888df708",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117945158",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945159",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320794",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466886",
                              "name": "2 Classic Non-Veg Rolls at 300",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "70 is your lucky number and thats exactly what youll SAVE by choosing any 2 of your favourite classic non-veg wraps.",
                              "imageId": "350dfc81082dbace6460ffd4ab1c9666",
                              "inStock": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785046",
                                  "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733551",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733547",
                                      "name": "Chicken Bhuna Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733552",
                                      "name": "Reshmi Chicken Kebab Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733553",
                                      "name": "Cheese Melt Chicken Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733548",
                                      "name": "Egg Cheese Sausage Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733549",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733554",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733550",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785047",
                                  "groupName": "Choose Second Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733647",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733642",
                                      "name": "Chicken Bhuna Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733649",
                                      "name": "Reshmi Chicken Kebab Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733650",
                                      "name": "Cheese Melt Chicken Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733643",
                                      "name": "Egg Cheese Sausage Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733645",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733651",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733646",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117944855",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944856",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944857",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785049",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "128074945",
                              "name": "2 Non-Veg Shawarmas at 169 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "With SAVINGS up to Rs 100, take a trip to Arabia with 2 sizzling non-veg shawarmas! Grab your favs and relish these sensational bites now.",
                              "imageId": "1a3dbd42f6a994f18dfe272fe9f58f73",
                              "inStock": 1,
                              "price": 33800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "122465562",
                                  "groupName": "Choose Your Shawarma (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "105270095",
                                      "name": "Classic Smoky Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270096",
                                      "name": "Special Smoky Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714371",
                                      "name": "Classic Peppy Chicken Shawarma with Rumali",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714372",
                                      "name": "Special Peppy Chicken Shawarma with Rumali",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270097",
                                      "name": "Open Smoky Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714373",
                                      "name": "Open Peppy Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163906",
                                      "name": "Classic Peppy Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163905",
                                      "name": "Special Peppy Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163912",
                                      "name": "Classic Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163911",
                                      "name": "Special Smoky Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "122465564",
                                  "groupName": "Choose Your Second Shawarma (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "105270100",
                                      "name": "Classic Smoky Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270101",
                                      "name": "Special Smoky Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714376",
                                      "name": "Classic Peppy Chicken Shawarma with Rumali",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714377",
                                      "name": "Special Peppy Chicken Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105270102",
                                      "name": "Open Smoky Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105714378",
                                      "name": "Open Peppy Chicken Shawarma with Kuboos (2 Pc)",
                                      "price": 10000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163914",
                                      "name": "Classic Peppy Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163910",
                                      "name": "Special Peppy Chicken Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163907",
                                      "name": "Classic Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163908",
                                      "name": "Special Smoky Chicken Shawarma with Kuboos (8\")",
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "122465565",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122465567",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122465568",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "122465569",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466981",
                              "name": "2 Classic Veg Rolls at 285",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Double surprises and amazing SAVINGS of Rs. 70 await you with this veg classic wraps. Choose 2 of your favourite now.",
                              "imageId": "dfe2fba1caf2acf51e5ccef560f8d2eb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "122637683",
                                  "groupName": "Choose Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "105276452",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276446",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276447",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276453",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276448",
                                      "name": "Veg Falafel Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276449",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276450",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276451",
                                      "name": "Ultimate Mix Veg Patty Chipotle Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106075680",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785454",
                                  "groupName": "Choose Second Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733571",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733567",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733568",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733572",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733569",
                                      "name": "Veg Falafel Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733570",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105165107",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105165108",
                                      "name": "Ultimate Mix Veg Patty Chipotle Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106075681",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945449",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945450",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945452",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785455",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116544007",
                              "name": "2 Signature Veg Wraps at 180 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Amazing wraps and SAVINGS up to Rs. 78. What else can you ask for. Choose any two from our unique Signature Veg Wraps with delicious fillings & sauces all wrapped in a flaky paratha.",
                              "imageId": "9ebe1728b87aae2f2680c36a324c7827",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114320735",
                                  "groupName": "Choose Veg Signature Wrap - (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733439",
                                      "name": "Mexicana Potato Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733440",
                                      "name": "Punjabi Chole Paneer Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733445",
                                      "name": "Cheesy Baked Pizza Wrap (Veg)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733441",
                                      "name": "Lebanese Falafel Veggie Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733444",
                                      "name": "Smoky Diced Paneer Salad Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114320736",
                                  "groupName": "Choose Second Veg Signature Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733455",
                                      "name": "Mexicana Potato Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733456",
                                      "name": "Punjabi Chole Paneer Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733461",
                                      "name": "Cheesy Baked Pizza Wrap (Veg)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733457",
                                      "name": "Lebanese Falafel Veggie Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733460",
                                      "name": "Smoky Diced Paneer Salad Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117944791",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944792",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944793",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320737",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314906",
                              "name": "1 Non-Veg Classic Wrap + 1 Non-Veg Rice Bowl starting at 268",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "With savings of upto Rs 80 this is the meal of your choice of 1 classic non-veg wrap with 1 classic non-veg bowl is a perfect deal-breaker. Now order, save, repeat.",
                              "imageId": "7c189956c69e84f0dca0190d2e541b42",
                              "inStock": 1,
                              "price": 26800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114320849",
                                  "groupName": "Choose Your Classic Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202956",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202957",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202958",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202959",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202960",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202961",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202962",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202963",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114320850",
                                  "groupName": "Choose Your Classic  Rice Bowl",
                                  "choices": [
                                    {
                                      "id": "101258115",
                                      "name": "Egg Rice Bowl (Regular)",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258116",
                                      "name": "Chicken Tikka Rice Feast (Regular)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258117",
                                      "name": "Chicken Bhuna Rice Feast (Regular)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258118",
                                      "name": "Malai Chicken Rice Feast (Regular)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258119",
                                      "name": "Chicken Signature Rice Bowl",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258120",
                                      "name": "Malai Chicken & Chicken Tikka Rice Feast (Regular)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258121",
                                      "name": "Chicken Bhuna & Chicken Tikka Rice Feast (Regular)",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258122",
                                      "name": "Smoked Butter Chicken Rice Bowl (Regular)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258123",
                                      "name": "Mutton Bhuna Rice Bowl (Regular)",
                                      "price": 9000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945502",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945503",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945505",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320852",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314908",
                              "name": "1 Chicken Bhuna Wrap + 1 Masala Chicken Tikka Wrap",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "No more wait, straightaway order your favourite Masala Chicken Tikka Wrap & Chicken Bhuna Wrap, and switch that conquer-all mode ON right away.",
                              "imageId": "271164fb6da0d822e7cda97c75aac79c",
                              "inStock": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117945506",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945507",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320856",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314901",
                              "name": "1 Veg Classic Wrap + 1 Veg Rice Bowl starting at 278",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Give a high-five to savings of upto Rs. 70. Choose 1 veg classic wrap & 1 veg classic rice bowl and tell yourself cest la vie.",
                              "imageId": "cfc8be841d5e633c84cf6e26869c28dd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 27800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114320832",
                                  "groupName": "Choose Your Classic Wrap (Veg)",
                                  "choices": [
                                    {
                                      "id": "101202920",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202921",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202922",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202923",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202924",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202925",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202926",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202927",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202928",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114320833",
                                  "groupName": "Choose Your Classic Rice Bowl",
                                  "choices": [
                                    {
                                      "id": "101258061",
                                      "name": "Corn Salsa Rice Feast (Regular)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258062",
                                      "name": "Rajma Masala Rice Bowl (Regular)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258063",
                                      "name": "Chole Signature Rice Bowl (Regular)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258064",
                                      "name": "Chole Paneer Rice Feast (Regular)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258065",
                                      "name": "Paneer Signature Rice Bowl (Regular)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101258066",
                                      "name": "Spicy Fried Paneer Rice Feast (Regular)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945393",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945394",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945395",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320835",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116544440",
                              "name": "2 Signature Non-Veg Wraps at 210 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Get spoiled with max SAVINGS of Rs. 70 & delicious surprises. Enjoy a delicious meal for two by choosing any two of our Signature Non-veg Wraps loaded with tender chicken & unique combinations of sauces.",
                              "imageId": "ca37357143403cf913409960ade15932",
                              "inStock": 1,
                              "price": 42000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114320858",
                                  "groupName": "Choose NonVeg Signature Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733592",
                                      "name": "American Smoked Sausage Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733593",
                                      "name": "Chicken Extravaganza Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733596",
                                      "name": "Smoked Butter Chicken Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733594",
                                      "name": "Lebanese Chicken Kefta Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733597",
                                      "name": "Zaikedar Mutton Bhuna Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114320859",
                                  "groupName": "Choose Second NonVeg Signature Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733598",
                                      "name": "American Smoked Sausage Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733599",
                                      "name": "Chicken Extravaganza Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733602",
                                      "name": "Smoked Butter Chicken Tikka Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733600",
                                      "name": "Lebanese Chicken Kefta Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733603",
                                      "name": "Zaikedar Mutton Bhuna Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945508",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945509",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945511",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320860",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127479971",
                              "name": "2 Veg Shawarmas at 149 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Save upto Rs 80, and experience the magic of the Middle East with not one, but two sizzling veg shawarmas of your choice\n",
                              "imageId": "639a39e8b47a9dad2eea7e49e2fca1d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "120614709",
                                  "groupName": "Choose Your Shawarma (Veg)",
                                  "choices": [
                                    {
                                      "id": "104090165",
                                      "name": "Sizzled Falafel Shawarma with Rumali",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104090167",
                                      "name": "Paneer Tikka Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163916",
                                      "name": "Sizzled Falafel Shawarma with Kuboos (8\")",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163913",
                                      "name": "Classic Paneer Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "120614710",
                                  "groupName": "Choose Your Second Shawarma (Veg)",
                                  "choices": [
                                    {
                                      "id": "104090169",
                                      "name": "Sizzled Falafel Shawarma with Rumali",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "104090171",
                                      "name": "Paneer Tikka Shawarma with Rumali",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163909",
                                      "name": "Sizzled Falafel Shawarma with Kuboos (8\")",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109163915",
                                      "name": "Classic Paneer Shawarma with Kuboos (8\")",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "120614711",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120614712",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120614713",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "120614714",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466960",
                              "name": "3 Veg Classic Wraps at 99 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "All hearts for SAVINGS up to Rs. 120 & all smiles for surprises. Choose any 3 from your favourite Classic Veg wraps loaded with unique ingredients and enjoy. Can we get a wow.",
                              "imageId": "b28036bbd27f5744ddc0213fab45558c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785348",
                                  "groupName": "Choose Your Classic Wrap (Veg)",
                                  "choices": [
                                    {
                                      "id": "101202920",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202921",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202922",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202923",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202924",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202925",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202926",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202927",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202928",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785354",
                                  "groupName": "Choose Your Second Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656753",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656754",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656755",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656756",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656757",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656758",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656759",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656760",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656761",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785361",
                                  "groupName": "Choose Your Third Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656762",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656763",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656764",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656765",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656766",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656767",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656768",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656769",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656770",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945363",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945365",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945368",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785366",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466943",
                              "name": "4 Classic Veg Wraps at 380",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "All hearts for SAVINGS up to Rs. 176 & all smiles for surprises. Choose any 4 from your favourite Classic Veg wraps loaded with unique ingredients and enjoy. Can we get a wow.",
                              "imageId": "e44059e8072ff9aa9a00f9a0fce87837",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785273",
                                  "groupName": "Choose Your Classic Wrap (Veg)",
                                  "choices": [
                                    {
                                      "id": "101202920",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202921",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202922",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202923",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202924",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202925",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202926",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202927",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202928",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785275",
                                  "groupName": "Choose Your Second Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656753",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656754",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656755",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656756",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656757",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656758",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656759",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656760",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656761",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785277",
                                  "groupName": "Choose Your Third Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656762",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656763",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656764",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656765",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656766",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656767",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656768",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656769",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656770",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785279",
                                  "groupName": "Choose Your Fourth Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656771",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656772",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656773",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656774",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656775",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656776",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656777",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656778",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656779",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945111",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945112",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945113",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785282",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125770936",
                              "name": "2 Classic Rolls (1 Veg + 1 Non-Veg) starting at 99 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "SAVE up to Rs. 70 and surprise your tastebuds with any 1 each of your favorite nonveg and nonveg classic wraps. There is no reason to delay here.",
                              "imageId": "0b537d59ebca78217ec8007358575899",
                              "inStock": 1,
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115397954",
                                  "groupName": "Choose Your Classic Wrap (Veg)",
                                  "choices": [
                                    {
                                      "id": "101202920",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202921",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202922",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202923",
                                      "name": "Ultimate Chipotle Veg Patty Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202924",
                                      "name": "Veg Falafel Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202925",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202926",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202927",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202928",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "115397955",
                                  "groupName": "Choose Your Classic Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202956",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202957",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202958",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202959",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202960",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202961",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202962",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202963",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945104",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945105",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945107",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115397956",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314865",
                              "name": "2 Double Egg Chatpata Wrap",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Your perfect combo of 2 delicious Double Egg Chatpata Wrap only at 198. Your protein packed meal awaits",
                              "imageId": "65cbc5a48e9128cb42b75fc0708f7680",
                              "inStock": 1,
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117944842",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944844",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320741",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125231044",
                              "name": "1 Masala Paneer Tikka Wrap + 1 Chatpate Chole Wrap",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "A power-packed combiation of paneer & chole, just heavenly. This Masala Paneer Tikka Wrap & Chatpate Chole Wrap combo is THE perfect deal.",
                              "imageId": "6de4bcf9fe1564f6a8466036accecc03",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117945230",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945232",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320827",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466888",
                              "name": "3 Non-Veg Classic Wraps at 99 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Lip-smacking flavours at jaw-dropping SAVINGS up to Rs. 120. Choose any 4 from your favourite Classic Non-Veg wraps with extraordinary flavours.",
                              "imageId": "289bc2a439fae995a6782d815126caef",
                              "inStock": 1,
                              "price": 29700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785053",
                                  "groupName": "Choose Your Classic Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202956",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202957",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202958",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202959",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202960",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202961",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202962",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202963",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785054",
                                  "groupName": "Choose Your Second Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656780",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656781",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656782",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656783",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656784",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656785",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656786",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656787",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785055",
                                  "groupName": "Choose Your Third Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656788",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656789",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656790",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656791",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656792",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656793",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656794",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656795",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117944929",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944932",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944934",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785057",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125314885",
                              "name": "1 Double Egg Chatpata Wrap + 1 Chicken Bhuna Wrap",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "This deal surely feels like a heaven. With a combination of Double Egg Chatpata Wrap & Chicken Bhuna Wrap, this will make you go wow.",
                              "imageId": "3c5def50cde7ab07f137c04345859902",
                              "inStock": 1,
                              "price": 27900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "117945094",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945095",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114320788",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466890",
                              "name": "4 Classic Non-Veg Wraps at 380",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Lip-smacking flavours at jaw-dropping SAVINGS up to Rs. 176. Choose any 4 from your favourite Classic Non-Veg wraps with extraordinary flavours.",
                              "imageId": "bd7d01026f06e1bb4696c5f8d9c6cbfc",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785061",
                                  "groupName": "Choose Your Classic Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202956",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202957",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202958",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202959",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202960",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202961",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202962",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202963",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785063",
                                  "groupName": "Choose Your Second Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656780",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656781",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656782",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656783",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656784",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656785",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656786",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656787",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785064",
                                  "groupName": "Choose Your Third Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656788",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656789",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656790",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656791",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656792",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656793",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656794",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656795",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785065",
                                  "groupName": "Choose Your Fourth Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656796",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656797",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656798",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656799",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656800",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656801",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656802",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656803",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117945046",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945047",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117945048",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785067",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125770935",
                              "name": "2 Signature (1 Veg + 1 Non-Veg) at 198 each",
                              "category": "Super Saver Wrap Duos (starting at 198)",
                              "description": "Bolder the flavours, bigger the SAVINGS up to Rs. 104. Choose any 2 from our Signature veg, non-beg wraps & enjoy this delicious meal for 2.",
                              "imageId": "8297466213b7867c1b6965113b917680",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "115397951",
                                  "groupName": "Choose Your Signature Wrap (Veg)",
                                  "choices": [
                                    {
                                      "id": "101203301",
                                      "name": "Punjabi Chole Paneer Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101203302",
                                      "name": "Mexicana Potato Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101203303",
                                      "name": "Cheesy Baked Pizza Wrap (Veg)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101203304",
                                      "name": "Lebanese Falafel Veggie Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101203305",
                                      "name": "Smoky Diced Paneer Salad Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "115397952",
                                  "groupName": "Choose Your Signature Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202969",
                                      "name": "Lebanese Chicken Meatball Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202971",
                                      "name": "American Smoked Sausage Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202972",
                                      "name": "Chicken Extravaganza Wrap",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202973",
                                      "name": "Smoked Butter Chicken Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202974",
                                      "name": "Zaikedar Chicken Tikka Wrap",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202975",
                                      "name": "Zaikedar Chicken Bhuna Wrap",
                                      "price": 4500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "117944797",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944798",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117944799",
                                  "groupName": "Choose Your Beverage & Dessert",
                                  "choices": [
                                    {
                                      "id": "100393392",
                                      "name": "Choco Lava (Save Rs 20)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393389",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393390",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100393391",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "price": 5700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476049",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 6650,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476047",
                                      "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                      "price": 15900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476052",
                                      "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                      "price": 9900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "115397953",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Pocket Friendly Rolls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116543466",
                              "name": "2 Classic Veg Rolls at 140 each",
                              "category": "Pocket Friendly Rolls",
                              "description": "Double surprises and amazing SAVINGS of Rs. 70 await you with this veg classic wraps. Choose 2 of your favourite now.",
                              "imageId": "7b969648c499879cb31288b496cb5e50",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129972070",
                                  "groupName": "Choose Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "105276452",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276446",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276447",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276453",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276448",
                                      "name": "Veg Falafel Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276449",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276450",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105276451",
                                      "name": "Ultimate Mix Veg Patty Chipotle Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106075680",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "129972073",
                                  "groupName": "Choose Second Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733571",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733567",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733568",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733572",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733569",
                                      "name": "Veg Falafel Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733570",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105165107",
                                      "name": "Ultimate Chipotle Aloo Patty Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "105165108",
                                      "name": "Ultimate Mix Veg Patty Chipotle Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "106075681",
                                      "name": "Indie Chatpata Aloo Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "129972077",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972082",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972087",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116544117",
                              "name": "2 Classic Non-Veg Rolls at 150 each",
                              "category": "Pocket Friendly Rolls",
                              "description": "70 is your lucky number and thats exactly what youll SAVE by choosing any 2 of your favourite classic non-veg wraps.",
                              "imageId": "eae147f05a1ee82676138dfe83f916b0",
                              "inStock": 1,
                              "price": 30000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129972095",
                                  "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733551",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733547",
                                      "name": "Chicken Bhuna Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733552",
                                      "name": "Reshmi Chicken Kebab Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733553",
                                      "name": "Cheese Melt Chicken Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733548",
                                      "name": "Egg Cheese Sausage Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733549",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733554",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733550",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "129972100",
                                  "groupName": "Choose Second Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "99733647",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733642",
                                      "name": "Chicken Bhuna Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733649",
                                      "name": "Reshmi Chicken Kebab Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733650",
                                      "name": "Cheese Melt Chicken Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733643",
                                      "name": "Egg Cheese Sausage Wrap",
                                      "price": 500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733645",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733651",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733646",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "129972104",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972107",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972109",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85335839",
                              "name": "Chipotle Cheese Potato Roll",
                              "category": "Pocket Friendly Rolls",
                              "description": "Who knew potato shots could even do this. Wrapped in a paratha with crunchy onion, chipotle cheese and a drizzle of mint plus chatpata mayo makes this wrap exceptional. I Calories (Kcals): 761 I Carbs (Gms): 85 I Proteins (Gms): 14 I Fats (Gms): 41",
                              "imageId": "b8f7fb7a4326c7b2250ffdbed87209b2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129972122",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972124",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972126",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 18500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85335837",
                              "name": "Chatpate Chole Roll",
                              "category": "Pocket Friendly Rolls",
                              "description": "No one believed us when we said chole can be even more exciting. So we created a wrap that has tangy burst of chole with flavorful Indian spices and crunchy onions, wrapped in a soft roti. Try it & get surprised. I Calories (Kcals): 562 I Carbs (Gms): 72 I Proteins (Gms): 14 I Fats (Gms): 25",
                              "imageId": "7a0b056ec23998dfa83406da85894e59",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36193568",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "112487562",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "112487564",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "112487565",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "112487567",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193568",
                                        "variationId": "112487562"
                                      }
                                    ],
                                    "price": 10900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193568",
                                        "variationId": "112487564"
                                      }
                                    ],
                                    "price": 13400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193568",
                                        "variationId": "112487565"
                                      }
                                    ],
                                    "price": 12400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193568",
                                        "variationId": "112487567"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972135",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972139",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972137",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129972135",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972137",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972139",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117996957",
                              "name": "Indie Chatpata Aloo Wrap",
                              "category": "Pocket Friendly Rolls",
                              "description": "Well-seasoned potatoes gently seasoned with Indian spices are rolled with lip-smacking imli chutney & crunchy onion jullienes in a soft wrap that balances all the flavours together like a pro. Let your chatpata era begin. I Calories (Kcals): 643 I Carbs (Gms): 72 I Proteins (Gms): 8 I Fats (Gms): 36",
                              "imageId": "3c1c83ff8cd61e1f6097e31f5da6c5a4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36193571",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "112487576",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "112487577",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Laccha Paratha",
                                        "price": 25,
                                        "id": "112487578",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chef Recommended)",
                                        "price": 30,
                                        "id": "112487579",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193571",
                                        "variationId": "112487576"
                                      }
                                    ],
                                    "price": 10500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193571",
                                        "variationId": "112487577"
                                      }
                                    ],
                                    "price": 12000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193571",
                                        "variationId": "112487578"
                                      }
                                    ],
                                    "price": 13000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193571",
                                        "variationId": "112487579"
                                      }
                                    ],
                                    "price": 13500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972147",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972149",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972148",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129972147",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972148",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972149",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 10500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85335821",
                              "name": "Chatpata Double Egg Roll",
                              "category": "Pocket Friendly Rolls",
                              "description": "Why settle for something ordinary when you can get a snack that is eggstra ordinary! Like this yum wrap made with golden-fried eggs, drizzled with tangy, cheesy mayo and wrapped in a soft roti. I Calories (Kcals): 817 I Carbs (Gms): 57 I Proteins (Gms): 22 I Fats (Gms): 56",
                              "imageId": "a5be439e731c63a9cb6a914aebc21579",
                              "inStock": 1,
                              "price": 10500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36193574",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "112487588",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "112487589",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "112487590",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "112487591",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193574",
                                        "variationId": "112487588"
                                      }
                                    ],
                                    "price": 10500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193574",
                                        "variationId": "112487589"
                                      }
                                    ],
                                    "price": 12000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193574",
                                        "variationId": "112487590"
                                      }
                                    ],
                                    "price": 13000,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193574",
                                        "variationId": "112487591"
                                      }
                                    ],
                                    "price": 13500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972156",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972158",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972157",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129972156",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972157",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972158",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 10500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "28 ratings",
                                  "ratingCountV2": "28"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117996959",
                              "name": "Ultimate Chipotle Aloo Patty Wrap",
                              "category": "Pocket Friendly Rolls",
                              "description": "Crispy & flavourful aloo patty is amped up with a generous drizzle of chipotle mayo and then gently wrapped with crunchy onions in a supple paratha. Add this to your wrap-list right away. I Calories (Kcals): 888 I Carbs (Gms): 86 I Proteins (Gms): 11 I Fats (Gms): 56",
                              "imageId": "fa582ec112fd00def9a70784eacecb1c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36193576",
                                    "name": "Customize Your Wrap Base",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "112487596",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 10,
                                        "id": "112487597",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Laccha Paratha",
                                        "price": 25,
                                        "id": "112487598",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chef Recommended)",
                                        "price": 25,
                                        "id": "112487599",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193576",
                                        "variationId": "112487596"
                                      }
                                    ],
                                    "price": 12900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193576",
                                        "variationId": "112487597"
                                      }
                                    ],
                                    "price": 13900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193576",
                                        "variationId": "112487598"
                                      }
                                    ],
                                    "price": 15400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193576",
                                        "variationId": "112487599"
                                      }
                                    ],
                                    "price": 15400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972163",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972167",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733446"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733447"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733448"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733449"
                                      },
                                      {
                                        "groupId": "129972165",
                                        "addonId": "99733450"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129972163",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972165",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "99733449",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733450",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733448",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733446",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733447",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972167",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 12900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589218",
                              "name": "Cheese Melt Double Egg Roll",
                              "category": "Pocket Friendly Rolls",
                              "description": "Golden-fried eggs are loaded with silky, creamy cheesy and wrapped in a soft roti. An overload of cheese, just like you wanted I Calories (Kcals): 605 I Carbs (Gms): 53 I Proteins (Gms): 24 I Fats (Gms): 34",
                              "imageId": "1a7ceb1990fc30c3895ccbfa8e50c6b5",
                              "inStock": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36193578",
                                    "name": "Cheese Melt Double Egg Wrap",
                                    "variations": [
                                      {
                                        "name": "Maida Paratha",
                                        "default": 1,
                                        "id": "112487604",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Wholewheat Paratha (Healthy)",
                                        "price": 15,
                                        "id": "112487605",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Lachha Paratha (Handcrafted)",
                                        "price": 25,
                                        "id": "112487606",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Crispy Bake (Chefs Special)",
                                        "price": 30,
                                        "id": "112487607",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193578",
                                        "variationId": "112487604"
                                      }
                                    ],
                                    "price": 14900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193578",
                                        "variationId": "112487605"
                                      }
                                    ],
                                    "price": 16400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193578",
                                        "variationId": "112487606"
                                      }
                                    ],
                                    "price": 17400,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36193578",
                                        "variationId": "112487607"
                                      }
                                    ],
                                    "price": 17900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016761"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "103344928"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016763"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016764"
                                      },
                                      {
                                        "groupId": "129972174",
                                        "addonId": "101016765"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733324"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733325"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733326"
                                      },
                                      {
                                        "groupId": "129972177",
                                        "addonId": "99733327"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195094"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195095"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "110559284"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195097"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195098"
                                      },
                                      {
                                        "groupId": "129972176",
                                        "addonId": "102195099"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129972174",
                                  "groupName": "Make it a Meal",
                                  "choices": [
                                    {
                                      "id": "101016761",
                                      "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016764",
                                      "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                      "price": 10900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103344928",
                                      "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016765",
                                      "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101016763",
                                      "name": "Fries (M) + Lemonade (Save Rs 49)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972176",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "102195098",
                                      "name": "French Fries (Save Rs 24)",
                                      "price": 8900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195099",
                                      "name": "Teekha Chaska Fries (Save Rs 24)",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195097",
                                      "name": "Potato Wedges (M) (Save Rs 20)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195094",
                                      "name": "Potato Wedges (S) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102195095",
                                      "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110559284",
                                      "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                      "price": 6900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 6,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129972177",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Classic Wraps",
                      "categories": [
                        {
                          "title": "Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390344",
                                  "name": "Masala Paneer Tikka Wrap",
                                  "category": "Classic Wraps",
                                  "description": "We dont have any pun for paneer, but we do have a lot of surprises in this exciting snack that we roll into this wrap. Fresh marinated paneer (with cooked onion) is smoked to perfection & drizzled with minty, spicy mayonnaise & wrapped in soft roti. I Calories (Kcals): 667 I Carbs (Gms): 61 I Proteins (Gms): 22 I Fats (Gms): 38",
                                  "imageId": "e33b232690d715d740431f779291335f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066828",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069407",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069409",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069410",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069412",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066828",
                                            "variationId": "99069407"
                                          }
                                        ],
                                        "price": 18500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066828",
                                            "variationId": "99069409"
                                          }
                                        ],
                                        "price": 20000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066828",
                                            "variationId": "99069410"
                                          }
                                        ],
                                        "price": 21000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066828",
                                            "variationId": "99069412"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685228",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488551",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882898",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488553",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488548",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113685228",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488548",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882898",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488551",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488553",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18500,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "112 ratings",
                                      "ratingCountV2": "112"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544728",
                                  "name": "Cheese Melt Paneer Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Let the good times roll with surprises & flavour with this exciting snack Cottage cheese is seasoned with select spices & cooked onion, slathered with creamy, gooey cheese & snuggly wrapped in soft roti. I Calories (Kcals): 688 I Carbs (Gms): 59 I Proteins (Gms): 26 I Fats (Gms): 39",
                                  "imageId": "3af85673c0994ffc3407c17f86d41938",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066830",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069421",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069422",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069423",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069424",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066830",
                                            "variationId": "99069421"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066830",
                                            "variationId": "99069422"
                                          }
                                        ],
                                        "price": 21400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066830",
                                            "variationId": "99069423"
                                          }
                                        ],
                                        "price": 22400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066830",
                                            "variationId": "99069424"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685183",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488563",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882887",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488565",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488561",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113685183",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488561",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882887",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488563",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488565",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 19900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "37 ratings",
                                      "ratingCountV2": "37"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390396",
                                  "name": "Cheesy Corn Salsa Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Caution: Not your average snack! Mexican inspired corn salsa with a generous serving of cheese is wrapped in a soft roti. A combination oh-so unique with flavours on a roll I Calories (Kcals): 693 I Carbs (Gms): 76 I Proteins (Gms): 13 I Fats (Gms): 38",
                                  "imageId": "33e65169ad602dba3057b668b6fd50ab",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066834",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069444",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069445",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069446",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069447",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066834",
                                            "variationId": "99069444"
                                          }
                                        ],
                                        "price": 16900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066834",
                                            "variationId": "99069445"
                                          }
                                        ],
                                        "price": 18400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066834",
                                            "variationId": "99069446"
                                          }
                                        ],
                                        "price": 19400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066834",
                                            "variationId": "99069447"
                                          }
                                        ],
                                        "price": 19900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684815",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488581",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882812",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488582",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488579",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113684815",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488579",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882812",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488581",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488582",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "84540901",
                                  "name": "Chipotle Potato Shots Wrap..",
                                  "category": "Classic Wraps",
                                  "description": "Who knew potato shots could even do this. Wrapped in a paratha with crunchy onion, chipotle cheese and a drizzle of mint plus chatpata mayo makes this wrap exceptional. I Calories (Kcals): 761 I Carbs (Gms): 85 I Proteins (Gms): 14 I Fats (Gms): 41",
                                  "imageId": "b8f7fb7a4326c7b2250ffdbed87209b2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123317569",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317570",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317571",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317572",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317573",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390409",
                                  "name": "Veg Falafel Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Get wrapped in this Mediterranean surprise! We roll up crispy falafel, made from the finest chickpeas, with classic mayo and crunchy onions in soft roti for an experience unlike ever before! I Calories (Kcals): 641 I Carbs (Gms): 77 I Proteins (Gms): 17 I Fats (Gms): 30",
                                  "imageId": "cfce9a27b79131804795881dc18445d1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066833",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069440",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069441",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069442",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069443",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066833",
                                            "variationId": "99069440"
                                          }
                                        ],
                                        "price": 14900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066833",
                                            "variationId": "99069441"
                                          }
                                        ],
                                        "price": 16400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066833",
                                            "variationId": "99069442"
                                          }
                                        ],
                                        "price": 17400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066833",
                                            "variationId": "99069443"
                                          }
                                        ],
                                        "price": 17900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685042",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488572",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882827",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488573",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110488569",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113685042",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488569",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882827",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488572",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488573",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "29 ratings",
                                      "ratingCountV2": "29"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390325",
                                  "name": "Masala Chicken Tikka Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Bored of the same old flavours Excite your taste buds with surprises that we roll into this wrap. Smokey marinated chicken tikka (with cooked onion) taken a notch above with a generous drizzle of minty, tangy mayonnaise clubbed with crunchy onions in a soft roti. I Calories (Kcals): 626 I Carbs (Gms): 60 I Proteins (Gms): 22 I Fats (Gms): 33",
                                  "imageId": "47a783a97daed3f033d30bc3c52ed60a",
                                  "inStock": 1,
                                  "price": 19500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066835",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069448",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069449",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069450",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069451",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066835",
                                            "variationId": "99069448"
                                          }
                                        ],
                                        "price": 19500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066835",
                                            "variationId": "99069449"
                                          }
                                        ],
                                        "price": 21000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066835",
                                            "variationId": "99069450"
                                          }
                                        ],
                                        "price": 22000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066835",
                                            "variationId": "99069451"
                                          }
                                        ],
                                        "price": 22500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684932",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488589",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882819",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510637",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488591",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113684932",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510637",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882819",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488589",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488591",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 19500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "106 ratings",
                                      "ratingCountV2": "106"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544605",
                                  "name": "Egg Cheese Chicken Sausage Wrap",
                                  "category": "Classic Wraps",
                                  "description": "When its about surprising your tastebuds, no one can beat us. This absolutely amazing wrap made with juicy sausages, omelette & lots of cheese is here to roll you up in exciting flavours & surprises. I Calories (Kcals): 815 I Carbs (Gms): 26 I Proteins (Gms): 56 I Fats (Gms): 53",
                                  "imageId": "c1d55178e0092f1e058fcca61c3f3f04",
                                  "inStock": 1,
                                  "price": 15500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066837",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069456",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069457",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069458",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069459",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066837",
                                            "variationId": "99069456"
                                          }
                                        ],
                                        "price": 15500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066837",
                                            "variationId": "99069457"
                                          }
                                        ],
                                        "price": 17000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066837",
                                            "variationId": "99069458"
                                          }
                                        ],
                                        "price": 18000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066837",
                                            "variationId": "99069459"
                                          }
                                        ],
                                        "price": 18500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685178",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488662",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882883",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734438"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734442"
                                          },
                                          {
                                            "groupId": "110488663",
                                            "addonId": "99734445"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510669",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113685178",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510669",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882883",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488662",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488663",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 15500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "24 ratings",
                                      "ratingCountV2": "24"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390389",
                                  "name": "Malai Chicken Kebab Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Fix your mundane days & let the good times roll! Oh so creamy & exotic, this Reshmi Chicken Wrap is made with soft chicken pieces cooked in creamy, rich & decadent masala. Remember, this is not made for sharing! I Calories (Kcals): 621 I Carbs (Gms): 61 I Proteins (Gms): 21 I Fats (Gms): 33",
                                  "imageId": "8f27e87af044a68aec6dff39b491f0cb",
                                  "inStock": 1,
                                  "price": 19500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066838",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069460",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069461",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069462",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069463",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066838",
                                            "variationId": "99069460"
                                          }
                                        ],
                                        "price": 19500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066838",
                                            "variationId": "99069461"
                                          }
                                        ],
                                        "price": 21000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066838",
                                            "variationId": "99069462"
                                          }
                                        ],
                                        "price": 22000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066838",
                                            "variationId": "99069463"
                                          }
                                        ],
                                        "price": 22500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684757",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488666",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882786",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510610",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488667",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113684757",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510610",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882786",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488666",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488667",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 19500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390382",
                                  "name": "Malai Chicken Cheese Melt Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Craving for something new. We got your back. We mean, we got you a wrap. Chunks of chicken cooked in reshmi masala, topped with sinful cheese into a soft roti. Roll up your sleeves, its snack time I Calories (Kcals): 643 I Carbs (Gms): 60 I Proteins (Gms): 25 I Fats (Gms): 34",
                                  "imageId": "7e3d4ffaf4726aaef459b2f53dda7a81",
                                  "inStock": 1,
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066840",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "99069468",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "99069469",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "99069470",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "99069471",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066840",
                                            "variationId": "99069468"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066840",
                                            "variationId": "99069469"
                                          }
                                        ],
                                        "price": 22400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066840",
                                            "variationId": "99069470"
                                          }
                                        ],
                                        "price": 23400,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066840",
                                            "variationId": "99069471"
                                          }
                                        ],
                                        "price": 23900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113684964",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "110488674",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111882822",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510642",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "110488675",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113684964",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510642",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111882822",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488674",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110488675",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117375772",
                                  "name": "Cheese Melt Chicken Bhuna Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Craving for something new, We got your back. We mean, we got you a wrap. Chunks of chicken cooked in bhuna masala with onion, topped with sinful cheese into a soft roti. Roll up your sleeves, its snack time I Calories (Kcals): 659 I Carbs (Gms): 59 I Proteins (Gms): 21 I Fats (Gms): 38",
                                  "imageId": "647a0408894f3ba64fb64304187e9a11",
                                  "inStock": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123317559",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317560",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317561",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317562",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317563",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116543980",
                                  "name": "Cheese Melt Chicken Tikka Wrap",
                                  "category": "Classic Wraps",
                                  "description": "Craving for something new, We got your back. We mean, we got you a wrap. Chunks of chicken cooked in tikka masala with cooked onion, topped with sinful cheese into a soft roti. Roll up your sleeves, its snack time I Calories (Kcals): 609 I Carbs (Gms): 57 I Proteins (Gms): 28 I Fats (Gms): 30",
                                  "imageId": "647a0408894f3ba64fb64304187e9a11",
                                  "inStock": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123317574",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317575",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317576",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317577",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123317578",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390377",
                                  "name": "Chicken Bhuna Wrap",
                                  "category": "Classic Wraps",
                                  "description": "The bestseller, rock n roll award goes to: Roasted and flavorful chicken pieces slow-cooked in spicy bhuna masala with onion and wrapped with crisp onions in a freshly made roti. Is it snack time yet I Calories (Kcals): 638 I Carbs (Gms): 60 I Proteins (Gms): 16 I Fats (Gms): 37",
                                  "imageId": "766caa63ce36fee16ef34db3a8ee749d",
                                  "inStock": 1,
                                  "price": 19500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32612079",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Maida Paratha",
                                            "default": 1,
                                            "id": "101175462",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "price": 15,
                                            "id": "101175463",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "price": 25,
                                            "id": "101175464",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 30,
                                            "id": "101290139",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32612079",
                                            "variationId": "101175462"
                                          }
                                        ],
                                        "price": 19500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32612079",
                                            "variationId": "101175463"
                                          }
                                        ],
                                        "price": 21000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32612079",
                                            "variationId": "101175464"
                                          }
                                        ],
                                        "price": 22000,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32612079",
                                            "variationId": "101290139"
                                          }
                                        ],
                                        "price": 22500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113685180",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "112591974",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "112591973",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510671",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734567"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734568"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734569"
                                          },
                                          {
                                            "groupId": "112591975",
                                            "addonId": "99734570"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113685180",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510671",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "112591973",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "112591974",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "112591975",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 19500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "43 ratings",
                                      "ratingCountV2": "43"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Signature Wraps (Unique Flavours)",
                      "categories": [
                        {
                          "title": "Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544304",
                                  "name": "Smoky Diced Paneer Salad Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Smoked to perfection, soft cottage cheese is paired with crunchy capsicum, corn & onion salad then drizzled with mayo & wrapped in a flaky lachha paratha. Ticks all the right checkboxes. I Calories (Kcals): 871 I Carbs (Gms): 64 I Proteins (Gms): 23 I Fats (Gms): 60",
                                  "imageId": "e12b95741390f212d06f767703362d1c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253622",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha",
                                            "default": 1,
                                            "id": "109116132",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha",
                                            "id": "109116133",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116134",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253622",
                                            "variationId": "109116132"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253622",
                                            "variationId": "109116133"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253622",
                                            "variationId": "109116134"
                                          }
                                        ],
                                        "price": 23900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937140",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937143",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937142",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937145",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937141",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937140",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937141",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937142",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937143",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937145",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126762",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126763",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 22900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109111127",
                                  "name": "Cheesy Baked Pizza Wrap (Veg)",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Is it a pizza or a wrap Let your tastebuds decide. A medley of flavours with fresh bell peppers, corn, olives & jalapenos draped in pizza sauce & mozzarella cheese, wrapped in a crispy baked paratha. So, what are you waiting for  Roll up your sleeves, and attack. I Calories (Kcals): 571 I Carbs (Gms): 62 I Proteins (Gms): 20 I Fats (Gms): 26",
                                  "imageId": "bb6328dde3d89d26ec69e1976e1ad89f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "126121602",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "126121603",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "126121604",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "126121605",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "126121606",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126762",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126763",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109111125",
                                  "name": "Mexicana Potato Corn Salsa Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Here potatoes dont potate, they do salsa. Dont take our word, try this amazing wrap of spicy seasoned potatoes, Mexican corn salsa and chipotle flavoured cheese that we roll with love in a wholewheat paratha. I Calories (Kcals): 829 I Carbs (Gms): 84 I Proteins (Gms): 12 I Fats (Gms): 50",
                                  "imageId": "f6e01d450319e5a25d2b0874dfec0f68",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253623",
                                        "name": "Customize your wrap base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116135",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116136",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 6,
                                            "id": "109116137",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253623",
                                            "variationId": "109116135"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253623",
                                            "variationId": "109116136"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253623",
                                            "variationId": "109116137"
                                          }
                                        ],
                                        "price": 21500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125936985",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125936994",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125936991",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125936998",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125936988",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125936985",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125936988",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125936991",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125936994",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125936998",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126762",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126763",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544835",
                                  "name": "Lebanese Falafel Veggie Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Crunchy, herbed Falafels and oven-roasted vegetables are generously drizzled with mint mayo and wrapped up in a wholewheat paratha. One bite is enough to transport you to the Mediterranean lands. I Calories (Kcals): 737 I Carbs (Gms): 78 I Proteins (Gms): 16 I Fats (Gms): 40",
                                  "imageId": "9bfc3a2e9747816a292fa6ab92976e4a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253625",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116141",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy Option)",
                                            "id": "109116142",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116143",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253625",
                                            "variationId": "109116141"
                                          }
                                        ],
                                        "price": 21900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253625",
                                            "variationId": "109116142"
                                          }
                                        ],
                                        "price": 21900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253625",
                                            "variationId": "109116143"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937308",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937311",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937310",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937312",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937309",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937308",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937309",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937310",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937311",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937312",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126762",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126763",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 21900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109111129",
                                  "name": "Punjabi Chole Paneer Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Everybody said paneer and chole cant be friends but we thought otherwise and created this. A perfect blend of soft masala paneer tikka, chatpate chole drizzled in flavorful mayonnaise and wrapped in wholewheat paratha. I Calories (Kcals): 781 I Carbs (Gms): 70 I Proteins (Gms): 18 I Fats (Gms): 48",
                                  "imageId": "e59cd9bd4aa5d8b410b35b81a4049018",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253641",
                                        "name": "Customize your wrap base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116189",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116190",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116191",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253641",
                                            "variationId": "109116189"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253641",
                                            "variationId": "109116190"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253641",
                                            "variationId": "109116191"
                                          }
                                        ],
                                        "price": 21900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937263",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937266",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937265",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126762"
                                          },
                                          {
                                            "groupId": "125937267",
                                            "addonId": "108126763"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937264",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937263",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937264",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937265",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937266",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937267",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126762",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126763",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809252",
                                  "name": "American Smoked Sausage Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Here comes the showstopper. Smoked chicken sausage lathered in barbeque sauce, chipotle-flavoured cheese and crunchy onions, wrapped in an omelette and wholewheat paratha. Now that's wow. I Calories (Kcals): 849 I Carbs (Gms): 62 I Proteins (Gms): 28 I Fats (Gms): 55",
                                  "imageId": "a5611297ee3475f13e4e977c141b1b1d",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253624",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116138",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116139",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116140",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253624",
                                            "variationId": "109116138"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253624",
                                            "variationId": "109116139"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253624",
                                            "variationId": "109116140"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937676",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937667",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937673",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937671",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937669",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937667",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937669",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937671",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937673",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937676",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126760",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126761",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109111131",
                                  "name": "Chicken Extravaganza Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Bestseller Alert. In this East-meets-West wrap, slow-cooked bhuna chicken and juicy chicken meatballs are wrapped along with an omelette in wholewheat paratha. I Calories (Kcals): 932 I Carbs (Gms): 60 I Proteins (Gms): 30 I Fats (Gms): 64",
                                  "imageId": "0ad89c2e1712860c0566869ee9038e60",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253634",
                                        "name": "Customize your wrap base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116168",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116169",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116173",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253634",
                                            "variationId": "109116168"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253634",
                                            "variationId": "109116169"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253634",
                                            "variationId": "109116173"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937653",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937643",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937650",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937648",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937645",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937643",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937645",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937648",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937650",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937653",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126760",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126761",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109111130",
                                  "name": "Smoked Butter Chicken Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "For the love of butter chicken and everything thats wrapped in between! Surprise your tastebuds with this amazing wrap. I Calories (Kcals): 701 I Carbs (Gms): 65 I Proteins (Gms): 39 I Fats (Gms): 23",
                                  "imageId": "e0e3b6b151ef95658999950fd4803bf0",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253626",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116144",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116145",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116146",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253626",
                                            "variationId": "109116144"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253626",
                                            "variationId": "109116145"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253626",
                                            "variationId": "109116146"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937608",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937604",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937607",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937606",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937605",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937604",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937605",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937606",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937607",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937608",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126760",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126761",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104584539",
                                  "name": "Lebanese Chicken Meatball Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Spiced chicken keftas and oven-roasted vegetables are generously drizzled with mint mayo and wrapped up in a wholewheat paratha. Street food from the Mediterranean all wrapped up for you I Calories (Kcals): 689 I Carbs (Gms): 65 I Proteins (Gms): 20 I Fats (Gms): 39",
                                  "imageId": "15921d88d6950115b39f0b3722fb49d9",
                                  "inStock": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253620",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116126",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy)",
                                            "id": "109116127",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116128",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253620",
                                            "variationId": "109116126"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253620",
                                            "variationId": "109116127"
                                          }
                                        ],
                                        "price": 22900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253620",
                                            "variationId": "109116128"
                                          }
                                        ],
                                        "price": 23900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937956",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937952",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937955",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937954",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937953",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937952",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937953",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937954",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937955",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937956",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126760",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126761",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 22900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "87915466",
                                  "name": "Zaikedar Mutton Bhuna Wrap",
                                  "category": "Signature Wraps (Unique Flavours)",
                                  "description": "Straight from the Faasos hall of fame. Soft and scrumptious mutton chunks cooked in bhuna flavorful masala and wrapped with an omelette in a wholewheat paratha. Order and let the good times roll. I Calories (Kcals): 870 I Carbs (Gms): 72 I Proteins (Gms): 39 I Fats (Gms): 49",
                                  "imageId": "72ba7c4a4fe9764edddf6f9e1732db0a",
                                  "inStock": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35253637",
                                        "name": "Customize Your Wrap Base",
                                        "variations": [
                                          {
                                            "name": "Lachha Paratha (Handcrafted)",
                                            "default": 1,
                                            "id": "109116177",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Wholewheat Paratha (Healthy Option)",
                                            "id": "109116178",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Crispy Bake (Chefs Special)",
                                            "price": 10,
                                            "id": "109116179",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253637",
                                            "variationId": "109116177"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253637",
                                            "variationId": "109116178"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "35253637",
                                            "variationId": "109116179"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126760"
                                          },
                                          {
                                            "groupId": "125937748",
                                            "addonId": "108126761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "125937743",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733324"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733325"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733326"
                                          },
                                          {
                                            "groupId": "125937747",
                                            "addonId": "99733327"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "125937746",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "125937745",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125937743",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937745",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937746",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937747",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125937748",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "108126760",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108126761",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Guilt Free Wraps (Wholewheat)",
                      "categories": [
                        {
                          "title": "Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117216383",
                                  "name": "Masala Paneer Tikka Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "We dont have any pun for paneer, but we do have a lot of surprises in this exciting snack that we roll into this wrap. Fresh marinated paneer (with cooked onion) is smoked to perfection & drizzled with minty, spicy mayonnaise & wrapped in soft roti. I Calories (Kcals): 616 I Carbs (Gms): 52 I Proteins (Gms): 22 I Fats (Gms): 36",
                                  "imageId": "310c8e087649c515d9c732221447db61",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 20000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722596",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489042",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859474",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489046",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489047",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "49 ratings",
                                      "ratingCountV2": "49"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103744212",
                                  "name": "Chatpate Chole Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "No one believed us when we said chole can be even more exciting. So we created a wrap that has tangy burst of chole with flavorful Indian spices and crunchy onions, wrapped in a soft wholewheat roti. Try it & get surprised. I Calories (Kcals): 511 I Carbs (Gms): 63 I Proteins (Gms): 14 I Fats (Gms): 23",
                                  "imageId": "302d2f78339f2807c36b9392142e59d9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722599",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489051",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859686",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489054",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489056",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131745427",
                                  "name": "Smoky Diced Paneer Salad Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "Smoked to perfection, soft cottage cheese is paired with crunchy capsicum, corn & onion salad then drizzled with mayo & wrapped in a flaky lachha paratha. Ticks all the right checkboxes. I Calories (Kcals): 820 I Carbs (Gms): 55 I Proteins (Gms): 23 I Fats (Gms): 58",
                                  "imageId": "11e81f846a8572d501b013f9e5f33d13",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "130696377",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "130696378",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "130696379",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "130696380",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "130696381",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734445",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734438",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734442",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 3,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Non-Veg Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117216386",
                                  "name": "Masala Chicken Tikka Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "Bored of the same old flavours Excite your taste buds with surprises that we roll into this wrap. Smokey marinated chicken tikka (with cooked onion) taken a notch above with a generous drizzle of minty, tangy mayonnaise clubbed with crunchy onions in a soft roti. I Calories (Kcals): 575 I Carbs (Gms): 51 I Proteins (Gms): 22 I Fats (Gms): 31",
                                  "imageId": "577c8207e32e22b8cf1374391c95b22b",
                                  "inStock": 1,
                                  "price": 21000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722601",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510822",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111860005",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489062",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489064",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117216384",
                                  "name": "Chicken Bhuna Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "The bestseller, rock n roll award goes to: Roasted and flavorful chicken pieces slow-cooked in spicy bhuna masala with onion and wrapped with crisp onions in a freshly made roti. Is it snack time yet I Calories (Kcals): 587 I Carbs (Gms): 51 I Proteins (Gms): 16 I Fats (Gms): 35",
                                  "imageId": "ebd668bf04b61c51a1c043a92667385f",
                                  "inStock": 1,
                                  "price": 21000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722600",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510778",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859944",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489075",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489079",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117216388",
                                  "name": "Malai Chicken Kebab Wholewheat Wrap",
                                  "category": "Guilt Free Wraps (Wholewheat)",
                                  "description": "Fix your mundane days & let the good times roll. Oh so creamy & exotic, this Reshmi Chicken Wrap is made with soft chicken pieces cooked in creamy, rich & decadent masala. Remember, this is not made for sharing. I Calories (Kcals): 570 I Carbs (Gms): 52 I Proteins (Gms): 21 I Fats (Gms): 31",
                                  "imageId": "a5d81541dbc174847cdaf44df25ab4e8",
                                  "inStock": 1,
                                  "price": 21000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722604",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115511028",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111860060",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489089",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489092",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99734569",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734570",
                                          "name": "Extra Cheese (In The Wrap)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734567",
                                          "name": "No Mayo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734568",
                                          "name": "No Raw Onion",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Wrap Meals (Save Upto 30%)",
                      "categories": [
                        {
                          "title": "Meals for 1 (starting at 119)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390627",
                                  "name": "Veg Signature Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Definite fun and exclusive SAVINGS. Choose from your favorite veg signature wrap with a starter or dessert.",
                                  "imageId": "b08ea685e5357177d5ff91b1698f5019",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288108",
                                      "groupName": "Choose Veg Signature Wrap - (Any 1)",
                                      "choices": [
                                        {
                                          "id": "99733439",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733440",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733445",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733441",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733444",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288109",
                                      "groupName": "Choose Accompaniment",
                                      "choices": [
                                        {
                                          "id": "108761909",
                                          "name": "French Fries (Large)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195281",
                                          "name": "Potato Wedges (Large)",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381192",
                                          "name": "French Fries",
                                          "price": 1100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381190",
                                          "name": "Potato Wedges Medium",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381191",
                                          "name": "Chocolate Fantasy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381193",
                                          "name": "Hazelnut Brownie",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179141",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179144",
                                          "name": "Thums Up 330 ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288110",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116531082",
                                  "name": "Veg Classic Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Let SAVINGS up to Rs. 39 and delicious surprises spoil you for choice. 1 veg classic wrap + 1 starter or dessert of your choice",
                                  "imageId": "bf9fa075064f176605d321c81b989153",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "122704869",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287921",
                                      "groupName": "Choose Accompaniment",
                                      "choices": [
                                        {
                                          "id": "108761909",
                                          "name": "French Fries (Large)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195281",
                                          "name": "Potato Wedges (Large)",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381192",
                                          "name": "French Fries",
                                          "price": 1100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381190",
                                          "name": "Potato Wedges Medium",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381191",
                                          "name": "Chocolate Fantasy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381193",
                                          "name": "Hazelnut Brownie",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179141",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179144",
                                          "name": "Thums Up 330 ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287925",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97732615",
                                  "name": "Cheese Melt Paneer Wrap & Wedges Mini Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs. 55 with this cheesy combo of 1 Cheese Melt Paneer Wrap , 1 Wedges. Something cheesy with a side of spicy and sassy awaits",
                                  "imageId": "99a65ffa969e461983ba888d222b203e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287769",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97732617",
                                  "name": "Masala Paneer Tikka Wrap & Wedges Mini Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs. 25 with this combo of 1 Masala Paneer Tikka Wrap , 1 Wedges. This spiced up combo is here to make saving big a tastier task",
                                  "imageId": "f9eebce3c350e859dadf462d38122739",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288179",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497614",
                                  "name": "Veg Classic Wrap & Wedges Meal at 168",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Let SAVINGS up to Rs 80 and delicious surprises spoil you for choice. 1 veg classic wrap + 1 wedges of your choice.",
                                  "imageId": "c06a44445b0a06dc2b77077e5d75eb07",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287879",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287882",
                                      "groupName": "Choose Your Wedges",
                                      "choices": [
                                        {
                                          "id": "101202986",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202987",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202988",
                                          "name": "Peri Peri Cheese Wedges",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202989",
                                          "name": "Chipotle Cheese Wedges (Newly Launched)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202990",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287884",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497543",
                                  "name": "Veg Classic Wrap and Beverage Meal at 119",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Savings upto Rs 45, this deal surely feels like a heaven. With your choice of a classic veg wrap, and a beverage, this will make you go wow.",
                                  "imageId": "bf54b648895f8a183096ebbb0a73c308",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288056",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288058",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202965",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202967",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202966",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202968",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476048",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288064",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309571",
                                  "name": "Veg Signature Wrap & Fries Meal at 289",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save upto Rs 54, heres your quick-fix. Get your choice of 1 signature veg wrap & fries. We can hear your stomach growling already.",
                                  "imageId": "7061ed56b45ad80c9f95c4545b666152",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287938",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287942",
                                      "groupName": "Choose Your Fries",
                                      "choices": [
                                        {
                                          "id": "101202983",
                                          "name": "French Fries",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202984",
                                          "name": "Teekha Chaska French Fries",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761905",
                                          "name": "French Fries (Large)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287945",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309607",
                                  "name": "Veg Classic Wrap & Fries Meal at 199",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Happy times are here. Save upto Rs 74 with your favourite veg classic wrap & fries combo. What else can you ask for.",
                                  "imageId": "8c1e20a55f6e98ef778cc78874835299",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288073",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288076",
                                      "groupName": "Choose Your Fries",
                                      "choices": [
                                        {
                                          "id": "101202983",
                                          "name": "French Fries",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202984",
                                          "name": "Teekha Chaska French Fries",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761905",
                                          "name": "French Fries (Large)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288078",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309563",
                                  "name": "Veg Signature Wrap & Wedges Meal at 245",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save upto Rs 83, heres your quick-fix. Get your choice of 1 signature veg wrap & wedges. We can hear your stomach growling already.",
                                  "imageId": "c90fe443f5de416cf7ca9f5cc94c3a43",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287891",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287896",
                                      "groupName": "Choose Your Wedges",
                                      "choices": [
                                        {
                                          "id": "101202986",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202987",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202988",
                                          "name": "Peri Peri Cheese Wedges",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202989",
                                          "name": "Chipotle Cheese Wedges (Newly Launched)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202990",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287899",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120347119",
                                  "name": "Non-Veg Signature Wrap, Side & Beverage Meal at 289",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save upto 56, heres your quick-fix. Get your choice of 1 signature veg wrap, beverage and side. We can hear your stomach growling already.",
                                  "imageId": "88a4348c5f843e190adc54d8fb9b8052",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288116",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288118",
                                      "groupName": "Choose Your Side (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "110559285",
                                          "name": "Cheesy Chicken Meatballs (3 pieces)",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203860",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203861",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203862",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203863",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203864",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203865",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203866",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761906",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203868",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203869",
                                          "name": "Teekha Chaska Sausages",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288119",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288120",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497641",
                                  "name": "Veg Signature Wrap & Beverage Meal at 219",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save upto Rs 20 while you watch your tastebuds do the jive. Choose 1 veg signature wrap, & 1 beverage. Personal party-time it is.",
                                  "imageId": "ae68a6466ff313c960a308cfb5262bf4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 21900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288194",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288197",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288198",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390630",
                                  "name": "Non-Veg Signature Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Your favourite wrap meal at an amazing deal. Choose from your favourite non-veg signature wrap with a starter or dessert",
                                  "imageId": "44eedfbcc73f5ab6e279922d352d4560",
                                  "inStock": 1,
                                  "price": 33900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288338",
                                      "groupName": "Choose NonVeg Signature Wrap (Any 1)",
                                      "choices": [
                                        {
                                          "id": "99733592",
                                          "name": "American Smoked Sausage Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733593",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733596",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733594",
                                          "name": "Lebanese Chicken Kefta Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733597",
                                          "name": "Zaikedar Mutton Bhuna Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288343",
                                      "groupName": "Choose Accompaniment",
                                      "choices": [
                                        {
                                          "id": "108761907",
                                          "name": "French Fries (Large)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195368",
                                          "name": "Potato Wedges (Large)",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381213",
                                          "name": "French Fries",
                                          "price": 1100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381211",
                                          "name": "Potato Wedges Medium",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381215",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 2300,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381212",
                                          "name": "Chocolate Fantasy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381214",
                                          "name": "Hazelnut brownie",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179142",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179143",
                                          "name": "Thums Up 330 ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288345",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116531138",
                                  "name": "Non-Veg Classic Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Something sweet, something savory and SAVINGS up to Rs. 39, amazing isnt it, 1 non-veg classic wrap + 1 starter or dessert of your choice",
                                  "imageId": "4e6600a22c5d9195142d4faa6e0c054e",
                                  "inStock": 1,
                                  "price": 24500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288210",
                                      "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                      "choices": [
                                        {
                                          "id": "99733551",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733547",
                                          "name": "Chicken Bhuna Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733552",
                                          "name": "Reshmi Chicken Kebab Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733553",
                                          "name": "Cheese Melt Chicken Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733548",
                                          "name": "Egg Cheese Sausage Wrap",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733549",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733554",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733550",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288213",
                                      "groupName": "Choose Accompaniment",
                                      "choices": [
                                        {
                                          "id": "108761907",
                                          "name": "French Fries (Large)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195368",
                                          "name": "Potato Wedges (Large)",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381213",
                                          "name": "French Fries",
                                          "price": 1100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381211",
                                          "name": "Potato Wedges Medium",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381215",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 2300,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381212",
                                          "name": "Chocolate Fantasy",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100381214",
                                          "name": "Hazelnut brownie",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179142",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110179143",
                                          "name": "Thums Up 330 ml Can",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288215",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125245466",
                                  "name": "Chicken Bhuna Wrap & Wedges Mini Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs. 15 with this perfect combo of 1 Chicken Bhuna Wrap , 1 Wedges (S). Something masaledar with a side of spicy and sassy awaits.",
                                  "imageId": "1ef556d937612f996027113bc8f5d762",
                                  "inStock": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287768",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497608",
                                  "name": "Non-Veg Classic Wrap & Wedges Meal at 168",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Something exciting, something flavorful and SAVINGS up to Rs 90, amazing isnt it, 1 non-veg classic wrap + 1 starter of your choice.",
                                  "imageId": "39560c9ec7b6f3f81c09d8da541e2668",
                                  "inStock": 1,
                                  "price": 16800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288089",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288093",
                                      "groupName": "Choose Your Wedges",
                                      "choices": [
                                        {
                                          "id": "101202986",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202987",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202988",
                                          "name": "Peri Peri Cheese Wedges",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202989",
                                          "name": "Chipotle Cheese Wedges (Newly Launched)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202990",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288096",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497607",
                                  "name": "Non-Veg Classic Wrap and Beverage Meal at 119",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "FYI, this time you got savings upto Rs 45. Add your choice of a classic non-veg wrap and a beverage. Now dont let all that chomp chomp stop.",
                                  "imageId": "2c21b93b8bba679cb1a71fb78831c6ff",
                                  "inStock": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287771",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287772",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202965",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202967",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202966",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202968",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476048",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287774",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120497558",
                                  "name": "Non-Veg Classic Wrap, Side and Beverage Meal at 188",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "FYI, this time you got savings upto Rs 95. Add your choice of classic non-veg wrap, beverage and a side. Now dont let all that chomp chomp stop.",
                                  "imageId": "8f3d99d2d6cea26d01513e4ee092f970",
                                  "inStock": 1,
                                  "price": 18800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288365",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288367",
                                      "groupName": "Choose Your Side (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "110559285",
                                          "name": "Cheesy Chicken Meatballs (3 pieces)",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203860",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203861",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203862",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203863",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203864",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203865",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203866",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761906",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203868",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203869",
                                          "name": "Teekha Chaska Sausages",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288371",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "110488190",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309542",
                                  "name": "Non-Veg Signature Wrap & Fries Meal at 299",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Signature savings of upto Rs 54, on signature cravings. Get your choice of 1 signature non-veg wrap & any fries. Time to switch that nom nom mode ON.",
                                  "imageId": "7967a72ce4c0e9c2fbb9b6722c1b4ad6",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287784",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287786",
                                      "groupName": "Choose Your Fries",
                                      "choices": [
                                        {
                                          "id": "101202983",
                                          "name": "French Fries",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202984",
                                          "name": "Teekha Chaska French Fries",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761905",
                                          "name": "French Fries (Large)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287787",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309613",
                                  "name": "Non-Veg Classic Wrap & Fries Meal at 199",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Get spoiled with the delicious surprises. Enjoy a delicious meal of your favourite non-veg classic wrap & fries and save upto Rs 64.",
                                  "imageId": "e4b85a83410b16dc2504339e77e73562",
                                  "inStock": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288099",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288100",
                                      "groupName": "Choose Your Fries",
                                      "choices": [
                                        {
                                          "id": "101202983",
                                          "name": "French Fries",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202984",
                                          "name": "Teekha Chaska French Fries",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761905",
                                          "name": "French Fries (Large)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288102",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309543",
                                  "name": "Non-Veg Signature Wrap & Wedges Meal at 269",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Signature savings of upto Rs 65, on signature cravings. Get your choice of 1 signature non-veg wrap & any wedges. Time to switch that nom nom mode ON.",
                                  "imageId": "8b720aa4a06222c6d124bb3df06d3783",
                                  "inStock": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287791",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287793",
                                      "groupName": "Choose Your Wedges",
                                      "choices": [
                                        {
                                          "id": "101202986",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202987",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202988",
                                          "name": "Peri Peri Cheese Wedges",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202989",
                                          "name": "Chipotle Cheese Wedges (Newly Launched)",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202990",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287795",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309539",
                                  "name": "Non-Veg Signature Wrap & Beverage Meal at 225",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Give a high-five to savings of upto Rs 24. Choose 1 non-veg signature wrap & 1 beverage and tell yourself cest la vie.",
                                  "imageId": "74d5c599b8a9fe9123b79059d94ec98b",
                                  "inStock": 1,
                                  "price": 22500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287776",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287777",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114287779",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309638",
                                  "name": "Veg Signature Wrap, Side & Beverage Meal at 269",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Signature savings of upto 56, on signature cravings. Get your choice of 1 signature non-veg wrap, beverage and side. Time to switch that nom nom mode ON.",
                                  "imageId": "7f27b66f73a34ad768e3e0de5d9ab9ae",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288328",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288330",
                                      "groupName": "Choose Your Side (Veg)",
                                      "choices": [
                                        {
                                          "id": "101204156",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204157",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204158",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204159",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204160",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204161",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204162",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204163",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761910",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288333",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114288334",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Snacking Meals",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125258691",
                                  "name": "Double Potato Wedges Combo",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs. 29 and indulge in this combo of 2 portions of Wedges. Cause when is one ever enough.",
                                  "imageId": "fd736054d5b7f7b5e853e0db61f25a5c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113882013",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544810",
                                  "name": "Wedges & Choco Lava Combo",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs 19 with this combo of 1 Wedges + 1 Choco Lava. The perfect combination of sweet & savory to hit all the right spots.",
                                  "imageId": "c28a173ee704a05e0d6f3d80d5649e55",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113881990",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116768332",
                                  "name": "Choose Your Own 4 Sides Combo",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Savings of upto 51 and a hell lot of fun. Get 2 portions of fries and 2 portion of wedges. Just the side-kick stealing the limelight.",
                                  "imageId": "b7b740cff6bf22408aba86cb6f09dd66",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113882014",
                                      "groupName": "Choose Veg Side (Any 1)",
                                      "choices": [
                                        {
                                          "id": "99733789",
                                          "name": "French Fries",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733787",
                                          "name": "Potato Wedges (Medium)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733788",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "113882015",
                                      "groupName": "Choose Second Veg Side (Any 1)",
                                      "choices": [
                                        {
                                          "id": "99734018",
                                          "name": "French Fries (Medium)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734016",
                                          "name": "Potato Wedges (Medium)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99734017",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "113882016",
                                      "groupName": "Choose Third Veg Side",
                                      "choices": [
                                        {
                                          "id": "99735955",
                                          "name": "French Fries (Medium)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735951",
                                          "name": "Potato Wedges (Medium)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735953",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "113882017",
                                      "groupName": "Choose Fourth Veg Side",
                                      "choices": [
                                        {
                                          "id": "99735962",
                                          "name": "French Fries (Medium)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735957",
                                          "name": "Potato Wedges (Medium)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735960",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "113882018",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104134119",
                                  "name": "Veg-Non Veg Sides Platter",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "SAVE Rs. 28 with this late night combo of dreams with all the munchies you would want, 1 Wedges , 1 Chili Shots , 1 Meatballs",
                                  "imageId": "4ab2f2c2d6714b9dd3167304188de93a",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113881985",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Meals for 2 & More (starting at 299)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309627",
                                  "name": "2 Masala Paneer Tikka Wrap with Fries & Coke Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save FLAT Rs 105 For all the paneer lovers out there, this combo is for you! 2 Masala Paneer Tikka Wrap + 1 Fries + 1 Coke (475 ml)",
                                  "imageId": "31435d9eddc2801d336c028d2f3d1a96",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114288227",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116768330",
                                  "name": "2 Classic Veg Wraps with 2 Sides & Beverage Combo Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "With savings of upto 156 this meal of your choice of 2 classic veg wraps, 1 beverage and 2 sides is a perfect deal-breaker. Now order, save, repeat.",
                                  "imageId": "7d216a552d92f7b7295b1d28fc13d2d5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114945188",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945189",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656753",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656754",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656755",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656756",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656757",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656758",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656759",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656760",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656761",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945190",
                                      "groupName": "Choose Your Side (Veg)",
                                      "choices": [
                                        {
                                          "id": "101204156",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204157",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204158",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204159",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204160",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204161",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204162",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204163",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761910",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945191",
                                      "groupName": "Choose Your Second Side (Veg)",
                                      "choices": [
                                        {
                                          "id": "101792045",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792046",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792047",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792048",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792049",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792050",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792051",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101792052",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761904",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945192",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945193",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125466974",
                                  "name": "3 Classic Veg Wraps at 99 each",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "All hearts for SAVINGS up to Rs. 135 & all smiles for surprises. Choose any 3 from your favourite Classic Veg wraps loaded with unique ingredients and enjoy. Can we get a wow.",
                                  "imageId": "efe7261b1afff7c02ada806da9e7b03b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785406",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785409",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656753",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656754",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656755",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656756",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656757",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656758",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656759",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656760",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656761",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785411",
                                      "groupName": "Choose Your Third Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656762",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656763",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656764",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656765",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656766",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656767",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656768",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656769",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656770",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785413",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116768318",
                                  "name": "2 Signature Veg Wraps with Side & Beverage Combo Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save upto 85 while you watch your tastebuds do the jive. Choose 2 veg signature wraps, 1 beverage and 1 side. Personal party-time it is.",
                                  "imageId": "7064945d72f4ebfafdb806c9fa200505",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 44900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114887826",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887827",
                                      "groupName": "Choose Your Second Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101730088",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730089",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730090",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730091",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730092",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887828",
                                      "groupName": "Choose Your Side (Veg)",
                                      "choices": [
                                        {
                                          "id": "101204156",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204157",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204158",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204159",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204160",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204161",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204162",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101204163",
                                          "name": "Potato Wedges (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761910",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887829",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887830",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125513524",
                                  "name": "3 Signature Veg Wraps at 498",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Bolder the flavours, bigger the SAVINGS up to Rs. 159. Choose any 3 from our Signature veg wraps & enjoy this delicious meal for 3. Because if two is company, three is a party for sure.",
                                  "imageId": "2b3be089e0043b259057ca0ad7bf6c1e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114887822",
                                      "groupName": "Choose Your Signature Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101203301",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203302",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203303",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203304",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203305",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887823",
                                      "groupName": "Choose Your Second Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101730088",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730089",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730090",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730091",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730092",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887824",
                                      "groupName": "Choose Your Third Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101730095",
                                          "name": "Punjabi Chole Paneer Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730096",
                                          "name": "Mexicana Potato Corn Salsa Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730097",
                                          "name": "Cheesy Baked Pizza Wrap (Veg)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730098",
                                          "name": "Lebanese Falafel Veggie Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101730099",
                                          "name": "Smoky Diced Paneer Salad Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114887825",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125466879",
                                  "name": "4 Classic Veg Wraps at 95 each",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "All hearts for SAVINGS up to Rs. 220 & all smiles for surprises. Choose any 4 from your favourite Classic Veg wraps loaded with unique ingredients and enjoy. Can we get a wow.",
                                  "imageId": "52415bc7954a4323b7a02b1150667a2a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785023",
                                      "groupName": "Choose Your Classic Wrap (Veg)",
                                      "choices": [
                                        {
                                          "id": "101202920",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202921",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202922",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202923",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202924",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202925",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202926",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202927",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202928",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785025",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656753",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656754",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656755",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656756",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656757",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656758",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656759",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656760",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656761",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785028",
                                      "groupName": "Choose Your Third Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656762",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656763",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656764",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656765",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656766",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656767",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656768",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656769",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656770",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785031",
                                      "groupName": "Choose Your Fourth Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656771",
                                          "name": "Chatpate Chole Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656772",
                                          "name": "Indie Chatpata Aloo Wrap",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656773",
                                          "name": "Ultimate Chipotle Aloo Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656774",
                                          "name": "Ultimate Chipotle Veg Patty Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656775",
                                          "name": "Veg Falafel Wrap",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656776",
                                          "name": "Chipotle Potato Shots Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656777",
                                          "name": "Cheesy Corn Salsa Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656778",
                                          "name": "Masala Paneer Tikka Wrap",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656779",
                                          "name": "Cheese Melt Paneer Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785034",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125309558",
                                  "name": "2 Chicken Bhuna Wrap with Fries & Coke Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Save FLAT Rs 97! An overload of flavours and overload of surprises await you with this meal consisting of 2 Masala Chicken Tikka Wrap + 1 Fries + 1 Coke (475 ml). Try now!",
                                  "imageId": "f8adcea6815b425e12bc4454c8cbe707",
                                  "inStock": 1,
                                  "price": 44900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114287870",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116768322",
                                  "name": "2 Classic Non-Veg Wraps with 2 Sides & Beverage Combo Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "No more wait, straightaway save upto 158. Choose 2 non-veg wraps, 1 beverage and 2 sides, and switch that binge-watching mode ON right away.",
                                  "imageId": "7d93cc8c85e5c9b3f1c80ce481f2b75a",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114945179",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945181",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656780",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656781",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656782",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656783",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656784",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656785",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656786",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656787",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945182",
                                      "groupName": "Choose Your Side (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "110559285",
                                          "name": "Cheesy Chicken Meatballs (3 pieces)",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203860",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203861",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203862",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203863",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203864",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203865",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203866",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761906",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203868",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101203869",
                                          "name": "Teekha Chaska Sausages",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945183",
                                      "groupName": "Choose Your Second Side (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "110559283",
                                          "name": "Cheesy Chicken Meatballs (3 pieces)",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657285",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657286",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657287",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657288",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657289",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657290",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657291",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761908",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657293",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657294",
                                          "name": "Teekha Chaska Sausages",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945184",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114945185",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125466953",
                                  "name": "3 Classic Non-Veg Wraps at 99 each",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Lip-smacking flavours at jaw-dropping SAVINGS up to Rs. 135. Choose any 4 from your favourite Classic Non-Veg wraps with extraordinary flavours.",
                                  "imageId": "30ce1e557ab6aa9a6a86a1c6a31b5650",
                                  "inStock": 1,
                                  "price": 29700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785318",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785323",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656780",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656781",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656782",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656783",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656784",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656785",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656786",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656787",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785330",
                                      "groupName": "Choose Your Third Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656788",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656789",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656790",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656791",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656792",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656793",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656794",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656795",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785337",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116768315",
                                  "name": "2 Signature Non-Veg Wraps with Side & Beverage Combo Meal",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Give a high-five to savings of upto 95. Choose 2 non-veg signature wraps, 1 beverage with 1 side and tell yourself cest la vie.",
                                  "imageId": "3744e6037dfd09d94b1c1b04a1b18940",
                                  "inStock": 1,
                                  "price": 49900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785456",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785457",
                                      "groupName": "Choose Your Second Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101657121",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657123",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657124",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657125",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657126",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657127",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785458",
                                      "groupName": "Choose Your Second Side (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "110559283",
                                          "name": "Cheesy Chicken Meatballs (3 pieces)",
                                          "price": 500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657285",
                                          "name": "Potato Wedges (Small)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657286",
                                          "name": "Falafel Shots (6 pieces)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657287",
                                          "name": "Potato Chilli Shots (6 Pcs)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657288",
                                          "name": "Potato Wedges (Medium)",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657289",
                                          "name": "Potato Chilli Shots with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657290",
                                          "name": "Falafel Nuggets with Mayo Dip",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657291",
                                          "name": "French Fries",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108761908",
                                          "name": "French Fries (Large)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657293",
                                          "name": "Cheesy Chicken Meatballs",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657294",
                                          "name": "Teekha Chaska Sausages",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785459",
                                      "groupName": "Choose Your Beverage",
                                      "choices": [
                                        {
                                          "id": "101202977",
                                          "name": "Masala Lemonade (180 ml)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202978",
                                          "name": "Skimmed Mint Buttermilk",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202980",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202979",
                                          "name": "SWIG Jeera Masala Soda",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476050",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202981",
                                          "name": "SWIG Green Apple",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785460",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125466967",
                                  "name": "3 Signature Non-Veg Wraps at 570",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Surprise your taste buds and your pockets with max SAVINGS of Rs. 165 & delicious flavours. Choose your 3 favourite Signature Non-veg wraps loaded with deliciously unique ingredients. Theres no reason to delay here.",
                                  "imageId": "22d81d775651f460aa90465f4e5925b1",
                                  "inStock": 1,
                                  "price": 57000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785380",
                                      "groupName": "Choose Your Signature Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202969",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202971",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202972",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202973",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202974",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202975",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785383",
                                      "groupName": "Choose Your Second Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101657121",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657123",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657124",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657125",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657126",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657127",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785390",
                                      "groupName": "Choose Your Third Signature Wrap",
                                      "choices": [
                                        {
                                          "id": "101657128",
                                          "name": "Lebanese Chicken Meatball Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657130",
                                          "name": "American Smoked Sausage Wrap",
                                          "price": 2000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657131",
                                          "name": "Chicken Extravaganza Wrap",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657132",
                                          "name": "Smoked Butter Chicken Wrap",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657133",
                                          "name": "Zaikedar Chicken Tikka Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101657134",
                                          "name": "Zaikedar Chicken Bhuna Wrap",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785398",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125466946",
                                  "name": "4 Classic Non-Veg Wraps at 95 each",
                                  "category": "Wrap Meals (Save Upto 30%)",
                                  "description": "Lip-smacking flavours at jaw-dropping SAVINGS up to Rs. 220. Choose any 4 from your favourite Classic Non-Veg wraps with extraordinary flavours.",
                                  "imageId": "d740aabf786990ceae4ed47b370af950",
                                  "inStock": 1,
                                  "price": 38000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "114785287",
                                      "groupName": "Choose Your Classic Wrap (NonVeg)",
                                      "choices": [
                                        {
                                          "id": "101202956",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202957",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202958",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202959",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202960",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202961",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202962",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101202963",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785292",
                                      "groupName": "Choose Your Second Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656780",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656781",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656782",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656783",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656784",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656785",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656786",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656787",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785295",
                                      "groupName": "Choose Your Third Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656788",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656789",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656790",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656791",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656792",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656793",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656794",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656795",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785300",
                                      "groupName": "Choose Your Fourth Classic Wrap",
                                      "choices": [
                                        {
                                          "id": "101656796",
                                          "name": "Double Egg Chatpata Wrap",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656797",
                                          "name": "Cheese Melt Double Egg Wrap",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656798",
                                          "name": "Egg Cheese Chicken Sausage Wrap",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656799",
                                          "name": "Masala Chicken Tikka Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656800",
                                          "name": "Chicken Bhuna Wrap",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656801",
                                          "name": "Malai Chicken Kebab Wrap",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656802",
                                          "name": "Cheese Melt Chicken Tikka Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101656803",
                                          "name": "Malai Chicken Cheese Melt Wrap",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "114785304",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Rice Bowls",
                      "categories": [
                        {
                          "title": "Classic Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "80417858",
                                  "name": "Rajma Masala Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "This humble dish just became more delicous! Choose your favourite from Spicy Hyderabadi Rice or Classic Flavourful Rice with slow-cooked rajma in a delicious gravy I Calories (Kcals): 553 I Carbs (Gms): 92 I Proteins (Gms): 10 I Fats (Gms): 16",
                                  "imageId": "0a78c425bfbf6e438a3c225e2c33bf1a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066911",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99069842",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99069843",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066911",
                                            "variationId": "99069842"
                                          }
                                        ],
                                        "price": 18900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066911",
                                            "variationId": "99069843"
                                          }
                                        ],
                                        "price": 18900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489188",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780831",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111860059",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489185",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780831",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489185",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111860059",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489188",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809273",
                                  "name": "Rajma Masala Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Amp up your mundane life with this delicious meal! A wholesome bowl of all-time favourite rajma slow-cooked in subtly spiced gravy and served with a portion of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 885 I Carbs (Gms): 142 I Proteins (Gms): 16 I Fats (Gms): 29",
                                  "imageId": "563e8ec6f6b1a1137126ff789bfd17fd",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066919",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99069871",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99069872",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066919",
                                            "variationId": "99069871"
                                          }
                                        ],
                                        "price": 23900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066919",
                                            "variationId": "99069872"
                                          }
                                        ],
                                        "price": 23900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489224",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780539",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859621",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489221",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780539",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489221",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859621",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489224",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 23900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119496446",
                                  "name": "Corn Salsa Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Let your taste buds fall in love with this unique India-meet-Mexico bowl made using delicious corn kernels with tangy salsa sauce served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 542 I Carbs (Gms): 102 I Proteins (Gms): 11 I Fats (Gms): 11",
                                  "imageId": "d56b4174b0f8326acfb1a247f1f98be3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066912",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "default": 1,
                                            "id": "99069844",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "id": "99069845",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066912",
                                            "variationId": "99069844"
                                          }
                                        ],
                                        "price": 18900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066912",
                                            "variationId": "99069845"
                                          }
                                        ],
                                        "price": 18900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489196",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780510",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859588",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489192",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780510",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489192",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859588",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489196",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 18900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809272",
                                  "name": "Veg Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "A large-sized bowl meal with a jaw-dropping, awe-inspiring flavours! Spicy Hyderabadi Rice or Classic Flavourful Rice is topped with either flavourful chole or spicy paneer tikka masala",
                                  "imageId": "e4b0298c74c5bec945ca5fc2c31e0fc5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066915",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99069851",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99069852",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066915",
                                            "variationId": "99069851"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735219"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735220"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735221"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735222"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735223"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735224"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066915",
                                            "variationId": "99069852"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489212",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780700",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735219"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735220"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735221"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735222"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735223"
                                          },
                                          {
                                            "groupId": "110489207",
                                            "addonId": "99735224"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859930",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "110489209",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780700",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489207",
                                      "groupName": "Choose Gravy (Veg) Jumbo",
                                      "choices": [
                                        {
                                          "id": "99735219",
                                          "name": "Paneer Tikka Jumbo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735220",
                                          "name": "Corn Salsa Jumbo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735221",
                                          "name": "Chole Jumbo",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735223",
                                          "name": "Paneer and Corn Salsa Jumbo",
                                          "price": 1905,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735224",
                                          "name": "Paneer and Chole Jumbo",
                                          "price": 1905,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735222",
                                          "name": "Chole and Corn Salsa Jumbo",
                                          "price": 1429,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "110489209",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859930",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489212",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809271",
                                  "name": "Chicken Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Take a few steps away from the same old and experience the new! Pick your favourite from chicken tikka, bhuna chicken or reshmi chicken kebab served with Spicy Hyderabadi Rice or Classic Flavourful Rice",
                                  "imageId": "f910f2ae7753fd12b932cf15ddbc0812",
                                  "inStock": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066951",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070032",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070033",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066951",
                                            "variationId": "99070032"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735336"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735337"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735338"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735339"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735340"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735341"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735342"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735343"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735344"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735345"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489368",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066951",
                                            "variationId": "99070033"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489365",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780486",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859485",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735336"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735337"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735338"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735339"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735340"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735341"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735342"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735343"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735344"
                                          },
                                          {
                                            "groupId": "110489357",
                                            "addonId": "99735345"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510630",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489368",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780486",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489357",
                                      "groupName": "Choose Gravy (Non-Veg) Jumbo",
                                      "choices": [
                                        {
                                          "id": "99735336",
                                          "name": "Chicken Tikka Jumbo",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735337",
                                          "name": "Reshmi Chicken Kabab Jumbo",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735338",
                                          "name": "Chicken Bhuna Jumbo",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735339",
                                          "name": "Chicken Salami Jumbo",
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735343",
                                          "name": "Chicken Tikka and Reshmi Chicken Kabab Jumbo",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735344",
                                          "name": "Chicken Tikka and Chicken Bhuna Jumbo",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735340",
                                          "name": "Chicken Tikka and Chicken Salami Jumbo",
                                          "price": 1905,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735345",
                                          "name": "Reshmi Chicken Kabab and Chicken Bhuna Jumbo",
                                          "price": 2381,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735341",
                                          "name": "Reshmi Chicken Kabab and Chicken Salami Jumbo",
                                          "price": 1905,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99735342",
                                          "name": "Chicken Bhuna and Chicken Salami Jumbo",
                                          "price": 1905,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1,
                                      "minAddons": 1
                                    },
                                    {
                                      "groupId": "115510630",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859485",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489365",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489368",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "27 ratings",
                                      "ratingCountV2": "27"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809301",
                                  "name": "Egg Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "This bowl is packed with delicious surprises, here to add eggstra flavour to your life. Pick your favourite from, Spicy Hyderabadi Rice or Classic Flavourful Rice with subtly-spiced gravy and a golden-fried omelette I Calories (Kcals): 581 I Carbs (Gms): 86 I Proteins (Gms): 16 I Fats (Gms): 20",
                                  "imageId": "255c81432a3932ed52c7d4d47c5e1fcc",
                                  "inStock": 1,
                                  "price": 17900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066923",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99069891",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99069892",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066923",
                                            "variationId": "99069891"
                                          }
                                        ],
                                        "price": 17900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066923",
                                            "variationId": "99069892"
                                          }
                                        ],
                                        "price": 17900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489237",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780505",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859500",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510636",
                                            "addonId": "102195099"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780505",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510636",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859500",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489237",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.2",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119496448",
                                  "name": "Chicken Bhuna Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "A treasure trove of unique Indian flavours waiting to surprise your palate! Spicy Hyderabadi Rice or Classic Flavourful Rice with boneless pieces of bhuna chicken with onion cooked in Indian gravy. I Calories (Kcals): 603 I Carbs (Gms): 89 I Proteins (Gms): 15 I Fats (Gms): 22",
                                  "imageId": "e193ad60c123a5523fd42eb46d529ea7",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066926",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "default": 1,
                                            "id": "99069908",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "id": "99069909",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066926",
                                            "variationId": "99069908"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489245",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066926",
                                            "variationId": "99069909"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489243",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780643",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859816",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510714",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489245",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780643",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510714",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859816",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489243",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489245",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119496447",
                                  "name": "Malai Chicken Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Everyone loves a malai chicken, with creamy, delicious sauce and tender chicken and this is exactly that! Served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 581 I Carbs (Gms): 88 I Proteins (Gms): 27 I Fats (Gms): 14",
                                  "imageId": "0c19ecf04758989f6a8450d4f8930bd2",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066941",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "default": 1,
                                            "id": "99069988",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "id": "99069989",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066941",
                                            "variationId": "99069988"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489312",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066941",
                                            "variationId": "99069989"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489311",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780481",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859470",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510618",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489312",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780481",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510618",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859470",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489311",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489312",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187319",
                                  "name": "Paneer Tikka Masala Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Spice up your life with this epic rice bowl. Soft, marinated paneer chunks in a tikka gravy with your fav rice, and dont forget the teekha chaska sprinkle for that extra zing.",
                                  "imageId": "d6261a6c9c76df2fb38dd6ec0d8d04d4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788646",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619780",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619781",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788646",
                                            "variationId": "101619780"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788646",
                                            "variationId": "101619781"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722574",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780734",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722573",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722572",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780734",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722572",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722573",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722574",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187322",
                                  "name": "Paneer Lababdar Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "A flavour bomb for your taste buds. Soft, marinated paneer in a creamy gravy with your choice of rice. Top it up with teekha chaska for that extra oomph. Chefs kiss.",
                                  "imageId": "f60430801a6f3647ff707c3f120626a2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788649",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619786",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619787",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788649",
                                            "variationId": "101619786"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788649",
                                            "variationId": "101619787"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722591",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "113722587",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722589",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722588",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113722587",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722588",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722589",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722591",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "119496451",
                                  "name": "Chicken Tikka Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Your favourite meal got the makeover it deserves. Succulent boneless chicken tikka in a rich gravy and served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 576 I Carbs (Gms): 90 I Proteins (Gms): 17 I Fats (Gms): 18",
                                  "imageId": "d5a4db6d96001abb38890780d5c7aebb",
                                  "inStock": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066949",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "default": 1,
                                            "id": "99070025",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "id": "99070026",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066949",
                                            "variationId": "99070025"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489349",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066949",
                                            "variationId": "99070026"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489344",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780450",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859325",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510607",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "110489349",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780450",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510607",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859325",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489344",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489349",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187307",
                                  "name": "Chicken Tikka Masala Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Calling all Chicken Tikka lovers. Feast on tikka masala gravy, your favourite rice and add an extra dash of spiciness with our teekha chaska.",
                                  "imageId": "c857d6be5b9ae209dc570fece1c96ac6",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788634",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619756",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619757",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788634",
                                            "variationId": "101619756"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722514",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788634",
                                            "variationId": "101619757"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722512",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780490",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722511",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510635",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722514",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780490",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510635",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722511",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722512",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722514",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187321",
                                  "name": "Chicken Lababdar Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Ready to rock your taste buds. Here goes- juicy chicken, creamy gravy goodness, your fav rice along with teekha chaska for a spicy kick. Delish.",
                                  "imageId": "1bd7ebe733540310493e27eccd0c7ce7",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788648",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619784",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619785",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788648",
                                            "variationId": "101619784"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722583",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788648",
                                            "variationId": "101619785"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722582",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780786",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722581",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510843",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722583",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780786",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510843",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722581",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722582",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722583",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187316",
                                  "name": "Chicken Kadai Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Meet your new bae- A rice bowl with rich Chicken Kadhai gravy, paired with teekha chaska. Your vibe, right.",
                                  "imageId": "13c1b179cb09c5c31f43ed3491d2f4f1",
                                  "inStock": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788643",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619774",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619775",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788643",
                                            "variationId": "101619774"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722554",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788643",
                                            "variationId": "101619775"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722553",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780672",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722552",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510720",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722554",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780672",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510720",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722552",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722553",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722554",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 28900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187310",
                                  "name": "Paneer Kadai Rice Feast (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Slay your cravings with this lit, spicy paneer kadhai gravy and your fav rice. Drizzle some teekha chaska, and youre basically the spice god of Flavourtown.",
                                  "imageId": "75c8651d2dffc4b5b8326c0c1d8b9b05",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788637",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619762",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619763",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788637",
                                            "variationId": "101619762"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788637",
                                            "variationId": "101619763"
                                          }
                                        ],
                                        "price": 27900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722525",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780508",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722523",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722519",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780508",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722519",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722523",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722525",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 27900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187314",
                                  "name": "Paneer Tikka Masala Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Spice up your life with this epic, hearty, jumbo rice bowl. Soft, marinated paneer chunks in a tikka gravy with your fav rice, and dont forget the teekha chaska for that extra zing.",
                                  "imageId": "709d5ed195c566433618557e4b2f384c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788641",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619770",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619771",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788641",
                                            "variationId": "101619770"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788641",
                                            "variationId": "101619771"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722544",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780575",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722542",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722540",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780575",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722540",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722542",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722544",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187320",
                                  "name": "Chicken Tikka Masala Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Calling all Chicken Tikka lovers. Feast on a generous portion of tikka masala gravy, your favourite rice, and add an extra dash of spiciness with our teekha chaska.",
                                  "imageId": "5506b24ab293d66d6d533e25ed1d2291",
                                  "inStock": 1,
                                  "price": 38900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788647",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619782",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619783",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788647",
                                            "variationId": "101619782"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722579",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788647",
                                            "variationId": "101619783"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722578",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780740",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722577",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510829",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722579",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780740",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510829",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722577",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722578",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722579",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 38900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187317",
                                  "name": "Chicken Lababdar Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Ready to rock your taste buds with a hearty, jumbo meal. Here goes- juicy chicken in creamy gravy goodness, your fav rice along with teekha chaska for a spicy kick. Delish.",
                                  "imageId": "8365e000038851580ea2f93696566b08",
                                  "inStock": 1,
                                  "price": 38900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788644",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619776",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619777",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788644",
                                            "variationId": "101619776"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722561",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788644",
                                            "variationId": "101619777"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722560",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780675",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722558",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510741",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722561",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780675",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510741",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722558",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722560",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722561",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 38900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187315",
                                  "name": "Paneer Kadai Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Slay your cravings with this lit & hearty jumbo feast of paneer kadhai gravy with your choice of rice. Drizzle some teekha chaska, and youll be a food coma.",
                                  "imageId": "b0254be18f7ad2e0260bd72804c2f738",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788642",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619772",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619773",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788642",
                                            "variationId": "101619772"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788642",
                                            "variationId": "101619773"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722548",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780606",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722547",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722546",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780606",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722546",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722547",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722548",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187318",
                                  "name": "Paneer Lababdar Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "A jumbo flavour bomb for your hungry taste buds. Soft, marinated paneer in a creamy gravy meets flavourful rice, top it up with teekha chaska for that extra oomph. Chefs kiss.",
                                  "imageId": "c14a45d2c460d1bb2995ed041887a3fb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788645",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619778",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619779",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788645",
                                            "variationId": "101619778"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788645",
                                            "variationId": "101619779"
                                          }
                                        ],
                                        "price": 37900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722571",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780681",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722569",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733446"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733447"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733448"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733449"
                                          },
                                          {
                                            "groupId": "113722568",
                                            "addonId": "99733450"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780681",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722568",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733449",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733450",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733448",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733446",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733447",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722569",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722571",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 37900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125187312",
                                  "name": "Chicken Kadai Rice Feast (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Meet your new bae: A generous, jumbo rice bowl with rich gravy, marinated chicken and spices, paired with teekha chaska. Your vibe, right.",
                                  "imageId": "dd029c9c9644e9c5b5d1fbeb35bc5820",
                                  "inStock": 1,
                                  "price": 38900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32788639",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavourful Rice",
                                            "default": 1,
                                            "id": "101619766",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "id": "101619767",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788639",
                                            "variationId": "101619766"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722536",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32788639",
                                            "variationId": "101619767"
                                          }
                                        ],
                                        "price": 38900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "113722533",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780530",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "113722532",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195094"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195095"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "110559284"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195097"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195098"
                                          },
                                          {
                                            "groupId": "115510651",
                                            "addonId": "102195099"
                                          },
                                          {
                                            "groupId": "113722536",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780530",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "115510651",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "102195098",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195099",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195097",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195094",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102195095",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559284",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722532",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722533",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "113722536",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 38900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Signature Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116544723",
                                  "name": "Spicy Paneer Rice Feast",
                                  "category": "Rice Bowls",
                                  "description": "Deliciously crispy fried paneer along with a spiced onion gravy is served over a bed of Hyderabadi biryani inspired basmati rice. I Calories (Kcals): 805 I Carbs (Gms): 90 I Proteins (Gms): 20 I Fats (Gms): 41",
                                  "imageId": "25c989c3e59c3a4188db172e99c7283b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066980",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice",
                                            "default": 1,
                                            "id": "99070191",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070192",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066980",
                                            "variationId": "99070191"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066980",
                                            "variationId": "99070192"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489538",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780609",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859712",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489533",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780609",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489533",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859712",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489538",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809308",
                                  "name": "Paneer Signature Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Let your taste buds fall in love with this unique bowl made using out-of-the-world paneer tikka chunks served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 657 I Carbs (Gms): 92 I Proteins (Gms): 15 I Fats (Gms): 23",
                                  "imageId": "e2288bd3c1252f7226715fb75fd36132",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066954",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070049",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "id": "99070050",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066954",
                                            "variationId": "99070049"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066954",
                                            "variationId": "99070050"
                                          }
                                        ],
                                        "price": 24900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489380",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780669",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859838",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489375",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780669",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489375",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859838",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489380",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 24900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "32 ratings",
                                      "ratingCountV2": "32"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97846221",
                                  "name": "Paneer Signature Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Here to satisfy those big cravings, soft paneer tikka chunks cooked in spiced onion-tomato gravy is served over a bed of Spicy Hyderabadi rice or Classic Flavourful Rice. I Calories (Kcals): 1057 I Carbs (Gms): 141 I Proteins (Gms): 25 I Fats (Gms): 41",
                                  "imageId": "f5d92b10caeb6d58b133dd874caae454",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066985",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070223",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "id": "99070224",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066985",
                                            "variationId": "99070223"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066985",
                                            "variationId": "99070224"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489545",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780582",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859701",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489542",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780582",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489542",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859701",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489545",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809298",
                                  "name": "Chole Signature Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Giving an all-time favourite a delicous makeover to make your meal exciting! Chole cooked to perfection in a spiced gravy is served with a portion of either Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 586 I Carbs (Gms): 99 I Proteins (Gms): 13 I Fats (Gms): 13",
                                  "imageId": "06d14affa371853a2ba7bf57d045dfe8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066956",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070054",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "id": "99070055",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066956",
                                            "variationId": "99070054"
                                          }
                                        ],
                                        "price": 19500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066956",
                                            "variationId": "99070055"
                                          }
                                        ],
                                        "price": 19500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489391",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780677",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859841",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489386",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780677",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489386",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859841",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489391",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 19500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809284",
                                  "name": "Royal Veg Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "An absolutely lovely combination of home-style chole, spiced paneer tikka and corn salsa served with Spicy Hyderabadi Rice or Classic Flavourful Rice. I Calories (Kcals): 1018 I Carbs (Gms): 156 I Proteins (Gms): 21 I Fats (Gms): 36",
                                  "imageId": "fc0d136bb3851f9ec54b58a1f0767196",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066990",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070255",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070256",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066990",
                                            "variationId": "99070255"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066990",
                                            "variationId": "99070256"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489553",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780729",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859998",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489550",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780729",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489550",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859998",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489553",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 29900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97846222",
                                  "name": "Chole Signature Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "A large-sized bowl of zesty chole cooked in spiced onion-tomato gravy till perfectly soft is served over a bed of Spicy Hyderabadi rice or Classic Flavourful Rice. I Calories (Kcals): 924 I Carbs (Gms): 154 I Proteins (Gms): 22 I Fats (Gms): 23",
                                  "imageId": "8ee3c00ddc709fc1e3fbf6832608b1aa",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066991",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070257",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "id": "99070258",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066991",
                                            "variationId": "99070257"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066991",
                                            "variationId": "99070258"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489556",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859389",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733462"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733464"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733466"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733468"
                                          },
                                          {
                                            "groupId": "110489554",
                                            "addonId": "99733470"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489554",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733468",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733470",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733466",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733462",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733464",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859389",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489556",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809291",
                                  "name": "Smoked Butter Chicken Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Everyone loves a good butter chicken and this one is made with added excitement to surprise your tastebuds! Served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 745 I Carbs (Gms): 118 I Proteins (Gms): 23 I Fats (Gms): 17",
                                  "imageId": "0a47e5db0bbcc864b376fe81dce41780",
                                  "inStock": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066993",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070261",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070262",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066993",
                                            "variationId": "99070261"
                                          }
                                        ],
                                        "price": 26900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489574",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066993",
                                            "variationId": "99070262"
                                          }
                                        ],
                                        "price": 26900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489571",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780636",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489564",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859798",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489574",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780636",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489564",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859798",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489571",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489574",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 26900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "44 ratings",
                                      "ratingCountV2": "44"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809293",
                                  "name": "Chicken Signature Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "Your favourite meal got the makeover it deserves. Succulent boneless chicken cooked in a rich gravy and served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 620 I Carbs (Gms): 89 I Proteins (Gms): 17 I Fats (Gms): 19",
                                  "imageId": "e9f5e2db195d9daed7f2daac3feba972",
                                  "inStock": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066997",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070269",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Regular)",
                                            "id": "99070270",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066997",
                                            "variationId": "99070269"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489608",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066997",
                                            "variationId": "99070270"
                                          }
                                        ],
                                        "price": 25900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489607",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780704",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489601",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859935",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489608",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780704",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489601",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859935",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489607",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489608",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 25900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809280",
                                  "name": "Royal Chicken Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Breaking the norm was never this delicious! Succulent chicken with roasted Indian spices, chicken tikka & chicken meatballs served on a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice & topped with a fluffy omelette I Calories (Kcals): 1127 I Carbs (Gms): 140 I Proteins (Gms): 38 I Fats (Gms): 47",
                                  "imageId": "25728ac974fe889d1a88f469c5bc436c",
                                  "inStock": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32067016",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070360",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070361",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067016",
                                            "variationId": "99070360"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489668",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067016",
                                            "variationId": "99070361"
                                          }
                                        ],
                                        "price": 34900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489666",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780529",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489661",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859599",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489668",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780529",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489661",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859599",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489666",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489668",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 34900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "106036759",
                                  "name": "Mutton Bhuna Rice Bowl (Regular)",
                                  "category": "Rice Bowls",
                                  "description": "A treasure trove of unique Indian flavours waiting to surprise your palate! Spicy Hyderabadi Rice or Classic Flavourful Rice with melt-in-your-mouth boneless pieces of bhuna mutton cooked in a spicy Indian gravy. I Calories (Kcals): 597 I Carbs (Gms): 97 I Proteins (Gms): 23 I Fats (Gms): 13",
                                  "imageId": "bc22b20c77e393551fa136e6962f78d6",
                                  "inStock": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32066995",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070265",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070266",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066995",
                                            "variationId": "99070265"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489592",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32066995",
                                            "variationId": "99070266"
                                          }
                                        ],
                                        "price": 30900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489590",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780709",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489584",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859991",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489592",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780709",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489584",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859991",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489590",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489592",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82809288",
                                  "name": "Smoked Butter Chicken Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Good old Butter Chicken but add a little bit of Faasos flair! Choose from a bowl of Spicy Hyderabadi Rice or Classic Flavourful Rice with our flavourful smoked butter chicken I Calories (Kcals): 970 I Carbs (Gms): 175 I Proteins (Gms): 33 I Fats (Gms): 12",
                                  "imageId": "0a47e5db0bbcc864b376fe81dce41780",
                                  "inStock": 1,
                                  "price": 32900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32067023",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "default": 1,
                                            "id": "99070386",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "id": "99070389",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067023",
                                            "variationId": "99070386"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489693",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067023",
                                            "variationId": "99070389"
                                          }
                                        ],
                                        "price": 32900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489691",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780457",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489684",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859364",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489693",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780457",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489684",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859364",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489691",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489693",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 32900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97846220",
                                  "name": "Chicken Signature Rice Bowl (Jumbo)",
                                  "category": "Rice Bowls",
                                  "description": "Your favourite meal got the makeover it deserves! Succulent boneless chicken cooked in a rich gravy and served over a bed of Spicy Hyderabadi Rice or Classic Flavourful Rice I Calories (Kcals): 987 I Carbs (Gms): 137 I Proteins (Gms): 29 I Fats (Gms): 33",
                                  "imageId": "e9f5e2db195d9daed7f2daac3feba972",
                                  "inStock": 1,
                                  "price": 31900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "32067018",
                                        "name": "Choose Rice",
                                        "variations": [
                                          {
                                            "name": "Classic Flavorful Rice",
                                            "default": 1,
                                            "id": "99070365",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hyderabadi Khas Rice (Spicy)",
                                            "id": "99070366",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067018",
                                            "variationId": "99070365"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489677",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "32067018",
                                            "variationId": "99070366"
                                          }
                                        ],
                                        "price": 31900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733543"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733545"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733544"
                                          },
                                          {
                                            "groupId": "110489675",
                                            "addonId": "99733546"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016761"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "103344928"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016763"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016764"
                                          },
                                          {
                                            "groupId": "119780569",
                                            "addonId": "101016765"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733604"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733605"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "110559282"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733607"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733608"
                                          },
                                          {
                                            "groupId": "110489673",
                                            "addonId": "99733609"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393389"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393390"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393391"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476049"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "100393392"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476052"
                                          },
                                          {
                                            "groupId": "111859669",
                                            "addonId": "109476047"
                                          },
                                          {
                                            "groupId": "110489677",
                                            "addonId": "99735225"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "119780569",
                                      "groupName": "Make it a Meal",
                                      "choices": [
                                        {
                                          "id": "101016761",
                                          "name": "Potato Wedges (S) + Lemonade (Save Rs 29)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016764",
                                          "name": "Potato Wedges (M) + Coke 475ML (Save Rs 47)",
                                          "price": 10900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "103344928",
                                          "name": "Potato Wedges (S) + Coke 475ML (Save Rs 37)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016765",
                                          "name": "Fries (M) + Coke 475ML (Save Rs 47)",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "101016763",
                                          "name": "Fries (M) + Lemonade (Save Rs 49)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489673",
                                      "groupName": "Choose Your Side",
                                      "choices": [
                                        {
                                          "id": "99733608",
                                          "name": "French Fries (Save Rs 24)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733609",
                                          "name": "Teekha Chaska Fries (Save Rs 24)",
                                          "price": 9500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733607",
                                          "name": "Potato Wedges (M) (Save Rs 20)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733604",
                                          "name": "Potato Wedges (S) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733605",
                                          "name": "Falafel Shots (6 Pcs) (Save Rs 15)",
                                          "price": 5400,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110559282",
                                          "name": "Cheesy Chicken Meatballs (3 Pcs)",
                                          "price": 6900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "111859669",
                                      "groupName": "Choose Your Beverage & Dessert",
                                      "choices": [
                                        {
                                          "id": "100393392",
                                          "name": "Choco Lava (Save Rs 20)",
                                          "price": 8900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393389",
                                          "name": "Masala Lemonade (180 ml)",
                                          "price": 3900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393390",
                                          "name": "Mint Chaas (Buttermilk)",
                                          "price": 4800,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "100393391",
                                          "name": "Coca-Cola Bottle (475 ML)",
                                          "price": 5700,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476049",
                                          "name": "Thums Up 330 ml Can",
                                          "price": 6650,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476047",
                                          "name": "Chocolate Cheesecake (Limited Period - Save Rs 50)",
                                          "price": 15900,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109476052",
                                          "name": "Chocolate Swiss Roll (Limited Period - Save Rs 20)",
                                          "price": 9900,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489675",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733544",
                                          "name": "Mughlai Gravy",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733545",
                                          "name": "Mint Raita",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733543",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733546",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "110489677",
                                      "groupName": "Customize Your Order",
                                      "choices": [
                                        {
                                          "id": "99735225",
                                          "name": "Extra Omelette (In The Wrap)",
                                          "price": 3000,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 31900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Sides And Beverages",
                      "categories": [
                        {
                          "title": "Sides",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "124939119",
                                  "name": "French Fries (Large)",
                                  "category": "Sides And Beverages",
                                  "description": "Since medium portion is never enough. Golden fried, super crispy Fries that are salted to perfection.",
                                  "imageId": "b8af36c4dd1f6d686b1c3d0af075d24a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 15500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "126984424",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "124939117",
                                  "name": "Potato Wedges (Large)",
                                  "category": "Sides And Beverages",
                                  "description": "When you dont know what to eat next, we suggest keep it simple and call for the Faasos special wedges, in a large size.",
                                  "imageId": "043a17d8fc28db21fcdfc11455575c42",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "113002408",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "97732600",
                                  "name": "Double Wedges Combo",
                                  "category": "Sides And Beverages",
                                  "description": "SAVE Rs. 29 and indulge in this combo of 2 portions of Wedges. Cause when is one ever enough.",
                                  "imageId": "fd736054d5b7f7b5e853e0db61f25a5c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489795",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104370909",
                                  "name": "French Fries (Medium)",
                                  "category": "Sides And Beverages",
                                  "description": "Just one can never be enough! Golden fried crunchy Fries that are salted to perfection.",
                                  "imageId": "fc04fd7f94bbb86b1f7dd3479214d8fe",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489836",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105514402",
                                  "name": "Teekha Chaska French Fries",
                                  "category": "Sides And Beverages",
                                  "description": "A Faasos favourite, Teekha Chaska comes with freshly fried, golden french fries for the ultimate snack. You could also make it a meal, we dont judge",
                                  "imageId": "d4bb4c63cc3cf34a1fbec628e4cab4d4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489839",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104134112",
                                  "name": "Peri Peri Cheese Wedges",
                                  "category": "Sides And Beverages",
                                  "description": "A spiced treat, unlike any other, herbed potato wedges, is served with a generous drizzle of peri peri cheese sauce. Dig in",
                                  "imageId": "45ddcf8b12315a0693252b0194d742a8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489842",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.4",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104134113",
                                  "name": "Chipotle Cheese Wedges (Newly Launched)",
                                  "category": "Sides And Beverages",
                                  "description": "Thick-cut potato wedges are drizzled with tangy chipotle-flavoured cheese sauce to make all your snacking dreams come true",
                                  "imageId": "608b642f216eba680e9c5f5a47cbbfe8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489845",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98451607",
                                  "name": "Potato Wedges (Medium)",
                                  "category": "Sides And Beverages",
                                  "description": "When you dont know what to eat next we suggest keep it simple and call for the wedges.",
                                  "imageId": "0124f146ebd7e4b6400ee82c82c28e20",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489846",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "26 ratings",
                                      "ratingCountV2": "26"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "87293358",
                                  "name": "Potato Chilli Shots with Mayo Dip",
                                  "category": "Sides And Beverages",
                                  "description": "Crispy and spiced potato shots served with a cheesy mayonnaise dip to tantalize your tastebuds.",
                                  "imageId": "9e86c8806c6d30ead54f5ed73d044bb3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489882",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "87293357",
                                  "name": "Falafel Nuggets with Mayo Dip",
                                  "category": "Sides And Beverages",
                                  "description": "Mediterranean inspired crispy falafel made from the finest soaked chickpeas and spices, served with a cheesy mayonnaise dip.",
                                  "imageId": "1961f767777b5bd22e08a03b1c456c42",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489893",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "79568707",
                                  "name": "Potato Wedges (Small)",
                                  "category": "Sides And Beverages",
                                  "description": "When you don't know what to eat next, keep it simple! Indulge in our delicious potato wedges sprinkled with Teekha Chaska for that perfect flavour punch.",
                                  "imageId": "251152c7359f99d9561fbaf1dbd21582",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489905",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390711",
                                  "name": "Cheesy Chicken Meatballs",
                                  "category": "Sides And Beverages",
                                  "description": "(100% Safely Cooked Chicken) Juicy minced chicken meatballs, served with a cheesy mayonnaise dip - A no-brainer for snack cravings!",
                                  "imageId": "265f8e0f7c900c5925865f1b1ae3244d",
                                  "inStock": 1,
                                  "price": 13500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489957",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "105943307",
                                  "name": "Teekha Chaska Sausages",
                                  "category": "Sides And Beverages",
                                  "description": "Succulent chicken sausages, cut into small bite sized pieces is sprinkled with our signature Teekha Chaska and served with a mayonnaise dip.",
                                  "imageId": "649e7d3664bc1bd5e33ad50c8b91e60d",
                                  "inStock": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "110489969",
                                      "groupName": "Choose Your Add On",
                                      "choices": [
                                        {
                                          "id": "99733325",
                                          "name": "Cheese Dip",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733326",
                                          "name": "Chipotle Cheese Dip (20 gm)",
                                          "price": 2500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733324",
                                          "name": "Teekha Chaska (2 packets)",
                                          "price": 1000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99733327",
                                          "name": "Teekha Chaska (10 packets)",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Beverages",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123944626",
                                  "name": "Masala Lemonade (180 ml)",
                                  "category": "Sides And Beverages",
                                  "description": "A refreshing classic drink with a combined goodness of fresh lime, himalayan pink salt & infused spices.",
                                  "imageId": "6e5e863072af841f403f4a0f9e26c43b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 4600,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127646608",
                                  "name": "Thums Up 330 ml Can",
                                  "category": "Sides And Beverages",
                                  "description": "Thums Up 330 ml",
                                  "imageId": "51ecb60ce9170ef15788585d76571cc4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6650,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "130304807",
                                  "name": "Cold Pressed Mix Fruit Juice (250 ml)",
                                  "category": "Sides And Beverages",
                                  "description": "Made with no added sugars, this fresh Mixed Fruit Juice can for sure be your go-to!",
                                  "imageId": "bf91d77cc56584bf43e34980137bf6f9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116531154",
                                  "name": "Coca-Cola Bottle (475 ML)",
                                  "category": "Sides And Beverages",
                                  "description": "475 ML Coca - Cola Bottle",
                                  "imageId": "ydqqpussdhedmr5edm2b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390714",
                                  "name": "SWIG Green Apple",
                                  "category": "Sides And Beverages",
                                  "description": "Aerated drink flavored with the mouth-puckering green apple. Sure to refresh you completely!",
                                  "imageId": "0b76e6413a00aa350ea89779bdaaa370",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "72390716",
                                  "name": "SWIG Jeera Masala Soda",
                                  "category": "Sides And Beverages",
                                  "description": "Aerated drink with the added zing of jeera and masala. A perfect accompaniment to your meal.",
                                  "imageId": "25b016a4f3021dad1923cf8d39f2378a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5700,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72390671",
                              "name": "Mango Cheesecake",
                              "category": "Desserts",
                              "description": "(Eggless) This New York Style Mango Cheesecake, made with premium quality cream cheese and a crust infused with delicious mango flavor, is every dessert lovers delight!",
                              "imageId": "22cb5b6544dd912155ba957ee7023c6a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72390635",
                              "name": "Hazelnut Brownie",
                              "category": "Desserts",
                              "description": "(Eggless) Gooey & fudgy on the inside and nutty on the outside. Our melt-in-the-mouth Single Nutty Hazelnut Brownie will give you serious dessert goals.",
                              "imageId": "ef40fedd41311c82e2ed3e2e16fab624",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531137",
                              "name": "Choco Lava Cake",
                              "category": "Desserts",
                              "description": "(Eggless) A perfect match of Chocolate Cake on the outside and molten Chocolate on the inside, our Choco Lava cake is every dessert lovers dream come true.",
                              "imageId": "bc581d5c5da4933c58262f5320a9e367",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72390647",
                              "name": "Chocolate Indulgence Brownie",
                              "category": "Desserts",
                              "description": "(Eggless) Indulge in richly decadent Indulgence brownie crafted with love & topped with bittersweet chocolate that provides ultra-rich chocolate experience.",
                              "imageId": "2181e009a59d1b9edbabda8392510c7a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531173",
                              "name": "Rich Red Velvet Pastry",
                              "category": "Desserts",
                              "description": "Rich and moist Red Velvet cake layered with fresh cream cheese makes our Red Velvet pastry difficult to share. Youll think twice too.",
                              "imageId": "25314893642f40a3fd2a4f82f0d74449",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531170",
                              "name": "Chocolate Lava Cake (Box Of 2)",
                              "category": "Desserts",
                              "description": "(Eggless) A perfect match between Chocolate Cake on the outside and melted gooey chocolate on the inside is an irresistible indulgence for 2.",
                              "imageId": "8697d1420ebb382be29867a533c1c4e4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "84540838",
                              "name": "Fudgy Brownie Combo (Box of 2)",
                              "category": "Desserts",
                              "imageId": "3c49c4266bad06293f8616abb4329c5f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100838193",
                              "name": "Hazelnut Brownie (Box of 2)",
                              "category": "Desserts",
                              "description": "(Eggless) Gooey & fudgy on the inside, nutty on the outside and amazingly delicious all over! Our melt-in-the-mouth Nutty Chocolate Brownie will give you serious dessert goals.",
                              "imageId": "d5e182691e9895379fcdb8ff4bfd8849",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531159",
                              "name": "Coffee Coated Cookie Box",
                              "category": "Desserts",
                              "description": "Its coated with chocolate and filled with coffee, do we need to say more. Try this best combination of coffee and cookie EVER",
                              "imageId": "edc4261492c9492ebf909e203e724a6a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "72390639",
                              "name": "New York Cheesecake",
                              "category": "Desserts",
                              "description": "Dense, creamy & smooth Philadelphia cream cheese paired with a crust made with crackers & butter with a hint of ginger ,this nifty New York Cheesecake is indulgence redefined (With egg).",
                              "imageId": "e278270b3c8d900ecdb305825dfce931",
                              "inStock": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531169",
                              "name": "Death by Chocolate Cake Jar",
                              "category": "Desserts",
                              "description": "Dont take the name literally, but our Death By Chocolate Jar is a chocolate heaven sure to transport you to another level.",
                              "imageId": "3315ec37406e0cd2f7e78ade2ce7c7b5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531152",
                              "name": "Chocolate Mocha Jar",
                              "category": "Desserts",
                              "description": "Feel like having coffee & dessert at the same time. Well, we have got you covered with our delicious Mocha jar made with richness of chocolate and goodness of coffee.",
                              "imageId": "73a6edf4ed01c63f5cfea24ad27047e2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114956171",
                              "name": "Chocolate Muffin",
                              "category": "Desserts",
                              "description": "This delicious Chocolate Muffin made with chocolate chips and rich ganache filling is what chocolatey dreams are made of.",
                              "imageId": "fa66007b6e28bcb7880f858a67ef4fe2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116531153",
                              "name": "Hazelnut Muffin",
                              "category": "Desserts",
                              "description": "A nutty affair you wont want to miss out on. Rich chocolatey muffin with delicious Nutella filling.",
                              "imageId": "2049940497ac948cb389376e68c7b9db",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127916438",
                              "name": "Death by Chocolate Jar & Choco lava cake",
                              "category": "Desserts",
                              "description": "1 Death by Chocolate Jar + 1 Choco lava cake This combo is too much chocolate, But no ones complaining!",
                              "imageId": "961def32ff3c256dc458895183b92cd9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130530486",
                              "name": "Strawberry jar",
                              "category": "Desserts",
                              "description": "Dig into the delectable layers of strawberry jelly, cream cheese & sponge cake. This jar is a dessert you can't miss this season!",
                              "imageId": "1319010b615fabe7ddc59943c7c90f8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127916440",
                              "name": "Macarons Gift Box (Box of 5)",
                              "category": "Desserts",
                              "description": "Assortment of 5 flavours of Macarons \n(Chocolate,\nHazelnut Salted Caramel, Alphonso Mango, Matcha Pistachio, Oreo)",
                              "imageId": "d9eb2bb2ac9454a154e5819b72da0fd3",
                              "inStock": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Party Combo (Save Upto Rs 407)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018138",
                              "name": "Veggie Supreme Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Say hello to your new fav combo with savings of FLAT Rs 94! Masala Paneer Tikka Wrap, Cheese Melt Paneer Wrap, Cheesy Corn Salsa Wrap with 2 refreshing Cokes. Hit the order button!",
                              "imageId": "9105701f856b5aff5c76d208add004f6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 55900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584982",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018140",
                              "name": "Chicken Supreme Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Desi for the win! FLAT Rs. 82 savings on this combo of Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Malai Chicken Kebab Wrap and 2 Cokes! Chalo, let's order",
                              "imageId": "d8d2c0cbb78f9a3c5686ab45d257f40d",
                              "inStock": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127585021",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018141",
                              "name": "Veg Wrapstars Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Wrap in style and save FLAT Rs. 108 with your favourites! Grab our Masala Paneer Tikka Wrap, Cheese Melt Paneer Wrap, Cheest Corn Salsa Wrap and 2 portions of French Fries!",
                              "imageId": "6a237a67056f056dc38e087dca340d8d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584976",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018144",
                              "name": "Chicken Wrapstars Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "No need to chicken out with this combo! Save FLAT Rs. 106 with our Chicken Wraps like Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Malai Chicken Kebab Wrap and 2 sides",
                              "imageId": "658633c6e9bfe641d9f52aa73b827f74",
                              "inStock": 1,
                              "price": 67900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127585007",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018145",
                              "name": "Fiesty Veggie Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.126 on this veggie-licious feast of Masala Paneer Tikka Wrap, Ultimate Chipotle Aloo Patty Wrap, Cheesy Corn Salsa Wrap, 2 sides of French Fries and 2 Cokes!",
                              "imageId": "5154b2d628ec7fa93fcefda113380a74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 67900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584981",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018146",
                              "name": "Fiesty Chicken Combo (Serves 3)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.126 and treat yourself to our Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Egg Cheese Chicken Sausage Wrap, 2 portions of French Fries and 2 Cokes!",
                              "imageId": "b3771fd3739abf3cd07497b1a633bc3e",
                              "inStock": 1,
                              "price": 72900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584969",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018148",
                              "name": "Super Veggie Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Our combo of Masala Paneer Tikka Wrap, Cheese Melt Paneer Wrap, Cheesy Corn Salsa Wrap, Veg Falafel Wrap are up for grabs along with 2 refreshing Cokes! Save FLAT Rs.139 on this combo.",
                              "imageId": "233fc990b2be49bd35b159f208285fbf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 65900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584959",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018150",
                              "name": "Veggie Celebrations Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Your care package is ready! Save FLAT Rs.167 with Masala Paneer Tikka Wrap, Cheese Melt Paneer Wrap, Ultimate Chipotle Aloo Patty Wrap, Veg Falafel Wrap and 2 sides of French Fries",
                              "imageId": "e28694aa43d5b37210c8a0a40b06fece",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584991",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018152",
                              "name": "Super Chicken Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.127 and get ready for this Chicken feast with Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap and 2 Cokes!",
                              "imageId": "a67232f396d66b6703d8532ad6ff1773",
                              "inStock": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127585022",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018154",
                              "name": "Chicken Celebrations Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Chicken lovers are in for a delightful feast! Save FLAT Rs.181 with Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap and 2 sides of French Fries.",
                              "imageId": "48422b972bfb51cd2624d0e13d8fefe3",
                              "inStock": 1,
                              "price": 74900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584985",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018157",
                              "name": "Paneer Feast Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.181 and celebrate with Masala Paneer Tikka Wrap, Cheese Melt Paneer Wrap, Ultimate Chipotle Aloo Patty Wrap, Veg Falafel Wrap, 2 sides of French Fries and 2 Cokes!",
                              "imageId": "2d4bfe344b1e4308ef9c1f36ad8cec55",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 79900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127585020",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018159",
                              "name": "Chicken Feast Combo (Serves 4)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.195 on this protein-rich and taste-rich combo of Chicken Bhuna Wrap, Masala Chicken Tikka Wrap, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap, 2 sides of French Fries and 2 Cokes!",
                              "imageId": "2cbd5b983e494044a6c44b8421da11f8",
                              "inStock": 1,
                              "price": 84900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584971",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018160",
                              "name": "Veggie Lit Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Yeah we got that yummy-yum combo for you! Save FLAT Rs.336 with 2 Masala Paneer Tikka Wraps, 2 Cheese Melt Paneer Wraps, Cheesy Corn Salsa Wrap, Veg Falafel Wrap and 3 sides of French Fries.",
                              "imageId": "8f18b74e9c57fea23871797878804acf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 104900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584984",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018162",
                              "name": "Chicken Extravaganza Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs.318 on this combo! Dil maange more for 2 Chicken Bhuna Wraps, 2 Masala Chicken Tikka Wraps, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap and 3 sides of French Fries!",
                              "imageId": "5c8dfd0e07a1180ed6788900213e8103",
                              "inStock": 1,
                              "price": 109900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584990",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018163",
                              "name": "Veg Extravaganza Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Include this bangin' combo to you parties! Save FLAT Rs. 280 on 2 Masala Paneer Tikka Wraps, 2 Cheese Melt Paneer Wraps, Cheesy Corn Salsa Wrap, Veg Falafel Wrap and 3 Cokes.",
                              "imageId": "fbb64d26267404b6c5437b146da59ee8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 94900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584995",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018164",
                              "name": "Chicken Lovers Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Satisfy your cravings and save FLAT Rs. 262 at the same time with 2 Chicken Bhuna Wraps, 2 Masala Chicken Tikka Wraps, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap and 3 Cokes!",
                              "imageId": "583b07c1ca347ff83660a979d5d65aac",
                              "inStock": 1,
                              "price": 99900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127585004",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018165",
                              "name": "Veggie Feast Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "Save FLAT Rs. 407 and get your hands on 2 Masala Paneer Tikka Wraps, 2 Cheese Melt Paneer Wraps, Cheesy Corn Salsa Wrap, Veg Falafel Wrap, 3 sides of French Fries and 3 Cokes!",
                              "imageId": "fbe1a377842b0e02a3b263c17faefdf6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 114900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584974",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "130018166",
                              "name": "Chicken Feast Combo (Serves 6)",
                              "category": "Party Combo (Save Upto Rs 407)",
                              "description": "For the love of wraps, you've gotta grab this combo! Save FLAT Rs.389 on 2 Chicken Bhuna Wraps, 2 Masala Chicken Tikka Wraps, Malai Chicken Kebab Wrap, Egg Cheese Chicken Sausage Wrap, 3 sides of French Fries and 3 Cokes.",
                              "imageId": "0ca49bcbf73f69866325024b433acd9c",
                              "inStock": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "127584993",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Breakfast Specials",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589214",
                              "name": "DIY Paneer Classic Wrap and Muffin Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "With savings of upto 15 percent this is the breakfast meal of your choice of 1 classic veg wrap with 1 muffin is a perfect deal-breaker. Now order, save, repeat.",
                              "imageId": "20252d16c4a8a2b427a70f44d1b3a7ac",
                              "isVeg": 1,
                              "price": 21900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111241784",
                                  "groupName": "Choose Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100136256",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136259",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136257",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136258",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136260",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241789",
                                  "groupName": "Choose Muffin (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135942",
                                      "name": "Red Velvet Muffin",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135943",
                                      "name": "Chocolate Muffin",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135944",
                                      "name": "Hazelnut Muffin",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135945",
                                      "name": "Blueberry Muffin",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241795",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100136264",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136262",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136263",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136261",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111241799",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589230",
                              "name": "DIY Paneer Classic Wrap and Beverage Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "With savings of upto 10 percent this breakfast meal of your choice of a classic veg wrap, & 1 beverage is a perfect deal-breaker. Now order, save, repeat.",
                              "imageId": "85cf3218a4b4bf7d707be4ad8cf3720c",
                              "isVeg": 1,
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111241410",
                                  "groupName": "Choose Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100136256",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136259",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136257",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136258",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136260",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241415",
                                  "groupName": "Choose Beverage (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135851",
                                      "name": "Skimmed Mint Buttermilk",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135853",
                                      "name": "SWIG Green Apple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135856",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476046",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135863",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241417",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100136264",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136262",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136263",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136261",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111241421",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589222",
                              "name": "DIY Paneer Classic Wrap and Wedges Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "Savings upto Rs 20 percent, this deal surely feels like a heaven. With your choice of a classic veg wrap, and a side, this will make you go wow.",
                              "imageId": "891317f4996d10fc349c6114b9cbdf58",
                              "isVeg": 1,
                              "price": 17500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111242295",
                                  "groupName": "Choose Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100136256",
                                      "name": "Chatpate Chole Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136259",
                                      "name": "Chipotle Potato Shots Wrap",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136257",
                                      "name": "Cheesy Corn Salsa Wrap",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136258",
                                      "name": "Masala Paneer Tikka Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136260",
                                      "name": "Cheese Melt Paneer Wrap",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111242299",
                                  "groupName": "Choose Sides (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100136380",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136381",
                                      "name": "Teekha Chaska Sausages",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111242301",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100136264",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136262",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136263",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136261",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111242304",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123813951",
                              "name": "Double Omelette with Masala Bread",
                              "category": "Breakfast Specials",
                              "description": "A protein-rich omelette with masala kulcha bread & butter on the side.",
                              "imageId": "e5759a30d94bbe465a82b061681b2698",
                              "price": 17500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111241431",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111241433",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124083183",
                              "name": "Double Omelette & Wedges with Masala Bread",
                              "category": "Breakfast Specials",
                              "description": "A protein-rich omelette with masala kulcha bread, Faasos' all-time favourite potato wedges, & butter on the side.",
                              "imageId": "35fc82c5c30e029d496b501544796ee2",
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111242482",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111242487",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589216",
                              "name": "DIY Egg Classic Wrap and Muffin Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "No more wait, straightaway save upto 20 percent. Choose 1 non-veg wrap with 1 muffin, and switch that rise and shine mode ON right away.",
                              "imageId": "88ab3cc3127e60497129d0cbdd8e82dd",
                              "price": 19500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111240857",
                                  "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135849",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135850",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111240861",
                                  "groupName": "Choose Muffin (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135942",
                                      "name": "Red Velvet Muffin",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135943",
                                      "name": "Chocolate Muffin",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135944",
                                      "name": "Hazelnut Muffin",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135945",
                                      "name": "Blueberry Muffin",
                                      "price": 1000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111240865",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111240868",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589212",
                              "name": "DIY Egg Classic Wrap and Beverage Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "No more wait, straightaway save upto 10 percent. Choose 1 non-veg wrap & 1 beverage, and switch that morning conquer-all mode ON right away.",
                              "imageId": "67d194fe0de3990c2ea49339bf200163",
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111240608",
                                  "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135849",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135850",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111240613",
                                  "groupName": "Choose Beverage (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135851",
                                      "name": "Skimmed Mint Buttermilk",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135853",
                                      "name": "SWIG Green Apple",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135856",
                                      "name": "Coca-Cola Bottle (475 ML)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109476046",
                                      "name": "Thums Up 330 ml Can",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135863",
                                      "name": "Masala Lemonade (180 ml)",
                                      "price": 3900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111240620",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111240624",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117589232",
                              "name": "DIY Egg Classic Wrap and Wedges Breakfast Meal",
                              "category": "Breakfast Specials",
                              "description": "FYI, this time you got savings upto 25 percent. Add your choice of a classic non-veg wrap and a side. Now dont let all that chomp chomp stop.",
                              "imageId": "14f8d8784936543c68dd5592f4465594",
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "111241493",
                                  "groupName": "Choose Non-Veg Classic Wrap (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100135849",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135850",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241495",
                                  "groupName": "Choose Sides (Any 1)",
                                  "choices": [
                                    {
                                      "id": "100136380",
                                      "name": "Potato Wedges (Small)",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100136381",
                                      "name": "Teekha Chaska Sausages",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "111241496",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "111241497",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125258683",
                              "name": "2 Double Egg Chatpata Wrap Breakfast Combo",
                              "category": "Breakfast Specials",
                              "description": "Breakfast started right with the perfect combo of 2 delicious Double Egg Chatpata Wrap. Your protein packed meal awaits.",
                              "imageId": "eb08a0bc6f40996eb55d8475cc2d15bd",
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "113881986",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "113881987",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125258684",
                              "name": "1 Double Egg Chatpata Wrap + 1 Egg Cheese Sausage Wrap Breakfast Combo",
                              "category": "Breakfast Specials",
                              "description": "With savings of Rs 15, this deal surely feels like the perfect combination for a heavenly breakfast. With your favourite Double Egg Chatpata Wrap & Egg Cheese Chicken Sausage Wrap, this will make you go wow.",
                              "imageId": "fc2f15196476a28e674b14a91713284c",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "113881988",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "113881989",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125466883",
                              "name": "2 Wrap Breakfast Combo",
                              "category": "Breakfast Specials",
                              "description": "With savings of upto Rs 60, this breakfast meal of your choice of any 2 classic breakfast wraps. Now order, save, repeat.",
                              "imageId": "264b73bc6b71ae5cb53d49ee61c241f5",
                              "price": 19800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114785038",
                                  "groupName": "Choose Your Classic Wrap (NonVeg)",
                                  "choices": [
                                    {
                                      "id": "101202956",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202957",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202958",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202959",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202960",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202961",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202962",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101202963",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785040",
                                  "groupName": "Choose Your Second Classic Wrap",
                                  "choices": [
                                    {
                                      "id": "101656780",
                                      "name": "Double Egg Chatpata Wrap",
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656781",
                                      "name": "Cheese Melt Double Egg Wrap",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656782",
                                      "name": "Egg Cheese Chicken Sausage Wrap",
                                      "price": 4000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656783",
                                      "name": "Masala Chicken Tikka Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656784",
                                      "name": "Chicken Bhuna Wrap",
                                      "price": 6000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656785",
                                      "name": "Malai Chicken Kebab Wrap",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656786",
                                      "name": "Cheese Melt Chicken Tikka Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101656787",
                                      "name": "Malai Chicken Cheese Melt Wrap",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114785042",
                                  "groupName": "Choose Your Side",
                                  "choices": [
                                    {
                                      "id": "100135881",
                                      "name": "Teekha Chaska Sausages (Save Rs 50)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135877",
                                      "name": "Potato Wedges (M) (Save Rs 40)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135870",
                                      "name": "Potato Wedges (S) (Save Rs 30)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135874",
                                      "name": "Chocolate Muffin (Save Rs 50)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100135867",
                                      "name": "Mint Chaas (Buttermilk)",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114785044",
                                  "groupName": "Choose Your Add On",
                                  "choices": [
                                    {
                                      "id": "99733325",
                                      "name": "Cheese Dip",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733326",
                                      "name": "Chipotle Cheese Dip (20 gm)",
                                      "price": 2500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733324",
                                      "name": "Teekha Chaska (2 packets)",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99733327",
                                      "name": "Teekha Chaska (10 packets)",
                                      "price": 5000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131275152",
                              "name": "Meatballs Cheese Omelette with Masala Bread",
                              "category": "Breakfast Specials",
                              "description": "Begin your day with fluffy eggs seasoned with meatballs and a generous layer of gooey cheese paired with soft Masala Kulchas creating a perfect harmony of flavors in every bite.",
                              "imageId": "8c559151a0af49fd083fec5fa8f4d0a0",
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131275153",
                              "name": "Sausage Cheese Omelette with Masala Bread",
                              "category": "Breakfast Specials",
                              "description": "Elevate your breakfast with our Sausage Cheese Omelette served with soft Masala Kulchas! Fluffy eggs, savory sausage, and melted cheese a delightful combination of hearty and cheesy goodness to kickstart your day",
                              "imageId": "bacbc3171553c51ff9ebf379c46091fb",
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131275154",
                              "name": "Masala Cheese Omelette with Kulcha Bread",
                              "category": "Breakfast Specials",
                              "description": "Spice up your morning routine with our Masala Cheese Omelette, a fusion of bold Indian spices, fluffy eggs, and molten cheese served with warm & soft Kulchas",
                              "imageId": "5cb0745408a7ef082de94c8bc47e595a",
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221333001316"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Faasos - Wraps, Rolls & Shawarma",
                      "area": "Shantinagar",
                      "completeAddress": "KMK Towers, 1st floor, WEST PORTION, 142 K H ROAD, above Tata Motors, Shanthinagar, Bangalore South, bangalore, 560027"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "olozX5nrMk6g-RhjMih5I_FuJ7ud2PTEESe-Hl_4"
},
// 20240105233819
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=448116&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "448116",
              "name": "The Bowl Company",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "the-bowl-company-basavanagudi-basavanagudi",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "bb6049fae59b8a2413a9177eb0338b49",
              "locality": "Akkithimanahalli",
              "areaName": "Shanti Nagar",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Pan-Asian",
                "Continental"
              ],
              "avgRating": 4.5,
              "feeDetails": {
                "restaurantId": "448116",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4600
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4600,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "3 kms | ₹46 Delivery fee will apply"
              },
              "parentId": "4317",
              "avgRatingString": "4.5",
              "totalRatingsString": "5K+ ratings",
              "sla": {
                "restaurantId": "448116",
                "deliveryTime": 27,
                "minDeliveryTime": 27,
                "maxDeliveryTime": 27,
                "lastMileTravel": 3,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 33,
                "slaString": "27 MINS",
                "lastMileTravelString": "3.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 00:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get every item @ 139",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 139",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 139",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "the-bowl-company-basavanagudi-basavanagudi",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "The Bowl Company, # 299,1st Floor, BBMP ward no 117, Akkithimanahalli , Shanthinagar, Bangalore 560025."
                },
                {
                  "title": "Cuisines",
                  "message": "Pan-Asian,Continental"
                }
              ],
              "logo": "marketing-dashboard/carousel/kcnahrbhty9uv8uraow4",
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "Get every item @ 139",
                "shortDescriptionList": [
                  {
                    "meta": "Get every item @ 139",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get every item @ 139",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ]
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/448116"
              },
              "expectationNotifiers": [
                {
                  "text": "3 kms | ₹46 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>3 kms</b> | ₹46 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.96076,77.60047"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 1,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "EVERY ITEM @ ₹139",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "6be0bbf9-6d7f-4a40-82e4-84558a55d449"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "offerType": "offers",
                      "restId": "448116",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274055",
                          "creativeId": "TopPicks/ChPnrGRB",
                          "title": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "116360311",
                              "name": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
                              "category": "Oriental Bowls",
                              "description": "Paneer cooked with a tantalizing blend of garlic, ginger, soy sauce, and fiery red chillies. Served with a bed of fragrant garlic fried rice. Contains milk, wheat and soy. Energy : 841 Kcal (Mini). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "df32f81d58156473fab1d13286483a87",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274100",
                          "creativeId": "TopPicks/PeCECRi",
                          "title": "Peri Peri Chicken with Egg Corn Rice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "85816114",
                              "name": "Peri Peri Chicken with Egg Corn Rice",
                              "category": "Chef's Special",
                              "description": "An irresistible combination of Portuguese inspired flavours. Tender peri peri grilled chicken on a bed of corn and egg rice, served with a portion of spicy peri peri sauce. Contains Egg, Milk, Traces of Soy. Energy : 657 Kcal (Mini Bowl). (Mini : 430 gms).",
                              "imageId": "351d6b3a57a06f804b50d0be36764205",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274146",
                          "creativeId": "TopPicks/MaFiCuRi",
                          "title": "Malabar Fish Curry with Steamed Rice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "111875279",
                              "name": "Malabar Fish Curry with Steamed Rice",
                              "category": "Chef's Special",
                              "description": "Kerala-style fish curry cooked the traditional way with a delicious gravy of tamarind, coconut and curry leaves. Relish with steamed rice for a classic coastal meal. Contains fish, milk. Energy : 548 Kcal (Mini). (Mini : 375 gms).",
                              "imageId": "78b2ea86c69ed0ff9a932d9d0f79316c",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274193",
                          "creativeId": "TopPicks/NwPnrLbPu",
                          "title": "Nawabi Paneer Lababdar with Flavoured Rice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "85815769",
                              "name": "Nawabi Paneer Lababdar with Flavoured Rice",
                              "category": "Chef's Special",
                              "description": "Feel like a Nawab with this one, soft cubes of paneer cooked in a flavourful Chef special gravy, served along with choice of rice. Contains milk, nuts. Energy : 671 Kcal (with Matar Pulao 375 gms), 1382 Kcal (with Masala Rice 550 gms), 958 Kcal (with Masala Rice 385 gms).",
                              "imageId": "b8304fb46f57ccecefeddf634f573731",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128539232",
                                  "groupName": "Choice of Rice",
                                  "choices": [
                                    {
                                      "id": "102745786",
                                      "name": "Matar Pulao",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274241",
                          "creativeId": "TopPicks/MalCkCuSe",
                          "title": "Malaysian Chicken Curry with Selasih Rice (Mini)",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "119259511",
                              "name": "Malaysian Chicken Curry with Selasih Rice (Mini)",
                              "category": "Chef's Special",
                              "description": "Delight your taste buds with an array of flavours. Roasted chicken in a rich and creamy gravy with potatoes, green beans and a boiled egg. Relish this traditional Malaysian curry with simple yet delicious selasih rice. Contains: Egg, Soy, Wheat. Energy = 481 kcal (Mini Bowl). (450 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "65d7f86add0ea98cb40e196d1a5c02c5",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274284",
                          "creativeId": "TopPicks/DruCGFriRiFl",
                          "title": "Drunken Chicken with Choice of Rice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "120894181",
                              "name": "Drunken Chicken with Choice of Rice",
                              "category": "Chef's Special",
                              "description": "A fiery classic, inspired from the streets of Shanghai; tender chunks of chicken cooked in a Chef's special flavorful Asian sauce and served along with aromatic chilli garlic fried rice. . Contains wheat, traces of soy, . Energy : 521 Kcal (Mini Bowl). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "007c27ee1d1deab29521813d4c88fe5f",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128539230",
                                  "groupName": "Choice of Carb",
                                  "choices": [
                                    {
                                      "id": "109632756",
                                      "name": "Garlic Fried Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109632755",
                                      "name": "Egg Fried Rice",
                                      "price": 2000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274332",
                          "creativeId": "TopPicks/CaGrCHeRi",
                          "title": "Caribbean Grilled Chicken with Herbed Rice",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "80698472",
                              "name": "Caribbean Grilled Chicken with Herbed Rice",
                              "category": "Chef's Special",
                              "description": "Tender and juicy grilled chicken breast cooked with caramelized onions, lemon-mustard sauce and served on a bed of flavourful and  herb rice. Served alongside a fiery peri peri sauce. Contains wheat, traces of soy. Energy : 533 Kcal (Mini Bowl). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "16e516e2efc399d32b44baaa8b21b604",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1274425",
                          "creativeId": "TopPicks/ClsMaCh",
                          "title": "Classic Mac & Cheese Pasta",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "80698711",
                              "name": "Classic Mac & Cheese Pasta",
                              "category": "Continental Bowls",
                              "description": "Good 'ol aromatic and flavorsome bowl, creamy blend of aged cheese and macaroni, topped off with a herby thyme flavored crust! Contains wheat, milk. Energy : 556 Kcal (Mini Bowl) (Mini : 390 gms).",
                              "imageId": "be65eb7f3e41f238a0746bcb7964d098",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Chef's Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111875279",
                              "name": "Malabar Fish Curry with Steamed Rice",
                              "category": "Chef's Special",
                              "description": "Kerala-style fish curry cooked the traditional way with a delicious gravy of tamarind, coconut and curry leaves. Relish with steamed rice for a classic coastal meal. Contains fish, milk. Energy : 548 Kcal (Mini). (Mini : 375 gms).",
                              "imageId": "78b2ea86c69ed0ff9a932d9d0f79316c",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "82 ratings",
                                  "ratingCountV2": "82"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119259511",
                              "name": "Malaysian Chicken Curry with Selasih Rice (Mini)",
                              "category": "Chef's Special",
                              "description": "Delight your taste buds with an array of flavours. Roasted chicken in a rich and creamy gravy with potatoes, green beans and a boiled egg. Relish this traditional Malaysian curry with simple yet delicious selasih rice. Contains: Egg, Soy, Wheat. Energy = 481 kcal (Mini Bowl). (450 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "65d7f86add0ea98cb40e196d1a5c02c5",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85815769",
                              "name": "Nawabi Paneer Lababdar with Flavoured Rice",
                              "category": "Chef's Special",
                              "description": "Feel like a Nawab with this one, soft cubes of paneer cooked in a flavourful Chef special gravy, served along with choice of rice. Contains milk, nuts. Energy : 671 Kcal (with Matar Pulao 375 gms), 1382 Kcal (with Masala Rice 550 gms), 958 Kcal (with Masala Rice 385 gms).",
                              "imageId": "b8304fb46f57ccecefeddf634f573731",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128539232",
                                  "groupName": "Choice of Rice",
                                  "choices": [
                                    {
                                      "id": "102745786",
                                      "name": "Matar Pulao",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "323 ratings",
                                  "ratingCountV2": "323"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "120894181",
                              "name": "Drunken Chicken with Choice of Rice",
                              "category": "Chef's Special",
                              "description": "A fiery classic, inspired from the streets of Shanghai; tender chunks of chicken cooked in a Chef's special flavorful Asian sauce and served along with aromatic chilli garlic fried rice. . Contains wheat, traces of soy, . Energy : 521 Kcal (Mini Bowl). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "007c27ee1d1deab29521813d4c88fe5f",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128539230",
                                  "groupName": "Choice of Carb",
                                  "choices": [
                                    {
                                      "id": "109632756",
                                      "name": "Garlic Fried Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109632755",
                                      "name": "Egg Fried Rice",
                                      "price": 2000,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "120 ratings",
                                  "ratingCountV2": "120"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698472",
                              "name": "Caribbean Grilled Chicken with Herbed Rice",
                              "category": "Chef's Special",
                              "description": "Tender and juicy grilled chicken breast cooked with caramelized onions, lemon-mustard sauce and served on a bed of flavourful and  herb rice. Served alongside a fiery peri peri sauce. Contains wheat, traces of soy. Energy : 533 Kcal (Mini Bowl). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "16e516e2efc399d32b44baaa8b21b604",
                              "inStock": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "309 ratings",
                                  "ratingCountV2": "309"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85816114",
                              "name": "Peri Peri Chicken with Egg Corn Rice",
                              "category": "Chef's Special",
                              "description": "An irresistible combination of Portuguese inspired flavours. Tender peri peri grilled chicken on a bed of corn and egg rice, served with a portion of spicy peri peri sauce. Contains Egg, Milk, Traces of Soy. Energy : 657 Kcal (Mini Bowl). (Mini : 430 gms).",
                              "imageId": "351d6b3a57a06f804b50d0be36764205",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "813 ratings",
                                  "ratingCountV2": "813"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Indian Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698522",
                              "name": "Dhaba Style Dal Tadka with Jeera Rice",
                              "category": "Indian Bowls",
                              "description": "Wholesome yellow lentils cooked with onions, tomatoes and flavoured with tempered ghee and a medley of Indian spices. Served with cumin spiced long grain basmati rice. Comfort in a bowl to get you going! Contains NA.",
                              "imageId": "e072121bae927608c8a7521e65ece47d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "509 ratings",
                                  "ratingCountV2": "509"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698774",
                              "name": "Good ol' Rajma Chawal",
                              "category": "Indian Bowls",
                              "description": "Classic comfort bowl consisting of red kidney beans cooked in a mildly spicy onion tomato masala gravy, served with cumin spiced basmati rice. Contains milk . Energy : 501 Kcal (Mini Bowl) (Mini : 375 gms).",
                              "imageId": "d0eb32387dd8980466ef21ec43995183",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "515 ratings",
                                  "ratingCountV2": "515"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698612",
                              "name": "Punjabi Kadhi Chawal",
                              "category": "Indian Bowls",
                              "description": "A little tangy and much flavourful comes this Punjabi kadhi with crispy pakoras doused in a thick mildly spiced gram flour based gravy served with steamed rice. Contains milk. Energy : 526 Kcal (Mini Bowl) (Mini : 375 gms).",
                              "imageId": "c912dccefadde3c259181febab53d88c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "270 ratings",
                                  "ratingCountV2": "270"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "110235237",
                              "name": "Classic Chicken Curry with Rice",
                              "category": "Indian Bowls",
                              "description": "Food that speaks directly to the soul - bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with coriander served with steamed rice. Contains nuts. Energy : 562 Kcal. (Mini Bowl) (Mini : 375 gms).",
                              "imageId": "aaf3ea1ec621af78b995697d57537d9d",
                              "inStock": 1,
                              "price": 20900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "96 ratings",
                                  "ratingCountV2": "96"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698497",
                              "name": "South Indian Style Egg Curry with Jeera Rice",
                              "category": "Indian Bowls",
                              "description": "A mouthwatering Chennai speciality; hard boiled eggs cooked with traditional South Indian spices alongside lots of fresh curry leaves and mustard seeds. Served with aromatic cumin spiced rice. Contains Egg. Energy : 479 Kcal (Mini Bowl). (Mini : 375 gms).",
                              "imageId": "378df4e9d12f5e1e26d18aa03612c280",
                              "inStock": 1,
                              "price": 20900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "New Launch!",
                      "categories": [
                        {
                          "title": "Gourmet Mediterranean Bowls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125977219",
                                  "name": "Harissa Paneer Saffron Rice Bowl",
                                  "category": "New Launch!",
                                  "description": "Experience the flavours of Middle-Eastern biryani - A tantalizing blend of smoky and spicy paneer, saffron-infused rice, and delicate spices. Topped with cashews, raisins, and fried onions, this biryani is a delight for biryani aficionados. Enjoy it with our special onion-based gravy and labheh (Greek yoghurt). Contains nut, milk, soy & traces of wheat. Energy 799 Kcal, (386 gms).",
                                  "imageId": "4dec654ce594d28603ec5ace5b7e0824",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "finalPrice": 13900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125977218",
                                  "name": "Harissa Chicken Saffron Rice Bowl",
                                  "category": "New Launch!",
                                  "description": "Indulge in the authentic Middle Eastern twist on biryani: Spicy chicken meets saffron-infused rice, simmered with delicate spices, and garnished with cashews, raisins, and crispy fried onions. Savour it with a delectable onion-based gravy and Labheh (Greek yogurt). Contains nuts, milk, soy, and traces of wheat. Energy: 837 Kcal (390g).",
                                  "imageId": "1bde44b7254bb171c49da35d8916a6ba",
                                  "inStock": 1,
                                  "price": 27900,
                                  "finalPrice": 13900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Oriental Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698760",
                              "name": "Classic Manchurian with Chilli Garlic Hakka Noodles",
                              "category": "Oriental Bowls",
                              "description": "Mixed vegetable balls tossed in a thick manchurian gravy on a bed of tossed hakka noodles! Twist your dish with a customizable option of Chilli Garlic Sprinkler . Contains wheat, soy. Energy : 522 Kcal (Mini Bowl) (Mini : 450 gms). * This menu item contains added Monosodium Glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "c05dc65488b2f165dbe223b69286f065",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "316 ratings",
                                  "ratingCountV2": "316"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116360310",
                              "name": "Veg Manchurian with Chilli Garlic Rice Bowl",
                              "category": "Oriental Bowls",
                              "description": "Crispy fried veg balls dunked in classic Indo-Chinese manchurian gravy and servered with chilli garlic fried rice. Contains wheat and soy. Energy : 656 Kcal (Mini), 914 Kcal (Regular). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "adc6858ffb9efa049d8e7077e3191063",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "96 ratings",
                                  "ratingCountV2": "96"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109234741",
                              "name": "Thai Green Veg Curry with Steamed Rice",
                              "category": "Oriental Bowls",
                              "description": "Locally sourced aubergine, beans and carrots cooked with coconut milk in a thai green curry paste; topped with fresh basil and red chilli. Served alongside with steamed rice. Contain traces of soy. Energy : 457 Kcal (Mini Bowl). (Mini : 390 gms).",
                              "imageId": "7fcd32f176de767224ddbacd6e0c24c8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "235 ratings",
                                  "ratingCountV2": "235"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116360309",
                              "name": "Chilli Paneer with Garlic Hakka Noodles Bowl",
                              "category": "Oriental Bowls",
                              "description": "Spicy wok tossed noodles topped with paneer dunked in a spicy sauce made of chilli, soy sauce and garlic. Contains wheat, soy and milk. Energy : 912 Kcal (Mini). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "b6a10130d21f03b251d3eef07a78bf71",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116360311",
                              "name": "Streetstyle Chilli Paneer with Garlic Rice Bowl",
                              "category": "Oriental Bowls",
                              "description": "Paneer cooked with a tantalizing blend of garlic, ginger, soy sauce, and fiery red chillies. Served with a bed of fragrant garlic fried rice. Contains milk, wheat and soy. Energy : 841 Kcal (Mini). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "df32f81d58156473fab1d13286483a87",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "120 ratings",
                                  "ratingCountV2": "120"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116360308",
                              "name": "Drunken Chicken with Garlic Hakka Noodles Bowl",
                              "category": "Oriental Bowls",
                              "description": "Succulent chicken cooked in a delicious gravy with pan-asian flavours and a medley of colorful vegetables. Relish with wok tossed chilli garlic noodles. Contains wheat, soy, egg and fish. Energy : 697 Kcal (Mini). This menu item contains added monosodium glutamate. Not recommended for infants below 12 months and pregnant women.",
                              "imageId": "c512678cb5f8c062d6953815a7db1355",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Continental Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698711",
                              "name": "Classic Mac & Cheese Pasta",
                              "category": "Continental Bowls",
                              "description": "Good 'ol aromatic and flavorsome bowl, creamy blend of aged cheese and macaroni, topped off with a herby thyme flavored crust! Contains wheat, milk. Energy : 556 Kcal (Mini Bowl) (Mini : 390 gms).",
                              "imageId": "be65eb7f3e41f238a0746bcb7964d098",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "200 ratings",
                                  "ratingCountV2": "200"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698696",
                              "name": "Creamy Mushroom Florentine Spaghetti Pasta",
                              "category": "Continental Bowls",
                              "description": "A beauty straight from the cobbled stoned aisles of Italy! Al dente spaghetti tossed in a luscious creamy sauce along with mushrooms, lush spinach leaves and finished off with parmesan shavings. Simple, delicious and definitely worth a try. Contains milk, wheat. Energy : 595 Kcal (Mini Bowl) (Mini : 380 gms).",
                              "imageId": "63814515f86c0094549431d548ba8795",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "103830692",
                              "name": "Butter Chicken Mac & Cheese",
                              "category": "Continental Bowls",
                              "description": "A dish that marries the two classics - al dente macaroni and tender chicken chunks tossed in a creamy makhani sauce and finished off with parmesean shavings to seal the deal. Ultimate comfort food! Contains : Nut, milk, wheat. Energy : 565 Kcal (Mini Bowl).",
                              "imageId": "1845aecbf6860afa1de66140cf878e7e",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Parotta Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698453",
                              "name": "Nawabi Paneer Lababdar Parotta Bowl",
                              "category": "Parotta Bowls",
                              "description": "Inspired from the kitchens of Punjab, soft cubes of paneer cooked in our flavourful Chef's special gravy seasoned with fragrant spices and served alongside soft, flaky conveniently chopped up, bite-sized pieces of your Choice of Parotta. Contains Milk, Nut, Wheat. Energy : 791 Kcal (Mini Bowl). (Mini : 385 gms).",
                              "imageId": "fc54bfbe5f4bdde2ad6aa2fe65a41594",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "128539231",
                                  "groupName": "Choice of Paratha",
                                  "choices": [
                                    {
                                      "id": "102977051",
                                      "name": "Laccha Paratha",
                                      "price": 1000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "102977052",
                                      "name": "Kerala Paratha",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "155 ratings",
                                  "ratingCountV2": "155"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698533",
                              "name": "Classic Chicken Curry Kerala Parotta Bowl",
                              "category": "Parotta Bowls",
                              "description": "Bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with coriander served with kerela parotta. Contains : wheat, nut. Energy : 758.3 Kcal (Mini Bowl) (Mini : 385 gms).",
                              "imageId": "b1118edd90b9c87036cb605ac56f351e",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698930",
                              "name": "Drunken Chicken Kerala Parotta Bowl",
                              "category": "Parotta Bowls",
                              "description": "Tender chunks of chicken cooked in a Chef's special flavorful Asian sauce (tinch of wine) and served along with kerela parotta. Contains wheat, traces of soy, fish crustaceans, molluscs (sauce) . Energy : 703 Kcal (Mini Bowl) (Mini : 385 gms).",
                              "imageId": "fcdb6804087b4931d9ad235cf73cf97e",
                              "inStock": 1,
                              "price": 21900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "118 ratings",
                                  "ratingCountV2": "118"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Guilt Free Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94174520",
                              "name": "Good ol' Rajma Chawal with Brown Jeera Rice (Mini)",
                              "category": "Guilt Free Bowls",
                              "description": "Classic comfort bowl consisting of red kidney beans cooked in a mildly spicy onion tomato masala gravy, served with cumin spiced brown rice. Contains : milk. Energy : 495 Kcal (Mini Bowl). (375 gms).",
                              "imageId": "9031285fb40c2f6c94a0a196e14b5b02",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "141 ratings",
                                  "ratingCountV2": "141"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94174523",
                              "name": "Classic Chicken Curry with Brown Jeera Rice (Mini)",
                              "category": "Guilt Free Bowls",
                              "description": "Food that speaks directly to the soul - bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with fresh coriander served with jeera brown rice. Contains Nut.",
                              "imageId": "154fd498ecb61eacc05e6131a5f807dc",
                              "inStock": 1,
                              "price": 23900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "84 ratings",
                                  "ratingCountV2": "84"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94174524",
                              "name": "Classic Chicken Curry Laccha Parotta Bowl",
                              "category": "Guilt Free Bowls",
                              "description": "Bhuna chicken cooked in a rich tomato-onion gravy cooked with flavourful masalas and finished with fresh coriander served with wheat laccha parotta. Contains : wheat, nut. Energy : 758. 3 Kcal (Mini Bowl). (Mini : 385 gms).",
                              "imageId": "2812b01f6623e5c1ebf4ee2d92bcaec1",
                              "inStock": 1,
                              "price": 24900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94174525",
                              "name": "Drunken Chicken Laccha Parotta Bowl",
                              "category": "Guilt Free Bowls",
                              "description": "Tender chunks of chicken cooked in a Chef's special flavorful Asian sauce (tinch of wine) and served along with wheat laccha parotta. Contains wheat, traces of soy, fish crustaceans, molluscs (sauce) . Energy : 703 Kcal (Mini Bowl) (Mini : 385 gms).",
                              "imageId": "1707509122c9fe150cc914c6bc2dbc1e",
                              "inStock": 1,
                              "price": 25900,
                              "finalPrice": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "32 ratings",
                                  "ratingCountV2": "32"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "101904049",
                              "name": "Mini Garlic Toast",
                              "category": "Sides",
                              "description": "Crispy rusk flavoured with garlic, chilli flakes and oregano. A perfect all-day munchie! (22 gms).",
                              "imageId": "507bef754dcb50c8d67f4707cb5d2a20",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117830537",
                              "name": "Falafel",
                              "category": "Sides",
                              "description": "Tasteful fritters made of ground chickpeas and herbs. A popular Middle Eastern snack. Contains wheat. Energy : 147 Kcal.",
                              "imageId": "76cb6932f6f724887e51c4e342cd4d7d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "122929677",
                              "name": "Palada Payasam",
                              "category": "Desserts",
                              "description": "Kerala special creamy, sweet pudding made with rice ada, milk, sugar and ghee. Contains milk and nut. Energy : 206 Kcal.",
                              "imageId": "e8e92480e8846d19022bc8abfb103913",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117830532",
                              "name": "Choco Nutty Mousse",
                              "category": "Desserts",
                              "description": "Smooth and creamy chocolate mousse topped with roasted almonds. Contains nuts and dairy.",
                              "imageId": "9b04b37678c8b231600103226ffcdc04",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698661",
                              "name": "Kesariya Rasamalai",
                              "category": "Desserts",
                              "description": "Soft and spongy cottage cheese dumplings soaked in a dry fruit aced creamy saffron milk rabri. Got to love all things old school. Contains milk, nuts. Energy : 121 Kcal.",
                              "imageId": "4d81e491e22d8c6981ddd174e57f09b2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "92 ratings",
                                  "ratingCountV2": "92"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698461",
                              "name": "Angoori Rasmalai",
                              "category": "Desserts",
                              "description": "Angoori Rasmalai is a traditional Bengali sweet soaked in a mouth watering milk based gravy. It's a jar of love. Contains milk, nuts. Energy : 125 Kcal (Cup).",
                              "imageId": "22e2c97a0ea211ff0fbf4dd15ba0e942",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "100 ratings",
                                  "ratingCountV2": "100"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698578",
                              "name": "Gajar Ka Halwa",
                              "category": "Desserts",
                              "description": "Mum's oh-so-yum Gajar Ka Halwa simply made with shredded red carrots in warm ghee, sugar and a blend of winter spices. Grab a spoonful with the chopped dry fruits and the wafting scent of cardamom and cuddle back in bed. Contains milk, nuts. Energy : 291. 99 Kcal. (100 gms).",
                              "imageId": "15a0e4f0bbbb89af15f4752e629e4eea",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "78 ratings",
                                  "ratingCountV2": "78"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698414",
                              "name": "Rabdi Jamun and a Boondi Drizzle",
                              "category": "Desserts",
                              "description": "Angoori gulab jamun topped with creamy homemade radbi, sugary drops of pillowy boondi and finished off with slivers of pistachios. Good for 1. Contains milk, nuts. Energy : 287.72 Kcal. (100 gms).",
                              "imageId": "9819dd17d46a40ffaef217df179d2f82",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109234740",
                              "name": "Gulab Jamun",
                              "category": "Desserts",
                              "description": "These soft little pleasures soaked in rose and saffron flavoured sugar syrup and garnished with dry fruit shavings is what deliciousness is all about. Good for 1. Contains milk, nuts, wheat. Energy : 278 Kcal (90 gms).",
                              "imageId": "2218f1124c32e23e3071c5caf6beb3f4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698427",
                              "name": "Triple Ripple Chocolate Cake",
                              "category": "Desserts",
                              "description": "Sink your spoon into this pool of Dutch dark chocolate; layers of fluffy chocolate sponge tucked amidst ripples of rich, whipped chocolate truffle, finished with delicate shavings of white and dark chocolate. Good for 2. Contains Milk, Wheat, Nut. Energy = 810 Kcal.",
                              "imageId": "2a791c74732c0de85581e527ae1daa55",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages!",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "85816127",
                              "name": "Zero Coke Can (330 ml)",
                              "category": "Beverages!",
                              "description": "The real Coke taste you love - minus the sugar and calories. *Packaged products sold by Venkatesh Trading Co. Country of origin : India. Energy : 1 Kcal/pack (as per label). Contains caffeine. Please read label for more specific declaration.",
                              "imageId": "129280ae5e6a8976a90cfdadfe3bcf79",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698475",
                              "name": "Coca-Cola Can (330 ml)",
                              "category": "Beverages!",
                              "description": "Meals seem incomplete without a chilled and bubbling can of Coca-Cola. *Packaged products sold by Venkatesh Trading Co. Country of origin : India . Energy : 145Kcal/pack (as per label) Contains caffeine. Please read label for more specific declaration.",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "21 ratings",
                                  "ratingCountV2": "21"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698446",
                              "name": "Sprite Can (330 ml)",
                              "category": "Beverages!",
                              "description": "The lemony taste of Sprite will always keep you refreshed. *Packaged products sold by Venkatesh Trading Co. \n Country of origin : India \n . Energy : 144 Kcal/pack (as per label) Please read label for more specific declaration",
                              "imageId": "caf2462684af14a1784bc0d2d77ddfc9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80698474",
                              "name": "Thums Up Can (330 ml)",
                              "category": "Beverages!",
                              "description": "India's unbeaten cold drink choice for decades - raise the excitement of any occasion to toofani levels with power-packed Thums Up. *Packaged products sold by Venkatesh Trading Co. Country of origin: India Energy= 129 Kcal/pack (as per label) Contains caffiene. Please read label for more specific declaration",
                              "imageId": "679489bfaa2985fc0ed33602a0841b5c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109990160",
                              "name": "Raw Pressery  - Alphonso Mango Juice",
                              "category": "Beverages!",
                              "description": "Enjoy your favourite fruit all year! Raw Pressery captured summer in a bottle to give you mango flavour all the season *Packaged products sold by Venkatesh Trading Co. Country of Origin : India. Energy : 104 Kcal/pack (as per label).",
                              "imageId": "36960b7866499d7e93bfa720ae091bcb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6300,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "offerTags": [
                                {
                                  
                                }
                              ],
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221333002431"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "The Bowl Company",
                      "area": "Shanti Nagar",
                      "completeAddress": "The Bowl Company, # 299,1st Floor, BBMP ward no 117, Akkithimanahalli , Shanthinagar, Bangalore 560025."
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "TsbK393UUlOt--q3gj4MLN3DM4uFmqIeLhxe2abw"
},
// 20240105233846
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=16073&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "16073",
              "name": "California Burrito",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "california-burrito-malleshwaram-malleshwaram",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "27238ee4292d42c7b705f2ce8671ff80",
              "locality": "Malleshwaram",
              "areaName": "Malleshwaram",
              "costForTwo": "25000",
              "costForTwoMessage": "₹250 for two",
              "cuisines": [
                "Mexican",
                "American"
              ],
              "avgRating": 4.7,
              "feeDetails": {
                "restaurantId": "16073",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 6700
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 6700,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (5 kms) | Additional delivery fee will apply"
              },
              "parentId": "1252",
              "avgRatingString": "4.7",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "16073",
                "deliveryTime": 29,
                "minDeliveryTime": 29,
                "maxDeliveryTime": 29,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 49,
                "slaString": "29 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 11 am, tomorrow",
                "nextOpenTime": "2024-01-06 11:00:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹100 | Use RUPAY100 Above ₹129",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "california-burrito-malleshwaram-malleshwaram",
              "multiOutlet": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "3rd Floor, Mantri Square Mall, Malleshwaram, Bangalore - 560003"
                },
                {
                  "title": "Cuisines",
                  "message": "Mexican,American"
                }
              ],
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹100 | Use RUPAY100 Above ₹129",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/16073"
              },
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 11 am, tomorrow",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 11:00 AM tomorrow",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "hasGuiltfreeItems": true,
              "brandHeaderText": "Interested in dining out here?\nEnjoy flat 50% off with Swiggy Dineout",
              "nearestOutletNudge": {
                "nearestOutletInfo": {
                  "siblingOutlet": {
                    "id": "10823",
                    "city": "0",
                    "slugs": {
                      
                    },
                    "areaName": "Indiranagar",
                    "costForTwo": "0",
                    "feeDetails": {
                      
                    },
                    "sla": {
                      "deliveryTime": 28,
                      "lastMileTravel": 6.2,
                      "slaString": "28 MINS",
                      "lastMileTravelString": "6.1 km",
                      "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                      "restaurantClosedMeta": {
                        
                      }
                    },
                    "aggregatedDiscountInfo": {
                      "visible": true
                    },
                    "badges": {
                      
                    },
                    "aggregatedDiscountInfoV2": {
                      "visible": true
                    },
                    "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                    "cartOrderabilityNudgeBanner": {
                      "parameters": {
                        
                      },
                      "presentation": {
                        
                      }
                    }
                  }
                },
                "nearestOutletComms": {
                  "title": {
                    "text": "Don't worry! Try our outlet that's delivering"
                  },
                  "subTitle": {
                    "text": "Switch to the fastest alternate"
                  }
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9915937,77.5710597"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 4,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "16073",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "16073",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "16073",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "16073",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Honest Bowls",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990923",
                              "name": "Grilled Barbeque Chicken Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and grilled chicken. Make it just the way you like it!",
                              "imageId": "850b109187edc3968df3c00cc8b9c825",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891617",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891668",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891638",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891662",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656086",
                              "name": "Crispy Peri Peri Chicken Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and crispy chicken. Make it just the way you like it!",
                              "imageId": "e27ed32be7247b7a1d0b57cb12e64efd",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896756",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896801",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896775",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896795",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "94 ratings",
                                  "ratingCountV2": "94"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990532",
                              "name": "Barbeque Paneer Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and grilled BBQ Paneer. Make it just the way you like it!",
                              "imageId": "f590ac3a24773c350ccc5e8dcfcbd808",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891360",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891394",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891372",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891386",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "148 ratings",
                                  "ratingCountV2": "148"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991044",
                              "name": "Mexican Spicy Paneer Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and mexican spicy paneer. Make it just the way you like it!",
                              "imageId": "93e99c97da526f9f84c4ca1d0e0d69a6",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891545",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891594",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891565",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891584",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "72 ratings",
                                  "ratingCountV2": "72"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990689",
                              "name": "Crispy Mushroom Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and crispy mushroom. Make it just the way you like it!",
                              "imageId": "34c3bd4a0c92ed117b93bb21c263ba69",
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891414",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891461",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891432",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891451",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "164 ratings",
                                  "ratingCountV2": "164"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991059",
                              "name": "Peri Peri Potato Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and peri peri potato. Make it just the way you like it!",
                              "imageId": "64190258f5ce49be309637ee86bbd17f",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891481",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891524",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891493",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891517",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "362 ratings",
                                  "ratingCountV2": "362"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990949",
                              "name": "Grilled Barbeque Chicken Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and grilled chicken. Make it just the way you like it!",
                              "imageId": "850b109187edc3968df3c00cc8b9c825",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892108",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892131",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892173",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892141",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892161",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "177 ratings",
                                  "ratingCountV2": "177"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656085",
                              "name": "Crispy Peri Peri Chicken Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and crispy chicken. Make it just the way you like it!",
                              "imageId": "e27ed32be7247b7a1d0b57cb12e64efd",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896446",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896464",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896495",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896467",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896489",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "90 ratings",
                                  "ratingCountV2": "90"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63989092",
                              "name": "Chili Chipotle Chicken Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and chili chipotle chicken. Make it just the way you like it!",
                              "imageId": "310f4791956453cf6c640a54f92c89d0",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897238",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897268",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897316",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897275",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897301",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990541",
                              "name": "Barbeque Paneer Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and BBQ Paneer. Make it just the way you like it!",
                              "imageId": "f590ac3a24773c350ccc5e8dcfcbd808",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891742",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891763",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891809",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891771",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891794",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "211 ratings",
                                  "ratingCountV2": "211"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991045",
                              "name": "Mexican Spicy Paneer Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and mexican spicy paneer. Make it just the way you like it!",
                              "imageId": "93e99c97da526f9f84c4ca1d0e0d69a6",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892023",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892041",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892079",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892049",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892070",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "75 ratings",
                                  "ratingCountV2": "75"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990710",
                              "name": "Crispy Mushroom Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and crispy mushroom. Make it just the way you like it!",
                              "imageId": "34c3bd4a0c92ed117b93bb21c263ba69",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891830",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891850",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891899",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891859",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891881",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "247 ratings",
                                  "ratingCountV2": "247"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991060",
                              "name": "Peri Peri Potato Rice Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and peri peri potato. Make it just the way you like it!",
                              "imageId": "64190258f5ce49be309637ee86bbd17f",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59891932",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891955",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891999",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891961",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59891984",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "254 ratings",
                                  "ratingCountV2": "254"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63989091",
                              "name": "Chili Chipotle Chicken Rice Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions, pico de galla and chili chipotle chicken. Make it just the way you like it!",
                              "imageId": "310f4791956453cf6c640a54f92c89d0",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897687",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897730",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897703",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897721",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656079",
                              "name": "Grilled Onion & Capsicum Bowl (Regular)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions & pico de galla. Make it just the way you like it!",
                              "imageId": "4f3d2766e798c4412ea244bea6beb530",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59898530",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898556",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898596",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898562",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898586",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656074",
                              "name": "Grilled Onion & Capsicum Bowl (Mini)",
                              "category": "Honest Bowls",
                              "description": "Serves 1 | Fresh cilantro rice and everything nice. Comes with your favourite toppings, fajita veggies like bell peppers and onions & pico de galla. Make it just the way you like it!",
                              "imageId": "4f3d2766e798c4412ea244bea6beb530",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59898229",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898297",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898253",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898283",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cali Burritos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990793",
                              "name": "Grilled Barbeque Chicken Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of grilled chicken, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "a179d06c570ac75bf386e5f248e8ead4",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892531",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892582",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892552",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892572",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656090",
                              "name": "Crispy Peri Peri Chicken Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of crispy chicken, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "ea801271a44d31067bf10a210b0dcd37",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896696",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896740",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896711",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896730",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656106",
                              "name": "Chili Chipotle Chicken Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of juicy chicken, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "e124ae9ff18a53078522591eb74cbe89",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897629",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897670",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897649",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897662",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990491",
                              "name": "Barbeque Paneer Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of paneer, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "d4836e8d08bb32f98b9f4659b4b7d60a",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892198",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892253",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892219",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892242",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "69 ratings",
                                  "ratingCountV2": "69"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991040",
                              "name": "Mexican Spicy Paneer Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of Mexican paneer, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "e080874ce37935cc286ef377528c2d93",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892462",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892510",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892482",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892500",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990621",
                              "name": "Crispy Mushroom Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of crispy mushrooms, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "af00a23971ccc89c92db368536926c20",
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892276",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892332",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892299",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892318",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "54 ratings",
                                  "ratingCountV2": "54"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991055",
                              "name": "Peri Peri Potato Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of soft potato, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "8ad2af2ff48e7df43dd771be747c7de7",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892383",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892441",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892405",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892428",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656073",
                              "name": "Grilled Onion & Capsicum Burrito (Mini)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of grilled fajita veggies like bell peppers and onions, pinto beans, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "6feb7bb9b2e20617f12ba858a7093057",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59898142",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898208",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898169",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898198",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990831",
                              "name": "Grilled Barbeque Chicken Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of grilled chicken, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "a179d06c570ac75bf386e5f248e8ead4",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892962",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892983",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893038",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892994",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893018",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "83 ratings",
                                  "ratingCountV2": "83"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656089",
                              "name": "Crispy Peri Peri Chicken Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of crispy chicken, pinto beans, fajita veggies like bell peppers and onion, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "ea801271a44d31067bf10a210b0dcd37",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896384",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896398",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896429",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896403",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896421",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656107",
                              "name": "Chili Chipotle Chicken Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of juicy chicken, pinto beans, fajita veggies like bell peppers and onion, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "e124ae9ff18a53078522591eb74cbe89",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897143",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897168",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897217",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897176",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897203",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990497",
                              "name": "Barbeque Paneer Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of paneer, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "d4836e8d08bb32f98b9f4659b4b7d60a",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892602",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892623",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892659",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892628",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892648",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "97 ratings",
                                  "ratingCountV2": "97"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991041",
                              "name": "Mexican Spicy Paneer Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of Mexican paneer, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "e080874ce37935cc286ef377528c2d93",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892845",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892867",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892906",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892874",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892896",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "63 ratings",
                                  "ratingCountV2": "63"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990634",
                              "name": "Crispy Mushroom Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of crispy mushroom, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "af00a23971ccc89c92db368536926c20",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892684",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892699",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892738",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892705",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892725",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "85 ratings",
                                  "ratingCountV2": "85"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991056",
                              "name": "Peri Peri Potato Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of soft potato, pinto beans, fajita veggies like bell peppers and onions, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "8ad2af2ff48e7df43dd771be747c7de7",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59892760",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892786",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892828",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892790",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59892812",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "97 ratings",
                                  "ratingCountV2": "97"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656069",
                              "name": "Grilled Onion & Capsicum Burrito (Regular)",
                              "category": "Cali Burritos",
                              "description": "Serves 1 | Our soft flour tortilla stuffed with your choice of fillings, rolled and lightly toasted. Enjoy the goodness of grilled fajita veggies like bell peppers and onions, pinto beans, fresh pico de gallo and sour cream. YUM!",
                              "imageId": "6feb7bb9b2e20617f12ba858a7093057",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897866",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897879",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897903",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897881",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897900",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "*New* Hangout Menu",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355426",
                              "name": "Popcorn Chicken",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Bite-sized seasoned boneless chicken, sprinkled with peri peri seasoning. Served with chipotle mayo & cheesy queso",
                              "imageId": "919625ccba52409fc8f92cad5a9a14c3",
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355427",
                              "name": "Popcorn Mushroom",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Bite-sized crispy mushroom, sprinkled with peri peri seasoning. Served with chipotle mayo & cheesy queso",
                              "imageId": "39347354ca5927eb1e257442b6ae0125",
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355428",
                              "name": "Popcorn Potato",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Bite-sized crispy potato, sprinkled with peri peri seasoning. Served with chipotle mayo & cheesy queso",
                              "imageId": "e86240ce7c8e8299b766f8fe6223c3ff",
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355429",
                              "name": "Veg Snachos",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Crispy tortilla chips layered with black beans, pico, chipotle mayo and topped with a dollop of fresh sour cream",
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355430",
                              "name": "Chicken Snachos",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Crispy tortilla chips layered with chipotle chicken, pico, chipotle sauce and topped with a dollop of fresh sour cream",
                              "imageId": "e6e9f4568db47cf8ed11c0c115606c85",
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355433",
                              "name": "Cheese Meltdown Veg Taco",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Molten lava cheese between a double layer soft & crunchy taco shell filled with peri peri potato, pinto beans, pico, lettuce and south west sauce",
                              "imageId": "8bb91fd7fd15b5c080254be4322e862f",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355431",
                              "name": "Cheese Meltdown Chicken Taco",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Molten lava cheese between a double layer soft & crunchy taco shell filled with chipotle chicken, pinto beans, pico, lettuce and south west sauce",
                              "imageId": "2da66bd04d9b4953e6e18c4400b25b5b",
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355432",
                              "name": "Veg Taquito (2 pcs)",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | A soft rolled mini tortilla filled with black beans and melted cheese.",
                              "imageId": "0edd3cbc0b49eea2c3e8eaae2fecd250",
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355434",
                              "name": "Chicken Taquito (2 pcs)",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | A soft rolled mini tortilla filled with Chili chipotle chicken and melted cheese.",
                              "imageId": "0edd3cbc0b49eea2c3e8eaae2fecd250",
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355435",
                              "name": "Avocado Toast",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Our tastiest guacamole & pico on a crispy tortilla",
                              "imageId": "cf63a36745f28cbf3cf13a467e726c29",
                              "isVeg": 1,
                              "price": 12900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129355436",
                              "name": "Veg Toastada",
                              "category": "*New* Hangout Menu",
                              "description": "Serves 1 | Cheese, pinto beans and pico on a crispy tortilla",
                              "imageId": "d9bd77ea380b49359a2847973e79dafe",
                              "isVeg": 1,
                              "price": 11900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "*New* HealthifyMe X California Burrito",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117567414",
                              "name": "PRO Salad - Grilled Barbeque Chicken",
                              "category": "*New* HealthifyMe X California Burrito",
                              "description": "Serves 1 | Eat salads like a PRO with fresh lettuce, grilled barbecue chicken, black beans, corn salsa, and zesty pico - drizzled with tangy chili lime vinaigrette and finished off with a sprinkle of sunflower seeds.\nCalorie: 390 Kcal, Protein: 30g, Carbs: 29g, Fat: 18g, Fiber: 10g",
                              "imageId": "ed3f518a44b8e847509f8f32337f474a",
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117567415",
                              "name": "PRO Salad - Mexican Paneer",
                              "category": "*New* HealthifyMe X California Burrito",
                              "description": "Serves 1 | Eat salads like a PRO with fresh lettuce, mexican paneer, black beans, corn salsa, and zesty pico - drizzled with tangy chili lime vinaigrette and finished off with a sprinkle of sunflower seeds.\nCalorie: 457 Kcal, Protein: 24g, Carbs: 30g, Fat: 28g, Fiber: 14g",
                              "imageId": "55147692a69f00660a7f1f2898e9fba1",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117567416",
                              "name": "PRO Bowl - Grilled Barbeque Chicken",
                              "category": "*New* HealthifyMe X California Burrito",
                              "description": "Serves 1 | Eat bowls like a PRO with cilantro rice, grilled barbeque chicken, fajita veggies, black beans, corn salsa, pico, topped with guacamole & zesty chili lime vinaigrette in our protein-packed Mexican bowl.\nCalorie: 488 Kcal, Protein: 29g, Carbs: 50g, Fat: 20g, Fiber: 12g",
                              "imageId": "445edd940bfa8fa405c0a4a33a6cecc0",
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117567417",
                              "name": "PRO Bowl - Mexican Paneer",
                              "category": "*New* HealthifyMe X California Burrito",
                              "description": "Serves 1 | Eat bowls like a PRO with cilantro rice, mexican paneer, fajita veggies, black beans, corn salsa, pico, topped with guacamole & zesty chili lime vinaigrette in our protein-packed Mexican bowl.\nCalorie: 555 Kcal, Protein: 23g, Carbs: 51g, Fat: 31g, Fiber: 15g",
                              "imageId": "b7d1f37015ed9ec45bbe98c3cb4e3bf5",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fresh Salads",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990555",
                              "name": "Barbeque Paneer Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and barbeque paneer.",
                              "imageId": "01df8427396661c0263dbc7469d9320b",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915436",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846586",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893126",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893090",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893115",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "49 ratings",
                                  "ratingCountV2": "49"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990960",
                              "name": "Grilled Barbeque Chicken Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and grilled barbeque chicken.",
                              "imageId": "e984d6d7eee5d187e338bfdc9fda7572",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915440",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846597",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893482",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893445",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893470",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990722",
                              "name": "Crispy Mushroom Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and crispy mushroom salad.",
                              "imageId": "490c3645a088bcbb3ce04f7dad83a7d2",
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915437",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846587",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893219",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893185",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893205",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656083",
                              "name": "Crispy Peri Peri Chicken Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and crispy peri peri chicken.",
                              "imageId": "2c794cc2df58fbbb3863df2eb2154334",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915458",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846615",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59896910",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896859",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896896",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "44 ratings",
                                  "ratingCountV2": "44"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656110",
                              "name": "Chili Chipotle Chicken Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and chili chipotle chicken.",
                              "imageId": "7d6caaf06804c7a819b079f3fed7f99b",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915459",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846617",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59897789",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897761",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897781",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991061",
                              "name": "Peri Peri Potato Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and peri peri potato.",
                              "imageId": "22fd59f16936c0ac94f44091807318c5",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915438",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846588",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893306",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893276",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893295",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "59 ratings",
                                  "ratingCountV2": "59"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991046",
                              "name": "Mexican Spicy Paneer Salad (Mini)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and mexican spicy paneer.",
                              "imageId": "b61b000ea223774187e51a6a8f83bf77",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "79915439",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846589",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893396",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893361",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893387",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "17 ratings",
                                  "ratingCountV2": "17"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990968",
                              "name": "Grilled Barbeque Chicken Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and grilled barbeque chicken.",
                              "imageId": "e984d6d7eee5d187e338bfdc9fda7572",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59893906",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893933",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846602",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893987",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893940",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893969",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656084",
                              "name": "Crispy Peri Peri Chicken Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and crispy peri peri chicken.",
                              "imageId": "2c794cc2df58fbbb3863df2eb2154334",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896507",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896523",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846613",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59896552",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896527",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896548",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990567",
                              "name": "Barbeque Paneer Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and barbeque paneer.",
                              "imageId": "01df8427396661c0263dbc7469d9320b",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59893506",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893531",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846598",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893569",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893533",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893560",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991047",
                              "name": "Mexican Spicy Paneer Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and mexican spicy paneer.",
                              "imageId": "b61b000ea223774187e51a6a8f83bf77",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59893813",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893841",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846601",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893881",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893849",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893870",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "51 ratings",
                                  "ratingCountV2": "51"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990735",
                              "name": "Crispy Mushroom Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and crispy mushroom.",
                              "imageId": "490c3645a088bcbb3ce04f7dad83a7d2",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59893622",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893651",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846599",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893697",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893656",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893682",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "90 ratings",
                                  "ratingCountV2": "90"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991062",
                              "name": "Peri Peri Potato Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and peri peri potato.",
                              "imageId": "22fd59f16936c0ac94f44091807318c5",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59893720",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893749",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846600",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59893792",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893755",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59893781",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "202 ratings",
                                  "ratingCountV2": "202"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656100",
                              "name": "Chili Chipotle Chicken Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and chili chipotle chicken.",
                              "imageId": "7d6caaf06804c7a819b079f3fed7f99b",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897444",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897480",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846616",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59897530",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897486",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897517",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656072",
                              "name": "Grilled Onion & Capsicum Salad (Regular)",
                              "category": "Fresh Salads",
                              "description": "Serves 1 | A crisp bowl of fresh greens that includes a variety of goodness such as corn salsa, pico de galla, pinto beans and grilled bell peppers and onions.",
                              "imageId": "35bec4cd89c50f1c729cebcbd3b9425f",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59898047",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898075",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "114846619",
                                  "groupName": "Dressing - on the side",
                                  "choices": [
                                    {
                                      "id": "101720630",
                                      "name": "Chilli Lime Vinaigrette",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720631",
                                      "name": "Ranch Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720632",
                                      "name": "Chipotle Mayo",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "103731199",
                                      "name": "No Dressing",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "59898120",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898079",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898113",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cheesy Quesadillas",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68294060",
                              "name": "Cheesy Barbeque Chicken Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with barbeque chicken and cheddar cheese. Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "e5b98bbbc6e1c489176166c3a8c8e38c",
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846630",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846631",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959451",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68294057",
                              "name": "Crispy Peri Peri Chicken Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with crispy chicken & cheddar cheese. Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "20ae46d2177cd2e3628cafbe3736f42d",
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846626",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846627",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959449",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68294059",
                              "name": "Cheesy Chipotle Chicken Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with chipotle chicken & cheddar cheese. Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "b24f608d42832a27038a12bbabccdd50",
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846628",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846629",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959450",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108295346",
                              "name": "Crispy Peri Peri Potato Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with crispy peri peri potato & cheddar cheese. Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "a5a8f22a5851163d6e97f014a28f4e95",
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846634",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846635",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959453",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "14340192",
                              "name": "Mexican Corn Fiesta Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with mexican corn & cheddar cheese . Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "3d6edd13691b26478199053d4b6ae851",
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846624",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846625",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959448",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "355 ratings",
                                  "ratingCountV2": "355"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95248604",
                              "name": "Kid's Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A unique creation with crispy corn tortilla loaded with pinto beans, fresh tomato salsa, cheese, jalapenos and chipotle mayo. Perfect for tiny tots!",
                              "imageId": "93e13a589ab9936994418d3f99402ebb",
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846632",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846633",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959452",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68294056",
                              "name": "Southwest Mushroom Quesadilla",
                              "category": "Cheesy Quesadillas",
                              "description": "Serves 1 | A grilled flour tortilla filled with crispy mushroom & cheddar cheese. Melted to perfection and served with south west sauce, salsa and nachos",
                              "imageId": "8ebffc2d3664f840b1eca0d45c64cd25",
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "114846622",
                                  "groupName": "Choose Your Dip - 1",
                                  "choices": [
                                    {
                                      "id": "101720636",
                                      "name": "Hot Salsa - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720637",
                                      "name": "Southwest Sauce - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "114846623",
                                  "groupName": "Choose Your Dip - 2",
                                  "choices": [
                                    {
                                      "id": "101720638",
                                      "name": "Creamy Ranch - Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "101720639",
                                      "name": "Hot Salsa-Dip",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1,
                                  "minAddons": 1
                                },
                                {
                                  "groupId": "94959447",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Munchies",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94742853",
                              "name": "Nacho Chips + Guac",
                              "category": "Munchies",
                              "description": "Serves 1 | Crunchiest nachos in town served with fresh wholesome guacamole. Super yum!",
                              "imageId": "af7trrgjoinme4uy1faj",
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454082",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94742854",
                              "name": "Nacho Chips + Cheesy Queso",
                              "category": "Munchies",
                              "description": "Serves 1 | Crunchiest nachos in town served with cheesy queso. Super yum!",
                              "imageId": "ikf2dbjv0tv5a1ojanwu",
                              "isVeg": 1,
                              "price": 15900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454084",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94742851",
                              "name": "Nacho Chips + Hot Salsa",
                              "category": "Munchies",
                              "description": "Serves 1 | Crunchiest nachos in town served with fresh hot salsa. Super yum!",
                              "imageId": "m02m7sksiwpoanmbplfe",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454080",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "94742852",
                              "name": "Nacho Chips + Mild Salsa",
                              "category": "Munchies",
                              "description": "Serves 1 | Crunchiest nachos in town served with fresh mild salsa. Super yum!",
                              "imageId": "9d3f58315aa54e8aa059b1a9aac52536",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454081",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70023846",
                              "name": "Chocodilla Regular",
                              "category": "Munchies",
                              "description": "Serves 1 | Quesadillas with a twist of chocolate! The perfect ending to your meal for your sweet tooth cravings!",
                              "imageId": "w1wihbwlyxv4yacpkzb6",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454077",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63676718",
                              "name": "Chocodilla (Mini)",
                              "category": "Munchies",
                              "description": "Serves 1 | Quesadillas with a twist of chocolate! The perfect ending to your meal for your sweet tooth cravings!",
                              "imageId": "oksujejhmx3zc1pgpqkm",
                              "isVeg": 1,
                              "price": 6500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "94454076",
                                  "groupName": "Beverage",
                                  "choices": [
                                    {
                                      "id": "92052988",
                                      "name": "Pink Lemonade",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052987",
                                      "name": "Peach Iced Tea",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "92052989",
                                      "name": "Mexican Sunrise",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "37 ratings",
                                  "ratingCountV2": "37"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Vegan",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656000",
                              "name": "Vegan Crispy Mushroom Bowl",
                              "category": "Vegan",
                              "description": "Serves 1 | Crispy chunks of mushroom with panko breadcrumbs that melt in your mouth. Served on long grain rice, with mexican beans, fresh salsa, lettuce, grilled veggies and corn.",
                              "imageId": "25964f84f1523df7e07f294ebb03e446",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59895961",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59895965",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656013",
                              "name": "Vegan Peri Peri Potato Bowl",
                              "category": "Vegan",
                              "description": "Serves 1 | An irresistible combination of seasoned peri peri potatoes and grilled veggies. Served on long grain rice, with mexican beans, fresh salsa, corn and lettuce.",
                              "imageId": "f7c451b8a153398c6adbb199d7996ed7",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896217",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896218",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63655996",
                              "name": "Vegan Crispy Mushroom Burrito",
                              "category": "Vegan",
                              "description": "Serves 1 | Burrito is a soft tortilla roll where all the goodness wrapped up on the inside. This has our crispy chunks of mushroom, with rice, mexican beans, fresh salsa , lettuce, grilled veggies and corn.",
                              "imageId": "98f9101c4323ca6407f70b03d90af04c",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59895905",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59895910",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59895954",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656012",
                              "name": "Vegan Peri Peri Potato Burrito",
                              "category": "Vegan",
                              "description": "Serves 1 | Burrito is a soft tortilla roll where all the goodness wrapped up on the inside. This has our seasoned peri peri potatoes with rice, mexican beans, fresh salsa , lettuce, grilled veggies and corn.",
                              "imageId": "16fc8ec16163d3ebeaa7b57382861b26",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896176",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896183",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896211",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656009",
                              "name": "Vegan Crispy Mushroom Salad",
                              "category": "Vegan",
                              "description": "Serves 1 | Comes with ranchdressing Fresh greens topped full of grilled veggies, seasoned peri peri potatoes, long grain rice, mexican beans, fresh salsa, lettuce, and corn.",
                              "imageId": "07f7987647ec17908ae206a54c8d718c",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896088",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896091",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896131",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656055",
                              "name": "Vegan Peri Peri Potato Salad",
                              "category": "Vegan",
                              "description": "Serves 1 | Comes with ranchdressing Fresh greens topped full of grilled veggies, seasoned peri peri potatoes, long grain rice, mexican beans, fresh salsa, lettuce, and corn.",
                              "imageId": "49025350d8047b3ca00a5fe91e2cd2b8",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896332",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896338",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896365",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656008",
                              "name": "Vegan Crispy Mushroom Nachos",
                              "category": "Vegan",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings long grain rice, mexican beans, fresh salsa, lettuce , grilled veggies and corn.",
                              "imageId": "29e0e793cf5ddc37761462851fe4881d",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896012",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896019",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896052",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656046",
                              "name": "Vegan Peri Peri Potato Nachos",
                              "category": "Vegan",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings seasones peri peri potato long grain rice, mexican beans, fresh salsa, lettuce , grilled veggies and corn.",
                              "imageId": "9fea27d956393b84b5c537d9f654054d",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896249",
                                  "groupName": "Beans",
                                  "choices": [
                                    {
                                      "id": "44148970",
                                      "name": "Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148971",
                                      "name": "Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896255",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896284",
                                  "groupName": "Choose Rice",
                                  "choices": [
                                    {
                                      "id": "44148972",
                                      "name": "With Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148973",
                                      "name": "Without Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Beverages",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "7814795",
                              "name": "Peach Iced Tea",
                              "category": "Beverages",
                              "description": "Serves 1 | Iced tea, made fresh daily.",
                              "imageId": "58af6d092dcca90c32859ae1e67ed975",
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "388 ratings",
                                  "ratingCountV2": "388"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "14340436",
                              "name": "Pink Lemonade",
                              "category": "Beverages",
                              "description": "Serves 1 | Lemonade, natually colored, and made fresh daily.",
                              "imageId": "02255452d1a7e575171fac886d331730",
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "244 ratings",
                                  "ratingCountV2": "244"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "7814796",
                              "name": "Mexican Sunrise",
                              "category": "Beverages",
                              "description": "Serves 1 | 50/50 tea and pink lemonade. Made fresh daily.",
                              "imageId": "0b8b48d9e4c8496b3833266c9918f522",
                              "isVeg": 1,
                              "price": 7500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "200 ratings",
                                  "ratingCountV2": "200"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51632969",
                              "name": "Coke Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "aacef476239f6a1d98f8ac69b2c87813",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51632961",
                              "name": "Coke Zero Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "ghtgoyhkh2d6etchiibe",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "37323235",
                              "name": "Raw Pressery Sugarcane",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "0a2f57784c1f126b8256c662e8c18b4d",
                              "isVeg": 1,
                              "price": 9524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70325670",
                              "name": "Black Pepsi Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "vb8lpjzqrazsxeceybzs",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117188631",
                              "name": "Schweppes Bitter Lemon",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "9c6293d70f9726a6cac343fcd0fb6aac",
                              "isVeg": 1,
                              "price": 7150,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70325671",
                              "name": "Pepsi Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "vc3cmilossiu5joyzjsi",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51633138",
                              "name": "Sprite Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "aem0jd0v9ldv4cghpgih",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991086",
                              "name": "Thums Up Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "u5bgppa7ezbsivh6edtj",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "111917918",
                              "name": "Diet Coke Can",
                              "category": "Beverages",
                              "description": "Serves 1",
                              "imageId": "ox677lnapamocbs8dul9",
                              "isVeg": 1,
                              "price": 6700,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "70687614",
                              "name": "Water Bottle 500ml",
                              "category": "Beverages",
                              "isVeg": 1,
                              "price": 2800,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Loaded Nachos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990520",
                              "name": "Barbeque Paneer Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "c4978e88f6d99ec6bef61e90dcff0ba7",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894516",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894530",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894555",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894534",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894548",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990863",
                              "name": "Barbeque Chicken Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "5c4836e7858c816f0dc23b315fe5955f",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894462",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894500",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894481",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894493",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990895",
                              "name": "Barbeque Chicken Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "5c4836e7858c816f0dc23b315fe5955f",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894767",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894782",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894814",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894789",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894804",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656088",
                              "name": "Crispy Peri Peri Chicken Nachos Bowl (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "19e2de76e688691e1276774bf34a5650",
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896940",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897019",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896973",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897004",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990666",
                              "name": "Crispy Mushroom Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "1115d26c9a2fde160ca35d1a00205876",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894566",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894582",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894613",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894587",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894606",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "41 ratings",
                                  "ratingCountV2": "41"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990507",
                              "name": "Barbeque Paneer Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "c4978e88f6d99ec6bef61e90dcff0ba7",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894178",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894241",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894200",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894228",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991042",
                              "name": "Mexican Spicy Paneer Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "7415ba4491ee44093ca7a7b4587b28ea",
                              "isVeg": 1,
                              "price": 24900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894407",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894452",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894426",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894442",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991058",
                              "name": "Peri Peri Potato Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "01f9246795f8ba574b7e7fb1ce3fd969",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894630",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894646",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894677",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894650",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894668",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "171 ratings",
                                  "ratingCountV2": "171"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58990652",
                              "name": "Crispy Mushroom Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "1115d26c9a2fde160ca35d1a00205876",
                              "isVeg": 1,
                              "price": 24500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894265",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894318",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894285",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894310",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991043",
                              "name": "Mexican Spicy Paneer Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "7415ba4491ee44093ca7a7b4587b28ea",
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894696",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894711",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894745",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894717",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894736",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58991057",
                              "name": "Peri Peri Potato Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "01f9246795f8ba574b7e7fb1ce3fd969",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59894355",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894395",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894372",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59894383",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656075",
                              "name": "Grilled Onion & Capsicum Nachos (Mini)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "6bb4ac968209b54be71956613962c461",
                              "isVeg": 1,
                              "price": 21500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59898319",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898403",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898353",
                                  "groupName": "Make It Rich (Mini)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59898387",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656087",
                              "name": "Crispy Peri Peri Chicken Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "19e2de76e688691e1276774bf34a5650",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59896568",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896588",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896619",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896592",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59896609",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63656105",
                              "name": "Chili Chipotle Chicken Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favorite toppings packed seperately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "55682f3679b53c74e587e853cb8d8b66",
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897339",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897370",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897417",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897375",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897409",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "89399512",
                              "name": "Grilled Onion & Capsicum Nachos (Regular)",
                              "category": "Loaded Nachos",
                              "description": "Serves 1 | Nacho chips with all your favourite toppings packed separately, mix together and enjoy! Customize for you, just deselect any toppings you don't want.",
                              "imageId": "6bb4ac968209b54be71956613962c461",
                              "isVeg": 1,
                              "price": 26900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "59897919",
                                  "groupName": "Customize your Toppings",
                                  "choices": [
                                    {
                                      "id": "44148868",
                                      "name": "No Rice",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148869",
                                      "name": "No Black Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148870",
                                      "name": "No Pinto Beans",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148871",
                                      "name": "No Grilled Onion & Capsicum",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148872",
                                      "name": "No Corn Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148873",
                                      "name": "No Sour Cream",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148874",
                                      "name": "No Fresh Tomato and Onion Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148875",
                                      "name": "No Tomatillo Roasted Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148876",
                                      "name": "No Tomatillo Red Chili Salsa",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 9,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897934",
                                  "groupName": "Customize your Other Toppings",
                                  "choices": [
                                    {
                                      "id": "44148904",
                                      "name": "No Cheese",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148905",
                                      "name": "No Lettuce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897962",
                                  "groupName": "Add Extra Fillings",
                                  "choices": [
                                    {
                                      "id": "48178334",
                                      "name": "Extra Peri Peri Potato",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177843",
                                      "name": "Extra Crispy Mushroom",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177842",
                                      "name": "Extra BBQ Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178333",
                                      "name": "Extra Mexican Spicy Paneer",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178336",
                                      "name": "Extra Crispy Peri Peri Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178335",
                                      "name": "Extra BBQ Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178337",
                                      "name": "Extra Chili Chipotle Chicken",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897938",
                                  "groupName": "Make It Rich (Regular)",
                                  "choices": [
                                    {
                                      "id": "44148877",
                                      "name": "Guacamole",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148881",
                                      "name": "Crushed Corn Chips",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178316",
                                      "name": "Extra Sour Cream",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148882",
                                      "name": "Extra Chipotle Mayo",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60613768",
                                      "name": "Extra Southwest Sauce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148880",
                                      "name": "Melted Cheese Queso",
                                      "price": 4900,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "44148878",
                                      "name": "Mango Salsa",
                                      "price": 4000,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 7,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "59897953",
                                  "groupName": "Add Extra Toppings",
                                  "choices": [
                                    {
                                      "id": "48177841",
                                      "name": "Extra Jalapenos",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178321",
                                      "name": "Extra Cheese",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48177840",
                                      "name": "Extra Lettuce",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "48178322",
                                      "name": "Extra Corn Salsa",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "*New* Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129892172",
                              "name": "Tres Leches Cake",
                              "category": "*New* Desserts",
                              "description": "Serves 1 | A traditional Mexican dessert made with a light & airy sponge cake soaked in 3 different kinds of milk, topped with a dallop of whipped cream.",
                              "imageId": "8bc43fbed9ca082d04711e88fcaf21ac",
                              "price": 17500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129892173",
                              "name": "Double Coco Brownie (1 PC)",
                              "category": "*New* Desserts",
                              "description": "Serves 1 | A rich and chewy brownie loaded with dark chocolate with a crinkle top. This brownie is the ultimate sweet indulgence!",
                              "imageId": "4f76d5db6f89017c7dc87148d35da347",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129892174",
                              "name": "Churros (3 pcs)",
                              "category": "*New* Desserts",
                              "description": "Serves 1 | A crispy churro covered in cinnamon sugar on the outside and super fluffy on the inside. Served with a thick chocolate sauce!",
                              "imageId": "8531c58d89418620aa211fdb6b45bd58",
                              "isVeg": 1,
                              "price": 10900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11216331000529"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "California Burrito",
                      "area": "Malleshwaram",
                      "completeAddress": "3rd Floor, Mantri Square Mall, Malleshwaram, Bangalore - 560003"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "HAR8WWJwVNAW-z3NCCDnosZY-cFNQ5PiwwzRCyrU"
},
// 20240105233914
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=363507&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "363507",
              "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "kwality-walls-frozen-dessert-and-ice-cream-shop-shantinagar-shantinagar-2",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "bavma5ly3xyktmkgpi1c",
              "locality": "2nd Stage",
              "areaName": "Indiranagar",
              "costForTwo": "30000",
              "costForTwoMessage": "₹300 for two",
              "cuisines": [
                "Desserts",
                "Ice Cream"
              ],
              "avgRating": 4.6,
              "veg": true,
              "feeDetails": {
                "restaurantId": "363507",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 6700
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 6700,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (5.8 kms) | Additional delivery fee will apply"
              },
              "parentId": "582",
              "avgRatingString": "4.6",
              "totalRatingsString": "100+ ratings",
              "sla": {
                "restaurantId": "363507",
                "deliveryTime": 26,
                "minDeliveryTime": 26,
                "maxDeliveryTime": 26,
                "lastMileTravel": 5.8,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 2,
                "slaString": "26 MINS",
                "lastMileTravelString": "5.8 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 9 am, tomorrow",
                "nextOpenTime": "2024-01-06 09:00:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹150 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹349",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹349 | Use code FLAT150",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "kwality-walls-frozen-dessert-and-ice-cream-shop-shantinagar-shantinagar-2",
              "multiOutlet": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "SRI BALAJI VENTURES: NO 41/2, 14TH CROSS, 2ND STAGE, INDIRA NAGAR, SHANTHI NAGARA, BANGALORE, KARNATAKA-560038"
                },
                {
                  "title": "Cuisines",
                  "message": "Desserts,Ice Cream"
                }
              ],
              "totalRatings": 100,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹150 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹349",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹150 off on orders above ₹349 | Use code FLAT150",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 244,
                  "maxValue": 349,
                  "priority": 1,
                  "couponCode": "FLAT150",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 150
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹150 | Code FLAT150",
                  "unlockedMessage": "FLAT150 Coupon Unlocked! Use it to save ₹150",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/363507"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 9 am, tomorrow",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 9:00 AM tomorrow",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "nearestOutletNudge": {
                "nearestOutletInfo": {
                  "siblingOutlet": {
                    "id": "688449",
                    "city": "0",
                    "slugs": {
                      
                    },
                    "areaName": "Seshadripuram",
                    "costForTwo": "0",
                    "feeDetails": {
                      
                    },
                    "sla": {
                      "deliveryTime": 26,
                      "lastMileTravel": 4.9,
                      "slaString": "26 MINS",
                      "lastMileTravelString": "4.9 km",
                      "iconType": "ICON_TYPE_EMPTY"
                    },
                    "availability": {
                      "restaurantClosedMeta": {
                        
                      }
                    },
                    "aggregatedDiscountInfo": {
                      "visible": true
                    },
                    "badges": {
                      
                    },
                    "aggregatedDiscountInfoV2": {
                      "visible": true
                    },
                    "availabilityServiceabilityMessage": "Temporarily closed for delivery",
                    "cartOrderabilityNudgeBanner": {
                      "parameters": {
                        
                      },
                      "presentation": {
                        
                      }
                    }
                  }
                },
                "nearestOutletComms": {
                  "title": {
                    "text": "Don't worry! Try our outlet that's delivering"
                  },
                  "subTitle": {
                    "text": "Switch to the fastest alternate"
                  }
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.973046,77.63459",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "fc38a4d1-eb4b-46f3-957e-39cd6c61d902"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT150",
                      "description": "ABOVE ₹349",
                      "offerType": "offers",
                      "restId": "363507",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "363507",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "363507",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "363507",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹120 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "offerIds": [
                        "0681e750-4d60-4066-9e7d-be11d720f180"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE AXIS120",
                      "description": "ABOVE ₹500",
                      "offerType": "offers",
                      "restId": "363507",
                      "offerLogo": "rng/md/ads/production/32b9f8a87957f8c1ca369622f6a1ca77",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "isPureVeg": true,
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123846769",
                              "name": "Slow Churn Mango Ice Cream 500 ML",
                              "category": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                              "description": "An artisanal premium icecream made by slowly churning fresh milk cream and handpicked real Alphonso Mango fruit. A delight for dessert and natural fruit lovers. Kcal/Serving: 133",
                              "imageId": "684515f94f483c47afd81a4f978289d8",
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123846770",
                              "name": "Slow Churn Strawberry Ice Cream 500 ML",
                              "category": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                              "description": "Handpicked real Strawberry and fresh milk cream, slowly churned to give a creamy gourmet premium icecream. Best for those who love desserts and natural fruit. Kcal/Serving: 124",
                              "imageId": "7a59683eb50d83986496e3fa5c86a260",
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123846767",
                              "name": "Slow Churn Guava Ice Cream 500 ML",
                              "category": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                              "description": "Indulge in an artisanal premium icecream made by tenderly and slowly churning fresh milk cream and handpicked real Guava fruit. A delight for dessert and natural fruit lovers. Kcal/Serving: 129",
                              "imageId": "4a1ff9e32503bb232338ac2f6ee298d2",
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123846768",
                              "name": "Slow Churn Chikoo Ice Cream 500 ML",
                              "category": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                              "description": "Handpicked real sweet Chikoo fruit slow churned with fresh milk cream to give a creamy artisanal premium icecream. Best for those who love desserts and natural fruit. Kcal/Serving: 132",
                              "imageId": "f1bf429661e23952d4e6f33f22e7161a",
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123846765",
                              "name": "Slow Churn Jamun Ice Cream 500 ML",
                              "category": "Slow Churn Artisanal Ice Cream (Exciting New Flavors)",
                              "description": "Treat yourself or your family to this creamy gourmet premium icecream made by slowly churning real Jamun fruit and fresh milk cream. Best for those who love desserts and natural fruit. Kcal/Serving: 141",
                              "imageId": "ff21f118852a8b34f0d9a1ee2d74ae39",
                              "isVeg": 1,
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "New Launches",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103220",
                              "name": "Hazelnut Chocolate Ice Cream 500ml",
                              "category": "New Launches",
                              "description": "(500ml Tub) Ice Cream Crafted for Indulgence! Decadent Chocolate Ice Cream full of crunchy and roasted hazelnuts and rich chocolate.  A perfect indulgent treat. Kcal/Serving: 165",
                              "imageId": "c30a941f8010959f4901bee7b8b2317b",
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889382",
                              "name": "Choco Brownie Fudge Cup 100ml",
                              "category": "New Launches",
                              "description": "(100ml Cup) Rich Chocolate Cup Full Of Chunky Brownie Pieces And Chocolate Fudge. A ,cup That Will Make A Dark Chocolate Lover Rock N Roll. Kcal/Serving: 144",
                              "imageId": "4e89a700975407399950c4bba74922ed",
                              "isVeg": 1,
                              "price": 8000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889380",
                              "name": "Divine Chocolate Chocochip Cup 100ml",
                              "category": "New Launches",
                              "description": "(100ml Cup) A Real Chocolate Indulgence Made With Rich Cocoa. Loaded With Choco Chips & Rich Chocolate Sauce In Every Creamy Bite. Kcal/Serving: 133",
                              "imageId": "e71fce503542d98bfee7a16bd133b799",
                              "isVeg": 1,
                              "price": 8000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Premium Family Tubs",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103223",
                              "name": "Cadbury Crackle 700ml",
                              "category": "Premium Family Tubs",
                              "description": "(700ml Tub) A Cadbury lover's delight!\nCadbury Crackle chunks in a rich creamy chocolate tub with swirls of rich chocolate sauce. A perfect partner for celebrations! Kcal/Serving: 155",
                              "imageId": "90a4e49b01848470a12792efa43a6767",
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103222",
                              "name": "Choco Brownie Fudge 700ml",
                              "category": "Premium Family Tubs",
                              "description": "(700ml Tub) Rich chocolate tub  full of chunky brownie pieces and chocolate fudge.  \nA tub that will make a dark chocolate lover Rock N Roll. Kcal/Serving: 150",
                              "imageId": "fa387aa9b3aaaa8ae0cd907405a5d73b",
                              "isVeg": 1,
                              "price": 31900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103240",
                              "name": "Oreo & Cream 700ml",
                              "category": "Premium Family Tubs",
                              "description": "(700ml Tub) The Original Oreo Tub!\nCrunchy Oreo cookie chunks in rich creamy vanilla.  Kcal/Serving: 126",
                              "imageId": "6a60ed96e444ca2cdd4cb4e9bce8e315",
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103238",
                              "name": "Divine Chocolate Sensation 700ml",
                              "category": "Premium Family Tubs",
                              "description": "(700ml Tub) A real chocolate indulgence made with rich cocoa. Loaded with choco chips & rich chocolate sauce in every creamy scoop. Kcal/Serving: 126",
                              "imageId": "1bb7bbb6b1011b0a3f379e9be0526f57",
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103241",
                              "name": "Fruit & Nut 700ml",
                              "category": "Premium Family Tubs",
                              "description": "(700ml Tub) A dry fruit lover's paradise! Crunchy cashew nuts, almond and delicious raisins in every bite of creamy scoop. Kcal/Serving: 128",
                              "imageId": "c873ed6921f3dc15bf0e92f2ba46b219",
                              "isVeg": 1,
                              "price": 25900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Mithai Ice Cream",
                      "categories": [
                        {
                          "title": "Mithai Ice Cream",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123536094",
                                  "name": "Gulab Jamun Ice cream 500ml",
                                  "category": "Mithai Ice Cream",
                                  "description": "(500ml Tub) Indulgence of gulab jamun and the sweetness of icecream, best of both the worlds in one tub. Mithai bhi, icecream bhi. Kcal/Serving: 128",
                                  "imageId": "041d127a0b948caba84c8e96f2b6997c",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Classic Family Tubs",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103250",
                              "name": "Butterscotch 700ml",
                              "category": "Classic Family Tubs",
                              "description": "(700ml Tub) Creamy butterscotch tub loaded with chunks of caramel coated cashew nuts. Kcal/Serving: 126",
                              "imageId": "7d805045086796ecab2caf73a052ec0f",
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103247",
                              "name": "Alphonso Mango 700ml",
                              "category": "Classic Family Tubs",
                              "description": "(700ml Tub) Enjoy the delight of real  alphonso mango in a delicious creamy tub.  A fruit lover's ultimate delight! Kcal/Serving: 94",
                              "imageId": "213425b9eac4bec6e6d3c9170a5ce386",
                              "isVeg": 1,
                              "price": 18000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103226",
                              "name": "Vanilla 700ml",
                              "category": "Classic Family Tubs",
                              "description": "(700ml Tub) Rich creamy vanilla dessert thats more vanilla-tasting than any vanilla you have ever tasted in all of vanillas entirety. Kcal/Serving: 112",
                              "imageId": "e804df5ec4db781b6bbdca268da6d6a8",
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Magnum Ice Cream Sticks",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103224",
                              "name": "Magnum Almond  Ice Cream 80ml",
                              "category": "Magnum Ice Cream Sticks",
                              "description": "Expertly crafted icecream with Madagascar vanilla, crunchy Australian almonds and Belgian chocolate. Kcal/Serving: 223",
                              "imageId": "650d407befc8665b9fe71a8ad58fe2e0",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103229",
                              "name": "Magnum Brownie Icecream 80ml",
                              "category": "Magnum Ice Cream Sticks",
                              "description": "Expertly crafted icecream with brownie flavour, crunchy cashew and Belgian chocolate. Kcal/Serving: 224",
                              "imageId": "3a521841cbeb5251f27b25df2fd2042e",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103228",
                              "name": "Magnum Chocolate Truffle Ice Cream 80ml",
                              "category": "Magnum Ice Cream Sticks",
                              "description": "Rich chocolate icecream with truffle sauce wrapped in thick Belgian chocolate. Kcal/Serving: 182",
                              "imageId": "737d22db3969261f12cf3464821cbb22",
                              "isVeg": 1,
                              "price": 9900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cornetto Cone",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103233",
                              "name": "Cornetto Chokissimo 110ml",
                              "category": "Cornetto Cone",
                              "description": "(110ml) Disc as soft as a kiss!\nCrunchy waffle cone filled with creamy chocolate and brownie pieces with a soft chocolate disc and almond sprinkles on top. Kcal/Serving: 249",
                              "imageId": "4935a18cef8264f63f9e4e709760e980",
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103237",
                              "name": "Cornetto Oreo 110ml",
                              "category": "Cornetto Cone",
                              "description": "(110ml) Oreo cookie chunks in creamy vanilla, delicious chocolate disc and crunchy waffle cone.  An all time favourite for cone lovers! Kcal/Serving: 246",
                              "imageId": "2d665bfdf73e8abb87bcc2252d3d8482",
                              "isVeg": 1,
                              "price": 7000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103286",
                              "name": "Cornetto Butterscotch 105ml",
                              "category": "Cornetto Cone",
                              "description": "(105ml) Creamy butterscotch loaded with chunks of caramel cashew topping in a crunchy waffle cone. Kcal/Serving: 198",
                              "imageId": "2f25b3897c950594eda32c440147c0c1",
                              "isVeg": 1,
                              "price": 4500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103283",
                              "name": "Cornetto Double Chocolate 105ml",
                              "category": "Cornetto Cone",
                              "description": "(105ml) A yummilicious duo of milk and dark chocolate topped with chocolate sauce, chocochips in a crunchy waffle cone. Kcal/Serving: 184",
                              "imageId": "fc3e3ddb31a071ee0cac2d705d50f05f",
                              "isVeg": 1,
                              "price": 4000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "45 ratings",
                                  "ratingCountV2": "45"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Family Value Packs",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "114103309",
                              "name": "Chocolate 700ml",
                              "category": "Family Value Packs",
                              "description": "(700ml) Finest chocolate scoop made with rich cocoa. So rich & chocolatey that will make you go Choco Doodle Do. Kcal/Serving: 114",
                              "imageId": "5f77d8cf5ce521ab695e5653e42798d2",
                              "isVeg": 1,
                              "price": 15000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Value Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889363",
                              "name": "Cassatta [125ml x 2pcs]",
                              "category": "Value Combos",
                              "description": "Creamy rainbow trio between crunchy cashew nuts, tutti frutti and soft cake. Kcal/Serving: 157",
                              "imageId": "e6428eccd2cb0885efa9652d84ec3b1b",
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889365",
                              "name": "Cornetto Choco Vanilla [105ml x 4pcs]",
                              "category": "Value Combos",
                              "description": "(105ml) A yummilicious duo of rich and creamy vanilla  topped with chocolate sauce and chocochips in a crunchy waffle cone. Kcal/Serving: 177",
                              "imageId": "6fe33b2572dec595b51cf6e911e5017f",
                              "isVeg": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889364",
                              "name": "Black Forest Feast  - [70ml x 3pcs]",
                              "category": "Value Combos",
                              "description": "Black Forest cake meets Feast!\nCake pieces through layers of Feast with a solid chocolate surprise at the end. Kcal/Serving: 249",
                              "imageId": "907fb5ca628c112308a00c4141407db3",
                              "isVeg": 1,
                              "price": 13500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889375",
                              "name": "Aamras [60ml x 2pcs]",
                              "category": "Value Combos",
                              "description": "Aamras All Year Round!\nDelicious mango stick made with pulp of real alphonso mangoes. Kcal/Serving: 195",
                              "imageId": "64c8411c16c0586a847492ec93daffc3",
                              "isVeg": 1,
                              "price": 6000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121889378",
                              "name": "Vanilla Party Pack [700ml x 2pcs]",
                              "category": "Value Combos",
                              "description": "Rich creamy vanilla dessert thats more vanilla-tasting than any vanilla you have ever tasted in all of vanillas entirety. Kcal/Serving: 224",
                              "imageId": "94a61de6ae90919924296b4ba1abf115",
                              "isVeg": 1,
                              "price": 25000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11221333002305"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
                      "area": "Indiranagar",
                      "completeAddress": "SRI BALAJI VENTURES: NO 41/2, 14TH CROSS, 2ND STAGE, INDIRA NAGAR, SHANTHI NAGARA, BANGALORE, KARNATAKA-560038"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "ATtEdr3nki69-w7cW4gHr6SOp-f6nKEu4zVXBvx0"
},
// 20240105233954
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=29784&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "29784",
              "name": "CakeZone",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "cakeszone-indiranagar-indiranagar",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "e386a679bad57c2527925e5a22cd283a",
              "locality": "Hoysala Nagar",
              "areaName": "Indira Nagar",
              "costForTwo": "20000",
              "costForTwoMessage": "₹200 for two",
              "cuisines": [
                "Bakery",
                "Desserts"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "29784",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 7400
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 7400,
                "icon": "v1648208530/surgecreatives/info",
                "message": "Far (5 kms) | Additional delivery fee will apply"
              },
              "parentId": "7003",
              "avgRatingString": "4.4",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "29784",
                "deliveryTime": 26,
                "minDeliveryTime": 26,
                "maxDeliveryTime": 26,
                "lastMileTravel": 5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 2,
                "slaString": "26 MINS",
                "lastMileTravelString": "5.0 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-06 02:00:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹120 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "cakeszone-indiranagar-indiranagar",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "# 24, SECOND FLOOR, CMH ROAD, SECOND STAGE, HOYSALA NAGAR, INDIRA NAGAR, BENGALURU, Sarvagna Nagar , B.B.M.P East, Karnataka-560038"
                },
                {
                  "title": "Cuisines",
                  "message": "Bakery,Desserts"
                }
              ],
              "logo": "v1675409413/Brand logo/CakeZone",
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "header": "60% off",
                "shortDescriptionList": [
                  {
                    "meta": "60% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "60% off up to ₹120 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹125 off on orders above ₹299 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 209,
                  "maxValue": 299,
                  "priority": 2,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                },
                {
                  "minValue": 560,
                  "maxValue": 800,
                  "priority": 3,
                  "couponCode": "PARTY",
                  "discountInfo": {
                    "discountType": "Percentage",
                    "value": 20
                  },
                  "lockedMessage": "Add items worth ₹<amount> to unlock flat 20% off | Code PARTY",
                  "unlockedMessage": "PARTY Coupon Unlocked! Use it to save flat 20% off",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/29784"
              },
              "expectationNotifiers": [
                {
                  "text": "Far (5 kms) | Additional delivery fee will apply",
                  "icon": {
                    "imageId": "v1648208530/surgecreatives/info"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>Far (5 kms)</b> | Additional delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.978210,77.635299",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "60% OFF UPTO ₹120",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "e9b5011f-8c7f-40b4-bbf3-ba25e9381ad0"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹199",
                      "offerType": "offers",
                      "restId": "29784",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "0d844408-af93-4ea5-baa1-fb5aeb22e193"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹299",
                      "offerType": "offers",
                      "restId": "29784",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 20% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "c09352da-621e-4618-adca-793ed29f08ec"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹800",
                      "offerType": "offers",
                      "restId": "29784",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹150 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "9ddb5cab-2ddd-4e45-aa1b-55fecd757fdc"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT150",
                      "description": "ABOVE ₹599",
                      "offerType": "offers",
                      "restId": "29784",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "29784",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1600905",
                          "creativeId": "TopPicks/CTPC200",
                          "title": "Christmas Tree Plum Cake - 200 Gms",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "129104659",
                              "name": "Christmas Tree Plum Cake - 200 Gms",
                              "category": "Plum Cakes",
                              "description": "A Christmas celebration delight, gracefully mixing candied fruits, crunchy nuts like cashews, raisins and our inhouse spice mix, creating a rich, flavorful tree shaped cake.",
                              "imageId": "321e280b2e44b22f32802b18f1db669e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1601052",
                          "creativeId": "TopPicks/CJCake",
                          "title": "Chocolate Jar Cake",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "41910877",
                              "name": "Chocolate Jar Cake",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "Our chocolate cake in the form of our jar cake is something you and your adorable ones will absolutely like. This cute little chocolate jar cake will fill any celebration with sweet smiles, and the jar makes the cake even more appealing. (1 Serving, 423 calories, 4gms Protein, 44gms Carbs).",
                              "imageId": "qzjuwsgdc0fnehqeuzrg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "30638071",
                                    "name": "Select Jar",
                                    "variations": [
                                      {
                                        "name": "Mini Jar (200 ml)",
                                        "price": 139,
                                        "default": 1,
                                        "id": "95295667",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large Jar (375 ml)",
                                        "price": 219,
                                        "id": "95295668",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638071",
                                        "variationId": "95295667"
                                      }
                                    ],
                                    "price": 13900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638071",
                                        "variationId": "95295668"
                                      }
                                    ],
                                    "price": 21900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1601262",
                          "creativeId": "TopPicks/CTECake",
                          "title": "Chocolate Truffle Eggless Cake",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "49748058",
                              "name": "Chocolate Truffle Eggless Cake",
                              "category": "Celebration Cakes",
                              "description": "Serves 4 | [Eggless/Veg] This chocolate cake gives the richness of chocolate truffle layers. It has a silky texture and a rich, melt-in-your-mouth consistency that is simply irresistible. (6 Serving, 388 calories each, protein-5g each, carbs - 53g each)",
                              "imageId": "5aaa916ac77c127f5aee2eada1543071",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "6222740",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 539,
                                        "default": 1,
                                        "id": "20244890",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 889,
                                        "id": "20244891",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222740",
                                        "variationId": "20244890"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222740",
                                        "variationId": "20244891"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457084",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457086",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457082",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125267210",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "defaultPrice": 53900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1601545",
                          "creativeId": "TopPicks/FBChcake",
                          "title": "French Blueberry Cheesecake (500 Gms)",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "25497936",
                              "name": "French Blueberry Cheesecake (500 Gms)",
                              "category": "Cheesecakes",
                              "description": "This cheesecake is combination of creamy cheesecake, buttery crust, and vibrant blueberry filling flavor, all presented with a touch of French culinary elegance, creates a delicious dessert. (521 Calories, Protein-6g, Carbs-40g)",
                              "imageId": "bqqq1z41ohvnthhmiogw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 98900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Recommended",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117954949",
                              "name": "Belgium Chocolate Cake - 500 Grams",
                              "category": "Celebration Cakes",
                              "description": "Experience pure delight with every bite, made with soft chocolate sponge layered with Belgium chocolate ganache and cocoa powder dusted on top of the cake.  [ 6 serving, 2453 calories each, protein - 37 g each, carbs-397 g each]",
                              "imageId": "d59a19ab82bfe3b5be4c301103e1c2b1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 64900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109458362",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458363",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458361",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "127666792",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124091423",
                              "name": "Opulent Butterscotch Bliss Cake",
                              "category": "Celebration Cakes",
                              "description": "This cake is a delicious dessert that features the rich and distinct flavor of butterscotch. It's a type of cake that incorporates butterscotch flavor into various components, creating a delightful treat for those who enjoy the unique combination, best cake for celebrations.",
                              "imageId": "b483818364c637bc590bd42360c9b81a",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "31816365",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 Grams (Serves 4-6)",
                                        "price": 509,
                                        "default": 1,
                                        "id": "98398690",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 769,
                                        "id": "98398691",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "31816365",
                                        "variationId": "98398690"
                                      }
                                    ],
                                    "price": 50900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109458647",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109458647",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "31816365",
                                        "variationId": "98398691"
                                      }
                                    ],
                                    "price": 76900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109458647",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109458647",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109458651",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "127666855",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109458642",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109458647",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458651",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458642",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "127666855",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 50900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121456729",
                              "name": "Tiramisu Gateaux Cake - 500 Grams",
                              "category": "Celebration Cakes",
                              "description": "This Cake is a delicious dessert that combines the flavors of classic Tiramisu with the elegance of a Gateaux cake. It is an indulgent and delectable dessert that is sure to impress your guests or satisfy your sweet tooth. Enjoy!",
                              "imageId": "5db34309d3565f85e8736d42ec203a7f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 71900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109458370",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458372",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458369",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "127666760",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121456733",
                              "name": "Chocolate Praline Cake - 500 Grams",
                              "category": "Celebration Cakes",
                              "description": "This Cake is a decadent dessert that combines rich chocolate cake layers with a luscious praline filling and a delightful praline topping. It's sure to be a hit at any gathering or celebration.",
                              "imageId": "9f3644f61d61be2fe071250a3802185b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 69900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109458374",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458376",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458373",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "127666674",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117954947",
                              "name": "Chocolate Opium Cake - 500 Grams",
                              "category": "Celebration Cakes",
                              "description": "Light mousse-based cake, made by layering a dark chocolate sponge with creamy chocolate mousse and topped with chocolate curls. It's finished with white & dark chocolate plaques all around. [ 6 serving, 2439 k calories each,  protien  - 36 g each, carbs-397 g each]",
                              "imageId": "06c5b1fe465989ee89851a1648fbaac6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 59900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "109458341",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458342",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109458339",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "127666806",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "49748058",
                              "name": "Chocolate Truffle Eggless Cake",
                              "category": "Celebration Cakes",
                              "description": "Serves 4 | [Eggless/Veg] This chocolate cake gives the richness of chocolate truffle layers. It has a silky texture and a rich, melt-in-your-mouth consistency that is simply irresistible. (6 Serving, 388 calories each, protein-5g each, carbs - 53g each)",
                              "imageId": "5aaa916ac77c127f5aee2eada1543071",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "6222740",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 539,
                                        "default": 1,
                                        "id": "20244890",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 889,
                                        "id": "20244891",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222740",
                                        "variationId": "20244890"
                                      }
                                    ],
                                    "price": 53900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222740",
                                        "variationId": "20244891"
                                      }
                                    ],
                                    "price": 88900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457084",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457086",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267210",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457082",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457084",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457086",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457082",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125267210",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "defaultPrice": 53900,
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "354 ratings",
                                  "ratingCountV2": "354"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "49748059",
                              "name": "Death by Chocolate Eggless Cake",
                              "category": "Celebration Cakes",
                              "description": "[Eggless/Veg] This sinfully rich and moist cake is a celebration of chocolate in all its glory, promising an indulgent experience that will leave you craving more. It's a symphony of Choco chips with chocolate layers that takes the cake to new heights. (6 Serving, 243 calories each, protein-4g each, carbs-39g each)",
                              "imageId": "f7c98259deb49b6604ab609e1c26861d",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "33431291",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 699,
                                        "default": 1,
                                        "id": "103284680",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 1099,
                                        "id": "103284681",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33431291",
                                        "variationId": "103284680"
                                      }
                                    ],
                                    "price": 69900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "117339377",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "117339377",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "33431291",
                                        "variationId": "103284681"
                                      }
                                    ],
                                    "price": 109900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "117339377",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "117339377",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "117339378",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267214",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "117339376",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "117339377",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117339378",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "117339376",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125267214",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 69900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "91103821",
                              "name": "Mango Fruit Eggless Cake",
                              "category": "Celebration Cakes",
                              "description": "[Eggless/Veg] This cake is a perfect choice for mango enthusiasts, offering a vibrant and fruity experience. To enhance the mango experience, the cake topped with a light mango-flavored frosting. This frosting complements the mango-infused sponge and adds a touch of creaminess to the overall dessert. [ Vanilla Sponge + Mango filling + Mango Crush + Cream] (6 serving, 321 Calories each, protein-6g each, Carbs-56g each)",
                              "imageId": "d198cac3865703ffe44d1eb050e6ceb8",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "14856621",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 459,
                                        "default": 1,
                                        "id": "48227996",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 859,
                                        "id": "48227998",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14856621",
                                        "variationId": "48227996"
                                      }
                                    ],
                                    "price": 45900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457730",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457730",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "14856621",
                                        "variationId": "48227998"
                                      }
                                    ],
                                    "price": 85900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457730",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457730",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457733",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "107701558"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "109112734"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "108316004"
                                      },
                                      {
                                        "groupId": "125267208",
                                        "addonId": "109112735"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457728",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457730",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457733",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457728",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "125267208",
                                  "groupName": "Add On - Beverages & Nachos",
                                  "choices": [
                                    {
                                      "id": "107701558",
                                      "name": "Coke (750ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112734",
                                      "name": "Sugarcane (200ml)",
                                      "price": 7000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "108316004",
                                      "name": "Peri Peri Nacho Chips",
                                      "price": 8000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109112735",
                                      "name": "Ice Tea (200ml)",
                                      "price": 7900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 45900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "49748055",
                              "name": "Black Forest Eggless Cake",
                              "category": "Celebration Cakes",
                              "description": "Serves 4 | [ Eggless/Veg ] Several layers of chocolate cake, with cherry filling, with lashings of whipped cream between each layer. The cake is then decorated with cherries, and chocolate shavings. We stand by our promise, sweeter celebrations with CakeZone.  (6 Serving, 327 calories each, protein-5g each, carbs-56g each)",
                              "imageId": "8c3d07019e3fc02f90ae31ed972cecb1",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "6222736",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 519,
                                        "default": 1,
                                        "id": "20244882",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 829,
                                        "id": "20244883",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222736",
                                        "variationId": "20244882"
                                      }
                                    ],
                                    "price": 51900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457042",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457042",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "6222736",
                                        "variationId": "20244883"
                                      }
                                    ],
                                    "price": 82900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457042",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457042",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457043",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457040",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457042",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457043",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457040",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "defaultPrice": 51900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "278 ratings",
                                  "ratingCountV2": "278"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108776041",
                              "name": "Pack Of Two Choco Lava Cakes",
                              "category": "Pastries & Brownies",
                              "description": "It is a mouthwatering dessert that combines rich, velvety chocolate cake with a luscious molten chocolate center. These heavenly treats are perfect for satisfying your chocolate cravings and making any occasion extra special.",
                              "imageId": "e99ab462b28015604675a876366674a3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95047677",
                              "name": "Vanilla Pineapple Lunch Box Cake",
                              "category": "Bento & Mini Cakes",
                              "description": "Serves 1 | [Eggless]Bento Cakes are always the best for sweeter celebrations, try our special bento cake and mark the memories.(one bento cake, 644 calories, 11gms Proteins, 103gms carbs)",
                              "imageId": "owuyqijuwmtzske18esr",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "95047669",
                              "name": "Chocolate Truffle Lunch Box Cake",
                              "category": "Bento & Mini Cakes",
                              "description": "Serves 1 | [Eggless]Lunch box Bento Cakes are always the best for sweeter celebrations, try our special bento cake and mark the memories.(one bento cake, 1416 calories, 15gms Proteins, 185gms carbs)",
                              "imageId": "m35xxzbsepb9rkofrntb",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "41910877",
                              "name": "Chocolate Jar Cake",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "Our chocolate cake in the form of our jar cake is something you and your adorable ones will absolutely like. This cute little chocolate jar cake will fill any celebration with sweet smiles, and the jar makes the cake even more appealing. (1 Serving, 423 calories, 4gms Protein, 44gms Carbs).",
                              "imageId": "qzjuwsgdc0fnehqeuzrg",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "30638071",
                                    "name": "Select Jar",
                                    "variations": [
                                      {
                                        "name": "Mini Jar (200 ml)",
                                        "price": 139,
                                        "default": 1,
                                        "id": "95295667",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large Jar (375 ml)",
                                        "price": 219,
                                        "id": "95295668",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638071",
                                        "variationId": "95295667"
                                      }
                                    ],
                                    "price": 13900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638071",
                                        "variationId": "95295668"
                                      }
                                    ],
                                    "price": 21900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "847 ratings",
                                  "ratingCountV2": "847"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "41910920",
                              "name": "Pineapple Dessert Jar Cake",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "[Eggless]. The Pineapple Dessert Jar Cake promises a delightful combination of tropical flavors, textures, and visual appeal. Each layer contributes to a harmonious experience, allowing you to savor the sweet and refreshing taste of pineapple (1 Serving, 259 calories, 4gms Protein, 44gms Carbs).",
                              "imageId": "bv9rg96oskvgpc44s2tj",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "30638072",
                                    "name": "Select Jar",
                                    "variations": [
                                      {
                                        "name": "Mini Jar (200 ml)",
                                        "price": 139,
                                        "default": 1,
                                        "id": "95295669",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large Jar (375 ml)",
                                        "price": 209,
                                        "id": "95295670",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638072",
                                        "variationId": "95295669"
                                      }
                                    ],
                                    "price": 13900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30638072",
                                        "variationId": "95295670"
                                      }
                                    ],
                                    "price": 20900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 13900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "167 ratings",
                                  "ratingCountV2": "167"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59549078",
                              "name": "Gulab Jamun Red Velvet  Jar Cake",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "Serves 1 | [Eggless]. CakeZone's signature fusion cake, a blend of traditional Gulab Jamun and Western Dessert freshly made after you place your order. We stand by our promise, sweeter celebrations with CakeZone.(1 Serving, 520 calories, 6gms Protein, 68gms Carbs).",
                              "imageId": "spqdmixzqbijvfqk72x6",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "7887284",
                                    "name": "Select Jar",
                                    "variations": [
                                      {
                                        "name": "Mini Jar (200 ml)",
                                        "price": 179,
                                        "default": 1,
                                        "id": "48148376",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Large Jar (375 ml)",
                                        "price": 249,
                                        "id": "48148377",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887284",
                                        "variationId": "48148376"
                                      }
                                    ],
                                    "price": 17900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887284",
                                        "variationId": "48148377"
                                      }
                                    ],
                                    "price": 24900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 1"
                              },
                              "defaultPrice": 17900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "107 ratings",
                                  "ratingCountV2": "107"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33532314",
                              "name": "Red Velvet Cupcake & Chocolate Cupcake",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "[Eggless]. Happiness is only one cupcake away. So a combo of cupcakes also leads to a combo of happiness. Our cupcakes are a delight to all your five senses. (2 Serving, 258 calories each)",
                              "imageId": "ff81bda09f05ab7afc48d145dc170e61",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "387 ratings",
                                  "ratingCountV2": "387"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "103414684",
                              "name": "Indian Fusion Cupcakes - 4 Pc",
                              "category": "Jar Cakes & Cupcakes",
                              "description": "[Eggless].Cupcakes are always best, try our delicious Indian fusion cupcakes and celebrate the moments.",
                              "imageId": "tmvchlwtxcw0kr4xo7em",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "103414683",
                              "name": "Assorted Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "Cupcakes are always best to complete your day, try our delicious set of red velvet, chocolate and vanilla cupcakes and make your day special.",
                              "imageId": "rjmcdmuo1zfl9vwrzvqw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108954818",
                              "name": "Pack Of 2 Lunch Box Cakes",
                              "category": "Celebrations Combo",
                              "description": "Lunch Box Bento Cakes are always the best for sweeter celebrations, try our special red velvet and chocolate truffle bento cakes and mark the memories. (Each bento, 856 calories, 9gms Protein, 115gms carbs)",
                              "imageId": "b49cc478ae91a4dd75fbcb62441d2298",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "30187391",
                                    "name": "Select Cake",
                                    "variations": [
                                      {
                                        "name": "Vanilla Pineapple Lunch Box Cake - Pack of 2",
                                        "price": 449,
                                        "default": 1,
                                        "id": "94128645",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Red Velvet Lunch Box Cake - Pack of 2",
                                        "price": 499,
                                        "id": "94128646",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chocolate Truffle Lunch Box Cake - Pack of 2",
                                        "price": 469,
                                        "id": "94128647",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128645"
                                      }
                                    ],
                                    "price": 44900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128646"
                                      }
                                    ],
                                    "price": 49900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128647"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "28730918",
                              "name": "Red Velvet Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "[Eggless].Who will ignore this beautiful and delicious red velvet cupcakes, a day without cupcake is incomplete. Make your day special by our red velvet cupcakes (Pack of 6 Pieces) and celebrate the moments. (111 Calories each)",
                              "imageId": "zbof5owd2dykmqlecxya",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "showImage": true,
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "174 ratings",
                                  "ratingCountV2": "174"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ],
                      "type": "CATEGORY_TYPE_RECOMMENDED"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Celebration Cakes",
                      "categories": [
                        {
                          "title": "Gourmet Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117954949",
                                  "name": "Belgium Chocolate Cake - 500 Grams",
                                  "category": "Celebration Cakes",
                                  "description": "Experience pure delight with every bite, made with soft chocolate sponge layered with Belgium chocolate ganache and cocoa powder dusted on top of the cake.  [ 6 serving, 2453 calories each, protein - 37 g each, carbs-397 g each]",
                                  "imageId": "d59a19ab82bfe3b5be4c301103e1c2b1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 64900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458362",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458363",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458361",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666792",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "124091423",
                                  "name": "Opulent Butterscotch Bliss Cake",
                                  "category": "Celebration Cakes",
                                  "description": "This cake is a delicious dessert that features the rich and distinct flavor of butterscotch. It's a type of cake that incorporates butterscotch flavor into various components, creating a delightful treat for those who enjoy the unique combination, best cake for celebrations.",
                                  "imageId": "b483818364c637bc590bd42360c9b81a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31816365",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "98398690",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 769,
                                            "id": "98398691",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816365",
                                            "variationId": "98398690"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458647",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458647",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816365",
                                            "variationId": "98398691"
                                          }
                                        ],
                                        "price": 76900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458647",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458647",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458651",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666855",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458642",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458647",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458651",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458642",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666855",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128284784",
                                  "name": "Hazelnut Truffle Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Hazelnut cake offers a delectable combination of nuttiness, sweetness, moist, and tender texture, making it a popular dessert choice for those who enjoy the unique taste of hazelnuts. Savor the sweet moments with our delectable cake.",
                                  "imageId": "054b5fe9cdbce7b10bf420fc3610c7b6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34387116",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 599,
                                            "default": 1,
                                            "id": "106221010",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 929,
                                            "id": "106221011",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34387116",
                                            "variationId": "106221010"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "122969709",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "122969709",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34387116",
                                            "variationId": "106221011"
                                          }
                                        ],
                                        "price": 92900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "122969709",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "122969709",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "122969710",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666827",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "122969708",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "122969709",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "122969710",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "122969708",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666827",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 59900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127590217",
                                  "name": "Nutty Truffle Cake",
                                  "category": "Celebration Cakes",
                                  "description": "It is a delectable dessert that combines the rich flavors of chocolate and nuts to create a delightful and indulgent treat, offering a perfect balance of sweetness, creaminess, and nuttiness. This cake is sure to please those who appreciate the delightful combination of chocolate and nuts in a dessert.",
                                  "imageId": "4cb815d6443ed2b341d204c739a6ccf7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33994285",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 559,
                                            "default": 1,
                                            "id": "105027194",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 909,
                                            "id": "105027195",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33994285",
                                            "variationId": "105027194"
                                          }
                                        ],
                                        "price": 55900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121070622",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121070622",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33994285",
                                            "variationId": "105027195"
                                          }
                                        ],
                                        "price": 90900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121070622",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121070622",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121070623",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666687",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121070621",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121070622",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121070623",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121070621",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666687",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 55900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127783999",
                                  "name": "Dutch Chocolate Overload Cake",
                                  "category": "Celebration Cakes",
                                  "description": "This Cake is a luxurious and indulgent dessert that embodies the finest elements of Belgian confectionery. It combines high-quality ingredients, sophisticated flavors, and exquisite presentation to create a delectable and visually stunning masterpiece.",
                                  "imageId": "550c9e845b07aff1ce2d15972b0a89d9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34084754",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 779,
                                            "default": 1,
                                            "id": "105308973",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1419,
                                            "id": "105308974",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34084754",
                                            "variationId": "105308973"
                                          }
                                        ],
                                        "price": 77900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121445694",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121445694",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34084754",
                                            "variationId": "105308974"
                                          }
                                        ],
                                        "price": 141900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121445694",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121445694",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121445695",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666832",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121445693",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121445694",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121445695",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121445693",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666832",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 77900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "127783996",
                                  "name": "Chocolate Apricot Gateaux",
                                  "category": "Celebration Cakes",
                                  "description": "It is renowned for its decadence and rich chocolate flavor, making it a favorite among chocolate connoisseurs.  A premium Sachertorte Cake is the epitome of chocolate indulgence, and its exquisite balance of flavors makes it a truly luxurious treat that appeals to those with a discerning palate.",
                                  "imageId": "7b08af03ed37a552c5da63e2f80039a5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34084753",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 859,
                                            "default": 1,
                                            "id": "105308971",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1309,
                                            "id": "105308972",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34084753",
                                            "variationId": "105308971"
                                          }
                                        ],
                                        "price": 85900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121445691",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121445691",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34084753",
                                            "variationId": "105308972"
                                          }
                                        ],
                                        "price": 130900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "121445691",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "121445691",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "121445692",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666877",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "121445690",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "121445691",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121445692",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "121445690",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666877",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 85900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128911483",
                                  "name": "Toffee Gateaux Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Enjoy the delightful contrast of moist cake layers adorned with crunchy toffee bits, adding a satisfying crunch to every bite. Whether it's a birthday celebration, anniversary, or just a sweet indulgence, our toffee cake is the perfect centerpiece for any occasion.",
                                  "imageId": "f13b46f40b7b72e38652d43eac032c7d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34756510",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 579,
                                            "default": 1,
                                            "id": "107511456",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 799,
                                            "id": "107511457",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34756510",
                                            "variationId": "107511456"
                                          }
                                        ],
                                        "price": 57900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "124524354",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "124524354",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34756510",
                                            "variationId": "107511457"
                                          }
                                        ],
                                        "price": 79900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "124524354",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "124524354",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "124524355",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666676",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "124524353",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124524354",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524355",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524353",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666676",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 57900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128911484",
                                  "name": "Choco Caramel Crunch Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Indulge in a symphony of flavors with our Choco Caramel Crunch?a delectable fusion of rich chocolate, gooey caramel, and a satisfying crunch that will delight your taste buds. Each bite is a harmonious dance of textures and tastes, creating a moment of pure indulgence.",
                                  "imageId": "3e93c29fd2f341b45c3b139832df6136",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34756511",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 539,
                                            "default": 1,
                                            "id": "107511458",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 859,
                                            "id": "107511459",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34756511",
                                            "variationId": "107511458"
                                          }
                                        ],
                                        "price": 53900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "124524357",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "124524357",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "34756511",
                                            "variationId": "107511459"
                                          }
                                        ],
                                        "price": 85900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "124524357",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "124524357",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "124524358",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666680",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "124524356",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124524357",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524358",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524356",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666680",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 53900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121456729",
                                  "name": "Tiramisu Gateaux Cake - 500 Grams",
                                  "category": "Celebration Cakes",
                                  "description": "This Cake is a delicious dessert that combines the flavors of classic Tiramisu with the elegance of a Gateaux cake. It is an indulgent and delectable dessert that is sure to impress your guests or satisfy your sweet tooth. Enjoy!",
                                  "imageId": "5db34309d3565f85e8736d42ec203a7f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 71900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458370",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458372",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458369",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666760",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121456733",
                                  "name": "Chocolate Praline Cake - 500 Grams",
                                  "category": "Celebration Cakes",
                                  "description": "This Cake is a decadent dessert that combines rich chocolate cake layers with a luscious praline filling and a delightful praline topping. It's sure to be a hit at any gathering or celebration.",
                                  "imageId": "9f3644f61d61be2fe071250a3802185b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 69900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458374",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458376",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458373",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666674",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117954947",
                                  "name": "Chocolate Opium Cake - 500 Grams",
                                  "category": "Celebration Cakes",
                                  "description": "Light mousse-based cake, made by layering a dark chocolate sponge with creamy chocolate mousse and topped with chocolate curls. It's finished with white & dark chocolate plaques all around. [ 6 serving, 2439 k calories each,  protien  - 36 g each, carbs-397 g each]",
                                  "imageId": "06c5b1fe465989ee89851a1648fbaac6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 59900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458341",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458342",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458339",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666806",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Eggless Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748058",
                                  "name": "Chocolate Truffle Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [Eggless/Veg] This chocolate cake gives the richness of chocolate truffle layers. It has a silky texture and a rich, melt-in-your-mouth consistency that is simply irresistible. (6 Serving, 388 calories each, protein-5g each, carbs - 53g each)",
                                  "imageId": "5aaa916ac77c127f5aee2eada1543071",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222740",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 539,
                                            "default": 1,
                                            "id": "20244890",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 889,
                                            "id": "20244891",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222740",
                                            "variationId": "20244890"
                                          }
                                        ],
                                        "price": 53900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457084",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457084",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222740",
                                            "variationId": "20244891"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457084",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457084",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457086",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267210",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457082",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457084",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457086",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457082",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267210",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 53900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "354 ratings",
                                      "ratingCountV2": "354"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "124091422",
                                  "name": "Pineapple Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[Eggless/Veg] This Cake is a delightful dessert that combines the tropical sweetness of pineapples with a moist and flavorful vanilla cake base. It's a popular choice for those who enjoy a balance of sweet and tangy flavors and is perfect for warm-weather celebrations or any occasion where a touch of the tropics is desired.",
                                  "imageId": "c72893d31519b4ca45c55c3905ef76a1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31816364",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams ( Serves 4-6 )",
                                            "price": 469,
                                            "default": 1,
                                            "id": "98398688",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg ( Serves 9 - 10)",
                                            "price": 679,
                                            "id": "98398689",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816364",
                                            "variationId": "98398688"
                                          }
                                        ],
                                        "price": 46900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458626",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458626",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816364",
                                            "variationId": "98398689"
                                          }
                                        ],
                                        "price": 67900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458626",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458626",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458633",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267189",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458621",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458626",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458633",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458621",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267189",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 46900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748059",
                                  "name": "Death by Chocolate Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[Eggless/Veg] This sinfully rich and moist cake is a celebration of chocolate in all its glory, promising an indulgent experience that will leave you craving more. It's a symphony of Choco chips with chocolate layers that takes the cake to new heights. (6 Serving, 243 calories each, protein-4g each, carbs-39g each)",
                                  "imageId": "f7c98259deb49b6604ab609e1c26861d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33431291",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 699,
                                            "default": 1,
                                            "id": "103284680",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1099,
                                            "id": "103284681",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33431291",
                                            "variationId": "103284680"
                                          }
                                        ],
                                        "price": 69900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "117339377",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "117339377",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33431291",
                                            "variationId": "103284681"
                                          }
                                        ],
                                        "price": 109900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "117339377",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "117339377",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "117339378",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267214",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "117339376",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "117339377",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117339378",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117339376",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267214",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 69900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "39 ratings",
                                      "ratingCountV2": "39"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748068",
                                  "name": "Vanilla Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [Eggless/Veg] Savor the elegance of our vanilla cake, the layered vanilla sponge is infused with the warm and inviting essence of vanilla syrup, which gives it a delicate sweetness. (6 Serving, 209 calories each, protein-3g each, carbs-35g each)",
                                  "imageId": "8578742137daa199445116d3a9268f88",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222756",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 489,
                                            "default": 1,
                                            "id": "20244926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 849,
                                            "id": "20244927",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222756",
                                            "variationId": "20244926"
                                          }
                                        ],
                                        "price": 48900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457359",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457359",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222756",
                                            "variationId": "20244927"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457359",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457359",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457360",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267218",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457358",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457359",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457360",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457358",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267218",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 48900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "65 ratings",
                                      "ratingCountV2": "65"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803961",
                                  "name": "Mango Shrikhand Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[Eggless/Veg] This Cake is an ideal dessert for mango lovers and those seeking a unique twist on traditional cakes. It is perfect for special occasions, celebrations, or simply as a decadent treat to savor any time of the year. (6 serving,169 calories each, protein-3 grams each, carbs-33 grams each)",
                                  "imageId": "b78011caba3422087231c8174b888bcf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "27632190",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 619,
                                            "default": 1,
                                            "id": "87380561",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1219,
                                            "id": "87380562",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632190",
                                            "variationId": "87380561"
                                          }
                                        ],
                                        "price": 61900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458246",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458246",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632190",
                                            "variationId": "87380562"
                                          }
                                        ],
                                        "price": 121900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458246",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458246",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458248",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267185",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458243",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458246",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458248",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458243",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267185",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 61900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748063",
                                  "name": "Mango Gateaux Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [Eggless/Veg]. Immerse yourself in layers of moist and flavorful vanilla cake infused with the sweetness of mango crush, creating a symphony of tropical flavors, perfect cake for all celebrations. (6 serving, 119 calories each, protein-1g each, carbs-19g each)",
                                  "imageId": "03f5eb9dee0d9de050155cbb31750a89",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222749",
                                        "name": "Select Size",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "20244912",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 949,
                                            "id": "20244913",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222749",
                                            "variationId": "20244912"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457242",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457242",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222749",
                                            "variationId": "20244913"
                                          }
                                        ],
                                        "price": 94900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457242",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457242",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457244",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267175",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457237",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457242",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457244",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457237",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267175",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "59 ratings",
                                      "ratingCountV2": "59"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91103821",
                                  "name": "Mango Fruit Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[Eggless/Veg] This cake is a perfect choice for mango enthusiasts, offering a vibrant and fruity experience. To enhance the mango experience, the cake topped with a light mango-flavored frosting. This frosting complements the mango-infused sponge and adds a touch of creaminess to the overall dessert. [ Vanilla Sponge + Mango filling + Mango Crush + Cream] (6 serving, 321 Calories each, protein-6g each, Carbs-56g each)",
                                  "imageId": "d198cac3865703ffe44d1eb050e6ceb8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "14856621",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 459,
                                            "default": 1,
                                            "id": "48227996",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 859,
                                            "id": "48227998",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14856621",
                                            "variationId": "48227996"
                                          }
                                        ],
                                        "price": 45900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457730",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457730",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "14856621",
                                            "variationId": "48227998"
                                          }
                                        ],
                                        "price": 85900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457730",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457730",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457733",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267208",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457728",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457730",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457733",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457728",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267208",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 45900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "38 ratings",
                                      "ratingCountV2": "38"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748055",
                                  "name": "Black Forest Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [ Eggless/Veg ] Several layers of chocolate cake, with cherry filling, with lashings of whipped cream between each layer. The cake is then decorated with cherries, and chocolate shavings. We stand by our promise, sweeter celebrations with CakeZone.  (6 Serving, 327 calories each, protein-5g each, carbs-56g each)",
                                  "imageId": "8c3d07019e3fc02f90ae31ed972cecb1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222736",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 519,
                                            "default": 1,
                                            "id": "20244882",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 829,
                                            "id": "20244883",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222736",
                                            "variationId": "20244882"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457042",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457042",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222736",
                                            "variationId": "20244883"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457042",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457042",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457043",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457040",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457042",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457043",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457040",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 51900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "278 ratings",
                                      "ratingCountV2": "278"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66210578",
                                  "name": "Cute Teddy Butterscotch Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[ Eggless/Veg ] A Teddy Butterscotch Cake offers a delightful and playful experience to kids, combining the warmth of butterscotch with the whimsy of a teddy bear design. Perfect cake for birthdays, or any occasions. (6 Serving, 229 calories each, protein-1g each, carbs-42g each)",
                                  "imageId": "f0ead50d26ee4ff865283cecf3418430",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "9353362",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 589,
                                            "default": 1,
                                            "id": "30934546",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 949,
                                            "id": "30934547",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9353362",
                                            "variationId": "30934546"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457542",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457542",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9353362",
                                            "variationId": "30934547"
                                          }
                                        ],
                                        "price": 94900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457542",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457542",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457543",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457541",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457542",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457543",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457541",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 58900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123100089",
                                  "name": "Butterscotch Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "[Eggless/Veg] This cake is a delicious treat that features the rich and distinct flavor of butterscotch that incorporates butterscotch flavor into various components, creating a delightful dessert for those who enjoy the unique combination of buttery, caramelized, and slightly chocolate notes.",
                                  "imageId": "57db893236ac67da9b9080890386e92b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31324713",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 479,
                                            "default": 1,
                                            "id": "97068867",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 699,
                                            "id": "97068868",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31324713",
                                            "variationId": "97068867"
                                          }
                                        ],
                                        "price": 47900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458493",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458493",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31324713",
                                            "variationId": "97068868"
                                          }
                                        ],
                                        "price": 69900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458493",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458493",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458497",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458488",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458493",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458497",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458488",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 47900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748060",
                                  "name": "Fruit Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [ Eggless/Veg ]  Delight in the perfect blend of moist vanilla sponge layers, each infused with the essence of mango, blueberry crush offers burst of freshness in every bite. Elevate dessert experience with the perfect fusion of vanilla sweetness and natural goodness of fruits. (6 Serving, 126 calories each, protein-2g each, carbs-21g each)",
                                  "imageId": "283b386e67cd3cdfe0fab99d09a52b85",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222744",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 579,
                                            "default": 1,
                                            "id": "20244898",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 979,
                                            "id": "20244899",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222744",
                                            "variationId": "20244898"
                                          }
                                        ],
                                        "price": 57900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457158",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457158",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222744",
                                            "variationId": "20244899"
                                          }
                                        ],
                                        "price": 97900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457158",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457158",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457162",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457154",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457158",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457162",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457154",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 57900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "43 ratings",
                                      "ratingCountV2": "43"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "49748062",
                                  "name": "Layered Chocolate Truffle Eggless Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | [Eggless/Veg] This exquisite cake is a chocolate lover's dream, featuring layers of rich chocolate cake and luxurious chocolate truffle frosting. [ Chocolate Sponge + Truffle + Double Chocolate layering] (6 Serving, 388 calories each, protein-5g each, carbs - 53g each)",
                                  "imageId": "c415e0397e3716190bdad1cd79f3c3a1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "6222748",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 549,
                                            "default": 1,
                                            "id": "20244910",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 919,
                                            "id": "20244911",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222748",
                                            "variationId": "20244910"
                                          }
                                        ],
                                        "price": 54900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457210",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457210",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "6222748",
                                            "variationId": "20244911"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457210",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457210",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457212",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457205",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457210",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457212",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457205",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 54900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "187 ratings",
                                      "ratingCountV2": "187"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Egg Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33422598",
                                  "name": "Pineapple Cake",
                                  "category": "Celebration Cakes",
                                  "description": "This Cake is a delightful dessert that combines the tropical sweetness of pineapples with a moist and flavorful cake base. It's a popular choice for those who enjoy a balance of sweet and tangy flavors and is perfect for warm-weather celebrations or any occasion where a touch of the tropics is desired.",
                                  "imageId": "c72893d31519b4ca45c55c3905ef76a1",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31816363",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams ( Serves 4-6 )",
                                            "price": 459,
                                            "default": 1,
                                            "id": "98398686",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg ( Serves 9 - 10)",
                                            "price": 659,
                                            "id": "98398687",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816363",
                                            "variationId": "98398686"
                                          }
                                        ],
                                        "price": 45900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458609",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458609",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31816363",
                                            "variationId": "98398687"
                                          }
                                        ],
                                        "price": 65900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458609",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458609",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458612",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267182",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458606",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458609",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458612",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458606",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267182",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 45900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.0",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123100087",
                                  "name": "Butterscotch Cake",
                                  "category": "Celebration Cakes",
                                  "description": "This cake is a delicious dessert that features the rich and distinct flavor of butterscotch. It's a type of cake that incorporates butterscotch flavor into various components, creating a delightful treat for those who enjoy the unique combination of buttery, caramelized, and slightly chocolate notes.",
                                  "imageId": "57db893236ac67da9b9080890386e92b",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "31324711",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 469,
                                            "default": 1,
                                            "id": "97068863",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 679,
                                            "id": "97068864",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31324711",
                                            "variationId": "97068863"
                                          }
                                        ],
                                        "price": 46900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458483",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458483",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "31324711",
                                            "variationId": "97068864"
                                          }
                                        ],
                                        "price": 67900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458483",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458483",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458484",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267187",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458481",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458483",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458484",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458481",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267187",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.1",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104475401",
                                  "name": "Mango Fruit Cake",
                                  "category": "Celebration Cakes",
                                  "description": "This Cake is a delightful dessert that captures the vibrant and sweet essence of ripe mangoes in a cake form. It is a perfect choice for those who crave the luscious taste of mangoes in a unique and delectable treat. [Vanilla Sponge + Mango filling + Cream] (6 serving, 334 calories each, Protein-7g each, Carbs-56g each)",
                                  "imageId": "d198cac3865703ffe44d1eb050e6ceb8",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "22009227",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 449,
                                            "default": 1,
                                            "id": "72169041",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 859,
                                            "id": "72169042",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "22009227",
                                            "variationId": "72169041"
                                          }
                                        ],
                                        "price": 44900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457893",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457893",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "22009227",
                                            "variationId": "72169042"
                                          }
                                        ],
                                        "price": 85900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457893",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457893",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457897",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267213",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457891",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457893",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457897",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457891",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267213",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 44900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "37575886",
                                  "name": "Vanilla Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | This Cake is a timeless and versatile dessert that appeals to a wide range of tastes. Its simplicity and classic flavor make it a popular choice for various occasions. The base of the cake is a soft and moist vanilla sponge cake. The cake's delicate and comforting vanilla flavor is evoking a sense of warmth and nostalgia.[ Vanilla Sponge + Vanilla Cream] (6 Serving, 209 calories each, protein-3g each, Carbs-35g each)",
                                  "imageId": "8578742137daa199445116d3a9268f88",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3766692",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 479,
                                            "default": 1,
                                            "id": "12280479",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 829,
                                            "id": "12280492",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3766692",
                                            "variationId": "12280479"
                                          }
                                        ],
                                        "price": 47900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457347",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457347",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3766692",
                                            "variationId": "12280492"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457347",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457347",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457348",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267220",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457346",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457347",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457348",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457346",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267220",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 47900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "453 ratings",
                                      "ratingCountV2": "453"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33422597",
                                  "name": "Mango Gateaux Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | Mango, cake and cream - a combination to invokes your childhood nostalgia. We stand by our promise, sweeter celebrations with CakeZone. (6 Serving, 132 calories each, protein-3g each, carbs-19g each)",
                                  "imageId": "03f5eb9dee0d9de050155cbb31750a89",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3088005",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 499,
                                            "default": 1,
                                            "id": "10298888",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 919,
                                            "id": "10298889",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088005",
                                            "variationId": "10298888"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457225",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457225",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088005",
                                            "variationId": "10298889"
                                          }
                                        ],
                                        "price": 91900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457225",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457225",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457228",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267181",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457222",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457225",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457228",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457222",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267181",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 49900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "64 ratings",
                                      "ratingCountV2": "64"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33424899",
                                  "name": "Chocolate Truffle Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | This Cake is a luxurious and indulgent dessert that's a true delight for chocolate enthusiasts. It is known for its rich and intense chocolate flavor, velvety texture, and often features a decadent truffle-like ganache frosting.  This cake promises an unforgettable taste experience that's deeply indulgent and satisfying for any chocolate lover.[ Chocolate Sponge + Truffle + Chocolate layering] (6 Serving, 401 calories each, protein-7g each, carbs- 53g each)",
                                  "imageId": "5aaa916ac77c127f5aee2eada1543071",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3088569",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 529,
                                            "default": 1,
                                            "id": "10300054",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 869,
                                            "id": "10300055",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088569",
                                            "variationId": "10300054"
                                          }
                                        ],
                                        "price": 52900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457072",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457072",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088569",
                                            "variationId": "10300055"
                                          }
                                        ],
                                        "price": 86900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457072",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457072",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457073",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "125267194",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457069",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457072",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457073",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457069",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125267194",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 52900,
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "1433 ratings",
                                      "ratingCountV2": "1433"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33532417",
                                  "name": "Black Forest Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | Several layers of chocolate cake, with cherry filling, with lashings of whipped cream between each layer. The cake is then decorated with piped, whipped cream, maraschino cherries, and chocolate shavings. We stand by our promise, sweeter celebrations with CakeZone. [ Chocolate Sponge + Cherry + Chocolate Flakes] (6 Serving, 340 calories each, protein-6g each, carbs-56g each)",
                                  "imageId": "8c3d07019e3fc02f90ae31ed972cecb1",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3103877",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "10341054",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 809,
                                            "id": "10341055",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3103877",
                                            "variationId": "10341054"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457033",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457033",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3103877",
                                            "variationId": "10341055"
                                          }
                                        ],
                                        "price": 80900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457033",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457033",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457036",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457030",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457033",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457036",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457030",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "338 ratings",
                                      "ratingCountV2": "338"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33422594",
                                  "name": "Fruit Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | Fruits artisenally arranged on our freshly made cakes to offer you an unmatched taste. Don't compromise on your special occasions. [ Vanilla Sponge + Apple + Pineapple + cherry+ Cream ] (6 serving, 140 calories each, protein-3g each, carbs-21g each)",
                                  "imageId": "283b386e67cd3cdfe0fab99d09a52b85",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3088002",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 539,
                                            "default": 1,
                                            "id": "10298882",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 849,
                                            "id": "10298883",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088002",
                                            "variationId": "10298882"
                                          }
                                        ],
                                        "price": 53900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457107",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457107",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3088002",
                                            "variationId": "10298883"
                                          }
                                        ],
                                        "price": 84900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457107",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457107",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457109",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457106",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457107",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457109",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457106",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 53900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "333 ratings",
                                      "ratingCountV2": "333"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "40550323",
                                  "name": "Death by Chocolate Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Did you know Chocolate is powerfull anti oxidant? Imporoves Blood flow and lowers blood pressure. So why wait, try our premium chocolate cake. Made with freshly baked Chocolate sponge cake. [ Chocolate Sponge + Chocolate Chips + Truffle + Mousse Cream] (6 Serving, 256 calories each, protein-5g each, carbs-39g each)",
                                  "imageId": "f7c98259deb49b6604ab609e1c26861d",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "33431290",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 679,
                                            "default": 1,
                                            "id": "103284678",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "103284679",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33431290",
                                            "variationId": "103284678"
                                          }
                                        ],
                                        "price": 67900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "117339374",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "117339374",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "33431290",
                                            "variationId": "103284679"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "117339374",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "117339374",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "117339375",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "117339373",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "117339374",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117339375",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "117339373",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 67900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "148 ratings",
                                      "ratingCountV2": "148"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "36472787",
                                  "name": "Layered Chocolate Truffle Egg Cake",
                                  "category": "Celebration Cakes",
                                  "description": "Serves 4 | Let's face it, you can not resist our chocolate cake. Freshly made after the order is placed. Don't compromise on your special occasions. [ Chocolate Sponge + Truffle + Double Chocolate layering ] (6 Serving, 401 calories each, protein-7g each, carbs- 53g each)",
                                  "imageId": "c415e0397e3716190bdad1cd79f3c3a1",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "3568806",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 539,
                                            "default": 1,
                                            "id": "11769209",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 899,
                                            "id": "11769210",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3568806",
                                            "variationId": "11769209"
                                          }
                                        ],
                                        "price": 53900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457190",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457190",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "3568806",
                                            "variationId": "11769210"
                                          }
                                        ],
                                        "price": 89900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457190",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457190",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457193",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457185",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457190",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457193",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457185",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 53900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "785 ratings",
                                      "ratingCountV2": "785"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66210566",
                                  "name": "Cute Teddy Butterscotch Cake",
                                  "category": "Celebration Cakes",
                                  "description": "A Teddy Butterscotch Cake offers a delightful and playful experience to kids, combining the warmth of butterscotch with the whimsy of a teddy bear design. Perfect cake for birthdays, or any occasions. (6 Serving, 242 calories each, protein-3g each, carbs-42g each)",
                                  "imageId": "f0ead50d26ee4ff865283cecf3418430",
                                  "inStock": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "9353350",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 579,
                                            "default": 1,
                                            "id": "30934516",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 889,
                                            "id": "30934518",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9353350",
                                            "variationId": "30934516"
                                          }
                                        ],
                                        "price": 57900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457519",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457519",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9353350",
                                            "variationId": "30934518"
                                          }
                                        ],
                                        "price": 88900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457519",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457519",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457521",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457516",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457519",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457521",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457516",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 57900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "51 ratings",
                                      "ratingCountV2": "51"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Plum Cakes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129104658",
                              "name": "Christmas Classic Plum Cake - 450 Gms",
                              "category": "Plum Cakes",
                              "description": "A festive delight, blending candied fruits, crunchy nuts like cashews, raisins and our inhouse spice mix, creating a rich, flavorful, and moist cake, perfect for Christmas celebrations.",
                              "imageId": "4b397ae65c229552c38b04ec84d0a97c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 49900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129104657",
                              "name": "Christmas Plum Cake Loaf - 300 Gms",
                              "category": "Plum Cakes",
                              "description": "A moist loaf of the most popular Christmas indulgence loaded with nuts, tutti frutti, a hint of ginger, orange zest and dates. A delicacy you can’t resist this festive season.",
                              "imageId": "589bb4d5c6a2819a584fbe48000b3a74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129104659",
                              "name": "Christmas Tree Plum Cake - 200 Gms",
                              "category": "Plum Cakes",
                              "description": "A Christmas celebration delight, gracefully mixing candied fruits, crunchy nuts like cashews, raisins and our inhouse spice mix, creating a rich, flavorful tree shaped cake.",
                              "imageId": "321e280b2e44b22f32802b18f1db669e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "129104660",
                              "name": "Christmas Fruit Muffins",
                              "category": "Plum Cakes",
                              "description": "A delicious and portable treat prepared with candied fruits, nuts, a hint of ginger and raisin comes as a wholesome moist Christmas fruit muffins.",
                              "imageId": "585b89ec8ab63bbcedcaaa136bbba7bb",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "35330246",
                                    "name": "Select Quantity",
                                    "variations": [
                                      {
                                        "name": "Pack of 3",
                                        "price": 209,
                                        "default": 1,
                                        "id": "109353007",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Pack of 5",
                                        "price": 319,
                                        "id": "109353008",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35330246",
                                        "variationId": "109353007"
                                      }
                                    ],
                                    "price": 20900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "35330246",
                                        "variationId": "109353008"
                                      }
                                    ],
                                    "price": 31900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 20900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Mithai Cakes - Chef's Special",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51278790",
                              "name": "Gulab Jamun Vanilla Eggless Cake- Chef's Special",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "Serves 4 | [Eggless/Veg]. Our Indian fusion Gulab jamun cake - a blend of traditional Indian Gulab jamun sweet with vanilla cake which creates a dessert that is perfect for special occasions and celebration. (6 Serving, 258 Calories each, Protein- 4g each, Carbs-39g each)",
                              "imageId": "zaouvmudwkn6xfpvyl3g",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "7887279",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 649,
                                        "default": 1,
                                        "id": "36050955",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 1019,
                                        "id": "36050956",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887279",
                                        "variationId": "36050955"
                                      }
                                    ],
                                    "price": 64900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457387",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457387",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887279",
                                        "variationId": "36050956"
                                      }
                                    ],
                                    "price": 101900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457387",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457387",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457389",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457385",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457387",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457389",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457385",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "defaultPrice": 64900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "34 ratings",
                                  "ratingCountV2": "34"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "73368037",
                              "name": "Kaju Barfi Eggless Cake",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "[Eggless/Veg].CakeZone's signature Indian fusion cake - a blend of traditional Indian Kaju katli sweet and western dessert. Our very own Indian fusion cakes creation promises a rich and nutty experience that's perfect for special occasions and celebrations. (6 Serving, 227 Calories each, Protein-4g each, Carbs-32g each)",
                              "imageId": "grjzj13ykygwsgnigjef",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "10958036",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 639,
                                        "default": 1,
                                        "id": "36050776",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 999,
                                        "id": "36050778",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "10958036",
                                        "variationId": "36050776"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457545",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457545",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "10958036",
                                        "variationId": "36050778"
                                      }
                                    ],
                                    "price": 99900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457545",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457545",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457547",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457544",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457545",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457547",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457544",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 63900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "51278799",
                              "name": "Gulab Jamun Red Velvet Eggless Cake - Chef's Special",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "Serves 4 | [Eggless/Veg]. CakeZone's signature Indian fusion cake - a blend of traditional Indian Gulab jamun sweet and western dessert. Our very own Indian fusion cakes creation. [Red velvet sponge+ Cheese cream+ Gulab Jamun] ( 6 Serving , 821 Calories each, Protein-8g each, Carbs-124g). Best cake for festive occasions.",
                              "imageId": "nhabziqzr8b7el317e4x",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "7887280",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 949,
                                        "default": 1,
                                        "id": "36050959",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 1589,
                                        "id": "36050960",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887280",
                                        "variationId": "36050959"
                                      }
                                    ],
                                    "price": 94900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457398",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457398",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "7887280",
                                        "variationId": "36050960"
                                      }
                                    ],
                                    "price": 158900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457398",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457398",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457401",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457397",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457398",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457401",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457397",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG",
                                "portionSize": "Serves 4"
                              },
                              "defaultPrice": 94900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "20 ratings",
                                  "ratingCountV2": "20"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86972194",
                              "name": "Gulab Jamun Vanilla Cake - Chef's Special",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "CakeZone's signature Indian fusion Gulab jamun cake - a blend of traditional Indian Gulab jamun sweet and western dessert. Our very own Indian fusion cakes creation. [Vanilla Sponge + Gulab Jamun] ( 6 Serving, 901 Calories each, Protein-8g each, Carbs-129g)",
                              "imageId": "zaouvmudwkn6xfpvyl3g",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "13724570",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 639,
                                        "default": 1,
                                        "id": "44510650",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 999,
                                        "id": "44510652",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724570",
                                        "variationId": "44510650"
                                      }
                                    ],
                                    "price": 63900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457716",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457716",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724570",
                                        "variationId": "44510652"
                                      }
                                    ],
                                    "price": 99900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457716",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457716",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457717",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457715",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457716",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457717",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457715",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 63900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86972191",
                              "name": "Kaju Barfi Cake",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "CakeZone's signature Indian fusion cake - a blend of traditional Indian Kaju katli sweet and western dessert. Our very own Indian fusion cakes creation promises a rich and nutty experience that's perfect for special occasions and celebrations. (6 Serving, 307 Calories each, Protein-12g each, Carbs-37g each)",
                              "imageId": "grjzj13ykygwsgnigjef",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "13724567",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 619,
                                        "default": 1,
                                        "id": "44510641",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 959,
                                        "id": "44510643",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724567",
                                        "variationId": "44510641"
                                      }
                                    ],
                                    "price": 61900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457683",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457683",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724567",
                                        "variationId": "44510643"
                                      }
                                    ],
                                    "price": 95900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457683",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457683",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457684",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457680",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457683",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457684",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457680",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 61900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "86972193",
                              "name": "Gulab Jamun Red Velvet Cake - Chef's Special",
                              "category": "Mithai Cakes - Chef's Special",
                              "description": "CakeZone's signature Indian fusion cake - a blend of traditional indian Gulab jamun sweet and western dessert. Our very own Indian fusion cakes creation. [Red Velvet Sponge+ Gulab jamun] (6 Serving , 901 calories each, Protein-9g each, Carbs -129g each)",
                              "imageId": "nhabziqzr8b7el317e4x",
                              "inStock": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "13724569",
                                    "name": "Select Weight",
                                    "variations": [
                                      {
                                        "name": "500 gms (Serves 4-6)",
                                        "price": 879,
                                        "default": 1,
                                        "id": "44510647",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "1 Kg (Serves 9-10)",
                                        "price": 1589,
                                        "id": "44510649",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724569",
                                        "variationId": "44510647"
                                      }
                                    ],
                                    "price": 87900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457705",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457705",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "13724569",
                                        "variationId": "44510649"
                                      }
                                    ],
                                    "price": 158900,
                                    "addonCombinations": [
                                      {
                                        "groupId": "109457705",
                                        "addonId": "99062827"
                                      },
                                      {
                                        "groupId": "109457705",
                                        "addonId": "99062828"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062830"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "110015925"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062829"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062832"
                                      },
                                      {
                                        "groupId": "109457707",
                                        "addonId": "99062831"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "102289596"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062823"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062824"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062825"
                                      },
                                      {
                                        "groupId": "109457703",
                                        "addonId": "99062826"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "109457705",
                                  "groupName": "Add On - Greeting Cards",
                                  "choices": [
                                    {
                                      "id": "99062827",
                                      "name": "Happy Birthday Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062828",
                                      "name": "To My Better Half Greeting Card",
                                      "price": 4900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457707",
                                  "groupName": "Add On - Party Essentials",
                                  "choices": [
                                    {
                                      "id": "99062830",
                                      "name": "Snow Spray",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110015925",
                                      "name": "Ginger Cookies (5 Pc)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062829",
                                      "name": "Paper Popper",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062832",
                                      "name": "Pack of 10 Party Balloons",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062831",
                                      "name": "Pack of 6 Birthday Caps",
                                      "price": 8500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "109457703",
                                  "groupName": "Add On - Candles",
                                  "choices": [
                                    {
                                      "id": "102289596",
                                      "name": "Knife and Candle",
                                      "price": 100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062823",
                                      "name": "Happy Birthday Candle",
                                      "price": 17900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062824",
                                      "name": "Sparkle Candle",
                                      "price": 3500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062825",
                                      "name": "Magic Candle",
                                      "price": 6500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "99062826",
                                      "name": "Flower Candle",
                                      "price": 11900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 87900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Pastries & Brownies",
                      "categories": [
                        {
                          "title": "Pastries",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117954948",
                                  "name": "Belgium Chocolate Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Treat yourself to a slice of belgian perfection, made with soft chocolate sponge layered with Belgium chocolate ganache and cocoa powder dusted on top of the pastry. [ 1 Serving, 328 K Calories, Protein - 5 g, Carbs- 56g.]",
                                  "imageId": "5bbef925f846cbdfcb16bb5d722dcd58",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117954950",
                                  "name": "Chocolate Opium Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Soft chocolate sponge layered with mousse cream and chocolate square on top. [1 Serving, 384 K Calories, Protein - 6g, Carbs-60g.]",
                                  "imageId": "49ec9e5e84de1fd4263851adab7707f7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497982",
                                  "name": "Pineapple Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Pineapple on Pizza or not, its sits perfectly well on a pastry.  Perfect for a after meal dessert. This soft pastry is a slice of heaven.(1 Serving, 314 calories, 5gms Protein, 53gms Carbs).",
                                  "imageId": "oiz0matrhyu0k21xlbhc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "625 ratings",
                                      "ratingCountV2": "625"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "22358774",
                                  "name": "Black Forest Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Several layers of chocolate cake, with cherry filling, with lashings of whipped cream between each layer. The cake is then decorated with piped, whipped cream, maraschino cherries, and chocolate shavings.(1 Serving, 313 calories, 4gms Protein, 50gms Carbs).",
                                  "imageId": "krqzcuk2qi6xabl2klkg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "619 ratings",
                                      "ratingCountV2": "619"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497942",
                                  "name": "Butterscotch Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Nothing could be richer than pastry. Pastries are edible love. This soft pastry is a slice of heaven.(1 Serving, 509 calories, 5gms Protein, 98 gms Carbs).",
                                  "imageId": "o8ads9m4faogmpe3zwe4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "345 ratings",
                                      "ratingCountV2": "345"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497957",
                                  "name": "Chocolate Truffle Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "Can a pastry be any more chocolatey than Choco truffle? It is not easy to resist chocolate. This soft pastry is a slice of heaven. (1 Serving, 314 calories, 5gms Protein, 53gms Carbs).",
                                  "imageId": "aisk49audydoed6suehr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "1381 ratings",
                                      "ratingCountV2": "1381"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91701708",
                                  "name": "Gulab Jamun Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "The delicious cake will make you drool in your mouth with its delectable vanilla in between with yummy, delicious Gulab jamuns. (1 Serving, 339 calories, 4gms Protein, 66gms Carbs).",
                                  "imageId": "obcphz1b7qumgbuzn9yh",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "104333793",
                                  "name": "Vanilla Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "The Delicious vanilla that comes with a fine cake will make you drool.(1 Serving, 314 calories, 5gms Protein, 53gms Carbs).",
                                  "imageId": "kez7g8hk25rydaaftlzw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "207 ratings",
                                      "ratingCountV2": "207"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497962",
                                  "name": "Death By Chocolate Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "This pastry is a layer upon layers of chocolate and the ultimate chocolate dessert. Try this delicious pastry and celebrate the moments. (1 Serving, 291 calories, 4gms Protein, 47gms Carbs).",
                                  "imageId": "zocj4mci3iwhfsovxadc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "420 ratings",
                                      "ratingCountV2": "420"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497993",
                                  "name": "Red Velvet Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "A magic happens when Red Velvet cake and cream cheese come together. And we created this for you. We stand by our promise, sweeter celebrations with CakeZone.(1 Serving, 513 calories, 4gms Protein, 72gms Carbs).",
                                  "imageId": "d3ap7zawgsjh8tjo0oqk",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "442 ratings",
                                      "ratingCountV2": "442"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803964",
                                  "name": "Mango Shrikhand Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "This Pastry is a delightful dessert that combines the rich flavors of mango and the creamy goodness of shrikand, a popular Indian sweet yogurt dish. This delectable pastry is a perfect fusion of Western pastry techniques and traditional Indian flavors.(1 serving,311 calories,5gms protein,55gms carbs)",
                                  "imageId": "70ec3d069e9e89d4311e83529ee6533c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458305",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458306",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458304",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803966",
                                  "name": "Aam Ras Pastry",
                                  "category": "Pastries & Brownies",
                                  "description": "It is generously filled with the Aam Ras mixture, ensuring a burst of mango goodness in every bite. (1 serving,314 calories,5gms Protein,56gms carbs)",
                                  "imageId": "fbe7650545d2297fd85918a208950ef8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458311",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458312",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458310",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Brownies",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497974",
                                  "name": "Choco Truffle  Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. Bakers make the world smell better and our brownies definitely make your day better.  Brownies are the most loved and addictive dessert which are moist, soft in texture and gives magical taste. Enjoy every bite and mark your moments with our Choco truffle brownie and mark your moments. (1 Serving, 338 Calories, Protein-3g, Carbs-35g)",
                                  "imageId": "nikyr8cdfuardi242emf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "674 ratings",
                                      "ratingCountV2": "674"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126638609",
                                  "name": "Confetti Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "It is also known as funfetti brownies, are a delightful and whimsical twist on traditional brownies, featuring colorful sprinkles that add a festive touch to a classic chocolate base. They are known for their colorful and celebratory appearance, making them a perfect treat for birthdays, parties, or any joyful occasion.",
                                  "imageId": "71ca21ad686f1711f549272072637352",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126868287",
                                  "name": "Belgium Chocolate Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "These are the epitome of chocolate indulgence, celebrated for their exceptional quality chocolate, rich and fudgy texture, and deep chocolate flavor. These brownies are a must-try for anyone seeking a premium chocolate dessert experience.",
                                  "imageId": "ad5b3f3a0cbf36b1b1b86bff3a5f5c3f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91701714",
                                  "name": "Choco Lava Cake",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. Life is too short to say no to cake and Chocolate as you know is irresistible so indulge in our perfect creations for your sweet celebrations. (1 Serving, 308 Calories, protein-7g, Carbs-46g)",
                                  "imageId": "olunokg0d8ad7p00qyxg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101891940",
                                  "name": "Choco Chip Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. Brownies are the most loved and addictive dessert which are moist, soft in texture and gives you unique taste. Enjoy every bite and mark your moments. (1 Serving, 385 Calories, Protein - 4g, Carbs-46g)",
                                  "imageId": "56721c9c31d4fd1685359ab34a93d72c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101891938",
                                  "name": "Butterscotch Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless].Celebrate the moments with our delicious and simple butterscotch brownie. Brownies are the most loved and addictive dessert which are moist, soft in texture and gives you magical taste. Enjoy every bite and mark your moments. (1 Serving, 373 Calories each, protein-6g, Carbs-52g)",
                                  "imageId": "u0mujifowkbiw4qdk8ha",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "88156728",
                                  "name": "Red Velvet Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. Brownies are the most loved and addictive dessert which are moist, soft in texture and gives you unique taste. Enjoy every bite and mark your moments. (1 Serving, 287 calories, Protein-6g, Carbs-57g)",
                                  "imageId": "zsmcykrjdhspsnftsm0j",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108776041",
                                  "name": "Pack Of Two Choco Lava Cakes",
                                  "category": "Pastries & Brownies",
                                  "description": "It is a mouthwatering dessert that combines rich, velvety chocolate cake with a luscious molten chocolate center. These heavenly treats are perfect for satisfying your chocolate cravings and making any occasion extra special.",
                                  "imageId": "e99ab462b28015604675a876366674a3",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33480794",
                                  "name": "Choco Lava + Choco Truffle Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. There's nothing better than brownies. This unbeatable combination is perfect choice for small celebrations. (2 Serving, 323 calories each)",
                                  "imageId": "wkaf9pix6zmdldcuyeyv",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "172 ratings",
                                      "ratingCountV2": "172"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108776045",
                                  "name": "Choco Chip Brownie + Choco Lava Cake",
                                  "category": "Pastries & Brownies",
                                  "description": "[Eggless]. There's nothing better than brownies. This unbeatable combination is perfect choice for small celebrations. (2 Serving, 346 calories each, protein-7g each, carbs-40g each)",
                                  "imageId": "968e9608a8894541179ef4d0e972124a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108776042",
                                  "name": "Pack Of Four Choco Lava Cakes",
                                  "category": "Pastries & Brownies",
                                  "description": "Choco Lava Cake is a mouthwatering dessert that combines rich, velvety chocolate cake with a luscious molten chocolate center. These heavenly treats are perfect for satisfying your chocolate cravings and making any occasion extra special.",
                                  "imageId": "5d7d813890c5b257cd7f802c12896ec8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126638607",
                                  "name": "Millionaire Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "It is also known as millionaire's shortbread or caramel brownies, are a luxurious and indulgent dessert that combines layers of rich flavors and textures. These decadent treats are sure to satisfy your sweet cravings.",
                                  "imageId": "0414dc7f31f5800bf6bdf101cd82979b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "126638608",
                                  "name": "Crunchy Almond Brownie",
                                  "category": "Pastries & Brownies",
                                  "description": "It offers a delightful contrast of textures and flavors, combining the deep chocolate richness of brownies with the nutty crunch of toasted almonds. These brownies are a delightful treat for those who enjoy a harmonious blend of chocolate and nuts in their desserts.",
                                  "imageId": "6c05db803cd15a6a16f3ce3d1bcb919a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Bento & Mini Cakes",
                      "categories": [
                        {
                          "title": "Bento Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95047677",
                                  "name": "Vanilla Pineapple Lunch Box Cake",
                                  "category": "Bento & Mini Cakes",
                                  "description": "Serves 1 | [Eggless]Bento Cakes are always the best for sweeter celebrations, try our special bento cake and mark the memories.(one bento cake, 644 calories, 11gms Proteins, 103gms carbs)",
                                  "imageId": "owuyqijuwmtzske18esr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95047669",
                                  "name": "Chocolate Truffle Lunch Box Cake",
                                  "category": "Bento & Mini Cakes",
                                  "description": "Serves 1 | [Eggless]Lunch box Bento Cakes are always the best for sweeter celebrations, try our special bento cake and mark the memories.(one bento cake, 1416 calories, 15gms Proteins, 185gms carbs)",
                                  "imageId": "m35xxzbsepb9rkofrntb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95047676",
                                  "name": "Red Velvet Lunch Box Cake",
                                  "category": "Bento & Mini Cakes",
                                  "description": "Serves 1 | Lunch Box Bento Cakes are always the best for sweeter celebrations, try our special bento cake and mark the memories. (one bento cake, 856 calories, 9gms Protein, 115gms carbs)",
                                  "imageId": "ibhuw67aphp1r5hx9try",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Mini Cakes (300 Grams)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109472816",
                                  "name": "Death by Chocolate Mini Cake - 300 Gms",
                                  "category": "Bento & Mini Cakes",
                                  "description": "300gms. It's a dessert that offers an indulgence like no other, perfect for those moments when you're craving an unabashedly chocolatey treat. This mini cake is sure to leave a lasting impression and satisfy even the most insatiable chocolate cravings.(6 serving, 874 calories, 12gms protien, 141gms carbs)",
                                  "imageId": "f7c98259deb49b6604ab609e1c26861d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124524351",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524352",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124524350",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109472820",
                                  "name": "Mango Fruit Mini Cake - 300 Gms",
                                  "category": "Bento & Mini Cakes",
                                  "description": "300 Grams. This mini cake is a delightful treat that combines the sweetness of mangoes with the indulgence of a well-crafted cake.. We stand by our promise of delivering sweeter celebrations.(6 Serving, 1154 calories,20 gms protien, 203 carbs)",
                                  "imageId": "d198cac3865703ffe44d1eb050e6ceb8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457877",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457881",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457876",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109472818",
                                  "name": "Gulab Jamun Vanilla Mini Cake - 300 Gms",
                                  "category": "Bento & Mini Cakes",
                                  "description": "300gms. To further enhance the fusion of flavors, the cake might be adorned with a delicate drizzle of Gulab Jamun syrup, infusing the cake layers with extra moisture and depth of flavor. A sprinkling of chopped pistachios, almonds, or edible rose petals could serve as garnishes, adding a delightful crunch and visual appeal. (6 serving, 929 calories, 12gms Protien, 138gms carbs)",
                                  "imageId": "zaouvmudwkn6xfpvyl3g",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 44900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457607",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457609",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457605",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109472819",
                                  "name": "Gulab Jamun Red Velvet Mini Cake - 300 Gms",
                                  "category": "Bento & Mini Cakes",
                                  "description": "300gms. To enhance the fusion experience, the cake may be adorned with a drizzle of Gulab Jamun syrup, providing an extra touch of moisture and indulgence. Chopped pistachios, almonds, might be used as garnishes, adding both visual appeal and a delightful crunch.(6 serving, 886 calories, 9gms Protien, 135gms carbs)",
                                  "imageId": "nhabziqzr8b7el317e4x",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 65900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457615",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457617",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457613",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Jar Cakes & Cupcakes",
                      "categories": [
                        {
                          "title": "Jar Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "41910877",
                                  "name": "Chocolate Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "Our chocolate cake in the form of our jar cake is something you and your adorable ones will absolutely like. This cute little chocolate jar cake will fill any celebration with sweet smiles, and the jar makes the cake even more appealing. (1 Serving, 423 calories, 4gms Protein, 44gms Carbs).",
                                  "imageId": "qzjuwsgdc0fnehqeuzrg",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30638071",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 139,
                                            "default": 1,
                                            "id": "95295667",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 219,
                                            "id": "95295668",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638071",
                                            "variationId": "95295667"
                                          }
                                        ],
                                        "price": 13900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638071",
                                            "variationId": "95295668"
                                          }
                                        ],
                                        "price": 21900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "847 ratings",
                                      "ratingCountV2": "847"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "41910920",
                                  "name": "Pineapple Dessert Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. The Pineapple Dessert Jar Cake promises a delightful combination of tropical flavors, textures, and visual appeal. Each layer contributes to a harmonious experience, allowing you to savor the sweet and refreshing taste of pineapple (1 Serving, 259 calories, 4gms Protein, 44gms Carbs).",
                                  "imageId": "bv9rg96oskvgpc44s2tj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30638072",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 139,
                                            "default": 1,
                                            "id": "95295669",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 209,
                                            "id": "95295670",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638072",
                                            "variationId": "95295669"
                                          }
                                        ],
                                        "price": 13900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638072",
                                            "variationId": "95295670"
                                          }
                                        ],
                                        "price": 20900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "167 ratings",
                                      "ratingCountV2": "167"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "41920174",
                                  "name": "Red Velvet Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Our Red Velvet Jar Cake promises a decadent and indulgent experience. The combination of moist red velvet cake and additional layers create a harmonious blend of flavors and textures. (1 Serving, 513 calories, 4gms Protein, 72gms Carbs).",
                                  "imageId": "aqoe5r3qdbwihvnyqosf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "4557847",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 169,
                                            "default": 1,
                                            "id": "48148388",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 219,
                                            "id": "48148389",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "4557847",
                                            "variationId": "48148388"
                                          }
                                        ],
                                        "price": 16900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "4557847",
                                            "variationId": "48148389"
                                          }
                                        ],
                                        "price": 21900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 16900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "1624 ratings",
                                      "ratingCountV2": "1624"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91103823",
                                  "name": "Mango Fruit Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. The goodness of mango fruits and fresh cake combined in a jar offer you a perfect after-meal dessert in this summer season. All our products are made fresh and we stand by our promise of delivering sweeter celebrations.",
                                  "imageId": "n3dx6fmpyqoojnsa3ryq",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30638073",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 Ml)",
                                            "price": 139,
                                            "default": 1,
                                            "id": "95295671",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 Ml)",
                                            "price": 209,
                                            "id": "95295672",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638073",
                                            "variationId": "95295671"
                                          }
                                        ],
                                        "price": 13900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638073",
                                            "variationId": "95295672"
                                          }
                                        ],
                                        "price": 20900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "59549078",
                                  "name": "Gulab Jamun Red Velvet  Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "Serves 1 | [Eggless]. CakeZone's signature fusion cake, a blend of traditional Gulab Jamun and Western Dessert freshly made after you place your order. We stand by our promise, sweeter celebrations with CakeZone.(1 Serving, 520 calories, 6gms Protein, 68gms Carbs).",
                                  "imageId": "spqdmixzqbijvfqk72x6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "7887284",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 179,
                                            "default": 1,
                                            "id": "48148376",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 249,
                                            "id": "48148377",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887284",
                                            "variationId": "48148376"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887284",
                                            "variationId": "48148377"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "107 ratings",
                                      "ratingCountV2": "107"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "41920073",
                                  "name": "Butterscotch Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. This Butterscotch Jar Cake promises a luxurious experience with its buttery, caramelized flavors. Each layer works together to create a harmonious blend of sweetness and richness of butterscotch, providing a satisfying and indulgent dessert. (1 Serving, 282 calories, 4gms Protein, 98 gms Carbs).",
                                  "imageId": "iezrnryugb1yctu1dci6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30638067",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 129,
                                            "default": 1,
                                            "id": "95295659",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 219,
                                            "id": "95295661",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638067",
                                            "variationId": "95295659"
                                          }
                                        ],
                                        "price": 12900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30638067",
                                            "variationId": "95295661"
                                          }
                                        ],
                                        "price": 21900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 12900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "185 ratings",
                                      "ratingCountV2": "185"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25498008",
                                  "name": "Blueberry Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Blueberry combining with our delicious cakes in a jar to become your perfect dessert. We make it fresh after you place your order. Freshness of the cake stays longer with our unique jar cakes invention.(1 Serving, 303 calories, 4grams Protein, 57 grams Carbs).",
                                  "imageId": "rtd86grmqg0mtitcsst8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "2327523",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 139,
                                            "default": 1,
                                            "id": "48148367",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 259,
                                            "id": "48148368",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "2327523",
                                            "variationId": "48148367"
                                          }
                                        ],
                                        "price": 13900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "2327523",
                                            "variationId": "48148368"
                                          }
                                        ],
                                        "price": 25900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 13900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "373 ratings",
                                      "ratingCountV2": "373"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "51503091",
                                  "name": "Gulab Jamun Vanilla Dessert Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. CakeZone's Signature fusion jar cake, a blend of traditional Gulab Jamun and Western Dessert freshly made after you place your order. Freshness of the cake stays longer with our unique jar cakes invention.(1 Serving, 542 calories, 6 gms Protein, 106 gms Carbs).",
                                  "imageId": "qxj0gcz0c3vf5g1zmzet",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "7887283",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 179,
                                            "default": 1,
                                            "id": "48148378",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375 ml)",
                                            "price": 249,
                                            "id": "48148379",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887283",
                                            "variationId": "48148378"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887283",
                                            "variationId": "48148379"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "88 ratings",
                                      "ratingCountV2": "88"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803960",
                                  "name": "Aam Ras Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "A fusion dessert that combines the beloved flavors of Aam Ras (mango pulp) with the indulgence of a moist and fluffy cake. This delightful creation will take your taste buds on a journey of sweet and tangy bliss.(1 serving, 502 calories, 8gms protein, 90gms carbs)",
                                  "imageId": "7f5a7061d7f3f8fd30ea3cbe2863c417",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "27632189",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar Cake",
                                            "price": 209,
                                            "default": 1,
                                            "id": "87380559",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar Cake",
                                            "price": 299,
                                            "id": "87380560",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632189",
                                            "variationId": "87380559"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458230",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458230",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632189",
                                            "variationId": "87380560"
                                          }
                                        ],
                                        "price": 29900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458230",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458230",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458233",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458225",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458230",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458233",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458225",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "74461717",
                                  "name": "Kaju Barfi Jar Cake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. CakeZone's Signature Indian fusion cake- a blend of traditional kaju with wester dessert freshly made right after you place your order. Feeling low today? Gift yourself this amazing cake dessert which comes in a premium glass jar.(1 Serving, 402 calories, 10gms Protein, 64gms Carbs).",
                                  "imageId": "mhphfeuhf1de7x2e0bov",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "11201155",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar (200 ml)",
                                            "price": 179,
                                            "default": 1,
                                            "id": "48148369",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar (375ml)",
                                            "price": 249,
                                            "id": "48148370",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "11201155",
                                            "variationId": "48148369"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "11201155",
                                            "variationId": "48148370"
                                          }
                                        ],
                                        "price": 24900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cupcakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25498003",
                                  "name": "Vanilla Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "Serves 1 | [Eggless]. A cupcake a day, keeps the tummy rumbles away. We stand by our promise, of sweeter celebrations with CakeZone. (1 serving - 102 calories each, protein-1g, carbs- 7g)",
                                  "imageId": "oc96jvpx9r2tmainjvwl",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "397 ratings",
                                      "ratingCountV2": "397"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "22358773",
                                  "name": "Black Forest Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Cupcakes are always the best to complete your day, taste our delicious black forest cupcake and make your day special. (1 Serving, 180 Calories each)",
                                  "imageId": "iobxldfxthfzkweh4uo0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "142 ratings",
                                      "ratingCountV2": "142"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497937",
                                  "name": "Blueberry Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless].Cupcakes are always good to go on every occasion, try our cupcake and celebrate moments (1 Serving, 184 calories each, Protein-3g, Carbs-33g)",
                                  "imageId": "0c712cb2e353830a14d4722548f926f0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "125 ratings",
                                      "ratingCountV2": "125"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497997",
                                  "name": "Strawberry Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless].Try our delicious cupcake and celebrate moments. (1 Serving, 182 Calories each, Protein-3g, Carbs-33g)",
                                  "imageId": "4ce40a71651405082ed8477fa4eb2ed7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "102 ratings",
                                      "ratingCountV2": "102"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497958",
                                  "name": "Crunchy Butterscotch Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Happiness is only one cupcake away. Our cupcakes are a delight to all your five senses. (1 Serving, 185 calories each, protein-3g, carbs-33g)",
                                  "imageId": "uaphyk4kwndgjf20s9og",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "96 ratings",
                                      "ratingCountV2": "96"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33532314",
                                  "name": "Red Velvet Cupcake & Chocolate Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Happiness is only one cupcake away. So a combo of cupcakes also leads to a combo of happiness. Our cupcakes are a delight to all your five senses. (2 Serving, 258 calories each)",
                                  "imageId": "ff81bda09f05ab7afc48d145dc170e61",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "387 ratings",
                                      "ratingCountV2": "387"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112871315",
                                  "name": "Mango Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless] This cupcake is a delightful fusion of sweet and tropical flavors, combining the richness of mango puree with a moist cupcake base. They are not only delicious but also a visually stunning treat that captures the essence of the beloved mango fruit. (1 Serving, 182 calories each, Protein-3g, Carbs-32g)",
                                  "imageId": "e460c3195bf266353ea5b00bc11100ab",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 9900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497989",
                                  "name": "Red Velvet Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "Serves 1 | [Eggless]. Try our delicious cupcake and celebrate the moments. (1 Serving, 335 Calories, Protein-4g, Carbs-40g)",
                                  "imageId": "b790e27d6df16526681b78ee863b6c5c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "838 ratings",
                                      "ratingCountV2": "838"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "60962334",
                                  "name": "Gulab Jamun Vanilla Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. A cupcake a day, keeps the tummy rumbles away. Indulge in our signature Indian Fusion dessert which elegantly combines traditional Indian  Gulab Jamun with w western dessert. (1 Serving, 251 Calories each, Protein- 5g, Carbs- 40g)",
                                  "imageId": "ppajpjko235vexblbwlf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497947",
                                  "name": "Chocolate Cupcake",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "Serves 1 | [Eggless]. Our cupcakes are a delight to all your five senses. Chocolate in particular is irresistible. (1 Serving, 182 Calories each, protein-6g, Carbs- 28g)",
                                  "imageId": "b456qtgduwjmn9mlujed",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 7900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 1"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "1672 ratings",
                                      "ratingCountV2": "1672"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103414684",
                                  "name": "Indian Fusion Cupcakes - 4 Pc",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless].Cupcakes are always best, try our delicious Indian fusion cupcakes and celebrate the moments.",
                                  "imageId": "tmvchlwtxcw0kr4xo7em",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "87513313",
                                  "name": "Farewell Chocolate Cupcakes",
                                  "category": "Jar Cakes & Cupcakes",
                                  "description": "[Eggless]. Bidding adieu is not easy but our freshly prepared Farewell Chocolate Cupcakes may well be the sweetest way to say goodbyes.",
                                  "imageId": "rwgpi3tkjpkkok9tzw34",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Celebrations Combo",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59549073",
                              "name": "Choice Of Any Six Cupcakes",
                              "category": "Celebrations Combo",
                              "description": "[Eggless]. Happiness is only one cupcake away. So a combo of cupcakes also leads to combo of happiness. Our cupcakes are a delight to all your five senses.",
                              "imageId": "ppv0znabfe6fb3m5u7dp",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "64 ratings",
                                  "ratingCountV2": "64"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "103414683",
                              "name": "Assorted Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "Cupcakes are always best to complete your day, try our delicious set of red velvet, chocolate and vanilla cupcakes and make your day special.",
                              "imageId": "rjmcdmuo1zfl9vwrzvqw",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 44900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59549072",
                              "name": "Choice Of Any Four Cupcakes",
                              "category": "Celebrations Combo",
                              "description": "[Eggless]. Happiness is only one cupcake away. So a combo of cupcakes also leads to a combo of happiness. Our cupcakes are a delight to all your five senses.",
                              "imageId": "gjzugjdrk3by0abfahqe",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "20147578",
                                  "groupName": "Select Cupcakes",
                                  "choices": [
                                    {
                                      "id": "16882640",
                                      "name": "Black Forest Cupcake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "96281008",
                                      "name": "Butterscotch Cupcake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882636",
                                      "name": "Chocolate Cupcake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882637",
                                      "name": "Red Velvet Cupcake",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882639",
                                      "name": "Blueberry Cupcake",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882638",
                                      "name": "Strawberry Cupcake",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882635",
                                      "name": "Vanilla Cupcake",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 4,
                                  "maxFreeAddons": -1,
                                  "minAddons": 4
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "91 ratings",
                                  "ratingCountV2": "91"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "103414682",
                              "name": "Vanilla Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "Cupcakes are always the best dessert to complete your day, try our classy vanilla cupcake (pack of 6 pieces) and celebrate the moments. (102 calories each)",
                              "imageId": "owd745l54kzen0unfzym",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 37900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108954818",
                              "name": "Pack Of 2 Lunch Box Cakes",
                              "category": "Celebrations Combo",
                              "description": "Lunch Box Bento Cakes are always the best for sweeter celebrations, try our special red velvet and chocolate truffle bento cakes and mark the memories. (Each bento, 856 calories, 9gms Protein, 115gms carbs)",
                              "imageId": "b49cc478ae91a4dd75fbcb62441d2298",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "30187391",
                                    "name": "Select Cake",
                                    "variations": [
                                      {
                                        "name": "Vanilla Pineapple Lunch Box Cake - Pack of 2",
                                        "price": 449,
                                        "default": 1,
                                        "id": "94128645",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Red Velvet Lunch Box Cake - Pack of 2",
                                        "price": 499,
                                        "id": "94128646",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Chocolate Truffle Lunch Box Cake - Pack of 2",
                                        "price": 469,
                                        "id": "94128647",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128645"
                                      }
                                    ],
                                    "price": 44900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128646"
                                      }
                                    ],
                                    "price": 49900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "30187391",
                                        "variationId": "94128647"
                                      }
                                    ],
                                    "price": 46900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 44900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "30638736",
                              "name": "Chocolate Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "[Eggless]. Our cupcakes are a delight to all your five senses. Chocolate in particular is irresistible. (182 Calories each, protein-6g, Carbs- 28g each)",
                              "imageId": "k4ss0yo3busggm3jbgxg",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "149 ratings",
                                  "ratingCountV2": "149"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "28730918",
                              "name": "Red Velvet Cupcakes - 6 Pc",
                              "category": "Celebrations Combo",
                              "description": "[Eggless].Who will ignore this beautiful and delicious red velvet cupcakes, a day without cupcake is incomplete. Make your day special by our red velvet cupcakes (Pack of 6 Pieces) and celebrate the moments. (111 Calories each)",
                              "imageId": "zbof5owd2dykmqlecxya",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 40900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "174 ratings",
                                  "ratingCountV2": "174"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108776040",
                              "name": "Pack Of Any Two Pastries",
                              "category": "Celebrations Combo",
                              "description": "Pastries are edible love. More the pastries, more the love. Do feel our love for you and try out various of our freshly crafted pastries. (1 Serving, 314 calories, 5gms Protein, 53gms Carbs).",
                              "imageId": "34aeacbc5dde2cdea2e4487c1988ee21",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "75482725",
                                  "groupName": "Select Pastries",
                                  "choices": [
                                    {
                                      "id": "60447104",
                                      "name": "Black Forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447105",
                                      "name": "Butterscotch Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447106",
                                      "name": "Chocolate Truffle Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447107",
                                      "name": "Death By Chocolate Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447108",
                                      "name": "Pineapple Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447109",
                                      "name": "Red Velvet Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "60447110",
                                      "name": "White Forest Pastry",
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1,
                                  "minAddons": 2
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59549074",
                              "name": "Pack of any Three Pastries",
                              "category": "Celebrations Combo",
                              "description": "Pastries are edible love. More the pastries, more the love. Do feel our love for you and try out various of our freshly crafted pastries. (1 Serving each, 314 calories, 5gms Protein, 53gms Carbs).",
                              "imageId": "frcny9treqo56tcr9d4g",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "20147583",
                                  "groupName": "Select any 3 Pastries",
                                  "choices": [
                                    {
                                      "id": "16882668",
                                      "name": "Black Forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882670",
                                      "name": "Butterscotch Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882666",
                                      "name": "Chocolate Truffle Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882667",
                                      "name": "Death By Chocolate Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882669",
                                      "name": "Pineapple Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882665",
                                      "name": "Red Velvet Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 3,
                                  "maxFreeAddons": -1,
                                  "minAddons": 3
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59549075",
                              "name": "Pack of any Four Pastries",
                              "category": "Celebrations Combo",
                              "description": "Pastries are edible love. More the pastries, more the love. Do feel our love for you and try out various of our freshly crafted pastries. (1 Serving each, 314 calories, 5gms Protein, 53gms Carbs).",
                              "imageId": "uinezp5qlkrgiu0v11sv",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "20147584",
                                  "groupName": "Select 1st & 2nd Flavour",
                                  "choices": [
                                    {
                                      "id": "16882676",
                                      "name": "Black Forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882678",
                                      "name": "Butterscotch Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882674",
                                      "name": "Chocolate Truffle Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882675",
                                      "name": "Death By Chocolate Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882677",
                                      "name": "Pineapple Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882673",
                                      "name": "Red Velvet Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1,
                                  "minAddons": 2
                                },
                                {
                                  "groupId": "20147585",
                                  "groupName": "Select 3rd & 4th Flavour",
                                  "choices": [
                                    {
                                      "id": "16882681",
                                      "name": "Red Velvet Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882682",
                                      "name": "Chocolate Truffle Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882683",
                                      "name": "Death By Chocolate Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882684",
                                      "name": "Black Forest Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882685",
                                      "name": "Pineapple Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "16882686",
                                      "name": "Butterscotch Pastry",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1,
                                  "minAddons": 2
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113597356",
                              "name": "Choco Lava Cake And Red Velvet Cupcake",
                              "category": "Celebrations Combo",
                              "description": "Try our special combo this includes choco lava cake and red velvet cupcake which gives you unique experience in every bite and enjoy the moments.",
                              "imageId": "4a71cb3769e1befec629286a6072a74b",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113597355",
                              "name": "Choco Lava Cake And Vanilla Cupcake",
                              "category": "Celebrations Combo",
                              "description": "Try our special combo this includes choco lava cake and vanilla cupcake which gives you unique experience in every bite and enjoy the moments.",
                              "imageId": "1591233a5b78a07e7373957cee0b2997",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113597357",
                              "name": "Choco Lava Cake And Butterscotch Cupcake",
                              "category": "Celebrations Combo",
                              "description": "Try our special combo this includes choco lava cake and butterscotch cupcake which gives you unique experience in every bite and enjoy the moments.",
                              "imageId": "9019a6d4a3cf4e72759fe3acc8a3ea4f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113597358",
                              "name": "Choco Lava Cake And Pineapple Pastry",
                              "category": "Celebrations Combo",
                              "description": "Try our special combo this includes choco lava cake and pineapple pastry which gives you unique experience in every bite and enjoy the moments.",
                              "imageId": "05dd7b26ef235ea362d67e0660e779fa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "113597359",
                              "name": "Choco Lava Cake And Butterscotch Pastry",
                              "category": "Celebrations Combo",
                              "description": "Try our special combo this includes choco lava cake and butterscotch pastry which gives you unique experience in every bite and enjoy the moments.",
                              "imageId": "7c3031c216ab12fff5e78b1432e42bee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cheesecakes",
                      "categories": [
                        {
                          "title": "Cheesecake Slices",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "108776039",
                                  "name": "Plain Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gms. Nothing could be richer than a cheesecake.  Try our cheesecake to know it for yourself.",
                                  "imageId": "ea3710779f8f90b1b7e4127853068dee",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377875",
                                  "name": "Brownie Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gms. Nothing could be richer than a cheesecakes. Try our cheesecake and know it for yourself. (893 Calories, Protein-10g, Carbs-80g)",
                                  "imageId": "c5tikvaj3mmlr8nny36n",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "96387053",
                                  "name": "Strawberry Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gms. Nothing could be more richer than a Pastry. Pastries are edible love. Try our Strawberry cheesecake to know it for yourself. (567 Calories, Protein-6g, Carbs-53g)",
                                  "imageId": "hzzjxw19nvtjkmf76xnf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377878",
                                  "name": "Choco Mousse Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gms. Nothing could be more richer than a pastry. Pastries are edible love. Try our Choco Mousse cheesecake pastry to know it for yourself. (959 Calories, Protein-9g, Carbs-74g)",
                                  "imageId": "i8nn9jfdvibssk11vpos",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91743922",
                                  "name": "Mango Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gms. Nothing could be more fresh than a Pastry. Pastries are edible love. Try our Mango cheesecake to know it for yourself. (516 Calories, Protein-6g, Carbs-39g)",
                                  "imageId": "b5g5yvgx4jul4ih0cyy9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.7",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98829150",
                                  "name": "Red Velvet Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "120 gms. Nothing could be more richer than a Cheesecake Pastry. Pastries are edible love. Try our pastry to know it for yourself. (535 Calories, Protein-6g, Carbs-40g)",
                                  "imageId": "x012j9ekwdta3zecmjiw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98844254",
                                  "name": "French Blueberry Cheesecake Slice",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 120 gm. This slice is combination of creamy cheesecake, buttery crust, and vibrant blueberry filling flavor, all presented with a touch of French culinary elegance, creates a delicious dessert. (521 Calories, Protein-6g, Carbs-40g)",
                                  "imageId": "byoortdstqjlo9pzbxjf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "138 ratings",
                                      "ratingCountV2": "138"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cheesecake Jars",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91743921",
                                  "name": "Mango Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. Mini Jar (150 gm). Smooth, rich, fresh, and with a dense texture of cheesecake and mango appropriately constructed in a jar. Feeling low today? Gift yourself this amazing cake dessert which comes in a premium glass jar. (684 Calories, Protein-7g, Carbs-55g)",
                                  "imageId": "94c4a15ae27b303f86297985df138831",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.4",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377874",
                                  "name": "Brownie Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. Mini Jar (150 gm). Smooth, rich, fresh, and with a dense texture of cheesecake and brownie appropriately constructed in a jar. Feeling low today? Gift yourself this amazing cake dessert which comes in a premium glass jar. (1072 Calories, Protein-12g, Carbs-96g)",
                                  "imageId": "f2f5b808a01a678f4cd389f54e94de07",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "65174743",
                                  "name": "French Blueberry Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 150 gm. A Blueberry Cheesecake Jar offers a delightful fusion of creamy cheesecake and the bright, fruity notes of blueberries filling. Each layer contributes to a harmonious blend of textures and flavors. (689 Calories, Protein-7g, Carbs-56g)",
                                  "imageId": "414ddc6da4cc9faaab92cdd24b62379f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "93 ratings",
                                      "ratingCountV2": "93"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377877",
                                  "name": "Choco Mousse Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. Mini Jar (150 gm).Smooth, rich, fresh, and with a dense texture of cheesecake and Choco Mousse appropriately constructed in a jar. Feeling low today? Gift yourself this amazing cake dessert which comes in a premium glass jar. (1151 Calories, Protein-10g, Carbs-88g)",
                                  "imageId": "45bac1ff344b6b262cc9bcb7ca92e32f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98829149",
                                  "name": "Red Velvet Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "Mini Jar (150 gm).The smooth, rich, fresh, original sourness of cheese and with the dense texture of cheesecake and Red Velvet are appropriately constructed in a jar. Feeling low today? Gift yourself this amazing cake dessert which comes in a premium glass jar. (702 Calories, Protein-7g, Carbs-57g)",
                                  "imageId": "t8fkpe7q1hjbhtnkypkr",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "96387051",
                                  "name": "Strawberry Cheesecake Jar",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. Smooth, rich, fresh, and with a dense texture of cheesecake and Strawberry. appropriately constructed in a jar. Gift yourself this amazing cake dessert which comes in a premium glass jar.",
                                  "imageId": "zwkbztheblse1nofeavx",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803959",
                                  "name": "Mango Shrikand Cheese Jar Cake",
                                  "category": "Cheesecakes",
                                  "description": "Refreshing sweetness of ripe mangoes, creating a heavenly treat that will leave your taste buds craving for more.(1 serving, 933 calories,16 gms protein,165gms carbs)",
                                  "imageId": "888f1307a837c99301999da74b933fb8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "27632188",
                                        "name": "Select Jar",
                                        "variations": [
                                          {
                                            "name": "Mini Jar Cake",
                                            "price": 209,
                                            "default": 1,
                                            "id": "87380557",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Large Jar Cake",
                                            "price": 289,
                                            "id": "87380558",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632188",
                                            "variationId": "87380557"
                                          }
                                        ],
                                        "price": 20900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458215",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458215",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "27632188",
                                            "variationId": "87380558"
                                          }
                                        ],
                                        "price": 28900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458215",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458215",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458218",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458208",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458215",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458218",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458208",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 20900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cheesecakes [500 Gms]",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377873",
                                  "name": "Brownie Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 500 gms. Bite into our smooth, rich, fresh, and dense texture of cheesecake and Brownie . We stand by our promise, of sweeter celebrations with CakeZone. (4 Serving, 745 calories each, protein-9g each, carbs-67g each)",
                                  "imageId": "lh9667kwoflxhgoghfup",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 97900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "98829148",
                                  "name": "Red Velvet Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "500 gms. Bite into our Smooth, rich, fresh, original sourness of cheese and with a dense texture of cheesecake and Red Velvet .  We stand by our promise, of sweeter celebrations with CakeZone. ( 4 Serving, 702 calories each, protein-7g each, carbs-57g each)",
                                  "imageId": "uah0eafmktfhywvzqb3v",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 95900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "91743923",
                                  "name": "Mango Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "500 gms. Bite into our smooth, rich, fresh, and dense texture of cheesecake and Mango. We stand by our promise, of sweeter celebrations with CakeZone. ( 4 Serving, 516 calories each, protein-6g each, carbs-39g each)",
                                  "imageId": "loon9vsqtuctuqdf4m1y",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 96900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497936",
                                  "name": "French Blueberry Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "This cheesecake is combination of creamy cheesecake, buttery crust, and vibrant blueberry filling flavor, all presented with a touch of French culinary elegance, creates a delicious dessert. (521 Calories, Protein-6g, Carbs-40g)",
                                  "imageId": "bqqq1z41ohvnthhmiogw",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 98900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "25497995",
                                  "name": "Strawberry Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 500 gms. Bite into our smooth, rich, fresh, and dense texture of cheesecake and Strawberry . We stand by our promise, of sweeter celebrations with CakeZone. (4 Serving, 567 calories each, protein - 6g each, carbs-53g each)",
                                  "imageId": "o4uzsfl6f3cw9alm9zwz",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 97900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "14 ratings",
                                      "ratingCountV2": "14"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95377876",
                                  "name": "Choco Mousse Cheesecake (500 Gms)",
                                  "category": "Cheesecakes",
                                  "description": "[Eggless]. 500 gms. Bite into our smooth, rich, fresh, and dense texture of cheesecake and Choco Mousse . We stand by our promise, of sweeter celebrations with CakeZone. (4 Serving, 800 calories each, protein-6g each, carbs-61g each)",
                                  "imageId": "gwjufklqnougriu732ld",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 97900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Tea Cakes",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124822203",
                              "name": "Marble Tea Cake",
                              "category": "Tea Cakes",
                              "description": "This cake is loved for its contrast of flavors and textures, with the vanilla providing a sweet and buttery base while the chocolate adds a rich and delicious taste to the cake. It's a perfect accompaniment to a cup of tea or coffee.",
                              "imageId": "3a6f7427926fcab71da4785c1581aebc",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32606528",
                                    "name": "Select Quantity",
                                    "variations": [
                                      {
                                        "name": "400 Grams",
                                        "price": 279,
                                        "id": "101160862",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "180 Grams",
                                        "price": 159,
                                        "default": 1,
                                        "id": "101160863",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606528",
                                        "variationId": "101160862"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606528",
                                        "variationId": "101160863"
                                      }
                                    ],
                                    "price": 15900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 15900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124822205",
                              "name": "Date and Raisin Tea Cake",
                              "category": "Tea Cakes",
                              "description": "This Cake is a delightful and flavorful dessert that incorporates the natural sweetness and chewy texture of dates and raisins into a moist and tender cake. It's an excellent choice for enjoying with a cup of tea or coffee and is known for its rich, fruity taste.",
                              "imageId": "a198b250c1b4d2bf3caae99fcdbee409",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32606530",
                                    "name": "Select Quantity",
                                    "variations": [
                                      {
                                        "name": "400 Grams",
                                        "price": 299,
                                        "id": "101160866",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "180 Grams",
                                        "price": 169,
                                        "default": 1,
                                        "id": "101160867",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606530",
                                        "variationId": "101160866"
                                      }
                                    ],
                                    "price": 29900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606530",
                                        "variationId": "101160867"
                                      }
                                    ],
                                    "price": 16900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 16900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124822204",
                              "name": "Orange Tea Cake",
                              "category": "Tea Cakes",
                              "description": "A soft and delicious cake flavored with orange and stubbed with tutti Frutti, this tea cake is just perfect with tea or coffee.",
                              "imageId": "e2058275f0c60891089262c23b19ccce",
                              "inStock": 1,
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "32606529",
                                    "name": "Select Quantity",
                                    "variations": [
                                      {
                                        "name": "400 Grams",
                                        "price": 279,
                                        "id": "101160864",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "180 Grams",
                                        "price": 149,
                                        "default": 1,
                                        "id": "101160865",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606529",
                                        "variationId": "101160864"
                                      }
                                    ],
                                    "price": 27900
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "32606529",
                                        "variationId": "101160865"
                                      }
                                    ],
                                    "price": 14900
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 14900,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sweets",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124594812",
                              "name": "Gulab Jamun",
                              "category": "Sweets",
                              "description": "Authentic traditional gulab jamun made with khoya and sweetened with jaggery.\nAllergen information: Dairy, gluten",
                              "imageId": "159adcea6271e9ef2574236d57e33600",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "127518414",
                              "name": "Signature Mithai Assortment - 1 Kg",
                              "category": "Sweets",
                              "description": "Indulge in a symphony of flavors with our irresistible assorted sweets! Discover a world of taste in every bite, as you savor the perfect blend of nutty, delicious and cashew goodness. These assorted sweets are Panjiri laddu-250 Gms, kaju katli - 250 Gms, Coconut Barfi -250 Gms and Dry Fruit Barfi-250 Gms.",
                              "imageId": "9a4924425167630cf332df437526bc5f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 119900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123845635",
                              "name": "Badam Kheer",
                              "category": "Sweets",
                              "description": "Creamy rich and delicious keer with skimmed milk, rice, sweetened with jaggery and topped with roasted almonds. [Skim Milk, Rice, Jaggery, Roasted Almonds] Allergen information: Dairy, nuts",
                              "imageId": "70590af5ad422f11054c344fc36e0e2f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7900,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Anniversary & Birthday Cakes",
                      "categories": [
                        {
                          "title": "Anniversary Special Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "65657482",
                                  "name": "Happy Anniversary Fondant Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Celebrate your special anniversary with our Fondant Cake a masterpiece that combines the rich warmth of flavors which you choose with the elegance of fondant design, a delightful blend of flavor and artistry that will make your moments memorable. (6 Serving, 912calories, 18 gms Protein, 176gms Carbs).",
                                  "imageId": "b406bcb9205e9c78b8d4e45eee0e49b1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "25635286",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "81312704",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635287",
                                              "variationId": "81312709"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "81312705",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635287",
                                              "variationId": "81312711"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "81312706",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635287",
                                              "variationId": "81312713"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "81312707",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635287",
                                              "variationId": "81312715"
                                            }
                                          },
                                          {
                                            "name": "Chocolate",
                                            "id": "81312708",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635287",
                                              "variationId": "81312717"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "25635287",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "81312709",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 519,
                                            "id": "81312711",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 819,
                                            "id": "81312713",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 599,
                                            "id": "81312715",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 589,
                                            "id": "81312717",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 829,
                                            "id": "81312710",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 879,
                                            "id": "81312712",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1149,
                                            "id": "81312714",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 809,
                                            "id": "81312716",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10) yugs",
                                            "price": 909,
                                            "id": "81312718",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312704"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312709"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312704"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312710"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312705"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312711"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312705"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312712"
                                          }
                                        ],
                                        "price": 87900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312706"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312713"
                                          }
                                        ],
                                        "price": 81900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312706"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312714"
                                          }
                                        ],
                                        "price": 114900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312707"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312715"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312707"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312716"
                                          }
                                        ],
                                        "price": 80900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312708"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312717"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635286",
                                            "variationId": "81312708"
                                          },
                                          {
                                            "groupId": "25635287",
                                            "variationId": "81312718"
                                          }
                                        ],
                                        "price": 90900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457529",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457531",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666797",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457527",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457529",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457531",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457527",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666797",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "31 ratings",
                                      "ratingCountV2": "31"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112871314",
                                  "name": "Kiss of Love Romantic Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Celebrate your special anniversary with our Fondant Cake a masterpiece that combines the rich warmth of flavors which you choose with the elegance of fondant design, a delightful blend of flavor and artistry that will make your moments memorable. (6 Serving, 912calories, 18 gms Protein, 176gms Carbs).",
                                  "imageId": "e35e68f0b435385c0edbeec49f22b52f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "25635282",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "81312674",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635283",
                                              "variationId": "81312679"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "81312675",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635283",
                                              "variationId": "81312681"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "81312676",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635283",
                                              "variationId": "81312683"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "81312677",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635283",
                                              "variationId": "81312685"
                                            }
                                          },
                                          {
                                            "name": "Chocolate",
                                            "id": "81312678",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635283",
                                              "variationId": "81312687"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "25635283",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "81312679",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 519,
                                            "id": "81312681",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 819,
                                            "id": "81312683",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 599,
                                            "id": "81312685",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 589,
                                            "id": "81312687",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 829,
                                            "id": "81312680",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 879,
                                            "id": "81312682",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1149,
                                            "id": "81312684",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 809,
                                            "id": "81312686",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10) yugs",
                                            "price": 909,
                                            "id": "81312688",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312674"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312679"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312674"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312680"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312675"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312681"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312675"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312682"
                                          }
                                        ],
                                        "price": 87900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312676"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312683"
                                          }
                                        ],
                                        "price": 81900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312676"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312684"
                                          }
                                        ],
                                        "price": 114900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312677"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312685"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312677"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312686"
                                          }
                                        ],
                                        "price": 80900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312678"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312687"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635282",
                                            "variationId": "81312678"
                                          },
                                          {
                                            "groupId": "25635283",
                                            "variationId": "81312688"
                                          }
                                        ],
                                        "price": 90900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457924",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457925",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666733",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457923",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457924",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457925",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457923",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666733",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66099929",
                                  "name": "Be My Love Fondant Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Celebrate your special anniversary with our Fondant Cake a masterpiece that combines the rich warmth of flavors which you choose with the elegance of fondant design, a delightful blend of flavor and artistry that will make your moments memorable. (6 Serving, 912 calories, 18 gms Protein, 176gms Carbs).",
                                  "imageId": "f49f2a32ff4192fd911c5dd8e9723708",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "25635284",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "81312689",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635285",
                                              "variationId": "81312694"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "81312690",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635285",
                                              "variationId": "81312696"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "81312691",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635285",
                                              "variationId": "81312698"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "81312692",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635285",
                                              "variationId": "81312700"
                                            }
                                          },
                                          {
                                            "name": "Chocolate",
                                            "id": "81312693",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "25635285",
                                              "variationId": "81312702"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "25635285",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 509,
                                            "default": 1,
                                            "id": "81312694",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 519,
                                            "id": "81312696",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 819,
                                            "id": "81312698",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 599,
                                            "id": "81312700",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 589,
                                            "id": "81312702",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 829,
                                            "id": "81312695",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 879,
                                            "id": "81312697",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1149,
                                            "id": "81312699",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 809,
                                            "id": "81312701",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10) yugs",
                                            "price": 909,
                                            "id": "81312703",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312689"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312694"
                                          }
                                        ],
                                        "price": 50900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312689"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312695"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312690"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312696"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312690"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312697"
                                          }
                                        ],
                                        "price": 87900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312691"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312698"
                                          }
                                        ],
                                        "price": 81900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312691"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312699"
                                          }
                                        ],
                                        "price": 114900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312692"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312700"
                                          }
                                        ],
                                        "price": 59900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312692"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312701"
                                          }
                                        ],
                                        "price": 80900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312693"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312702"
                                          }
                                        ],
                                        "price": 58900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "25635284",
                                            "variationId": "81312693"
                                          },
                                          {
                                            "groupId": "25635285",
                                            "variationId": "81312703"
                                          }
                                        ],
                                        "price": 90900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457512",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457513",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666890",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457510",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457512",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457513",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457510",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666890",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 50900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "66099913",
                                  "name": "Heart Shape Choco Twin Hearts Truffle Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Serves 4 | This chocolate cake gives the richness of chocolate truffle layers in heart shape. It has a silky texture and a rich, melt-in-your-mouth consistency that is simply irresistible. Perfect cake for all celebrations. (6 Serving, 2328 calories, 31gms Protein, 319gms Carbs).",
                                  "imageId": "76c9eaf6cafec7ad5318d1f60e7a2667",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "9334274",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 639,
                                            "default": 1,
                                            "id": "37935255",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "37935256",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9334274",
                                            "variationId": "37935255"
                                          }
                                        ],
                                        "price": 63900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457455",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457455",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9334274",
                                            "variationId": "37935256"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457455",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457455",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457457",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666697",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457453",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457455",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457457",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457453",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666697",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 63900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "42 ratings",
                                      "ratingCountV2": "42"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "59549082",
                                  "name": "Red Velvet Heart Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Serves 4 | Celebrate special moments with our red velvet anniversary cake. Layers of red velvet sponges enveloped in a smooth cream and red velvet crumbs. This is perfect dessert for all special occasions. (6 Serving, 2217calories, 25gms Protein, 279gms Carbs).",
                                  "imageId": "840c31cd990c776133b2b2d7deb64c87",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "7887288",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 659,
                                            "default": 1,
                                            "id": "37935239",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1179,
                                            "id": "37935240",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887288",
                                            "variationId": "37935239"
                                          }
                                        ],
                                        "price": 65900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457443",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457443",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "7887288",
                                            "variationId": "37935240"
                                          }
                                        ],
                                        "price": 117900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457443",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457443",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457444",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666869",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457442",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457443",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457444",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457442",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666869",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG",
                                    "portionSize": "Serves 4"
                                  },
                                  "defaultPrice": 65900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "117 ratings",
                                      "ratingCountV2": "117"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "86448718",
                                  "name": "Premium Red Velvet Anniversary Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Celebrate special moments with our red velvet anniversary cake. Layers of red velvet sponges enveloped in a smooth cream, red velvet crumbs and white compound flakes. This is perfect dessert for all special occasions.6 Serving, 2217calories, 25gms Protein, 279gms Carbs).",
                                  "imageId": "2a552c7350f30ee520f724b3907f6a2f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "13647317",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 gms (Serves 4-6)",
                                            "price": 999,
                                            "default": 1,
                                            "id": "44304341",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1799,
                                            "id": "44304342",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "13647317",
                                            "variationId": "44304341"
                                          }
                                        ],
                                        "price": 99900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457627",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457627",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "13647317",
                                            "variationId": "44304342"
                                          }
                                        ],
                                        "price": 179900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457627",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457627",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457629",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666771",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457625",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457627",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457629",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457625",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666771",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 99900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "65657581",
                                  "name": "I Love You My Sweet Heart Cupcakes",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "There is nothing a cupcake can not solve. Indulge in our soft and fresh cupcakes to amaze your sweethearts. Just know that our cupcakes are a delight to all our senses. We stand by our promise, of sweeter celebrations with CakeZone.(6 Serving, 612calories, 6gms Protein, 42gms Carbs).",
                                  "imageId": "3efc4e8e00cc0cdfef32a944c4ba7eff",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "9236948",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Chocolate Cupcakes - 6 Pc",
                                            "price": 499,
                                            "id": "30533546",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Red Velvet Cupcakes - 6 Pc",
                                            "price": 519,
                                            "id": "30533547",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Vanilla Cupcake - 6 Pc",
                                            "price": 499,
                                            "id": "30533545",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Assorted Cupcakes - 6 Pc",
                                            "price": 489,
                                            "default": 1,
                                            "id": "30533548",
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9236948",
                                            "variationId": "30533545"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9236948",
                                            "variationId": "30533546"
                                          }
                                        ],
                                        "price": 49900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9236948",
                                            "variationId": "30533547"
                                          }
                                        ],
                                        "price": 51900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "9236948",
                                            "variationId": "30533548"
                                          }
                                        ],
                                        "price": 48900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109457535",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109457537",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666769",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109457533",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109457535",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457537",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457533",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666769",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 48900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.6",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Birthday Photo Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272110",
                                  "name": "1st Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "bcf3b33e51eb8f8625187c32d826ce9d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070339",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703389",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070340",
                                              "variationId": "88703394"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703390",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070340",
                                              "variationId": "88703396"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703391",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070340",
                                              "variationId": "88703398"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703392",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070340",
                                              "variationId": "88703400"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703393",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070340",
                                              "variationId": "88703402"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070340",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703394",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703396",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703398",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703400",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703402",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703395",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703397",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703399",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703401",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703403",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703389"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703394"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703389"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703395"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703390"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703396"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703390"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703397"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703391"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703398"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703391"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703399"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703392"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703400"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703392"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703401"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703393"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703402"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070339",
                                            "variationId": "88703393"
                                          },
                                          {
                                            "groupId": "28070340",
                                            "variationId": "88703403"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458008",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458009",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666875",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458007",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458008",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458009",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458007",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666875",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272113",
                                  "name": "2nd Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "2f4d0c369fb1d86542d2b71364dc2242",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070341",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703404",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070342",
                                              "variationId": "88703409"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703405",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070342",
                                              "variationId": "88703411"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703406",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070342",
                                              "variationId": "88703413"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703407",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070342",
                                              "variationId": "88703415"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703408",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070342",
                                              "variationId": "88703417"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070342",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703409",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703411",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703413",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703415",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703417",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703410",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703412",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703414",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703416",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703418",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703404"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703409"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703404"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703410"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703405"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703411"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703405"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703412"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703406"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703413"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703406"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703414"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703407"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703415"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703407"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703416"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703408"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703417"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070341",
                                            "variationId": "88703408"
                                          },
                                          {
                                            "groupId": "28070342",
                                            "variationId": "88703418"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458011",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458012",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666866",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458010",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458011",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458012",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458010",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666866",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272116",
                                  "name": "3rd Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "a267f41437812af79c3444db9738d994",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070343",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703419",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070344",
                                              "variationId": "88703424"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703420",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070344",
                                              "variationId": "88703426"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703421",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070344",
                                              "variationId": "88703428"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703422",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070344",
                                              "variationId": "88703430"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703423",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070344",
                                              "variationId": "88703432"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070344",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703424",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703426",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703428",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703430",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703432",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703425",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703427",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703429",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703431",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703433",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703419"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703424"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703419"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703425"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703420"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703426"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703420"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703427"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703421"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703428"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703421"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703429"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703422"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703430"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703422"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703431"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703423"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703432"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070343",
                                            "variationId": "88703423"
                                          },
                                          {
                                            "groupId": "28070344",
                                            "variationId": "88703433"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458014",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458017",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666691",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458013",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458014",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458017",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458013",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666691",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272118",
                                  "name": "4th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "8c2e7a28cf41d29c1af9f76954774c06",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070345",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703434",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070346",
                                              "variationId": "88703439"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703435",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070346",
                                              "variationId": "88703441"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703436",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070346",
                                              "variationId": "88703443"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703437",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070346",
                                              "variationId": "88703445"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703438",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070346",
                                              "variationId": "88703447"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070346",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703439",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703441",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703443",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703445",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703447",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703440",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703442",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703444",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703446",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703448",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703434"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703439"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703434"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703440"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703435"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703441"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703435"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703442"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703436"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703443"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703436"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703444"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703437"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703445"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703437"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703446"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703438"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703447"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070345",
                                            "variationId": "88703438"
                                          },
                                          {
                                            "groupId": "28070346",
                                            "variationId": "88703448"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458034",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458038",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666702",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458031",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458034",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458038",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458031",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666702",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272120",
                                  "name": "5th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "dc196d804b087a90939e2871e1645bba",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070347",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703449",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070348",
                                              "variationId": "88703454"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703450",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070348",
                                              "variationId": "88703456"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703451",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070348",
                                              "variationId": "88703458"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703452",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070348",
                                              "variationId": "88703462"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703453",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070348",
                                              "variationId": "88703466"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070348",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703454",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703456",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703458",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703462",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703466",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703455",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703457",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703460",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703464",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703468",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703449"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703454"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703449"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703455"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703450"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703456"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703450"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703457"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703451"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703458"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703451"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703460"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703452"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703462"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703452"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703464"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703453"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703466"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070347",
                                            "variationId": "88703453"
                                          },
                                          {
                                            "groupId": "28070348",
                                            "variationId": "88703468"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458089",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458090",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666861",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458087",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458089",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458090",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458087",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666861",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272126",
                                  "name": "6th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "6111d6a7a5b0826926d50b5d150770f7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28756746",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "90498176",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756747",
                                              "variationId": "90498181"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "90498177",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756747",
                                              "variationId": "90498183"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "90498178",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756747",
                                              "variationId": "90498185"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "90498179",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756747",
                                              "variationId": "90498187"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "90498180",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756747",
                                              "variationId": "90498189"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28756747",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "90498181",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "90498183",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "90498185",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "90498187",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "90498189",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "90498182",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "90498184",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "90498186",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "90498188",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "90498190",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498176"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498181"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498176"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498182"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498177"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498183"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498177"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498184"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498178"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498185"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498178"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498186"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498179"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498187"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498179"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498188"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498180"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498189"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756746",
                                            "variationId": "90498180"
                                          },
                                          {
                                            "groupId": "28756747",
                                            "variationId": "90498190"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458097",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458099",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666711",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458095",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458097",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458099",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458095",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666711",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100272134",
                                  "name": "7th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "8d64c835d325f85e3761555b5d2030f1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28756748",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "90498191",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756749",
                                              "variationId": "90498196"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "90498192",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756749",
                                              "variationId": "90498198"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "90498193",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756749",
                                              "variationId": "90498200"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "90498194",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756749",
                                              "variationId": "90498202"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "90498195",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28756749",
                                              "variationId": "90498204"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28756749",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "90498196",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "90498198",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "90498200",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "90498202",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "90498204",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "90498197",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "90498199",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "90498201",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "90498203",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "90498205",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498191"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498196"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498191"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498197"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498192"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498198"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498192"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498199"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498193"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498200"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498193"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498201"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498194"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498202"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498194"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498203"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498195"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498204"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28756748",
                                            "variationId": "90498195"
                                          },
                                          {
                                            "groupId": "28756749",
                                            "variationId": "90498205"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458109",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458112",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666754",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458105",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458109",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458112",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458105",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666754",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114160920",
                                  "name": "8th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "2aec1d5e40fce37d64252a22473a1a79",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070367",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703599",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070368",
                                              "variationId": "88703604"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703600",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070368",
                                              "variationId": "88703606"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703601",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070368",
                                              "variationId": "88703608"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703602",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070368",
                                              "variationId": "88703610"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703603",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070368",
                                              "variationId": "88703612"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070368",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703604",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703606",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703608",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703610",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703612",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703605",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703607",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703609",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703611",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703613",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703599"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703604"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703599"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703605"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703600"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703606"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703600"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703607"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703601"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703608"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703601"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703609"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703602"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703610"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703602"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703611"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703603"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703612"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070367",
                                            "variationId": "88703603"
                                          },
                                          {
                                            "groupId": "28070368",
                                            "variationId": "88703613"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458122",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458124",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666718",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458120",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458122",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458124",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458120",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666718",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114160921",
                                  "name": "9th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "ed8151174e4f5dc004d9b7b358d1ba68",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070369",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703614",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070370",
                                              "variationId": "88703619"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703615",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070370",
                                              "variationId": "88703621"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703616",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070370",
                                              "variationId": "88703623"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703617",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070370",
                                              "variationId": "88703625"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703618",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070370",
                                              "variationId": "88703627"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070370",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703619",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703621",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703623",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703625",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703627",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703620",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703622",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703624",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703626",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703628",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703614"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703619"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703614"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703620"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703615"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703621"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703615"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703622"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703616"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703623"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703616"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703624"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703617"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703625"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703617"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703626"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703618"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703627"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070369",
                                            "variationId": "88703618"
                                          },
                                          {
                                            "groupId": "28070370",
                                            "variationId": "88703628"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458145",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458148",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666748",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458140",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458145",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458148",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458140",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666748",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114160924",
                                  "name": "10th Birthday Photo Cake",
                                  "category": "Anniversary & Birthday Cakes",
                                  "description": "Enjoy our number-based photo cakes. You can choose the flavor which you like most.  All our cakes are made fresh and with love, with No added preservatives, all-natural, and best quality ingredients safe for children and adults alike.(6 Servings, 262 calories each)",
                                  "imageId": "0742f81d41ab7608494d73293864f87e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28070371",
                                        "name": "Select Flavour",
                                        "variations": [
                                          {
                                            "name": "Vanilla",
                                            "default": 1,
                                            "id": "88703629",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070372",
                                              "variationId": "88703634"
                                            }
                                          },
                                          {
                                            "name": "Butterscotch",
                                            "id": "88703630",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070372",
                                              "variationId": "88703636"
                                            }
                                          },
                                          {
                                            "name": "Chocolate Truffle",
                                            "id": "88703631",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070372",
                                              "variationId": "88703638"
                                            }
                                          },
                                          {
                                            "name": "Black Forest",
                                            "id": "88703632",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070372",
                                              "variationId": "88703640"
                                            }
                                          },
                                          {
                                            "name": "Red Velvet",
                                            "id": "88703633",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1,
                                            "dependantVariation": {
                                              "groupId": "28070372",
                                              "variationId": "88703642"
                                            }
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28070372",
                                        "name": "Select Weight",
                                        "variations": [
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 759,
                                            "default": 1,
                                            "id": "88703634",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 749,
                                            "id": "88703636",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703638",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 829,
                                            "id": "88703640",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "500 Grams (Serves 4-6)",
                                            "price": 1029,
                                            "id": "88703642",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703635",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1069,
                                            "id": "88703637",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1119,
                                            "id": "88703639",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1059,
                                            "id": "88703641",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "1 Kg (Serves 9-10)",
                                            "price": 1349,
                                            "id": "88703643",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703629"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703634"
                                          }
                                        ],
                                        "price": 75900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703629"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703635"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703630"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703636"
                                          }
                                        ],
                                        "price": 74900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703630"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703637"
                                          }
                                        ],
                                        "price": 106900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703631"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703638"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703631"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703639"
                                          }
                                        ],
                                        "price": 111900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703632"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703640"
                                          }
                                        ],
                                        "price": 82900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703632"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703641"
                                          }
                                        ],
                                        "price": 105900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703633"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703642"
                                          }
                                        ],
                                        "price": 102900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "28070371",
                                            "variationId": "88703633"
                                          },
                                          {
                                            "groupId": "28070372",
                                            "variationId": "88703643"
                                          }
                                        ],
                                        "price": 134900,
                                        "addonCombinations": [
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062827"
                                          },
                                          {
                                            "groupId": "109458159",
                                            "addonId": "99062828"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062830"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "110015925"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062829"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062832"
                                          },
                                          {
                                            "groupId": "109458161",
                                            "addonId": "99062831"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "107701558"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112734"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "108316004"
                                          },
                                          {
                                            "groupId": "127666849",
                                            "addonId": "109112735"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "102289596"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062823"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062824"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062825"
                                          },
                                          {
                                            "groupId": "109458157",
                                            "addonId": "99062826"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458159",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458161",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458157",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "127666849",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701558",
                                          "name": "Coke (750ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112734",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "108316004",
                                          "name": "Peri Peri Nacho Chips",
                                          "price": 8000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109112735",
                                          "name": "Ice Tea (200ml)",
                                          "price": 7900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 75900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Signature Desserts",
                      "categories": [
                        {
                          "title": "Tres Leches & Cake Tubs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112110600",
                                  "name": "Rose Milk Cake Tub",
                                  "category": "Signature Desserts",
                                  "description": "This soft and tender cake tub is a layered blend of vanilla sponges, pista flakes and rose milk, and classic way of toppings with simple pista nuts and rose petals makes you feel extra overloaded. [Weight: 195 Grams]",
                                  "imageId": "3f39fb47712bde37b82e6cc9536780eb",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112110601",
                                  "name": "Rasmalai Cake Tub",
                                  "category": "Signature Desserts",
                                  "description": "This classic Indian dessert is a layered blend of vanilla sponges, pista flakes and garnished with delicious rasmalai and much loved pista nuts on top in cake tub. [Weight: 195 Grams](one cake tub, 1477calories, 15gms Protien, 225gms carbs)",
                                  "imageId": "304cfee0c74d49b9eebfb7a0fc641425",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "112110602",
                                  "name": "Hazelnut Cake Tub",
                                  "category": "Signature Desserts",
                                  "description": "Amazing taste and flavor of cake makes your day perfect, this sweetest dessert is a layered with chocolate sponges, hazelnut ganache and garnished with hazelnut on top. [Weight: 200 Grams](one cake tub, 1548calories, 20gms Proteins, 230gms carbs)",
                                  "imageId": "11dfed6554a066756d2a0578702a11de",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114463987",
                                  "name": "Rasmalai Tres Leches",
                                  "category": "Signature Desserts",
                                  "description": "Beat this summer with delicious Tres leches, soft vanilla sponge dipped in rasmalai milk and garnished with pista flakes gives your unique taste experience. [Weight: 165 Grams]",
                                  "imageId": "791cdf1c6740ee577e2d9c084f43edd4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114463988",
                                  "name": "Rose And Honey Tres Leches",
                                  "category": "Signature Desserts",
                                  "description": "This Tres leches will make your day memorable, soft vanilla sponge drenched with rose and honey milk and crushed butterscotch nuts and almonds on top gives you unique taste experience. [ Weight:165 Grams]",
                                  "imageId": "59f931c22572b5648bcbd298ebf25cc4",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115803967",
                                  "name": "Mango Tres Leches",
                                  "category": "Signature Desserts",
                                  "description": "Once the cake has soaked up the milk mixture, it is topped with a layer of freshly whipped cream. The whipped cream adds a light and creamy element to the dessert, balancing the sweetness and providing a smooth finish.(1 serving,,967calories,21gms protein,169gms carbs).",
                                  "imageId": "71cacf1a395bd7c50ba1c3372962e50d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458317",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458318",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458316",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116279997",
                                  "name": "Mango Cheese Cake Tub",
                                  "category": "Signature Desserts",
                                  "description": "The base of the Cake Tub is made up of layers of soft and fluffy mango cake. The cake layers are often infused with mango puree or essence, giving them a distinct mango flavor. The cake itself is typically light and moist, providing a delicate texture that melts in your mouth.(1 serving,525 calories,8gms protein,91gms carbs)",
                                  "imageId": "b025928594d347c3ba019573b0829723",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "109458325",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458327",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109458322",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cake Pops",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110127022",
                                  "name": "Heart Shape Vanilla Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small heart shape, and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 409 calories,4gms protien,27gms carbs)",
                                  "imageId": "a1d236a55f5fb473e68aea8e13f6d22d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110127023",
                                  "name": "Heart Shape Chocolate Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small heart shape , and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 755 calories,12gms protien,114gms carbs)",
                                  "imageId": "bed211a33ca57dfcbbe222a1fae91521",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "63124334",
                                  "name": "Sweet Red Velvet Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small balls, and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 443calories,4gms protien,47gms carbs)",
                                  "imageId": "a7b89956b5cf40cb7505b92bec4fd91a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "110127004",
                                  "name": "Heart Shape Red Velvet Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small heart shape, and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 443 calories,6gms protien,47gms carbs)",
                                  "imageId": "615d0e793c25fe6215902adfbc2bf037",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "63124335",
                                  "name": "Sweet Chocolate Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small balls, and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 755 calories,12gms protien,114gms carbs)",
                                  "imageId": "ef7c1779a56fd392bc82330bb6fe5d32",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "63124333",
                                  "name": "Sweet Vanilla Cake Pops - 4 Pc",
                                  "category": "Signature Desserts",
                                  "description": "[Eggless].Cake pops are delightful and whimsical treats that combine the best of cake and lollipops. These bite-sized confections are made by crumbling moist cake and mixing it with frosting, shaping the mixture into small balls, and then inserting a stick into each one to create a cake pop on a stick. (4 pieces, 409 calories,4gms protien,27gms carbs)",
                                  "imageId": "7ce231ffb2809e1a91e8193260c15c91",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 25900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Bomb Cakes & Pinata Cakes",
                      "categories": [
                        {
                          "title": "Bomb Cakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99852163",
                                  "name": "Chocolate Truffle Bomb Cake - 500 grams",
                                  "category": "Bomb Cakes & Pinata Cakes",
                                  "description": "[ 500 Gms ]. Bomb cakes are excellent for all occasions, where chocolate truffle cake is placed inside a bomb-shaped container that is lit up to open with an unintended explosion. Celebrate the moments and We stand by our promise, of sweeter celebrations.( 6 Serving, 388 Calories each, Protein-5g each, Carbs-53g each)",
                                  "imageId": "gwnwmuevdzhjwf89nbdf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 183900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125267191",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701559",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457813",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457815",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457811",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99852235",
                                  "name": "Mango Bomb Cake - 500 grams",
                                  "category": "Bomb Cakes & Pinata Cakes",
                                  "description": "[ 500 Gms ]. Bomb cakes are excellent for all occasions, where mango cake is placed inside a bomb-shaped container that is lighted up to open with an unintended explosion. Celebrate the moments and We stand by our promise, sweeter celebrations. ( 6 Serving, 1923 Calories each, Protein-33g each, Carbs-338g each)",
                                  "imageId": "342ed2508064850f1c684dd5cf9fd750",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 175900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125267183",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701559",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457822",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457824",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457820",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99852255",
                                  "name": "Red Velvet Bomb Cake  - 500 grams",
                                  "category": "Bomb Cakes & Pinata Cakes",
                                  "description": "[500 grams]. Bomb cakes are wonderful for all occasions, where red velvet cake is placed inside the bomb shaped container that is lighted up to open with an unintended explosion. Celebrate the moments and We stand by our promise, sweeter celebrations.( 6 Serving, 370 Calories each, Protein-4g each, Carbs-47g each)",
                                  "imageId": "lfwcelmqoaafbwwo8cns",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 202900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125267203",
                                      "groupName": "Add On - Beverages & Nachos",
                                      "choices": [
                                        {
                                          "id": "107701559",
                                          "name": "Sugarcane (200ml)",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457834",
                                      "groupName": "Add On - Greeting Cards",
                                      "choices": [
                                        {
                                          "id": "99062827",
                                          "name": "Happy Birthday Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062828",
                                          "name": "To My Better Half Greeting Card",
                                          "price": 4900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457836",
                                      "groupName": "Add On - Party Essentials",
                                      "choices": [
                                        {
                                          "id": "99062830",
                                          "name": "Snow Spray",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "110015925",
                                          "name": "Ginger Cookies (5 Pc)",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062829",
                                          "name": "Paper Popper",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062832",
                                          "name": "Pack of 10 Party Balloons",
                                          "price": 9900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062831",
                                          "name": "Pack of 6 Birthday Caps",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "109457833",
                                      "groupName": "Add On - Candles",
                                      "choices": [
                                        {
                                          "id": "102289596",
                                          "name": "Knife and Candle",
                                          "price": 100,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062823",
                                          "name": "Happy Birthday Candle",
                                          "price": 17900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062824",
                                          "name": "Sparkle Candle",
                                          "price": 3500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062825",
                                          "name": "Magic Candle",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "99062826",
                                          "name": "Flower Candle",
                                          "price": 11900,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Puff Rolls",
                      "categories": [
                        {
                          "title": "Puff Rolls",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121718981",
                                  "name": "Pack of Chocochip Puff Roll",
                                  "category": "Puff Rolls",
                                  "description": "This Puff is a delightful dessert that combines the classic flavors of chocolate and the delightful texture of chocolate chips within a puff pastry roll. It's a sweet treat that's sure to satisfy anyone with a sweet tooth.",
                                  "imageId": "62fff03016b2aa75353cc6a5bdf96517",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30596606",
                                        "name": "Select Pack of Puff Rolls",
                                        "variations": [
                                          {
                                            "name": "Pack of Two",
                                            "price": 149,
                                            "default": 1,
                                            "id": "95173356",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of Four",
                                            "price": 279,
                                            "id": "95173357",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30596606",
                                            "variationId": "95173356"
                                          }
                                        ],
                                        "price": 14900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30596606",
                                            "variationId": "95173357"
                                          }
                                        ],
                                        "price": 27900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 14900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121718979",
                                  "name": "Choco Chip Puff Roll",
                                  "category": "Puff Rolls",
                                  "description": "This Puff is a delightful dessert that combines the classic flavors of chocolate and the delightful texture of chocolate chips within a puff pastry roll. It's a sweet treat that's sure to satisfy anyone with a sweet tooth.",
                                  "imageId": "9f780a7c68c7c66784d5f5f6419a2e16",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121718978",
                                  "name": "Rocky Road Puff Roll",
                                  "category": "Puff Rolls",
                                  "description": "It is a unique twist on the classic puff pastry, where a croissant is used as the base instead of a regular puff pastry sheet and it is combining the rich and indulgent of Dark truffle, Dark chocolate, Gems, and Brownie.",
                                  "imageId": "64dcc40afd11e71ed53acefc42e3617a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121718980",
                                  "name": "Pack Of Rocky Road Puff Rolls",
                                  "category": "Puff Rolls",
                                  "description": "It is a unique twist on the classic puff pastry, where a croissant is used as the base instead of a regular puff pastry sheet and it is combining the rich and indulgent of Dark truffle, Dark chocolate, Gems, and Brownie.",
                                  "imageId": "3890460bf04b3f952abac6fdd5d244b2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "30596605",
                                        "name": "Select Pack of Puff Rolls",
                                        "variations": [
                                          {
                                            "name": "Pack of Two",
                                            "price": 179,
                                            "default": 1,
                                            "id": "95173354",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Pack of Four",
                                            "price": 339,
                                            "id": "95173355",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30596605",
                                            "variationId": "95173354"
                                          }
                                        ],
                                        "price": 17900
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "30596605",
                                            "variationId": "95173355"
                                          }
                                        ],
                                        "price": 33900
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "defaultPrice": 17900,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Celebration Party Essentials",
                      "categories": [
                        {
                          "title": "Party Essentials",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "118466813",
                                  "name": "World's Most Awesome Dad Printed Mug",
                                  "category": "Celebration Party Essentials",
                                  "description": "This Printed Mug is a versatile gift that suits various occasions. It's a perfect gift for Dad when you want to make them feel special. It serves as a daily reminder of the love and appreciation that surrounds him.",
                                  "imageId": "3c7c2a833b77fa084898150fcd944cb7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180655",
                                  "name": "Happy Birthday Greeting Card",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "dc87c6b2c86f7d77e56893c7a467a54d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5100,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180658",
                                  "name": "To My Better Half Greeting Card",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "931330ab74e9e812574b4def3598e466",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5100,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180660",
                                  "name": "Happy Birthday Candles",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "c45e6649699da467af3bae7dbb15b18d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 18900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116621745",
                                  "name": "Greeting Card For Mom - English",
                                  "category": "Celebration Party Essentials",
                                  "description": "Creating a greeting card for your mom is a wonderful way to express your love and appreciation.",
                                  "imageId": "7b4dafb477e7c8cab370600821f5c172",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 5900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180641",
                                  "name": "Birthday Caps (Pack of 12)",
                                  "category": "Celebration Party Essentials",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180642",
                                  "name": "Party Balloons (Pack of 20)",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "a6312812e337e1fc99b6af4519f0a1d7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 19900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180663",
                                  "name": "Paper Popper",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "b3fa06c4a26340f0b2cc32261aff269f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180646",
                                  "name": "Flower Candle (Pack of 2)",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "8b883823c495e03d5bb2b91f76d7382c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180665",
                                  "name": "Sparkle Candle",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "f83bc8978d852c23e4420e42dc48f6ad",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 3900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180673",
                                  "name": "Magic Candle",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "7d4d0053808a7efcce517f74942b169e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180676",
                                  "name": "Birthday Caps (Pack of 6)",
                                  "category": "Celebration Party Essentials",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 8900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180634",
                                  "name": "Sparkle Candle (Pack of 2)",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "0b1dfc9c932b54d1e0833407d36551bc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 6900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180678",
                                  "name": "Party Balloons - Pack of 10",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "cd0bb670bd8719d551e2a071fb646770",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 10900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180635",
                                  "name": "Magic Candles (Pack of 2)",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "ece253d9369fcfc1d0846bb3ad5f5266",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180680",
                                  "name": "Flower Candle",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "7f42ecdb304c292ab47c57bf80f2038a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 12900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180632",
                                  "name": "Paper Popper (Pack of 2)",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "972eda177b4199d26acd6ebcf265f098",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109180653",
                                  "name": "Knife and Candle",
                                  "category": "Celebration Party Essentials",
                                  "imageId": "90273b8f11c4d64179fab2498b27c629",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Party Combos",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "114160926",
                                  "name": "Birthday Combo",
                                  "category": "Celebration Party Essentials",
                                  "description": "This Combo Includes:\nHappy Birthday Candle\nParty Balloons( Pack of 10)\nSnow Spray\nPaper Popper\nBirthday Caps( Pack of 6)\nHappy Birthday Greeting Card",
                                  "imageId": "a4ea63f53a17505c92c52ce6264eb9f1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 67900,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "107840641",
                                      "groupName": "Select Items",
                                      "choices": [
                                        {
                                          "id": "98557114",
                                          "name": "Happy Birthday Candles",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98557115",
                                          "name": "Party Balloons (Pack of 10)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98557116",
                                          "name": "Snow Spray",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98557117",
                                          "name": "Paper Popper",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98557118",
                                          "name": "Birthday Caps (Pack of 6)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98557119",
                                          "name": "Happy Birthday Greeting Card",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1,
                                      "minAddons": 6
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11220333001248"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "CakeZone",
                      "area": "Indira Nagar",
                      "completeAddress": "# 24, SECOND FLOOR, CMH ROAD, SECOND STAGE, HOYSALA NAGAR, INDIRA NAGAR, BENGALURU, Sarvagna Nagar , B.B.M.P East, Karnataka-560038"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "FelWH96HWmcW-fbaJgRQSuOfFermJu52BdVjxa5g"
},
// 20240105234018
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=124178&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "124178",
              "name": "Starbucks Coffee",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "starbucks-coffee-lavelle-road-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "258fe8a3577877fbfe064095ed1d9dc3",
              "locality": "Ashok Nagar",
              "areaName": "Lavelle Road",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Beverages",
                "Cafe"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "124178",
                "fees": [
                  {
                    "name": "time"
                  },
                  {
                    "name": "distance",
                    "fee": 4500
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4500,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.5 kms | ₹45 Delivery fee will apply"
              },
              "parentId": "195515",
              "avgRatingString": "4.3",
              "totalRatingsString": "1K+ ratings",
              "sla": {
                "restaurantId": "124178",
                "deliveryTime": 21,
                "minDeliveryTime": 21,
                "maxDeliveryTime": 21,
                "lastMileTravel": 0.5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "21 MINS",
                "lastMileTravelString": "0.5 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-01-05 23:59:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Get items under 219",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 219",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 219",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "starbucks-coffee-lavelle-road-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "38/1,Vittal Mallya, Lavelle Road Junction,Vittal Mallya Road, Bangalore ? 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Beverages,Cafe"
                }
              ],
              "totalRatings": 1000,
              "aggregatedDiscountInfoV2": {
                "header": "Get items under 219",
                "shortDescriptionList": [
                  {
                    "meta": "Get items under 219",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off | Use TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Get items under 219",
                    "discountType": "FinalPrice",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "20% off up to ₹50 | Use code TRYNEW",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "priority": 11,
                  "discountInfo": {
                    "discountType": "FinalPrice",
                    "value": 219
                  },
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD",
                  "nudgeTagInfo": {
                    "title": "Deal of the Day",
                    "fontName": "FONT_NAME_CONDENSED_BOLD"
                  },
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/124178"
              },
              "expectationNotifiers": [
                {
                  "text": "0.5 kms | ₹45 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>0.5 kms</b> | ₹45 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "itemNudges": {
                "SILD": {
                  "priority": 11,
                  "unlockedMessage": "Deal of the Day unlocked!",
                  "minItemCount": 1,
                  "maxItemCount": 1,
                  "type": "SILD"
                }
              },
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.9710778,77.598162"
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "ITEMS AT ₹219",
                      "offerTag": "DEAL OF DAY",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "b172dd5f-4443-4599-ad24-04da858163a9"
                      ],
                      "expiryTime": "1970-01-01T00:18:43Z",
                      "description": "ON SELECT ITEMS |",
                      "offerType": "offers",
                      "restId": "124178",
                      "offerLogo": "offers/deal-of-day",
                      "descriptionTextColor": "#7302060C",
                      "showExpiryTimer": true
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹50",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "603b2c3d-b2a7-4e91-992e-7bec5dcebe30"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE TRYNEW",
                      "description": "ABOVE ₹179",
                      "offerType": "offers",
                      "restId": "124178",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT 10% OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "b561b984-59fb-4b37-92a1-168ce4ef1a09"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE PARTY",
                      "description": "ABOVE ₹900",
                      "offerType": "offers",
                      "restId": "124178",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "124178",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "124178",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1624455",
                          "creativeId": "TopPicks/ChTPastry",
                          "title": "Christmas Tree Pastry",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "106106461",
                              "name": "Christmas Tree Pastry",
                              "category": "Holiday Classics from The Archies",
                              "description": "Dive into the holiday spirit with this decadent pastry reminiscent of a Christmas tree. A chocolate lover's dream dipped in velvety ganache and crowned with a layer of milk chocolate. With its edible Christmas tree ornaments, this festive treat is a delight for your tastebuds and eyes alike.\nContains - Soy, Milk\n110 g | 631 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                              "imageId": "5fd8ddbd3527bf7ffb9ee15bee74da88",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "1624647",
                          "creativeId": "TopPicks/CCLog",
                          "title": "Carrot Cake Log",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "129579183",
                              "name": "Carrot Cake Log",
                              "category": "Holiday Classics from The Archies",
                              "description": "Let the sweet decadence of carrot cake, coupled with the comforting aroma of cinnamon and nutmeg, transport you to a cozy winter wonderland with this log shaped masterpiece topped with an enchanting Christmas tree cookie.\nContains - Egg, Wheat, Nut, Milk, Soy\n158 g | 742 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                              "imageId": "c07c2b47e0a9d34598e3fe14b7200561",
                              "inStock": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Frappuccino Fridays",
                      "categories": [
                        {
                          "title": "Frappuccino Fridays",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758566",
                                  "name": "Tall Coffee Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Coffee meets milk and ice in a blender and together they create one of our original Frappuccino? beverages.\nEnergy  - Tall (354ml) - 208.6 kcal / Grande (473ml) - 306.87 kcal / Venti (591ml) 391.98 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "a96e63604672f1495f6b6239f5359885",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350498",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422397",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350499",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422398",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758557",
                                  "name": "Tall Java Chip Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "We blend mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle to bring you endless java joy.\nEnergy  - Tall (354ml) - 391.7 kcal / Grande (473ml) - 536.19 kcal / Venti (591ml) 667.4 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "434146cff15b354b9dc1b6273a9afede",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350500",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422400",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350501",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422401",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129705388",
                                  "name": "Tall Vanilla Cream Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "This rich and creamy blend of vanilla, milk and ice topped with whipped cream takes vanilla flavour to another level.\nEnergy  - Tall (354ml) - 345.1 kcal / Grande (473ml) - 474.75 kcal / Venti (591ml) 591.72 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "dd9d369cc7ecf3fa8f7487cefe0df410",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350502",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422403",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350503",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422404",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758563",
                                  "name": "Tall Espresso Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Coffee is combined with a shot of espresso and milk, then blended with ice to give you a nice little jolt and lots of sipping joy.\nEnergy  - Tall (354ml) - 194.8 kcal / Grande (473ml) - 292.78 kcal / Venti (591ml) 378.2 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "941109213cfd61b695033c90c8e0bf1f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350504",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422406",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350505",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422407",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758561",
                                  "name": "Tall Caramel Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "A blend of coffee, sweet caramel syrup, milk and ice topped with whipped cream and a swirl of caramel drizzle.\nEnergy  - Tall (354ml) - 364.5 kcal / Grande (473ml) - 485.42 kcal / Venti (591ml) 601.65 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "f59a4ebafc1381f2ee49c5a2ce6e93ae",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37000,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350506",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422409",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350507",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422410",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129705389",
                                  "name": "Tall Strawberries & Creme Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Strawberries and milk are blended with ice and topped with a swirl of whipped cream.\nEnergy  - Tall (354ml) - 530.2 kcal / Grande (473ml) - 752.87 kcal / Venti (591ml) 962.58 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "99b80e8043d2b904a6dee1984a14c67f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350508",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422412",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350509",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422413",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758559",
                                  "name": "Tall Mocha Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Coffee with rich mocha sauce blended with milk and ice. Topped with sweetened whipped cream.\nEnergy  - Tall (354ml) - 341.7 kcal / Grande (473ml) - 470.31 kcal / Venti (591ml) 585.42 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "57d5ab91750bf825caf36de7caf89e76",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350510",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422415",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350511",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422416",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129705390",
                                  "name": "Tall White Mocha Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "White chocolate Frappuccino is a blend of coffee, white chocolate sauce, milk and ice. Topped with sweetened whipped cream.\nEnergy  - Tall (354ml) - 370.7 kcal / Grande (473ml) - 538.87 kcal / Venti (591ml) 643.58 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "8aaebd72bc16a8d1c34f0b74a4b105df",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350512",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422418",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350513",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422419",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129705391",
                                  "name": "Tall Caramel Java Chip Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Coffee with rich mocha flavoured sauce blended with milk chocolaty chips, caramel syrup and ice. Topped with sweetened whipped cream and chocolate drizzle.\nEnergy  - Tall (354ml) - 398 kcal / Grande (473ml) - 574.16 kcal / Venti (591ml) 714.18 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "3c7b2ce395ed7658612e7b2f212f1b8d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 44000,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350514",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422421",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350515",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422422",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "102758556",
                                  "name": "Tall Double Chocolate Chip Frappuccino",
                                  "category": "Frappuccino Fridays",
                                  "description": "Rich mocha-flavoured sauce meets up with chocolaty chips, milk and ice. Top it off with sweetened whipped cream and mocha drizzle for a real party in your mouth.\nEnergy  - Tall (354ml) - 414.9 kcal / Grande (473ml) - 580.35 kcal / Venti (591ml) 729.42 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "7eca19e43a0014e011e36752dfdb6b0e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "finalPrice": 21900,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35350516",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109422424",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35350517",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109422425",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "offerTags": [
                                    {
                                      
                                    }
                                  ],
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "itemNudgeType": "FinalPrice",
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Value Meals (20% OFF)",
                      "categories": [
                        {
                          "title": "Value Meals (20% OFF)",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128985",
                                  "name": "Short Signature Hot Chocolate with Masala Potato Puff",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 86! Enjoy Four cocoas and fresh steamed milk topped with chocolate powder, served with Masala Potato Puff -A savoury snack made with masala potato filling in a puff pastry.\nEnergy  - Hot - Picco (180ml) - 123.24 kcal / Short (237ml) - 283.99 kcal / Tall (354ml) - 445.89 kcal / Grande (473ml) - 580.13 kcal / Venti (591ml) 735.16 kcal.\nServing size (g/ml) - 90g/372kcal\nAllergen - Nut, Milk, Wheat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "e9c8a34e1ea56ca8c6d47e4b9bf418e8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37200,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128987",
                                  "name": "Tall Cappuccino with Egg White & Chicken in Multigrain Croissant",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 125! Enjoy Dark, rich espresso lies in wait under a smoothed and stretched layer of thick foam, served with Egg White & Chicken in Multigrain Croissaint -Fluffy egg white omelette and chicken ham sandwiched in multigrain croissant.\nEnergy - Hot - Picco (180ml) - 94.5 kcal / Short (237ml) 103.8 kcal / Tall (354ml) - 103.8 kcal / Grande (473ml) - 173 kcal / Venti (591ml) 220.18 kcal.\nServing size (g/ml) - 200g/541kcal.\nAllergen - Contains Wheat, Oats, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "72b4e22d44b180326c94fbe760473c8f",
                                  "inStock": 1,
                                  "price": 55600,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805378",
                                  "name": "Tall Java Chip Frappuccino with Chilli Cheese Toast",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 127! Enjoy We blend mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle, served with Chilli Cheese Toast -Cheesy and fiery snack on a toasted French-style baguette, topped with red, yellow and green pepper and chopped green chilli. 2 pieces per portion.\nEnergy - Tall (354ml) - 391.7 kcal / Grande (473ml) - 536.19 kcal / Venti (591ml) 667.4 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nServing size (g/ml) - 170g/419kcal.\nAllergen - Contains Wheat, Milk.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "a9d214c955150b644327eac547b83d8c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 58400,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820494",
                                        "name": "Java Chip Frappuccino Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674585",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128988",
                                  "name": "Tall Cappuccino with Herbed Chicken Focaccia Sandwich",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 137! Enjoy Dark, rich espresso lies in wait under a smoothed and stretched layer of thick foam, served with Herbed Chicken Focaccia Sandwich -Freshly Assembled Sandwich A western styled chicken salad sandwiched in a focaccia bread.\nEnergy per serving size - Hot - Picco (180ml) - 94.5 kcal / Short (237ml) 103.8 kcal / Tall (354ml) - 103.8 kcal / Grande (473ml) - 173 kcal / Venti (591ml) 220.18 kcal.\nServing size (g/ml) - 240g/686kcal\nAllergen - Contains  Milk, Wheat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "6fdcb8417708fbc0f708ff620e918648",
                                  "inStock": 1,
                                  "price": 58000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128990",
                                  "name": "Tall Chocolate Milkshake with Pesto & Mozzarella Sandwich in Panini",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 157! Enjoy Classic Chocolate Milkshake for summers served with Pesto & Mozzarella Sandwich in Panini -Freshly Assembled Sandwich A panini bread loaded with spinach, cheddar and Emmenthal.\nServing size (g/ml) - 250g/775kcal\nAllergen - Contains Milk, Wheat, Soy, Rye, Oat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "c51e03263712786fb7a0da4ff9f1706b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 63600,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820496",
                                        "name": " Chocolate Milkshake Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674587",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128989",
                                  "name": "Tall Cold Coffee with Tandoori Chicken Panini Sandwich",
                                  "category": "Value Meals (20% OFF)",
                                  "description": "\"Meal for One! SAVE Rs. 151! Enjoy Classic Cold coffee drink for summers served with Tandoori Chicken Panini Sandwich -Freshly Assembled Sandwich Masala?chicken?tikka with?tomato?salsa?&?cheddar?cheese?sandwiched?in a panini bread.\nEnergy - Tall (354ml) - 353 kcal / Grande (473ml) - 473 kcal.\nServing size (g/ml) - 290g/901kcal\nAllergen - Contains Milk, Nut, Wheat, Rye, Soy, Oat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "57a06062e4b168a6a2b61ad0ba498e02",
                                  "price": 61600,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820495",
                                        "name": "BLENDED Cold coffee Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674586",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                      "categories": [
                        {
                          "title": "Puffs",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100711601",
                                  "name": "Masala Potato Puff",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "A savoury snack made with masala potato filling in a puff pastry. The perfect accompaniment with your evening cup of coffee. \nServing size (g/ml) - 90g/372kcal\nAllergen - Nut, Milk, Wheat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "ce7cf19b419a57940601b8c22616b675",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 16500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805379",
                                  "name": "Bhuna Chicken Puff",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "A spiced & flavourful bhuna chicken filling encased in a puff pastry with a topping of black sesame seeds.\nServing size (g/ml) - 85g/390kcal.\nAllergen - Contains Milk, Wheat, Soy, Rye, Oat, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary\n",
                                  "imageId": "3c99abd0beafe902d89913741a963124",
                                  "price": 19000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Sandwiches",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412926",
                                  "name": "Ultimate Double Egg Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Treat yourself to an egg bhurji and fried egg sandwich in a brown bread.\nServing size 205 g | 770 kcal\nAllergens - Wheat, Soy, Rye, Oat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "07df255cee41fe70b2883308e2f47d08",
                                  "inStock": 1,
                                  "price": 39000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805390",
                                  "name": "Spiced Paneer Sandwich in Focaccia",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Freshly Assembled Sandwich\nAn Indian masala paneer with tomato salsa & cheddar cheese sandwiched in a foccacia bread.\nServing size (g/ml) - 225g/727kcal\nAllergen - Contains Milk, Nut, Wheat\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "d177a001ac5706d9a8dbf282b28a1cbe",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117056270",
                                  "name": "Pesto & Mozzarella Sandwich in Panini..",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Freshly Assembled Sandwich\nA panini bread loaded with spinach, cheddar and Emmenthal.\nServing size (g/ml) - 290g/731kcal\nAllergen - Contains Milk, Wheat, Soy, Rye, Oat, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "90386479a9643531016ddbc234969080",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117056267",
                                  "name": "Herbed Chicken Focaccia Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Freshly Assembled Sandwich\nA western styled chicken salad sandwiched in a focaccia bread.\nServing size (g/ml) - 230g/717kcal\nAllergen - Contains  Milk, Wheat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "2cf1f9ef230cbcd1e39061d7a0b78bc7",
                                  "inStock": 1,
                                  "price": 40500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412924",
                                  "name": "Roasted Veggie Hummus Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Roasted zucchini and aubergine with crunchy pickled vegetables resting on a bed of creamy hummus in a multigrain brown bread.\nServing size 205 g | 671 kcal\nAllergens - Wheat, Soy, Rye, Oat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "89691da9592474b48981238e7f542153",
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412925",
                                  "name": "Mushroom Feta Cream Cheese Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Sautéed mushrooms and soft brined feta in a cream cheese spread in a multigrain brown bread.\nServing size 205 g | 646 kcal\nAllergens - Wheat, Soy, Rye, Oat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "6f7ea40d65e591b006a0442decbfe105",
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412927",
                                  "name": "Roasted Harissa Chicken Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Brown bread sandwich filled with succulent harissa roasted chicken filling.\nServing size 185 g | 842 kcal\nAllergens - Wheat, Soy, Rye, Oat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "4fec9ee2ec3ddbb8805452e97060581f",
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412928",
                                  "name": "Creamy Moroccan Chicken Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Creamy Moroccan chicken with roasted onions and bell peppers in a brown bread.\nServing size 185 g | 755 kcal\nAllergens - Wheat, Soy, Rye, Oat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101109748",
                                  "name": "Tandoori Chicken Panini Sandwich",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Freshly Assembled Sandwich\nMasala?chicken?tikka with?tomato?salsa?&?cheddar?cheese?sandwiched?in a panini bread.\nServing size (g/ml) - 290g/901kcal\nAllergen - Contains Milk, Nut, Wheat, Rye, Soy, Oat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "906b41e2d8f5a3b8f682cb5c586cdfde",
                                  "price": 41000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "9 ratings",
                                      "ratingCountV2": "9"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Savoury",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652418",
                                  "name": "Baked Veggie Bagel",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Herb roasted farm fresh vegetables cooked in a tomato based sauce and sandwiched in a sunflower seed and paprika bagel.\nContains - Wheat, Milk, Soy\n170 g | 419 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "ad63e647a7288ba1863567a015fd9189",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652419",
                                  "name": "Podi Cream Cheese Bagel",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Gunpowder and cream cheese with coriander, in a sesame and poppy bagel.\nContains - Wheat, Milk\n150 g | 545 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "5a40a719f1491a2967f81bcc8481b246",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652420",
                                  "name": "Double Egg Bagel",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "A melange of eggs cooked two ways - scrambled and boiled. With parsley and cheese in a bagel.\nContains - Wheat, Milk, Egg, Soy\n185 g | 640 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "79b3cbd6c453de1d211b89dbd015c0fc",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461140",
                                  "name": "Creamy Spinach & Corn Pocket",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "\"A creamy spinach and corn filling encased in a buttery French style dough.\nServing size (g/ml) - 160g/358kcal.\nAllergen - Contains Wheat, Milk.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "eba054eb104dc6f270ba2d7b4f217723",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412929",
                                  "name": "Overnight Blueberry Soaked Oats",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Overnight oats soaked in creamy yogurt topped with honey granola and berries.\nServing size 180 g | 375 kcal\nAllergens - Soy, Milk, Wheat, Barley, Oat, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "190f240ad3275ba73feb833f434fc7f6",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "123412930",
                                  "name": "Overnight Honey & Pineapple Soaked Oats",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Overnight oats soaked in creamy yogurt, layered with pineapple chunks and topped with honey & almond granola.\nServing size 180 g | 352 kcal\nAllergens - Soy, Milk, Wheat, Barley, Oat, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "4eba2adff350f883d94566d69a0aacdc",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "103604532",
                                  "name": "Three dip Chips",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Crispy Tortilla Chips loaded with peri peri cheesy dip, spicy tomato salsa & cream cheese. Share with your friends loaded with delightful dip.\nServing size (g/ml) - 180g/498kcal.\nAllergen - Contains Milk, Wheat, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "439dff959b92c08625af92c8e3a10c70",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461143",
                                  "name": "Chilly Chicken in English Muffin",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "\"A chilly chicken filling on a bed of chopped spinach topped with omelette & cheese in an English style muffin.\nServing size (g/ml) - 160g/529kcal.\nAllergen - Contains Soy, Wheat, Milk, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "57b3349d431ca867635551248acf9bc3",
                                  "inStock": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100711606",
                                  "name": "Chilli Paneer in Herbed Bun",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "A tangy chilli paneer filling topped with sliced cheese in a herbed bun.\nServing size (g/ml) - 160g/598kcal.\nAllergen - Soy, Wheat, Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "c4674a536e6fc96e45a6cc2c27a497c9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716501",
                                  "name": "Chilli Cheese Toast",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "\"Cheesy and fiery snack on a toasted French-style baguette, topped with red, yellow and green pepper and chopped green chilli. 2 pieces per portion.\nServing size (g/ml) - 140g/479kcal.\nAllergen - Contains Wheat, Milk, Soy, Rye, Oat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "458dd3d9e8d3f5c5a039add46980700c",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "118194586",
                                  "name": "Rayalaseema Mutton Bun Bom",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Minced mutton wrapped in a blend of spices and herbs, stuffed in a dough bun and sprinkled with chili flakes.   \nServing size (g/ml) - 120g/236kcal\nAllergen - Contains  Wheat, Soy, Rye, Oat\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "15b01ce4f84b6cc3c3a302171724b76c",
                                  "price": 36000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Wraps",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716514",
                                  "name": "Murgh Kathi Wrap",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Spicy melange of chicken, onion, peppers and cheddar cheese packed in a tortilla wrap.\nServing size (g/ml) - 180g/398.9kcal\nAllergen - Contains Wheat, Milk, Soy, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\n",
                                  "imageId": "bce70f553a75592ca923cc537b5b2ede",
                                  "price": 35500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "118194585",
                                  "name": "Koli Menasu Wrap",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Spicy chicken filling with egg and hints of curry leaves and black pepper wrapped in a tortilla wrap  \nServing size (g/ml) - 215g/695kcal\nAllergen - Contains  Soy, Milk, Nut, Egg, Wheat\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "41600fca9d1c64078ca930edf3b2c8ad",
                                  "price": 37500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716507",
                                  "name": "Chatpata Paratha Wrap",
                                  "category": "Puffs, Wraps, Sandwiches & Savoury Snacks",
                                  "description": "Tangy paneer and vegetable filling wrapped in spinach paratha.\nServing size (g/ml) - 180g/465kcal.\nAllergen - Contains Wheat, Milk, Soy, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "7fcbc469281a22c5555455abc913e774",
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Christmas Gift Hampers 20% off",
                      "categories": [
                        {
                          "title": "Christmas Gift Hampers 20% off",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121991363",
                                  "name": "Tall Java Chip Frappuccino with Hazelnut Triangle",
                                  "category": "Christmas Gift Hampers 20% off",
                                  "description": "\"We blend mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle to bring you endless java joy with A Pastry with layers of hazelnut meringue and buttercream.\nEnergy per serving size - Tall (354ml) - 392 kcal.\nServing size (g/ml) - 50g/302kcal.\nAllergen - Contains Milk, Egg, Wheat, Barley, Soy, Nut.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "2925bad2e7bcce7d70fb076658aa260d",
                                  "inStock": 1,
                                  "price": 46800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121991364",
                                  "name": "Tall Double Chocolate Chip Frappuccino with Blueberry Muffin",
                                  "category": "Christmas Gift Hampers 20% off",
                                  "description": "\"Rich mocha-flavoured sauce meets up with chocolaty chips, milk and ice. Top it off with sweetened whipped cream and mocha drizzle for a real party in your mouth with Buttery vanilla cake with blueberries dusted with granulated sugar for a delightfully crunchy texture.\nEnergy per serving size - Tall (354ml) - 415 kcal.\nServing size (g/ml) - 120g/376kcal.\nAllergen - Contains Wheat, Milk, Soy, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "5d9a11cc54ccb09ecc7b07d008b3611a",
                                  "inStock": 1,
                                  "price": 56800,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121991365",
                                  "name": "Tall Cold coffee with Double Chocolate Chip Cookie",
                                  "category": "Christmas Gift Hampers 20% off",
                                  "description": "\"Our rich in flavour espresso blended with delicate vanilla flavour and milk to create a perfect cold coffee delight. An all-time favourite with A soft & chewy chocolate cookie topped with chocolate chips for the perfect textured bite.\nEnergy per serving size - Tall (354ml) - 353 kcal.\nServing size (g/ml) - 80g/385kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "9f93d687cb5d72f6048d3004e86aa10a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 51600,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121991367",
                                  "name": "Tall Cold coffee with New York Cheesecake",
                                  "category": "Christmas Gift Hampers 20% off",
                                  "description": "\"Our rich in flavour espresso blended with delicate vanilla flavour and milk to create a perfect cold coffee delight. An all time favourite with The Classic New York Cheese cake with a rich, creamy satiny texture and a crumbly biscuit base. Served along with Strawberry jam on the side. \nEnergy - Tall (354ml) - 353 kcal.\nServing size (g/ml) - 150g/485kcal.\nAllergen - Contains Wheat, Milk, Soy, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "19a599dc5493848dfb6f92288bd63af1",
                                  "inStock": 1,
                                  "price": 60400,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "121991366",
                                  "name": "Tall Signature Hot Chocolate with Chocolate Brownie Cupcake",
                                  "category": "Christmas Gift Hampers 20% off",
                                  "description": "\"Four cocoas and freshly steamed milk topped with chocolate powder with A gooey and fudgy walnut brownie loaded with chocolate. 2 pieces per portion.\nEnergy per serving size - Tall (354ml) - 446 kcal.\nServing size (g/ml) - 80g/416kcal.\nAllergens - Soy, Wheat, Milk, Nut.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "79e914aab188e521da0eb5eff4732472",
                                  "isVeg": 1,
                                  "price": 49200,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cold Coffee, Milkshake & Frappuccino",
                      "categories": [
                        {
                          "title": "Cold Coffee & Milkshakes",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461132",
                                  "name": "Cold coffee",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Our signature rich in flavour espresso blended with delicate vanilla flavour and milk to create a perfect cold coffee delight. An all time favourite. Allergen - Contains Milk, Tall: 354 ML, 354 kcal, Grande: 473 ML, 473 kcal, Venti: 591 ML, 501 kcal.An average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "a96e63604672f1495f6b6239f5359885",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765288",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527994",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527995",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765289",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527996",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527997",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684744",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684745",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286807",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684746",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427311",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427310",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "18 ratings",
                                      "ratingCountV2": "18"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805507",
                                  "name": " Chocolate Milkshake",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Our Starbucks signature chocolate perfected for you as a smooth and delightful milkshake. Happiness in every sip.\nEnergy  - Tall (354ml) - 632 kcal / Grande (473ml) - 825 kcal / Venti (591ml) 1050 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "ddffd6918a67a3e5f37a7bd3c21fb450",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826421",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212383",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212384",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212385",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765291",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528001",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90528002",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684747",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684748",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427311",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805504",
                                  "name": "Strawberry Milkshake",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "A Delicious milkshake for those with a sweet tooth and love our favourite berry, Strawberry.\nEnergy  - Tall (354ml) - 569 kcal / Grande (473ml) - 769 kcal / Venti (591ml) 943 kcal.\nAllergen - Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "e7c3aad38b061ab1e09d2fa829843a37",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765292",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90528003",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90528004",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90528005",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765293",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528006",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90528007",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684749",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684750",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427311",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805502",
                                  "name": "Vanilla Milkshake",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Your favourite Vanilla milkshake is now at Starbucks. A perfect delight for any mood.\nEnergy  - Tall (354ml) - 531 kcal / Grande (473ml) - 700 kcal / Venti (591ml) 920 kcal.\nAllergen - Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "35e43f1e67336d6464f569dd22703adf",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765294",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90528008",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90528009",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90528010",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765295",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528011",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90528012",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684751",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684752",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Frappuccino.",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716753",
                                  "name": "Coffee Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Coffee meets milk and ice in a blender and together they create one of our original Frappuccino? beverages.\nEnergy  - Tall (354ml) - 208.6 kcal / Grande (473ml) - 306.87 kcal / Venti (591ml) 391.98 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\n",
                                  "imageId": "a96e63604672f1495f6b6239f5359885",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765268",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527914",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527915",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90527916",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765269",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527917",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527918",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527919",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527920",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527921",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684712",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684713",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684714",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "81 ratings",
                                      "ratingCountV2": "81"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461158",
                                  "name": "Mocha  Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Coffee with rich mocha sauce blended with milk and ice. Topped with sweetened whipped cream.\nEnergy  - Tall (354ml) - 341.7 kcal / Grande (473ml) - 470.31 kcal / Venti (591ml) 585.42 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "57d5ab91750bf825caf36de7caf89e76",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826416",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212366",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212367",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212368",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765281",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527965",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527966",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527967",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527968",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527969",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684718",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684719",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684720",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "12 ratings",
                                      "ratingCountV2": "12"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117747453",
                                  "name": "Java Chip Frappuccino.",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "We blend mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle to bring you endless java joy.\nEnergy  - Tall (354ml) - 391.7 kcal / Grande (473ml) - 536.19 kcal / Venti (591ml) 667.4 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "434146cff15b354b9dc1b6273a9afede",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826415",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212363",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212364",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212365",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765271",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527925",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527927",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527928",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527929",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684715",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684716",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684717",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "96 ratings",
                                      "ratingCountV2": "96"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716755",
                                  "name": "Vanilla Cream Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "This rich and creamy blend of vanilla, milk and ice topped with whipped cream takes vanilla flavour to another level.\nEnergy  - Tall (354ml) - 345.1 kcal / Grande (473ml) - 474.75 kcal / Venti (591ml) 591.72 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "dd9d369cc7ecf3fa8f7487cefe0df410",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765272",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527930",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90527932",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527931",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765273",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527933",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527934",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527935",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527936",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527937",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684721",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684722",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684723",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.2",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716754",
                                  "name": "Espresso Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Coffee is combined with a shot of espresso and milk, then blended with ice to give you a nice little jolt and lots of sipping joy.\nEnergy  - Tall (354ml) - 194.8 kcal / Grande (473ml) - 292.78 kcal / Venti (591ml) 378.2 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "941109213cfd61b695033c90c8e0bf1f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765274",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527938",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527939",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90527940",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765275",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527941",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527942",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527943",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527944",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527945",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684724",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684725",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684726",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.1",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716752",
                                  "name": "Caramel Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "A blend of coffee, sweet caramel syrup, milk and ice topped with whipped cream and a swirl of caramel drizzle.\nEnergy  - Tall (354ml) - 364.5 kcal / Grande (473ml) - 485.42 kcal / Venti (591ml) 601.65 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "f59a4ebafc1381f2ee49c5a2ce6e93ae",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765276",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527946",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527947",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90527948",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765277",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527949",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527950",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527951",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527952",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527953",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684727",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684728",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684729",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "89 ratings",
                                      "ratingCountV2": "89"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461157",
                                  "name": "Strawberries & Cr?me Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Strawberries and milk are blended with ice and topped with a swirl of whipped cream.\nEnergy  - Tall (354ml) - 530.2 kcal / Grande (473ml) - 752.87 kcal / Venti (591ml) 962.58 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\n",
                                  "imageId": "99b80e8043d2b904a6dee1984a14c67f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 38500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765278",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "90527954",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "90527955",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "90527956",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765279",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527957",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527958",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527959",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527960",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527961",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684730",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286771",
                                          "name": "Strawberry Syrup Modifier",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684731",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427311",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427310",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151107",
                                  "name": "White Mocha Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "White chocolate Frappuccino is a blend of coffee, white chocolate sauce, milk and ice. Topped with sweetened whipped cream.\nEnergy  - Tall (354ml) - 370.7 kcal / Grande (473ml) - 538.87 kcal / Venti (591ml) 643.58 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "8aaebd72bc16a8d1c34f0b74a4b105df",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826417",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212369",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212371",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212370",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765283",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527973",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527974",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527975",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527976",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527977",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684732",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684733",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684734",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.3",
                                      "ratingCount": "35 ratings",
                                      "ratingCountV2": "35"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716751",
                                  "name": "Caramel Java Chip Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Coffee with rich mocha flavoured sauce blended with milk chocolaty chips, caramel syrup and ice. Topped with sweetened whipped cream and chocolate drizzle.\nEnergy  - Tall (354ml) - 398 kcal / Grande (473ml) - 574.16 kcal / Venti (591ml) 714.18 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "3c7b2ce395ed7658612e7b2f212f1b8d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 44000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826418",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212372",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212374",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212373",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "29826419",
                                        "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "93212375",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "93212376",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "93212377",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "93212379",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "93212378",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684735",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684736",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684737",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "23 ratings",
                                      "ratingCountV2": "23"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716757",
                                  "name": "Double Chocolate Chip Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "Rich mocha-flavoured sauce meets up with chocolaty chips, milk and ice. Top it off with sweetened whipped cream and mocha drizzle for a real party in your mouth.\nEnergy  - Tall (354ml) - 414.9 kcal / Grande (473ml) - 580.35 kcal / Venti (591ml) 729.42 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "7eca19e43a0014e011e36752dfdb6b0e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "29826420",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "93212380",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "93212381",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "93212382",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765287",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90527989",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90527990",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90527991",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90527992",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90527993",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684738",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684739",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684740",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "61 ratings",
                                      "ratingCountV2": "61"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716510",
                                  "name": "Green Tea Cream Frappuccino",
                                  "category": "Cold Coffee, Milkshake & Frappuccino",
                                  "description": "We blend sweetened premium matcha?green?tea, milk and ice and top it with sweetened whipped cream to give you a delicious boost of energy.\nEnergy  - Tall (354ml) - 412.4 kcal / Grande (473ml) - 575.94 kcal / Venti (591ml) 726.64 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "8494064d33646e4697dc7f56f0908a78",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820497",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674588",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "107674590",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "107674589",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820498",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674591",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674592",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674593",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674594",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674595",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684741",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684742",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684743",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cold Beverages (Iced Coffee)",
                      "categories": [
                        {
                          "title": "Cold brews",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716520",
                                  "name": "Cold Brew Black",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Starbucks Kenya coffee is freshly ground and then steeped for 48 hours. This artisanal process results in deliciously iced coffee that is served over ice, unsweetened.\nEnergy  - Nil , Allergen - Nil\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "35949f79295efd13d1456ce8f87805ef",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765296",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528013",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 4000,
                                            "id": "90528014",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7500,
                                            "id": "90528015",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "94723568",
                                      "groupName": "Non-dairy Alternatives / Milk",
                                      "choices": [
                                        {
                                          "id": "92357452",
                                          "name": "Regular milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92357453",
                                          "name": "Skimmed Milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427312",
                                          "name": "Soy Milk",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427313",
                                          "name": "Oats Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427314",
                                          "name": "Almond Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684753",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "75 ratings",
                                      "ratingCountV2": "75"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716524",
                                  "name": "Vanilla Sweet Cream Cold Brew",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Cold brew with Vanilla Sweet Cream is made with Starbucks cold brew over ice and topped with a house made vanilla sweet cream, which floats on top of the beverage before slowly cascading down.\nEnergy  - Tall (354ml) - 63 kcal / Grande (473ml) - 84 kcal / Venti (591ml) 104.97 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "25acb2b6f55939cf70d98678cd2c5e30",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 40000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765297",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528016",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 4000,
                                            "id": "90528017",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7500,
                                            "id": "90528018",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765298",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528019",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684754",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "166 ratings",
                                      "ratingCountV2": "166"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461161",
                                  "name": "White mocha caramel Cold Brew",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Our slow steeped Cold brew shaken with milk and white chocolate to strike the perfect balance of coffee and sweetness.\nEnergy  - Tall (354ml) - 193.6 kcal / Grande (473ml) - 288.85 kcal / Venti (591ml) 371.65 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "7aad9626ae5348c35d80a6fb4c2f4f81",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765299",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528020",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 4000,
                                            "id": "90528021",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7500,
                                            "id": "90528022",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765300",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528023",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684755",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427315",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115129012",
                                  "name": "Cold Brew Malt",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Our Cold Brew blended with vanilla ice cream and malt. A classic ice cream?beverage.\nEnergy  - 187 kcal/ 100ml. Size 412 ml\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "1132d862a8aa1a1e9c35ffe80393e1ce",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 48000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820499",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall Cold Brew Malt",
                                            "default": 1,
                                            "id": "107674596",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820500",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674597",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684756",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286993",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427316",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Iced Beverages",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461159",
                                  "name": "Iced Caff? Americano",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Espresso shots are topped with water to produce a light layer of crema, then served over ice.\nEnergy  Nil, Allergen Nil.\nServing size Tall (354ml) / Grande (473ml) / Venti (591ml).",
                                  "imageId": "7929088409382fd2a917275d70e58b15",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765303",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528026",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 3500,
                                            "id": "90528027",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7000,
                                            "id": "90528028",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684757",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "94723574",
                                      "groupName": "Non-dairy Alternatives / Milk",
                                      "choices": [
                                        {
                                          "id": "92357452",
                                          "name": "Regular milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92357453",
                                          "name": "Skimmed Milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427312",
                                          "name": "Soy Milk",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427313",
                                          "name": "Oats Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427314",
                                          "name": "Almond Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684758",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "11 ratings",
                                      "ratingCountV2": "11"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461160",
                                  "name": "Iced Caff? Latte",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Our dark, rich espresso balanced with milk. Our Iced Latte turns your favourite morning beverage into a refreshing drink that you can enjoy at any time of the day.\nEnergy  - Iced - Tall (354ml) - 121.59 kcal / Grande (473ml) - 157.5 kcal / Venti (591ml) - 176.4 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "32632f33976aede26beb407156b51057",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 32500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765304",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528029",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 3500,
                                            "id": "90528030",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7000,
                                            "id": "90528031",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765305",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528032",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90528033",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90528034",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90528035",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90528036",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684759",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684760",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716603",
                                  "name": "Iced Shaken Hibiscus & Passion Lemonade",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Our blend of hibiscus, lemongrass and apple is slightly sweetened and hand shaken with ice for a refreshing vibrant flavour.\nEnergy  - Tall: 354 ML, 74 kcal, Grande: 473 ML, 111 kcal, Venti: 591 ML, 149 kcal.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "637587e4d95cf0d6a962017feb5befc7",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 34000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765306",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528037",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 4000,
                                            "id": "90528038",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7500,
                                            "id": "90528039",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684761",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.8",
                                      "ratingCount": "22 ratings",
                                      "ratingCountV2": "22"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "81537066",
                                  "name": "Iced Caramel Macchiato",
                                  "category": "Cold Beverages (Iced Coffee)",
                                  "description": "Sweet. Creamy. And chilled to perfection. Rich espresso, milk and vanilla syrup are topped with caramel for a delightfully refreshing start to your day.\nEnergy  - Iced - Tall (354ml) - 209.59 kcal / Grande (473ml) - 287 kcal / Venti (591ml) - 325.36 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "8c022e30f7482347c6a7248c366d2059",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 39500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "28765307",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "90528040",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED GRANDE",
                                            "price": 3500,
                                            "id": "90528041",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "ICED VENTI",
                                            "price": 7000,
                                            "id": "90528042",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "28765308",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "90528043",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "90528044",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "90528045",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "90528046",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "90528047",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684762",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684763",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.0",
                                      "ratingCount": "19 ratings",
                                      "ratingCountV2": "19"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Hot Beverages",
                      "categories": [
                        {
                          "title": "Hot Coffee",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128973",
                                  "name": "Cappuccino..",
                                  "category": "Hot Beverages",
                                  "description": "Dark, rich espresso lies in wait under a smoothed and stretched layer of thick foam. It's truly the height of our baristas' craft.\nEnergy per serving size - Hot - Short (237ml) 103.8 kcal / Tall (354ml) - 103.8 kcal / Grande (473ml) - 173 kcal / Venti (591ml) 220.18 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "55904772a4328bfeff407ea73bf76c85",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820501",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674598",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Tall Cappuccino",
                                            "price": 3000,
                                            "id": "107674599",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674600",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674601",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820502",
                                        "name": "Milk / Non-dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674602",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674603",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674604",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674605",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674606",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684764",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684765",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427293",
                                          "name": "Espresso shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684766",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427297",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "225 ratings",
                                      "ratingCountV2": "225"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716718",
                                  "name": "Caffe Latte",
                                  "category": "Hot Beverages",
                                  "description": "Our dark, rich espresso balanced with steamed milk and a light layer of foam. A perfect milk forward warm up.\nEnergy per serving size - Hot - Short (237ml) - 103.8 kcal / Tall (354ml) - 173 kcal / Grande (473ml) - 220.2 kcal / Venti (591ml) 289.4 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "879e3f36c309519bd089ce9a8d13746f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820503",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674607",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674608",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674609",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674610",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820504",
                                        "name": "Milk / Non-dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674611",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674612",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674613",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674614",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674615",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684767",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684768",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427317",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684769",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427318",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "124 ratings",
                                      "ratingCountV2": "124"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "117747455",
                                  "name": "Caffe Americano.",
                                  "category": "Hot Beverages",
                                  "description": "Rich in flavour, full-bodied espresso with hot water in true European style. Short: 237 ML, 0 kcal, Tall: 354 ML, 0 kcal, Grande: 473 ML, 0 kcal, Venti: 591 ML, 0 kcal.An average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "a45fc95997eeb22c6c21b6b1fd9fade2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820505",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674616",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674617",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674618",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674619",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684770",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684771",
                                      "groupName": "Non-dairy Alternatives / Milk",
                                      "choices": [
                                        {
                                          "id": "92357452",
                                          "name": "Regular milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "92357453",
                                          "name": "Skimmed Milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427312",
                                          "name": "Soy Milk",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427313",
                                          "name": "Oats Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427314",
                                          "name": "Almond Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684772",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684773",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "184 ratings",
                                      "ratingCountV2": "184"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716740",
                                  "name": "Flat White",
                                  "category": "Hot Beverages",
                                  "description": "\"Expertly steamed milk poured over Ristretto shots of espresso and finished with a Starbucks dot.\nHot - Short (237ml) - 103.8 kcal / Tall (354ml) - 173 kcal / Grande (473ml) - 220.18 kcal / Venti (591ml) 289.38 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "8c22a38997cd0a8a8811c6654ab5565d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820506",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674620",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674621",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674622",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674623",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820507",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674624",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674625",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674626",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674627",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674628",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684774",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684775",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684776",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "83 ratings",
                                      "ratingCountV2": "83"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461151",
                                  "name": "Hazelnut Caffe Latte",
                                  "category": "Hot Beverages",
                                  "description": "\"Our dark, rich espresso balanced with Hazelnut flavored syrup, steamed milk and a light layer of foam.\nHot - Short (237ml) - 129.8 kcal / Tall (354ml) - 199 kcal / Grande (473ml) - 246.2 kcal / Venti (591ml) 315.4 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "1a9fdce66bf505e44187be24c8279649",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820508",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674629",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674630",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674631",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674632",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820509",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674633",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674634",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674635",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674636",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674637",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684777",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684778",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684779",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461153",
                                  "name": "Vanilla Caffe Latte",
                                  "category": "Hot Beverages",
                                  "description": "\"Our dark, rich espresso balanced with vanilla flavored syrup, steamed milk and a light layer of foam.\nHot - Short (237ml) - 124.8 kcal / Tall (354ml) - 194 kcal / Grande (473ml) - 241.2 kcal / Venti (591ml) 310.4 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "68ee40a1b229ac0fc54c955b81190c91",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820510",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674638",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674639",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674640",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674641",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820511",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674642",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674643",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674644",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674645",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674646",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684780",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684781",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684782",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151104",
                                  "name": "White Chocolate Mocha",
                                  "category": "Hot Beverages",
                                  "description": "\"Our signature espresso meets white chocolate sauce and steamed milk in this white chocolate delight.\nHot - Short (237ml) - 251.8 kcal / Tall (354ml) - 395 kcal / Grande (473ml) - 451.38 kcal / Venti (591ml) 563.74 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "c3be401a767e1112eb08332238e23486",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 33500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820512",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674647",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674648",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674649",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674650",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820513",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674651",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674652",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674653",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674654",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674655",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684783",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684784",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684785",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "30 ratings",
                                      "ratingCountV2": "30"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461152",
                                  "name": "Caff? Mocha",
                                  "category": "Hot Beverages",
                                  "description": "\"We combine our Rich in flavour, full-bodied espresso with bittersweet mocha sauce and steamed milk. The classic coffee drink to satisfy your sweet tooth.\nHot - Short (237ml) - 232 kcal / Tall (354ml) - 335.7 kcal / Grande (473ml) - 391.1 kcal / Venti (591ml) 472.7 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "3025f8a9c06ea45d6b44ec51a387d617",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 33500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820514",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674656",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674657",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674658",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674659",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820515",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674660",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674661",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674662",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674663",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674664",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684786",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684787",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684788",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.9",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "35337428",
                                  "name": "Caramel Macchiato",
                                  "category": "Hot Beverages",
                                  "description": "\"Freshly steamed milk with vanilla-flavored syrup is marked with espresso and topped with caramel drizzle.\nHot - Short (237ml) - 162.2 kcal / Tall (354ml) - 255.2 kcal / Grande (473ml) - 333.1 kcal / Venti (591ml) 426.1 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "1941c60d2aceaa617548dd5273ae5eec",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 36500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820516",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674665",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674666",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674667",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674668",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820517",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674669",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674670",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674671",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674672",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674673",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684789",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684790",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684791",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Chai & Filter Coffee",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805316",
                                  "name": "Filter Coffee",
                                  "category": "Hot Beverages",
                                  "description": "Your favourite South Indian filter coffee prepared using a blend of our medium and dark roast coffees. Unreasonably perfect.\nEnergy  - Hot - Picco (180ml) / Short (236ml) - 226 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "0c685119085657406f83377693bc1a70",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34951773",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Short Filter Coffee",
                                            "default": 1,
                                            "id": "108268684",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34951774",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "108268685",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.8",
                                      "ratingCount": "8 ratings",
                                      "ratingCountV2": "8"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716535",
                                  "name": "Green Tea Latte",
                                  "category": "Hot Beverages",
                                  "description": "\"Smooth and creamy matcha is lightly sweetened and served with steamed milk\nHot - Short (237ml) - 171.2 kcal / Tall (354ml) - 240.4 kcal / Grande (473ml) - 321.28 kcal / Venti (591ml) 424.18 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "e0564cbe64a6cbdbebadcc6e6672186e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820523",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674679",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674680",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674681",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674682",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820524",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674683",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674684",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674685",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674686",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674687",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684792",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684793",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "25 ratings",
                                      "ratingCountV2": "25"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716532",
                                  "name": "Chai Tea Latte",
                                  "category": "Hot Beverages",
                                  "description": "\"Black tea infused with cinnamon, clove, and other warming spices are combined with milk for the perfect balance of sweet and spicy\nHot - Short (237ml) - 169.84 kcal / Tall (354ml) - 203 kcal / Grande (473ml) - 305.07 kcal / Venti (591ml) 385.27 kcal\nAllergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"\n",
                                  "imageId": "fa43c02ef546cb60eb92c03de562d52d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820525",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674688",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674689",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674690",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674691",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820526",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674692",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674693",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674694",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674695",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674696",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684794",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684795",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.3",
                                      "ratingCount": "21 ratings",
                                      "ratingCountV2": "21"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Signature Hot Chocolate",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716527",
                                  "name": "Signature Hot Chocolate",
                                  "category": "Hot Beverages",
                                  "description": "Four cocoas and fresh steamed milk topped with chocolate powder.\nEnergy per serving size - Hot - Short (237ml) - 283.99 kcal / Tall (354ml) - 445.89 kcal / Grande (473ml) - 580.13 kcal / Venti (591ml) 735.16 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "22a7de0a911ce1409758c05769c5fc4b",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 30000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820527",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674697",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674698",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674699",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674700",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820528",
                                        "name": "Dairy(Milk)/Non-Dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674701",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674702",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674703",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674704",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674705",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684796",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684797",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "107427319",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427316",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427296",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427295",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427320",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427321",
                                          "name": "Hazelnut Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96235117",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 9,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.8",
                                      "ratingCount": "182 ratings",
                                      "ratingCountV2": "182"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Croissants",
                      "categories": [
                        {
                          "title": "Croissants.",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461135",
                                  "name": "Butter Croissant.",
                                  "category": "Croissants",
                                  "description": "A flaky and buttery French style pastry served with butter.\nServing size (g/ml) - 75g/255kcal.\nAllergen - Contains Wheat, Barley, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "f6fe5c49d4e670df5632783f5830f5d1",
                                  "inStock": 1,
                                  "price": 28500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "10 ratings",
                                      "ratingCountV2": "10"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805359",
                                  "name": "Malabari Egg Croissant",
                                  "category": "Croissants",
                                  "description": "A South Indian Malabari inspired spiced egg filling with hints of coconut encased in a croissant with sesame seeds on top.\nServing size (g/ml) - 180g/591kcal.\nAllergen - Contains Wheat, Milk, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "1e76fd2396c5be2cc13842e9eb56b6e2",
                                  "inStock": 1,
                                  "price": 26500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652422",
                                  "name": "Classic Cinnamon Swirl",
                                  "category": "Croissants",
                                  "description": "A classic croissant based cinnamon roll.\nContains - Milk, Wheat\n80 g | 424 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "d403f5d952371577e77aec16da44cb62",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 22000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652423",
                                  "name": "Smoked Chicken and Cranberry Croissant",
                                  "category": "Croissants",
                                  "description": "A French style creamy twist of smoked chicken, cranberries and cheddar cheese in a polenta and paprika croissant.\nContains - Milk, Wheat\n150 g | 658 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "3ab3710b7d3d6c8d22a87194da6b4d85",
                                  "inStock": 1,
                                  "price": 39000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461134",
                                  "name": "Butter Croissant Add on Preserve",
                                  "category": "Croissants",
                                  "description": "A flaky and buttery French style pastry served with Jam.\nServing size (g/ml) - 75g/255kcal.\nAllergen - Contains Wheat, Barley, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "4ef38e705856d07085534c6273c41c3c",
                                  "inStock": 1,
                                  "price": 33000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "2.6",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461133",
                                  "name": "Egg White & Chicken in Multigrain Croiss",
                                  "category": "Croissants",
                                  "description": "Fluffy egg white omelette and chicken ham sandwiched in multigrain croissant.\nServing size (g/ml) - 200g/541kcal.\nAllergen - Contains Wheat, Oats, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "b717f5cafb9785cd212a6ff489cb4ef3",
                                  "inStock": 1,
                                  "price": 37500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.6",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "125652421",
                                  "name": "Chicken Ham & Cheese Swirl",
                                  "category": "Croissants",
                                  "description": "The comfort of chicken ham & cheese in a croissant swirl.\nContains - Milk, Wheat\n80 g | 351 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "20ba8744ee24057291ef4dc96386a37f",
                                  "price": 25000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Holiday Classics from The Archies",
                      "categories": [
                        {
                          "title": "Hot",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128742241",
                                  "name": "Veronica's Toffee Nut Crunch Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Delight your senses with our Toffee Nut Crunch Latte. A perfect combination of steamed milk, our signature espresso, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with graham crackers.\nServing size (ml)/Calories (kcal) - Short: 237 ML, 225 kcal, Tall: 354 ML, 343 kcal, Grande: 431 ML, 419 kcal, Venti: 591 ML, 527 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "88b74d9742ef06d740c6d0825653a2e9",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34655897",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Hot Short",
                                            "default": 1,
                                            "id": "107157904",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tall",
                                            "price": 4000,
                                            "id": "107157905",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Grande",
                                            "price": 8000,
                                            "id": "107157906",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Venti",
                                            "price": 12000,
                                            "id": "107157907",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34655898",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107157908",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107157909",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107157910",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107157911",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107157912",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124014108",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014109",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "96235117",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014110",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598717",
                                  "name": "Archie's Crunchy Red Hat Mocha",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Almost too cute to drink, our Crunchy Red Hat Mocha Latte combines steamed milk, our signature espresso, decadent mocha topped with strawberry drizzle, finished with crunchy graham crackers. This beverage is not just a delight for your eyes but also a party in your mouth.\nServing size (ml)/Calories (kcal) - Short: 237 ML, 415 kcal, Tall: 354 ML, 621 kcal, Grande: 431 ML, 797 kcal, Venti: 591 ML, 994 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "c45caa7480f08f666190dbe569319c2d",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557859",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Hot Short",
                                            "default": 1,
                                            "id": "106730351",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Tall",
                                            "price": 4000,
                                            "id": "106730352",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Grande",
                                            "price": 8000,
                                            "id": "106730353",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Venti",
                                            "price": 12000,
                                            "id": "106730354",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557860",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730355",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730356",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730357",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730358",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730359",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711766",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711767",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711768",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598719",
                                  "name": "Betty's Chestnut Mont Blanc Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Inspired by the french dessert of the same name, our Chestnut Mont Blanc Latte showcases the harmony between the earthy and nutty notes of chestnut, steamed milk, and our signature espresso. Topped with a luscious chestnut sauce drizzled over it.\nServing size (ml)/Calories (kcal) - Short: 237 ML, 233 kcal, Tall: 354 ML, 347 kcal, Grande: 431 ML, 420 kcal, Venti: 591 ML, 524 kcal\nAllergen - Contains Wheat, Milk, Nut, Oat, Soy.",
                                  "imageId": "3d5701dbb740511622348a8c459bca08",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557861",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Hot Short",
                                            "default": 1,
                                            "id": "106730360",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Tall",
                                            "price": 4000,
                                            "id": "106730361",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Grande",
                                            "price": 8000,
                                            "id": "106730362",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Venti",
                                            "price": 12000,
                                            "id": "106730363",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557862",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730364",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730365",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730366",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730367",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730368",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711770",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711771",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711772",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579178",
                                  "name": "Jughead's Gingerbread Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Get your festive cheer on with our Gingerbread Latte. Sweet and delicately spicy gingerbread flavors mingle with our signature espresso and steamed milk, topped with sprinkles with a spice blend that tastes just like the holidays.\nServing size (ml)/Calories (kcal) - Short: 237 ML, 204 kcal, Tall: 354 ML, 322 kcal, Grande: 431 ML, 399 kcal, Venti: 591 ML, 507 kcal\nAllergen - Contains Wheat, Milk, Nut.",
                                  "imageId": "d9c1d1cb6c95cba08f9cb19b070d0266",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 42500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35266063",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Hot Short",
                                            "default": 1,
                                            "id": "109149607",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 4000,
                                            "id": "109149608",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Grande",
                                            "price": 8000,
                                            "id": "109149609",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Venti",
                                            "price": 12000,
                                            "id": "109149610",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35266064",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109149611",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "109149612",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "109149613",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "109149614",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "109149615",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125889552",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889553",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889554",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Frappuccino",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598720",
                                  "name": "Veronica's Toffee Nut Crunch Crème Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Delight your senses with our Toffee Nut Crème Frappuccino. A perfect blend of milk, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with toffee nut whipped cream and graham crackers. A coffee free offering.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 372 kcal, Grande: 431 ML, 501 kcal, Venti: 591 ML, 618 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "ce473bc379086e3c2de271fafceb1db8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557863",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "106730369",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "106730370",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "106730371",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557864",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730372",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730373",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730374",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730375",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730376",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711773",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711774",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711775",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128742243",
                                  "name": "Veronica's Toffee Nut Crunch Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Delight your senses with our Toffee Nut Frappuccino. A perfect blend of milk, coffee, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with toffee nut whipped cream and graham crackers.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 358 kcal, Grande: 431 ML, 480 kcal, Venti: 591 ML, 589 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "ce473bc379086e3c2de271fafceb1db8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34655899",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Blended Tall",
                                            "default": 1,
                                            "id": "107157913",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "107157914",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "107157915",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34655900",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107157916",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107157917",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107157918",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107157919",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107157920",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124014111",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014112",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014113",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598721",
                                  "name": "Archie's Crunchy Red Hat Mocha Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Almost too cute to drink, our Crunchy Red Hat Mocha Frappuccino is a perfect blend of milk, smooth coffee, decadent mocha, a generous amout of vanilla whipped cream topped with a chocolate whipped cream hat and strawberry drizzle, finished with crunchy graham crackers. This beverage is not just a delight for your eyes but also a party in your mouth.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 552 kcal, Grande:431ML,755 kcal, Venti: 591ML,908kcal\nAllergen -Contains Wheat,Soy,Milk,Oat.",
                                  "imageId": "e9dfa7e9fb9bacced404fdc9dd139c78",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557865",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "106730377",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "106730378",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "106730379",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557866",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730380",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730381",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730382",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730383",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730384",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711776",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711777",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711778",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286993",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711779",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "106515702",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "106515703",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598722",
                                  "name": "Betty's Chestnut Mont Blanc Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Inspired by the french dessert of the same name, our Chestnut Mont Blanc Frappuccino showcases the harmony between the earthy and nutty notes of chestnut, blended with milk and coffee with a layer of chestnut whipped cream in between. Topped with a luscious chestnut whipped cream and chestnut sauce drizzled over it.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 407 kcal, Grande: 431 ML, 539 kcal, Venti: 591 ML, 572 kcal\nAllergen - Contains Wheat, Milk, Nut, Oat, Soy.",
                                  "imageId": "54a2ac98f24fb2c5475df4840496fa19",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557867",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Blended Tall",
                                            "default": 1,
                                            "id": "106730385",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "106730386",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "106730387",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557868",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730388",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730389",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730390",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730391",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730392",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711780",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711781",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711782",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711783",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579179",
                                  "name": "Jughead's Gingerbread Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Get your festive cheer on with our Gingerbread Frappuccino. Sweet and delicately spicy gingerbread flavors blended with milk, and smooth coffee, topped with gingerbread whipped cream sprinkled with a spice blend that tastes just like the holidays.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 337 kcal, Grande: 431 ML, 459 kcal, Venti: 591 ML, 568 kcal\nAllergen - Contains Milk.",
                                  "imageId": "f620fee75beb24a00ec87084c31fefa5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35266065",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109149616",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "109149617",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "109149618",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35266066",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109149619",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "109149620",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "109149621",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "109149622",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "109149623",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "126382279",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889555",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889556",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579180",
                                  "name": "Jughead's Gingerbread Creme Frappuccino",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Get your festive cheer on with our Gingerbread Crème Frappuccino. Sweet and delicately spicy gingerbread flavors blended with milk, topped with gingerbread whipped cream and sprinkled with a spice blend that tastes just like the holidays. A coffee free offering.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 351 kcal, Grande: 431 ML, 480 kcal, Venti: 591 ML, 597 kcal\nAllergen - Contains Milk.",
                                  "imageId": "f620fee75beb24a00ec87084c31fefa5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 49000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35266068",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "109149625",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Grande",
                                            "price": 4500,
                                            "id": "109149626",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Blended Venti",
                                            "price": 9000,
                                            "id": "109149627",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35266069",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109149628",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "109149629",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "109149630",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "109149631",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "109149632",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125889557",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139615",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 8,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Brewed Coffee",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128742244",
                                  "name": "Veronica's Toffee Nut Crunch Cold Brew",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Our small-batch cold brew—slow-steeped for a super-smooth taste—gets even better. Paired with the buttery and warm notes of toffee nut foam, topped with graham crackers.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 194 kcal, Grande: 431 ML, 223 kcal, Venti: 591 ML, 253 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "6f9d3d3ffb7984e8b52f39960bf32a75",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34655901",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Iced Tall",
                                            "default": 1,
                                            "id": "107157921",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Grande",
                                            "price": 4500,
                                            "id": "107157922",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Venti",
                                            "price": 9000,
                                            "id": "107157923",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124014114",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Iced",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128742245",
                                  "name": "Veronica's Iced Toffee Nut Crunch Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Delight your senses with our Iced Toffee Nut Crunch Latte. A perfect combination of velvety milk, our signature espresso, heartwarming flavors of buttery toffee and the warmth of toasted nuts. Topped with toffee nut whipped cream and graham crackers. Served over ice.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 280 kcal, Grande: 431 ML, 341kcal, Venti: 591 ML, 393 kcal\nAllergen - Contains Wheat, Milk, Oat.",
                                  "imageId": "2c6981469821c1b43d5d66655a746149",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34655902",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107157924",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Grande",
                                            "price": 4000,
                                            "id": "107157925",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Venti",
                                            "price": 8000,
                                            "id": "107157926",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34655903",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107157927",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107157928",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107157929",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107157930",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107157931",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124014115",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014116",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014117",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124014118",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598723",
                                  "name": "Archie's Iced Crunchy Red Hat Mocha",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Almost too cute to drink, our Iced Crunchy Red Hat Mocha Latte combines velvety milk, our signature Espresso,decadent mocha, a generous amout of vanilla whipped cream topped with a chocolate whipped cream hat and strawberry drizzle,finished with crunchy graham crackers.This beverage is not just a delight for your eyes but also a party in your mouth. Served over ice.\nServing size(ml)/Calories(kcal) -Tall:354 ML,396kcal,Grande:431ML,477kcal, Venti:591ML,545kcal\nAllergen-Contains Wheat,Milk,Oat.",
                                  "imageId": "clea3hlce4uwkl0wauyj",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557869",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "106730393",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Grande",
                                            "price": 4000,
                                            "id": "106730394",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Venti",
                                            "price": 8000,
                                            "id": "106730395",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557870",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730396",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730397",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730398",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730399",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730400",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711784",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711785",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711786",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711787",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "128598724",
                                  "name": "Betty's Iced Chestnut Mont Blanc Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Inspired by the french dessert of the same name, our Iced Chestnut Mont Blanc Latte showcases the harmony between the earthy and nutty notes of chestnut, velvety milk, and our signature espresso. Topped with a luscious chestnut whipped cream and chestnut sauce drizzled over it. Served over ice.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 312 kcal, Grande: 431 ML, 387 kcal, Venti: 591 ML, 433 kcal\nAllergen - Contains Wheat, Milk, Nut, Oat, Soy.",
                                  "imageId": "13b639452b059fd7e371bfdec7879132",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34557871",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Iced Tall",
                                            "default": 1,
                                            "id": "106730401",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Grande",
                                            "price": 4000,
                                            "id": "106730402",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Venti",
                                            "price": 8000,
                                            "id": "106730403",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34557872",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "106730404",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "106730405",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "106730406",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "106730407",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "106730408",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "123711788",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711789",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711790",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "123711791",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579181",
                                  "name": "Jughead's Iced Gingerbread Latte",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Get your festive cheer on with our Iced Gingerbread Latte. Sweet and delicately spicy gingerbread flavors mingle with our signature espresso and velvety milk, topped with gingerbread whipped cream sprinkled with a spice blend that tastes just like the holidays. Served over ice.\nServing size (ml)/Calories (kcal) - Tall: 354 ML, 259 kcal, Grande: 431 ML, 320 kcal, Venti: 591 ML, 373 kcal\nAllergen - Contains Milk.",
                                  "imageId": "12c32aaf879acbac582f05c0fdefc325",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "35266070",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "ICED TALL",
                                            "default": 1,
                                            "id": "109149633",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Grande",
                                            "price": 4000,
                                            "id": "109149634",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Iced Venti",
                                            "price": 8000,
                                            "id": "109149635",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "35266071",
                                        "name": "Non-dairy Alternatives / Milk",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "109149636",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "109149637",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "109149638",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "109149639",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "109149640",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "125889558",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889559",
                                      "groupName": "Whipped cream",
                                      "choices": [
                                        {
                                          "id": "93782100",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889560",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286995",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139637",
                                          "name": "Vanilla Syrup",
                                          "price": 5310,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "98529156",
                                          "name": "Classic Syrup (sweet)",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 7,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "125889561",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "102691506",
                                          "name": "Extra Shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Cakes & Pastries",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579182",
                                  "name": "Merry Berry Bun",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "A berrylicious Christmas affair! Light and airy choux pastry encasing a luscious medley of mixed berries with a delightfully crumbly red exterior.\nContains - Milk, Wheat, Egg, Soy\n70 g | 307 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "3b7254a41efb9fde77989db262aeb9de",
                                  "inStock": 1,
                                  "price": 17500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "106106461",
                                  "name": "Christmas Tree Pastry",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Dive into the holiday spirit with this decadent pastry reminiscent of a Christmas tree. A chocolate lover's dream dipped in velvety ganache and crowned with a layer of milk chocolate. With its edible Christmas tree ornaments, this festive treat is a delight for your tastebuds and eyes alike.\nContains - Soy, Milk\n110 g | 631 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "5fd8ddbd3527bf7ffb9ee15bee74da88",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    "text": "Bestseller",
                                    "textColor": "#ffffff",
                                    "topBackgroundColor": "#d53d4c",
                                    "bottomBackgroundColor": "#b02331"
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isBestseller": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "129579183",
                                  "name": "Carrot Cake Log",
                                  "category": "Holiday Classics from The Archies",
                                  "description": "Let the sweet decadence of carrot cake, coupled with the comforting aroma of cinnamon and nutmeg, transport you to a cozy winter wonderland with this log shaped masterpiece topped with an enchanting Christmas tree cookie.\nContains - Egg, Wheat, Nut, Milk, Soy\n158 g | 742 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "c07c2b47e0a9d34598e3fe14b7200561",
                                  "inStock": 1,
                                  "price": 38500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Ice Cream  Scoops",
                      "categories": [
                        {
                          "title": "Scoops",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461164",
                                  "name": "Vanilla with strawberry Sauce",
                                  "category": "Ice Cream  Scoops",
                                  "description": "A delicious scoop of Vanilla ice cream served with strawberry sauce on top.\nServing Size - 165 ML/344kcal, Allergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "5afaba5d7fe83b4d70e03dfe83554e48",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "88794833",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "86476727",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72287065",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286811",
                                          "name": "Strawberry Sauce",
                                          "price": 5000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286807",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461165",
                                  "name": "Java Chip with chocolate sauce and Chips",
                                  "category": "Ice Cream  Scoops",
                                  "description": "A delicious scoop of Java Chip ice cream served with Chocolatey sauce drizzle and java chips on top.\nServing Size - 140 ML/393kcal, Allergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "8182021b1b260d0fbeae27ca7a8714d0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "88794843",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "99676151",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286771",
                                          "name": "Strawberry Syrup Modifier",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.9",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461166",
                                  "name": "Caramel Macchiato with salted caramel Drizzle",
                                  "category": "Ice Cream  Scoops",
                                  "description": "A delicious scoop of Caramel Macchiato ice cream served with caramel drizzle on top.\nServing Size - 170 ML/381kcal, Allergen - Contains Milk, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "e6144c20002f6274599c80021d371949",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 14500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "88794845",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "86476729",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286771",
                                          "name": "Strawberry Syrup Modifier",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 4,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Cookies, Cakes & Desserts",
                      "categories": [
                        {
                          "title": "Cookie",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "52186219",
                                  "name": "Almond Butterscotch Cookie",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "A buttery cookie with a combination of crunchy almond and butterscotch.\nServing size (g/ml) - 85g/370kcal.\nAllergen - Contains Wheat, Milk, Nut.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "ef6123fd15a2af2424e1394babbac8b5",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 29500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "42399942",
                                  "name": "Double Chocolate Chip Cookie",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "A soft & chewy chocolate cookie topped with chocolate chips for the perfect textured bite\nServing size (g/ml) - 80g/385kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "ab4e963453672424b10c51b5a16133b1",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 28500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.7",
                                      "ratingCount": "28 ratings",
                                      "ratingCountV2": "28"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Loaf Cake, Muffins & Cup cake",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716530",
                                  "name": "Lemon Loaf Cake",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "English tea cake with rich taste of butter and citrusy lemon notes.\nServing size (g/ml) - 120g/477kcal.\nAllergen - Contains Wheat, Egg, Milk.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "87bef170ad96e1af480b03926dd86dc6",
                                  "inStock": 1,
                                  "price": 32000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "7 ratings",
                                      "ratingCountV2": "7"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "42402951",
                                  "name": "Blueberry Muffin",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "\"Buttery vanilla cake with blueberries dusted with granulated sugar for a delightfully crunchy texture.\nServing size (g/ml) - 120g/376kcal.\nAllergen - Contains Wheat, Milk, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "c6a2308b012dab5ffd4852a02f012483",
                                  "inStock": 1,
                                  "price": 31000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.5",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "42402865",
                                  "name": "Banana Chocolate Loaf Cake",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "\"English tea cake with rich taste of banana and chocolate.\nServing size (g/ml) - 125g/385kcal.\nAllergen - Contains Wheat, Soy, Egg, milk.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"",
                                  "imageId": "fab5ba89ee338aef3a61df9baf96a13b",
                                  "inStock": 1,
                                  "price": 32000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "17 ratings",
                                      "ratingCountV2": "17"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100711608",
                                  "name": "Chocolate Brownie Cupcake",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "\"A gooey and fudgy walnut brownie loaded with chocolate. 2pcs per portion\nServing size (g/ml) - 80g/416kcal\nAllergen - Soy, Wheat, Milk, Nut\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.\"",
                                  "imageId": "cb672e71b73939f5c0fd1fe312825c14",
                                  "isVeg": 1,
                                  "price": 28500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Pastries & Cheese Cake",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "99461147",
                                  "name": "Hazelnut Triangle",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "A Pastry with layers of hazelnut meringue and buttercream.\nServing size (g/ml) - 50g/302kcal.\nAllergen - Contains Milk, Egg, Wheat, Barley, Soy, Nut.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "51d6eaaa37affe77e6877c3759a9e254",
                                  "inStock": 1,
                                  "price": 19500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131640151",
                                  "name": "Biscoff Pastry",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "A delightful pairing of Biscoff buttercream nestled between layers of vanilla sponge, coated with crunchy biscoff biscuits and a milk chocolate shell.\nContains - Wheat, Milk, Soy\n100 g | 793 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "6db851435f8cabcda023026e71ebb6a8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 35500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151092",
                                  "name": "New York Cheesecake",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "The Classic New York Cheese cake with a rich, creamy satiny texture and a crumbly biscuit base. Served along with Strawberry jam on the side. An all time coffee house favourite.\nServing size (g/ml) - 150g/485kcal.\nAllergen - Contains Wheat, Milk, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "63c8d5eca8afb261a0cab6146d98edf5",
                                  "inStock": 1,
                                  "price": 39500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.7",
                                      "ratingCount": "16 ratings",
                                      "ratingCountV2": "16"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131640152",
                                  "name": "Chocolate Silk Pastry",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "\"Experience a triple chocolate delight with a mix of textures—crunchy, soft, and creamy. Our Chocolate Silk Pastry is made with decadent nuts and layers of double chocolate mousse topped with dark chocolate ganache. \nContains - Nut, Wheat, Milk, Soy\n100 g | 298 kcal\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "02fa302e410a201bdc9354bf8da75d34",
                                  "isVeg": 1,
                                  "price": 31500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "33716522",
                                  "name": "Red velvet cheesecake",
                                  "category": "Cookies, Cakes & Desserts",
                                  "description": "Red velvety sponge cake with cream cheese and white chocolate. Hint of orange zest for perfect tanginess.\nServing size (g/ml) - 125g/389kcal.\nAllergen - Contains Wheat, Milk, Egg.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "d0e87614fa0f5b585731db2383cb3f5b",
                                  "price": 39000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Ready to Drink & Eat",
                      "categories": [
                        {
                          "title": "Bottled Frappuccino & Bottled Juice",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "111325435",
                                  "name": "Bottled Caramel Frappuccino",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Bottled Caramel Frappuccino\nProduct Size - 200 ML\nEnergy  -   65.7 kcal / 100 ml, Allergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "e9806e7571929a4056fe8d6013925033",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37619,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151109",
                                  "name": "Bottled Mocha Frappuccino",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Bottled Mocha Frappuccino\nProduct Size - 200 ML\nEnergy  - 64.6 kcal / 100 ml, Allergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "b05e5543a0a996215330cf3c5a03442a",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37619,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "5 ratings",
                                      "ratingCountV2": "5"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "111325436",
                                  "name": "Bottled Coffee Frappuccino",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Bottled Coffee Frappuccino\nProduct Size - 200 ML\nEnergy  -  63.9 kcal / 100 ml, Allergen - Contains Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "f78f91e8d6fb29dd433a9d85ac918943",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 37619,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116145866",
                                  "name": "Rauch Pineapple Juice",
                                  "category": "Ready to Drink & Eat",
                                  "description": "\"A Frefreshing pinapple fruit juice from concentrate with no added sugar.\nProduct Size - 200 ML.\nEnergy  -   54 kcal / 100 ml, Allergen - NA.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "ad0ad2009cf05051fd4d0f1ec904c25f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23810,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116145867",
                                  "name": "Rauch Organic Apple Juice",
                                  "category": "Ready to Drink & Eat",
                                  "description": "\"Directly pressed apple fruit juice not from concentrate and no added sugar.\nProduct Size - 200 ML.\nEnergy  -   50 kcal / 100 ml, Allergen - NA.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "58517ab3160cd47dac864527f4d78e4f",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 23810,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "116145868",
                                  "name": "Rauch Blueberry Juice",
                                  "category": "Ready to Drink & Eat",
                                  "description": "\"A refreshing juice with the goodness of blueberries, best enjoyed on ice.\nProduct Size - 200 ML.\nEnergy  -   60 kcal / 100 ml, Allergen - NA.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "988f93808a71f2e12c905884f10419d2",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 26667,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115129065",
                                  "name": "Rauch Vitamindrink ACE Juice",
                                  "category": "Ready to Drink & Eat",
                                  "description": "I Fruity juice with the goodness of orange, carrots and lemon. Contains Vitamins A, C and E.\nProduct Size - 200 ML.\nEnergy  -   45 kcal / 100 ml, Allergen - NA.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "205720f81a5a7609c30b7bb5349eda8e",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 24762,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Packaged Food",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109844263",
                                  "name": "Almond Biscotti 50 Gms",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Almond Biscotti\nProduct Size - 50 g\nEnergy  - 409 kcal / 100 g\nAllergen - Contains Nut, Wheat, Egg and Milk\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "cf5a4ac8048682e0d5f98aab89d91314",
                                  "inStock": 1,
                                  "price": 15238,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "95805486",
                                  "name": "Roasted & Salted Cashews",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Roasted & Salted Cashews\nProduct Size - 50 g\nEnergy  - 606.3 kcal /100 g\nAllergen - Contains Nuts An average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "362d4d0a24158517cfcc3be7a463f2b0",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17143,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "89738705",
                                  "name": "Roasted & Salted Almonds",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Roasted & Salted Almonds\nProduct Size - 50 g\nEnergy  - 630.2 kcal /100 g\nAllergen - Contains Nuts An average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "b2de7a38be1bfd89c36255cebf085961",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 17143,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Other Bottled Bevarages",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "54070603",
                                  "name": "Himalayan Still Water",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Himalayan Still Water\nProduct Size - 250 ML\nEnergy  - 0 kcal\nAllergen - Nil An average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "f090a130f49f6d29012d68cd9a01cbf8",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 11905,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "109844264",
                                  "name": "Sparkling Himalayan Water",
                                  "category": "Ready to Drink & Eat",
                                  "description": "Himalayan sparkling Water\nProduct Size - 250 ML\nEnergy  - 0 kcal\nAllergen - Nil An average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "8a8001e62cebae752b73631110cbe191",
                                  "inStock": 1,
                                  "isVeg": 1,
                                  "price": 13333,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Breakfast Specials",
                      "categories": [
                        {
                          "title": "Breakfast Specials.",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120134382",
                                  "name": "Cappuccino.",
                                  "category": "Breakfast Specials",
                                  "description": "Dark, Rich in flavour espresso lies in wait under a smoothed and stretched layer of thick foam. It's truly the height of our baristas' craft. Allergen - Contains Milk, Short: 237 ML, 104 kcal, Tall: 354 ML, 104 kcal, Grande: 473 ML, 173 kcal, Venti: 591 ML, 220 kcal.An average active adult requires 2000 kcal energy per day, however, calorie needs may vary",
                                  "imageId": "55904772a4328bfeff407ea73bf76c85",
                                  "isVeg": 1,
                                  "price": 29000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820484",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674552",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Hot Tall Cappuccino",
                                            "price": 3000,
                                            "id": "107674553",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674554",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674555",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820485",
                                        "name": "Milk / Non-dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674556",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674557",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674558",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674559",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674560",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684699",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427293",
                                          "name": "Espresso shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684700",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286993",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427295",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427296",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684701",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427297",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.1",
                                      "ratingCount": "15 ratings",
                                      "ratingCountV2": "15"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120134383",
                                  "name": "Caffe Latte.",
                                  "category": "Breakfast Specials",
                                  "description": "Our dark, rich espresso balanced with steamed milk and a light layer of foam. A perfect milk forward warm up.\nEnergy per serving size - Hot - Short (237ml) - 103.8 kcal / Tall (354ml) - 173 kcal / Grande (473ml) - 220.2 kcal / Venti (591ml) 289.4 kcal.\nAllergen - Contains Milk.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "879e3f36c309519bd089ce9a8d13746f",
                                  "isVeg": 1,
                                  "price": 29500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820486",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674561",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674562",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674563",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674564",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820487",
                                        "name": "Milk / Non-dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674565",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674566",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674567",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674568",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674569",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684702",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427293",
                                          "name": "Espresso shot",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427294",
                                          "name": "Espresso Choice-Modifier",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684703",
                                      "groupName": "Syrups & Sauces ",
                                      "choices": [
                                        {
                                          "id": "72286993",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286992",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286994",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286997",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139598",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "73139614",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684704",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115170490",
                                  "name": "Caffe Americano..",
                                  "category": "Breakfast Specials",
                                  "description": "Rich in flavour, full-bodied espresso with hot water in true European style. Short: 237 ML, 0 kcal, Tall: 354 ML, 0 kcal, Grande: 473 ML, 0 kcal, Venti: 591 ML, 0 kcal.An average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "a45fc95997eeb22c6c21b6b1fd9fade2",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820488",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "HOT SHORT",
                                            "default": 1,
                                            "id": "107674570",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT TALL",
                                            "price": 3000,
                                            "id": "107674571",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT GRANDE",
                                            "price": 6500,
                                            "id": "107674572",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "HOT VENTI",
                                            "price": 10000,
                                            "id": "107674573",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684705",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684706",
                                      "groupName": "Milk / Non-dairy Alternatives",
                                      "choices": [
                                        {
                                          "id": "77961122",
                                          "name": "Regular milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "77961124",
                                          "name": "Skimmed Milk",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427300",
                                          "name": "Soy Milk",
                                          "price": 6500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427301",
                                          "name": "Almond Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427302",
                                          "name": "Oats Milk",
                                          "price": 8500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684707",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427306",
                                          "name": "Caramel Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427307",
                                          "name": "Classic Syrup",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286747",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286750",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684708",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "107427298",
                                          "name": "Honey",
                                          "price": 1500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "isGuiltfree": true,
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.4",
                                      "ratingCount": "184 ratings",
                                      "ratingCountV2": "184"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151106",
                                  "name": "Java Chip Frappuccino..",
                                  "category": "Breakfast Specials",
                                  "description": "We blend mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle to bring you endless java joy.\nEnergy  - Tall (354ml) - 391.7 kcal / Grande (473ml) - 536.19 kcal / Venti (591ml) 667.4 kcal.\nAllergen - Contains Wheat, Milk, Soy.\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "434146cff15b354b9dc1b6273a9afede",
                                  "isVeg": 1,
                                  "price": 39000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820489",
                                        "name": "Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674574",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Grande",
                                            "price": 4000,
                                            "id": "107674575",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Venti",
                                            "price": 8500,
                                            "id": "107674576",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      },
                                      {
                                        "groupId": "34820490",
                                        "name": "Milk / Non-dairy Alternatives",
                                        "variations": [
                                          {
                                            "name": "Regular milk",
                                            "default": 1,
                                            "id": "107674577",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Skimmed Milk",
                                            "id": "107674578",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Soy Milk",
                                            "price": 6500,
                                            "id": "107674579",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Almond Milk",
                                            "price": 8500,
                                            "id": "107674580",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Oats Milk",
                                            "price": 8500,
                                            "id": "107674581",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "124684709",
                                      "groupName": "Choice Of Espresso",
                                      "choices": [
                                        {
                                          "id": "107427299",
                                          "name": "Espresso Shot Regular",
                                          "price": 7000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286764",
                                          "name": "Blonde Espresso",
                                          "price": 4500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 1,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684710",
                                      "groupName": "Syrup and Sauces",
                                      "choices": [
                                        {
                                          "id": "107427303",
                                          "name": "Vanilla Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427304",
                                          "name": "Hazelnut Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427305",
                                          "name": "Caramel Syrup",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286807",
                                          "name": "Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72287065",
                                          "name": "White Mocha Sauce",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "72286765",
                                          "name": "Caramel Drizzle",
                                          "price": 6000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 6,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "124684711",
                                      "groupName": "Custom",
                                      "choices": [
                                        {
                                          "id": "72286767",
                                          "name": "Java Chips",
                                          "price": 4000,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "107427308",
                                          "name": "No Whip Cream",
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.9",
                                      "ratingCount": "96 ratings",
                                      "ratingCountV2": "96"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115170492",
                                  "name": "Butter Croissant..",
                                  "category": "Breakfast Specials",
                                  "description": "A flaky and buttery French style pastry served with butter.\nServing size (g/ml) - 75g/255kcal.\nAllergen - Contains Wheat, Barley, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "f6fe5c49d4e670df5632783f5830f5d1",
                                  "price": 28500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "3.5",
                                      "ratingCount": "6 ratings",
                                      "ratingCountV2": "6"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "44151088",
                                  "name": "Egg White & Chicken In Multigrain Croissant",
                                  "category": "Breakfast Specials",
                                  "description": "Fluffy egg white omlette and chicken ham sandwiched in multigrain croissant. Allergen - Contains Wheat, Oats, Milk, Egg, Soy. Serving size 200 g, 541 kcal",
                                  "imageId": "xu6obusw9cxcvmd4syej",
                                  "price": 37500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "3 ratings",
                                      "ratingCountV2": "3"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "101109747",
                                  "name": "Herbed Chicken Focaccia Sandwich.",
                                  "category": "Breakfast Specials",
                                  "description": "A western styled chicken salad sandwiched in a focaccia bread.\nServing size (g/ml) - 240g/686kcal\nAllergen - Contains  Milk, Wheat\nAn average active adult requires 2000 kcal energy per day, however, calorie needs may vary.",
                                  "imageId": "2cf1f9ef230cbcd1e39061d7a0b78bc7",
                                  "price": 40500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "100711599",
                                  "name": "Pesto & Mozzarella Sandwich in Panini.",
                                  "category": "Breakfast Specials",
                                  "description": "Freshly Assembled Sandwich\nA panini bread loaded with spinach, cheddar and Emmenthal.\nServing size (g/ml) - 290g/731kcal\nAllergen - Contains Milk, Wheat, Soy, Rye, Oat, Nut\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.",
                                  "imageId": "90386479a9643531016ddbc234969080",
                                  "isVeg": 1,
                                  "price": 40500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128982",
                                  "name": "Tall Cold Coffee with Malabari Egg Croissant",
                                  "category": "Breakfast Specials",
                                  "description": "\"Meal for One! Enjoy Classic Cold coffee drink for summers served with Malabari Egg Croissant -A South Indian Malabari inspired spiced egg filling with hints of coconut encased in a croissant with sesame seeds on top.\nServing size (g/ml) - 235g/850kcal.\nAllergen - Contains Egg, Wheat, Soy, Rye, Oat, Milk.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n",
                                  "imageId": "1be3b0813916179f31d67c5e19c6ae2a",
                                  "price": 62500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820491",
                                        "name": "BLENDED Cold coffee Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674582",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "115128984",
                                  "name": "Tall Java Chip Frapuccino with Tandoori Chicken Panini Sandwich",
                                  "category": "Breakfast Specials",
                                  "description": "\"Meal for One! Enjoy Our blended mocha sauce and Frappuccino chips with Frappuccino roast coffee and milk and ice, then top with whipped cream and mocha drizzle served with Tandoori Chicken Panini Sandwich -Freshly Assembled Sandwich\nMasala?chicken?tikka with?tomato?salsa?&?cheddar?cheese?sandwiched?in a panini bread.\nEnergy per serving size - Tall (354ml) - 391.7 kcal / Grande (473ml) - 536.19 kcal / Venti (591ml) 667.4 kcal.\nServing size (g/ml) - 290g/901kcal\nAllergen - Contains Milk, Nut, Wheat, Rye, Soy, Oat\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "992b4732fda2351fc389f8472a29a9a2",
                                  "price": 80000,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820492",
                                        "name": "Java Chip Frappuccino. Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674583",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 8 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120773639",
                                  "name": "Tall Cold Coffee with Creamy Spinach & Corn Pocket",
                                  "category": "Breakfast Specials",
                                  "description": "\"Meal for One! Enjoy Our rich in flavour espresso blended with delicate vanilla flavour and milk to create a perfect cold coffee delight. An all time favourite served with A creamy spinach and corn filling encased in a buttery French style dough.\nEnergy per serving size - Tall (354ml) - 353 kcal.\nServing size (g/ml) - 160g/358kcal.\nAllergen - Contains Milk, Wheat, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "9d78632a11474358ab0ad6cb205c7255",
                                  "isVeg": 1,
                                  "price": 60500,
                                  "variants": {
                                    "variantGroups": [
                                      {
                                        "groupId": "34820493",
                                        "name": "BLENDED Cold coffee Size",
                                        "variations": [
                                          {
                                            "name": "Tall",
                                            "default": 1,
                                            "id": "107674584",
                                            "inStock": 1,
                                            "isVeg": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120773640",
                                  "name": "Tall Signature Hot Chocolate with Butter Croissant",
                                  "category": "Breakfast Specials",
                                  "description": "\"Meal for One! Enjoy Our Four cocoas and fresh steamed milk topped with chocolate powder with A flaky and buttery French style pastry served with butter.\nEnergy per serving size - Tall (354ml) - 446 kcal.\nServing size (g/ml) - 75g/255kcal.\nAllergen - Contains Wheat, Barley, Milk, Egg, Soy.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "d0105220dda7b88ee8406f9e19b6dd48",
                                  "price": 61500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "120773641",
                                  "name": "Tall Amerciano with Herbed Chicken Focaccia Sandwich",
                                  "category": "Breakfast Specials",
                                  "description": "\n\n\"Meal for One! Enjoy Our Rich, full-bodied espresso with hot water in true European style served with Freshly Assembled Sandwich, A western styled chicken salad sandwiched in a focaccia bread.\nEnergy per serving size - Tall (354ml) - Nil kcal.\nServing size (g/ml) - 230g/717kcal.\nAllergen - Contains Milk, Wheat.\nAn average active adult requires 2000 kcal energy per day; however, calorie needs may vary.\"\n\n",
                                  "imageId": "217caebfb8ec41329f4eadfc6d9c97f3",
                                  "price": 71000,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "nextAvailableAtMessage": "Next available at 7 am, tomorrow",
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11218333002406"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Starbucks Coffee",
                      "area": "Lavelle Road",
                      "completeAddress": "38/1,Vittal Mallya, Lavelle Road Junction,Vittal Mallya Road, Bangalore ? 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "acJxICb9Xcs3-ruJcOBSWym1HHn3wnhNShwLCNHM"
},
// 20240105234044
// https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=29063&catalog_qa=undefined&submitAction=ENTER

{
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "29063",
              "name": "Misu",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "misu-st-marks-road-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "lx0tpfgsbqygafwh30wh",
              "locality": "St. Marks Road",
              "areaName": "St. Marks Road",
              "costForTwo": "130000",
              "costForTwoMessage": "₹1300 for two",
              "cuisines": [
                "Asian",
                "Chinese"
              ],
              "avgRating": 4.4,
              "feeDetails": {
                "restaurantId": "29063",
                "fees": [
                  {
                    "name": "distance",
                    "fee": 4500
                  },
                  {
                    "name": "time"
                  },
                  {
                    "name": "special"
                  }
                ],
                "totalFee": 4500,
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "0.8 kms | ₹45 Delivery fee will apply"
              },
              "parentId": "7415",
              "avgRatingString": "4.4",
              "totalRatingsString": "5K+ ratings",
              "sla": {
                "restaurantId": "29063",
                "deliveryTime": 35,
                "minDeliveryTime": 35,
                "maxDeliveryTime": 35,
                "lastMileTravel": 0.8,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_NONE",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "35 MINS",
                "lastMileTravelString": "0.8 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextOpenTimeMessage": "Opens next at 12 noon, tomorrow",
                "nextOpenTime": "2024-01-06 12:00:00",
                "visibility": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹499",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹499 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "misu-st-marks-road-central-bangalore",
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "4th Floor, Halcyon Complex, Saint Marks Road, Ashok Nagar, Bengaluru, Karnataka 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Asian,Chinese"
                }
              ],
              "logo": "v1643287112/Gourmet-Rework/Misu.png",
              "totalRatings": 5000,
              "aggregatedDiscountInfoV2": {
                "header": "Flat ₹125 off",
                "shortDescriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹499",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹125 off on orders above ₹499 | Use code SWIGGYWEEKENDS",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "Flat ₹100 off | Above ₹750",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "nudgeBanners": [
                {
                  "minValue": 349,
                  "maxValue": 499,
                  "priority": 1,
                  "couponCode": "SWIGGYWEEKENDS",
                  "discountInfo": {
                    "discountType": "Flat",
                    "value": 125
                  },
                  "lockedMessage": "Add items worth ₹<amount> to save ₹125 | Code SWIGGYWEEKENDS",
                  "unlockedMessage": "SWIGGYWEEKENDS Coupon Unlocked! Use it to save ₹125",
                  "logoCtx": {
                    
                  }
                }
              ],
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/29063"
              },
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "availabilityServiceabilityMessage": "Currently closed for delivery. Opens next at 12 noon, tomorrow",
              "restaurantCategory": "RESTAURANT_CATEGORY_GOURMET",
              "backgroundImage": "v1643349034/Gourmet%20Menu%20header%20reworks%20/Misu.png",
              "orderabilityCommunication": {
                "title": {
                  "text": "Currently"
                },
                "subTitle": {
                  "text": "CLOSED"
                },
                "message": {
                  "text": "Uh-oh! Outlet is not accepting orders at the moment. They should be back by 12:00 PM tomorrow",
                  "textColour": "primary"
                },
                "customIcon": {
                  "bgGradientColorStart": "#EB8322",
                  "bgGradientColorEnd": "#EE5803"
                }
              },
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.970613,77.60062800000003",
              "hasKidscategoryItems": true
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 5,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "b49329f4-dddd-47e8-8450-8607879190e9"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE SWIGGYWEEKENDS",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "29063",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹100 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "offerIds": [
                        "80873c0f-e6b3-485a-9215-a0c0c8f1a078"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹750",
                      "offerType": "offers",
                      "restId": "29063",
                      "offerLogo": "rng/md/ads/production/cd60f23dc2ac83be906d0f6ba55d3d12",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "20% OFF UPTO ₹100",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "offerIds": [
                        "b2534320-db3a-42b9-84f8-5d3fb7734d5d"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE RUPAY100",
                      "description": "ABOVE ₹129",
                      "offerType": "offers",
                      "restId": "29063",
                      "offerLogo": "rng/md/ads/production/be912a4c543f00172d9f82c033ee7239",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹300",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "offerIds": [
                        "1a4ecf1d-60f2-4034-b918-89db25e95d98"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE CITIFOODIE",
                      "description": "ABOVE ₹1200",
                      "offerType": "offers",
                      "restId": "29063",
                      "offerLogo": "rng/md/ads/production/15fb1cfe885005447dc8375e7970600f",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "FLAT ₹125 OFF",
                      "offerTag": "FLAT DEAL",
                      "offerTagColor": "#E46D47",
                      "offerIds": [
                        "ae6b82cd-d756-41af-a132-36998387ad4c"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE FLAT125",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "29063",
                      "offerLogo": "offers/generic",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Appetizers",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052618",
                              "name": "Black Pepper- Non-veg",
                              "category": "Appetizers",
                              "description": "Fried shredded chicken  tossed with bell peppers, chili, oyster sauce, and crushed black pepper. ",
                              "imageId": "jg6shavcqpfdbdcwxea3",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011128",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808024",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Buff",
                                        "id": "111808025",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011128",
                                        "variationId": "111808024"
                                      }
                                    ],
                                    "price": 46500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011581",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011581",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011128",
                                        "variationId": "111808025"
                                      }
                                    ],
                                    "price": 54500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011581",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011581",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011580",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011580",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011581",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052628",
                              "name": "Kung Pao - Non-veg",
                              "category": "Appetizers",
                              "description": "Chicken toss with bell peppers, chili, chinkiang vinegar, light soy sauce and top it with peanuts for a delicious and healthy. ",
                              "imageId": "swrs1lmdons17r2nawto",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011132",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808035",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808036",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011132",
                                        "variationId": "111808035"
                                      }
                                    ],
                                    "price": 46500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011132",
                                        "variationId": "111808036"
                                      }
                                    ],
                                    "price": 54500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052664",
                              "name": "Philadelphia Cream Cheese Roll",
                              "category": "Appetizers",
                              "description": "Cream cheese, spring onion, carrot, and green chilli are wrapped in wonton wrappers and fried until golden brown. Served in six pieces. ",
                              "imageId": "e5bcbacb7c3e1ffa6cd895522584487f",
                              "isVeg": 1,
                              "price": 54500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011676",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011677",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293441",
                              "name": "Nam Phrik Tofu",
                              "category": "Appetizers",
                              "description": "Deep fried tofu tossed in roasted thai chilli paste",
                              "imageId": "mdbhx8fem1fqddhceewn",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011637",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011638",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293506",
                              "name": "Nam Phrik Chicken",
                              "category": "Appetizers",
                              "description": "Deep fried chicken tossed in roasted thai chilli paste",
                              "imageId": "q9szuzvsb92hwirxq34t",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011603",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011604",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052612",
                              "name": "Crispy Thai Golden Bags Vegetarian",
                              "category": "Appetizers",
                              "description": "Golden fried pouches filled with a selection of mushrooms and water chestnut. ",
                              "imageId": "zijs9ngelxgsy42lk4ol",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011570",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011571",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052624",
                              "name": "Crispy Thai Golden Bags Chicken",
                              "category": "Appetizers",
                              "description": "Golden fried pouches filled with chicken. ",
                              "imageId": "zijs9ngelxgsy42lk4ol",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011592",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011593",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052610",
                              "name": "Bok Choy & Mushroom Vegetarian",
                              "category": "Appetizers",
                              "description": "\"chinese bok choy and mushrooms stir-fried and tossed in garlic oyster sauce\"",
                              "imageId": "ymlcmtej1d1fpgxsitxt",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011566",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011567",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052619",
                              "name": "Bok Choy & Mushroom Chicken",
                              "category": "Appetizers",
                              "description": "\"chinese bok choy and mushrooms stir-fried and tossed in garlic oyster sauce\"",
                              "imageId": "ltndcwzaikjnkdqyzlgg",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011582",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011583",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052611",
                              "name": "Crispy Fried Wontons Vegetarian",
                              "category": "Appetizers",
                              "description": "Crispy wontons that are deep-fried until golden brown, served alongside a sweet and spicy thai chilli dipping sauce. ",
                              "imageId": "vt2gzecjwjcidvfg2cak",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011568",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011569",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052623",
                              "name": "Crispy Fried Wontons Chicken",
                              "category": "Appetizers",
                              "description": "Crispy wontons that are deep-fried until golden brown, served alongside a sweet and spicy thai chilli dipping sauce. ",
                              "imageId": "vt2gzecjwjcidvfg2cak",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011590",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011591",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "59148102",
                              "name": "Kung Pao Tofu",
                              "category": "Appetizers",
                              "description": "Tofu toss with bell peppers, chili, chinkiang vinegar, light soy sauce and top it with peanuts for a delicious and healthy. ",
                              "imageId": "zioo9bto7rgejmzazi9e",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011629",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011630",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052634",
                              "name": "Honey Chilli Tofu In Mustard Sauce",
                              "category": "Appetizers",
                              "description": "Deep fried and slices of tofu white fish are coated in batter and wok-tossed in honey-chili paste and kasundi mustard. ",
                              "isVeg": 1,
                              "price": 41500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011607",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011608",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052627",
                              "name": "Honey Chilli Chicken In Mustard Sauce",
                              "category": "Appetizers",
                              "description": "Deep fried and  slices of chicken are coated in batter and wok-tossed in honey-chili paste and kasundi mustard. ",
                              "imageId": "xivbeh0dvaff3lxjtk9x",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011598",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011599",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052633",
                              "name": "Honey Chilli Fish In Mustard Sauce",
                              "category": "Appetizers",
                              "description": "Deep fried and  slices of white fish (basa fish) are coated in batter and wok-tossed in honey-chili paste and kasundi mustard. ",
                              "imageId": "g1g2oja60bwyumcwk7yr",
                              "price": 57500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011605",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011606",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052621",
                              "name": "Chicken Wings With Thai Herbs",
                              "category": "Appetizers",
                              "description": "Golden chicken wings are battered and fried, then tossed in a mixture of galangal, thai basil, chili, and soy sauce. ",
                              "imageId": "anppzcgqnrzxfkdgt0cx",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011586",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011587",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052638",
                              "name": "Crispy Thai Garlic Prawn",
                              "category": "Appetizers",
                              "description": "Crispy fried prawns are coated in a savoury thai garlic sauce and then tossed for a perfect blend of flavours. ",
                              "imageId": "d5cd45ba8cc200b19416b4a05eb838c3",
                              "price": 60500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011622",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011623",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052668",
                              "name": "Stir Fried Fish In Chilli & Basil Sauce",
                              "category": "Appetizers",
                              "description": "Wok-tossed white fish slices with thai basil, garlic, chili, and soy sauce. ",
                              "imageId": "o0aptff9kalehwkua18f",
                              "price": 57500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011687",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011688",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052669",
                              "name": "Soft Shell Crab With Garlic Pepper",
                              "category": "Appetizers",
                              "description": "Fried soft-shell crab and then toss it with garlic, black pepper, and chili. ",
                              "imageId": "e3nke8pzhly8edoyzkdg",
                              "price": 76500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011691",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011692",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293591",
                              "name": "Prawns With Thai Herbs",
                              "category": "Appetizers",
                              "description": "Wok-tossed prawns with galangal, kaffir lime, chilies, and lemongrass",
                              "imageId": "cd3eeuatifl756tkk9od",
                              "price": 60500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011689",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011690",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293593",
                              "name": "Dynamite Shrimps",
                              "category": "Appetizers",
                              "description": "Shrimp lightly battered and tossed in a blend of thai sweet chili sauce and japanese mayo. ",
                              "imageId": "9f58028da3715c66fdd2d51ba1c882e4",
                              "price": 60500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011624",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011625",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "124181851",
                              "name": "Prawn Crackers",
                              "category": "Appetizers",
                              "description": "Fry the kropek wafers in hot oil until they turn golden brown and crispy. ",
                              "imageId": "zhlsccrimpfrm5gce2ka",
                              "price": 22500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011564",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011565",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293592",
                              "name": "Drunken Buff",
                              "category": "Appetizers",
                              "description": "Shredded buffalo meat is stir-fried and then mixed with chili, thai basil, oyster sauce, and cooking wine. ",
                              "imageId": "gvi283wi8kidxskid0pw",
                              "price": 54500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011614",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011615",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "14 ratings",
                                  "ratingCountV2": "14"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131662955",
                              "name": "Edamame",
                              "category": "Appetizers",
                              "description": "Edamame steamed with rock salt or stir-fried with garlic, chilli & soya",
                              "imageId": "d0e9bd58a6d4b3a200e841b556727dae",
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36266682",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Steamed",
                                        "default": 1,
                                        "id": "112703283",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Fried",
                                        "id": "112703284",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36266682",
                                        "variationId": "112703283"
                                      }
                                    ],
                                    "price": 43500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "130363517",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "130363517",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36266682",
                                        "variationId": "112703284"
                                      }
                                    ],
                                    "price": 46500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "130363517",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "130363517",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "130363516",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "130363516",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130363517",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 43500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131662956",
                              "name": "Turnip Cake",
                              "category": "Appetizers",
                              "description": "Turnip cake made with rice flour, mushroom  steamed/fried; tossed with burnt garlic, fried onion, spring & chilli",
                              "imageId": "zafzwepxlfjlkia3nlzi",
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36266683",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Steamed",
                                        "default": 1,
                                        "id": "112703285",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Fried",
                                        "id": "112703286",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36266683",
                                        "variationId": "112703285"
                                      }
                                    ],
                                    "price": 41500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "130363519",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "130363519",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36266683",
                                        "variationId": "112703286"
                                      }
                                    ],
                                    "price": 41500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "130363519",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "130363519",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "130363518",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "130363518",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "130363519",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Sushi",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293531",
                              "name": "Kappa Maki",
                              "category": "Sushi",
                              "description": "Cucumber and cream cheese roll, which is accompanied by a side of soy sauce and pickled ginger with wasabi. ",
                              "imageId": "aab4b5a5776988e710315b2dcf81d38f",
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011121",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808010",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808011",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011121",
                                        "variationId": "111808010"
                                      }
                                    ],
                                    "price": 29500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011121",
                                        "variationId": "111808011"
                                      }
                                    ],
                                    "price": 49500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 29500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052587",
                              "name": "Tofu & Avocado Maki",
                              "category": "Sushi",
                              "description": "Spicy tofu and avocado roll, served with a side of soy sauce and pickled ginger with wasabi. ",
                              "imageId": "kse7oxgugj7lt8ofiujm",
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011124",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "8 Pcs",
                                        "default": 1,
                                        "id": "111808017",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "4 Pcs",
                                        "id": "111808016",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011124",
                                        "variationId": "111808017"
                                      }
                                    ],
                                    "price": 54500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011124",
                                        "variationId": "111808016"
                                      }
                                    ],
                                    "price": 34500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 54500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052640",
                              "name": "Tempura Vegetable Cream Cheese Maki",
                              "category": "Sushi",
                              "description": "Japanese-style fried vegetable and cream cheese uramaki. It is served with soy sauce, wasabi, and pickled ginger. ",
                              "imageId": "smbs5vvyng6ben7ffihq",
                              "isVeg": 1,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011139",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808051",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808052",
                                        "inStock": 1,
                                        "isVeg": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011139",
                                        "variationId": "111808051"
                                      }
                                    ],
                                    "price": 41500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011139",
                                        "variationId": "111808052"
                                      }
                                    ],
                                    "price": 65500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052639",
                              "name": "Tempura Prawn Maki",
                              "category": "Sushi",
                              "description": "Tempura prawns rolled in spicy japanese mayo, topped with roasted sesame seeds. Served with soy sauce and wasabi gari on the side. ",
                              "imageId": "bdnbtkmlgud7d8cfk4de",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011138",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808049",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808050",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011138",
                                        "variationId": "111808049"
                                      }
                                    ],
                                    "price": 41500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011138",
                                        "variationId": "111808050"
                                      }
                                    ],
                                    "price": 71500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052613",
                              "name": "Fried Coconut Shrimp Roll",
                              "category": "Sushi",
                              "description": "Coconut fried shrimp, along with cilantro and avocado. It is served with a side of soy sauce and wasabi gari. ",
                              "imageId": "ulhfywpbdpjmplhmhdqf",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011127",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808022",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808023",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011127",
                                        "variationId": "111808022"
                                      }
                                    ],
                                    "price": 41500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011127",
                                        "variationId": "111808023"
                                      }
                                    ],
                                    "price": 71500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293612",
                              "name": "California Maki",
                              "category": "Sushi",
                              "description": "Rolled with crab stick, avocado, cucumber, tobiko, and japanese mayo, served with soy sauce and wasabi gari on the side. ",
                              "imageId": "cc5db9ce46a71c563482eb7a25e4ae54",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011126",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808020",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808021",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011126",
                                        "variationId": "111808020"
                                      }
                                    ],
                                    "price": 41500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011126",
                                        "variationId": "111808021"
                                      }
                                    ],
                                    "price": 71500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116403039",
                              "name": "Salmon Cream Cheese Roll",
                              "category": "Sushi",
                              "description": "Spicy salmon and cream cheese uramaki served with wasabi, soy and gari",
                              "imageId": "rsaoaqbucatciiecqy6y",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011147",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808074",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808075",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011147",
                                        "variationId": "111808074"
                                      }
                                    ],
                                    "price": 49500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011147",
                                        "variationId": "111808075"
                                      }
                                    ],
                                    "price": 79500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 49500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052609",
                              "name": "Bbq Buff & Hot Sauce",
                              "category": "Sushi",
                              "description": "Avocado and shiitake mushroom bbq with in-house hot sauce, served with soy and wasabi gari on the side. ",
                              "imageId": "qfbjmkweowwvquzgssao",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011125",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "4 Pcs",
                                        "default": 1,
                                        "id": "111808018",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "8 Pcs",
                                        "id": "111808019",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011125",
                                        "variationId": "111808018"
                                      }
                                    ],
                                    "price": 41500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011125",
                                        "variationId": "111808019"
                                      }
                                    ],
                                    "price": 71500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 41500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Dimsum",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052607",
                              "name": "Spinach And Corn Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Dumplings made of wheat and potato starch, filled with spinach, corn, and garlic. ",
                              "isVeg": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052598",
                              "name": "Assorted Mushroom Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Wheat flour dumplings that are filled with a variety of mushrooms. ",
                              "isVeg": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052603",
                              "name": "Crunchy Vegetarianetable Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Our chef's special dish consists of a salad made from a combination of water chestnut, carrot, beans, and papaya served with unique and delicious sauces. ",
                              "isVeg": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052599",
                              "name": "Broccoli & Cashewnut Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Dumplings filled with ground cashews and broccoli. ",
                              "imageId": "w4gflj7zpxhloffnlvhp",
                              "isVeg": 1,
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052597",
                              "name": "Cream Cheese Dumplings In Chilli Oil (4 Pcs)",
                              "category": "Dimsum",
                              "description": "Misu special dumpling cream cheese, spring onion and chilli filling with chilli oil drizzle. ",
                              "imageId": "dsucsqwjgfv6vukofgam",
                              "isVeg": 1,
                              "price": 39500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052600",
                              "name": "Chicken And Shiitake Crystal Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "This dish comprises of chicken dumplings stuffed with shiitake mushrooms and water chestnuts. ",
                              "imageId": "7a589089357086a42ec3046873e86b9c",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052604",
                              "name": "Herbed Chicken Dumplings (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Chicken that has been marinated in a stuffing made with thai herbs. ",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052602",
                              "name": "Crispy Fried Chicken Wontons With Wasabi Mayo (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Misu's crispy fried chicken wontons which is served with our special in-house wasabi mayo. ",
                              "imageId": "xvxzr3tfagc2e4agcp9z",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052591",
                              "name": "Classic Bao With Tofu",
                              "category": "Dimsum",
                              "description": "Steamed bun with katsu tofu and spicy mayo on top",
                              "imageId": "wmb0uvsesbtrmk3htval",
                              "isVeg": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052601",
                              "name": "Classic Bao With Chicken",
                              "category": "Dimsum",
                              "description": "Steamed bun with katsu chicken and spicy mayo on top",
                              "imageId": "ydbglvc3aowra7jxnee3",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052594",
                              "name": "Rainbow Dumplings Vegetarian (6 Pcs)",
                              "category": "Dimsum",
                              "description": "A colorful dumpling made in the chinese style. ",
                              "isVeg": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052605",
                              "name": "Rainbow Dumplings Chicken (6 Pcs)",
                              "category": "Dimsum",
                              "description": "A colorful dumpling made in the chinese style. ",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052595",
                              "name": "Sour & Spicy Dumplings Vegetarian (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Steamed dumplings served with a homemade sour and spicy sauce drizzled on top. ",
                              "imageId": "85cf0865ca65a198ec9e0198477f7158",
                              "isVeg": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052606",
                              "name": "Sour & Spicy Dumplings Chicken (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Steamed dumplings served with a homemade sour and spicy sauce drizzled on top. ",
                              "imageId": "wtifwokjdtbarspivaik",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052596",
                              "name": "Steamed Chilli Wontons Vegetarian (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Steamed wonton with assorted vegetable filling topped with schezwan chilli sauce",
                              "imageId": "jgncseyq44rgupo7piqq",
                              "isVeg": 1,
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052608",
                              "name": "Steamed Chilli Wontons Chicken (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Steamed wonton with chicken filling topped with schezwan chilli sauce",
                              "imageId": "jgncseyq44rgupo7piqq",
                              "price": 40500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052589",
                              "name": "Gyoza -Pan Seared Vegetarian (5 Pcs)",
                              "category": "Dimsum",
                              "description": "Japanese gyoza, a traditional dish. ",
                              "imageId": "wruxawpdurrrv9sgqa0v",
                              "isVeg": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052593",
                              "name": "Gyoza -Pan Seared Chicken (5 Pcs)",
                              "category": "Dimsum",
                              "description": "Japanese gyoza, a traditional dish. ",
                              "imageId": "wruxawpdurrrv9sgqa0v",
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052588",
                              "name": "Gyoza - Steamed Vegetarian (5 Pcs)",
                              "category": "Dimsum",
                              "description": "Japanese gyoza, a traditional dish. ",
                              "imageId": "lk6weonpy9msdqru37zz",
                              "isVeg": 1,
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052592",
                              "name": "Gyoza - Steamed Chicken (5 Pcs)",
                              "category": "Dimsum",
                              "description": "Japanese gyoza, a traditional dish. ",
                              "imageId": "bgslyzyqkj59uqdfs2mp",
                              "price": 38500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052652",
                              "name": "Siu Mai Chicken & Prawn (6 Pcs)",
                              "category": "Dimsum",
                              "description": "One of the most popular items at dim sum parlours worldwide are these traditional, steamed dumplings. ",
                              "imageId": "re6ikeygsb6rm0ailgom",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052650",
                              "name": "Prawn Dumplings In Chilli Oil (6 Pcs)",
                              "category": "Dimsum",
                              "description": "Dumpling made using misu's secret recipe, which features stuffed shrimp and chili oil. ",
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Meal In A Bowl",
                      "categories": [
                        {
                          "title": "Non-veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052662",
                                  "name": "Nasi Goreng - Non Veg",
                                  "category": "Meal In A Bowl",
                                  "description": "Indonesian-style fried rice served with chicken satay, prawn crackers, and a fried egg. \"it's a combo meal. \"",
                                  "imageId": "rgrlbz7qdedagkjzu3nu",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011148",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808076",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Buff",
                                            "id": "111808077",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808078",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011148",
                                            "variationId": "111808076"
                                          }
                                        ],
                                        "price": 52500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011148",
                                            "variationId": "111808077"
                                          }
                                        ],
                                        "price": 55000
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011148",
                                            "variationId": "111808078"
                                          }
                                        ],
                                        "price": 60500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 52500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052632",
                                  "name": "Khow Suey Non-veg",
                                  "category": "Meal In A Bowl",
                                  "description": "A dish of burmese noodles cooked in coconut milk and curry, served with condiments on the side. It's a combo meal. \"",
                                  "imageId": "dg0ka8xkzode5rlgzuns",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011134",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808039",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Mix Seafood (Fish & prawn)",
                                            "id": "111808040",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808041",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011134",
                                            "variationId": "111808039"
                                          }
                                        ],
                                        "price": 52500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011134",
                                            "variationId": "111808040"
                                          }
                                        ],
                                        "price": 60500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011134",
                                            "variationId": "111808041"
                                          }
                                        ],
                                        "price": 65500
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 52500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Others",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052657",
                                  "name": "Wonton Mee Vegetarian",
                                  "category": "Meal In A Bowl",
                                  "description": "Cantonese noodles with bok choy, spring onions, bean sprouts, and tossed in dark soy sauce served with fried wontons \"it's a combo meal. \"",
                                  "imageId": "kqbg3d7n7ibgcsib2wxa",
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "31125019",
                                  "name": "Wonton Mee Chicken",
                                  "category": "Meal In A Bowl",
                                  "description": "Cantonese noodles with bok choy, spring onions, bean sprouts, and tossed in dark soy sauce served with fried wontons \"it's a combo meal. \"",
                                  "imageId": "ushab4ac5hrbewn3zrh0",
                                  "price": 49500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "4.2",
                                      "ratingCount": "45 ratings",
                                      "ratingCountV2": "45"
                                    }
                                  },
                                  "isKidcategory": true
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052631",
                                  "name": "Khow Suey Vegetarian",
                                  "category": "Meal In A Bowl",
                                  "description": "A dish of burmese noodles cooked in coconut milk and curry, served with condiments on the side. It's a combo meal. \"",
                                  "imageId": "dg0ka8xkzode5rlgzuns",
                                  "isVeg": 1,
                                  "price": 49500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Ramen",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052663",
                              "name": "Spiced Korean Ramen Non-veg",
                              "category": "Ramen",
                              "description": "Choice of protein in a spicy kimchi broth with a soft fried egg and fresh bean sprouts. ",
                              "imageId": "oukjcn2it8k2f9c8zvwg",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011149",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808079",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808080",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011149",
                                        "variationId": "111808079"
                                      }
                                    ],
                                    "price": 52500
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011149",
                                        "variationId": "111808080"
                                      }
                                    ],
                                    "price": 63500
                                  }
                                ]
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 52500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052630",
                              "name": "Miso Ramen Vegetarian",
                              "category": "Ramen",
                              "description": "Traditional japanese misu broth",
                              "imageId": "t7dnai9vbkmdoacuysz3",
                              "isVeg": 1,
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31124947",
                              "name": "Miso Ramen Chicken",
                              "category": "Ramen",
                              "description": "Traditional japanese misu broth with a soft boiled egg & chicken",
                              "imageId": "olm9vigr1vodsdf6xfi9",
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "116 ratings",
                                  "ratingCountV2": "116"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Rice",
                      "categories": [
                        {
                          "title": "Non-veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052625",
                                  "name": "Hibachi Fried Rice Non-veg",
                                  "category": "Rice",
                                  "description": "Our famous japanese-style fried sticky rice with shiitake mushrooms. ",
                                  "imageId": "bbuhwkijta8iloyfwozn",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011131",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808032",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808033",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808034",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011131",
                                            "variationId": "111808032"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011131",
                                            "variationId": "111808033"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011131",
                                            "variationId": "111808034"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011595",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011594",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011594",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011595",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052620",
                                  "name": "Burnt Garlic Fried Rice Non-veg",
                                  "category": "Rice",
                                  "description": "Fried rice is mixed with butter, burnt garlic, and scallions, and topped with golden fried garlic. ",
                                  "imageId": "edqkqgfjwvycpf1nysvm",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011129",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808026",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808027",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808028",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011129",
                                            "variationId": "111808026"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011129",
                                            "variationId": "111808027"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011129",
                                            "variationId": "111808028"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011584",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011585",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011584",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011585",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052656",
                                  "name": "Thai Wok-fried Rice Non-veg",
                                  "category": "Rice",
                                  "description": "Wok-tossed fried rice with roasted chili, tomato, bell pepper, and basil",
                                  "imageId": "qqjdrlwcbahlbdbfewmo",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011145",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808068",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808069",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808070",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011145",
                                            "variationId": "111808068"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011145",
                                            "variationId": "111808069"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011145",
                                            "variationId": "111808070"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011663",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011664",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011663",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011664",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Others",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052617",
                                  "name": "Classic Chinese Egg Fried Rice",
                                  "category": "Rice",
                                  "description": "Enjoy a delicious plate of egg fried rice, topped with fresh spring onions for a classic and satisfying meal. ",
                                  "imageId": "p1ehxxr0b2ffo2twpvhz",
                                  "price": 45500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011578",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011579",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052626",
                                  "name": "Hibachi Fried Rice Vegetarian",
                                  "category": "Rice",
                                  "description": "Our famous japanese-style fried sticky rice with shiitake mushrooms. ",
                                  "imageId": "bbuhwkijta8iloyfwozn",
                                  "isVeg": 1,
                                  "price": 46500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011596",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011597",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052614",
                                  "name": "Burnt Garlic Fried Rice Vegetarian",
                                  "category": "Rice",
                                  "description": "Fried rice is mixed with butter, burnt garlic, and scallions, and topped with golden fried garlic. ",
                                  "imageId": "bb14e075acb38ff4c965283b7cf844f6",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011572",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011573",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052646",
                                  "name": "Thai Wok-fried Rice Vegetarian",
                                  "category": "Rice",
                                  "description": "Wok-tossed fried rice with roasted chili, tomato, bell pepper, and basil",
                                  "imageId": "qqjdrlwcbahlbdbfewmo",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011649",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011650",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Noodles",
                      "categories": [
                        {
                          "title": "Non-veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052622",
                                  "name": "Classic Hakka Noodles Non-veg",
                                  "category": "Noodles",
                                  "description": "Wok-tossed noodles with bok choy, bell peppers, soy sauce and spring onions. ",
                                  "imageId": "c0e523fa3761259604d325ca5f17a5db",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011130",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808029",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808030",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808031",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011130",
                                            "variationId": "111808029"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011130",
                                            "variationId": "111808030"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011130",
                                            "variationId": "111808031"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011588",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011589",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011588",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011589",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052654",
                                  "name": "Spicy Yaki Soba Noodles Non-veg",
                                  "category": "Noodles",
                                  "description": "Buckwheat noodles, cooked japanese-style, stir-fried with a delicious mix of fresh garlic, soy sauce, shiitake mushrooms, chinese greens, and spiced butter. ",
                                  "imageId": "iscvuvhx7byzcpcvmdgl",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011143",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808062",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808063",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808064",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011143",
                                            "variationId": "111808062"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011143",
                                            "variationId": "111808063"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011143",
                                            "variationId": "111808064"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011659",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011660",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011659",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011660",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052653",
                                  "name": "Spicy Chilli Basil Noodles Non-veg",
                                  "category": "Noodles",
                                  "description": "Thin noodles tossed with chilli, garlic, thai basil & chinese vegetables",
                                  "imageId": "wlvwmyddkyrca0ykwynp",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011142",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808059",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808060",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808061",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011142",
                                            "variationId": "111808059"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011142",
                                            "variationId": "111808060"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011142",
                                            "variationId": "111808061"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011657",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011658",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011657",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011658",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052649",
                                  "name": "Pad Thai Flat Noodles Non-veg",
                                  "category": "Noodles",
                                  "description": "Thai flat noodles tossed with tamarind, chilli & crushed peanuts",
                                  "imageId": "ah2bz6l5qws0tscwhlot",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011140",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808053",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808054",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808055",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011140",
                                            "variationId": "111808053"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011140",
                                            "variationId": "111808054"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011140",
                                            "variationId": "111808055"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011653",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011654",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011653",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011654",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052635",
                                  "name": "Mamak Wok Fried Noodles - Non Veg",
                                  "category": "Noodles",
                                  "description": "The classic mee goreng made in indo-malaysian style",
                                  "imageId": "wy3lnj8atmivdmeqxbdv",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011135",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808042",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808043",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808044",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011135",
                                            "variationId": "111808042"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011135",
                                            "variationId": "111808043"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011135",
                                            "variationId": "111808044"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011609",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011610",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011609",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011610",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052658",
                                  "name": "Zucchini Pad Thai Noodles - Non Veg",
                                  "category": "Noodles",
                                  "description": "Stir-fried zucchini noodles with bok choy & bean sprouts in tamarind sauce",
                                  "imageId": "spjoznvntsvhvhpjrj4z",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011146",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808071",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808072",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808073",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011146",
                                            "variationId": "111808071"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011146",
                                            "variationId": "111808072"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011146",
                                            "variationId": "111808073"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011665",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011666",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011665",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011666",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052651",
                                  "name": "Shanghai Udon Noodles  - Non Veg",
                                  "category": "Noodles",
                                  "description": "Udon noodles with vegetables in a spiced black bean sauce",
                                  "imageId": "qixlb0nelmlgpcaazng3",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011141",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808056",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808057",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808058",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011141",
                                            "variationId": "111808056"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011141",
                                            "variationId": "111808057"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011141",
                                            "variationId": "111808058"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011655",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011656",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011655",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011656",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052655",
                                  "name": "Thai Curry Noodles  - Non Veg",
                                  "category": "Noodles",
                                  "description": "Chinese thin noodles cooked in thai red curry, with vegetables and choice of proteins",
                                  "imageId": "3933d1b2b6cd2a1508c83cb856bbb7b9",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011144",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808065",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808066",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Chicken & Prawn",
                                            "id": "111808067",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011144",
                                            "variationId": "111808065"
                                          }
                                        ],
                                        "price": 46500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011144",
                                            "variationId": "111808066"
                                          }
                                        ],
                                        "price": 49500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011144",
                                            "variationId": "111808067"
                                          }
                                        ],
                                        "price": 52500,
                                        "addonCombinations": [
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934253"
                                          },
                                          {
                                            "groupId": "129011661",
                                            "addonId": "109934252"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934258"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934259"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934255"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934256"
                                          },
                                          {
                                            "groupId": "129011662",
                                            "addonId": "109934254"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011661",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011662",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 46500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Others",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052615",
                                  "name": "Classic Hakka Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Wok-tossed noodles with bok choy, bell peppers, soy sauce and spring onions. ",
                                  "imageId": "ua5ocl5kkse6rxqnoeas",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011574",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011575",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052644",
                                  "name": "Spicy Yaki Soba Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Buckwheat noodles, cooked japanese-style, stir-fried with a delicious mix of fresh garlic, soy sauce, shiitake mushrooms, chinese greens, and spiced butter. ",
                                  "imageId": "detj4bagzo4rlv0a0hj1",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011645",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011646",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052643",
                                  "name": "Spicy Chilli Basil Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Thin noodles tossed with chilli, garlic, thai basil & chinese vegetables",
                                  "imageId": "wlvwmyddkyrca0ykwynp",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011643",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011644",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052641",
                                  "name": "Pad Thai Flat Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Thai flat noodles tossed with tamarind, chilli & crushed peanuts",
                                  "imageId": "gycemwb2zom1gxbkzjzl",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011639",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011640",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052616",
                                  "name": "Mamak Wok Fried Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "The classic mee goreng made in indo-malaysian style",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011576",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011577",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052647",
                                  "name": "Zucchini Pad Thai Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Stir-fried zucchini noodles with bok choy & bean sprouts in tamarind sauce",
                                  "imageId": "pktlfeysdbmbveklynwb",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011651",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011652",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052642",
                                  "name": "Shanghai Udon Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Udon noodles with vegetables in a spiced black bean sauce",
                                  "imageId": "qixlb0nelmlgpcaazng3",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011641",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011642",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052645",
                                  "name": "Thai Curry Noodles Vegetarian",
                                  "category": "Noodles",
                                  "description": "Chinese thin noodles cooked in thai red curry, with vegetables",
                                  "imageId": "3933d1b2b6cd2a1508c83cb856bbb7b9",
                                  "isVeg": 1,
                                  "price": 44500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "addons": [
                                    {
                                      "groupId": "129011647",
                                      "groupName": "Desserts",
                                      "choices": [
                                        {
                                          "id": "109934253",
                                          "name": "Sugar Free & Gluten Free Chocolate Cake",
                                          "price": 49500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934252",
                                          "name": "Japanese Souffle Cheesecake",
                                          "price": 35500,
                                          "inStock": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 2,
                                      "maxFreeAddons": -1
                                    },
                                    {
                                      "groupId": "129011648",
                                      "groupName": "Beverages",
                                      "choices": [
                                        {
                                          "id": "109934258",
                                          "name": "Kombucha",
                                          "price": 22500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934259",
                                          "name": "Tonic Water (Schweppes)",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934255",
                                          "name": "Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934254",
                                          "name": "Diet Coke",
                                          "price": 12500,
                                          "inStock": 1,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        },
                                        {
                                          "id": "109934256",
                                          "name": "Sprite",
                                          "price": 12500,
                                          "isVeg": 1,
                                          "isEnabled": 1
                                        }
                                      ],
                                      "maxAddons": 5,
                                      "maxFreeAddons": -1
                                    }
                                  ],
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Stir-fries & Curries (Meal For One)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052637",
                              "name": "Massaman Curry - Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Cubed potatoes and tofu are cooked in a spiced coconut curry, a classic dish from thailand. It's a combo meal. \"",
                              "imageId": "a3vlxf4wbnzixarz23hc",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011137",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808047",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808048",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011137",
                                        "variationId": "111808047"
                                      }
                                    ],
                                    "price": 54500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011620",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011619",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011619",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011137",
                                        "variationId": "111808048"
                                      }
                                    ],
                                    "price": 63500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011620",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011619",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011619",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011621",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011619",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011620",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011621",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 54500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052629",
                              "name": "Kung Pao Gravy- Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Chicken tossed with bell peppers, chilli, chinkiang vinegar, light soy & topped with peanuts",
                              "imageId": "ou6nqpddgo5eu1sipiby",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011133",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808037",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808038",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011133",
                                        "variationId": "111808037"
                                      }
                                    ],
                                    "price": 46500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011601",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011600",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011600",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011133",
                                        "variationId": "111808038"
                                      }
                                    ],
                                    "price": 59500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011601",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011600",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011600",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011602",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011600",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011601",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011602",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 46500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052636",
                              "name": "Black Pepper Gravy- Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Shredded chicken/buffalo tossed with bell peppers, chilli, oyster sauce & crushed black papers",
                              "imageId": "iiueevyffho2mqijdck1",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011136",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808045",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Buff",
                                        "id": "111808046",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011136",
                                        "variationId": "111808045"
                                      }
                                    ],
                                    "price": 52500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011612",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011611",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011611",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011136",
                                        "variationId": "111808046"
                                      }
                                    ],
                                    "price": 59500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011612",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011611",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011611",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011613",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011611",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011612",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011613",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 52500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052666",
                              "name": "Thai Green Curry - Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Classic thai green curry made with coconut milk, bamboo shoots, galangal, and eggplant, served with a side of basmati rice. It's a combo meal. \"",
                              "imageId": "c478da23c457a4924ea7f720c9d68635",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011151",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808083",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808084",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011151",
                                        "variationId": "111808083"
                                      }
                                    ],
                                    "price": 54500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011682",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011681",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011681",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011151",
                                        "variationId": "111808084"
                                      }
                                    ],
                                    "price": 63500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011682",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011681",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011681",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011683",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011681",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011682",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011683",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 54500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052667",
                              "name": "Thai Red Curry - Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Classic thai red curry made with coconut milk, bamboo shoots, galangal, and eggplant, served with a side of basmati rice. It's a combo meal. \"",
                              "imageId": "pzxlate2vegyyc9vbotb",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011152",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808085",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Prawn",
                                        "id": "111808086",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011152",
                                        "variationId": "111808085"
                                      }
                                    ],
                                    "price": 54500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011685",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011684",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011684",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011152",
                                        "variationId": "111808086"
                                      }
                                    ],
                                    "price": 63500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011685",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011684",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011684",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011686",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011684",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011685",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011686",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 54500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052665",
                              "name": "Rendang Curry -Non Veg",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Malaysian meat curry with coconut milk, lemongrass, and galangal, and a paste of ground mixed spices served with basmati rice. It's a combo meal. \"",
                              "imageId": "xb4xnum32etfxldkww7q",
                              "variants": {
                                
                              },
                              "variantsV2": {
                                "variantGroups": [
                                  {
                                    "groupId": "36011150",
                                    "name": "Quantity",
                                    "variations": [
                                      {
                                        "name": "Chicken",
                                        "default": 1,
                                        "id": "111808081",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      },
                                      {
                                        "name": "Buff",
                                        "id": "111808082",
                                        "inStock": 1,
                                        "isEnabled": 1
                                      }
                                    ]
                                  }
                                ],
                                "pricingModels": [
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011150",
                                        "variationId": "111808081"
                                      }
                                    ],
                                    "price": 54500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011679",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011678",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011678",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  },
                                  {
                                    "variations": [
                                      {
                                        "groupId": "36011150",
                                        "variationId": "111808082"
                                      }
                                    ],
                                    "price": 63500,
                                    "addonCombinations": [
                                      {
                                        "groupId": "129011679",
                                        "addonId": "110016688"
                                      },
                                      {
                                        "groupId": "129011678",
                                        "addonId": "109934253"
                                      },
                                      {
                                        "groupId": "129011678",
                                        "addonId": "109934252"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934258"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934259"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934255"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934256"
                                      },
                                      {
                                        "groupId": "129011680",
                                        "addonId": "109934254"
                                      }
                                    ]
                                  }
                                ]
                              },
                              "addons": [
                                {
                                  "groupId": "129011678",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011679",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011680",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "defaultPrice": 54500,
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052659",
                              "name": "Stir Fried Vegetables In A Chilli Basil Sauce",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Stir-fried mushroom, bok choy, chinese cabbage, black mushroom with chili garlic, and basil sauce served with basmati rice it's a combo meal. \"",
                              "isVeg": 1,
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011667",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011668",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011669",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31124934",
                              "name": "Krapow Tofu",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Cubed proteins wok-fried in a thai basil, chilli, garlic sauce, served with basmati rice on the side. It's a combo meal. \"",
                              "imageId": "b9755e7bbf9f7de1b0020fa561a986d0",
                              "isVeg": 1,
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011628",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011627",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011626",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "31124980",
                              "name": "Krapow Chicken",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Cubed proteins wok-fried in a thai basil, chilli, garlic sauce, served with basmati rice on the side. It's a combo meal. \"",
                              "imageId": "optzrwaqpjjnzdkfuev3",
                              "price": 54500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011616",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011617",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011618",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "98 ratings",
                                  "ratingCountV2": "98"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293500",
                              "name": "Kung Pao Tofu Gravy",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Tofu tossed with bell peppers, chilli, chinkiang vinegar, light soy & topped with peanuts",
                              "imageId": "dstxsmpzn0izljnslsfi",
                              "isVeg": 1,
                              "price": 46500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011631",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011632",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011633",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293538",
                              "name": "Massaman Curry Tofu",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Cubed potatoes and tofu are cooked in a spiced coconut curry, a classic dish from thailand. It's a combo meal. \"",
                              "imageId": "utc7fjpd76ycwe4vxfrv",
                              "isVeg": 1,
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011634",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011635",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011636",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052660",
                              "name": "Thai Green Curry Vegetarian",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Classic thai green curry made with coconut milk, bamboo shoots, galangal, and eggplant, served with a side of basmati rice. It's a combo meal. \"",
                              "imageId": "iuc7ylykcddztkvxlxdj",
                              "isVeg": 1,
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011670",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011671",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011672",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052661",
                              "name": "Thai Red Curry Vegetarian",
                              "category": "Stir-fries & Curries (Meal For One)",
                              "description": "Classic thai red curry made with coconut milk, bamboo shoots, galangal, and eggplant, served with a side of basmati rice. It's a combo meal. \"",
                              "imageId": "e932ddecb5cc6d3b106bbe12818c6013",
                              "isVeg": 1,
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129011673",
                                  "groupName": "Desserts",
                                  "choices": [
                                    {
                                      "id": "109934253",
                                      "name": "Sugar Free & Gluten Free Chocolate Cake",
                                      "price": 49500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934252",
                                      "name": "Japanese Souffle Cheesecake",
                                      "price": 35500,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 2,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011674",
                                  "groupName": "Upgrade To Jasmine Rice @ Rs 95",
                                  "choices": [
                                    {
                                      "id": "110016688",
                                      "name": "Jasmin Rice ",
                                      "price": 9500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129011675",
                                  "groupName": "Beverages",
                                  "choices": [
                                    {
                                      "id": "109934258",
                                      "name": "Kombucha",
                                      "price": 22500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934259",
                                      "name": "Tonic Water (Schweppes)",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934255",
                                      "name": "Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934254",
                                      "name": "Diet Coke",
                                      "price": 12500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "109934256",
                                      "name": "Sprite",
                                      "price": 12500,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 5,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Salad",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052584",
                              "name": "Green Mango Salad Vegetarian",
                              "category": "Salad",
                              "description": "Shredded green mango with bird?s eye chilli in a home made thai dressing with peanut",
                              "imageId": "srmyaogxkey4mvsj7jxv",
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293427",
                              "name": "Green Mango Salad Prawn",
                              "category": "Salad",
                              "description": "Shredded green mango with bird?s eye chilli in a home made thai dressing with peanut",
                              "imageId": "rythkzlmbvc23efn08fy",
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052585",
                              "name": "Som Tam Salad Vegetarian",
                              "category": "Salad",
                              "description": "Shredded raw papaya & carrots with cherry tomatoes, chilli, garlic & crushed peanuts in a home made thai dressing",
                              "imageId": "ll0op3rbim1dvtxral8s",
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293428",
                              "name": "Som Tam Salad Prawn",
                              "category": "Salad",
                              "description": "Shredded raw papaya & carrots with cherry tomatoes, chilli, garlic & crushed peanuts in a home made thai dressing",
                              "imageId": "nbiozv3q39p98awynovg",
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052583",
                              "name": "Glass Noodle Salad Vegetarian",
                              "category": "Salad",
                              "description": "Glass noodles with a combination of cherry tomato, beans, mint & coriander in a spicy tangy dressing",
                              "imageId": "k5zy1qaamsrsoi1ntypp",
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293424",
                              "name": "Glass Noodle Salad Prawn",
                              "category": "Salad",
                              "description": "Glass noodles with a combination of cherry tomato, beans, mint & coriander in a spicy tangy dressing",
                              "imageId": "k5zy1qaamsrsoi1ntypp",
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052586",
                              "name": "Spicy Pomelo Salad Vegetarian",
                              "category": "Salad",
                              "description": "Fresh pomelo chunks tossed with lime, peanuts & fresh red chilli in a roasted thai chilli paste",
                              "imageId": "dnaddcqafxl9hx6m7tsu",
                              "isVeg": 1,
                              "price": 32500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "82293429",
                              "name": "Spicy Pomelo Salad Prawn",
                              "category": "Salad",
                              "description": "Fresh pomelo chunks tossed with lime, peanuts & fresh red chilli in a roasted thai chilli paste",
                              "imageId": "a6c96c0f6b1deaab04d4f1fb6b2a6bb1",
                              "price": 37500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory",
                      "title": "Soups",
                      "categories": [
                        {
                          "title": "Non-veg",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052580",
                                  "name": "Tom Kha Soup -Non Veg",
                                  "category": "Soups",
                                  "description": "Coconut based spicy & sour soup with galangal, kaffi r lime & lemongrass",
                                  "imageId": "jeeht4imxuqkzuixwady",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011122",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808012",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808013",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011122",
                                            "variationId": "111808012"
                                          }
                                        ],
                                        "price": 30500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011122",
                                            "variationId": "111808013"
                                          }
                                        ],
                                        "price": 33000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052581",
                                  "name": "Tom Yum Soup -Non Veg",
                                  "category": "Soups",
                                  "description": "Thin soup flavoured with chilli, lemongrass chunks galangal & kaffir lime",
                                  "imageId": "93b055c081821339e9ac0aeb51b018a5",
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    "variantGroups": [
                                      {
                                        "groupId": "36011123",
                                        "name": "Quantity",
                                        "variations": [
                                          {
                                            "name": "Chicken",
                                            "default": 1,
                                            "id": "111808014",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          },
                                          {
                                            "name": "Prawn",
                                            "id": "111808015",
                                            "inStock": 1,
                                            "isEnabled": 1
                                          }
                                        ]
                                      }
                                    ],
                                    "pricingModels": [
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011123",
                                            "variationId": "111808014"
                                          }
                                        ],
                                        "price": 30500
                                      },
                                      {
                                        "variations": [
                                          {
                                            "groupId": "36011123",
                                            "variationId": "111808015"
                                          }
                                        ],
                                        "price": 33000
                                      }
                                    ]
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "defaultPrice": 30500,
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        },
                        {
                          "title": "Others",
                          "itemCards": [
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052574",
                                  "name": "Corn Soup Vegetarian",
                                  "category": "Soups",
                                  "description": "Creamy & tasty filipino-style soup made with corn",
                                  "imageId": "lwacfzlav2x1cirpbvd7",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "82293405",
                                  "name": "Corn Soup Chicken",
                                  "category": "Soups",
                                  "description": "Creamy & tasty filipino-style soup made with corn",
                                  "imageId": "lwacfzlav2x1cirpbvd7",
                                  "price": 30500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      "rating": "5.0",
                                      "ratingCount": "4 ratings",
                                      "ratingCountV2": "4"
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052575",
                                  "name": "Shanghai Hot & Sour Soup Vegetarian",
                                  "category": "Soups",
                                  "description": "Classic hot & sour soup with chilli bean sauce, tofu mushroom and bok choy",
                                  "imageId": "zbymsxg8xo3pvvgco6rp",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052579",
                                  "name": "Shanghai Hot & Sour Soup Chicken",
                                  "category": "Soups",
                                  "description": "Classic hot & sour soup with chilli bean sauce, tofu mushroom and bok choy",
                                  "imageId": "zbymsxg8xo3pvvgco6rp",
                                  "price": 30500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052576",
                                  "name": "Tom Kha Soup Vegetarian",
                                  "category": "Soups",
                                  "description": "Coconut based spicy & sour soup with galangal, kaffi r lime & lemongrass",
                                  "imageId": "jeeht4imxuqkzuixwady",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052577",
                                  "name": "Tom Yum Soup Vegetarian",
                                  "category": "Soups",
                                  "description": "Thin soup fl avoured with chilli, lemongrass chunks galangal & kaffi r lime",
                                  "imageId": "93b055c081821339e9ac0aeb51b018a5",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052578",
                                  "name": "Vietnamese Pho Vegetarian",
                                  "category": "Soups",
                                  "description": "Flat noodles in a star anise-fl avoured broth with sprouts & chinese cabbage",
                                  "imageId": "5dd74320fda1255cfd2ec757c3b228ca",
                                  "isVeg": 1,
                                  "price": 27500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "VEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            },
                            {
                              "card": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                                "info": {
                                  "id": "131052582",
                                  "name": "Vietnamese Pho Chicken",
                                  "category": "Soups",
                                  "description": "Flat noodles in a star anise-fl avoured broth with sprouts & chinese cabbage",
                                  "imageId": "bf776f436e3158dc5350b681270c54d3",
                                  "price": 30500,
                                  "variants": {
                                    
                                  },
                                  "variantsV2": {
                                    
                                  },
                                  "itemAttribute": {
                                    "vegClassifier": "NONVEG"
                                  },
                                  "ribbon": {
                                    
                                  },
                                  "type": "ITEM",
                                  "itemBadge": {
                                    
                                  },
                                  "badgesV2": {
                                    
                                  },
                                  "ratings": {
                                    "aggregatedRating": {
                                      
                                    }
                                  }
                                },
                                "analytics": {
                                  
                                },
                                "hideRestaurantDetails": true
                              }
                            }
                          ]
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052590",
                              "name": "Japanese Souffle Cheesecake",
                              "category": "Desserts",
                              "description": "Souffle-styled baked cheesecake",
                              "imageId": "10c3fc994ee47d32a7a135d420d24a38",
                              "price": 35500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78554308",
                              "name": "Sugar Free & Gluten Free Chocolate Cake",
                              "category": "Desserts",
                              "description": "Gluten free layerd coffee mouse cake, covered with dates and dark choclate glaze",
                              "imageId": "gjdfuxvzlki3yoh5kjww",
                              "price": 49500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              },
                              "isKidcategory": true
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Add On",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "131052572",
                              "name": "Tonic Water (Schweppes)",
                              "category": "Add On",
                              "isVeg": 1,
                              "price": 12500,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11218333002449"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "Misu",
                      "area": "St. Marks Road",
                      "completeAddress": "4th Floor, Halcyon Complex, Saint Marks Road, Ashok Nagar, Bengaluru, Karnataka 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "6222b310-c041-4eec-be05-4d9b788b8c83",
  "sid": "bfb2e9fd-9995-4ab2-91d9-6c5284352c5c",
  "deviceId": "6d7efd21-6b42-d2fa-b8ce-9e0ffe99a2d5",
  "csrfToken": "gMRJuPgkLdsu-hcIVEk3dS2VnMLjTM4tMr485OvA"
}


]


export  default GroupedMenuData;